/*!
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function (t) { const e = t["en"] = t["en"] || {}; e.dictionary = Object.assign(e.dictionary || {}, { "%0 of %1": "%0 of %1", "Align center": "Align center", "Align left": "Align left", "Align right": "Align right", Aquamarine: "Aquamarine", Big: "Big", Black: "Black", "Block quote": "Block quote", Blue: "Blue", Bold: "Bold", "Bulleted List": "Bulleted List", Cancel: "Cancel", "Centered image": "Centered image", "Change image text alternative": "Change image text alternative", "Choose heading": "Choose heading", "Decrease indent": "Decrease indent", Default: "Default", "Dim grey": "Dim grey", "Document colors": "Document colors", Downloadable: "Downloadable", "Dropdown toolbar": "Dropdown toolbar", "Edit block": "Edit block", "Edit link": "Edit link", "Editor toolbar": "Editor toolbar", "Enter image caption": "Enter image caption", "Font Color": "Font Color", "Font Size": "Font Size", "Full size image": "Full size image", Green: "Green", Grey: "Grey", Heading: "Heading", "Heading 1": "Heading 1", "Heading 2": "Heading 2", "Heading 3": "Heading 3", "Heading 4": "Heading 4", "Heading 5": "Heading 5", "Heading 6": "Heading 6", Huge: "Huge", "Image resize list": "Image resize list", "Image toolbar": "Image toolbar", "image widget": "image widget", "Increase indent": "Increase indent", "Insert image": "Insert image", "Insert paragraph after block": "Insert paragraph after block", "Insert paragraph before block": "Insert paragraph before block", Italic: "Italic", Justify: "Justify", "Left aligned image": "Left aligned image", "Light blue": "Light blue", "Light green": "Light green", "Light grey": "Light grey", Link: "Link", "Link URL": "Link URL", Next: "Next", "Numbered List": "Numbered List", "Open in a new tab": "Open in a new tab", "Open link in new tab": "Open link in new tab", Orange: "Orange", Original: "Original", Paragraph: "Paragraph", Previous: "Previous", Purple: "Purple", Red: "Red", Redo: "Redo", "Remove color": "Remove color", "Resize image": "Resize image", "Resize image to %0": "Resize image to %0", "Resize image to the original size": "Resize image to the original size", "Rich Text Editor": "Rich Text Editor", "Rich Text Editor, %0": "Rich Text Editor, %0", "Right aligned image": "Right aligned image", Save: "Save", "Select all": "Select all", "Show more items": "Show more items", "Side image": "Side image", Small: "Small", "Text alignment": "Text alignment", "Text alignment toolbar": "Text alignment toolbar", "Text alternative": "Text alternative", "This link has no URL": "This link has no URL", Tiny: "Tiny", Turquoise: "Turquoise", Undo: "Undo", Unlink: "Unlink", "Upload failed": "Upload failed", "Upload in progress": "Upload in progress", White: "White", "Widget toolbar": "Widget toolbar", Yellow: "Yellow" }); })(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {}));
(function t(e, n) { if (typeof exports === "object" && typeof module === "object")
    module.exports = n();
else if (typeof define === "function" && define.amd)
    define([], n);
else if (typeof exports === "object")
    exports["ClassicEditor"] = n();
else
    e["ClassicEditor"] = n(); })(window, (function () { return function (t) { var e = {}; function n(o) { if (e[o]) {
    return e[o].exports;
} var i = e[o] = { i: o, l: false, exports: {} }; t[o].call(i.exports, i, i.exports, n); i.l = true; return i.exports; } n.m = t; n.c = e; n.d = function (t, e, o) { if (!n.o(t, e)) {
    Object.defineProperty(t, e, { enumerable: true, get: o });
} }; n.r = function (t) { if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    Object.defineProperty(t, Symbol.toStringTag, { value: "Module" });
} Object.defineProperty(t, "__esModule", { value: true }); }; n.t = function (t, e) { if (e & 1)
    t = n(t); if (e & 8)
    return t; if (e & 4 && typeof t === "object" && t && t.__esModule)
    return t; var o = Object.create(null); n.r(o); Object.defineProperty(o, "default", { enumerable: true, value: t }); if (e & 2 && typeof t != "string")
    for (var i in t)
        n.d(o, i, function (e) { return t[e]; }.bind(null, i)); return o; }; n.n = function (t) { var e = t && t.__esModule ? function e() { return t["default"]; } : function e() { return t; }; n.d(e, "a", e); return e; }; n.o = function (t, e) { return Object.prototype.hasOwnProperty.call(t, e); }; n.p = ""; return n(n.s = 58); }([function (t, e, n) {
        "use strict";
        n.d(e, "a", (function () { return i; }));
        n.d(e, "b", (function () { return r; }));
        const o = "https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html";
        class i extends Error {
            constructor(t, e, n) { const o = `${t}${n ? ` ${JSON.stringify(n)}` : ""}${a(t)}`; super(o); this.name = "CKEditorError"; this.context = e; this.data = n; }
            is(t) { return t === "CKEditorError"; }
            static rethrowUnexpectedError(t, e) { if (t.is && t.is("CKEditorError")) {
                throw t;
            } const n = new i(t.message, e); n.stack = t.stack; throw n; }
        }
        function r(t, e) { console.warn(...c(t, e)); }
        function s(t, e) { console.error(...c(t, e)); }
        function a(t) { return `\nRead more: ${o}#error-${t}`; }
        function c(t, e) { const n = a(t); return e ? [t, e, n] : [t, n]; }
    }, function (t, e, n) {
        "use strict";
        var o = function t() { var e; return function t() { if (typeof e === "undefined") {
            e = Boolean(window && document && document.all && !window.atob);
        } return e; }; }();
        var i = function t() { var e = {}; return function t(n) { if (typeof e[n] === "undefined") {
            var o = document.querySelector(n);
            if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) {
                try {
                    o = o.contentDocument.head;
                }
                catch (t) {
                    o = null;
                }
            }
            e[n] = o;
        } return e[n]; }; }();
        var r = [];
        function s(t) { var e = -1; for (var n = 0; n < r.length; n++) {
            if (r[n].identifier === t) {
                e = n;
                break;
            }
        } return e; }
        function a(t, e) { var n = {}; var o = []; for (var i = 0; i < t.length; i++) {
            var a = t[i];
            var c = e.base ? a[0] + e.base : a[0];
            var l = n[c] || 0;
            var d = "".concat(c, " ").concat(l);
            n[c] = l + 1;
            var u = s(d);
            var h = { css: a[1], media: a[2], sourceMap: a[3] };
            if (u !== -1) {
                r[u].references++;
                r[u].updater(h);
            }
            else {
                r.push({ identifier: d, updater: g(h, e), references: 1 });
            }
            o.push(d);
        } return o; }
        function c(t) { var e = document.createElement("style"); var o = t.attributes || {}; if (typeof o.nonce === "undefined") {
            var r = true ? n.nc : undefined;
            if (r) {
                o.nonce = r;
            }
        } Object.keys(o).forEach((function (t) { e.setAttribute(t, o[t]); })); if (typeof t.insert === "function") {
            t.insert(e);
        }
        else {
            var s = i(t.insert || "head");
            if (!s) {
                throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            }
            s.appendChild(e);
        } return e; }
        function l(t) { if (t.parentNode === null) {
            return false;
        } t.parentNode.removeChild(t); }
        var d = function t() { var e = []; return function t(n, o) { e[n] = o; return e.filter(Boolean).join("\n"); }; }();
        function u(t, e, n, o) { var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css; if (t.styleSheet) {
            t.styleSheet.cssText = d(e, i);
        }
        else {
            var r = document.createTextNode(i);
            var s = t.childNodes;
            if (s[e]) {
                t.removeChild(s[e]);
            }
            if (s.length) {
                t.insertBefore(r, s[e]);
            }
            else {
                t.appendChild(r);
            }
        } }
        function h(t, e, n) { var o = n.css; var i = n.media; var r = n.sourceMap; if (i) {
            t.setAttribute("media", i);
        }
        else {
            t.removeAttribute("media");
        } if (r && typeof btoa !== "undefined") {
            o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */");
        } if (t.styleSheet) {
            t.styleSheet.cssText = o;
        }
        else {
            while (t.firstChild) {
                t.removeChild(t.firstChild);
            }
            t.appendChild(document.createTextNode(o));
        } }
        var f = null;
        var p = 0;
        function g(t, e) { var n; var o; var i; if (e.singleton) {
            var r = p++;
            n = f || (f = c(e));
            o = u.bind(null, n, r, false);
            i = u.bind(null, n, r, true);
        }
        else {
            n = c(e);
            o = h.bind(null, n, e);
            i = function t() { l(n); };
        } o(t); return function e(n) { if (n) {
            if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) {
                return;
            }
            o(t = n);
        }
        else {
            i();
        } }; }
        t.exports = function (t, e) { e = e || {}; if (!e.singleton && typeof e.singleton !== "boolean") {
            e.singleton = o();
        } t = t || []; var n = a(t, e); return function t(o) { o = o || []; if (Object.prototype.toString.call(o) !== "[object Array]") {
            return;
        } for (var i = 0; i < n.length; i++) {
            var c = n[i];
            var l = s(c);
            r[l].references--;
        } var d = a(o, e); for (var u = 0; u < n.length; u++) {
            var h = n[u];
            var f = s(h);
            if (r[f].references === 0) {
                r[f].updater();
                r.splice(f, 1);
            }
        } n = d; }; };
    }, function (t, e, n) {
        "use strict";
        function o(t, e) { return c(t) || a(t, e) || r(t, e) || i(); }
        function i() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
        function r(t, e) { if (!t)
            return; if (typeof t === "string")
            return s(t, e); var n = Object.prototype.toString.call(t).slice(8, -1); if (n === "Object" && t.constructor)
            n = t.constructor.name; if (n === "Map" || n === "Set")
            return Array.from(t); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
            return s(t, e); }
        function s(t, e) { if (e == null || e > t.length)
            e = t.length; for (var n = 0, o = new Array(e); n < e; n++) {
            o[n] = t[n];
        } return o; }
        function a(t, e) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(t)))
            return; var n = []; var o = true; var i = false; var r = undefined; try {
            for (var s = t[Symbol.iterator](), a; !(o = (a = s.next()).done); o = true) {
                n.push(a.value);
                if (e && n.length === e)
                    break;
            }
        }
        catch (t) {
            i = true;
            r = t;
        }
        finally {
            try {
                if (!o && s["return"] != null)
                    s["return"]();
            }
            finally {
                if (i)
                    throw r;
            }
        } return n; }
        function c(t) { if (Array.isArray(t))
            return t; }
        t.exports = function t(e) { var n = o(e, 4), i = n[1], r = n[3]; if (typeof btoa === "function") {
            var s = btoa(unescape(encodeURIComponent(JSON.stringify(r))));
            var a = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s);
            var c = "/*# ".concat(a, " */");
            var l = r.sources.map((function (t) { return "/*# sourceURL=".concat(r.sourceRoot || "").concat(t, " */"); }));
            return [i].concat(l).concat([c]).join("\n");
        } return [i].join("\n"); };
    }, function (t, e, n) {
        "use strict";
        t.exports = function (t) { var e = []; e.toString = function e() { return this.map((function (e) { var n = t(e); if (e[2]) {
            return "@media ".concat(e[2], " {").concat(n, "}");
        } return n; })).join(""); }; e.i = function (t, n, o) { if (typeof t === "string") {
            t = [[null, t, ""]];
        } var i = {}; if (o) {
            for (var r = 0; r < this.length; r++) {
                var s = this[r][0];
                if (s != null) {
                    i[s] = true;
                }
            }
        } for (var a = 0; a < t.length; a++) {
            var c = [].concat(t[a]);
            if (o && i[c[0]]) {
                continue;
            }
            if (n) {
                if (!c[2]) {
                    c[2] = n;
                }
                else {
                    c[2] = "".concat(n, " and ").concat(c[2]);
                }
            }
            e.push(c);
        } }; return e; };
    }, , function (t, e, n) {
        "use strict";
        var o = n(9);
        var i = typeof self == "object" && self && self.Object === Object && self;
        var r = o["a"] || i || Function("return this")();
        e["a"] = r;
    }, function (t, e, n) {
        "use strict";
        (function (t) { var o = n(5); var i = n(57); var r = typeof exports == "object" && exports && !exports.nodeType && exports; var s = r && typeof t == "object" && t && !t.nodeType && t; var a = s && s.exports === r; var c = a ? o["a"].Buffer : undefined; var l = c ? c.isBuffer : undefined; var d = l || i["a"]; e["a"] = d; }).call(this, n(11)(t));
    }, function (t, e, n) {
        "use strict";
        (function (t) { var o = n(9); var i = typeof exports == "object" && exports && !exports.nodeType && exports; var r = i && typeof t == "object" && t && !t.nodeType && t; var s = r && r.exports === i; var a = s && o["a"].process; var c = function () { try {
            var t = r && r.require && r.require("util").types;
            if (t) {
                return t;
            }
            return a && a.binding && a.binding("util");
        }
        catch (t) { } }(); e["a"] = c; }).call(this, n(11)(t));
    }, function (t, e, n) {
        "use strict";
        (function (t) { var e = n(0); const o = "27.1.0"; var i = o; const r = typeof window === "object" ? window : t; if (r.CKEDITOR_VERSION) {
            throw new e["a"]("ckeditor-duplicated-modules", null);
        }
        else {
            r.CKEDITOR_VERSION = o;
        } }).call(this, n(56));
    }, function (t, e, n) {
        "use strict";
        (function (t) { var n = typeof t == "object" && t && t.Object === Object && t; e["a"] = n; }).call(this, n(56));
    }, function (t, e, n) {
        "use strict";
        (function (t) { var o = n(5); var i = typeof exports == "object" && exports && !exports.nodeType && exports; var r = i && typeof t == "object" && t && !t.nodeType && t; var s = r && r.exports === i; var a = s ? o["a"].Buffer : undefined, c = a ? a.allocUnsafe : undefined; function l(t, e) { if (e) {
            return t.slice();
        } var n = t.length, o = c ? c(n) : new t.constructor(n); t.copy(o); return o; } e["a"] = l; }).call(this, n(11)(t));
    }, function (t, e) { t.exports = function (t) { if (!t.webpackPolyfill) {
        var e = Object.create(t);
        if (!e.children)
            e.children = [];
        Object.defineProperty(e, "loaded", { enumerable: true, get: function () { return e.l; } });
        Object.defineProperty(e, "id", { enumerable: true, get: function () { return e.i; } });
        Object.defineProperty(e, "exports", { enumerable: true });
        e.webpackPolyfill = 1;
    } return e; }; }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"], names: [], mappings: "AAQA,WAGC,sBACD,CCPA,iDAGC,qBAAsB,CACtB,UAAW,CACX,WAAY,CACZ,eACD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAgD,CAChD,8BAAmD,CACnD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAmD,CACnD,oCAAuD,CACvD,6BAAkD,CAIlD,+CAAwD,CACxD,qEAA+E,CAC/E,qCAAwD,CACxD,sDAA8D,CAC9D,iDAAyD,CACzD,yCAAqD,CACrD,uCAAsD,CACtD,6CAA0D,CAC1D,uCAAsD,CAItD,gDAAuD,CACvD,kDAA+D,CAC/D,mDAAgE,CAChE,+CAA6D,CAC7D,yDAA8D,CAE9D,uCAAuD,CACvD,6CAA4D,CAC5D,8CAA4D,CAC5D,0CAAyD,CACzD,gDAA8D,CAE9D,+DAAsE,CACtE,iDAAkE,CAClE,kDAAkE,CAClE,8CAA+D,CAC/D,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA4D,CAC5D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAmE,CACnE,yEAA8E,CAC9E,qDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,+BAAiD,CACjD,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,wCAAwD,CACxD,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,gEAAuE,CACvE,4EAAiF,CACjF,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,wDAAmE,CACnE,mDAAgE,CCpGhE,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJoGD,CI9FA,iDAIC,QAAS,CACT,SAAU,CACV,QAAS,CACT,sBAAuB,CACvB,oBAAqB,CACrB,qBAAsB,CACtB,eAAgB,CAGhB,oBACD,CAKA,oCAGC,wBAAyB,CACzB,iGAAkG,CAClG,0BAA2B,CAC3B,eAAgB,CAChB,kBAAmB,CACnB,WAAY,CACZ,UACD,CAGC,2BACC,gBACD,CAEA,wBAEC,sBACD,CAEA,0BACC,oBACD,CAEA,kGAGC,WACD,CAEA,gIAGC,cACD,CAEA,0BACC,YAAa,CACb,yBACD,CAEA,0CAEC,SAAU,CACV,QACD,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 44%, 48%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(208, 88%, 52%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(208, 88%, 47%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t208, 79%, 51%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(207, 89%, 86%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 90%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 85%);\n\t--ck-color-button-default-active-shadow: \t\t\t\t\thsl(0, 0%, 75%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(0, 0%, 87%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(0, 0%, 73%);\n\t--ck-color-button-on-active-shadow: \t\t\t\t\t\thsl(0, 0%, 63%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(0, 0%, 87%);\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 44%, 41%);\n\t--ck-color-button-action-active-shadow: \t\t\t\t\thsl(104, 44%, 36%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 69%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 64%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-base-active);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-base-active-focus);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-foreground);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck.ck-reset_all {\n\t& .ck-rtl * {\n\t\ttext-align: right;\n\t}\n\n\t& iframe {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea,\n\t& input[type="text"],\n\t& input[type="password"] {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled],\n\t& input[type="text"][disabled],\n\t& input[type="password"][disabled] {\n\t\tcursor: default;\n\t}\n\n\t& fieldset {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"], names: [], mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YACC,yBAA0B,CAC1B,0BAA2B,CAG3B,uBAAwB,CAQxB,qBAcD,CAZC,0BARA,aAAc,CAGd,cAgBA,CAJC,yBAEC,iBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\tcolor: inherit;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\n\t\t/* Allows dynamic coloring of the icons. */\n\t\tcolor: inherit;\n\n\t\t&:not([fill]) {\n\t\t\t/* Needed by FF. */\n\t\t\tfill: currentColor;\n\t\t}\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s,.ck.ck-tooltip.ck-tooltip_se,.ck.ck-tooltip.ck-tooltip_sw{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{top:calc(var(--ck-tooltip-arrow-size)*-1 + 1px);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_sw{right:50%;left:auto}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text{left:auto;right:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{left:auto;right:0}.ck.ck-tooltip.ck-tooltip_se{left:50%;right:auto}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text{right:auto;left:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after{right:auto;left:0;transform:translateX(50%)}.ck.ck-tooltip.ck-tooltip_n{top:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_e{left:calc(100% + var(--ck-tooltip-arrow-size));top:50%}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text:after{left:calc(var(--ck-tooltip-arrow-size)*-1);top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:transparent;border-bottom-color:transparent;border-right-color:var(--ck-color-tooltip-background);border-top-color:transparent;border-left-width:0;border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_w{right:calc(100% + var(--ck-tooltip-arrow-size));left:auto;top:50%}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text:after{left:100%;top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:var(--ck-color-tooltip-background);border-bottom-color:transparent;border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:0;border-top-width:var(--ck-tooltip-arrow-size)}', "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,sDAEC,iBAAkB,CAGlB,mBAAoB,CAIpB,kCACD,CAEA,eAEC,iBAAkB,CAClB,SAAU,CACV,YAAa,CACb,yBAWD,CATC,iCACC,oBAOD,CALC,uCACC,UAAW,CACX,OAAQ,CACR,QACD,CCxBF,MACC,2BACD,CAEA,eACC,QAAS,CAMT,KAAM,CAON,sCAwKD,CAtKC,iCChBA,eDqCA,CArBA,yGCZC,qCDiCD,CArBA,iCAGC,cAAe,CACf,eAAgB,CAChB,kCAAmC,CACnC,wDAAyD,CACzD,6CAA8C,CAC9C,iBAAkB,CAClB,SAYD,CAVC,uCAMC,sCAAuC,CACvC,kBAAmB,CACnB,QACD,CAYD,sFAGC,4CAA+C,CAC/C,0BASD,CAPC,8JAEC,+CAAkD,CAClD,0BAA6B,CAC7B,6BAAoF,CAApF,sDAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,kBACD,CAaD,6BACC,SAAU,CACV,SAWD,CATC,+CACC,SAAU,CACV,2CACD,CAEA,qDACC,SAAU,CACV,OACD,CAYD,6BACC,QAAS,CACT,UAYD,CAVC,+CACC,UAAW,CACX,0CACD,CAEA,qDACC,UAAW,CACX,MAAO,CACP,yBACD,CAYD,4BACC,yCAA4C,CAC5C,2BAQD,CANC,oDACC,4CAA+C,CAC/C,0BAA6B,CAC7B,6BAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,mDAAoF,CACpF,8CAAsG,CAAtG,qBAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAUD,4BACC,8CAA+C,CAC/C,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,0CAA6C,CAC7C,8CAAiD,CACjD,6BAAoF,CAApF,+BAAoF,CAApF,qDAAoF,CAApF,4BAAoF,CACpF,mBAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAWF,4BACC,+CAAgD,CAChD,SAAU,CACV,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,SAAU,CACV,8CAAiD,CACjD,oDAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,oBAAsG,CAAtG,6CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-tooltip,\n.ck.ck-tooltip .ck-tooltip__text::after {\n\tposition: absolute;\n\n\t/* Without this, hovering the tooltip could keep it visible. */\n\tpointer-events: none;\n\n\t/* This is to get rid of flickering when transitioning opacity in Chrome.\n\tIt\'s weird but it works. */\n\t-webkit-backface-visibility: hidden;\n}\n\n.ck.ck-tooltip {\n\t/* Tooltip is hidden by default. */\n\tvisibility: hidden;\n\topacity: 0;\n\tdisplay: none;\n\tz-index: var(--ck-z-modal);\n\n\t& .ck-tooltip__text {\n\t\tdisplay: inline-block;\n\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-tooltip-arrow-size: 5px;\n}\n\n.ck.ck-tooltip {\n\tleft: 50%;\n\n\t/*\n\t * Prevent blurry tooltips in LoDPI environments.\n\t * See https://github.com/ckeditor/ckeditor5/issues/1802.\n\t */\n\ttop: 0;\n\n\t/*\n\t * For the transition to work, the tooltip must be controlled\n\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t * i.e. when scanning the toolbar with mouse cursor.\n\t */\n\ttransition: opacity .2s ease-in-out .2s;\n\n\t& .ck-tooltip__text {\n\t\t@mixin ck-rounded-corners;\n\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\tbackground: var(--ck-color-tooltip-background);\n\t\tposition: relative;\n\t\tleft: -50%;\n\n\t\t&::after {\n\t\t\t/*\n\t\t\t * For the transition to work, the tooltip must be controlled\n\t\t\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t\t\t * i.e. when scanning the toolbar with mouse cursor.\n\t\t\t */\n\t\t\ttransition: opacity .2s ease-in-out .2s;\n\t\t\tborder-style: solid;\n\t\t\tleft: 50%;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south of the element.\n\t *\n\t *       [element]\n\t *           ^\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t */\n\t&.ck-tooltip_s,\n\t&.ck-tooltip_sw,\n\t&.ck-tooltip_se {\n\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( 100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\t/* 1px addresses gliches in rendering causing gap between the triangle and the text */\n\t\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size) + 1px);\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: transparent transparent var(--ck-color-tooltip-background) transparent;\n\t\t\tborder-width: 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-west of the element.\n\t *\n\t *        [element]\n\t *            ^\n\t *  +-----------+\n\t *  |  Tooltip  |\n\t *  +-----------+\n\t */\n\n\t&.ck-tooltip_sw {\n\t\tright: 50%;\n\t\tleft: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: auto;\n\t\t\tright: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tleft: auto;\n\t\t\tright: 0;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-east of the element.\n\t *\n\t *  [element]\n\t *      ^\n\t *    +-----------+\n\t *    |  Tooltip  |\n\t *    +-----------+\n\t */\n\t&.ck-tooltip_se {\n\t\tleft: 50%;\n\t\tright: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tright: auto;\n\t\t\tleft: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tright: auto;\n\t\t\tleft: 0;\n\t\t\ttransform: translateX( 50% );\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip north of the element.\n\t *\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t *           V\n\t *       [element]\n\t */\n\t&.ck-tooltip_n {\n\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( -100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: var(--ck-color-tooltip-background) transparent transparent transparent;\n\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip east of the element.\n\t *\n\t *                +----------+\n\t *    [element] < |   east   |\n\t *                +----------+\n\t */\n\t&.ck-tooltip_e {\n\t\tleft: calc(100% + var(--ck-tooltip-arrow-size));\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent var(--ck-color-tooltip-background) transparent transparent;\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip west of the element.\n\t *\n\t *    +----------+\n\t *    |   west   | > [element]\n\t *    +----------+\n\t */\n\t&.ck-tooltip_w {\n\t\tright: calc(100% + var(--ck-tooltip-arrow-size));\n\t\tleft: auto;\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: 100%;\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-color-tooltip-background);\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(var(--ck-spacing-small)*-1);margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"], names: [], mappings: "AAQA,6BCCC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6BD,CE/BC,qDACC,aAqBD,CAHC,oBAnBD,qDAoBE,YAEF,CADC,CFvBF,6BAKC,iBAAkB,CAClB,mBAAoB,CACpB,kBAAmB,CACnB,oBAyBD,CAvBC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEkBA,iEACC,kBAAmB,CACnB,SACD,CAbA,yFACC,YACD,CC7BD,6BCAC,oDD0ID,CCvIE,6EACC,0DACD,CAEA,+EACC,2DAA4C,CAC5C,uEACD,CAID,qDACC,6DACD,CDhBD,6BEDC,eF2ID,CA1IA,wIEGE,qCFuIF,CA1IA,6BAKC,kBAAmB,CACnB,cAAe,CACf,qBAAsB,CACtB,8BAA+B,CAC/B,iBAAkB,CAGlB,2CAA4C,CAC5C,4CAA6C,CAI7C,aAAc,CAGd,iBAAkB,CAGlB,4BAA6B,CAG7B,4DAA8D,CAG9D,uBA6GD,CA3GC,oFGjCA,YAAa,CACb,2BAA2B,CCF3B,2CJsCA,CAIC,kJAEC,aACD,CAGD,iEAEC,iBAAkB,CAClB,mBAAoB,CACpB,aAAc,CACd,cAAe,CAIf,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAEA,uFK3FD,kCL6FC,CAGA,yFKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAOE,6CAAgD,CAChD,mCAEF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDiIA,CC9HC,yFACC,qDACD,CAEA,2FACC,sDAA4C,CAC5C,kEACD,CAID,iEACC,wDACD,CDmHA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC7IC,mDDkJD,CC/IE,2FACC,yDACD,CAEA,6FACC,0DAA4C,CAC5C,sEACD,CAID,mEACC,4DACD,CD6HD,2CAIC,wCACD,CAEA,uCAEC,eACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\t@mixin ck-tooltip_enabled;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n\n\t&:hover {\n\t\t@mixin ck-tooltip_visible;\n\t}\n\n\t/* Get rid of the native focus outline around the tooltip when focused (but not :hover). */\n\t&:focus:not(:hover) {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t\tbox-shadow: inset 0 2px 2px var($(prefix)-active-shadow);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - var(--ck-switch-button-toggle-spacing)*2)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*0.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var(--ck-switch-button-translation)*-1))}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"], names: [], mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,mDAAoD,CACpD,qCAAsC,CACtC,gKAKD,CAGC,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDC3BA,eDoEA,CAzCA,yICvBC,qCDgED,CAzCA,2DAKE,gBAoCF,CAzCA,2DAUE,iBA+BF,CAzCA,iDAcC,8BAAiC,CAEjC,0CAA2C,CAC3C,uDAwBD,CAtBC,2EC9CD,eD2DC,CAbA,6LC1CA,qCAAsC,CD4CpC,+CAWF,CAbA,2EAMC,6CAA8C,CAC9C,+CAAgD,CAChD,gDAAiD,CACjD,yDAA0D,CAG1D,uBACD,CAEA,uDACC,6DAKD,CAHC,iFACC,+DACD,CAIF,6DExEA,kCF0EA,CAEA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,yDAMF,CAXA,2FASE,kEAEF", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: 1.0769230769em;\n\t--ck-switch-button-toggle-spacing: 1px;\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2 * var(--ck-switch-button-toggle-spacing)\n\t);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease;\n\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\t/* Leave some tiny bit of space around the inner part of the switch */\n\t\t\tmargin: var(--ck-switch-button-toggle-spacing);\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t&.ck-on .ck-button__toggle {\n\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t}\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t/*\n\t\t\t * Move the toggle switch to the right. It will be animated.\n\t\t\t */\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#000}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{width:var(--ck-color-grid-tile-size);height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;border:0}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{display:none;color:var(--ck-color-color-grid-check-icon)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css"], names: [], mappings: "AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,qCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBACC,oCAAqC,CACrC,qCAAsC,CACtC,wCAAyC,CACzC,yCAA0C,CAC1C,SAAU,CACV,8BAA+B,CAC/B,QAmCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,4DACC,gDACD,CAEA,oCACC,YAAa,CACb,2CACD,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(0, 0%, 0%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\twidth: var(--ck-color-grid-tile-size);\n\theight: var(--ck-color-grid-tile-size);\n\tmin-width: var(--ck-color-grid-tile-size);\n\tmin-height: var(--ck-color-grid-tile-size);\n\tpadding: 0;\n\ttransition: .2s ease box-shadow;\n\tborder: 0;\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t&.ck-color-table__color-tile_bordered {\n\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&.ck-on,\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\t/* Disable the default .ck-button\'s border ring. */\n\t\tborder: 0;\n\t}\n\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-radius:0}.ck-rounded-corners [dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow,[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-left-color:var(--ck-color-split-button-hover-border)}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-right-color:var(--ck-color-split-button-hover-border)}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,mBAEC,iBAUD,CARC,iDACC,qCACD,CC0BA,8DACC,YACD,CClCD,MACC,gDAAyD,CACzD,4CACD,CAMC,qDAGE,6BAA8B,CAC9B,gCAQF,CAZA,qDASE,4BAA6B,CAC7B,+BAEF,CAEA,0CAGC,eAmBD,CAtBA,oDCnBA,eDyCA,CAtBA,+ICfC,qCAAsC,CDuBpC,4BAA6B,CAC7B,+BAaH,CAtBA,oDAeE,6BAA8B,CAC9B,gCAMF,CAHC,8CACC,mCACD,CASA,0KACC,wDACD,CAGC,sKACC,2DACD,CAIA,sKACC,4DACD,CAMF,uCCpEA,eD8EA,CAVA,qHChEC,qCD0ED,CARE,qKACC,2BACD,CAEA,mKACC,4BACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n\n\t/* Disable tooltips for the buttons when the button is "open" */\n\t&.ck-splitbutton_open > .ck-button {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t& > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: unset;\n\t\t\t\tborder-bottom-left-radius: unset;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled) {\n\t\t\t\tborder-left-color: var(--ck-color-split-button-hover-border);\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled) {\n\t\t\t\tborder-right-color: var(--ck-color-split-button-hover-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);max-width:var(--ck-dropdown-max-width);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBAqFD,CAnFC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UAOD,CCUA,iEACC,YACD,CDVA,oCAGC,kCAAmC,CAEnC,YAAa,CACb,yBAA0B,CAC1B,sCAAuC,CAEvC,iBAyDD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSASC,QAAS,CACT,WACD,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CEhGA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CACC,gCAAiC,CAGjC,sCACD,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEACC,SAAU,CACV,eAAgB,CAChB,sBACD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eH8GD,CA5BA,qFG9EE,qCH0GF,CA5BA,uBEpFC,oCAA8B,CFwF9B,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CAGT,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"../tooltip/mixins/_tooltip.css\";\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\n\t\t/* Disable main button's tooltip when the dropdown is open. Otherwise the panel may\n\t\tpartially cover the tooltip */\n\t\t&.ck-on {\n\t\t\t@mixin ck-tooltip_disabled;\n\t\t}\n\t}\n\n\t& .ck-dropdown__panel {\n\t\t/* This is to get rid of flickering when the tooltip is shown under the panel,\n\t\twhich looks like the panel moves vertically a pixel down and up. */\n\t\t-webkit-backface-visibility: hidden;\n\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\t\t\t\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;background:var(--ck-color-toolbar-border);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,eCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,oBAAqB,CACrB,kBA6CD,CA3CC,kCACC,YAAa,CACb,kBAAmB,CACnB,kBAAmB,CACnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eD0FD,CA7FA,qECOE,qCDsFF,CA7FA,eAGC,6CAA8C,CAC9C,iCAAkC,CAClC,+CAwFD,CAtFC,yCACC,kBAAmB,CACnB,SAAU,CACV,aAAc,CACd,yCAA0C,CAM1C,kCAAmC,CACnC,qCACD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAGC,kCAAmC,CACnC,qCACD,CAEA,mCAEC,SAgBD,CAbC,0DAEC,UAAW,CAGX,QAAS,CAGT,eAAgB,CAGhB,QACD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAvFF,qCA2FE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JACC,wBAAyB,CACzB,2BACD,CAGA,2JACC,yBAA0B,CAC1B,4BACD,CAID,qGACC,mCACD,CAGA,yLACC,mCACD,CAWA,qHACC,cACD,CAIC,6JACC,yBAA0B,CAC1B,4BACD,CAGA,2JACC,wBAAyB,CACzB,2BACD,CAID,qGACC,oCACD,CAGA,yLACC,oCACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so any border is pointless. */\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(var(--ck-line-height-base)*0.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,YCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,qBAcD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAGC,oBAAqB,CACrB,0CACD,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BACC,gBAAiB,CACjB,UAAW,CACX,eAAgB,CAChB,eAAgB,CAKhB,mIAiCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,2DACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBACC,UAAW,CACX,UAAW,CACX,sCACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{width:max-content;max-width:var(--ck-toolbar-dropdown-max-width)}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"], names: [], mappings: "AAKA,MACC,oCACD,CAEA,4CAEC,iBAAkB,CAClB,8CAOD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDIpC,wBAAyB,CACzB,2BAA4B,CAC5B,4BAEF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEERA,YAAa,CACb,2BAA2B,CCF3B,qCHYA,CAGD,+BACC,aAAc,CACd,oCAAqC,CACrC,4BAwBD,CAtBC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CACC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-base-foreground);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-base-foreground);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"], names: [], mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-form__header{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{padding:var(--ck-spacing-small) var(--ck-spacing-large);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-form__header .ck-form__header__label{font-weight:700}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"], names: [], mappings: "AAKA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,kBAAmB,CACnB,6BACD,CCNA,MACC,4BACD,CAEA,oBACC,uDAAwD,CACxD,mCAAoC,CACpC,wCAAyC,CACzC,mDAKD,CAHC,4CACC,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& .ck-form__header__label {\n\t\tfont-weight: bold;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/inputtext/inputtext.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AASA,MACC,0BACD,CAEA,kBCFC,eDwCD,CAtCA,2ECEE,qCDoCF,CAtCA,kBAGC,2CAA4C,CAC5C,6CAA8C,CAC9C,6DAA8D,CAC9D,oCAAqC,CAGrC,4CAA6C,CAG7C,4DA0BD,CAxBC,wBEjBA,YAAa,CACb,2BAA2B,CCF3B,2CHqBA,CAEA,4BACC,sDAAuD,CACvD,oDAAqD,CACrD,yCAMD,CAJC,kCG5BD,oDH+BC,CAGD,2BACC,+CAAgD,CAChD,2CAKD,CAHC,iCGtCD,iDHwCC,CAIF,+BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-text-width: 18em;\n}\n\n.ck.ck-input-text {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-text-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-text-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-text-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{pointer-events:none;transform-origin:0 0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);background:var(--ck-color-labeled-field-label-background);padding:0 calc(var(--ck-font-size-tiny)*0.5);line-height:normal;font-weight:400;text-overflow:ellipsis;overflow:hidden;max-width:100%;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-spacing-medium),calc(var(--ck-font-size-base)*0.6)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-spacing-medium)*-1),calc(var(--ck-font-size-base)*0.6)) scale(1)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));background:transparent;padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,yEACD,CAEA,0BCHC,eD4GD,CAzGA,2FCCE,qCDwGF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAWC,mBAAoB,CACpB,oBAAqB,CAGrB,6DAA+D,CAE/D,yDAA0D,CAC1D,4CAA8C,CAC9C,kBAAoB,CACpB,eAAmB,CAGnB,sBAAuB,CACvB,eAAgB,CAEhB,cAAe,CAEf,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,wSAGE,yFAYF,CAfA,wSAOE,kGAQF,CAfA,oRAWC,iEAAkE,CAElE,sBAAuB,CACvB,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-spacing-medium), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border);filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}', "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCJC,eD4ID,CAxIA,iFCAE,qCDwIF,CAxIA,qBENC,oCAA8B,CFU9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAiID,CA9HE,+GAEC,OAAQ,CACR,QAAS,CACT,kBACD,CAIA,uFAEC,oDAAoH,CAApH,kDAAoH,CAApH,qDAAoH,CAApH,kBACD,CAEA,4CACC,gDACD,CAEA,uFAHC,6BAA8E,CAA9E,8BAA8E,CAA9E,4BAMD,CAHA,2CACC,oDAAkF,CAClF,yCACD,CAIA,uFAEC,oDAAoH,CAApH,qBAAoH,CAApH,qDAAoH,CAApH,+CACD,CAEA,4CACC,6CAAkE,CAClE,uDACD,CAEA,uFAJC,6BAAkE,CAAlE,+BAAkE,CAAlE,8BAOD,CAHA,2CACC,iDAAkF,CAClF,4CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,8CACD,CAIA,2GAEC,+CAAkD,CAClD,8CACD,CAIA,2GAEC,gDAAmD,CACnD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,8CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"], names: [], mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCACC,oCAAqC,CACrC,kCAAmC,CACnC,qCACD,CAGA,iEACC,uCAAwC,CAGxC,mCACD,CAMA,2DACC,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBCJC,oCAA8B,CDO9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CAEtC,UAAW,CACX,WACD,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAMC,qDACC,yBAA0B,CAC1B,cAAe,CACf,KACD,CAEA,kEACC,QAAS,CACT,iBACD,CCPA,qDCCA,oCAA8B,CDE7B,sBAAuB,CACvB,wBAAyB,CACzB,yBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"], names: [], mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-placeholder,.ck .ck-placeholder{position:relative}.ck.ck-placeholder:before,.ck .ck-placeholder:before{position:absolute;left:0;right:0;content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"], names: [], mappings: "AAMA,uCAEC,iBAWD,CATC,qDACC,iBAAkB,CAClB,MAAO,CACP,OAAQ,CACR,8BAA+B,CAG/B,mBACD,CAKA,wCACC,YACD,CClBA,qDACC,WAAY,CACZ,6CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css"], names: [], mappings: "AAKA,uBAEC,eAAgB,CAGhB,mBAAoB,CACpB,kBAAmB,CAEnB,aAAc,CACd,cAAe,CACf,iBAAkB,CAClB,0BACD,CAEA,gCACC,aAAc,CACd,2BACD", sourcesContent: ['/**\n * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, '.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(var(--ck-widget-outline-thickness)*-0.5);left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-0.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"], names: [], mappings: "AASC,+CACC,aAAc,CACd,iBAAkB,CAClB,eAAgB,CAChB,2BAwBD,CAtBC,mDACC,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAEA,qFAEC,iDAAoD,CACpD,kBAAoB,CAEpB,0BACD,CAEA,oFAEC,oDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CACd,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAMD,2EACC,YAAa,CACb,iBAAkB,CAClB,MAAO,CACP,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHACC,qDAA0D,CAC1D,aACD,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CACC,8CAA+C,CAC/C,+CAAgD,CAChD,oDAAqD,CACrD,mBAAoB,CACpB,uMAAyM,CAb1M,SAAU,CACV,mBA0DA,CA1CC,mDACC,UAAW,CACX,UAAW,CACX,8BAA+B,CAC/B,6BAA8B,CAC9B,cAgBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLACC,0DAA2D,CAC3D,2DAA4D,CAC5D,mBAAoB,CACpB,uEACD,CAOD,8GACC,gBACD,CAKA,mDACC,mBAAoB,CACpB,UAAW,CACX,mFAAoF,CAMpF,oCAAwC,CACxC,oCACD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CASE,0jBACC,SACD,CASF,mPACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CACtD,0CAA2C,CAC3C,qDAAsD,CACtD,6CAA8C,CAC9C,kCAAmC,CACnC,aAAc,CACd,+BA4BD,CA1BC,gLAIC,iBACD,CAEA,0CACC,oCAAqC,CACrC,qCACD,CAEA,2CACC,oCAAqC,CACrC,sCACD,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CCtED,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eACC,gDAAiD,CACjD,mBAAoB,CACpB,yBAA0B,CAC1B,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGC/BA,YAAa,CACb,2BAA2B,CCF3B,qCAA8B,CFqC7B,iEACD,CAIA,4EACC,WAAY,CACZ,qBAAsB,CAGtB,4BAA6B,CAC7B,SAAU,CAMV,6SAG6F,CAG7F,iEAAkE,CAGlE,2BAA4B,CAC5B,mDAqBD,CAnBC,qFAEC,wCAAyC,CACzC,yCAA0C,CAC1C,oDASD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFACC,SAAU,CACV,oDACD,CAKC,oMACC,SAAU,CACV,6CAMD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: var(--ck-spacing-small);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;position:relative;pointer-events:none}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);border:1px solid var(--ck-clipboard-drop-target-color);background:var(--ck-clipboard-drop-target-color);margin-left:-1px}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{content:"";width:0;height:0;display:block;position:absolute;left:50%;top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);transform:translateX(-50%);border-left:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-bottom:0 solid transparent;border-right:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-top:calc(var(--ck-clipboard-drop-target-dot-height)) solid var(--ck-clipboard-drop-target-color)}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}', "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"], names: [], mappings: "AASC,8DACC,cAAe,CACf,iBAAkB,CAClB,mBAMD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CCzBF,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEACC,4DAA8D,CAC9D,yDAA2D,CAC3D,sDAAuD,CACvD,gDAAiD,CACjD,gBAkBD,CAfC,yEACC,UAAW,CACX,OAAQ,CACR,QAAS,CAET,aAAc,CACd,iBAAkB,CAClB,QAAS,CACT,yDAA2D,CAE3D,0BAA2B,CAG3B,iFAAmB,CAAnB,iCAAmB,CAAnB,kFAAmB,CAAnB,uGACD,CA2DF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border)\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(var(--ck-clipboard-drop-target-dot-height) * -.5);\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t// Horizontal drop target (between blocks).\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\ttext-align: initial;\n\n\t\t& .ck-clipboard-drop-target__line {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 0;\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-top: -1px;\n\n\t\t\t&::before {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) 0 var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size)) var(--ck-clipboard-drop-target-dot-size) 0;\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\t*/\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck .ck-button.ck-color-table__remove-color{display:flex;align-items:center;width:100%}label.ck.ck-color-grid__label{font-weight:unset}.ck .ck-button.ck-color-table__remove-color{padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck .ck-button.ck-color-table__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-base-border)}[dir=ltr] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-font/theme/fontcolor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-font/fontcolor.css"], names: [], mappings: "AAKA,4CACC,YAAa,CACb,kBAAmB,CACnB,UACD,CAEA,8BACC,iBACD,CCNA,4CACC,qEAAyE,CACzE,2BAA4B,CAC5B,4BAeD,CAbC,wDACC,mDACD,CAEA,kEAEE,uCAMF,CARA,kEAME,sCAEF", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-button.ck-color-table__remove-color {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n}\n\nlabel.ck.ck-color-grid__label {\n\tfont-weight: unset;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck .ck-button.ck-color-table__remove-color {\n\tpadding: calc(var(--ck-spacing-standard) / 2 ) var(--ck-spacing-standard);\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n\n\t&:not(:focus) {\n\t\tborder-bottom: 1px solid var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n}\n\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck-content .text-tiny{font-size:.7em}.ck-content .text-small{font-size:.85em}.ck-content .text-big{font-size:1.4em}.ck-content .text-huge{font-size:1.8em}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-font/theme/fontsize.css"], names: [], mappings: "AAUC,uBACC,cACD,CAEA,wBACC,eACD,CAEA,sBACC,eACD,CAEA,uBACC,eACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* The values should be synchronized with the "FONT_SIZE_PRESET_UNITS" object in the "/src/fontsize/utils.js" file. */\n\n/* Styles should be prefixed with the `.ck-content` class.\nSee https://github.com/ckeditor/ckeditor5/issues/6636 */\n.ck-content {\n\t& .text-tiny {\n\t\tfont-size: .7em;\n\t}\n\n\t& .text-small {\n\t\tfont-size: .85em;\n\t}\n\n\t& .text-big {\n\t\tfont-size: 1.4em;\n\t}\n\n\t& .text-huge {\n\t\tfont-size: 1.8em;\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"], names: [], mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"], names: [], mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CACb,iBAAkB,CAGlB,mBAAoB,CAEpB,MAAO,CACP,KACD,CAGC,2EACC,aACD,CAGD,gCACC,iBAAkB,CAGlB,kBAWD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCACC,4BAA6B,CAC7B,6BAA8B,CAC9B,uCAAwC,CACxC,gDAA6D,CAC7D,6CAqBD,CAnBC,oEACC,4BAA6B,CAC7B,6BACD,CAEA,qEACC,4BAA6B,CAC7B,8BACD,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"], names: [], mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, '.ck-vertical-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-text-width)*0.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-large);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after,[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"], names: [], mappings: "AAOA,mCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCTC,oCDaC,wCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCnBD,CCAD,qDACC,kDACD,CAEA,uBACC,+BAkED,CAhEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,0CA6CF,CA3CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAID,iGAEC,kCAAmC,CACnC,kCAAmC,CAEnC,eAAgB,CAChB,QAAS,CACT,gDAaD,CApBA,0OAcE,aAMF,CAGC,yMACC,kDACD,CDpEF", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button::after {\n\tcontent: "";\n\twidth: 0;\n\tposition: absolute;\n\tright: -1px;\n\ttop: var(--ck-spacing-small);\n\tbottom: var(--ck-spacing-small);\n\tz-index: 1;\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\tposition: absolute;\n\t\t\tright: -1px;\n\t\t\ttop: var(--ck-spacing-small);\n\t\t\tbottom: var(--ck-spacing-small);\n\t\t\tz-index: 1;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-text-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t\tborder-radius: 0;\n\t\t\tborder: 0;\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:50px}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{position:static}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css"], names: [], mappings: "AAKA,mBACC,aAAc,CACd,UAAW,CACX,iBAAkB,CAGlB,eAeD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD,CAQD,gEACC,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .image {\n\tdisplay: table;\n\tclear: both;\n\ttext-align: center;\n\n\t/* Make sure there is some space between the content and the image. Center image by default. */\n\tmargin: 1em auto;\n\n\t& img {\n\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\tdisplay: block;\n\n\t\t/* Center the image if its width is smaller than the content's width. */\n\t\tmargin: 0 auto;\n\n\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\tmax-width: 100%;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\t}\n}\n\n/*\n * Since the caption placeholder for images disappears when focused, it does not require special treatment\n * and can go with a position that follows text alignment of an .image out-of-the-box (center by default).\n * See https://github.com/ckeditor/ckeditor5/issues/8689.\n */\n.ck.ck-editor__editable .image > figcaption.ck-placeholder::before {\n\tposition: static;\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css"], names: [], mappings: "AAKA,8BACC,qBAAsB,CACtB,mBAAoB,CACpB,qBAAsB,CACtB,UAAsB,CACtB,wBAAiC,CACjC,YAAa,CACb,eAAgB,CAChB,mBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: hsl(0, 0%, 20%);\n\tbackground-color: hsl(0, 0%, 97%);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck-content .image.image_resized{max-width:100%;display:block;box-sizing:border-box}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageresize.css"], names: [], mappings: "AAKA,iCACC,cAAe,CAMf,aAAc,CACd,qBAWD,CATC,qCAEC,UACD,CAEA,4CAEC,aACD,CAGD,oFACC,uCACD,CAEA,oFACC,sCACD,CAEA,oEACC,SACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .image.image_resized {\n\tmax-width: 100%;\n\t/*\n\tThe `<figure>` element for resized images must not use `display:table` as browsers do not support `max-width` for it well.\n\tSee https://stackoverflow.com/questions/4019604/chrome-safari-ignoring-max-width-in-table/14420691#14420691 for more.\n\tFortunately, since we control the width, there is no risk that the image will look bad.\n\t*/\n\tdisplay: block;\n\tbox-sizing: border-box;\n\n\t& img {\n\t\t/* For resized images it is the `<figure>` element that determines the image width. */\n\t\twidth: 100%;\n\t}\n\n\t& > figcaption {\n\t\t/* The `<figure>` element uses `display:block`, so `<figcaption>` also has to. */\n\t\tdisplay: block;\n\t}\n}\n\n[dir="ltr"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-right: var(--ck-spacing-standard);\n}\n\n[dir="rtl"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-left: var(--ck-spacing-standard);\n}\n\n.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label {\n\twidth: 4em;\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css"], names: [], mappings: "AAKA,MACC,8BACD,CAGC,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n}\n\n.ck-content {\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"], names: [], mappings: "AAKA,+BACC,iBACD,CAGA,gDACC,iBAAkB,CAClB,KAAM,CACN,MACD,CCPC,yCACC,oBACD,CAID,gDACC,UAAW,CACX,OAAQ,CACR,gDAAiD,CACjD,oBACD,CAEA,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable .image {\n\tposition: relative;\n}\n\n/* Upload progress bar. */\n.ck.ck-editor__editable .image .ck-progress-bar {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable .image {\n\t/* Showing animation. */\n\t&.ck-appear {\n\t\tanimation: fadeIn 700ms;\n\t}\n}\n\n/* Upload progress bar. */\n.ck.ck-editor__editable .image .ck-progress-bar {\n\theight: 2px;\n\twidth: 0;\n\tbackground: var(--ck-color-upload-bar-background);\n\ttransition: width 100ms;\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}', "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"], names: [], mappings: "AAKA,+BACC,aAAc,CACd,iBAAkB,CAClB,QAAS,CACT,UAAW,CACX,iBAMD,CAJC,qCACC,UAAW,CACX,iBACD,CCVD,MACC,iCAA8C,CAC9C,+CAA4D,CAE5D,gCAAiC,CACjC,gCACD,CAEA,+BACC,sCAAuC,CACvC,uCAAwC,CACxC,SAAU,CACV,uDAAwD,CACxD,wEAA0E,CAC1E,qCAAuC,CACvC,0BAAgC,CAGhC,0CAA2C,CAG3C,sBAyBD,CAtBC,qCAEC,QAAS,CAET,OAAQ,CACR,SAAU,CACV,QAAS,CACT,OAAQ,CAER,mCAAoC,CACpC,yBAA0B,CAC1B,oFAAqF,CACrF,sFAAuF,CAEvF,4CAA6C,CAC7C,sBAAyB,CACzB,mBAAsB,CACtB,4BAA6B,CAG7B,qBACD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GACC,SAAU,CACV,OAAQ,CACR,QACD,CACA,IACC,UAAY,CACZ,QACD,CACA,GACC,SAAU,CACV,UAAY,CACZ,YACD,CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n\tborder-radius: 50%;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t--ck-image-upload-icon-size: 20px;\n\t--ck-image-upload-icon-width: 2px;\n}\n\n.ck-image-upload-complete-icon {\n\twidth: var(--ck-image-upload-icon-size);\n\theight: var(--ck-image-upload-icon-size);\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: var(--ck-image-upload-icon-size);\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"], names: [], mappings: "AAKA,kCACC,iBAAkB,CAClB,YAAa,CACb,kBAAmB,CACnB,sBAAuB,CACvB,KAAM,CACN,MAMD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCACD,CAEA,iCAEC,UAAW,CACX,QACD,CAEA,kCACC,UAAW,CACX,WAUD,CARC,yCACC,8CAA+C,CAC/C,+CAAgD,CAChD,iBAAkB,CAClB,8DAA+D,CAC/D,kCAAmC,CACnC,yDACD,CAGD,wCACC,GACC,uBACD,CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{height:100%;border-right:1px solid var(--ck-color-base-text);margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css"], names: [], mappings: "AAMA,sBACC,mDACD,CAMA,4BACC,8CACD,CAGA,sCACC,WAAY,CACZ,gDAAiD,CACjD,iBAAkB,CAClB,oCACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"], names: [], mappings: "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCACC,SAAU,CACV,oCA8CD,CA5CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CACC,kCAAmC,CACnC,QAAS,CACT,eAAgB,CAChB,QAAS,CACT,gDAAiD,CACjD,SAaD,CAnBA,4GAaE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAWD,CATC,wEACC,QAAS,CACT,SAAU,CACV,UAKD,CAHC,8EACC,eACD", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-text-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\tborder-radius: 0;\n\t\tborder: 0;\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\twidth: 50%;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tborder: 0;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e, n) {
        "use strict";
        var o = n(2);
        var i = n.n(o);
        var r = n(3);
        var s = n.n(r);
        var a = s()(i.a);
        a.push([t.i, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", { version: 3, sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"], names: [], mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCKA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EACC,kCAAmC,CACnC,kCAAmC,CACnC,sBAAuB,CACvB,cAAe,CAIf,oCAAqC,CACrC,aAAc,CACd,iBAKD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDvDD,oCC2DC,wDACC,8DAMD,CAJC,0EACC,WAAY,CACZ,cACD,CAGD,gJAME,aAEF,CD1ED", sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-text-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'], sourceRoot: "" }]);
        e["a"] = a;
    }, function (t, e) { var n; n = function () { return this; }(); try {
        n = n || new Function("return this")();
    }
    catch (t) {
        if (typeof window === "object")
            n = window;
    } t.exports = n; }, function (t, e, n) {
        "use strict";
        function o() { return false; }
        e["a"] = o;
    }, function (t, e, n) {
        "use strict";
        n.r(e);
        function o() { return function t() { t.called = true; }; }
        var i = o;
        class r {
            constructor(t, e) { this.source = t; this.name = e; this.path = []; this.stop = i(); this.off = i(); }
        }
        const s = new Array(256).fill().map(((t, e) => ("0" + e.toString(16)).slice(-2)));
        function a() { const t = Math.random() * 4294967296 >>> 0; const e = Math.random() * 4294967296 >>> 0; const n = Math.random() * 4294967296 >>> 0; const o = Math.random() * 4294967296 >>> 0; return "e" + s[t >> 0 & 255] + s[t >> 8 & 255] + s[t >> 16 & 255] + s[t >> 24 & 255] + s[e >> 0 & 255] + s[e >> 8 & 255] + s[e >> 16 & 255] + s[e >> 24 & 255] + s[n >> 0 & 255] + s[n >> 8 & 255] + s[n >> 16 & 255] + s[n >> 24 & 255] + s[o >> 0 & 255] + s[o >> 8 & 255] + s[o >> 16 & 255] + s[o >> 24 & 255]; }
        const c = { get(t) { if (typeof t != "number") {
                return this[t] || this.normal;
            }
            else {
                return t;
            } }, highest: 1e5, high: 1e3, normal: 0, low: -1e3, lowest: -1e5 };
        var l = c;
        var d = n(8);
        var u = n(0);
        const h = Symbol("listeningTo");
        const f = Symbol("emitterId");
        const p = { on(t, e, n = {}) { this.listenTo(this, t, e, n); }, once(t, e, n) { let o = false; const i = function (t, ...n) { if (!o) {
                o = true;
                t.off();
                e.call(this, t, ...n);
            } }; this.listenTo(this, t, i, n); }, off(t, e) { this.stopListening(this, t, e); }, listenTo(t, e, n, o = {}) { let i, r; if (!this[h]) {
                this[h] = {};
            } const s = this[h]; if (!b(t)) {
                k(t);
            } const a = b(t); if (!(i = s[a])) {
                i = s[a] = { emitter: t, callbacks: {} };
            } if (!(r = i.callbacks[e])) {
                r = i.callbacks[e] = [];
            } r.push(n); x(this, t, e, n, o); }, stopListening(t, e, n) { const o = this[h]; let i = t && b(t); const r = o && i && o[i]; const s = r && e && r.callbacks[e]; if (!o || t && !r || e && !s) {
                return;
            } if (n) {
                E(this, t, e, n);
                const o = s.indexOf(n);
                if (o !== -1) {
                    if (s.length === 1) {
                        delete r.callbacks[e];
                    }
                    else {
                        E(this, t, e, n);
                    }
                }
            }
            else if (s) {
                while (n = s.pop()) {
                    E(this, t, e, n);
                }
                delete r.callbacks[e];
            }
            else if (r) {
                for (e in r.callbacks) {
                    this.stopListening(t, e);
                }
                delete o[i];
            }
            else {
                for (i in o) {
                    this.stopListening(o[i].emitter);
                }
                delete this[h];
            } }, fire(t, ...e) { try {
                const n = t instanceof r ? t : new r(this, t);
                const o = n.name;
                let i = C(this, o);
                n.path.push(this);
                if (i) {
                    const t = [n, ...e];
                    i = Array.from(i);
                    for (let e = 0; e < i.length; e++) {
                        i[e].callback.apply(this, t);
                        if (n.off.called) {
                            delete n.off.called;
                            this._removeEventListener(o, i[e].callback);
                        }
                        if (n.stop.called) {
                            break;
                        }
                    }
                }
                if (this._delegations) {
                    const t = this._delegations.get(o);
                    const i = this._delegations.get("*");
                    if (t) {
                        y(t, n, e);
                    }
                    if (i) {
                        y(i, n, e);
                    }
                }
                return n.return;
            }
            catch (t) {
                u["a"].rethrowUnexpectedError(t, this);
            } }, delegate(...t) { return { to: (e, n) => { if (!this._delegations) {
                    this._delegations = new Map;
                } t.forEach((t => { const o = this._delegations.get(t); if (!o) {
                    this._delegations.set(t, new Map([[e, n]]));
                }
                else {
                    o.set(e, n);
                } })); } }; }, stopDelegating(t, e) { if (!this._delegations) {
                return;
            } if (!t) {
                this._delegations.clear();
            }
            else if (!e) {
                this._delegations.delete(t);
            }
            else {
                const n = this._delegations.get(t);
                if (n) {
                    n.delete(e);
                }
            } }, _addEventListener(t, e, n) { v(this, t); const o = A(this, t); const i = l.get(n.priority); const r = { callback: e, priority: i }; for (const t of o) {
                let e = false;
                for (let n = 0; n < t.length; n++) {
                    if (t[n].priority < i) {
                        t.splice(n, 0, r);
                        e = true;
                        break;
                    }
                }
                if (!e) {
                    t.push(r);
                }
            } }, _removeEventListener(t, e) { const n = A(this, t); for (const t of n) {
                for (let n = 0; n < t.length; n++) {
                    if (t[n].callback == e) {
                        t.splice(n, 1);
                        n--;
                    }
                }
            } } };
        var g = p;
        function m(t, e) { if (t[h] && t[h][e]) {
            return t[h][e].emitter;
        } return null; }
        function k(t, e) { if (!t[f]) {
            t[f] = e || a();
        } }
        function b(t) { return t[f]; }
        function w(t) { if (!t._events) {
            Object.defineProperty(t, "_events", { value: {} });
        } return t._events; }
        function _() { return { callbacks: [], childEvents: [] }; }
        function v(t, e) { const n = w(t); if (n[e]) {
            return;
        } let o = e; let i = null; const r = []; while (o !== "") {
            if (n[o]) {
                break;
            }
            n[o] = _();
            r.push(n[o]);
            if (i) {
                n[o].childEvents.push(i);
            }
            i = o;
            o = o.substr(0, o.lastIndexOf(":"));
        } if (o !== "") {
            for (const t of r) {
                t.callbacks = n[o].callbacks.slice();
            }
            n[o].childEvents.push(i);
        } }
        function A(t, e) { const n = w(t)[e]; if (!n) {
            return [];
        } let o = [n.callbacks]; for (let e = 0; e < n.childEvents.length; e++) {
            const i = A(t, n.childEvents[e]);
            o = o.concat(i);
        } return o; }
        function C(t, e) { let n; if (!t._events || !(n = t._events[e]) || !n.callbacks.length) {
            if (e.indexOf(":") > -1) {
                return C(t, e.substr(0, e.lastIndexOf(":")));
            }
            else {
                return null;
            }
        } return n.callbacks; }
        function y(t, e, n) { for (let [o, i] of t) {
            if (!i) {
                i = e.name;
            }
            else if (typeof i == "function") {
                i = i(e.name);
            }
            const t = new r(e.source, i);
            t.path = [...e.path];
            o.fire(t, ...n);
        } }
        function x(t, e, n, o, i) { if (e._addEventListener) {
            e._addEventListener(n, o, i);
        }
        else {
            t._addEventListener.call(e, n, o, i);
        } }
        function E(t, e, n, o) { if (e._removeEventListener) {
            e._removeEventListener(n, o);
        }
        else {
            t._removeEventListener.call(e, n, o);
        } }
        function D(t) { var e = typeof t; return t != null && (e == "object" || e == "function"); }
        var S = D;
        var T = n(5);
        var P = T["a"].Symbol;
        var B = P;
        var I = Object.prototype;
        var R = I.hasOwnProperty;
        var F = I.toString;
        var O = B ? B.toStringTag : undefined;
        function z(t) { var e = R.call(t, O), n = t[O]; try {
            t[O] = undefined;
            var o = true;
        }
        catch (t) { } var i = F.call(t); if (o) {
            if (e) {
                t[O] = n;
            }
            else {
                delete t[O];
            }
        } return i; }
        var N = z;
        var M = Object.prototype;
        var V = M.toString;
        function L(t) { return V.call(t); }
        var q = L;
        var K = "[object Null]", j = "[object Undefined]";
        var H = B ? B.toStringTag : undefined;
        function W(t) { if (t == null) {
            return t === undefined ? j : K;
        } return H && H in Object(t) ? N(t) : q(t); }
        var $ = W;
        var G = "[object AsyncFunction]", U = "[object Function]", J = "[object GeneratorFunction]", Y = "[object Proxy]";
        function Q(t) { if (!S(t)) {
            return false;
        } var e = $(t); return e == U || e == J || e == G || e == Y; }
        var X = Q;
        var Z = T["a"]["__core-js_shared__"];
        var tt = Z;
        var et = function () { var t = /[^.]+$/.exec(tt && tt.keys && tt.keys.IE_PROTO || ""); return t ? "Symbol(src)_1." + t : ""; }();
        function nt(t) { return !!et && et in t; }
        var ot = nt;
        var it = Function.prototype;
        var rt = it.toString;
        function st(t) { if (t != null) {
            try {
                return rt.call(t);
            }
            catch (t) { }
            try {
                return t + "";
            }
            catch (t) { }
        } return ""; }
        var at = st;
        var ct = /[\\^$.*+?()[\]{}|]/g;
        var lt = /^\[object .+?Constructor\]$/;
        var dt = Function.prototype, ut = Object.prototype;
        var ht = dt.toString;
        var ft = ut.hasOwnProperty;
        var pt = RegExp("^" + ht.call(ft).replace(ct, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        function gt(t) { if (!S(t) || ot(t)) {
            return false;
        } var e = X(t) ? pt : lt; return e.test(at(t)); }
        var mt = gt;
        function kt(t, e) { return t == null ? undefined : t[e]; }
        var bt = kt;
        function wt(t, e) { var n = bt(t, e); return mt(n) ? n : undefined; }
        var _t = wt;
        var vt = function () { try {
            var t = _t(Object, "defineProperty");
            t({}, "", {});
            return t;
        }
        catch (t) { } }();
        var At = vt;
        function Ct(t, e, n) { if (e == "__proto__" && At) {
            At(t, e, { configurable: true, enumerable: true, value: n, writable: true });
        }
        else {
            t[e] = n;
        } }
        var yt = Ct;
        function xt(t, e) { return t === e || t !== t && e !== e; }
        var Et = xt;
        var Dt = Object.prototype;
        var St = Dt.hasOwnProperty;
        function Tt(t, e, n) { var o = t[e]; if (!(St.call(t, e) && Et(o, n)) || n === undefined && !(e in t)) {
            yt(t, e, n);
        } }
        var Pt = Tt;
        function Bt(t, e, n, o) { var i = !n; n || (n = {}); var r = -1, s = e.length; while (++r < s) {
            var a = e[r];
            var c = o ? o(n[a], t[a], a, n, t) : undefined;
            if (c === undefined) {
                c = t[a];
            }
            if (i) {
                yt(n, a, c);
            }
            else {
                Pt(n, a, c);
            }
        } return n; }
        var It = Bt;
        function Rt(t) { return t; }
        var Ft = Rt;
        function Ot(t, e, n) { switch (n.length) {
            case 0: return t.call(e);
            case 1: return t.call(e, n[0]);
            case 2: return t.call(e, n[0], n[1]);
            case 3: return t.call(e, n[0], n[1], n[2]);
        } return t.apply(e, n); }
        var zt = Ot;
        var Nt = Math.max;
        function Mt(t, e, n) { e = Nt(e === undefined ? t.length - 1 : e, 0); return function () { var o = arguments, i = -1, r = Nt(o.length - e, 0), s = Array(r); while (++i < r) {
            s[i] = o[e + i];
        } i = -1; var a = Array(e + 1); while (++i < e) {
            a[i] = o[i];
        } a[e] = n(s); return zt(t, this, a); }; }
        var Vt = Mt;
        function Lt(t) { return function () { return t; }; }
        var qt = Lt;
        var Kt = !At ? Ft : function (t, e) { return At(t, "toString", { configurable: true, enumerable: false, value: qt(e), writable: true }); };
        var jt = Kt;
        var Ht = 800, Wt = 16;
        var $t = Date.now;
        function Gt(t) { var e = 0, n = 0; return function () { var o = $t(), i = Wt - (o - n); n = o; if (i > 0) {
            if (++e >= Ht) {
                return arguments[0];
            }
        }
        else {
            e = 0;
        } return t.apply(undefined, arguments); }; }
        var Ut = Gt;
        var Jt = Ut(jt);
        var Yt = Jt;
        function Qt(t, e) { return Yt(Vt(t, e, Ft), t + ""); }
        var Xt = Qt;
        var Zt = 9007199254740991;
        function te(t) { return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Zt; }
        var ee = te;
        function ne(t) { return t != null && ee(t.length) && !X(t); }
        var oe = ne;
        var ie = 9007199254740991;
        var re = /^(?:0|[1-9]\d*)$/;
        function se(t, e) { var n = typeof t; e = e == null ? ie : e; return !!e && (n == "number" || n != "symbol" && re.test(t)) && (t > -1 && t % 1 == 0 && t < e); }
        var ae = se;
        function ce(t, e, n) { if (!S(n)) {
            return false;
        } var o = typeof e; if (o == "number" ? oe(n) && ae(e, n.length) : o == "string" && e in n) {
            return Et(n[e], t);
        } return false; }
        var le = ce;
        function de(t) { return Xt((function (e, n) { var o = -1, i = n.length, r = i > 1 ? n[i - 1] : undefined, s = i > 2 ? n[2] : undefined; r = t.length > 3 && typeof r == "function" ? (i--, r) : undefined; if (s && le(n[0], n[1], s)) {
            r = i < 3 ? undefined : r;
            i = 1;
        } e = Object(e); while (++o < i) {
            var a = n[o];
            if (a) {
                t(e, a, o, r);
            }
        } return e; })); }
        var ue = de;
        function he(t, e) { var n = -1, o = Array(t); while (++n < t) {
            o[n] = e(n);
        } return o; }
        var fe = he;
        function pe(t) { return t != null && typeof t == "object"; }
        var ge = pe;
        var me = "[object Arguments]";
        function ke(t) { return ge(t) && $(t) == me; }
        var be = ke;
        var we = Object.prototype;
        var _e = we.hasOwnProperty;
        var ve = we.propertyIsEnumerable;
        var Ae = be(function () { return arguments; }()) ? be : function (t) { return ge(t) && _e.call(t, "callee") && !ve.call(t, "callee"); };
        var Ce = Ae;
        var ye = Array.isArray;
        var xe = ye;
        var Ee = n(6);
        var De = "[object Arguments]", Se = "[object Array]", Te = "[object Boolean]", Pe = "[object Date]", Be = "[object Error]", Ie = "[object Function]", Re = "[object Map]", Fe = "[object Number]", Oe = "[object Object]", ze = "[object RegExp]", Ne = "[object Set]", Me = "[object String]", Ve = "[object WeakMap]";
        var Le = "[object ArrayBuffer]", qe = "[object DataView]", Ke = "[object Float32Array]", je = "[object Float64Array]", He = "[object Int8Array]", We = "[object Int16Array]", $e = "[object Int32Array]", Ge = "[object Uint8Array]", Ue = "[object Uint8ClampedArray]", Je = "[object Uint16Array]", Ye = "[object Uint32Array]";
        var Qe = {};
        Qe[Ke] = Qe[je] = Qe[He] = Qe[We] = Qe[$e] = Qe[Ge] = Qe[Ue] = Qe[Je] = Qe[Ye] = true;
        Qe[De] = Qe[Se] = Qe[Le] = Qe[Te] = Qe[qe] = Qe[Pe] = Qe[Be] = Qe[Ie] = Qe[Re] = Qe[Fe] = Qe[Oe] = Qe[ze] = Qe[Ne] = Qe[Me] = Qe[Ve] = false;
        function Xe(t) { return ge(t) && ee(t.length) && !!Qe[$(t)]; }
        var Ze = Xe;
        function tn(t) { return function (e) { return t(e); }; }
        var en = tn;
        var nn = n(7);
        var on = nn["a"] && nn["a"].isTypedArray;
        var rn = on ? en(on) : Ze;
        var sn = rn;
        var an = Object.prototype;
        var cn = an.hasOwnProperty;
        function ln(t, e) { var n = xe(t), o = !n && Ce(t), i = !n && !o && Object(Ee["a"])(t), r = !n && !o && !i && sn(t), s = n || o || i || r, a = s ? fe(t.length, String) : [], c = a.length; for (var l in t) {
            if ((e || cn.call(t, l)) && !(s && (l == "length" || i && (l == "offset" || l == "parent") || r && (l == "buffer" || l == "byteLength" || l == "byteOffset") || ae(l, c)))) {
                a.push(l);
            }
        } return a; }
        var dn = ln;
        var un = Object.prototype;
        function hn(t) { var e = t && t.constructor, n = typeof e == "function" && e.prototype || un; return t === n; }
        var fn = hn;
        function pn(t) { var e = []; if (t != null) {
            for (var n in Object(t)) {
                e.push(n);
            }
        } return e; }
        var gn = pn;
        var mn = Object.prototype;
        var kn = mn.hasOwnProperty;
        function bn(t) { if (!S(t)) {
            return gn(t);
        } var e = fn(t), n = []; for (var o in t) {
            if (!(o == "constructor" && (e || !kn.call(t, o)))) {
                n.push(o);
            }
        } return n; }
        var wn = bn;
        function _n(t) { return oe(t) ? dn(t, true) : wn(t); }
        var vn = _n;
        var An = ue((function (t, e) { It(e, vn(e), t); }));
        var Cn = An;
        const yn = Symbol("observableProperties");
        const xn = Symbol("boundObservables");
        const En = Symbol("boundProperties");
        const Dn = Symbol("decoratedMethods");
        const Sn = Symbol("decoratedOriginal");
        const Tn = { set(t, e) { if (S(t)) {
                Object.keys(t).forEach((e => { this.set(e, t[e]); }), this);
                return;
            } Bn(this); const n = this[yn]; if (t in this && !n.has(t)) {
                throw new u["a"]("observable-set-cannot-override", this);
            } Object.defineProperty(this, t, { enumerable: true, configurable: true, get() { return n.get(t); }, set(e) { const o = n.get(t); let i = this.fire("set:" + t, t, e, o); if (i === undefined) {
                    i = e;
                } if (o !== i || !n.has(t)) {
                    n.set(t, i);
                    this.fire("change:" + t, t, i, o);
                } } }); this[t] = e; }, bind(...t) { if (!t.length || !On(t)) {
                throw new u["a"]("observable-bind-wrong-properties", this);
            } if (new Set(t).size !== t.length) {
                throw new u["a"]("observable-bind-duplicate-properties", this);
            } Bn(this); const e = this[En]; t.forEach((t => { if (e.has(t)) {
                throw new u["a"]("observable-bind-rebind", this);
            } })); const n = new Map; t.forEach((t => { const o = { property: t, to: [] }; e.set(t, o); n.set(t, o); })); return { to: In, toMany: Rn, _observable: this, _bindProperties: t, _to: [], _bindings: n }; }, unbind(...t) { if (!this[yn]) {
                return;
            } const e = this[En]; const n = this[xn]; if (t.length) {
                if (!On(t)) {
                    throw new u["a"]("observable-unbind-wrong-properties", this);
                }
                t.forEach((t => { const o = e.get(t); if (!o) {
                    return;
                } let i, r, s, a; o.to.forEach((t => { i = t[0]; r = t[1]; s = n.get(i); a = s[r]; a.delete(o); if (!a.size) {
                    delete s[r];
                } if (!Object.keys(s).length) {
                    n.delete(i);
                    this.stopListening(i, "change");
                } })); e.delete(t); }));
            }
            else {
                n.forEach(((t, e) => { this.stopListening(e, "change"); }));
                n.clear();
                e.clear();
            } }, decorate(t) { const e = this[t]; if (!e) {
                throw new u["a"]("observablemixin-cannot-decorate-undefined", this, { object: this, methodName: t });
            } this.on(t, ((t, n) => { t.return = e.apply(this, n); })); this[t] = function (...e) { return this.fire(t, e); }; this[t][Sn] = e; if (!this[Dn]) {
                this[Dn] = [];
            } this[Dn].push(t); } };
        Cn(Tn, g);
        Tn.stopListening = function (t, e, n) { if (!t && this[Dn]) {
            for (const t of this[Dn]) {
                this[t] = this[t][Sn];
            }
            delete this[Dn];
        } g.stopListening.call(this, t, e, n); };
        var Pn = Tn;
        function Bn(t) { if (t[yn]) {
            return;
        } Object.defineProperty(t, yn, { value: new Map }); Object.defineProperty(t, xn, { value: new Map }); Object.defineProperty(t, En, { value: new Map }); }
        function In(...t) { const e = zn(...t); const n = Array.from(this._bindings.keys()); const o = n.length; if (!e.callback && e.to.length > 1) {
            throw new u["a"]("observable-bind-to-no-callback", this);
        } if (o > 1 && e.callback) {
            throw new u["a"]("observable-bind-to-extra-callback", this);
        } e.to.forEach((t => { if (t.properties.length && t.properties.length !== o) {
            throw new u["a"]("observable-bind-to-properties-length", this);
        } if (!t.properties.length) {
            t.properties = this._bindProperties;
        } })); this._to = e.to; if (e.callback) {
            this._bindings.get(n[0]).callback = e.callback;
        } Ln(this._observable, this._to); Mn(this); this._bindProperties.forEach((t => { Vn(this._observable, t); })); }
        function Rn(t, e, n) { if (this._bindings.size > 1) {
            throw new u["a"]("observable-bind-to-many-not-one-binding", this);
        } this.to(...Fn(t, e), n); }
        function Fn(t, e) { const n = t.map((t => [t, e])); return Array.prototype.concat.apply([], n); }
        function On(t) { return t.every((t => typeof t == "string")); }
        function zn(...t) { if (!t.length) {
            throw new u["a"]("observable-bind-to-parse-error", null);
        } const e = { to: [] }; let n; if (typeof t[t.length - 1] == "function") {
            e.callback = t.pop();
        } t.forEach((t => { if (typeof t == "string") {
            n.properties.push(t);
        }
        else if (typeof t == "object") {
            n = { observable: t, properties: [] };
            e.to.push(n);
        }
        else {
            throw new u["a"]("observable-bind-to-parse-error", null);
        } })); return e; }
        function Nn(t, e, n, o) { const i = t[xn]; const r = i.get(n); const s = r || {}; if (!s[o]) {
            s[o] = new Set;
        } s[o].add(e); if (!r) {
            i.set(n, s);
        } }
        function Mn(t) { let e; t._bindings.forEach(((n, o) => { t._to.forEach((i => { e = i.properties[n.callback ? 0 : t._bindProperties.indexOf(o)]; n.to.push([i.observable, e]); Nn(t._observable, n, i.observable, e); })); })); }
        function Vn(t, e) { const n = t[En]; const o = n.get(e); let i; if (o.callback) {
            i = o.callback.apply(t, o.to.map((t => t[0][t[1]])));
        }
        else {
            i = o.to[0];
            i = i[0][i[1]];
        } if (Object.prototype.hasOwnProperty.call(t, e)) {
            t[e] = i;
        }
        else {
            t.set(e, i);
        } }
        function Ln(t, e) { e.forEach((e => { const n = t[xn]; let o; if (!n.get(e.observable)) {
            t.listenTo(e.observable, "change", ((i, r) => { o = n.get(e.observable)[r]; if (o) {
                o.forEach((e => { Vn(t, e.property); }));
            } }));
        } })); }
        function qn(t, ...e) { e.forEach((e => { Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach((n => { if (n in t.prototype) {
            return;
        } const o = Object.getOwnPropertyDescriptor(e, n); o.enumerable = false; Object.defineProperty(t.prototype, n, o); })); })); }
        class Kn {
            constructor(t) { this.editor = t; this.set("isEnabled", true); this._disableStack = new Set; }
            forceDisabled(t) { this._disableStack.add(t); if (this._disableStack.size == 1) {
                this.on("set:isEnabled", jn, { priority: "highest" });
                this.isEnabled = false;
            } }
            clearForceDisabled(t) { this._disableStack.delete(t); if (this._disableStack.size == 0) {
                this.off("set:isEnabled", jn);
                this.isEnabled = true;
            } }
            destroy() { this.stopListening(); }
            static get isContextPlugin() { return false; }
        }
        qn(Kn, Pn);
        function jn(t) { t.return = false; t.stop(); }
        class Hn {
            constructor(t) { this.editor = t; this.set("value", undefined); this.set("isEnabled", false); this._disableStack = new Set; this.decorate("execute"); this.listenTo(this.editor.model.document, "change", (() => { this.refresh(); })); this.on("execute", (t => { if (!this.isEnabled) {
                t.stop();
            } }), { priority: "high" }); this.listenTo(t, "change:isReadOnly", ((t, e, n) => { if (n) {
                this.forceDisabled("readOnlyMode");
            }
            else {
                this.clearForceDisabled("readOnlyMode");
            } })); }
            refresh() { this.isEnabled = true; }
            forceDisabled(t) { this._disableStack.add(t); if (this._disableStack.size == 1) {
                this.on("set:isEnabled", Wn, { priority: "highest" });
                this.isEnabled = false;
            } }
            clearForceDisabled(t) { this._disableStack.delete(t); if (this._disableStack.size == 0) {
                this.off("set:isEnabled", Wn);
                this.refresh();
            } }
            execute() { }
            destroy() { this.stopListening(); }
        }
        qn(Hn, Pn);
        function Wn(t) { t.return = false; t.stop(); }
        class $n extends Hn {
            constructor(t) { super(t); this._childCommands = []; }
            refresh() { }
            execute(...t) { const e = this._getFirstEnabledCommand(); return e != null && e.execute(t); }
            registerChildCommand(t) { this._childCommands.push(t); t.on("change:isEnabled", (() => this._checkEnabled())); this._checkEnabled(); }
            _checkEnabled() { this.isEnabled = !!this._getFirstEnabledCommand(); }
            _getFirstEnabledCommand() { return this._childCommands.find((t => t.isEnabled)); }
        }
        function Gn(t, e) { return function (n) { return t(e(n)); }; }
        var Un = Gn;
        var Jn = Un(Object.getPrototypeOf, Object);
        var Yn = Jn;
        var Qn = "[object Object]";
        var Xn = Function.prototype, Zn = Object.prototype;
        var to = Xn.toString;
        var eo = Zn.hasOwnProperty;
        var no = to.call(Object);
        function oo(t) { if (!ge(t) || $(t) != Qn) {
            return false;
        } var e = Yn(t); if (e === null) {
            return true;
        } var n = eo.call(e, "constructor") && e.constructor; return typeof n == "function" && n instanceof n && to.call(n) == no; }
        var io = oo;
        function ro() { this.__data__ = []; this.size = 0; }
        var so = ro;
        function ao(t, e) { var n = t.length; while (n--) {
            if (Et(t[n][0], e)) {
                return n;
            }
        } return -1; }
        var co = ao;
        var lo = Array.prototype;
        var uo = lo.splice;
        function ho(t) { var e = this.__data__, n = co(e, t); if (n < 0) {
            return false;
        } var o = e.length - 1; if (n == o) {
            e.pop();
        }
        else {
            uo.call(e, n, 1);
        } --this.size; return true; }
        var fo = ho;
        function po(t) { var e = this.__data__, n = co(e, t); return n < 0 ? undefined : e[n][1]; }
        var go = po;
        function mo(t) { return co(this.__data__, t) > -1; }
        var ko = mo;
        function bo(t, e) { var n = this.__data__, o = co(n, t); if (o < 0) {
            ++this.size;
            n.push([t, e]);
        }
        else {
            n[o][1] = e;
        } return this; }
        var wo = bo;
        function _o(t) { var e = -1, n = t == null ? 0 : t.length; this.clear(); while (++e < n) {
            var o = t[e];
            this.set(o[0], o[1]);
        } }
        _o.prototype.clear = so;
        _o.prototype["delete"] = fo;
        _o.prototype.get = go;
        _o.prototype.has = ko;
        _o.prototype.set = wo;
        var vo = _o;
        function Ao() { this.__data__ = new vo; this.size = 0; }
        var Co = Ao;
        function yo(t) { var e = this.__data__, n = e["delete"](t); this.size = e.size; return n; }
        var xo = yo;
        function Eo(t) { return this.__data__.get(t); }
        var Do = Eo;
        function So(t) { return this.__data__.has(t); }
        var To = So;
        var Po = _t(T["a"], "Map");
        var Bo = Po;
        var Io = _t(Object, "create");
        var Ro = Io;
        function Fo() { this.__data__ = Ro ? Ro(null) : {}; this.size = 0; }
        var Oo = Fo;
        function zo(t) { var e = this.has(t) && delete this.__data__[t]; this.size -= e ? 1 : 0; return e; }
        var No = zo;
        var Mo = "__lodash_hash_undefined__";
        var Vo = Object.prototype;
        var Lo = Vo.hasOwnProperty;
        function qo(t) { var e = this.__data__; if (Ro) {
            var n = e[t];
            return n === Mo ? undefined : n;
        } return Lo.call(e, t) ? e[t] : undefined; }
        var Ko = qo;
        var jo = Object.prototype;
        var Ho = jo.hasOwnProperty;
        function Wo(t) { var e = this.__data__; return Ro ? e[t] !== undefined : Ho.call(e, t); }
        var $o = Wo;
        var Go = "__lodash_hash_undefined__";
        function Uo(t, e) { var n = this.__data__; this.size += this.has(t) ? 0 : 1; n[t] = Ro && e === undefined ? Go : e; return this; }
        var Jo = Uo;
        function Yo(t) { var e = -1, n = t == null ? 0 : t.length; this.clear(); while (++e < n) {
            var o = t[e];
            this.set(o[0], o[1]);
        } }
        Yo.prototype.clear = Oo;
        Yo.prototype["delete"] = No;
        Yo.prototype.get = Ko;
        Yo.prototype.has = $o;
        Yo.prototype.set = Jo;
        var Qo = Yo;
        function Xo() { this.size = 0; this.__data__ = { hash: new Qo, map: new (Bo || vo), string: new Qo }; }
        var Zo = Xo;
        function ti(t) { var e = typeof t; return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null; }
        var ei = ti;
        function ni(t, e) { var n = t.__data__; return ei(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map; }
        var oi = ni;
        function ii(t) { var e = oi(this, t)["delete"](t); this.size -= e ? 1 : 0; return e; }
        var ri = ii;
        function si(t) { return oi(this, t).get(t); }
        var ai = si;
        function ci(t) { return oi(this, t).has(t); }
        var li = ci;
        function di(t, e) { var n = oi(this, t), o = n.size; n.set(t, e); this.size += n.size == o ? 0 : 1; return this; }
        var ui = di;
        function hi(t) { var e = -1, n = t == null ? 0 : t.length; this.clear(); while (++e < n) {
            var o = t[e];
            this.set(o[0], o[1]);
        } }
        hi.prototype.clear = Zo;
        hi.prototype["delete"] = ri;
        hi.prototype.get = ai;
        hi.prototype.has = li;
        hi.prototype.set = ui;
        var fi = hi;
        var pi = 200;
        function gi(t, e) { var n = this.__data__; if (n instanceof vo) {
            var o = n.__data__;
            if (!Bo || o.length < pi - 1) {
                o.push([t, e]);
                this.size = ++n.size;
                return this;
            }
            n = this.__data__ = new fi(o);
        } n.set(t, e); this.size = n.size; return this; }
        var mi = gi;
        function ki(t) { var e = this.__data__ = new vo(t); this.size = e.size; }
        ki.prototype.clear = Co;
        ki.prototype["delete"] = xo;
        ki.prototype.get = Do;
        ki.prototype.has = To;
        ki.prototype.set = mi;
        var bi = ki;
        function wi(t, e) { var n = -1, o = t == null ? 0 : t.length; while (++n < o) {
            if (e(t[n], n, t) === false) {
                break;
            }
        } return t; }
        var _i = wi;
        var vi = Un(Object.keys, Object);
        var Ai = vi;
        var Ci = Object.prototype;
        var yi = Ci.hasOwnProperty;
        function xi(t) { if (!fn(t)) {
            return Ai(t);
        } var e = []; for (var n in Object(t)) {
            if (yi.call(t, n) && n != "constructor") {
                e.push(n);
            }
        } return e; }
        var Ei = xi;
        function Di(t) { return oe(t) ? dn(t) : Ei(t); }
        var Si = Di;
        function Ti(t, e) { return t && It(e, Si(e), t); }
        var Pi = Ti;
        function Bi(t, e) { return t && It(e, vn(e), t); }
        var Ii = Bi;
        var Ri = n(10);
        function Fi(t, e) { var n = -1, o = t.length; e || (e = Array(o)); while (++n < o) {
            e[n] = t[n];
        } return e; }
        var Oi = Fi;
        function zi(t, e) { var n = -1, o = t == null ? 0 : t.length, i = 0, r = []; while (++n < o) {
            var s = t[n];
            if (e(s, n, t)) {
                r[i++] = s;
            }
        } return r; }
        var Ni = zi;
        function Mi() { return []; }
        var Vi = Mi;
        var Li = Object.prototype;
        var qi = Li.propertyIsEnumerable;
        var Ki = Object.getOwnPropertySymbols;
        var ji = !Ki ? Vi : function (t) { if (t == null) {
            return [];
        } t = Object(t); return Ni(Ki(t), (function (e) { return qi.call(t, e); })); };
        var Hi = ji;
        function Wi(t, e) { return It(t, Hi(t), e); }
        var $i = Wi;
        function Gi(t, e) { var n = -1, o = e.length, i = t.length; while (++n < o) {
            t[i + n] = e[n];
        } return t; }
        var Ui = Gi;
        var Ji = Object.getOwnPropertySymbols;
        var Yi = !Ji ? Vi : function (t) { var e = []; while (t) {
            Ui(e, Hi(t));
            t = Yn(t);
        } return e; };
        var Qi = Yi;
        function Xi(t, e) { return It(t, Qi(t), e); }
        var Zi = Xi;
        function tr(t, e, n) { var o = e(t); return xe(t) ? o : Ui(o, n(t)); }
        var er = tr;
        function nr(t) { return er(t, Si, Hi); }
        var or = nr;
        function ir(t) { return er(t, vn, Qi); }
        var rr = ir;
        var sr = _t(T["a"], "DataView");
        var ar = sr;
        var cr = _t(T["a"], "Promise");
        var lr = cr;
        var dr = _t(T["a"], "Set");
        var ur = dr;
        var hr = _t(T["a"], "WeakMap");
        var fr = hr;
        var pr = "[object Map]", gr = "[object Object]", mr = "[object Promise]", kr = "[object Set]", br = "[object WeakMap]";
        var wr = "[object DataView]";
        var _r = at(ar), vr = at(Bo), Ar = at(lr), Cr = at(ur), yr = at(fr);
        var xr = $;
        if (ar && xr(new ar(new ArrayBuffer(1))) != wr || Bo && xr(new Bo) != pr || lr && xr(lr.resolve()) != mr || ur && xr(new ur) != kr || fr && xr(new fr) != br) {
            xr = function (t) { var e = $(t), n = e == gr ? t.constructor : undefined, o = n ? at(n) : ""; if (o) {
                switch (o) {
                    case _r: return wr;
                    case vr: return pr;
                    case Ar: return mr;
                    case Cr: return kr;
                    case yr: return br;
                }
            } return e; };
        }
        var Er = xr;
        var Dr = Object.prototype;
        var Sr = Dr.hasOwnProperty;
        function Tr(t) { var e = t.length, n = new t.constructor(e); if (e && typeof t[0] == "string" && Sr.call(t, "index")) {
            n.index = t.index;
            n.input = t.input;
        } return n; }
        var Pr = Tr;
        var Br = T["a"].Uint8Array;
        var Ir = Br;
        function Rr(t) { var e = new t.constructor(t.byteLength); new Ir(e).set(new Ir(t)); return e; }
        var Fr = Rr;
        function Or(t, e) { var n = e ? Fr(t.buffer) : t.buffer; return new t.constructor(n, t.byteOffset, t.byteLength); }
        var zr = Or;
        var Nr = /\w*$/;
        function Mr(t) { var e = new t.constructor(t.source, Nr.exec(t)); e.lastIndex = t.lastIndex; return e; }
        var Vr = Mr;
        var Lr = B ? B.prototype : undefined, qr = Lr ? Lr.valueOf : undefined;
        function Kr(t) { return qr ? Object(qr.call(t)) : {}; }
        var jr = Kr;
        function Hr(t, e) { var n = e ? Fr(t.buffer) : t.buffer; return new t.constructor(n, t.byteOffset, t.length); }
        var Wr = Hr;
        var $r = "[object Boolean]", Gr = "[object Date]", Ur = "[object Map]", Jr = "[object Number]", Yr = "[object RegExp]", Qr = "[object Set]", Xr = "[object String]", Zr = "[object Symbol]";
        var ts = "[object ArrayBuffer]", es = "[object DataView]", ns = "[object Float32Array]", os = "[object Float64Array]", is = "[object Int8Array]", rs = "[object Int16Array]", ss = "[object Int32Array]", as = "[object Uint8Array]", cs = "[object Uint8ClampedArray]", ls = "[object Uint16Array]", ds = "[object Uint32Array]";
        function us(t, e, n) { var o = t.constructor; switch (e) {
            case ts: return Fr(t);
            case $r:
            case Gr: return new o(+t);
            case es: return zr(t, n);
            case ns:
            case os:
            case is:
            case rs:
            case ss:
            case as:
            case cs:
            case ls:
            case ds: return Wr(t, n);
            case Ur: return new o;
            case Jr:
            case Xr: return new o(t);
            case Yr: return Vr(t);
            case Qr: return new o;
            case Zr: return jr(t);
        } }
        var hs = us;
        var fs = Object.create;
        var ps = function () { function t() { } return function (e) { if (!S(e)) {
            return {};
        } if (fs) {
            return fs(e);
        } t.prototype = e; var n = new t; t.prototype = undefined; return n; }; }();
        var gs = ps;
        function ms(t) { return typeof t.constructor == "function" && !fn(t) ? gs(Yn(t)) : {}; }
        var ks = ms;
        var bs = "[object Map]";
        function ws(t) { return ge(t) && Er(t) == bs; }
        var _s = ws;
        var vs = nn["a"] && nn["a"].isMap;
        var As = vs ? en(vs) : _s;
        var Cs = As;
        var ys = "[object Set]";
        function xs(t) { return ge(t) && Er(t) == ys; }
        var Es = xs;
        var Ds = nn["a"] && nn["a"].isSet;
        var Ss = Ds ? en(Ds) : Es;
        var Ts = Ss;
        var Ps = 1, Bs = 2, Is = 4;
        var Rs = "[object Arguments]", Fs = "[object Array]", Os = "[object Boolean]", zs = "[object Date]", Ns = "[object Error]", Ms = "[object Function]", Vs = "[object GeneratorFunction]", Ls = "[object Map]", qs = "[object Number]", Ks = "[object Object]", js = "[object RegExp]", Hs = "[object Set]", Ws = "[object String]", $s = "[object Symbol]", Gs = "[object WeakMap]";
        var Us = "[object ArrayBuffer]", Js = "[object DataView]", Ys = "[object Float32Array]", Qs = "[object Float64Array]", Xs = "[object Int8Array]", Zs = "[object Int16Array]", ta = "[object Int32Array]", ea = "[object Uint8Array]", na = "[object Uint8ClampedArray]", oa = "[object Uint16Array]", ia = "[object Uint32Array]";
        var ra = {};
        ra[Rs] = ra[Fs] = ra[Us] = ra[Js] = ra[Os] = ra[zs] = ra[Ys] = ra[Qs] = ra[Xs] = ra[Zs] = ra[ta] = ra[Ls] = ra[qs] = ra[Ks] = ra[js] = ra[Hs] = ra[Ws] = ra[$s] = ra[ea] = ra[na] = ra[oa] = ra[ia] = true;
        ra[Ns] = ra[Ms] = ra[Gs] = false;
        function sa(t, e, n, o, i, r) { var s, a = e & Ps, c = e & Bs, l = e & Is; if (n) {
            s = i ? n(t, o, i, r) : n(t);
        } if (s !== undefined) {
            return s;
        } if (!S(t)) {
            return t;
        } var d = xe(t); if (d) {
            s = Pr(t);
            if (!a) {
                return Oi(t, s);
            }
        }
        else {
            var u = Er(t), h = u == Ms || u == Vs;
            if (Object(Ee["a"])(t)) {
                return Object(Ri["a"])(t, a);
            }
            if (u == Ks || u == Rs || h && !i) {
                s = c || h ? {} : ks(t);
                if (!a) {
                    return c ? Zi(t, Ii(s, t)) : $i(t, Pi(s, t));
                }
            }
            else {
                if (!ra[u]) {
                    return i ? t : {};
                }
                s = hs(t, u, a);
            }
        } r || (r = new bi); var f = r.get(t); if (f) {
            return f;
        } r.set(t, s); if (Ts(t)) {
            t.forEach((function (o) { s.add(sa(o, e, n, o, t, r)); }));
        }
        else if (Cs(t)) {
            t.forEach((function (o, i) { s.set(i, sa(o, e, n, i, t, r)); }));
        } var p = l ? c ? rr : or : c ? vn : Si; var g = d ? undefined : p(t); _i(g || t, (function (o, i) { if (g) {
            i = o;
            o = t[i];
        } Pt(s, i, sa(o, e, n, i, t, r)); })); return s; }
        var aa = sa;
        var ca = 1, la = 4;
        function da(t, e) { e = typeof e == "function" ? e : undefined; return aa(t, ca | la, e); }
        var ua = da;
        function ha(t) { return ge(t) && t.nodeType === 1 && !io(t); }
        var fa = ha;
        class pa {
            constructor(t, e) { this._config = {}; if (e) {
                this.define(ga(e));
            } if (t) {
                this._setObjectToTarget(this._config, t);
            } }
            set(t, e) { this._setToTarget(this._config, t, e); }
            define(t, e) { const n = true; this._setToTarget(this._config, t, e, n); }
            get(t) { return this._getFromSource(this._config, t); }
            *names() { for (const t of Object.keys(this._config)) {
                yield t;
            } }
            _setToTarget(t, e, n, o = false) { if (io(e)) {
                this._setObjectToTarget(t, e, o);
                return;
            } const i = e.split("."); e = i.pop(); for (const e of i) {
                if (!io(t[e])) {
                    t[e] = {};
                }
                t = t[e];
            } if (io(n)) {
                if (!io(t[e])) {
                    t[e] = {};
                }
                t = t[e];
                this._setObjectToTarget(t, n, o);
                return;
            } if (o && typeof t[e] != "undefined") {
                return;
            } t[e] = n; }
            _getFromSource(t, e) { const n = e.split("."); e = n.pop(); for (const e of n) {
                if (!io(t[e])) {
                    t = null;
                    break;
                }
                t = t[e];
            } return t ? ga(t[e]) : undefined; }
            _setObjectToTarget(t, e, n) { Object.keys(e).forEach((o => { this._setToTarget(t, o, e[o], n); })); }
        }
        function ga(t) { return ua(t, ma); }
        function ma(t) { return fa(t) ? t : undefined; }
        function ka(t) { return !!(t && t[Symbol.iterator]); }
        class ba {
            constructor(t = {}, e = {}) { const n = ka(t); if (!n) {
                e = t;
            } this._items = []; this._itemMap = new Map; this._idProperty = e.idProperty || "id"; this._bindToExternalToInternalMap = new WeakMap; this._bindToInternalToExternalMap = new WeakMap; this._skippedIndexesFromExternal = []; if (n) {
                for (const e of t) {
                    this._items.push(e);
                    this._itemMap.set(this._getItemIdBeforeAdding(e), e);
                }
            } }
            get length() { return this._items.length; }
            get first() { return this._items[0] || null; }
            get last() { return this._items[this.length - 1] || null; }
            add(t, e) { return this.addMany([t], e); }
            addMany(t, e) { if (e === undefined) {
                e = this._items.length;
            }
            else if (e > this._items.length || e < 0) {
                throw new u["a"]("collection-add-item-invalid-index", this);
            } for (let n = 0; n < t.length; n++) {
                const o = t[n];
                const i = this._getItemIdBeforeAdding(o);
                const r = e + n;
                this._items.splice(r, 0, o);
                this._itemMap.set(i, o);
                this.fire("add", o, r);
            } this.fire("change", { added: t, removed: [], index: e }); return this; }
            get(t) { let e; if (typeof t == "string") {
                e = this._itemMap.get(t);
            }
            else if (typeof t == "number") {
                e = this._items[t];
            }
            else {
                throw new u["a"]("collection-get-invalid-arg", this);
            } return e || null; }
            has(t) { if (typeof t == "string") {
                return this._itemMap.has(t);
            }
            else {
                const e = this._idProperty;
                const n = t[e];
                return this._itemMap.has(n);
            } }
            getIndex(t) { let e; if (typeof t == "string") {
                e = this._itemMap.get(t);
            }
            else {
                e = t;
            } return this._items.indexOf(e); }
            remove(t) { const [e, n] = this._remove(t); this.fire("change", { added: [], removed: [e], index: n }); return e; }
            map(t, e) { return this._items.map(t, e); }
            find(t, e) { return this._items.find(t, e); }
            filter(t, e) { return this._items.filter(t, e); }
            clear() { if (this._bindToCollection) {
                this.stopListening(this._bindToCollection);
                this._bindToCollection = null;
            } const t = Array.from(this._items); while (this.length) {
                this._remove(0);
            } this.fire("change", { added: [], removed: t, index: 0 }); }
            bindTo(t) { if (this._bindToCollection) {
                throw new u["a"]("collection-bind-to-rebind", this);
            } this._bindToCollection = t; return { as: t => { this._setUpBindToBinding((e => new t(e))); }, using: t => { if (typeof t == "function") {
                    this._setUpBindToBinding((e => t(e)));
                }
                else {
                    this._setUpBindToBinding((e => e[t]));
                } } }; }
            _setUpBindToBinding(t) { const e = this._bindToCollection; const n = (n, o, i) => { const r = e._bindToCollection == this; const s = e._bindToInternalToExternalMap.get(o); if (r && s) {
                this._bindToExternalToInternalMap.set(o, s);
                this._bindToInternalToExternalMap.set(s, o);
            }
            else {
                const n = t(o);
                if (!n) {
                    this._skippedIndexesFromExternal.push(i);
                    return;
                }
                let r = i;
                for (const t of this._skippedIndexesFromExternal) {
                    if (i > t) {
                        r--;
                    }
                }
                for (const t of e._skippedIndexesFromExternal) {
                    if (r >= t) {
                        r++;
                    }
                }
                this._bindToExternalToInternalMap.set(o, n);
                this._bindToInternalToExternalMap.set(n, o);
                this.add(n, r);
                for (let t = 0; t < e._skippedIndexesFromExternal.length; t++) {
                    if (r <= e._skippedIndexesFromExternal[t]) {
                        e._skippedIndexesFromExternal[t]++;
                    }
                }
            } }; for (const t of e) {
                n(null, t, e.getIndex(t));
            } this.listenTo(e, "add", n); this.listenTo(e, "remove", ((t, e, n) => { const o = this._bindToExternalToInternalMap.get(e); if (o) {
                this.remove(o);
            } this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce(((t, e) => { if (n < e) {
                t.push(e - 1);
            } if (n > e) {
                t.push(e);
            } return t; }), []); })); }
            _getItemIdBeforeAdding(t) { const e = this._idProperty; let n; if (e in t) {
                n = t[e];
                if (typeof n != "string") {
                    throw new u["a"]("collection-add-invalid-id", this);
                }
                if (this.get(n)) {
                    throw new u["a"]("collection-add-item-already-exists", this);
                }
            }
            else {
                t[e] = n = a();
            } return n; }
            _remove(t) { let e, n, o; let i = false; const r = this._idProperty; if (typeof t == "string") {
                n = t;
                o = this._itemMap.get(n);
                i = !o;
                if (o) {
                    e = this._items.indexOf(o);
                }
            }
            else if (typeof t == "number") {
                e = t;
                o = this._items[e];
                i = !o;
                if (o) {
                    n = o[r];
                }
            }
            else {
                o = t;
                n = o[r];
                e = this._items.indexOf(o);
                i = e == -1 || !this._itemMap.get(n);
            } if (i) {
                throw new u["a"]("collection-remove-404", this);
            } this._items.splice(e, 1); this._itemMap.delete(n); const s = this._bindToInternalToExternalMap.get(o); this._bindToInternalToExternalMap.delete(o); this._bindToExternalToInternalMap.delete(s); this.fire("remove", o, e); return [o, e]; }
            [Symbol.iterator]() { return this._items[Symbol.iterator](); }
        }
        qn(ba, g);
        class wa {
            constructor(t, e = [], n = []) { this._context = t; this._plugins = new Map; this._availablePlugins = new Map; for (const t of e) {
                if (t.pluginName) {
                    this._availablePlugins.set(t.pluginName, t);
                }
            } this._contextPlugins = new Map; for (const [t, e] of n) {
                this._contextPlugins.set(t, e);
                this._contextPlugins.set(e, t);
                if (t.pluginName) {
                    this._availablePlugins.set(t.pluginName, t);
                }
            } }
            *[Symbol.iterator]() { for (const t of this._plugins) {
                if (typeof t[0] == "function") {
                    yield t;
                }
            } }
            get(t) { const e = this._plugins.get(t); if (!e) {
                let e = t;
                if (typeof t == "function") {
                    e = t.pluginName || t.name;
                }
                throw new u["a"]("plugincollection-plugin-not-loaded", this._context, { plugin: e });
            } return e; }
            has(t) { return this._plugins.has(t); }
            init(t, e = [], n = []) { const o = this; const i = this._context; f(t); g(t); const r = t.filter((t => !d(t, e))); const s = [...p(r)]; v(s, n); const a = w(s); return _(a, "init").then((() => _(a, "afterInit"))).then((() => a)); function c(t) { return typeof t === "function"; } function l(t) { return c(t) && t.isContextPlugin; } function d(t, e) { return e.some((e => { if (e === t) {
                return true;
            } if (h(t) === e) {
                return true;
            } if (h(e) === t) {
                return true;
            } return false; })); } function h(t) { return c(t) ? t.pluginName || t.name : t; } function f(t, e = new Set) { t.forEach((t => { if (!c(t)) {
                return;
            } if (e.has(t)) {
                return;
            } e.add(t); if (t.pluginName && !o._availablePlugins.has(t.pluginName)) {
                o._availablePlugins.set(t.pluginName, t);
            } if (t.requires) {
                f(t.requires, e);
            } })); } function p(t, e = new Set) { return t.map((t => c(t) ? t : o._availablePlugins.get(t))).reduce(((t, n) => { if (e.has(n)) {
                return t;
            } e.add(n); if (n.requires) {
                g(n.requires, n);
                p(n.requires, e).forEach((e => t.add(e)));
            } return t.add(n); }), new Set); } function g(t, e = null) { t.map((t => c(t) ? t : o._availablePlugins.get(t) || t)).forEach((t => { m(t, e); k(t, e); b(t, e); })); } function m(t, e) { if (c(t)) {
                return;
            } if (e) {
                throw new u["a"]("plugincollection-soft-required", i, { missingPlugin: t, requiredBy: h(e) });
            } throw new u["a"]("plugincollection-plugin-not-found", i, { plugin: t }); } function k(t, e) { if (!l(e)) {
                return;
            } if (l(t)) {
                return;
            } throw new u["a"]("plugincollection-context-required", i, { plugin: h(t), requiredBy: h(e) }); } function b(t, n) { if (!n) {
                return;
            } if (!d(t, e)) {
                return;
            } throw new u["a"]("plugincollection-required", i, { plugin: h(t), requiredBy: h(n) }); } function w(t) { return t.map((t => { const e = o._contextPlugins.get(t) || new t(i); o._add(t, e); return e; })); } function _(t, e) { return t.reduce(((t, n) => { if (!n[e]) {
                return t;
            } if (o._contextPlugins.has(n)) {
                return t;
            } return t.then(n[e].bind(n)); }), Promise.resolve()); } function v(t, e) { for (const n of e) {
                if (typeof n != "function") {
                    throw new u["a"]("plugincollection-replace-plugin-invalid-type", null, { pluginItem: n });
                }
                const e = n.pluginName;
                if (!e) {
                    throw new u["a"]("plugincollection-replace-plugin-missing-name", null, { pluginItem: n });
                }
                if (n.requires && n.requires.length) {
                    throw new u["a"]("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, { pluginName: e });
                }
                const i = o._availablePlugins.get(e);
                if (!i) {
                    throw new u["a"]("plugincollection-plugin-for-replacing-not-exist", null, { pluginName: e });
                }
                const r = t.indexOf(i);
                if (r === -1) {
                    if (o._contextPlugins.has(i)) {
                        return;
                    }
                    throw new u["a"]("plugincollection-plugin-for-replacing-not-loaded", null, { pluginName: e });
                }
                if (i.requires && i.requires.length) {
                    throw new u["a"]("plugincollection-replaced-plugin-cannot-have-dependencies", null, { pluginName: e });
                }
                t.splice(r, 1, n);
                o._availablePlugins.set(e, n);
            } } }
            destroy() { const t = []; for (const [, e] of this) {
                if (typeof e.destroy == "function" && !this._contextPlugins.has(e)) {
                    t.push(e.destroy());
                }
            } return Promise.all(t); }
            _add(t, e) { this._plugins.set(t, e); const n = t.pluginName; if (!n) {
                return;
            } if (this._plugins.has(n)) {
                throw new u["a"]("plugincollection-plugin-name-conflict", null, { pluginName: n, plugin1: this._plugins.get(n).constructor, plugin2: t });
            } this._plugins.set(n, e); }
        }
        qn(wa, g);
        function _a(t) { return Array.isArray(t) ? t : [t]; }
        if (!window.CKEDITOR_TRANSLATIONS) {
            window.CKEDITOR_TRANSLATIONS = {};
        }
        function va(t, e, n) { if (!window.CKEDITOR_TRANSLATIONS[t]) {
            window.CKEDITOR_TRANSLATIONS[t] = {};
        } const o = window.CKEDITOR_TRANSLATIONS[t]; o.dictionary = o.dictionary || {}; o.getPluralForm = n || o.getPluralForm; Object.assign(o.dictionary, e); }
        function Aa(t, e, n = 1) { if (typeof n !== "number") {
            throw new u["a"]("translation-service-quantity-not-a-number", null, { quantity: n });
        } const o = xa(); if (o === 1) {
            t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0];
        } const i = e.id || e.string; if (o === 0 || !ya(t, i)) {
            if (n !== 1) {
                return e.plural;
            }
            return e.string;
        } const r = window.CKEDITOR_TRANSLATIONS[t].dictionary; const s = window.CKEDITOR_TRANSLATIONS[t].getPluralForm || (t => t === 1 ? 0 : 1); if (typeof r[i] === "string") {
            return r[i];
        } const a = Number(s(n)); return r[i][a]; }
        function Ca() { window.CKEDITOR_TRANSLATIONS = {}; }
        function ya(t, e) { return !!window.CKEDITOR_TRANSLATIONS[t] && !!window.CKEDITOR_TRANSLATIONS[t].dictionary[e]; }
        function xa() { return Object.keys(window.CKEDITOR_TRANSLATIONS).length; }
        const Ea = ["ar", "ara", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
        function Da(t) { return Ea.includes(t) ? "rtl" : "ltr"; }
        class Sa {
            constructor(t = {}) { this.uiLanguage = t.uiLanguage || "en"; this.contentLanguage = t.contentLanguage || this.uiLanguage; this.uiLanguageDirection = Da(this.uiLanguage); this.contentLanguageDirection = Da(this.contentLanguage); this.t = (t, e) => this._t(t, e); }
            get language() { console.warn("locale-deprecated-language-property: " + "The Locale#language property has been deprecated and will be removed in the near future. " + "Please use #uiLanguage and #contentLanguage properties instead."); return this.uiLanguage; }
            _t(t, e = []) { e = _a(e); if (typeof t === "string") {
                t = { string: t };
            } const n = !!t.plural; const o = n ? e[0] : 1; const i = Aa(this.uiLanguage, t, o); return Ta(i, e); }
        }
        function Ta(t, e) { return t.replace(/%(\d+)/g, ((t, n) => n < e.length ? e[n] : t)); }
        class Pa {
            constructor(t) { this.config = new pa(t, this.constructor.defaultConfig); const e = this.constructor.builtinPlugins; this.config.define("plugins", e); this.plugins = new wa(this, e); const n = this.config.get("language") || {}; this.locale = new Sa({ uiLanguage: typeof n === "string" ? n : n.ui, contentLanguage: this.config.get("language.content") }); this.t = this.locale.t; this.editors = new ba; this._contextOwner = null; }
            initPlugins() { const t = this.config.get("plugins") || []; const e = this.config.get("substitutePlugins") || []; for (const n of t.concat(e)) {
                if (typeof n != "function") {
                    throw new u["a"]("context-initplugins-constructor-only", null, { Plugin: n });
                }
                if (n.isContextPlugin !== true) {
                    throw new u["a"]("context-initplugins-invalid-plugin", null, { Plugin: n });
                }
            } return this.plugins.init(t, [], e); }
            destroy() { return Promise.all(Array.from(this.editors, (t => t.destroy()))).then((() => this.plugins.destroy())); }
            _addEditor(t, e) { if (this._contextOwner) {
                throw new u["a"]("context-addeditor-private-context");
            } this.editors.add(t); if (e) {
                this._contextOwner = t;
            } }
            _removeEditor(t) { if (this.editors.has(t)) {
                this.editors.remove(t);
            } if (this._contextOwner === t) {
                return this.destroy();
            } return Promise.resolve(); }
            _getEditorConfig() { const t = {}; for (const e of this.config.names()) {
                if (!["plugins", "removePlugins", "extraPlugins"].includes(e)) {
                    t[e] = this.config.get(e);
                }
            } return t; }
            static create(t) { return new Promise((e => { const n = new this(t); e(n.initPlugins().then((() => n))); })); }
        }
        class Ba {
            constructor(t) { this.context = t; }
            destroy() { this.stopListening(); }
            static get isContextPlugin() { return true; }
        }
        qn(Ba, Pn);
        function Ia(t, e) { const n = Math.min(t.length, e.length); for (let o = 0; o < n; o++) {
            if (t[o] != e[o]) {
                return o;
            }
        } if (t.length == e.length) {
            return "same";
        }
        else if (t.length < e.length) {
            return "prefix";
        }
        else {
            return "extension";
        } }
        var Ra = 4;
        function Fa(t) { return aa(t, Ra); }
        var Oa = Fa;
        class za {
            constructor(t) { this.document = t; this.parent = null; }
            get index() { let t; if (!this.parent) {
                return null;
            } if ((t = this.parent.getChildIndex(this)) == -1) {
                throw new u["a"]("view-node-not-found-in-parent", this);
            } return t; }
            get nextSibling() { const t = this.index; return t !== null && this.parent.getChild(t + 1) || null; }
            get previousSibling() { const t = this.index; return t !== null && this.parent.getChild(t - 1) || null; }
            get root() { let t = this; while (t.parent) {
                t = t.parent;
            } return t; }
            isAttached() { return this.root.is("rootElement"); }
            getPath() { const t = []; let e = this; while (e.parent) {
                t.unshift(e.index);
                e = e.parent;
            } return t; }
            getAncestors(t = { includeSelf: false, parentFirst: false }) { const e = []; let n = t.includeSelf ? this : this.parent; while (n) {
                e[t.parentFirst ? "push" : "unshift"](n);
                n = n.parent;
            } return e; }
            getCommonAncestor(t, e = {}) { const n = this.getAncestors(e); const o = t.getAncestors(e); let i = 0; while (n[i] == o[i] && n[i]) {
                i++;
            } return i === 0 ? null : n[i - 1]; }
            isBefore(t) { if (this == t) {
                return false;
            } if (this.root !== t.root) {
                return false;
            } const e = this.getPath(); const n = t.getPath(); const o = Ia(e, n); switch (o) {
                case "prefix": return true;
                case "extension": return false;
                default: return e[o] < n[o];
            } }
            isAfter(t) { if (this == t) {
                return false;
            } if (this.root !== t.root) {
                return false;
            } return !this.isBefore(t); }
            _remove() { this.parent._removeChildren(this.index); }
            _fireChange(t, e) { this.fire("change:" + t, e); if (this.parent) {
                this.parent._fireChange(t, e);
            } }
            toJSON() { const t = Oa(this); delete t.parent; return t; }
            is(t) { return t === "node" || t === "view:node"; }
        }
        qn(za, g);
        class Na extends za {
            constructor(t, e) { super(t); this._textData = e; }
            is(t) { return t === "$text" || t === "view:$text" || t === "text" || t === "view:text" || t === "node" || t === "view:node"; }
            get data() { return this._textData; }
            get _data() { return this.data; }
            set _data(t) { this._fireChange("text", this); this._textData = t; }
            isSimilar(t) { if (!(t instanceof Na)) {
                return false;
            } return this === t || this.data === t.data; }
            _clone() { return new Na(this.document, this.data); }
        }
        class Ma {
            constructor(t, e, n) { this.textNode = t; if (e < 0 || e > t.data.length) {
                throw new u["a"]("view-textproxy-wrong-offsetintext", this);
            } if (n < 0 || e + n > t.data.length) {
                throw new u["a"]("view-textproxy-wrong-length", this);
            } this.data = t.data.substring(e, e + n); this.offsetInText = e; }
            get offsetSize() { return this.data.length; }
            get isPartial() { return this.data.length !== this.textNode.data.length; }
            get parent() { return this.textNode.parent; }
            get root() { return this.textNode.root; }
            get document() { return this.textNode.document; }
            is(t) { return t === "$textProxy" || t === "view:$textProxy" || t === "textProxy" || t === "view:textProxy"; }
            getAncestors(t = { includeSelf: false, parentFirst: false }) { const e = []; let n = t.includeSelf ? this.textNode : this.parent; while (n !== null) {
                e[t.parentFirst ? "push" : "unshift"](n);
                n = n.parent;
            } return e; }
        }
        function Va(t) { const e = new Map; for (const n in t) {
            e.set(n, t[n]);
        } return e; }
        function La(t) { if (ka(t)) {
            return new Map(t);
        }
        else {
            return Va(t);
        } }
        class qa {
            constructor(...t) { this._patterns = []; this.add(...t); }
            add(...t) { for (let e of t) {
                if (typeof e == "string" || e instanceof RegExp) {
                    e = { name: e };
                }
                if (e.classes && (typeof e.classes == "string" || e.classes instanceof RegExp)) {
                    e.classes = [e.classes];
                }
                this._patterns.push(e);
            } }
            match(...t) { for (const e of t) {
                for (const t of this._patterns) {
                    const n = Ka(e, t);
                    if (n) {
                        return { element: e, pattern: t, match: n };
                    }
                }
            } return null; }
            matchAll(...t) { const e = []; for (const n of t) {
                for (const t of this._patterns) {
                    const o = Ka(n, t);
                    if (o) {
                        e.push({ element: n, pattern: t, match: o });
                    }
                }
            } return e.length > 0 ? e : null; }
            getElementName() { if (this._patterns.length !== 1) {
                return null;
            } const t = this._patterns[0]; const e = t.name; return typeof t != "function" && e && !(e instanceof RegExp) ? e : null; }
        }
        function Ka(t, e) { if (typeof e == "function") {
            return e(t);
        } const n = {}; if (e.name) {
            n.name = ja(e.name, t.name);
            if (!n.name) {
                return null;
            }
        } if (e.attributes) {
            n.attributes = Ha(e.attributes, t);
            if (!n.attributes) {
                return null;
            }
        } if (e.classes) {
            n.classes = Wa(e.classes, t);
            if (!n.classes) {
                return false;
            }
        } if (e.styles) {
            n.styles = $a(e.styles, t);
            if (!n.styles) {
                return false;
            }
        } return n; }
        function ja(t, e) { if (t instanceof RegExp) {
            return t.test(e);
        } return t === e; }
        function Ha(t, e) { const n = []; for (const o in t) {
            const i = t[o];
            if (e.hasAttribute(o)) {
                const t = e.getAttribute(o);
                if (i === true) {
                    n.push(o);
                }
                else if (i instanceof RegExp) {
                    if (i.test(t)) {
                        n.push(o);
                    }
                    else {
                        return null;
                    }
                }
                else if (t === i) {
                    n.push(o);
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        } return n; }
        function Wa(t, e) { const n = []; for (const o of t) {
            if (o instanceof RegExp) {
                const t = e.getClassNames();
                for (const e of t) {
                    if (o.test(e)) {
                        n.push(e);
                    }
                }
                if (n.length === 0) {
                    return null;
                }
            }
            else if (e.hasClass(o)) {
                n.push(o);
            }
            else {
                return null;
            }
        } return n; }
        function $a(t, e) { const n = []; for (const o in t) {
            const i = t[o];
            if (e.hasStyle(o)) {
                const t = e.getStyle(o);
                if (i instanceof RegExp) {
                    if (i.test(t)) {
                        n.push(o);
                    }
                    else {
                        return null;
                    }
                }
                else if (t === i) {
                    n.push(o);
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        } return n; }
        var Ga = "[object Symbol]";
        function Ua(t) { return typeof t == "symbol" || ge(t) && $(t) == Ga; }
        var Ja = Ua;
        var Ya = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Qa = /^\w*$/;
        function Xa(t, e) { if (xe(t)) {
            return false;
        } var n = typeof t; if (n == "number" || n == "symbol" || n == "boolean" || t == null || Ja(t)) {
            return true;
        } return Qa.test(t) || !Ya.test(t) || e != null && t in Object(e); }
        var Za = Xa;
        var tc = "Expected a function";
        function ec(t, e) { if (typeof t != "function" || e != null && typeof e != "function") {
            throw new TypeError(tc);
        } var n = function () { var o = arguments, i = e ? e.apply(this, o) : o[0], r = n.cache; if (r.has(i)) {
            return r.get(i);
        } var s = t.apply(this, o); n.cache = r.set(i, s) || r; return s; }; n.cache = new (ec.Cache || fi); return n; }
        ec.Cache = fi;
        var nc = ec;
        var oc = 500;
        function ic(t) { var e = nc(t, (function (t) { if (n.size === oc) {
            n.clear();
        } return t; })); var n = e.cache; return e; }
        var rc = ic;
        var sc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        var ac = /\\(\\)?/g;
        var cc = rc((function (t) { var e = []; if (t.charCodeAt(0) === 46) {
            e.push("");
        } t.replace(sc, (function (t, n, o, i) { e.push(o ? i.replace(ac, "$1") : n || t); })); return e; }));
        var lc = cc;
        function dc(t, e) { var n = -1, o = t == null ? 0 : t.length, i = Array(o); while (++n < o) {
            i[n] = e(t[n], n, t);
        } return i; }
        var uc = dc;
        var hc = 1 / 0;
        var fc = B ? B.prototype : undefined, pc = fc ? fc.toString : undefined;
        function gc(t) { if (typeof t == "string") {
            return t;
        } if (xe(t)) {
            return uc(t, gc) + "";
        } if (Ja(t)) {
            return pc ? pc.call(t) : "";
        } var e = t + ""; return e == "0" && 1 / t == -hc ? "-0" : e; }
        var mc = gc;
        function kc(t) { return t == null ? "" : mc(t); }
        var bc = kc;
        function wc(t, e) { if (xe(t)) {
            return t;
        } return Za(t, e) ? [t] : lc(bc(t)); }
        var _c = wc;
        function vc(t) { var e = t == null ? 0 : t.length; return e ? t[e - 1] : undefined; }
        var Ac = vc;
        var Cc = 1 / 0;
        function yc(t) { if (typeof t == "string" || Ja(t)) {
            return t;
        } var e = t + ""; return e == "0" && 1 / t == -Cc ? "-0" : e; }
        var xc = yc;
        function Ec(t, e) { e = _c(e, t); var n = 0, o = e.length; while (t != null && n < o) {
            t = t[xc(e[n++])];
        } return n && n == o ? t : undefined; }
        var Dc = Ec;
        function Sc(t, e, n) { var o = -1, i = t.length; if (e < 0) {
            e = -e > i ? 0 : i + e;
        } n = n > i ? i : n; if (n < 0) {
            n += i;
        } i = e > n ? 0 : n - e >>> 0; e >>>= 0; var r = Array(i); while (++o < i) {
            r[o] = t[o + e];
        } return r; }
        var Tc = Sc;
        function Pc(t, e) { return e.length < 2 ? t : Dc(t, Tc(e, 0, -1)); }
        var Bc = Pc;
        function Ic(t, e) { e = _c(e, t); t = Bc(t, e); return t == null || delete t[xc(Ac(e))]; }
        var Rc = Ic;
        function Fc(t, e) { return t == null ? true : Rc(t, e); }
        var Oc = Fc;
        function zc(t, e, n) { var o = t == null ? undefined : Dc(t, e); return o === undefined ? n : o; }
        var Nc = zc;
        function Mc(t, e, n) { if (n !== undefined && !Et(t[e], n) || n === undefined && !(e in t)) {
            yt(t, e, n);
        } }
        var Vc = Mc;
        function Lc(t) { return function (e, n, o) { var i = -1, r = Object(e), s = o(e), a = s.length; while (a--) {
            var c = s[t ? a : ++i];
            if (n(r[c], c, r) === false) {
                break;
            }
        } return e; }; }
        var qc = Lc;
        var Kc = qc();
        var jc = Kc;
        function Hc(t) { return ge(t) && oe(t); }
        var Wc = Hc;
        function $c(t, e) { if (e === "constructor" && typeof t[e] === "function") {
            return;
        } if (e == "__proto__") {
            return;
        } return t[e]; }
        var Gc = $c;
        function Uc(t) { return It(t, vn(t)); }
        var Jc = Uc;
        function Yc(t, e, n, o, i, r, s) { var a = Gc(t, n), c = Gc(e, n), l = s.get(c); if (l) {
            Vc(t, n, l);
            return;
        } var d = r ? r(a, c, n + "", t, e, s) : undefined; var u = d === undefined; if (u) {
            var h = xe(c), f = !h && Object(Ee["a"])(c), p = !h && !f && sn(c);
            d = c;
            if (h || f || p) {
                if (xe(a)) {
                    d = a;
                }
                else if (Wc(a)) {
                    d = Oi(a);
                }
                else if (f) {
                    u = false;
                    d = Object(Ri["a"])(c, true);
                }
                else if (p) {
                    u = false;
                    d = Wr(c, true);
                }
                else {
                    d = [];
                }
            }
            else if (io(c) || Ce(c)) {
                d = a;
                if (Ce(a)) {
                    d = Jc(a);
                }
                else if (!S(a) || X(a)) {
                    d = ks(c);
                }
            }
            else {
                u = false;
            }
        } if (u) {
            s.set(c, d);
            i(d, c, o, r, s);
            s["delete"](c);
        } Vc(t, n, d); }
        var Qc = Yc;
        function Xc(t, e, n, o, i) { if (t === e) {
            return;
        } jc(e, (function (r, s) { i || (i = new bi); if (S(r)) {
            Qc(t, e, s, n, Xc, o, i);
        }
        else {
            var a = o ? o(Gc(t, s), r, s + "", t, e, i) : undefined;
            if (a === undefined) {
                a = r;
            }
            Vc(t, s, a);
        } }), vn); }
        var Zc = Xc;
        var tl = ue((function (t, e, n) { Zc(t, e, n); }));
        var el = tl;
        function nl(t, e, n, o) { if (!S(t)) {
            return t;
        } e = _c(e, t); var i = -1, r = e.length, s = r - 1, a = t; while (a != null && ++i < r) {
            var c = xc(e[i]), l = n;
            if (c === "__proto__" || c === "constructor" || c === "prototype") {
                return t;
            }
            if (i != s) {
                var d = a[c];
                l = o ? o(d, c, a) : undefined;
                if (l === undefined) {
                    l = S(d) ? d : ae(e[i + 1]) ? [] : {};
                }
            }
            Pt(a, c, l);
            a = a[c];
        } return t; }
        var ol = nl;
        function il(t, e, n) { return t == null ? t : ol(t, e, n); }
        var rl = il;
        class sl {
            constructor(t) { this._styles = {}; this._styleProcessor = t; }
            get isEmpty() { const t = Object.entries(this._styles); const e = Array.from(t); return !e.length; }
            get size() { if (this.isEmpty) {
                return 0;
            } return this.getStyleNames().length; }
            setTo(t) { this.clear(); const e = Array.from(cl(t).entries()); for (const [t, n] of e) {
                this._styleProcessor.toNormalizedForm(t, n, this._styles);
            } }
            has(t) { if (this.isEmpty) {
                return false;
            } const e = this._styleProcessor.getReducedForm(t, this._styles); const n = e.find((([e]) => e === t)); return Array.isArray(n); }
            set(t, e) { if (S(t)) {
                for (const [e, n] of Object.entries(t)) {
                    this._styleProcessor.toNormalizedForm(e, n, this._styles);
                }
            }
            else {
                this._styleProcessor.toNormalizedForm(t, e, this._styles);
            } }
            remove(t) { const e = ll(t); Oc(this._styles, e); delete this._styles[t]; this._cleanEmptyObjectsOnPath(e); }
            getNormalized(t) { return this._styleProcessor.getNormalized(t, this._styles); }
            toString() { if (this.isEmpty) {
                return "";
            } return this._getStylesEntries().map((t => t.join(":"))).sort().join(";") + ";"; }
            getAsString(t) { if (this.isEmpty) {
                return;
            } if (this._styles[t] && !S(this._styles[t])) {
                return this._styles[t];
            } const e = this._styleProcessor.getReducedForm(t, this._styles); const n = e.find((([e]) => e === t)); if (Array.isArray(n)) {
                return n[1];
            } }
            getStyleNames() { if (this.isEmpty) {
                return [];
            } const t = this._getStylesEntries(); return t.map((([t]) => t)); }
            clear() { this._styles = {}; }
            _getStylesEntries() { const t = []; const e = Object.keys(this._styles); for (const n of e) {
                t.push(...this._styleProcessor.getReducedForm(n, this._styles));
            } return t; }
            _cleanEmptyObjectsOnPath(t) { const e = t.split("."); const n = e.length > 1; if (!n) {
                return;
            } const o = e.splice(0, e.length - 1).join("."); const i = Nc(this._styles, o); if (!i) {
                return;
            } const r = !Array.from(Object.keys(i)).length; if (r) {
                this.remove(o);
            } }
        }
        class al {
            constructor() { this._normalizers = new Map; this._extractors = new Map; this._reducers = new Map; this._consumables = new Map; }
            toNormalizedForm(t, e, n) { if (S(e)) {
                dl(n, ll(t), e);
                return;
            } if (this._normalizers.has(t)) {
                const o = this._normalizers.get(t);
                const { path: i, value: r } = o(e);
                dl(n, i, r);
            }
            else {
                dl(n, t, e);
            } }
            getNormalized(t, e) { if (!t) {
                return el({}, e);
            } if (e[t] !== undefined) {
                return e[t];
            } if (this._extractors.has(t)) {
                const n = this._extractors.get(t);
                if (typeof n === "string") {
                    return Nc(e, n);
                }
                const o = n(t, e);
                if (o) {
                    return o;
                }
            } return Nc(e, ll(t)); }
            getReducedForm(t, e) { const n = this.getNormalized(t, e); if (n === undefined) {
                return [];
            } if (this._reducers.has(t)) {
                const e = this._reducers.get(t);
                return e(n);
            } return [[t, n]]; }
            getRelatedStyles(t) { return this._consumables.get(t) || []; }
            setNormalizer(t, e) { this._normalizers.set(t, e); }
            setExtractor(t, e) { this._extractors.set(t, e); }
            setReducer(t, e) { this._reducers.set(t, e); }
            setStyleRelation(t, e) { this._mapStyleNames(t, e); for (const n of e) {
                this._mapStyleNames(n, [t]);
            } }
            _mapStyleNames(t, e) { if (!this._consumables.has(t)) {
                this._consumables.set(t, []);
            } this._consumables.get(t).push(...e); }
        }
        function cl(t) { let e = null; let n = 0; let o = 0; let i = null; const r = new Map; if (t === "") {
            return r;
        } if (t.charAt(t.length - 1) != ";") {
            t = t + ";";
        } for (let s = 0; s < t.length; s++) {
            const a = t.charAt(s);
            if (e === null) {
                switch (a) {
                    case ":":
                        if (!i) {
                            i = t.substr(n, s - n);
                            o = s + 1;
                        }
                        break;
                    case '"':
                    case "'":
                        e = a;
                        break;
                    case ";": {
                        const e = t.substr(o, s - o);
                        if (i) {
                            r.set(i.trim(), e.trim());
                        }
                        i = null;
                        n = s + 1;
                        break;
                    }
                }
            }
            else if (a === e) {
                e = null;
            }
        } return r; }
        function ll(t) { return t.replace("-", "."); }
        function dl(t, e, n) { let o = n; if (S(n)) {
            o = el({}, Nc(t, e), n);
        } rl(t, e, o); }
        class ul extends za {
            constructor(t, e, n, o) { super(t); this.name = e; this._attrs = hl(n); this._children = []; if (o) {
                this._insertChild(0, o);
            } this._classes = new Set; if (this._attrs.has("class")) {
                const t = this._attrs.get("class");
                fl(this._classes, t);
                this._attrs.delete("class");
            } this._styles = new sl(this.document.stylesProcessor); if (this._attrs.has("style")) {
                this._styles.setTo(this._attrs.get("style"));
                this._attrs.delete("style");
            } this._customProperties = new Map; this._isAllowedInsideAttributeElement = false; }
            get childCount() { return this._children.length; }
            get isEmpty() { return this._children.length === 0; }
            get isAllowedInsideAttributeElement() { return this._isAllowedInsideAttributeElement; }
            is(t, e = null) { if (!e) {
                return t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "element" || t === "view:element");
            } }
            getChild(t) { return this._children[t]; }
            getChildIndex(t) { return this._children.indexOf(t); }
            getChildren() { return this._children[Symbol.iterator](); }
            *getAttributeKeys() { if (this._classes.size > 0) {
                yield "class";
            } if (!this._styles.isEmpty) {
                yield "style";
            } yield* this._attrs.keys(); }
            *getAttributes() { yield* this._attrs.entries(); if (this._classes.size > 0) {
                yield ["class", this.getAttribute("class")];
            } if (!this._styles.isEmpty) {
                yield ["style", this.getAttribute("style")];
            } }
            getAttribute(t) { if (t == "class") {
                if (this._classes.size > 0) {
                    return [...this._classes].join(" ");
                }
                return undefined;
            } if (t == "style") {
                const t = this._styles.toString();
                return t == "" ? undefined : t;
            } return this._attrs.get(t); }
            hasAttribute(t) { if (t == "class") {
                return this._classes.size > 0;
            } if (t == "style") {
                return !this._styles.isEmpty;
            } return this._attrs.has(t); }
            isSimilar(t) { if (!(t instanceof ul)) {
                return false;
            } if (this === t) {
                return true;
            } if (this.name != t.name) {
                return false;
            } if (this.isAllowedInsideAttributeElement != t.isAllowedInsideAttributeElement) {
                return false;
            } if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) {
                return false;
            } for (const [e, n] of this._attrs) {
                if (!t._attrs.has(e) || t._attrs.get(e) !== n) {
                    return false;
                }
            } for (const e of this._classes) {
                if (!t._classes.has(e)) {
                    return false;
                }
            } for (const e of this._styles.getStyleNames()) {
                if (!t._styles.has(e) || t._styles.getAsString(e) !== this._styles.getAsString(e)) {
                    return false;
                }
            } return true; }
            hasClass(...t) { for (const e of t) {
                if (!this._classes.has(e)) {
                    return false;
                }
            } return true; }
            getClassNames() { return this._classes.keys(); }
            getStyle(t) { return this._styles.getAsString(t); }
            getNormalizedStyle(t) { return this._styles.getNormalized(t); }
            getStyleNames() { return this._styles.getStyleNames(); }
            hasStyle(...t) { for (const e of t) {
                if (!this._styles.has(e)) {
                    return false;
                }
            } return true; }
            findAncestor(...t) { const e = new qa(...t); let n = this.parent; while (n) {
                if (e.match(n)) {
                    return n;
                }
                n = n.parent;
            } return null; }
            getCustomProperty(t) { return this._customProperties.get(t); }
            *getCustomProperties() { yield* this._customProperties.entries(); }
            getIdentity() { const t = Array.from(this._classes).sort().join(","); const e = this._styles.toString(); const n = Array.from(this._attrs).map((t => `${t[0]}="${t[1]}"`)).sort().join(" "); return this.name + (t == "" ? "" : ` class="${t}"`) + (!e ? "" : ` style="${e}"`) + (n == "" ? "" : ` ${n}`); }
            _clone(t = false) { const e = []; if (t) {
                for (const n of this.getChildren()) {
                    e.push(n._clone(t));
                }
            } const n = new this.constructor(this.document, this.name, this._attrs, e); n._classes = new Set(this._classes); n._styles.set(this._styles.getNormalized()); n._customProperties = new Map(this._customProperties); n.getFillerOffset = this.getFillerOffset; n._isAllowedInsideAttributeElement = this.isAllowedInsideAttributeElement; return n; }
            _appendChild(t) { return this._insertChild(this.childCount, t); }
            _insertChild(t, e) { this._fireChange("children", this); let n = 0; const o = pl(this.document, e); for (const e of o) {
                if (e.parent !== null) {
                    e._remove();
                }
                e.parent = this;
                e.document = this.document;
                this._children.splice(t, 0, e);
                t++;
                n++;
            } return n; }
            _removeChildren(t, e = 1) { this._fireChange("children", this); for (let n = t; n < t + e; n++) {
                this._children[n].parent = null;
            } return this._children.splice(t, e); }
            _setAttribute(t, e) { e = String(e); this._fireChange("attributes", this); if (t == "class") {
                fl(this._classes, e);
            }
            else if (t == "style") {
                this._styles.setTo(e);
            }
            else {
                this._attrs.set(t, e);
            } }
            _removeAttribute(t) { this._fireChange("attributes", this); if (t == "class") {
                if (this._classes.size > 0) {
                    this._classes.clear();
                    return true;
                }
                return false;
            } if (t == "style") {
                if (!this._styles.isEmpty) {
                    this._styles.clear();
                    return true;
                }
                return false;
            } return this._attrs.delete(t); }
            _addClass(t) { this._fireChange("attributes", this); for (const e of _a(t)) {
                this._classes.add(e);
            } }
            _removeClass(t) { this._fireChange("attributes", this); for (const e of _a(t)) {
                this._classes.delete(e);
            } }
            _setStyle(t, e) { this._fireChange("attributes", this); this._styles.set(t, e); }
            _removeStyle(t) { this._fireChange("attributes", this); for (const e of _a(t)) {
                this._styles.remove(e);
            } }
            _setCustomProperty(t, e) { this._customProperties.set(t, e); }
            _removeCustomProperty(t) { return this._customProperties.delete(t); }
        }
        function hl(t) { t = La(t); for (const [e, n] of t) {
            if (n === null) {
                t.delete(e);
            }
            else if (typeof n != "string") {
                t.set(e, String(n));
            }
        } return t; }
        function fl(t, e) { const n = e.split(/\s+/); t.clear(); n.forEach((e => t.add(e))); }
        function pl(t, e) { if (typeof e == "string") {
            return [new Na(t, e)];
        } if (!ka(e)) {
            e = [e];
        } return Array.from(e).map((e => { if (typeof e == "string") {
            return new Na(t, e);
        } if (e instanceof Ma) {
            return new Na(t, e.data);
        } return e; })); }
        class gl extends ul {
            constructor(t, e, n, o) { super(t, e, n, o); this.getFillerOffset = ml; }
            is(t, e = null) { if (!e) {
                return t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
            } }
        }
        function ml() { const t = [...this.getChildren()]; const e = t[this.childCount - 1]; if (e && e.is("element", "br")) {
            return this.childCount;
        } for (const e of t) {
            if (!e.is("uiElement")) {
                return null;
            }
        } return this.childCount; }
        class kl extends gl {
            constructor(t, e, n, o) { super(t, e, n, o); this.set("isReadOnly", false); this.set("isFocused", false); this.bind("isReadOnly").to(t); this.bind("isFocused").to(t, "isFocused", (e => e && t.selection.editableElement == this)); this.listenTo(t.selection, "change", (() => { this.isFocused = t.isFocused && t.selection.editableElement == this; })); }
            is(t, e = null) { if (!e) {
                return t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
            } }
            destroy() { this.stopListening(); }
        }
        qn(kl, Pn);
        const bl = Symbol("rootName");
        class wl extends kl {
            constructor(t, e) { super(t, e); this.rootName = "main"; }
            is(t, e = null) { if (!e) {
                return t === "rootElement" || t === "view:rootElement" || t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "rootElement" || t === "view:rootElement" || t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
            } }
            get rootName() { return this.getCustomProperty(bl); }
            set rootName(t) { this._setCustomProperty(bl, t); }
            set _name(t) { this.name = t; }
        }
        class _l {
            constructor(t = {}) { if (!t.boundaries && !t.startPosition) {
                throw new u["a"]("view-tree-walker-no-start-position", null);
            } if (t.direction && t.direction != "forward" && t.direction != "backward") {
                throw new u["a"]("view-tree-walker-unknown-direction", t.startPosition, { direction: t.direction });
            } this.boundaries = t.boundaries || null; if (t.startPosition) {
                this.position = vl._createAt(t.startPosition);
            }
            else {
                this.position = vl._createAt(t.boundaries[t.direction == "backward" ? "end" : "start"]);
            } this.direction = t.direction || "forward"; this.singleCharacters = !!t.singleCharacters; this.shallow = !!t.shallow; this.ignoreElementEnd = !!t.ignoreElementEnd; this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null; this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null; }
            [Symbol.iterator]() { return this; }
            skip(t) { let e, n, o; do {
                o = this.position;
                ({ done: e, value: n } = this.next());
            } while (!e && t(n)); if (!e) {
                this.position = o;
            } }
            next() { if (this.direction == "forward") {
                return this._next();
            }
            else {
                return this._previous();
            } }
            _next() { let t = this.position.clone(); const e = this.position; const n = t.parent; if (n.parent === null && t.offset === n.childCount) {
                return { done: true };
            } if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) {
                return { done: true };
            } let o; if (n instanceof Na) {
                if (t.isAtEnd) {
                    this.position = vl._createAfter(n);
                    return this._next();
                }
                o = n.data[t.offset];
            }
            else {
                o = n.getChild(t.offset);
            } if (o instanceof ul) {
                if (!this.shallow) {
                    t = new vl(o, 0);
                }
                else {
                    t.offset++;
                }
                this.position = t;
                return this._formatReturnValue("elementStart", o, e, t, 1);
            }
            else if (o instanceof Na) {
                if (this.singleCharacters) {
                    t = new vl(o, 0);
                    this.position = t;
                    return this._next();
                }
                else {
                    let n = o.data.length;
                    let i;
                    if (o == this._boundaryEndParent) {
                        n = this.boundaries.end.offset;
                        i = new Ma(o, 0, n);
                        t = vl._createAfter(i);
                    }
                    else {
                        i = new Ma(o, 0, o.data.length);
                        t.offset++;
                    }
                    this.position = t;
                    return this._formatReturnValue("text", i, e, t, n);
                }
            }
            else if (typeof o == "string") {
                let o;
                if (this.singleCharacters) {
                    o = 1;
                }
                else {
                    const e = n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length;
                    o = e - t.offset;
                }
                const i = new Ma(n, t.offset, o);
                t.offset += o;
                this.position = t;
                return this._formatReturnValue("text", i, e, t, o);
            }
            else {
                t = vl._createAfter(n);
                this.position = t;
                if (this.ignoreElementEnd) {
                    return this._next();
                }
                else {
                    return this._formatReturnValue("elementEnd", n, e, t);
                }
            } }
            _previous() { let t = this.position.clone(); const e = this.position; const n = t.parent; if (n.parent === null && t.offset === 0) {
                return { done: true };
            } if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) {
                return { done: true };
            } let o; if (n instanceof Na) {
                if (t.isAtStart) {
                    this.position = vl._createBefore(n);
                    return this._previous();
                }
                o = n.data[t.offset - 1];
            }
            else {
                o = n.getChild(t.offset - 1);
            } if (o instanceof ul) {
                if (!this.shallow) {
                    t = new vl(o, o.childCount);
                    this.position = t;
                    if (this.ignoreElementEnd) {
                        return this._previous();
                    }
                    else {
                        return this._formatReturnValue("elementEnd", o, e, t);
                    }
                }
                else {
                    t.offset--;
                    this.position = t;
                    return this._formatReturnValue("elementStart", o, e, t, 1);
                }
            }
            else if (o instanceof Na) {
                if (this.singleCharacters) {
                    t = new vl(o, o.data.length);
                    this.position = t;
                    return this._previous();
                }
                else {
                    let n = o.data.length;
                    let i;
                    if (o == this._boundaryStartParent) {
                        const e = this.boundaries.start.offset;
                        i = new Ma(o, e, o.data.length - e);
                        n = i.data.length;
                        t = vl._createBefore(i);
                    }
                    else {
                        i = new Ma(o, 0, o.data.length);
                        t.offset--;
                    }
                    this.position = t;
                    return this._formatReturnValue("text", i, e, t, n);
                }
            }
            else if (typeof o == "string") {
                let o;
                if (!this.singleCharacters) {
                    const e = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
                    o = t.offset - e;
                }
                else {
                    o = 1;
                }
                t.offset -= o;
                const i = new Ma(n, t.offset, o);
                this.position = t;
                return this._formatReturnValue("text", i, e, t, o);
            }
            else {
                t = vl._createBefore(n);
                this.position = t;
                return this._formatReturnValue("elementStart", n, e, t, 1);
            } }
            _formatReturnValue(t, e, n, o, i) { if (e instanceof Ma) {
                if (e.offsetInText + e.data.length == e.textNode.data.length) {
                    if (this.direction == "forward" && !(this.boundaries && this.boundaries.end.isEqual(this.position))) {
                        o = vl._createAfter(e.textNode);
                        this.position = o;
                    }
                    else {
                        n = vl._createAfter(e.textNode);
                    }
                }
                if (e.offsetInText === 0) {
                    if (this.direction == "backward" && !(this.boundaries && this.boundaries.start.isEqual(this.position))) {
                        o = vl._createBefore(e.textNode);
                        this.position = o;
                    }
                    else {
                        n = vl._createBefore(e.textNode);
                    }
                }
            } return { done: false, value: { type: t, item: e, previousPosition: n, nextPosition: o, length: i } }; }
        }
        class vl {
            constructor(t, e) { this.parent = t; this.offset = e; }
            get nodeAfter() { if (this.parent.is("$text")) {
                return null;
            } return this.parent.getChild(this.offset) || null; }
            get nodeBefore() { if (this.parent.is("$text")) {
                return null;
            } return this.parent.getChild(this.offset - 1) || null; }
            get isAtStart() { return this.offset === 0; }
            get isAtEnd() { const t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount; return this.offset === t; }
            get root() { return this.parent.root; }
            get editableElement() { let t = this.parent; while (!(t instanceof kl)) {
                if (t.parent) {
                    t = t.parent;
                }
                else {
                    return null;
                }
            } return t; }
            getShiftedBy(t) { const e = vl._createAt(this); const n = e.offset + t; e.offset = n < 0 ? 0 : n; return e; }
            getLastMatchingPosition(t, e = {}) { e.startPosition = this; const n = new _l(e); n.skip(t); return n.position; }
            getAncestors() { if (this.parent.is("documentFragment")) {
                return [this.parent];
            }
            else {
                return this.parent.getAncestors({ includeSelf: true });
            } }
            getCommonAncestor(t) { const e = this.getAncestors(); const n = t.getAncestors(); let o = 0; while (e[o] == n[o] && e[o]) {
                o++;
            } return o === 0 ? null : e[o - 1]; }
            is(t) { return t === "position" || t === "view:position"; }
            isEqual(t) { return this.parent == t.parent && this.offset == t.offset; }
            isBefore(t) { return this.compareWith(t) == "before"; }
            isAfter(t) { return this.compareWith(t) == "after"; }
            compareWith(t) { if (this.root !== t.root) {
                return "different";
            } if (this.isEqual(t)) {
                return "same";
            } const e = this.parent.is("node") ? this.parent.getPath() : []; const n = t.parent.is("node") ? t.parent.getPath() : []; e.push(this.offset); n.push(t.offset); const o = Ia(e, n); switch (o) {
                case "prefix": return "before";
                case "extension": return "after";
                default: return e[o] < n[o] ? "before" : "after";
            } }
            getWalker(t = {}) { t.startPosition = this; return new _l(t); }
            clone() { return new vl(this.parent, this.offset); }
            static _createAt(t, e) { if (t instanceof vl) {
                return new this(t.parent, t.offset);
            }
            else {
                const n = t;
                if (e == "end") {
                    e = n.is("$text") ? n.data.length : n.childCount;
                }
                else if (e == "before") {
                    return this._createBefore(n);
                }
                else if (e == "after") {
                    return this._createAfter(n);
                }
                else if (e !== 0 && !e) {
                    throw new u["a"]("view-createpositionat-offset-required", n);
                }
                return new vl(n, e);
            } }
            static _createAfter(t) { if (t.is("$textProxy")) {
                return new vl(t.textNode, t.offsetInText + t.data.length);
            } if (!t.parent) {
                throw new u["a"]("view-position-after-root", t, { root: t });
            } return new vl(t.parent, t.index + 1); }
            static _createBefore(t) { if (t.is("$textProxy")) {
                return new vl(t.textNode, t.offsetInText);
            } if (!t.parent) {
                throw new u["a"]("view-position-before-root", t, { root: t });
            } return new vl(t.parent, t.index); }
        }
        class Al {
            constructor(t, e = null) { this.start = t.clone(); this.end = e ? e.clone() : t.clone(); }
            *[Symbol.iterator]() { yield* new _l({ boundaries: this, ignoreElementEnd: true }); }
            get isCollapsed() { return this.start.isEqual(this.end); }
            get isFlat() { return this.start.parent === this.end.parent; }
            get root() { return this.start.root; }
            getEnlarged() { let t = this.start.getLastMatchingPosition(Cl, { direction: "backward" }); let e = this.end.getLastMatchingPosition(Cl); if (t.parent.is("$text") && t.isAtStart) {
                t = vl._createBefore(t.parent);
            } if (e.parent.is("$text") && e.isAtEnd) {
                e = vl._createAfter(e.parent);
            } return new Al(t, e); }
            getTrimmed() { let t = this.start.getLastMatchingPosition(Cl); if (t.isAfter(this.end) || t.isEqual(this.end)) {
                return new Al(t, t);
            } let e = this.end.getLastMatchingPosition(Cl, { direction: "backward" }); const n = t.nodeAfter; const o = e.nodeBefore; if (n && n.is("$text")) {
                t = new vl(n, 0);
            } if (o && o.is("$text")) {
                e = new vl(o, o.data.length);
            } return new Al(t, e); }
            isEqual(t) { return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end); }
            containsPosition(t) { return t.isAfter(this.start) && t.isBefore(this.end); }
            containsRange(t, e = false) { if (t.isCollapsed) {
                e = false;
            } const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start); const o = this.containsPosition(t.end) || e && this.end.isEqual(t.end); return n && o; }
            getDifference(t) { const e = []; if (this.isIntersecting(t)) {
                if (this.containsPosition(t.start)) {
                    e.push(new Al(this.start, t.start));
                }
                if (this.containsPosition(t.end)) {
                    e.push(new Al(t.end, this.end));
                }
            }
            else {
                e.push(this.clone());
            } return e; }
            getIntersection(t) { if (this.isIntersecting(t)) {
                let e = this.start;
                let n = this.end;
                if (this.containsPosition(t.start)) {
                    e = t.start;
                }
                if (this.containsPosition(t.end)) {
                    n = t.end;
                }
                return new Al(e, n);
            } return null; }
            getWalker(t = {}) { t.boundaries = this; return new _l(t); }
            getCommonAncestor() { return this.start.getCommonAncestor(this.end); }
            getContainedElement() { if (this.isCollapsed) {
                return null;
            } let t = this.start.nodeAfter; let e = this.end.nodeBefore; if (this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling) {
                t = this.start.parent.nextSibling;
            } if (this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling) {
                e = this.end.parent.previousSibling;
            } if (t && t.is("element") && t === e) {
                return t;
            } return null; }
            clone() { return new Al(this.start, this.end); }
            *getItems(t = {}) { t.boundaries = this; t.ignoreElementEnd = true; const e = new _l(t); for (const t of e) {
                yield t.item;
            } }
            *getPositions(t = {}) { t.boundaries = this; const e = new _l(t); yield e.position; for (const t of e) {
                yield t.nextPosition;
            } }
            is(t) { return t === "range" || t === "view:range"; }
            isIntersecting(t) { return this.start.isBefore(t.end) && this.end.isAfter(t.start); }
            static _createFromParentsAndOffsets(t, e, n, o) { return new this(new vl(t, e), new vl(n, o)); }
            static _createFromPositionAndShift(t, e) { const n = t; const o = t.getShiftedBy(e); return e > 0 ? new this(n, o) : new this(o, n); }
            static _createIn(t) { return this._createFromParentsAndOffsets(t, 0, t, t.childCount); }
            static _createOn(t) { const e = t.is("$textProxy") ? t.offsetSize : 1; return this._createFromPositionAndShift(vl._createBefore(t), e); }
        }
        function Cl(t) { if (t.item.is("attributeElement") || t.item.is("uiElement")) {
            return true;
        } return false; }
        function yl(t) { let e = 0; for (const n of t) {
            e++;
        } return e; }
        class xl {
            constructor(t = null, e, n) { this._ranges = []; this._lastRangeBackward = false; this._isFake = false; this._fakeSelectionLabel = ""; this.setTo(t, e, n); }
            get isFake() { return this._isFake; }
            get fakeSelectionLabel() { return this._fakeSelectionLabel; }
            get anchor() { if (!this._ranges.length) {
                return null;
            } const t = this._ranges[this._ranges.length - 1]; const e = this._lastRangeBackward ? t.end : t.start; return e.clone(); }
            get focus() { if (!this._ranges.length) {
                return null;
            } const t = this._ranges[this._ranges.length - 1]; const e = this._lastRangeBackward ? t.start : t.end; return e.clone(); }
            get isCollapsed() { return this.rangeCount === 1 && this._ranges[0].isCollapsed; }
            get rangeCount() { return this._ranges.length; }
            get isBackward() { return !this.isCollapsed && this._lastRangeBackward; }
            get editableElement() { if (this.anchor) {
                return this.anchor.editableElement;
            } return null; }
            *getRanges() { for (const t of this._ranges) {
                yield t.clone();
            } }
            getFirstRange() { let t = null; for (const e of this._ranges) {
                if (!t || e.start.isBefore(t.start)) {
                    t = e;
                }
            } return t ? t.clone() : null; }
            getLastRange() { let t = null; for (const e of this._ranges) {
                if (!t || e.end.isAfter(t.end)) {
                    t = e;
                }
            } return t ? t.clone() : null; }
            getFirstPosition() { const t = this.getFirstRange(); return t ? t.start.clone() : null; }
            getLastPosition() { const t = this.getLastRange(); return t ? t.end.clone() : null; }
            isEqual(t) { if (this.isFake != t.isFake) {
                return false;
            } if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) {
                return false;
            } if (this.rangeCount != t.rangeCount) {
                return false;
            }
            else if (this.rangeCount === 0) {
                return true;
            } if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) {
                return false;
            } for (const e of this._ranges) {
                let n = false;
                for (const o of t._ranges) {
                    if (e.isEqual(o)) {
                        n = true;
                        break;
                    }
                }
                if (!n) {
                    return false;
                }
            } return true; }
            isSimilar(t) { if (this.isBackward != t.isBackward) {
                return false;
            } const e = yl(this.getRanges()); const n = yl(t.getRanges()); if (e != n) {
                return false;
            } if (e == 0) {
                return true;
            } for (let e of this.getRanges()) {
                e = e.getTrimmed();
                let n = false;
                for (let o of t.getRanges()) {
                    o = o.getTrimmed();
                    if (e.start.isEqual(o.start) && e.end.isEqual(o.end)) {
                        n = true;
                        break;
                    }
                }
                if (!n) {
                    return false;
                }
            } return true; }
            getSelectedElement() { if (this.rangeCount !== 1) {
                return null;
            } return this.getFirstRange().getContainedElement(); }
            setTo(t, e, n) { if (t === null) {
                this._setRanges([]);
                this._setFakeOptions(e);
            }
            else if (t instanceof xl || t instanceof El) {
                this._setRanges(t.getRanges(), t.isBackward);
                this._setFakeOptions({ fake: t.isFake, label: t.fakeSelectionLabel });
            }
            else if (t instanceof Al) {
                this._setRanges([t], e && e.backward);
                this._setFakeOptions(e);
            }
            else if (t instanceof vl) {
                this._setRanges([new Al(t)]);
                this._setFakeOptions(e);
            }
            else if (t instanceof za) {
                const o = !!n && !!n.backward;
                let i;
                if (e === undefined) {
                    throw new u["a"]("view-selection-setto-required-second-parameter", this);
                }
                else if (e == "in") {
                    i = Al._createIn(t);
                }
                else if (e == "on") {
                    i = Al._createOn(t);
                }
                else {
                    i = new Al(vl._createAt(t, e));
                }
                this._setRanges([i], o);
                this._setFakeOptions(n);
            }
            else if (ka(t)) {
                this._setRanges(t, e && e.backward);
                this._setFakeOptions(e);
            }
            else {
                throw new u["a"]("view-selection-setto-not-selectable", this);
            } this.fire("change"); }
            setFocus(t, e) { if (this.anchor === null) {
                throw new u["a"]("view-selection-setfocus-no-ranges", this);
            } const n = vl._createAt(t, e); if (n.compareWith(this.focus) == "same") {
                return;
            } const o = this.anchor; this._ranges.pop(); if (n.compareWith(o) == "before") {
                this._addRange(new Al(n, o), true);
            }
            else {
                this._addRange(new Al(o, n));
            } this.fire("change"); }
            is(t) { return t === "selection" || t === "view:selection"; }
            _setRanges(t, e = false) { t = Array.from(t); this._ranges = []; for (const e of t) {
                this._addRange(e);
            } this._lastRangeBackward = !!e; }
            _setFakeOptions(t = {}) { this._isFake = !!t.fake; this._fakeSelectionLabel = t.fake ? t.label || "" : ""; }
            _addRange(t, e = false) { if (!(t instanceof Al)) {
                throw new u["a"]("view-selection-add-range-not-range", this);
            } this._pushRange(t); this._lastRangeBackward = !!e; }
            _pushRange(t) { for (const e of this._ranges) {
                if (t.isIntersecting(e)) {
                    throw new u["a"]("view-selection-range-intersects", this, { addedRange: t, intersectingRange: e });
                }
            } this._ranges.push(new Al(t.start, t.end)); }
        }
        qn(xl, g);
        class El {
            constructor(t = null, e, n) { this._selection = new xl; this._selection.delegate("change").to(this); this._selection.setTo(t, e, n); }
            get isFake() { return this._selection.isFake; }
            get fakeSelectionLabel() { return this._selection.fakeSelectionLabel; }
            get anchor() { return this._selection.anchor; }
            get focus() { return this._selection.focus; }
            get isCollapsed() { return this._selection.isCollapsed; }
            get rangeCount() { return this._selection.rangeCount; }
            get isBackward() { return this._selection.isBackward; }
            get editableElement() { return this._selection.editableElement; }
            get _ranges() { return this._selection._ranges; }
            *getRanges() { yield* this._selection.getRanges(); }
            getFirstRange() { return this._selection.getFirstRange(); }
            getLastRange() { return this._selection.getLastRange(); }
            getFirstPosition() { return this._selection.getFirstPosition(); }
            getLastPosition() { return this._selection.getLastPosition(); }
            getSelectedElement() { return this._selection.getSelectedElement(); }
            isEqual(t) { return this._selection.isEqual(t); }
            isSimilar(t) { return this._selection.isSimilar(t); }
            is(t) { return t === "selection" || t == "documentSelection" || t == "view:selection" || t == "view:documentSelection"; }
            _setTo(t, e, n) { this._selection.setTo(t, e, n); }
            _setFocus(t, e) { this._selection.setFocus(t, e); }
        }
        qn(El, g);
        class Dl extends r {
            constructor(t, e, n) { super(t, e); this.startRange = n; this._eventPhase = "none"; this._currentTarget = null; }
            get eventPhase() { return this._eventPhase; }
            get currentTarget() { return this._currentTarget; }
        }
        const Sl = Symbol("bubbling contexts");
        const Tl = { fire(t, ...e) { try {
                const n = t instanceof r ? t : new r(this, t);
                const o = Fl(this);
                if (!o.size) {
                    return;
                }
                Bl(n, "capturing", this);
                if (Il(o, "$capture", n, ...e)) {
                    return n.return;
                }
                const i = n.startRange || this.selection.getFirstRange();
                const s = i ? i.getContainedElement() : null;
                const a = s ? Boolean(Rl(o, s)) : false;
                let c = s || Ol(i);
                Bl(n, "atTarget", c);
                if (!a) {
                    if (Il(o, "$text", n, ...e)) {
                        return n.return;
                    }
                    Bl(n, "bubbling", c);
                }
                while (c) {
                    if (c.is("rootElement")) {
                        if (Il(o, "$root", n, ...e)) {
                            return n.return;
                        }
                    }
                    else if (c.is("element")) {
                        if (Il(o, c.name, n, ...e)) {
                            return n.return;
                        }
                    }
                    if (Il(o, c, n, ...e)) {
                        return n.return;
                    }
                    c = c.parent;
                    Bl(n, "bubbling", c);
                }
                Bl(n, "bubbling", this);
                Il(o, "$document", n, ...e);
                return n.return;
            }
            catch (t) {
                u["a"].rethrowUnexpectedError(t, this);
            } }, _addEventListener(t, e, n) { const o = _a(n.context || "$document"); const i = Fl(this); for (const r of o) {
                let o = i.get(r);
                if (!o) {
                    o = Object.create(g);
                    i.set(r, o);
                }
                this.listenTo(o, t, e, n);
            } }, _removeEventListener(t, e) { const n = Fl(this); for (const o of n.values()) {
                this.stopListening(o, t, e);
            } } };
        var Pl = Tl;
        function Bl(t, e, n) { if (t instanceof Dl) {
            t._eventPhase = e;
            t._currentTarget = n;
        } }
        function Il(t, e, n, ...o) { const i = typeof e == "string" ? t.get(e) : Rl(t, e); if (!i) {
            return false;
        } i.fire(n, ...o); return n.stop.called; }
        function Rl(t, e) { for (const [n, o] of t) {
            if (typeof n == "function" && n(e)) {
                return o;
            }
        } return null; }
        function Fl(t) { if (!t[Sl]) {
            t[Sl] = new Map;
        } return t[Sl]; }
        function Ol(t) { if (!t) {
            return null;
        } const e = t.start.parent; const n = t.end.parent; const o = e.getPath(); const i = n.getPath(); return o.length > i.length ? e : n; }
        class zl {
            constructor(t) { this.selection = new El; this.roots = new ba({ idProperty: "rootName" }); this.stylesProcessor = t; this.set("isReadOnly", false); this.set("isFocused", false); this.set("isComposing", false); this._postFixers = new Set; }
            getRoot(t = "main") { return this.roots.get(t); }
            registerPostFixer(t) { this._postFixers.add(t); }
            destroy() { this.roots.map((t => t.destroy())); this.stopListening(); }
            _callPostFixers(t) { let e = false; do {
                for (const n of this._postFixers) {
                    e = n(t);
                    if (e) {
                        break;
                    }
                }
            } while (e); }
        }
        qn(zl, Pl);
        qn(zl, Pn);
        const Nl = 10;
        class Ml extends ul {
            constructor(t, e, n, o) { super(t, e, n, o); this.getFillerOffset = Vl; this._priority = Nl; this._id = null; this._clonesGroup = null; }
            get priority() { return this._priority; }
            get id() { return this._id; }
            getElementsWithSameId() { if (this.id === null) {
                throw new u["a"]("attribute-element-get-elements-with-same-id-no-id", this);
            } return new Set(this._clonesGroup); }
            is(t, e = null) { if (!e) {
                return t === "attributeElement" || t === "view:attributeElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "attributeElement" || t === "view:attributeElement" || t === "element" || t === "view:element");
            } }
            isSimilar(t) { if (this.id !== null || t.id !== null) {
                return this.id === t.id;
            } return super.isSimilar(t) && this.priority == t.priority; }
            _clone(t) { const e = super._clone(t); e._priority = this._priority; e._id = this._id; return e; }
        }
        Ml.DEFAULT_PRIORITY = Nl;
        function Vl() { if (Ll(this)) {
            return null;
        } let t = this.parent; while (t && t.is("attributeElement")) {
            if (Ll(t) > 1) {
                return null;
            }
            t = t.parent;
        } if (!t || Ll(t) > 1) {
            return null;
        } return this.childCount; }
        function Ll(t) { return Array.from(t.getChildren()).filter((t => !t.is("uiElement"))).length; }
        class ql extends ul {
            constructor(t, e, n, o) { super(t, e, n, o); this._isAllowedInsideAttributeElement = true; this.getFillerOffset = Kl; }
            is(t, e = null) { if (!e) {
                return t === "emptyElement" || t === "view:emptyElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "emptyElement" || t === "view:emptyElement" || t === "element" || t === "view:element");
            } }
            _insertChild(t, e) { if (e && (e instanceof za || Array.from(e).length > 0)) {
                throw new u["a"]("view-emptyelement-cannot-add", [this, e]);
            } }
        }
        function Kl() { return null; }
        const jl = navigator.userAgent.toLowerCase();
        const Hl = { isMac: $l(jl), isGecko: Gl(jl), isSafari: Ul(jl), isAndroid: Jl(jl), isBlink: Yl(jl), features: { isRegExpUnicodePropertySupported: Ql() } };
        var Wl = Hl;
        function $l(t) { return t.indexOf("macintosh") > -1; }
        function Gl(t) { return !!t.match(/gecko\/\d+/); }
        function Ul(t) { return t.indexOf(" applewebkit/") > -1 && t.indexOf("chrome") === -1; }
        function Jl(t) { return t.indexOf("android") > -1; }
        function Yl(t) { return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0; }
        function Ql() { let t = false; try {
            t = "ć".search(new RegExp("[\\p{L}]", "u")) === 0;
        }
        catch (t) { } return t; }
        const Xl = { ctrl: "⌃", cmd: "⌘", alt: "⌥", shift: "⇧" };
        const Zl = { ctrl: "Ctrl+", alt: "Alt+", shift: "Shift+" };
        const td = ld();
        const ed = Object.fromEntries(Object.entries(td).map((([t, e]) => [e, t.charAt(0).toUpperCase() + t.slice(1)])));
        function nd(t) { let e; if (typeof t == "string") {
            e = td[t.toLowerCase()];
            if (!e) {
                throw new u["a"]("keyboard-unknown-key", null, { key: t });
            }
        }
        else {
            e = t.keyCode + (t.altKey ? td.alt : 0) + (t.ctrlKey ? td.ctrl : 0) + (t.shiftKey ? td.shift : 0) + (t.metaKey ? td.cmd : 0);
        } return e; }
        function od(t) { if (typeof t == "string") {
            t = dd(t);
        } return t.map((t => typeof t == "string" ? ad(t) : t)).reduce(((t, e) => e + t), 0); }
        function id(t) { let e = od(t); const n = Object.entries(Wl.isMac ? Xl : Zl); const o = n.reduce(((t, [n, o]) => { if ((e & td[n]) != 0) {
            e &= ~td[n];
            t += o;
        } return t; }), ""); return o + (e ? ed[e] : ""); }
        function rd(t) { return t == td.arrowright || t == td.arrowleft || t == td.arrowup || t == td.arrowdown; }
        function sd(t, e) { const n = e === "ltr"; switch (t) {
            case td.arrowleft: return n ? "left" : "right";
            case td.arrowright: return n ? "right" : "left";
            case td.arrowup: return "up";
            case td.arrowdown: return "down";
        } }
        function ad(t) { if (t.endsWith("!")) {
            return nd(t.slice(0, -1));
        } const e = nd(t); return Wl.isMac && e == td.ctrl ? td.cmd : e; }
        function cd(t, e) { const n = sd(t, e); return n === "down" || n === "right"; }
        function ld() { const t = { arrowleft: 37, arrowup: 38, arrowright: 39, arrowdown: 40, backspace: 8, delete: 46, enter: 13, space: 32, esc: 27, tab: 9, ctrl: 1114112, shift: 2228224, alt: 4456448, cmd: 8912896 }; for (let e = 65; e <= 90; e++) {
            const n = String.fromCharCode(e);
            t[n.toLowerCase()] = e;
        } for (let e = 48; e <= 57; e++) {
            t[e - 48] = e;
        } for (let e = 112; e <= 123; e++) {
            t["f" + (e - 111)] = e;
        } return t; }
        function dd(t) { return t.split("+").map((t => t.trim())); }
        class ud extends ul {
            constructor(t, e, n, o) { super(t, e, n, o); this._isAllowedInsideAttributeElement = true; this.getFillerOffset = fd; }
            is(t, e = null) { if (!e) {
                return t === "uiElement" || t === "view:uiElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "uiElement" || t === "view:uiElement" || t === "element" || t === "view:element");
            } }
            _insertChild(t, e) { if (e && (e instanceof za || Array.from(e).length > 0)) {
                throw new u["a"]("view-uielement-cannot-add", this);
            } }
            render(t) { return this.toDomElement(t); }
            toDomElement(t) { const e = t.createElement(this.name); for (const t of this.getAttributeKeys()) {
                e.setAttribute(t, this.getAttribute(t));
            } return e; }
        }
        function hd(t) { t.document.on("arrowKey", ((e, n) => pd(e, n, t.domConverter)), { priority: "low" }); }
        function fd() { return null; }
        function pd(t, e, n) { if (e.keyCode == td.arrowright) {
            const t = e.domTarget.ownerDocument.defaultView.getSelection();
            const o = t.rangeCount == 1 && t.getRangeAt(0).collapsed;
            if (o || e.shiftKey) {
                const e = t.focusNode;
                const i = t.focusOffset;
                const r = n.domPositionToView(e, i);
                if (r === null) {
                    return;
                }
                let s = false;
                const a = r.getLastMatchingPosition((t => { if (t.item.is("uiElement")) {
                    s = true;
                } if (t.item.is("uiElement") || t.item.is("attributeElement")) {
                    return true;
                } return false; }));
                if (s) {
                    const e = n.viewPositionToDom(a);
                    if (o) {
                        t.collapse(e.parent, e.offset);
                    }
                    else {
                        t.extend(e.parent, e.offset);
                    }
                }
            }
        } }
        class gd extends ul {
            constructor(t, e, n, o) { super(t, e, n, o); this._isAllowedInsideAttributeElement = true; this.getFillerOffset = md; }
            is(t, e = null) { if (!e) {
                return t === "rawElement" || t === "view:rawElement" || t === this.name || t === "view:" + this.name || t === "element" || t === "view:element" || t === "node" || t === "view:node";
            }
            else {
                return e === this.name && (t === "rawElement" || t === "view:rawElement" || t === "element" || t === "view:element");
            } }
            _insertChild(t, e) { if (e && (e instanceof za || Array.from(e).length > 0)) {
                throw new u["a"]("view-rawelement-cannot-add", [this, e]);
            } }
        }
        function md() { return null; }
        class kd {
            constructor(t, e) { this.document = t; this._children = []; if (e) {
                this._insertChild(0, e);
            } }
            [Symbol.iterator]() { return this._children[Symbol.iterator](); }
            get childCount() { return this._children.length; }
            get isEmpty() { return this.childCount === 0; }
            get root() { return this; }
            get parent() { return null; }
            is(t) { return t === "documentFragment" || t === "view:documentFragment"; }
            _appendChild(t) { return this._insertChild(this.childCount, t); }
            getChild(t) { return this._children[t]; }
            getChildIndex(t) { return this._children.indexOf(t); }
            getChildren() { return this._children[Symbol.iterator](); }
            _insertChild(t, e) { this._fireChange("children", this); let n = 0; const o = bd(this.document, e); for (const e of o) {
                if (e.parent !== null) {
                    e._remove();
                }
                e.parent = this;
                this._children.splice(t, 0, e);
                t++;
                n++;
            } return n; }
            _removeChildren(t, e = 1) { this._fireChange("children", this); for (let n = t; n < t + e; n++) {
                this._children[n].parent = null;
            } return this._children.splice(t, e); }
            _fireChange(t, e) { this.fire("change:" + t, e); }
        }
        qn(kd, g);
        function bd(t, e) { if (typeof e == "string") {
            return [new Na(t, e)];
        } if (!ka(e)) {
            e = [e];
        } return Array.from(e).map((e => { if (typeof e == "string") {
            return new Na(t, e);
        } if (e instanceof Ma) {
            return new Na(t, e.data);
        } return e; })); }
        class wd {
            constructor(t) { this.document = t; this._cloneGroups = new Map; }
            setSelection(t, e, n) { this.document.selection._setTo(t, e, n); }
            setSelectionFocus(t, e) { this.document.selection._setFocus(t, e); }
            createDocumentFragment(t) { return new kd(this.document, t); }
            createText(t) { return new Na(this.document, t); }
            createAttributeElement(t, e, n = {}) { const o = new Ml(this.document, t, e); if (n.priority) {
                o._priority = n.priority;
            } if (n.id) {
                o._id = n.id;
            } return o; }
            createContainerElement(t, e, n = {}) { const o = new gl(this.document, t, e); if (n.isAllowedInsideAttributeElement !== undefined) {
                o._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement;
            } return o; }
            createEditableElement(t, e) { const n = new kl(this.document, t, e); n._document = this.document; return n; }
            createEmptyElement(t, e, n = {}) { const o = new ql(this.document, t, e); if (n.isAllowedInsideAttributeElement !== undefined) {
                o._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement;
            } return o; }
            createUIElement(t, e, n, o = {}) { const i = new ud(this.document, t, e); if (n) {
                i.render = n;
            } if (o.isAllowedInsideAttributeElement !== undefined) {
                i._isAllowedInsideAttributeElement = o.isAllowedInsideAttributeElement;
            } return i; }
            createRawElement(t, e, n, o = {}) { const i = new gd(this.document, t, e); i.render = n || (() => { }); if (o.isAllowedInsideAttributeElement !== undefined) {
                i._isAllowedInsideAttributeElement = o.isAllowedInsideAttributeElement;
            } return i; }
            setAttribute(t, e, n) { n._setAttribute(t, e); }
            removeAttribute(t, e) { e._removeAttribute(t); }
            addClass(t, e) { e._addClass(t); }
            removeClass(t, e) { e._removeClass(t); }
            setStyle(t, e, n) { if (io(t) && n === undefined) {
                n = e;
            } n._setStyle(t, e); }
            removeStyle(t, e) { e._removeStyle(t); }
            setCustomProperty(t, e, n) { n._setCustomProperty(t, e); }
            removeCustomProperty(t, e) { return e._removeCustomProperty(t); }
            breakAttributes(t) { if (t instanceof vl) {
                return this._breakAttributes(t);
            }
            else {
                return this._breakAttributesRange(t);
            } }
            breakContainer(t) { const e = t.parent; if (!e.is("containerElement")) {
                throw new u["a"]("view-writer-break-non-container-element", this.document);
            } if (!e.parent) {
                throw new u["a"]("view-writer-break-root", this.document);
            } if (t.isAtStart) {
                return vl._createBefore(e);
            }
            else if (!t.isAtEnd) {
                const n = e._clone(false);
                this.insert(vl._createAfter(e), n);
                const o = new Al(t, vl._createAt(e, "end"));
                const i = new vl(n, 0);
                this.move(o, i);
            } return vl._createAfter(e); }
            mergeAttributes(t) { const e = t.offset; const n = t.parent; if (n.is("$text")) {
                return t;
            } if (n.is("attributeElement") && n.childCount === 0) {
                const t = n.parent;
                const e = n.index;
                n._remove();
                this._removeFromClonedElementsGroup(n);
                return this.mergeAttributes(new vl(t, e));
            } const o = n.getChild(e - 1); const i = n.getChild(e); if (!o || !i) {
                return t;
            } if (o.is("$text") && i.is("$text")) {
                return xd(o, i);
            }
            else if (o.is("attributeElement") && i.is("attributeElement") && o.isSimilar(i)) {
                const t = o.childCount;
                o._appendChild(i.getChildren());
                i._remove();
                this._removeFromClonedElementsGroup(i);
                return this.mergeAttributes(new vl(o, t));
            } return t; }
            mergeContainers(t) { const e = t.nodeBefore; const n = t.nodeAfter; if (!e || !n || !e.is("containerElement") || !n.is("containerElement")) {
                throw new u["a"]("view-writer-merge-containers-invalid-position", this.document);
            } const o = e.getChild(e.childCount - 1); const i = o instanceof Na ? vl._createAt(o, "end") : vl._createAt(e, "end"); this.move(Al._createIn(n), vl._createAt(e, "end")); this.remove(Al._createOn(n)); return i; }
            insert(t, e) { e = ka(e) ? [...e] : [e]; Ed(e, this.document); const n = e.reduce(((t, e) => { const n = t[t.length - 1]; const o = !(e.is("uiElement") && e.isAllowedInsideAttributeElement); if (!n || n.breakAttributes != o) {
                t.push({ breakAttributes: o, nodes: [e] });
            }
            else {
                n.nodes.push(e);
            } return t; }), []); let o = null; let i = t; for (const { nodes: t, breakAttributes: e } of n) {
                const n = this._insertNodes(i, t, e);
                if (!o) {
                    o = n.start;
                }
                i = n.end;
            } if (!o) {
                return new Al(t);
            } return new Al(o, i); }
            remove(t) { const e = t instanceof Al ? t : Al._createOn(t); Td(e, this.document); if (e.isCollapsed) {
                return new kd(this.document);
            } const { start: n, end: o } = this._breakAttributesRange(e, true); const i = n.parent; const r = o.offset - n.offset; const s = i._removeChildren(n.offset, r); for (const t of s) {
                this._removeFromClonedElementsGroup(t);
            } const a = this.mergeAttributes(n); e.start = a; e.end = a.clone(); return new kd(this.document, s); }
            clear(t, e) { Td(t, this.document); const n = t.getWalker({ direction: "backward", ignoreElementEnd: true }); for (const o of n) {
                const n = o.item;
                let i;
                if (n.is("element") && e.isSimilar(n)) {
                    i = Al._createOn(n);
                }
                else if (!o.nextPosition.isAfter(t.start) && n.is("$textProxy")) {
                    const t = n.getAncestors().find((t => t.is("element") && e.isSimilar(t)));
                    if (t) {
                        i = Al._createIn(t);
                    }
                }
                if (i) {
                    if (i.end.isAfter(t.end)) {
                        i.end = t.end;
                    }
                    if (i.start.isBefore(t.start)) {
                        i.start = t.start;
                    }
                    this.remove(i);
                }
            } }
            move(t, e) { let n; if (e.isAfter(t.end)) {
                e = this._breakAttributes(e, true);
                const o = e.parent;
                const i = o.childCount;
                t = this._breakAttributesRange(t, true);
                n = this.remove(t);
                e.offset += o.childCount - i;
            }
            else {
                n = this.remove(t);
            } return this.insert(e, n); }
            wrap(t, e) { if (!(e instanceof Ml)) {
                throw new u["a"]("view-writer-wrap-invalid-attribute", this.document);
            } Td(t, this.document); if (!t.isCollapsed) {
                return this._wrapRange(t, e);
            }
            else {
                let n = t.start;
                if (n.parent.is("element") && !_d(n.parent)) {
                    n = n.getLastMatchingPosition((t => t.item.is("uiElement")));
                }
                n = this._wrapPosition(n, e);
                const o = this.document.selection;
                if (o.isCollapsed && o.getFirstPosition().isEqual(t.start)) {
                    this.setSelection(n);
                }
                return new Al(n);
            } }
            unwrap(t, e) { if (!(e instanceof Ml)) {
                throw new u["a"]("view-writer-unwrap-invalid-attribute", this.document);
            } Td(t, this.document); if (t.isCollapsed) {
                return t;
            } const { start: n, end: o } = this._breakAttributesRange(t, true); const i = n.parent; const r = this._unwrapChildren(i, n.offset, o.offset, e); const s = this.mergeAttributes(r.start); if (!s.isEqual(r.start)) {
                r.end.offset--;
            } const a = this.mergeAttributes(r.end); return new Al(s, a); }
            rename(t, e) { const n = new gl(this.document, t, e.getAttributes()); this.insert(vl._createAfter(e), n); this.move(Al._createIn(e), vl._createAt(n, 0)); this.remove(Al._createOn(e)); return n; }
            clearClonedElementsGroup(t) { this._cloneGroups.delete(t); }
            createPositionAt(t, e) { return vl._createAt(t, e); }
            createPositionAfter(t) { return vl._createAfter(t); }
            createPositionBefore(t) { return vl._createBefore(t); }
            createRange(t, e) { return new Al(t, e); }
            createRangeOn(t) { return Al._createOn(t); }
            createRangeIn(t) { return Al._createIn(t); }
            createSelection(t, e, n) { return new xl(t, e, n); }
            _insertNodes(t, e, n) { let o; if (n) {
                o = vd(t);
            }
            else {
                o = t.parent.is("$text") ? t.parent.parent : t.parent;
            } if (!o) {
                throw new u["a"]("view-writer-invalid-position-container", this.document);
            } let i; if (n) {
                i = this._breakAttributes(t, true);
            }
            else {
                i = t.parent.is("$text") ? yd(t) : t;
            } const r = o._insertChild(i.offset, e); for (const t of e) {
                this._addToClonedElementsGroup(t);
            } const s = i.getShiftedBy(r); const a = this.mergeAttributes(i); if (!a.isEqual(i)) {
                s.offset--;
            } const c = this.mergeAttributes(s); return new Al(a, c); }
            _wrapChildren(t, e, n, o) { let i = e; const r = []; while (i < n) {
                const e = t.getChild(i);
                const n = e.is("$text");
                const s = e.is("attributeElement");
                const a = e.isAllowedInsideAttributeElement;
                if (s && this._wrapAttributeElement(o, e)) {
                    r.push(new vl(t, i));
                }
                else if (n || a || s && Ad(o, e)) {
                    const n = o._clone();
                    e._remove();
                    n._appendChild(e);
                    t._insertChild(i, n);
                    this._addToClonedElementsGroup(n);
                    r.push(new vl(t, i));
                }
                else if (s) {
                    this._wrapChildren(e, 0, e.childCount, o);
                }
                i++;
            } let s = 0; for (const t of r) {
                t.offset -= s;
                if (t.offset == e) {
                    continue;
                }
                const o = this.mergeAttributes(t);
                if (!o.isEqual(t)) {
                    s++;
                    n--;
                }
            } return Al._createFromParentsAndOffsets(t, e, t, n); }
            _unwrapChildren(t, e, n, o) { let i = e; const r = []; while (i < n) {
                const e = t.getChild(i);
                if (!e.is("attributeElement")) {
                    i++;
                    continue;
                }
                if (e.isSimilar(o)) {
                    const o = e.getChildren();
                    const s = e.childCount;
                    e._remove();
                    t._insertChild(i, o);
                    this._removeFromClonedElementsGroup(e);
                    r.push(new vl(t, i), new vl(t, i + s));
                    i += s;
                    n += s - 1;
                    continue;
                }
                if (this._unwrapAttributeElement(o, e)) {
                    r.push(new vl(t, i), new vl(t, i + 1));
                    i++;
                    continue;
                }
                this._unwrapChildren(e, 0, e.childCount, o);
                i++;
            } let s = 0; for (const t of r) {
                t.offset -= s;
                if (t.offset == e || t.offset == n) {
                    continue;
                }
                const o = this.mergeAttributes(t);
                if (!o.isEqual(t)) {
                    s++;
                    n--;
                }
            } return Al._createFromParentsAndOffsets(t, e, t, n); }
            _wrapRange(t, e) { const { start: n, end: o } = this._breakAttributesRange(t, true); const i = n.parent; const r = this._wrapChildren(i, n.offset, o.offset, e); const s = this.mergeAttributes(r.start); if (!s.isEqual(r.start)) {
                r.end.offset--;
            } const a = this.mergeAttributes(r.end); return new Al(s, a); }
            _wrapPosition(t, e) { if (e.isSimilar(t.parent)) {
                return Cd(t.clone());
            } if (t.parent.is("$text")) {
                t = yd(t);
            } const n = this.createAttributeElement(); n._priority = Number.POSITIVE_INFINITY; n.isSimilar = () => false; t.parent._insertChild(t.offset, n); const o = new Al(t, t.getShiftedBy(1)); this.wrap(o, e); const i = new vl(n.parent, n.index); n._remove(); const r = i.nodeBefore; const s = i.nodeAfter; if (r instanceof Na && s instanceof Na) {
                return xd(r, s);
            } return Cd(i); }
            _wrapAttributeElement(t, e) { if (!Pd(t, e)) {
                return false;
            } if (t.name !== e.name || t.priority !== e.priority) {
                return false;
            } for (const n of t.getAttributeKeys()) {
                if (n === "class" || n === "style") {
                    continue;
                }
                if (e.hasAttribute(n) && e.getAttribute(n) !== t.getAttribute(n)) {
                    return false;
                }
            } for (const n of t.getStyleNames()) {
                if (e.hasStyle(n) && e.getStyle(n) !== t.getStyle(n)) {
                    return false;
                }
            } for (const n of t.getAttributeKeys()) {
                if (n === "class" || n === "style") {
                    continue;
                }
                if (!e.hasAttribute(n)) {
                    this.setAttribute(n, t.getAttribute(n), e);
                }
            } for (const n of t.getStyleNames()) {
                if (!e.hasStyle(n)) {
                    this.setStyle(n, t.getStyle(n), e);
                }
            } for (const n of t.getClassNames()) {
                if (!e.hasClass(n)) {
                    this.addClass(n, e);
                }
            } return true; }
            _unwrapAttributeElement(t, e) { if (!Pd(t, e)) {
                return false;
            } if (t.name !== e.name || t.priority !== e.priority) {
                return false;
            } for (const n of t.getAttributeKeys()) {
                if (n === "class" || n === "style") {
                    continue;
                }
                if (!e.hasAttribute(n) || e.getAttribute(n) !== t.getAttribute(n)) {
                    return false;
                }
            } if (!e.hasClass(...t.getClassNames())) {
                return false;
            } for (const n of t.getStyleNames()) {
                if (!e.hasStyle(n) || e.getStyle(n) !== t.getStyle(n)) {
                    return false;
                }
            } for (const n of t.getAttributeKeys()) {
                if (n === "class" || n === "style") {
                    continue;
                }
                this.removeAttribute(n, e);
            } this.removeClass(Array.from(t.getClassNames()), e); this.removeStyle(Array.from(t.getStyleNames()), e); return true; }
            _breakAttributesRange(t, e = false) { const n = t.start; const o = t.end; Td(t, this.document); if (t.isCollapsed) {
                const n = this._breakAttributes(t.start, e);
                return new Al(n, n);
            } const i = this._breakAttributes(o, e); const r = i.parent.childCount; const s = this._breakAttributes(n, e); i.offset += i.parent.childCount - r; return new Al(s, i); }
            _breakAttributes(t, e = false) { const n = t.offset; const o = t.parent; if (t.parent.is("emptyElement")) {
                throw new u["a"]("view-writer-cannot-break-empty-element", this.document);
            } if (t.parent.is("uiElement")) {
                throw new u["a"]("view-writer-cannot-break-ui-element", this.document);
            } if (t.parent.is("rawElement")) {
                throw new u["a"]("view-writer-cannot-break-raw-element", this.document);
            } if (!e && o.is("$text") && Sd(o.parent)) {
                return t.clone();
            } if (Sd(o)) {
                return t.clone();
            } if (o.is("$text")) {
                return this._breakAttributes(yd(t), e);
            } const i = o.childCount; if (n == i) {
                const t = new vl(o.parent, o.index + 1);
                return this._breakAttributes(t, e);
            }
            else {
                if (n === 0) {
                    const t = new vl(o.parent, o.index);
                    return this._breakAttributes(t, e);
                }
                else {
                    const t = o.index + 1;
                    const i = o._clone();
                    o.parent._insertChild(t, i);
                    this._addToClonedElementsGroup(i);
                    const r = o.childCount - n;
                    const s = o._removeChildren(n, r);
                    i._appendChild(s);
                    const a = new vl(o.parent, t);
                    return this._breakAttributes(a, e);
                }
            } }
            _addToClonedElementsGroup(t) { if (!t.root.is("rootElement")) {
                return;
            } if (t.is("element")) {
                for (const e of t.getChildren()) {
                    this._addToClonedElementsGroup(e);
                }
            } const e = t.id; if (!e) {
                return;
            } let n = this._cloneGroups.get(e); if (!n) {
                n = new Set;
                this._cloneGroups.set(e, n);
            } n.add(t); t._clonesGroup = n; }
            _removeFromClonedElementsGroup(t) { if (t.is("element")) {
                for (const e of t.getChildren()) {
                    this._removeFromClonedElementsGroup(e);
                }
            } const e = t.id; if (!e) {
                return;
            } const n = this._cloneGroups.get(e); if (!n) {
                return;
            } n.delete(t); }
        }
        function _d(t) { return Array.from(t.getChildren()).some((t => !t.is("uiElement"))); }
        function vd(t) { let e = t.parent; while (!Sd(e)) {
            if (!e) {
                return undefined;
            }
            e = e.parent;
        } return e; }
        function Ad(t, e) { if (t.priority < e.priority) {
            return true;
        }
        else if (t.priority > e.priority) {
            return false;
        } return t.getIdentity() < e.getIdentity(); }
        function Cd(t) { const e = t.nodeBefore; if (e && e.is("$text")) {
            return new vl(e, e.data.length);
        } const n = t.nodeAfter; if (n && n.is("$text")) {
            return new vl(n, 0);
        } return t; }
        function yd(t) { if (t.offset == t.parent.data.length) {
            return new vl(t.parent.parent, t.parent.index + 1);
        } if (t.offset === 0) {
            return new vl(t.parent.parent, t.parent.index);
        } const e = t.parent.data.slice(t.offset); t.parent._data = t.parent.data.slice(0, t.offset); t.parent.parent._insertChild(t.parent.index + 1, new Na(t.root.document, e)); return new vl(t.parent.parent, t.parent.index + 1); }
        function xd(t, e) { const n = t.data.length; t._data += e.data; e._remove(); return new vl(t, n); }
        function Ed(t, e) { for (const n of t) {
            if (!Dd.some((t => n instanceof t))) {
                throw new u["a"]("view-writer-insert-invalid-node-type", e);
            }
            if (!n.is("$text")) {
                Ed(n.getChildren(), e);
            }
        } }
        const Dd = [Na, Ml, gl, ql, gd, ud];
        function Sd(t) { return t && (t.is("containerElement") || t.is("documentFragment")); }
        function Td(t, e) { const n = vd(t.start); const o = vd(t.end); if (!n || !o || n !== o) {
            throw new u["a"]("view-writer-invalid-range-container", e);
        } }
        function Pd(t, e) { return t.id === null && e.id === null; }
        function Bd(t) { return Object.prototype.toString.call(t) == "[object Text]"; }
        const Id = t => t.createTextNode(" ");
        const Rd = t => { const e = t.createElement("span"); e.dataset.ckeFiller = true; e.innerHTML = " "; return e; };
        const Fd = t => { const e = t.createElement("br"); e.dataset.ckeFiller = true; return e; };
        const Od = 7;
        const zd = "⁠".repeat(Od);
        function Nd(t) { return Bd(t) && t.data.substr(0, Od) === zd; }
        function Md(t) { return t.data.length == Od && Nd(t); }
        function Vd(t) { if (Nd(t)) {
            return t.data.slice(Od);
        }
        else {
            return t.data;
        } }
        function Ld(t) { t.document.on("arrowKey", qd, { priority: "low" }); }
        function qd(t, e) { if (e.keyCode == td.arrowleft) {
            const t = e.domTarget.ownerDocument.defaultView.getSelection();
            if (t.rangeCount == 1 && t.getRangeAt(0).collapsed) {
                const e = t.getRangeAt(0).startContainer;
                const n = t.getRangeAt(0).startOffset;
                if (Nd(e) && n <= Od) {
                    t.collapse(e, 0);
                }
            }
        } }
        function Kd(t, e, n, o = false) { n = n || function (t, e) { return t === e; }; if (!Array.isArray(t)) {
            t = Array.prototype.slice.call(t);
        } if (!Array.isArray(e)) {
            e = Array.prototype.slice.call(e);
        } const i = jd(t, e, n); return o ? Gd(i, e.length) : $d(e, i); }
        function jd(t, e, n) { const o = Hd(t, e, n); if (o === -1) {
            return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
        } const i = Wd(t, o); const r = Wd(e, o); const s = Hd(i, r, n); const a = t.length - s; const c = e.length - s; return { firstIndex: o, lastIndexOld: a, lastIndexNew: c }; }
        function Hd(t, e, n) { for (let o = 0; o < Math.max(t.length, e.length); o++) {
            if (t[o] === undefined || e[o] === undefined || !n(t[o], e[o])) {
                return o;
            }
        } return -1; }
        function Wd(t, e) { return t.slice(e).reverse(); }
        function $d(t, e) { const n = []; const { firstIndex: o, lastIndexOld: i, lastIndexNew: r } = e; if (r - o > 0) {
            n.push({ index: o, type: "insert", values: t.slice(o, r) });
        } if (i - o > 0) {
            n.push({ index: o + (r - o), type: "delete", howMany: i - o });
        } return n; }
        function Gd(t, e) { const { firstIndex: n, lastIndexOld: o, lastIndexNew: i } = t; if (n === -1) {
            return Array(e).fill("equal");
        } let r = []; if (n > 0) {
            r = r.concat(Array(n).fill("equal"));
        } if (i - n > 0) {
            r = r.concat(Array(i - n).fill("insert"));
        } if (o - n > 0) {
            r = r.concat(Array(o - n).fill("delete"));
        } if (i < e) {
            r = r.concat(Array(e - i).fill("equal"));
        } return r; }
        function Ud(t, e, n) { n = n || function (t, e) { return t === e; }; const o = t.length; const i = e.length; if (o > 200 || i > 200 || o + i > 300) {
            return Ud.fastDiff(t, e, n, true);
        } let r, s; if (i < o) {
            const n = t;
            t = e;
            e = n;
            r = "delete";
            s = "insert";
        }
        else {
            r = "insert";
            s = "delete";
        } const a = t.length; const c = e.length; const l = c - a; const d = {}; const u = {}; function h(o) { const i = (u[o - 1] !== undefined ? u[o - 1] : -1) + 1; const l = u[o + 1] !== undefined ? u[o + 1] : -1; const h = i > l ? -1 : 1; if (d[o + h]) {
            d[o] = d[o + h].slice(0);
        } if (!d[o]) {
            d[o] = [];
        } d[o].push(i > l ? r : s); let f = Math.max(i, l); let p = f - o; while (p < a && f < c && n(t[p], e[f])) {
            p++;
            f++;
            d[o].push("equal");
        } return f; } let f = 0; let p; do {
            for (p = -f; p < l; p++) {
                u[p] = h(p);
            }
            for (p = l + f; p > l; p--) {
                u[p] = h(p);
            }
            u[l] = h(l);
            f++;
        } while (u[l] !== c); return d[l].slice(1); }
        Ud.fastDiff = Kd;
        function Jd(t, e, n) { t.insertBefore(n, t.childNodes[e] || null); }
        function Yd(t) { const e = t.parentNode; if (e) {
            e.removeChild(t);
        } }
        function Qd(t) { if (t) {
            if (t.defaultView) {
                return t instanceof t.defaultView.Document;
            }
            else if (t.ownerDocument && t.ownerDocument.defaultView) {
                return t instanceof t.ownerDocument.defaultView.Node;
            }
        } return false; }
        class Xd {
            constructor(t, e) { this.domDocuments = new Set; this.domConverter = t; this.markedAttributes = new Set; this.markedChildren = new Set; this.markedTexts = new Set; this.selection = e; this.isFocused = false; this._inlineFiller = null; this._fakeSelectionContainer = null; }
            markToSync(t, e) { if (t === "text") {
                if (this.domConverter.mapViewToDom(e.parent)) {
                    this.markedTexts.add(e);
                }
            }
            else {
                if (!this.domConverter.mapViewToDom(e)) {
                    return;
                }
                if (t === "attributes") {
                    this.markedAttributes.add(e);
                }
                else if (t === "children") {
                    this.markedChildren.add(e);
                }
                else {
                    throw new u["a"]("view-renderer-unknown-type", this);
                }
            } }
            render() { let t; for (const t of this.markedChildren) {
                this._updateChildrenMappings(t);
            } if (this._inlineFiller && !this._isSelectionInInlineFiller()) {
                this._removeInlineFiller();
            } if (this._inlineFiller) {
                t = this._getInlineFillerPosition();
            }
            else if (this._needsInlineFillerAtSelection()) {
                t = this.selection.getFirstPosition();
                this.markedChildren.add(t.parent);
            } for (const t of this.markedAttributes) {
                this._updateAttrs(t);
            } for (const e of this.markedChildren) {
                this._updateChildren(e, { inlineFillerPosition: t });
            } for (const e of this.markedTexts) {
                if (!this.markedChildren.has(e.parent) && this.domConverter.mapViewToDom(e.parent)) {
                    this._updateText(e, { inlineFillerPosition: t });
                }
            } if (t) {
                const e = this.domConverter.viewPositionToDom(t);
                const n = e.parent.ownerDocument;
                if (!Nd(e.parent)) {
                    this._inlineFiller = tu(n, e.parent, e.offset);
                }
                else {
                    this._inlineFiller = e.parent;
                }
            }
            else {
                this._inlineFiller = null;
            } this._updateFocus(); this._updateSelection(); this.markedTexts.clear(); this.markedAttributes.clear(); this.markedChildren.clear(); }
            _updateChildrenMappings(t) { const e = this.domConverter.mapViewToDom(t); if (!e) {
                return;
            } const n = this.domConverter.mapViewToDom(t).childNodes; const o = Array.from(this.domConverter.viewChildrenToDom(t, e.ownerDocument, { withChildren: false })); const i = this._diffNodeLists(n, o); const r = this._findReplaceActions(i, n, o); if (r.indexOf("replace") !== -1) {
                const e = { equal: 0, insert: 0, delete: 0 };
                for (const i of r) {
                    if (i === "replace") {
                        const i = e.equal + e.insert;
                        const r = e.equal + e.delete;
                        const s = t.getChild(i);
                        if (s && !(s.is("uiElement") || s.is("rawElement"))) {
                            this._updateElementMappings(s, n[r]);
                        }
                        Yd(o[i]);
                        e.equal++;
                    }
                    else {
                        e[i]++;
                    }
                }
            } }
            _updateElementMappings(t, e) { this.domConverter.unbindDomElement(e); this.domConverter.bindElements(e, t); this.markedChildren.add(t); this.markedAttributes.add(t); }
            _getInlineFillerPosition() { const t = this.selection.getFirstPosition(); if (t.parent.is("$text")) {
                return vl._createBefore(this.selection.getFirstPosition().parent);
            }
            else {
                return t;
            } }
            _isSelectionInInlineFiller() { if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
                return false;
            } const t = this.selection.getFirstPosition(); const e = this.domConverter.viewPositionToDom(t); if (e && Bd(e.parent) && Nd(e.parent)) {
                return true;
            } return false; }
            _removeInlineFiller() { const t = this._inlineFiller; if (!Nd(t)) {
                throw new u["a"]("view-renderer-filler-was-lost", this);
            } if (Md(t)) {
                t.parentNode.removeChild(t);
            }
            else {
                t.data = t.data.substr(Od);
            } this._inlineFiller = null; }
            _needsInlineFillerAtSelection() { if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
                return false;
            } const t = this.selection.getFirstPosition(); const e = t.parent; const n = t.offset; if (!this.domConverter.mapViewToDom(e.root)) {
                return false;
            } if (!e.is("element")) {
                return false;
            } if (!Zd(e)) {
                return false;
            } if (n === e.getFillerOffset()) {
                return false;
            } const o = t.nodeBefore; const i = t.nodeAfter; if (o instanceof Na || i instanceof Na) {
                return false;
            } return true; }
            _updateText(t, e) { const n = this.domConverter.findCorrespondingDomText(t); const o = this.domConverter.viewToDom(t, n.ownerDocument); const i = n.data; let r = o.data; const s = e.inlineFillerPosition; if (s && s.parent == t.parent && s.offset == t.index) {
                r = zd + r;
            } if (i != r) {
                const t = Kd(i, r);
                for (const e of t) {
                    if (e.type === "insert") {
                        n.insertData(e.index, e.values.join(""));
                    }
                    else {
                        n.deleteData(e.index, e.howMany);
                    }
                }
            } }
            _updateAttrs(t) { const e = this.domConverter.mapViewToDom(t); if (!e) {
                return;
            } const n = Array.from(e.attributes).map((t => t.name)); const o = t.getAttributeKeys(); for (const n of o) {
                e.setAttribute(n, t.getAttribute(n));
            } for (const o of n) {
                if (!t.hasAttribute(o)) {
                    e.removeAttribute(o);
                }
            } }
            _updateChildren(t, e) { const n = this.domConverter.mapViewToDom(t); if (!n) {
                return;
            } const o = e.inlineFillerPosition; const i = this.domConverter.mapViewToDom(t).childNodes; const r = Array.from(this.domConverter.viewChildrenToDom(t, n.ownerDocument, { bind: true, inlineFillerPosition: o })); if (o && o.parent === t) {
                tu(n.ownerDocument, r, o.offset);
            } const s = this._diffNodeLists(i, r); let a = 0; const c = new Set; for (const t of s) {
                if (t === "delete") {
                    c.add(i[a]);
                    Yd(i[a]);
                }
                else if (t === "equal") {
                    a++;
                }
            } a = 0; for (const t of s) {
                if (t === "insert") {
                    Jd(n, a, r[a]);
                    a++;
                }
                else if (t === "equal") {
                    this._markDescendantTextToSync(this.domConverter.domToView(r[a]));
                    a++;
                }
            } for (const t of c) {
                if (!t.parentNode) {
                    this.domConverter.unbindDomElement(t);
                }
            } }
            _diffNodeLists(t, e) { t = iu(t, this._fakeSelectionContainer); return Ud(t, e, nu.bind(null, this.domConverter)); }
            _findReplaceActions(t, e, n) { if (t.indexOf("insert") === -1 || t.indexOf("delete") === -1) {
                return t;
            } let o = []; let i = []; let r = []; const s = { equal: 0, insert: 0, delete: 0 }; for (const a of t) {
                if (a === "insert") {
                    r.push(n[s.equal + s.insert]);
                }
                else if (a === "delete") {
                    i.push(e[s.equal + s.delete]);
                }
                else {
                    o = o.concat(Ud(i, r, eu).map((t => t === "equal" ? "replace" : t)));
                    o.push("equal");
                    i = [];
                    r = [];
                }
                s[a]++;
            } return o.concat(Ud(i, r, eu).map((t => t === "equal" ? "replace" : t))); }
            _markDescendantTextToSync(t) { if (!t) {
                return;
            } if (t.is("$text")) {
                this.markedTexts.add(t);
            }
            else if (t.is("element")) {
                for (const e of t.getChildren()) {
                    this._markDescendantTextToSync(e);
                }
            } }
            _updateSelection() { if (this.selection.rangeCount === 0) {
                this._removeDomSelection();
                this._removeFakeSelection();
                return;
            } const t = this.domConverter.mapViewToDom(this.selection.editableElement); if (!this.isFocused || !t) {
                return;
            } if (this.selection.isFake) {
                this._updateFakeSelection(t);
            }
            else {
                this._removeFakeSelection();
                this._updateDomSelection(t);
            } }
            _updateFakeSelection(t) { const e = t.ownerDocument; if (!this._fakeSelectionContainer) {
                this._fakeSelectionContainer = ru(e);
            } const n = this._fakeSelectionContainer; this.domConverter.bindFakeSelection(n, this.selection); if (!this._fakeSelectionNeedsUpdate(t)) {
                return;
            } if (!n.parentElement || n.parentElement != t) {
                t.appendChild(n);
            } n.textContent = this.selection.fakeSelectionLabel || " "; const o = e.getSelection(); const i = e.createRange(); o.removeAllRanges(); i.selectNodeContents(n); o.addRange(i); }
            _updateDomSelection(t) { const e = t.ownerDocument.defaultView.getSelection(); if (!this._domSelectionNeedsUpdate(e)) {
                return;
            } const n = this.domConverter.viewPositionToDom(this.selection.anchor); const o = this.domConverter.viewPositionToDom(this.selection.focus); e.collapse(n.parent, n.offset); e.extend(o.parent, o.offset); if (Wl.isGecko) {
                ou(o, e);
            } }
            _domSelectionNeedsUpdate(t) { if (!this.domConverter.isDomSelectionCorrect(t)) {
                return true;
            } const e = t && this.domConverter.domSelectionToView(t); if (e && this.selection.isEqual(e)) {
                return false;
            } if (!this.selection.isCollapsed && this.selection.isSimilar(e)) {
                return false;
            } return true; }
            _fakeSelectionNeedsUpdate(t) { const e = this._fakeSelectionContainer; const n = t.ownerDocument.getSelection(); if (!e || e.parentElement !== t) {
                return true;
            } if (n.anchorNode !== e && !e.contains(n.anchorNode)) {
                return true;
            } return e.textContent !== this.selection.fakeSelectionLabel; }
            _removeDomSelection() { for (const t of this.domDocuments) {
                const e = t.getSelection();
                if (e.rangeCount) {
                    const e = t.activeElement;
                    const n = this.domConverter.mapDomToView(e);
                    if (e && n) {
                        t.getSelection().removeAllRanges();
                    }
                }
            } }
            _removeFakeSelection() { const t = this._fakeSelectionContainer; if (t) {
                t.remove();
            } }
            _updateFocus() { if (this.isFocused) {
                const t = this.selection.editableElement;
                if (t) {
                    this.domConverter.focus(t);
                }
            } }
        }
        qn(Xd, Pn);
        function Zd(t) { if (t.getAttribute("contenteditable") == "false") {
            return false;
        } const e = t.findAncestor((t => t.hasAttribute("contenteditable"))); return !e || e.getAttribute("contenteditable") == "true"; }
        function tu(t, e, n) { const o = e instanceof Array ? e : e.childNodes; const i = o[n]; if (Bd(i)) {
            i.data = zd + i.data;
            return i;
        }
        else {
            const i = t.createTextNode(zd);
            if (Array.isArray(e)) {
                o.splice(n, 0, i);
            }
            else {
                Jd(e, n, i);
            }
            return i;
        } }
        function eu(t, e) { return Qd(t) && Qd(e) && !Bd(t) && !Bd(e) && t.nodeType !== Node.COMMENT_NODE && e.nodeType !== Node.COMMENT_NODE && t.tagName.toLowerCase() === e.tagName.toLowerCase(); }
        function nu(t, e, n) { if (e === n) {
            return true;
        }
        else if (Bd(e) && Bd(n)) {
            return e.data === n.data;
        }
        else if (t.isBlockFiller(e) && t.isBlockFiller(n)) {
            return true;
        } return false; }
        function ou(t, e) { const n = t.parent; if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) {
            return;
        } const o = n.childNodes[t.offset]; if (o && o.tagName == "BR") {
            e.addRange(e.getRangeAt(0));
        } }
        function iu(t, e) { const n = Array.from(t); if (n.length == 0 || !e) {
            return n;
        } const o = n[n.length - 1]; if (o == e) {
            n.pop();
        } return n; }
        function ru(t) { const e = t.createElement("div"); e.className = "ck-fake-selection-container"; Object.assign(e.style, { position: "fixed", top: 0, left: "-9999px", width: "42px" }); e.textContent = " "; return e; }
        var su = { window: window, document: document };
        function au(t) { let e = 0; while (t.previousSibling) {
            t = t.previousSibling;
            e++;
        } return e; }
        function cu(t) { const e = []; while (t && t.nodeType != Node.DOCUMENT_NODE) {
            e.unshift(t);
            t = t.parentNode;
        } return e; }
        function lu(t, e) { const n = cu(t); const o = cu(e); let i = 0; while (n[i] == o[i] && n[i]) {
            i++;
        } return i === 0 ? null : n[i - 1]; }
        const du = Fd(document);
        const uu = Id(document);
        const hu = Rd(document);
        class fu {
            constructor(t, e = {}) { this.document = t; this.blockFillerMode = e.blockFillerMode || "br"; this.preElements = ["pre"]; this.blockElements = ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6", "li", "dd", "dt", "figcaption", "td", "th"]; this._domToViewMapping = new WeakMap; this._viewToDomMapping = new WeakMap; this._fakeSelectionMapping = new WeakMap; this._rawContentElementMatcher = new qa; this._encounteredRawContentDomNodes = new WeakSet; }
            bindFakeSelection(t, e) { this._fakeSelectionMapping.set(t, new xl(e)); }
            fakeSelectionToView(t) { return this._fakeSelectionMapping.get(t); }
            bindElements(t, e) { this._domToViewMapping.set(t, e); this._viewToDomMapping.set(e, t); }
            unbindDomElement(t) { const e = this._domToViewMapping.get(t); if (e) {
                this._domToViewMapping.delete(t);
                this._viewToDomMapping.delete(e);
                for (const e of t.childNodes) {
                    this.unbindDomElement(e);
                }
            } }
            bindDocumentFragments(t, e) { this._domToViewMapping.set(t, e); this._viewToDomMapping.set(e, t); }
            viewToDom(t, e, n = {}) { if (t.is("$text")) {
                const n = this._processDataFromViewText(t);
                return e.createTextNode(n);
            }
            else {
                if (this.mapViewToDom(t)) {
                    return this.mapViewToDom(t);
                }
                let o;
                if (t.is("documentFragment")) {
                    o = e.createDocumentFragment();
                    if (n.bind) {
                        this.bindDocumentFragments(o, t);
                    }
                }
                else if (t.is("uiElement")) {
                    o = t.render(e);
                    if (n.bind) {
                        this.bindElements(o, t);
                    }
                    return o;
                }
                else {
                    if (t.hasAttribute("xmlns")) {
                        o = e.createElementNS(t.getAttribute("xmlns"), t.name);
                    }
                    else {
                        o = e.createElement(t.name);
                    }
                    if (t.is("rawElement")) {
                        t.render(o);
                    }
                    if (n.bind) {
                        this.bindElements(o, t);
                    }
                    for (const e of t.getAttributeKeys()) {
                        o.setAttribute(e, t.getAttribute(e));
                    }
                }
                if (n.withChildren !== false) {
                    for (const i of this.viewChildrenToDom(t, e, n)) {
                        o.appendChild(i);
                    }
                }
                return o;
            } }
            *viewChildrenToDom(t, e, n = {}) { const o = t.getFillerOffset && t.getFillerOffset(); let i = 0; for (const r of t.getChildren()) {
                if (o === i) {
                    yield this._getBlockFiller(e);
                }
                yield this.viewToDom(r, e, n);
                i++;
            } if (o === i) {
                yield this._getBlockFiller(e);
            } }
            viewRangeToDom(t) { const e = this.viewPositionToDom(t.start); const n = this.viewPositionToDom(t.end); const o = document.createRange(); o.setStart(e.parent, e.offset); o.setEnd(n.parent, n.offset); return o; }
            viewPositionToDom(t) { const e = t.parent; if (e.is("$text")) {
                const n = this.findCorrespondingDomText(e);
                if (!n) {
                    return null;
                }
                let o = t.offset;
                if (Nd(n)) {
                    o += Od;
                }
                return { parent: n, offset: o };
            }
            else {
                let n, o, i;
                if (t.offset === 0) {
                    n = this.mapViewToDom(e);
                    if (!n) {
                        return null;
                    }
                    i = n.childNodes[0];
                }
                else {
                    const e = t.nodeBefore;
                    o = e.is("$text") ? this.findCorrespondingDomText(e) : this.mapViewToDom(t.nodeBefore);
                    if (!o) {
                        return null;
                    }
                    n = o.parentNode;
                    i = o.nextSibling;
                }
                if (Bd(i) && Nd(i)) {
                    return { parent: i, offset: Od };
                }
                const r = o ? au(o) + 1 : 0;
                return { parent: n, offset: r };
            } }
            domToView(t, e = {}) { if (this.isBlockFiller(t)) {
                return null;
            } const n = this.getHostViewElement(t); if (n) {
                return n;
            } if (Bd(t)) {
                if (Md(t)) {
                    return null;
                }
                else {
                    const e = this._processDataFromDomText(t);
                    return e === "" ? null : new Na(this.document, e);
                }
            }
            else if (this.isComment(t)) {
                return null;
            }
            else {
                if (this.mapDomToView(t)) {
                    return this.mapDomToView(t);
                }
                let n;
                if (this.isDocumentFragment(t)) {
                    n = new kd(this.document);
                    if (e.bind) {
                        this.bindDocumentFragments(t, n);
                    }
                }
                else {
                    const o = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
                    n = new ul(this.document, o);
                    if (e.bind) {
                        this.bindElements(t, n);
                    }
                    const i = t.attributes;
                    for (let t = i.length - 1; t >= 0; t--) {
                        n._setAttribute(i[t].name, i[t].value);
                    }
                    if (e.withChildren !== false && this._rawContentElementMatcher.match(n)) {
                        n._setCustomProperty("$rawContent", t.innerHTML);
                        this._encounteredRawContentDomNodes.add(t);
                        return n;
                    }
                }
                if (e.withChildren !== false) {
                    for (const o of this.domChildrenToView(t, e)) {
                        n._appendChild(o);
                    }
                }
                return n;
            } }
            *domChildrenToView(t, e = {}) { for (let n = 0; n < t.childNodes.length; n++) {
                const o = t.childNodes[n];
                const i = this.domToView(o, e);
                if (i !== null) {
                    yield i;
                }
            } }
            domSelectionToView(t) { if (t.rangeCount === 1) {
                let e = t.getRangeAt(0).startContainer;
                if (Bd(e)) {
                    e = e.parentNode;
                }
                const n = this.fakeSelectionToView(e);
                if (n) {
                    return n;
                }
            } const e = this.isDomSelectionBackward(t); const n = []; for (let e = 0; e < t.rangeCount; e++) {
                const o = t.getRangeAt(e);
                const i = this.domRangeToView(o);
                if (i) {
                    n.push(i);
                }
            } return new xl(n, { backward: e }); }
            domRangeToView(t) { const e = this.domPositionToView(t.startContainer, t.startOffset); const n = this.domPositionToView(t.endContainer, t.endOffset); if (e && n) {
                return new Al(e, n);
            } return null; }
            domPositionToView(t, e) { if (this.isBlockFiller(t)) {
                return this.domPositionToView(t.parentNode, au(t));
            } const n = this.mapDomToView(t); if (n && (n.is("uiElement") || n.is("rawElement"))) {
                return vl._createBefore(n);
            } if (Bd(t)) {
                if (Md(t)) {
                    return this.domPositionToView(t.parentNode, au(t));
                }
                const n = this.findCorrespondingViewText(t);
                let o = e;
                if (!n) {
                    return null;
                }
                if (Nd(t)) {
                    o -= Od;
                    o = o < 0 ? 0 : o;
                }
                return new vl(n, o);
            }
            else {
                if (e === 0) {
                    const e = this.mapDomToView(t);
                    if (e) {
                        return new vl(e, 0);
                    }
                }
                else {
                    const n = t.childNodes[e - 1];
                    const o = Bd(n) ? this.findCorrespondingViewText(n) : this.mapDomToView(n);
                    if (o && o.parent) {
                        return new vl(o.parent, o.index + 1);
                    }
                }
                return null;
            } }
            mapDomToView(t) { const e = this.getHostViewElement(t); return e || this._domToViewMapping.get(t); }
            findCorrespondingViewText(t) { if (Md(t)) {
                return null;
            } const e = this.getHostViewElement(t); if (e) {
                return e;
            } const n = t.previousSibling; if (n) {
                if (!this.isElement(n)) {
                    return null;
                }
                const t = this.mapDomToView(n);
                if (t) {
                    const e = t.nextSibling;
                    if (e instanceof Na) {
                        return t.nextSibling;
                    }
                    else {
                        return null;
                    }
                }
            }
            else {
                const e = this.mapDomToView(t.parentNode);
                if (e) {
                    const t = e.getChild(0);
                    if (t instanceof Na) {
                        return t;
                    }
                    else {
                        return null;
                    }
                }
            } return null; }
            mapViewToDom(t) { return this._viewToDomMapping.get(t); }
            findCorrespondingDomText(t) { const e = t.previousSibling; if (e && this.mapViewToDom(e)) {
                return this.mapViewToDom(e).nextSibling;
            } if (!e && t.parent && this.mapViewToDom(t.parent)) {
                return this.mapViewToDom(t.parent).childNodes[0];
            } return null; }
            focus(t) { const e = this.mapViewToDom(t); if (e && e.ownerDocument.activeElement !== e) {
                const { scrollX: t, scrollY: n } = su.window;
                const o = [];
                gu(e, (t => { const { scrollLeft: e, scrollTop: n } = t; o.push([e, n]); }));
                e.focus();
                gu(e, (t => { const [e, n] = o.shift(); t.scrollLeft = e; t.scrollTop = n; }));
                su.window.scrollTo(t, n);
            } }
            isElement(t) { return t && t.nodeType == Node.ELEMENT_NODE; }
            isDocumentFragment(t) { return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE; }
            isComment(t) { return t && t.nodeType == Node.COMMENT_NODE; }
            isBlockFiller(t) { if (this.blockFillerMode == "br") {
                return t.isEqualNode(du);
            } if (t.tagName === "BR" && ku(t, this.blockElements) && t.parentNode.childNodes.length === 1) {
                return true;
            } return t.isEqualNode(hu) || mu(t, this.blockElements); }
            isDomSelectionBackward(t) { if (t.isCollapsed) {
                return false;
            } const e = document.createRange(); e.setStart(t.anchorNode, t.anchorOffset); e.setEnd(t.focusNode, t.focusOffset); const n = e.collapsed; e.detach(); return n; }
            getHostViewElement(t) { const e = cu(t); e.pop(); while (e.length) {
                const t = e.pop();
                const n = this._domToViewMapping.get(t);
                if (n && (n.is("uiElement") || n.is("rawElement"))) {
                    return n;
                }
            } return null; }
            isDomSelectionCorrect(t) { return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset); }
            registerRawContentMatcher(t) { this._rawContentElementMatcher.add(t); }
            _getBlockFiller(t) { switch (this.blockFillerMode) {
                case "nbsp": return Id(t);
                case "markedNbsp": return Rd(t);
                case "br": return Fd(t);
            } }
            _isDomSelectionPositionCorrect(t, e) { if (Bd(t) && Nd(t) && e < Od) {
                return false;
            } if (this.isElement(t) && Nd(t.childNodes[e])) {
                return false;
            } const n = this.mapDomToView(t); if (n && (n.is("uiElement") || n.is("rawElement"))) {
                return false;
            } return true; }
            _processDataFromViewText(t) { let e = t.data; if (t.getAncestors().some((t => this.preElements.includes(t.name)))) {
                return e;
            } if (e.charAt(0) == " ") {
                const n = this._getTouchingViewTextNode(t, false);
                const o = n && this._nodeEndsWithSpace(n);
                if (o || !n) {
                    e = " " + e.substr(1);
                }
            } if (e.charAt(e.length - 1) == " ") {
                const n = this._getTouchingViewTextNode(t, true);
                if (e.charAt(e.length - 2) == " " || !n || n.data.charAt(0) == " ") {
                    e = e.substr(0, e.length - 1) + " ";
                }
            } return e.replace(/ {2}/g, "  "); }
            _nodeEndsWithSpace(t) { if (t.getAncestors().some((t => this.preElements.includes(t.name)))) {
                return false;
            } const e = this._processDataFromViewText(t); return e.charAt(e.length - 1) == " "; }
            _processDataFromDomText(t) { let e = t.data; if (pu(t, this.preElements)) {
                return Vd(t);
            } e = e.replace(/[ \n\t\r]{1,}/g, " "); const n = this._getTouchingInlineDomNode(t, false); const o = this._getTouchingInlineDomNode(t, true); const i = this._checkShouldLeftTrimDomText(t, n); const r = this._checkShouldRightTrimDomText(t, o); if (i) {
                e = e.replace(/^ /, "");
            } if (r) {
                e = e.replace(/ $/, "");
            } e = Vd(new Text(e)); e = e.replace(/ \u00A0/g, "  "); if (/( |\u00A0)\u00A0$/.test(e) || !o || o.data && o.data.charAt(0) == " ") {
                e = e.replace(/\u00A0$/, " ");
            } if (i) {
                e = e.replace(/^\u00A0/, " ");
            } return e; }
            _checkShouldLeftTrimDomText(t, e) { if (!e) {
                return true;
            } if (fa(e)) {
                return true;
            } if (this._encounteredRawContentDomNodes.has(t.previousSibling)) {
                return false;
            } return /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1)); }
            _checkShouldRightTrimDomText(t, e) { if (e) {
                return false;
            } return !Nd(t); }
            _getTouchingViewTextNode(t, e) { const n = new _l({ startPosition: e ? vl._createAfter(t) : vl._createBefore(t), direction: e ? "forward" : "backward" }); for (const t of n) {
                if (t.item.is("containerElement")) {
                    return null;
                }
                else if (t.item.is("element", "br")) {
                    return null;
                }
                else if (t.item.is("$textProxy")) {
                    return t.item;
                }
            } return null; }
            _getTouchingInlineDomNode(t, e) { if (!t.parentNode) {
                return null;
            } const n = e ? "nextNode" : "previousNode"; const o = t.ownerDocument; const i = cu(t)[0]; const r = o.createTreeWalker(i, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, { acceptNode(t) { if (Bd(t)) {
                    return NodeFilter.FILTER_ACCEPT;
                } if (t.tagName == "BR") {
                    return NodeFilter.FILTER_ACCEPT;
                } return NodeFilter.FILTER_SKIP; } }); r.currentNode = t; const s = r[n](); if (s !== null) {
                const e = lu(t, s);
                if (e && !pu(t, this.blockElements, e) && !pu(s, this.blockElements, e)) {
                    return s;
                }
            } return null; }
        }
        function pu(t, e, n) { let o = cu(t); if (n) {
            o = o.slice(o.indexOf(n) + 1);
        } return o.some((t => t.tagName && e.includes(t.tagName.toLowerCase()))); }
        function gu(t, e) { while (t && t != su.document) {
            e(t);
            t = t.parentNode;
        } }
        function mu(t, e) { const n = t.isEqualNode(uu); return n && ku(t, e) && t.parentNode.childNodes.length === 1; }
        function ku(t, e) { const n = t.parentNode; return n && n.tagName && e.includes(n.tagName.toLowerCase()); }
        function bu(t) { const e = Object.prototype.toString.apply(t); if (e == "[object Window]") {
            return true;
        } if (e == "[object global]") {
            return true;
        } return false; }
        const wu = Cn({}, g, { listenTo(t, ...e) { if (Qd(t) || bu(t)) {
                const n = this._getProxyEmitter(t) || new vu(t);
                n.attach(...e);
                t = n;
            } g.listenTo.call(this, t, ...e); }, stopListening(t, e, n) { if (Qd(t) || bu(t)) {
                const e = this._getProxyEmitter(t);
                if (!e) {
                    return;
                }
                t = e;
            } g.stopListening.call(this, t, e, n); if (t instanceof vu) {
                t.detach(e);
            } }, _getProxyEmitter(t) { return m(this, Au(t)); } });
        var _u = wu;
        class vu {
            constructor(t) { k(this, Au(t)); this._domNode = t; }
        }
        Cn(vu.prototype, g, { attach(t, e, n = {}) { if (this._domListeners && this._domListeners[t]) {
                return;
            } const o = { capture: !!n.useCapture, passive: !!n.usePassive }; const i = this._createDomListener(t, o); this._domNode.addEventListener(t, i, o); if (!this._domListeners) {
                this._domListeners = {};
            } this._domListeners[t] = i; }, detach(t) { let e; if (this._domListeners[t] && (!(e = this._events[t]) || !e.callbacks.length)) {
                this._domListeners[t].removeListener();
            } }, _createDomListener(t, e) { const n = e => { this.fire(t, e); }; n.removeListener = () => { this._domNode.removeEventListener(t, n, e); delete this._domListeners[t]; }; return n; } });
        function Au(t) { return t["data-ck-expando"] || (t["data-ck-expando"] = a()); }
        class Cu {
            constructor(t) { this.view = t; this.document = t.document; this.isEnabled = false; }
            enable() { this.isEnabled = true; }
            disable() { this.isEnabled = false; }
            destroy() { this.disable(); this.stopListening(); }
            checkShouldIgnoreEventFromTarget(t) { if (t && t.nodeType === 3) {
                t = t.parentNode;
            } if (!t || t.nodeType !== 1) {
                return false;
            } return t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *"); }
        }
        qn(Cu, _u);
        var yu = "__lodash_hash_undefined__";
        function xu(t) { this.__data__.set(t, yu); return this; }
        var Eu = xu;
        function Du(t) { return this.__data__.has(t); }
        var Su = Du;
        function Tu(t) { var e = -1, n = t == null ? 0 : t.length; this.__data__ = new fi; while (++e < n) {
            this.add(t[e]);
        } }
        Tu.prototype.add = Tu.prototype.push = Eu;
        Tu.prototype.has = Su;
        var Pu = Tu;
        function Bu(t, e) { var n = -1, o = t == null ? 0 : t.length; while (++n < o) {
            if (e(t[n], n, t)) {
                return true;
            }
        } return false; }
        var Iu = Bu;
        function Ru(t, e) { return t.has(e); }
        var Fu = Ru;
        var Ou = 1, zu = 2;
        function Nu(t, e, n, o, i, r) { var s = n & Ou, a = t.length, c = e.length; if (a != c && !(s && c > a)) {
            return false;
        } var l = r.get(t); var d = r.get(e); if (l && d) {
            return l == e && d == t;
        } var u = -1, h = true, f = n & zu ? new Pu : undefined; r.set(t, e); r.set(e, t); while (++u < a) {
            var p = t[u], g = e[u];
            if (o) {
                var m = s ? o(g, p, u, e, t, r) : o(p, g, u, t, e, r);
            }
            if (m !== undefined) {
                if (m) {
                    continue;
                }
                h = false;
                break;
            }
            if (f) {
                if (!Iu(e, (function (t, e) { if (!Fu(f, e) && (p === t || i(p, t, n, o, r))) {
                    return f.push(e);
                } }))) {
                    h = false;
                    break;
                }
            }
            else if (!(p === g || i(p, g, n, o, r))) {
                h = false;
                break;
            }
        } r["delete"](t); r["delete"](e); return h; }
        var Mu = Nu;
        function Vu(t) { var e = -1, n = Array(t.size); t.forEach((function (t, o) { n[++e] = [o, t]; })); return n; }
        var Lu = Vu;
        function qu(t) { var e = -1, n = Array(t.size); t.forEach((function (t) { n[++e] = t; })); return n; }
        var Ku = qu;
        var ju = 1, Hu = 2;
        var Wu = "[object Boolean]", $u = "[object Date]", Gu = "[object Error]", Uu = "[object Map]", Ju = "[object Number]", Yu = "[object RegExp]", Qu = "[object Set]", Xu = "[object String]", Zu = "[object Symbol]";
        var th = "[object ArrayBuffer]", eh = "[object DataView]";
        var nh = B ? B.prototype : undefined, oh = nh ? nh.valueOf : undefined;
        function ih(t, e, n, o, i, r, s) { switch (n) {
            case eh:
                if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) {
                    return false;
                }
                t = t.buffer;
                e = e.buffer;
            case th:
                if (t.byteLength != e.byteLength || !r(new Ir(t), new Ir(e))) {
                    return false;
                }
                return true;
            case Wu:
            case $u:
            case Ju: return Et(+t, +e);
            case Gu: return t.name == e.name && t.message == e.message;
            case Yu:
            case Xu: return t == e + "";
            case Uu: var a = Lu;
            case Qu:
                var c = o & ju;
                a || (a = Ku);
                if (t.size != e.size && !c) {
                    return false;
                }
                var l = s.get(t);
                if (l) {
                    return l == e;
                }
                o |= Hu;
                s.set(t, e);
                var d = Mu(a(t), a(e), o, i, r, s);
                s["delete"](t);
                return d;
            case Zu: if (oh) {
                return oh.call(t) == oh.call(e);
            }
        } return false; }
        var rh = ih;
        var sh = 1;
        var ah = Object.prototype;
        var ch = ah.hasOwnProperty;
        function lh(t, e, n, o, i, r) { var s = n & sh, a = or(t), c = a.length, l = or(e), d = l.length; if (c != d && !s) {
            return false;
        } var u = c; while (u--) {
            var h = a[u];
            if (!(s ? h in e : ch.call(e, h))) {
                return false;
            }
        } var f = r.get(t); var p = r.get(e); if (f && p) {
            return f == e && p == t;
        } var g = true; r.set(t, e); r.set(e, t); var m = s; while (++u < c) {
            h = a[u];
            var k = t[h], b = e[h];
            if (o) {
                var w = s ? o(b, k, h, e, t, r) : o(k, b, h, t, e, r);
            }
            if (!(w === undefined ? k === b || i(k, b, n, o, r) : w)) {
                g = false;
                break;
            }
            m || (m = h == "constructor");
        } if (g && !m) {
            var _ = t.constructor, v = e.constructor;
            if (_ != v && ("constructor" in t && "constructor" in e) && !(typeof _ == "function" && _ instanceof _ && typeof v == "function" && v instanceof v)) {
                g = false;
            }
        } r["delete"](t); r["delete"](e); return g; }
        var dh = lh;
        var uh = 1;
        var hh = "[object Arguments]", fh = "[object Array]", ph = "[object Object]";
        var gh = Object.prototype;
        var mh = gh.hasOwnProperty;
        function kh(t, e, n, o, i, r) { var s = xe(t), a = xe(e), c = s ? fh : Er(t), l = a ? fh : Er(e); c = c == hh ? ph : c; l = l == hh ? ph : l; var d = c == ph, u = l == ph, h = c == l; if (h && Object(Ee["a"])(t)) {
            if (!Object(Ee["a"])(e)) {
                return false;
            }
            s = true;
            d = false;
        } if (h && !d) {
            r || (r = new bi);
            return s || sn(t) ? Mu(t, e, n, o, i, r) : rh(t, e, c, n, o, i, r);
        } if (!(n & uh)) {
            var f = d && mh.call(t, "__wrapped__"), p = u && mh.call(e, "__wrapped__");
            if (f || p) {
                var g = f ? t.value() : t, m = p ? e.value() : e;
                r || (r = new bi);
                return i(g, m, n, o, r);
            }
        } if (!h) {
            return false;
        } r || (r = new bi); return dh(t, e, n, o, i, r); }
        var bh = kh;
        function wh(t, e, n, o, i) { if (t === e) {
            return true;
        } if (t == null || e == null || !ge(t) && !ge(e)) {
            return t !== t && e !== e;
        } return bh(t, e, n, o, wh, i); }
        var _h = wh;
        function vh(t, e, n) { n = typeof n == "function" ? n : undefined; var o = n ? n(t, e) : undefined; return o === undefined ? _h(t, e, undefined, n) : !!o; }
        var Ah = vh;
        class Ch extends Cu {
            constructor(t) { super(t); this._config = { childList: true, characterData: true, characterDataOldValue: true, subtree: true }; this.domConverter = t.domConverter; this.renderer = t._renderer; this._domElements = []; this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this)); }
            flush() { this._onMutations(this._mutationObserver.takeRecords()); }
            observe(t) { this._domElements.push(t); if (this.isEnabled) {
                this._mutationObserver.observe(t, this._config);
            } }
            enable() { super.enable(); for (const t of this._domElements) {
                this._mutationObserver.observe(t, this._config);
            } }
            disable() { super.disable(); this._mutationObserver.disconnect(); }
            destroy() { super.destroy(); this._mutationObserver.disconnect(); }
            _onMutations(t) { if (t.length === 0) {
                return;
            } const e = this.domConverter; const n = new Map; const o = new Set; for (const n of t) {
                if (n.type === "childList") {
                    const t = e.mapDomToView(n.target);
                    if (t && (t.is("uiElement") || t.is("rawElement"))) {
                        continue;
                    }
                    if (t && !this._isBogusBrMutation(n)) {
                        o.add(t);
                    }
                }
            } for (const i of t) {
                const t = e.mapDomToView(i.target);
                if (t && (t.is("uiElement") || t.is("rawElement"))) {
                    continue;
                }
                if (i.type === "characterData") {
                    const t = e.findCorrespondingViewText(i.target);
                    if (t && !o.has(t.parent)) {
                        n.set(t, { type: "text", oldText: t.data, newText: Vd(i.target), node: t });
                    }
                    else if (!t && Nd(i.target)) {
                        o.add(e.mapDomToView(i.target.parentNode));
                    }
                }
            } const i = []; for (const t of n.values()) {
                this.renderer.markToSync("text", t.node);
                i.push(t);
            } for (const t of o) {
                const n = e.mapViewToDom(t);
                const o = Array.from(t.getChildren());
                const r = Array.from(e.domChildrenToView(n, { withChildren: false }));
                if (!Ah(o, r, a)) {
                    this.renderer.markToSync("children", t);
                    i.push({ type: "children", oldChildren: o, newChildren: r, node: t });
                }
            } const r = t[0].target.ownerDocument.getSelection(); let s = null; if (r && r.anchorNode) {
                const t = e.domPositionToView(r.anchorNode, r.anchorOffset);
                const n = e.domPositionToView(r.focusNode, r.focusOffset);
                if (t && n) {
                    s = new xl(t);
                    s.setFocus(n);
                }
            } if (i.length) {
                this.document.fire("mutations", i, s);
                this.view.forceRender();
            } function a(t, e) { if (Array.isArray(t)) {
                return;
            } if (t === e) {
                return true;
            }
            else if (t.is("$text") && e.is("$text")) {
                return t.data === e.data;
            } return false; } }
            _isBogusBrMutation(t) { let e = null; if (t.nextSibling === null && t.removedNodes.length === 0 && t.addedNodes.length == 1) {
                e = this.domConverter.domToView(t.addedNodes[0], { withChildren: false });
            } return e && e.is("element", "br"); }
        }
        class yh {
            constructor(t, e, n) { this.view = t; this.document = t.document; this.domEvent = e; this.domTarget = e.target; Cn(this, n); }
            get target() { return this.view.domConverter.mapDomToView(this.domTarget); }
            preventDefault() { this.domEvent.preventDefault(); }
            stopPropagation() { this.domEvent.stopPropagation(); }
        }
        class xh extends Cu {
            constructor(t) { super(t); this.useCapture = false; }
            observe(t) { const e = typeof this.domEventType == "string" ? [this.domEventType] : this.domEventType; e.forEach((e => { this.listenTo(t, e, ((t, e) => { if (this.isEnabled && !this.checkShouldIgnoreEventFromTarget(e.target)) {
                this.onDomEvent(e);
            } }), { useCapture: this.useCapture }); })); }
            fire(t, e, n) { if (this.isEnabled) {
                this.document.fire(t, new yh(this.view, e, n));
            } }
        }
        class Eh extends xh {
            constructor(t) { super(t); this.domEventType = ["keydown", "keyup"]; }
            onDomEvent(t) { this.fire(t.type, t, { keyCode: t.keyCode, altKey: t.altKey, ctrlKey: t.ctrlKey, shiftKey: t.shiftKey, metaKey: t.metaKey, get keystroke() { return nd(this); } }); }
        }
        var Dh = function () { return T["a"].Date.now(); };
        var Sh = Dh;
        var Th = /\s/;
        function Ph(t) { var e = t.length; while (e-- && Th.test(t.charAt(e))) { } return e; }
        var Bh = Ph;
        var Ih = /^\s+/;
        function Rh(t) { return t ? t.slice(0, Bh(t) + 1).replace(Ih, "") : t; }
        var Fh = Rh;
        var Oh = 0 / 0;
        var zh = /^[-+]0x[0-9a-f]+$/i;
        var Nh = /^0b[01]+$/i;
        var Mh = /^0o[0-7]+$/i;
        var Vh = parseInt;
        function Lh(t) { if (typeof t == "number") {
            return t;
        } if (Ja(t)) {
            return Oh;
        } if (S(t)) {
            var e = typeof t.valueOf == "function" ? t.valueOf() : t;
            t = S(e) ? e + "" : e;
        } if (typeof t != "string") {
            return t === 0 ? t : +t;
        } t = Fh(t); var n = Nh.test(t); return n || Mh.test(t) ? Vh(t.slice(2), n ? 2 : 8) : zh.test(t) ? Oh : +t; }
        var qh = Lh;
        var Kh = "Expected a function";
        var jh = Math.max, Hh = Math.min;
        function Wh(t, e, n) { var o, i, r, s, a, c, l = 0, d = false, u = false, h = true; if (typeof t != "function") {
            throw new TypeError(Kh);
        } e = qh(e) || 0; if (S(n)) {
            d = !!n.leading;
            u = "maxWait" in n;
            r = u ? jh(qh(n.maxWait) || 0, e) : r;
            h = "trailing" in n ? !!n.trailing : h;
        } function f(e) { var n = o, r = i; o = i = undefined; l = e; s = t.apply(r, n); return s; } function p(t) { l = t; a = setTimeout(k, e); return d ? f(t) : s; } function g(t) { var n = t - c, o = t - l, i = e - n; return u ? Hh(i, r - o) : i; } function m(t) { var n = t - c, o = t - l; return c === undefined || n >= e || n < 0 || u && o >= r; } function k() { var t = Sh(); if (m(t)) {
            return b(t);
        } a = setTimeout(k, g(t)); } function b(t) { a = undefined; if (h && o) {
            return f(t);
        } o = i = undefined; return s; } function w() { if (a !== undefined) {
            clearTimeout(a);
        } l = 0; o = c = i = a = undefined; } function _() { return a === undefined ? s : b(Sh()); } function v() { var t = Sh(), n = m(t); o = arguments; i = this; c = t; if (n) {
            if (a === undefined) {
                return p(c);
            }
            if (u) {
                clearTimeout(a);
                a = setTimeout(k, e);
                return f(c);
            }
        } if (a === undefined) {
            a = setTimeout(k, e);
        } return s; } v.cancel = w; v.flush = _; return v; }
        var $h = Wh;
        class Gh extends Cu {
            constructor(t) { super(t); this._fireSelectionChangeDoneDebounced = $h((t => this.document.fire("selectionChangeDone", t)), 200); }
            observe() { const t = this.document; t.on("arrowKey", ((e, n) => { const o = t.selection; if (o.isFake && this.isEnabled) {
                n.preventDefault();
            } }), { context: "$capture" }); t.on("arrowKey", ((e, n) => { const o = t.selection; if (o.isFake && this.isEnabled) {
                this._handleSelectionMove(n.keyCode);
            } }), { priority: "lowest" }); }
            destroy() { super.destroy(); this._fireSelectionChangeDoneDebounced.cancel(); }
            _handleSelectionMove(t) { const e = this.document.selection; const n = new xl(e.getRanges(), { backward: e.isBackward, fake: false }); if (t == td.arrowleft || t == td.arrowup) {
                n.setTo(n.getFirstPosition());
            } if (t == td.arrowright || t == td.arrowdown) {
                n.setTo(n.getLastPosition());
            } const o = { oldSelection: e, newSelection: n, domSelection: null }; this.document.fire("selectionChange", o); this._fireSelectionChangeDoneDebounced(o); }
        }
        class Uh extends Cu {
            constructor(t) { super(t); this.mutationObserver = t.getObserver(Ch); this.selection = this.document.selection; this.domConverter = t.domConverter; this._documents = new WeakSet; this._fireSelectionChangeDoneDebounced = $h((t => this.document.fire("selectionChangeDone", t)), 200); this._clearInfiniteLoopInterval = setInterval((() => this._clearInfiniteLoop()), 1e3); this._loopbackCounter = 0; }
            observe(t) { const e = t.ownerDocument; if (this._documents.has(e)) {
                return;
            } this.listenTo(e, "selectionchange", ((t, n) => { this._handleSelectionChange(n, e); })); this._documents.add(e); }
            destroy() { super.destroy(); clearInterval(this._clearInfiniteLoopInterval); this._fireSelectionChangeDoneDebounced.cancel(); }
            _handleSelectionChange(t, e) { if (!this.isEnabled) {
                return;
            } const n = e.defaultView.getSelection(); if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) {
                return;
            } this.mutationObserver.flush(); const o = this.domConverter.domSelectionToView(n); if (o.rangeCount == 0) {
                this.view.hasDomSelection = false;
                return;
            } this.view.hasDomSelection = true; if (this.selection.isEqual(o) && this.domConverter.isDomSelectionCorrect(n)) {
                return;
            } if (++this._loopbackCounter > 60) {
                return;
            } if (this.selection.isSimilar(o)) {
                this.view.forceRender();
            }
            else {
                const t = { oldSelection: this.selection, newSelection: o, domSelection: n };
                this.document.fire("selectionChange", t);
                this._fireSelectionChangeDoneDebounced(t);
            } }
            _clearInfiniteLoop() { this._loopbackCounter = 0; }
        }
        class Jh extends xh {
            constructor(t) { super(t); this.domEventType = ["focus", "blur"]; this.useCapture = true; const e = this.document; e.on("focus", (() => { e.isFocused = true; this._renderTimeoutId = setTimeout((() => t.forceRender()), 50); })); e.on("blur", ((n, o) => { const i = e.selection.editableElement; if (i === null || i === o.target) {
                e.isFocused = false;
                t.forceRender();
            } })); }
            onDomEvent(t) { this.fire(t.type, t); }
            destroy() { if (this._renderTimeoutId) {
                clearTimeout(this._renderTimeoutId);
            } super.destroy(); }
        }
        class Yh extends xh {
            constructor(t) { super(t); this.domEventType = ["compositionstart", "compositionupdate", "compositionend"]; const e = this.document; e.on("compositionstart", (() => { e.isComposing = true; })); e.on("compositionend", (() => { e.isComposing = false; })); }
            onDomEvent(t) { this.fire(t.type, t); }
        }
        class Qh extends xh {
            constructor(t) { super(t); this.domEventType = ["beforeinput"]; }
            onDomEvent(t) { this.fire(t.type, t); }
        }
        class Xh {
            constructor() { this._replacedElements = []; }
            replace(t, e) { this._replacedElements.push({ element: t, newElement: e }); t.style.display = "none"; if (e) {
                t.parentNode.insertBefore(e, t.nextSibling);
            } }
            restore() { this._replacedElements.forEach((({ element: t, newElement: e }) => { t.style.display = ""; if (e) {
                e.remove();
            } })); this._replacedElements = []; }
        }
        var Zh = "[object String]";
        function tf(t) { return typeof t == "string" || !xe(t) && ge(t) && $(t) == Zh; }
        var ef = tf;
        function nf(t, e, n = {}, o = []) { const i = n && n.xmlns; const r = i ? t.createElementNS(i, e) : t.createElement(e); for (const t in n) {
            r.setAttribute(t, n[t]);
        } if (ef(o) || !ka(o)) {
            o = [o];
        } for (let e of o) {
            if (ef(e)) {
                e = t.createTextNode(e);
            }
            r.appendChild(e);
        } return r; }
        function of(t) { if (t instanceof HTMLTextAreaElement) {
            return t.value;
        } return t.innerHTML; }
        function rf(t) { return Object.prototype.toString.apply(t) == "[object Range]"; }
        function sf(t) { const e = t.ownerDocument.defaultView.getComputedStyle(t); return { top: parseInt(e.borderTopWidth, 10), right: parseInt(e.borderRightWidth, 10), bottom: parseInt(e.borderBottomWidth, 10), left: parseInt(e.borderLeftWidth, 10) }; }
        const af = ["top", "right", "bottom", "left", "width", "height"];
        class cf {
            constructor(t) { const e = rf(t); Object.defineProperty(this, "_source", { value: t._source || t, writable: true, enumerable: false }); if (fa(t) || e) {
                if (e) {
                    const e = cf.getDomRangeRects(t);
                    lf(this, cf.getBoundingRect(e));
                }
                else {
                    lf(this, t.getBoundingClientRect());
                }
            }
            else if (bu(t)) {
                const { innerWidth: e, innerHeight: n } = t;
                lf(this, { top: 0, right: e, bottom: n, left: 0, width: e, height: n });
            }
            else {
                lf(this, t);
            } }
            clone() { return new cf(this); }
            moveTo(t, e) { this.top = e; this.right = t + this.width; this.bottom = e + this.height; this.left = t; return this; }
            moveBy(t, e) { this.top += e; this.right += t; this.left += t; this.bottom += e; return this; }
            getIntersection(t) { const e = { top: Math.max(this.top, t.top), right: Math.min(this.right, t.right), bottom: Math.min(this.bottom, t.bottom), left: Math.max(this.left, t.left) }; e.width = e.right - e.left; e.height = e.bottom - e.top; if (e.width < 0 || e.height < 0) {
                return null;
            }
            else {
                return new cf(e);
            } }
            getIntersectionArea(t) { const e = this.getIntersection(t); if (e) {
                return e.getArea();
            }
            else {
                return 0;
            } }
            getArea() { return this.width * this.height; }
            getVisible() { const t = this._source; let e = this.clone(); if (!df(t)) {
                let n = t.parentNode || t.commonAncestorContainer;
                while (n && !df(n)) {
                    const t = new cf(n);
                    const o = e.getIntersection(t);
                    if (o) {
                        if (o.getArea() < e.getArea()) {
                            e = o;
                        }
                    }
                    else {
                        return null;
                    }
                    n = n.parentNode;
                }
            } return e; }
            isEqual(t) { for (const e of af) {
                if (this[e] !== t[e]) {
                    return false;
                }
            } return true; }
            contains(t) { const e = this.getIntersection(t); return !!(e && e.isEqual(t)); }
            excludeScrollbarsAndBorders() { const t = this._source; let e, n, o; if (bu(t)) {
                e = t.innerWidth - t.document.documentElement.clientWidth;
                n = t.innerHeight - t.document.documentElement.clientHeight;
                o = t.getComputedStyle(t.document.documentElement).direction;
            }
            else {
                const i = sf(this._source);
                e = t.offsetWidth - t.clientWidth - i.left - i.right;
                n = t.offsetHeight - t.clientHeight - i.top - i.bottom;
                o = t.ownerDocument.defaultView.getComputedStyle(t).direction;
                this.left += i.left;
                this.top += i.top;
                this.right -= i.right;
                this.bottom -= i.bottom;
                this.width = this.right - this.left;
                this.height = this.bottom - this.top;
            } this.width -= e; if (o === "ltr") {
                this.right -= e;
            }
            else {
                this.left += e;
            } this.height -= n; this.bottom -= n; return this; }
            static getDomRangeRects(t) { const e = []; const n = Array.from(t.getClientRects()); if (n.length) {
                for (const t of n) {
                    e.push(new cf(t));
                }
            }
            else {
                let n = t.startContainer;
                if (Bd(n)) {
                    n = n.parentNode;
                }
                const o = new cf(n.getBoundingClientRect());
                o.right = o.left;
                o.width = 0;
                e.push(o);
            } return e; }
            static getBoundingRect(t) { const e = { left: Number.POSITIVE_INFINITY, top: Number.POSITIVE_INFINITY, right: Number.NEGATIVE_INFINITY, bottom: Number.NEGATIVE_INFINITY }; let n = 0; for (const o of t) {
                n++;
                e.left = Math.min(e.left, o.left);
                e.top = Math.min(e.top, o.top);
                e.right = Math.max(e.right, o.right);
                e.bottom = Math.max(e.bottom, o.bottom);
            } if (n == 0) {
                return null;
            } e.width = e.right - e.left; e.height = e.bottom - e.top; return new cf(e); }
        }
        function lf(t, e) { for (const n of af) {
            t[n] = e[n];
        } }
        function df(t) { if (!fa(t)) {
            return false;
        } return t === t.ownerDocument.body; }
        const uf = 100;
        class hf {
            constructor(t, e) { if (!hf._observerInstance) {
                hf._createObserver();
            } this._element = t; this._callback = e; hf._addElementCallback(t, e); hf._observerInstance.observe(t); }
            destroy() { hf._deleteElementCallback(this._element, this._callback); }
            static _addElementCallback(t, e) { if (!hf._elementCallbacks) {
                hf._elementCallbacks = new Map;
            } let n = hf._elementCallbacks.get(t); if (!n) {
                n = new Set;
                hf._elementCallbacks.set(t, n);
            } n.add(e); }
            static _deleteElementCallback(t, e) { const n = hf._getElementCallbacks(t); if (n) {
                n.delete(e);
                if (!n.size) {
                    hf._elementCallbacks.delete(t);
                    hf._observerInstance.unobserve(t);
                }
            } if (hf._elementCallbacks && !hf._elementCallbacks.size) {
                hf._observerInstance = null;
                hf._elementCallbacks = null;
            } }
            static _getElementCallbacks(t) { if (!hf._elementCallbacks) {
                return null;
            } return hf._elementCallbacks.get(t); }
            static _createObserver() { let t; if (typeof su.window.ResizeObserver === "function") {
                t = su.window.ResizeObserver;
            }
            else {
                t = ff;
            } hf._observerInstance = new t((t => { for (const e of t) {
                const t = hf._getElementCallbacks(e.target);
                if (t) {
                    for (const n of t) {
                        n(e);
                    }
                }
            } })); }
        }
        hf._observerInstance = null;
        hf._elementCallbacks = null;
        class ff {
            constructor(t) { this._callback = t; this._elements = new Set; this._previousRects = new Map; this._periodicCheckTimeout = null; }
            observe(t) { this._elements.add(t); this._checkElementRectsAndExecuteCallback(); if (this._elements.size === 1) {
                this._startPeriodicCheck();
            } }
            unobserve(t) { this._elements.delete(t); this._previousRects.delete(t); if (!this._elements.size) {
                this._stopPeriodicCheck();
            } }
            _startPeriodicCheck() { const t = () => { this._checkElementRectsAndExecuteCallback(); this._periodicCheckTimeout = setTimeout(t, uf); }; this.listenTo(su.window, "resize", (() => { this._checkElementRectsAndExecuteCallback(); })); this._periodicCheckTimeout = setTimeout(t, uf); }
            _stopPeriodicCheck() { clearTimeout(this._periodicCheckTimeout); this.stopListening(); this._previousRects.clear(); }
            _checkElementRectsAndExecuteCallback() { const t = []; for (const e of this._elements) {
                if (this._hasRectChanged(e)) {
                    t.push({ target: e, contentRect: this._previousRects.get(e) });
                }
            } if (t.length) {
                this._callback(t);
            } }
            _hasRectChanged(t) { if (!t.ownerDocument.body.contains(t)) {
                return false;
            } const e = new cf(t); const n = this._previousRects.get(t); const o = !n || !n.isEqual(e); this._previousRects.set(t, e); return o; }
        }
        qn(ff, _u);
        function pf(t, e) { if (t instanceof HTMLTextAreaElement) {
            t.value = e;
        } t.innerHTML = e; }
        function gf(t) { return e => e + t; }
        function mf(t) { const e = t.next(); if (e.done) {
            return null;
        } return e.value; }
        class kf {
            constructor() { this.set("isFocused", false); this.set("focusedElement", null); this._elements = new Set; this._nextEventLoopTimeout = null; }
            add(t) { if (this._elements.has(t)) {
                throw new u["a"]("focustracker-add-element-already-exist", this);
            } this.listenTo(t, "focus", (() => this._focus(t)), { useCapture: true }); this.listenTo(t, "blur", (() => this._blur()), { useCapture: true }); this._elements.add(t); }
            remove(t) { if (t === this.focusedElement) {
                this._blur(t);
            } if (this._elements.has(t)) {
                this.stopListening(t);
                this._elements.delete(t);
            } }
            destroy() { this.stopListening(); }
            _focus(t) { clearTimeout(this._nextEventLoopTimeout); this.focusedElement = t; this.isFocused = true; }
            _blur() { clearTimeout(this._nextEventLoopTimeout); this._nextEventLoopTimeout = setTimeout((() => { this.focusedElement = null; this.isFocused = false; }), 0); }
        }
        qn(kf, _u);
        qn(kf, Pn);
        class bf {
            constructor() { this._listener = Object.create(_u); }
            listenTo(t) { this._listener.listenTo(t, "keydown", ((t, e) => { this._listener.fire("_keydown:" + nd(e), e); })); }
            set(t, e, n = {}) { const o = od(t); const i = n.priority; this._listener.listenTo(this._listener, "_keydown:" + o, ((t, n) => { e(n, (() => { n.preventDefault(); n.stopPropagation(); t.stop(); })); t.return = true; }), { priority: i }); }
            press(t) { return !!this._listener.fire("_keydown:" + nd(t), t); }
            destroy() { this._listener.stopListening(); }
        }
        class wf extends Cu {
            constructor(t) { super(t); this.document.on("keydown", ((t, e) => { if (this.isEnabled && rd(e.keyCode)) {
                const n = new Dl(this.document, "arrowKey", this.document.selection.getFirstRange());
                this.document.fire(n, e);
                if (n.stop.called) {
                    t.stop();
                }
            } })); }
            observe() { }
        }
        const _f = {};
        function vf({ target: t, viewportOffset: e = 0 }) { const n = Tf(t); let o = n; let i = null; while (o) {
            let r;
            if (o == n) {
                r = Pf(t);
            }
            else {
                r = Pf(i);
            }
            yf(r, (() => Bf(t, o)));
            const s = Bf(t, o);
            Cf(o, s, e);
            if (o.parent != o) {
                i = o.frameElement;
                o = o.parent;
                if (!i) {
                    return;
                }
            }
            else {
                o = null;
            }
        } }
        function Af(t) { const e = Pf(t); yf(e, (() => new cf(t))); }
        Object.assign(_f, { scrollViewportToShowTarget: vf, scrollAncestorsToShowTarget: Af });
        function Cf(t, e, n) { const o = e.clone().moveBy(0, n); const i = e.clone().moveBy(0, -n); const r = new cf(t).excludeScrollbarsAndBorders(); const s = [i, o]; if (!s.every((t => r.contains(t)))) {
            let { scrollX: s, scrollY: a } = t;
            if (Ef(i, r)) {
                a -= r.top - e.top + n;
            }
            else if (xf(o, r)) {
                a += e.bottom - r.bottom + n;
            }
            if (Df(e, r)) {
                s -= r.left - e.left + n;
            }
            else if (Sf(e, r)) {
                s += e.right - r.right + n;
            }
            t.scrollTo(s, a);
        } }
        function yf(t, e) { const n = Tf(t); let o, i; while (t != n.document.body) {
            i = e();
            o = new cf(t).excludeScrollbarsAndBorders();
            if (!o.contains(i)) {
                if (Ef(i, o)) {
                    t.scrollTop -= o.top - i.top;
                }
                else if (xf(i, o)) {
                    t.scrollTop += i.bottom - o.bottom;
                }
                if (Df(i, o)) {
                    t.scrollLeft -= o.left - i.left;
                }
                else if (Sf(i, o)) {
                    t.scrollLeft += i.right - o.right;
                }
            }
            t = t.parentNode;
        } }
        function xf(t, e) { return t.bottom > e.bottom; }
        function Ef(t, e) { return t.top < e.top; }
        function Df(t, e) { return t.left < e.left; }
        function Sf(t, e) { return t.right > e.right; }
        function Tf(t) { if (rf(t)) {
            return t.startContainer.ownerDocument.defaultView;
        }
        else {
            return t.ownerDocument.defaultView;
        } }
        function Pf(t) { if (rf(t)) {
            let e = t.commonAncestorContainer;
            if (Bd(e)) {
                e = e.parentNode;
            }
            return e;
        }
        else {
            return t.parentNode;
        } }
        function Bf(t, e) { const n = Tf(t); const o = new cf(t); if (n === e) {
            return o;
        }
        else {
            let t = n;
            while (t != e) {
                const e = t.frameElement;
                const n = new cf(e).excludeScrollbarsAndBorders();
                o.moveBy(n.left, n.top);
                t = t.parent;
            }
        } return o; }
        class If {
            constructor(t) { this.document = new zl(t); this.domConverter = new fu(this.document); this.domRoots = new Map; this.set("isRenderingInProgress", false); this.set("hasDomSelection", false); this._renderer = new Xd(this.domConverter, this.document.selection); this._renderer.bind("isFocused").to(this.document); this._initialDomRootAttributes = new WeakMap; this._observers = new Map; this._ongoingChange = false; this._postFixersInProgress = false; this._renderingDisabled = false; this._hasChangedSinceTheLastRendering = false; this._writer = new wd(this.document); this.addObserver(Ch); this.addObserver(Uh); this.addObserver(Jh); this.addObserver(Eh); this.addObserver(Gh); this.addObserver(Yh); this.addObserver(wf); if (Wl.isAndroid) {
                this.addObserver(Qh);
            } Ld(this); hd(this); this.on("render", (() => { this._render(); this.document.fire("layoutChanged"); this._hasChangedSinceTheLastRendering = false; })); this.listenTo(this.document.selection, "change", (() => { this._hasChangedSinceTheLastRendering = true; })); }
            attachDomRoot(t, e = "main") { const n = this.document.getRoot(e); n._name = t.tagName.toLowerCase(); const o = {}; for (const { name: e, value: i } of Array.from(t.attributes)) {
                o[e] = i;
                if (e === "class") {
                    this._writer.addClass(i.split(" "), n);
                }
                else {
                    this._writer.setAttribute(e, i, n);
                }
            } this._initialDomRootAttributes.set(t, o); const i = () => { this._writer.setAttribute("contenteditable", !n.isReadOnly, n); if (n.isReadOnly) {
                this._writer.addClass("ck-read-only", n);
            }
            else {
                this._writer.removeClass("ck-read-only", n);
            } }; i(); this.domRoots.set(e, t); this.domConverter.bindElements(t, n); this._renderer.markToSync("children", n); this._renderer.markToSync("attributes", n); this._renderer.domDocuments.add(t.ownerDocument); n.on("change:children", ((t, e) => this._renderer.markToSync("children", e))); n.on("change:attributes", ((t, e) => this._renderer.markToSync("attributes", e))); n.on("change:text", ((t, e) => this._renderer.markToSync("text", e))); n.on("change:isReadOnly", (() => this.change(i))); n.on("change", (() => { this._hasChangedSinceTheLastRendering = true; })); for (const n of this._observers.values()) {
                n.observe(t, e);
            } }
            detachDomRoot(t) { const e = this.domRoots.get(t); Array.from(e.attributes).forEach((({ name: t }) => e.removeAttribute(t))); const n = this._initialDomRootAttributes.get(e); for (const t in n) {
                e.setAttribute(t, n[t]);
            } this.domRoots.delete(t); this.domConverter.unbindDomElement(e); }
            getDomRoot(t = "main") { return this.domRoots.get(t); }
            addObserver(t) { let e = this._observers.get(t); if (e) {
                return e;
            } e = new t(this); this._observers.set(t, e); for (const [t, n] of this.domRoots) {
                e.observe(n, t);
            } e.enable(); return e; }
            getObserver(t) { return this._observers.get(t); }
            disableObservers() { for (const t of this._observers.values()) {
                t.disable();
            } }
            enableObservers() { for (const t of this._observers.values()) {
                t.enable();
            } }
            scrollToTheSelection() { const t = this.document.selection.getFirstRange(); if (t) {
                vf({ target: this.domConverter.viewRangeToDom(t), viewportOffset: 20 });
            } }
            focus() { if (!this.document.isFocused) {
                const t = this.document.selection.editableElement;
                if (t) {
                    this.domConverter.focus(t);
                    this.forceRender();
                }
                else { }
            } }
            change(t) { if (this.isRenderingInProgress || this._postFixersInProgress) {
                throw new u["a"]("cannot-change-view-tree", this);
            } try {
                if (this._ongoingChange) {
                    return t(this._writer);
                }
                this._ongoingChange = true;
                const e = t(this._writer);
                this._ongoingChange = false;
                if (!this._renderingDisabled && this._hasChangedSinceTheLastRendering) {
                    this._postFixersInProgress = true;
                    this.document._callPostFixers(this._writer);
                    this._postFixersInProgress = false;
                    this.fire("render");
                }
                return e;
            }
            catch (t) {
                u["a"].rethrowUnexpectedError(t, this);
            } }
            forceRender() { this._hasChangedSinceTheLastRendering = true; this.change((() => { })); }
            destroy() { for (const t of this._observers.values()) {
                t.destroy();
            } this.document.destroy(); this.stopListening(); }
            createPositionAt(t, e) { return vl._createAt(t, e); }
            createPositionAfter(t) { return vl._createAfter(t); }
            createPositionBefore(t) { return vl._createBefore(t); }
            createRange(t, e) { return new Al(t, e); }
            createRangeOn(t) { return Al._createOn(t); }
            createRangeIn(t) { return Al._createIn(t); }
            createSelection(t, e, n) { return new xl(t, e, n); }
            _disableRendering(t) { this._renderingDisabled = t; if (t == false) {
                this.change((() => { }));
            } }
            _render() { this.isRenderingInProgress = true; this.disableObservers(); this._renderer.render(); this.enableObservers(); this.isRenderingInProgress = false; }
        }
        qn(If, Pn);
        class Rf {
            constructor(t) { this.parent = null; this._attrs = La(t); }
            get index() { let t; if (!this.parent) {
                return null;
            } if ((t = this.parent.getChildIndex(this)) === null) {
                throw new u["a"]("model-node-not-found-in-parent", this);
            } return t; }
            get startOffset() { let t; if (!this.parent) {
                return null;
            } if ((t = this.parent.getChildStartOffset(this)) === null) {
                throw new u["a"]("model-node-not-found-in-parent", this);
            } return t; }
            get offsetSize() { return 1; }
            get endOffset() { if (!this.parent) {
                return null;
            } return this.startOffset + this.offsetSize; }
            get nextSibling() { const t = this.index; return t !== null && this.parent.getChild(t + 1) || null; }
            get previousSibling() { const t = this.index; return t !== null && this.parent.getChild(t - 1) || null; }
            get root() { let t = this; while (t.parent) {
                t = t.parent;
            } return t; }
            isAttached() { return this.root.is("rootElement"); }
            getPath() { const t = []; let e = this; while (e.parent) {
                t.unshift(e.startOffset);
                e = e.parent;
            } return t; }
            getAncestors(t = { includeSelf: false, parentFirst: false }) { const e = []; let n = t.includeSelf ? this : this.parent; while (n) {
                e[t.parentFirst ? "push" : "unshift"](n);
                n = n.parent;
            } return e; }
            getCommonAncestor(t, e = {}) { const n = this.getAncestors(e); const o = t.getAncestors(e); let i = 0; while (n[i] == o[i] && n[i]) {
                i++;
            } return i === 0 ? null : n[i - 1]; }
            isBefore(t) { if (this == t) {
                return false;
            } if (this.root !== t.root) {
                return false;
            } const e = this.getPath(); const n = t.getPath(); const o = Ia(e, n); switch (o) {
                case "prefix": return true;
                case "extension": return false;
                default: return e[o] < n[o];
            } }
            isAfter(t) { if (this == t) {
                return false;
            } if (this.root !== t.root) {
                return false;
            } return !this.isBefore(t); }
            hasAttribute(t) { return this._attrs.has(t); }
            getAttribute(t) { return this._attrs.get(t); }
            getAttributes() { return this._attrs.entries(); }
            getAttributeKeys() { return this._attrs.keys(); }
            toJSON() { const t = {}; if (this._attrs.size) {
                t.attributes = Array.from(this._attrs).reduce(((t, e) => { t[e[0]] = e[1]; return t; }), {});
            } return t; }
            is(t) { return t === "node" || t === "model:node"; }
            _clone() { return new Rf(this._attrs); }
            _remove() { this.parent._removeChildren(this.index); }
            _setAttribute(t, e) { this._attrs.set(t, e); }
            _setAttributesTo(t) { this._attrs = La(t); }
            _removeAttribute(t) { return this._attrs.delete(t); }
            _clearAttributes() { this._attrs.clear(); }
        }
        class Ff extends Rf {
            constructor(t, e) { super(e); this._data = t || ""; }
            get offsetSize() { return this.data.length; }
            get data() { return this._data; }
            is(t) { return t === "$text" || t === "model:$text" || t === "text" || t === "model:text" || t === "node" || t === "model:node"; }
            toJSON() { const t = super.toJSON(); t.data = this.data; return t; }
            _clone() { return new Ff(this.data, this.getAttributes()); }
            static fromJSON(t) { return new Ff(t.data, t.attributes); }
        }
        class Of {
            constructor(t, e, n) { this.textNode = t; if (e < 0 || e > t.offsetSize) {
                throw new u["a"]("model-textproxy-wrong-offsetintext", this);
            } if (n < 0 || e + n > t.offsetSize) {
                throw new u["a"]("model-textproxy-wrong-length", this);
            } this.data = t.data.substring(e, e + n); this.offsetInText = e; }
            get startOffset() { return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null; }
            get offsetSize() { return this.data.length; }
            get endOffset() { return this.startOffset !== null ? this.startOffset + this.offsetSize : null; }
            get isPartial() { return this.offsetSize !== this.textNode.offsetSize; }
            get parent() { return this.textNode.parent; }
            get root() { return this.textNode.root; }
            is(t) { return t === "$textProxy" || t === "model:$textProxy" || t === "textProxy" || t === "model:textProxy"; }
            getPath() { const t = this.textNode.getPath(); if (t.length > 0) {
                t[t.length - 1] += this.offsetInText;
            } return t; }
            getAncestors(t = { includeSelf: false, parentFirst: false }) { const e = []; let n = t.includeSelf ? this : this.parent; while (n) {
                e[t.parentFirst ? "push" : "unshift"](n);
                n = n.parent;
            } return e; }
            hasAttribute(t) { return this.textNode.hasAttribute(t); }
            getAttribute(t) { return this.textNode.getAttribute(t); }
            getAttributes() { return this.textNode.getAttributes(); }
            getAttributeKeys() { return this.textNode.getAttributeKeys(); }
        }
        class zf {
            constructor(t) { this._nodes = []; if (t) {
                this._insertNodes(0, t);
            } }
            [Symbol.iterator]() { return this._nodes[Symbol.iterator](); }
            get length() { return this._nodes.length; }
            get maxOffset() { return this._nodes.reduce(((t, e) => t + e.offsetSize), 0); }
            getNode(t) { return this._nodes[t] || null; }
            getNodeIndex(t) { const e = this._nodes.indexOf(t); return e == -1 ? null : e; }
            getNodeStartOffset(t) { const e = this.getNodeIndex(t); return e === null ? null : this._nodes.slice(0, e).reduce(((t, e) => t + e.offsetSize), 0); }
            indexToOffset(t) { if (t == this._nodes.length) {
                return this.maxOffset;
            } const e = this._nodes[t]; if (!e) {
                throw new u["a"]("model-nodelist-index-out-of-bounds", this);
            } return this.getNodeStartOffset(e); }
            offsetToIndex(t) { let e = 0; for (const n of this._nodes) {
                if (t >= e && t < e + n.offsetSize) {
                    return this.getNodeIndex(n);
                }
                e += n.offsetSize;
            } if (e != t) {
                throw new u["a"]("model-nodelist-offset-out-of-bounds", this, { offset: t, nodeList: this });
            } return this.length; }
            _insertNodes(t, e) { for (const t of e) {
                if (!(t instanceof Rf)) {
                    throw new u["a"]("model-nodelist-insertnodes-not-node", this);
                }
            } this._nodes.splice(t, 0, ...e); }
            _removeNodes(t, e = 1) { return this._nodes.splice(t, e); }
            toJSON() { return this._nodes.map((t => t.toJSON())); }
        }
        class Nf extends Rf {
            constructor(t, e, n) { super(e); this.name = t; this._children = new zf; if (n) {
                this._insertChild(0, n);
            } }
            get childCount() { return this._children.length; }
            get maxOffset() { return this._children.maxOffset; }
            get isEmpty() { return this.childCount === 0; }
            is(t, e = null) { if (!e) {
                return t === "element" || t === "model:element" || t === "node" || t === "model:node";
            } return e === this.name && (t === "element" || t === "model:element"); }
            getChild(t) { return this._children.getNode(t); }
            getChildren() { return this._children[Symbol.iterator](); }
            getChildIndex(t) { return this._children.getNodeIndex(t); }
            getChildStartOffset(t) { return this._children.getNodeStartOffset(t); }
            offsetToIndex(t) { return this._children.offsetToIndex(t); }
            getNodeByPath(t) { let e = this; for (const n of t) {
                e = e.getChild(e.offsetToIndex(n));
            } return e; }
            findAncestor(t, e = { includeSelf: false }) { let n = e.includeSelf ? this : this.parent; while (n) {
                if (n.name === t) {
                    return n;
                }
                n = n.parent;
            } return null; }
            toJSON() { const t = super.toJSON(); t.name = this.name; if (this._children.length > 0) {
                t.children = [];
                for (const e of this._children) {
                    t.children.push(e.toJSON());
                }
            } return t; }
            _clone(t = false) { const e = t ? Array.from(this._children).map((t => t._clone(true))) : null; return new Nf(this.name, this.getAttributes(), e); }
            _appendChild(t) { this._insertChild(this.childCount, t); }
            _insertChild(t, e) { const n = Mf(e); for (const t of n) {
                if (t.parent !== null) {
                    t._remove();
                }
                t.parent = this;
            } this._children._insertNodes(t, n); }
            _removeChildren(t, e = 1) { const n = this._children._removeNodes(t, e); for (const t of n) {
                t.parent = null;
            } return n; }
            static fromJSON(t) { let e = null; if (t.children) {
                e = [];
                for (const n of t.children) {
                    if (n.name) {
                        e.push(Nf.fromJSON(n));
                    }
                    else {
                        e.push(Ff.fromJSON(n));
                    }
                }
            } return new Nf(t.name, t.attributes, e); }
        }
        function Mf(t) { if (typeof t == "string") {
            return [new Ff(t)];
        } if (!ka(t)) {
            t = [t];
        } return Array.from(t).map((t => { if (typeof t == "string") {
            return new Ff(t);
        } if (t instanceof Of) {
            return new Ff(t.data, t.getAttributes());
        } return t; })); }
        class Vf {
            constructor(t = {}) { if (!t.boundaries && !t.startPosition) {
                throw new u["a"]("model-tree-walker-no-start-position", null);
            } const e = t.direction || "forward"; if (e != "forward" && e != "backward") {
                throw new u["a"]("model-tree-walker-unknown-direction", t, { direction: e });
            } this.direction = e; this.boundaries = t.boundaries || null; if (t.startPosition) {
                this.position = t.startPosition.clone();
            }
            else {
                this.position = qf._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]);
            } this.position.stickiness = "toNone"; this.singleCharacters = !!t.singleCharacters; this.shallow = !!t.shallow; this.ignoreElementEnd = !!t.ignoreElementEnd; this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null; this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null; this._visitedParent = this.position.parent; }
            [Symbol.iterator]() { return this; }
            skip(t) { let e, n, o, i; do {
                o = this.position;
                i = this._visitedParent;
                ({ done: e, value: n } = this.next());
            } while (!e && t(n)); if (!e) {
                this.position = o;
                this._visitedParent = i;
            } }
            next() { if (this.direction == "forward") {
                return this._next();
            }
            else {
                return this._previous();
            } }
            _next() { const t = this.position; const e = this.position.clone(); const n = this._visitedParent; if (n.parent === null && e.offset === n.maxOffset) {
                return { done: true };
            } if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) {
                return { done: true };
            } const o = e.parent; const i = Kf(e, o); const r = i ? i : jf(e, o, i); if (r instanceof Nf) {
                if (!this.shallow) {
                    e.path.push(0);
                    this._visitedParent = r;
                }
                else {
                    e.offset++;
                }
                this.position = e;
                return Lf("elementStart", r, t, e, 1);
            }
            else if (r instanceof Ff) {
                let o;
                if (this.singleCharacters) {
                    o = 1;
                }
                else {
                    let t = r.endOffset;
                    if (this._boundaryEndParent == n && this.boundaries.end.offset < t) {
                        t = this.boundaries.end.offset;
                    }
                    o = t - e.offset;
                }
                const i = e.offset - r.startOffset;
                const s = new Of(r, i, o);
                e.offset += o;
                this.position = e;
                return Lf("text", s, t, e, o);
            }
            else {
                e.path.pop();
                e.offset++;
                this.position = e;
                this._visitedParent = n.parent;
                if (this.ignoreElementEnd) {
                    return this._next();
                }
                else {
                    return Lf("elementEnd", n, t, e);
                }
            } }
            _previous() { const t = this.position; const e = this.position.clone(); const n = this._visitedParent; if (n.parent === null && e.offset === 0) {
                return { done: true };
            } if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) {
                return { done: true };
            } const o = e.parent; const i = Kf(e, o); const r = i ? i : Hf(e, o, i); if (r instanceof Nf) {
                e.offset--;
                if (!this.shallow) {
                    e.path.push(r.maxOffset);
                    this.position = e;
                    this._visitedParent = r;
                    if (this.ignoreElementEnd) {
                        return this._previous();
                    }
                    else {
                        return Lf("elementEnd", r, t, e);
                    }
                }
                else {
                    this.position = e;
                    return Lf("elementStart", r, t, e, 1);
                }
            }
            else if (r instanceof Ff) {
                let o;
                if (this.singleCharacters) {
                    o = 1;
                }
                else {
                    let t = r.startOffset;
                    if (this._boundaryStartParent == n && this.boundaries.start.offset > t) {
                        t = this.boundaries.start.offset;
                    }
                    o = e.offset - t;
                }
                const i = e.offset - r.startOffset;
                const s = new Of(r, i - o, o);
                e.offset -= o;
                this.position = e;
                return Lf("text", s, t, e, o);
            }
            else {
                e.path.pop();
                this.position = e;
                this._visitedParent = n.parent;
                return Lf("elementStart", n, t, e, 1);
            } }
        }
        function Lf(t, e, n, o, i) { return { done: false, value: { type: t, item: e, previousPosition: n, nextPosition: o, length: i } }; }
        class qf {
            constructor(t, e, n = "toNone") { if (!t.is("element") && !t.is("documentFragment")) {
                throw new u["a"]("model-position-root-invalid", t);
            } if (!(e instanceof Array) || e.length === 0) {
                throw new u["a"]("model-position-path-incorrect-format", t, { path: e });
            } if (t.is("rootElement")) {
                e = e.slice();
            }
            else {
                e = [...t.getPath(), ...e];
                t = t.root;
            } this.root = t; this.path = e; this.stickiness = n; }
            get offset() { return this.path[this.path.length - 1]; }
            set offset(t) { this.path[this.path.length - 1] = t; }
            get parent() { let t = this.root; for (let e = 0; e < this.path.length - 1; e++) {
                t = t.getChild(t.offsetToIndex(this.path[e]));
                if (!t) {
                    throw new u["a"]("model-position-path-incorrect", this, { position: this });
                }
            } if (t.is("$text")) {
                throw new u["a"]("model-position-path-incorrect", this, { position: this });
            } return t; }
            get index() { return this.parent.offsetToIndex(this.offset); }
            get textNode() { return Kf(this, this.parent); }
            get nodeAfter() { const t = this.parent; return jf(this, t, Kf(this, t)); }
            get nodeBefore() { const t = this.parent; return Hf(this, t, Kf(this, t)); }
            get isAtStart() { return this.offset === 0; }
            get isAtEnd() { return this.offset == this.parent.maxOffset; }
            compareWith(t) { if (this.root != t.root) {
                return "different";
            } const e = Ia(this.path, t.path); switch (e) {
                case "same": return "same";
                case "prefix": return "before";
                case "extension": return "after";
                default: return this.path[e] < t.path[e] ? "before" : "after";
            } }
            getLastMatchingPosition(t, e = {}) { e.startPosition = this; const n = new Vf(e); n.skip(t); return n.position; }
            getParentPath() { return this.path.slice(0, -1); }
            getAncestors() { const t = this.parent; if (t.is("documentFragment")) {
                return [t];
            }
            else {
                return t.getAncestors({ includeSelf: true });
            } }
            findAncestor(t) { const e = this.parent; if (e.is("element")) {
                return e.findAncestor(t, { includeSelf: true });
            } return null; }
            getCommonPath(t) { if (this.root != t.root) {
                return [];
            } const e = Ia(this.path, t.path); const n = typeof e == "string" ? Math.min(this.path.length, t.path.length) : e; return this.path.slice(0, n); }
            getCommonAncestor(t) { const e = this.getAncestors(); const n = t.getAncestors(); let o = 0; while (e[o] == n[o] && e[o]) {
                o++;
            } return o === 0 ? null : e[o - 1]; }
            getShiftedBy(t) { const e = this.clone(); const n = e.offset + t; e.offset = n < 0 ? 0 : n; return e; }
            isAfter(t) { return this.compareWith(t) == "after"; }
            isBefore(t) { return this.compareWith(t) == "before"; }
            isEqual(t) { return this.compareWith(t) == "same"; }
            isTouching(t) { let e = null; let n = null; const o = this.compareWith(t); switch (o) {
                case "same": return true;
                case "before":
                    e = qf._createAt(this);
                    n = qf._createAt(t);
                    break;
                case "after":
                    e = qf._createAt(t);
                    n = qf._createAt(this);
                    break;
                default: return false;
            } let i = e.parent; while (e.path.length + n.path.length) {
                if (e.isEqual(n)) {
                    return true;
                }
                if (e.path.length > n.path.length) {
                    if (e.offset !== i.maxOffset) {
                        return false;
                    }
                    e.path = e.path.slice(0, -1);
                    i = i.parent;
                    e.offset++;
                }
                else {
                    if (n.offset !== 0) {
                        return false;
                    }
                    n.path = n.path.slice(0, -1);
                }
            } }
            is(t) { return t === "position" || t === "model:position"; }
            hasSameParentAs(t) { if (this.root !== t.root) {
                return false;
            } const e = this.getParentPath(); const n = t.getParentPath(); return Ia(e, n) == "same"; }
            getTransformedByOperation(t) { let e; switch (t.type) {
                case "insert":
                    e = this._getTransformedByInsertOperation(t);
                    break;
                case "move":
                case "remove":
                case "reinsert":
                    e = this._getTransformedByMoveOperation(t);
                    break;
                case "split":
                    e = this._getTransformedBySplitOperation(t);
                    break;
                case "merge":
                    e = this._getTransformedByMergeOperation(t);
                    break;
                default:
                    e = qf._createAt(this);
                    break;
            } return e; }
            _getTransformedByInsertOperation(t) { return this._getTransformedByInsertion(t.position, t.howMany); }
            _getTransformedByMoveOperation(t) { return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany); }
            _getTransformedBySplitOperation(t) { const e = t.movedRange; const n = e.containsPosition(this) || e.start.isEqual(this) && this.stickiness == "toNext"; if (n) {
                return this._getCombined(t.splitPosition, t.moveTargetPosition);
            }
            else {
                if (t.graveyardPosition) {
                    return this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1);
                }
                else {
                    return this._getTransformedByInsertion(t.insertionPosition, 1);
                }
            } }
            _getTransformedByMergeOperation(t) { const e = t.movedRange; const n = e.containsPosition(this) || e.start.isEqual(this); let o; if (n) {
                o = this._getCombined(t.sourcePosition, t.targetPosition);
                if (t.sourcePosition.isBefore(t.targetPosition)) {
                    o = o._getTransformedByDeletion(t.deletionPosition, 1);
                }
            }
            else if (this.isEqual(t.deletionPosition)) {
                o = qf._createAt(t.deletionPosition);
            }
            else {
                o = this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1);
            } return o; }
            _getTransformedByDeletion(t, e) { const n = qf._createAt(this); if (this.root != t.root) {
                return n;
            } if (Ia(t.getParentPath(), this.getParentPath()) == "same") {
                if (t.offset < this.offset) {
                    if (t.offset + e > this.offset) {
                        return null;
                    }
                    else {
                        n.offset -= e;
                    }
                }
            }
            else if (Ia(t.getParentPath(), this.getParentPath()) == "prefix") {
                const o = t.path.length - 1;
                if (t.offset <= this.path[o]) {
                    if (t.offset + e > this.path[o]) {
                        return null;
                    }
                    else {
                        n.path[o] -= e;
                    }
                }
            } return n; }
            _getTransformedByInsertion(t, e) { const n = qf._createAt(this); if (this.root != t.root) {
                return n;
            } if (Ia(t.getParentPath(), this.getParentPath()) == "same") {
                if (t.offset < this.offset || t.offset == this.offset && this.stickiness != "toPrevious") {
                    n.offset += e;
                }
            }
            else if (Ia(t.getParentPath(), this.getParentPath()) == "prefix") {
                const o = t.path.length - 1;
                if (t.offset <= this.path[o]) {
                    n.path[o] += e;
                }
            } return n; }
            _getTransformedByMove(t, e, n) { e = e._getTransformedByDeletion(t, n); if (t.isEqual(e)) {
                return qf._createAt(this);
            } const o = this._getTransformedByDeletion(t, n); const i = o === null || t.isEqual(this) && this.stickiness == "toNext" || t.getShiftedBy(n).isEqual(this) && this.stickiness == "toPrevious"; if (i) {
                return this._getCombined(t, e);
            }
            else {
                return o._getTransformedByInsertion(e, n);
            } }
            _getCombined(t, e) { const n = t.path.length - 1; const o = qf._createAt(e); o.stickiness = this.stickiness; o.offset = o.offset + this.path[n] - t.offset; o.path = [...o.path, ...this.path.slice(n + 1)]; return o; }
            toJSON() { return { root: this.root.toJSON(), path: Array.from(this.path), stickiness: this.stickiness }; }
            clone() { return new this.constructor(this.root, this.path, this.stickiness); }
            static _createAt(t, e, n = "toNone") { if (t instanceof qf) {
                return new qf(t.root, t.path, t.stickiness);
            }
            else {
                const o = t;
                if (e == "end") {
                    e = o.maxOffset;
                }
                else if (e == "before") {
                    return this._createBefore(o, n);
                }
                else if (e == "after") {
                    return this._createAfter(o, n);
                }
                else if (e !== 0 && !e) {
                    throw new u["a"]("model-createpositionat-offset-required", [this, t]);
                }
                if (!o.is("element") && !o.is("documentFragment")) {
                    throw new u["a"]("model-position-parent-incorrect", [this, t]);
                }
                const i = o.getPath();
                i.push(e);
                return new this(o.root, i, n);
            } }
            static _createAfter(t, e) { if (!t.parent) {
                throw new u["a"]("model-position-after-root", [this, t], { root: t });
            } return this._createAt(t.parent, t.endOffset, e); }
            static _createBefore(t, e) { if (!t.parent) {
                throw new u["a"]("model-position-before-root", t, { root: t });
            } return this._createAt(t.parent, t.startOffset, e); }
            static fromJSON(t, e) { if (t.root === "$graveyard") {
                const n = new qf(e.graveyard, t.path);
                n.stickiness = t.stickiness;
                return n;
            } if (!e.getRoot(t.root)) {
                throw new u["a"]("model-position-fromjson-no-root", e, { rootName: t.root });
            } return new qf(e.getRoot(t.root), t.path, t.stickiness); }
        }
        function Kf(t, e) { const n = e.getChild(e.offsetToIndex(t.offset)); if (n && n.is("$text") && n.startOffset < t.offset) {
            return n;
        } return null; }
        function jf(t, e, n) { if (n !== null) {
            return null;
        } return e.getChild(e.offsetToIndex(t.offset)); }
        function Hf(t, e, n) { if (n !== null) {
            return null;
        } return e.getChild(e.offsetToIndex(t.offset) - 1); }
        class Wf {
            constructor(t, e = null) { this.start = qf._createAt(t); this.end = e ? qf._createAt(e) : qf._createAt(t); this.start.stickiness = this.isCollapsed ? "toNone" : "toNext"; this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious"; }
            *[Symbol.iterator]() { yield* new Vf({ boundaries: this, ignoreElementEnd: true }); }
            get isCollapsed() { return this.start.isEqual(this.end); }
            get isFlat() { const t = this.start.getParentPath(); const e = this.end.getParentPath(); return Ia(t, e) == "same"; }
            get root() { return this.start.root; }
            containsPosition(t) { return t.isAfter(this.start) && t.isBefore(this.end); }
            containsRange(t, e = false) { if (t.isCollapsed) {
                e = false;
            } const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start); const o = this.containsPosition(t.end) || e && this.end.isEqual(t.end); return n && o; }
            containsItem(t) { const e = qf._createBefore(t); return this.containsPosition(e) || this.start.isEqual(e); }
            is(t) { return t === "range" || t === "model:range"; }
            isEqual(t) { return this.start.isEqual(t.start) && this.end.isEqual(t.end); }
            isIntersecting(t) { return this.start.isBefore(t.end) && this.end.isAfter(t.start); }
            getDifference(t) { const e = []; if (this.isIntersecting(t)) {
                if (this.containsPosition(t.start)) {
                    e.push(new Wf(this.start, t.start));
                }
                if (this.containsPosition(t.end)) {
                    e.push(new Wf(t.end, this.end));
                }
            }
            else {
                e.push(new Wf(this.start, this.end));
            } return e; }
            getIntersection(t) { if (this.isIntersecting(t)) {
                let e = this.start;
                let n = this.end;
                if (this.containsPosition(t.start)) {
                    e = t.start;
                }
                if (this.containsPosition(t.end)) {
                    n = t.end;
                }
                return new Wf(e, n);
            } return null; }
            getJoined(t, e = false) { let n = this.isIntersecting(t); if (!n) {
                if (this.start.isBefore(t.start)) {
                    n = e ? this.end.isTouching(t.start) : this.end.isEqual(t.start);
                }
                else {
                    n = e ? t.end.isTouching(this.start) : t.end.isEqual(this.start);
                }
            } if (!n) {
                return null;
            } let o = this.start; let i = this.end; if (t.start.isBefore(o)) {
                o = t.start;
            } if (t.end.isAfter(i)) {
                i = t.end;
            } return new Wf(o, i); }
            getMinimalFlatRanges() { const t = []; const e = this.start.getCommonPath(this.end).length; const n = qf._createAt(this.start); let o = n.parent; while (n.path.length > e + 1) {
                const e = o.maxOffset - n.offset;
                if (e !== 0) {
                    t.push(new Wf(n, n.getShiftedBy(e)));
                }
                n.path = n.path.slice(0, -1);
                n.offset++;
                o = o.parent;
            } while (n.path.length <= this.end.path.length) {
                const e = this.end.path[n.path.length - 1];
                const o = e - n.offset;
                if (o !== 0) {
                    t.push(new Wf(n, n.getShiftedBy(o)));
                }
                n.offset = e;
                n.path.push(0);
            } return t; }
            getWalker(t = {}) { t.boundaries = this; return new Vf(t); }
            *getItems(t = {}) { t.boundaries = this; t.ignoreElementEnd = true; const e = new Vf(t); for (const t of e) {
                yield t.item;
            } }
            *getPositions(t = {}) { t.boundaries = this; const e = new Vf(t); yield e.position; for (const t of e) {
                yield t.nextPosition;
            } }
            getTransformedByOperation(t) { switch (t.type) {
                case "insert": return this._getTransformedByInsertOperation(t);
                case "move":
                case "remove":
                case "reinsert": return this._getTransformedByMoveOperation(t);
                case "split": return [this._getTransformedBySplitOperation(t)];
                case "merge": return [this._getTransformedByMergeOperation(t)];
            } return [new Wf(this.start, this.end)]; }
            getTransformedByOperations(t) { const e = [new Wf(this.start, this.end)]; for (const n of t) {
                for (let t = 0; t < e.length; t++) {
                    const o = e[t].getTransformedByOperation(n);
                    e.splice(t, 1, ...o);
                    t += o.length - 1;
                }
            } for (let t = 0; t < e.length; t++) {
                const n = e[t];
                for (let o = t + 1; o < e.length; o++) {
                    const t = e[o];
                    if (n.containsRange(t) || t.containsRange(n) || n.isEqual(t)) {
                        e.splice(o, 1);
                    }
                }
            } return e; }
            getCommonAncestor() { return this.start.getCommonAncestor(this.end); }
            getContainedElement() { if (this.isCollapsed) {
                return null;
            } const t = this.start.nodeAfter; const e = this.end.nodeBefore; if (t && t.is("element") && t === e) {
                return t;
            } return null; }
            toJSON() { return { start: this.start.toJSON(), end: this.end.toJSON() }; }
            clone() { return new this.constructor(this.start, this.end); }
            _getTransformedByInsertOperation(t, e = false) { return this._getTransformedByInsertion(t.position, t.howMany, e); }
            _getTransformedByMoveOperation(t, e = false) { const n = t.sourcePosition; const o = t.howMany; const i = t.targetPosition; return this._getTransformedByMove(n, i, o, e); }
            _getTransformedBySplitOperation(t) { const e = this.start._getTransformedBySplitOperation(t); let n = this.end._getTransformedBySplitOperation(t); if (this.end.isEqual(t.insertionPosition)) {
                n = this.end.getShiftedBy(1);
            } if (e.root != n.root) {
                n = this.end.getShiftedBy(-1);
            } return new Wf(e, n); }
            _getTransformedByMergeOperation(t) { if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) {
                return new Wf(this.start);
            } let e = this.start._getTransformedByMergeOperation(t); let n = this.end._getTransformedByMergeOperation(t); if (e.root != n.root) {
                n = this.end.getShiftedBy(-1);
            } if (e.isAfter(n)) {
                if (t.sourcePosition.isBefore(t.targetPosition)) {
                    e = qf._createAt(n);
                    e.offset = 0;
                }
                else {
                    if (!t.deletionPosition.isEqual(e)) {
                        n = t.deletionPosition;
                    }
                    e = t.targetPosition;
                }
                return new Wf(e, n);
            } return new Wf(e, n); }
            _getTransformedByInsertion(t, e, n = false) { if (n && this.containsPosition(t)) {
                return [new Wf(this.start, t), new Wf(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
            }
            else {
                const n = new Wf(this.start, this.end);
                n.start = n.start._getTransformedByInsertion(t, e);
                n.end = n.end._getTransformedByInsertion(t, e);
                return [n];
            } }
            _getTransformedByMove(t, e, n, o = false) { if (this.isCollapsed) {
                const o = this.start._getTransformedByMove(t, e, n);
                return [new Wf(o)];
            } const i = Wf._createFromPositionAndShift(t, n); const r = e._getTransformedByDeletion(t, n); if (this.containsPosition(e) && !o) {
                if (i.containsPosition(this.start) || i.containsPosition(this.end)) {
                    const o = this.start._getTransformedByMove(t, e, n);
                    const i = this.end._getTransformedByMove(t, e, n);
                    return [new Wf(o, i)];
                }
            } let s; const a = this.getDifference(i); let c = null; const l = this.getIntersection(i); if (a.length == 1) {
                c = new Wf(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n));
            }
            else if (a.length == 2) {
                c = new Wf(this.start, this.end._getTransformedByDeletion(t, n));
            } if (c) {
                s = c._getTransformedByInsertion(r, n, l !== null || o);
            }
            else {
                s = [];
            } if (l) {
                const t = new Wf(l.start._getCombined(i.start, r), l.end._getCombined(i.start, r));
                if (s.length == 2) {
                    s.splice(1, 0, t);
                }
                else {
                    s.push(t);
                }
            } return s; }
            _getTransformedByDeletion(t, e) { let n = this.start._getTransformedByDeletion(t, e); let o = this.end._getTransformedByDeletion(t, e); if (n == null && o == null) {
                return null;
            } if (n == null) {
                n = t;
            } if (o == null) {
                o = t;
            } return new Wf(n, o); }
            static _createFromPositionAndShift(t, e) { const n = t; const o = t.getShiftedBy(e); return e > 0 ? new this(n, o) : new this(o, n); }
            static _createIn(t) { return new this(qf._createAt(t, 0), qf._createAt(t, t.maxOffset)); }
            static _createOn(t) { return this._createFromPositionAndShift(qf._createBefore(t), t.offsetSize); }
            static _createFromRanges(t) { if (t.length === 0) {
                throw new u["a"]("range-create-from-ranges-empty-array", null);
            }
            else if (t.length == 1) {
                return t[0].clone();
            } const e = t[0]; t.sort(((t, e) => t.start.isAfter(e.start) ? 1 : -1)); const n = t.indexOf(e); const o = new this(e.start, e.end); if (n > 0) {
                for (let e = n - 1; true; e++) {
                    if (t[e].end.isEqual(o.start)) {
                        o.start = qf._createAt(t[e].start);
                    }
                    else {
                        break;
                    }
                }
            } for (let e = n + 1; e < t.length; e++) {
                if (t[e].start.isEqual(o.end)) {
                    o.end = qf._createAt(t[e].end);
                }
                else {
                    break;
                }
            } return o; }
            static fromJSON(t, e) { return new this(qf.fromJSON(t.start, e), qf.fromJSON(t.end, e)); }
        }
        class $f {
            constructor() { this._modelToViewMapping = new WeakMap; this._viewToModelMapping = new WeakMap; this._viewToModelLengthCallbacks = new Map; this._markerNameToElements = new Map; this._elementToMarkerNames = new Map; this._unboundMarkerNames = new Set; this.on("modelToViewPosition", ((t, e) => { if (e.viewPosition) {
                return;
            } const n = this._modelToViewMapping.get(e.modelPosition.parent); e.viewPosition = this.findPositionIn(n, e.modelPosition.offset); }), { priority: "low" }); this.on("viewToModelPosition", ((t, e) => { if (e.modelPosition) {
                return;
            } const n = this.findMappedViewAncestor(e.viewPosition); const o = this._viewToModelMapping.get(n); const i = this._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n); e.modelPosition = qf._createAt(o, i); }), { priority: "low" }); }
            bindElements(t, e) { this._modelToViewMapping.set(t, e); this._viewToModelMapping.set(e, t); }
            unbindViewElement(t) { const e = this.toModelElement(t); this._viewToModelMapping.delete(t); if (this._elementToMarkerNames.has(t)) {
                for (const e of this._elementToMarkerNames.get(t)) {
                    this._unboundMarkerNames.add(e);
                }
            } if (this._modelToViewMapping.get(e) == t) {
                this._modelToViewMapping.delete(e);
            } }
            unbindModelElement(t) { const e = this.toViewElement(t); this._modelToViewMapping.delete(t); if (this._viewToModelMapping.get(e) == t) {
                this._viewToModelMapping.delete(e);
            } }
            bindElementToMarker(t, e) { const n = this._markerNameToElements.get(e) || new Set; n.add(t); const o = this._elementToMarkerNames.get(t) || new Set; o.add(e); this._markerNameToElements.set(e, n); this._elementToMarkerNames.set(t, o); }
            unbindElementFromMarkerName(t, e) { const n = this._markerNameToElements.get(e); if (n) {
                n.delete(t);
                if (n.size == 0) {
                    this._markerNameToElements.delete(e);
                }
            } const o = this._elementToMarkerNames.get(t); if (o) {
                o.delete(e);
                if (o.size == 0) {
                    this._elementToMarkerNames.delete(t);
                }
            } }
            flushUnboundMarkerNames() { const t = Array.from(this._unboundMarkerNames); this._unboundMarkerNames.clear(); return t; }
            clearBindings() { this._modelToViewMapping = new WeakMap; this._viewToModelMapping = new WeakMap; this._markerNameToElements = new Map; this._elementToMarkerNames = new Map; this._unboundMarkerNames = new Set; }
            toModelElement(t) { return this._viewToModelMapping.get(t); }
            toViewElement(t) { return this._modelToViewMapping.get(t); }
            toModelRange(t) { return new Wf(this.toModelPosition(t.start), this.toModelPosition(t.end)); }
            toViewRange(t) { return new Al(this.toViewPosition(t.start), this.toViewPosition(t.end)); }
            toModelPosition(t) { const e = { viewPosition: t, mapper: this }; this.fire("viewToModelPosition", e); return e.modelPosition; }
            toViewPosition(t, e = { isPhantom: false }) { const n = { modelPosition: t, mapper: this, isPhantom: e.isPhantom }; this.fire("modelToViewPosition", n); return n.viewPosition; }
            markerNameToElements(t) { const e = this._markerNameToElements.get(t); if (!e) {
                return null;
            } const n = new Set; for (const t of e) {
                if (t.is("attributeElement")) {
                    for (const e of t.getElementsWithSameId()) {
                        n.add(e);
                    }
                }
                else {
                    n.add(t);
                }
            } return n; }
            registerViewToModelLength(t, e) { this._viewToModelLengthCallbacks.set(t, e); }
            findMappedViewAncestor(t) { let e = t.parent; while (!this._viewToModelMapping.has(e)) {
                e = e.parent;
            } return e; }
            _toModelOffset(t, e, n) { if (n != t) {
                const o = this._toModelOffset(t.parent, t.index, n);
                const i = this._toModelOffset(t, e, t);
                return o + i;
            } if (t.is("$text")) {
                return e;
            } let o = 0; for (let n = 0; n < e; n++) {
                o += this.getModelLength(t.getChild(n));
            } return o; }
            getModelLength(t) { if (this._viewToModelLengthCallbacks.get(t.name)) {
                const e = this._viewToModelLengthCallbacks.get(t.name);
                return e(t);
            }
            else if (this._viewToModelMapping.has(t)) {
                return 1;
            }
            else if (t.is("$text")) {
                return t.data.length;
            }
            else if (t.is("uiElement")) {
                return 0;
            }
            else {
                let e = 0;
                for (const n of t.getChildren()) {
                    e += this.getModelLength(n);
                }
                return e;
            } }
            findPositionIn(t, e) { let n; let o = 0; let i = 0; let r = 0; if (t.is("$text")) {
                return new vl(t, e);
            } while (i < e) {
                n = t.getChild(r);
                o = this.getModelLength(n);
                i += o;
                r++;
            } if (i == e) {
                return this._moveViewPositionToTextNode(new vl(t, r));
            }
            else {
                return this.findPositionIn(n, e - (i - o));
            } }
            _moveViewPositionToTextNode(t) { const e = t.nodeBefore; const n = t.nodeAfter; if (e instanceof Na) {
                return new vl(e, e.data.length);
            }
            else if (n instanceof Na) {
                return new vl(n, 0);
            } return t; }
        }
        qn($f, g);
        class Gf {
            constructor() { this._consumable = new Map; this._textProxyRegistry = new Map; }
            add(t, e) { e = Uf(e); if (t instanceof Of) {
                t = this._getSymbolForTextProxy(t);
            } if (!this._consumable.has(t)) {
                this._consumable.set(t, new Map);
            } this._consumable.get(t).set(e, true); }
            consume(t, e) { e = Uf(e); if (t instanceof Of) {
                t = this._getSymbolForTextProxy(t);
            } if (this.test(t, e)) {
                this._consumable.get(t).set(e, false);
                return true;
            }
            else {
                return false;
            } }
            test(t, e) { e = Uf(e); if (t instanceof Of) {
                t = this._getSymbolForTextProxy(t);
            } const n = this._consumable.get(t); if (n === undefined) {
                return null;
            } const o = n.get(e); if (o === undefined) {
                return null;
            } return o; }
            revert(t, e) { e = Uf(e); if (t instanceof Of) {
                t = this._getSymbolForTextProxy(t);
            } const n = this.test(t, e); if (n === false) {
                this._consumable.get(t).set(e, true);
                return true;
            }
            else if (n === true) {
                return false;
            } return null; }
            _getSymbolForTextProxy(t) { let e = null; const n = this._textProxyRegistry.get(t.startOffset); if (n) {
                const o = n.get(t.endOffset);
                if (o) {
                    e = o.get(t.parent);
                }
            } if (!e) {
                e = this._addSymbolForTextProxy(t.startOffset, t.endOffset, t.parent);
            } return e; }
            _addSymbolForTextProxy(t, e, n) { const o = Symbol("textProxySymbol"); let i, r; i = this._textProxyRegistry.get(t); if (!i) {
                i = new Map;
                this._textProxyRegistry.set(t, i);
            } r = i.get(e); if (!r) {
                r = new Map;
                i.set(e, r);
            } r.set(n, o); return o; }
        }
        function Uf(t) { const e = t.split(":"); return e.length > 1 ? e[0] + ":" + e[1] : e[0]; }
        class Jf {
            constructor(t) { this.conversionApi = Object.assign({ dispatcher: this }, t); this._reconversionEventsMapping = new Map; }
            convertChanges(t, e, n) { for (const e of t.getMarkersToRemove()) {
                this.convertMarkerRemove(e.name, e.range, n);
            } const o = this._mapChangesWithAutomaticReconversion(t); for (const t of o) {
                if (t.type === "insert") {
                    this.convertInsert(Wf._createFromPositionAndShift(t.position, t.length), n);
                }
                else if (t.type === "remove") {
                    this.convertRemove(t.position, t.length, t.name, n);
                }
                else if (t.type === "reconvert") {
                    this.reconvertElement(t.element, n);
                }
                else {
                    this.convertAttribute(t.range, t.attributeKey, t.attributeOldValue, t.attributeNewValue, n);
                }
            } for (const t of this.conversionApi.mapper.flushUnboundMarkerNames()) {
                const o = e.get(t).getRange();
                this.convertMarkerRemove(t, o, n);
                this.convertMarkerAdd(t, o, n);
            } for (const e of t.getMarkersToAdd()) {
                this.convertMarkerAdd(e.name, e.range, n);
            } }
            convertInsert(t, e) { this.conversionApi.writer = e; this.conversionApi.consumable = this._createInsertConsumable(t); for (const e of Array.from(t).map(Xf)) {
                this._convertInsertWithAttributes(e);
            } this._clearConversionApi(); }
            convertRemove(t, e, n, o) { this.conversionApi.writer = o; this.fire("remove:" + n, { position: t, length: e }, this.conversionApi); this._clearConversionApi(); }
            convertAttribute(t, e, n, o, i) { this.conversionApi.writer = i; this.conversionApi.consumable = this._createConsumableForRange(t, `attribute:${e}`); for (const i of t) {
                const t = i.item;
                const r = Wf._createFromPositionAndShift(i.previousPosition, i.length);
                const s = { item: t, range: r, attributeKey: e, attributeOldValue: n, attributeNewValue: o };
                this._testAndFire(`attribute:${e}`, s);
            } this._clearConversionApi(); }
            reconvertElement(t, e) { const n = Wf._createOn(t); this.conversionApi.writer = e; this.conversionApi.consumable = this._createInsertConsumable(n); const o = this.conversionApi.mapper; const i = o.toViewElement(t); e.remove(i); this._convertInsertWithAttributes({ item: t, range: n }); const r = o.toViewElement(t); for (const n of Wf._createIn(t)) {
                const { item: t } = n;
                const i = Zf(t, o);
                if (i) {
                    if (i.root !== r.root) {
                        e.move(e.createRangeOn(i), o.toViewPosition(qf._createBefore(t)));
                    }
                }
                else {
                    this._convertInsertWithAttributes(Xf(n));
                }
            } o.unbindViewElement(i); this._clearConversionApi(); }
            convertSelection(t, e, n) { const o = Array.from(e.getMarkersAtPosition(t.getFirstPosition())); this.conversionApi.writer = n; this.conversionApi.consumable = this._createSelectionConsumable(t, o); this.fire("selection", { selection: t }, this.conversionApi); if (!t.isCollapsed) {
                return;
            } for (const e of o) {
                const n = e.getRange();
                if (!Yf(t.getFirstPosition(), e, this.conversionApi.mapper)) {
                    continue;
                }
                const o = { item: t, markerName: e.name, markerRange: n };
                if (this.conversionApi.consumable.test(t, "addMarker:" + e.name)) {
                    this.fire("addMarker:" + e.name, o, this.conversionApi);
                }
            } for (const e of t.getAttributeKeys()) {
                const n = { item: t, range: t.getFirstRange(), attributeKey: e, attributeOldValue: null, attributeNewValue: t.getAttribute(e) };
                if (this.conversionApi.consumable.test(t, "attribute:" + n.attributeKey)) {
                    this.fire("attribute:" + n.attributeKey + ":$text", n, this.conversionApi);
                }
            } this._clearConversionApi(); }
            convertMarkerAdd(t, e, n) { if (e.root.rootName == "$graveyard") {
                return;
            } this.conversionApi.writer = n; const o = "addMarker:" + t; const i = new Gf; i.add(e, o); this.conversionApi.consumable = i; this.fire(o, { markerName: t, markerRange: e }, this.conversionApi); if (!i.test(e, o)) {
                return;
            } this.conversionApi.consumable = this._createConsumableForRange(e, o); for (const n of e.getItems()) {
                if (!this.conversionApi.consumable.test(n, o)) {
                    continue;
                }
                const i = { item: n, range: Wf._createOn(n), markerName: t, markerRange: e };
                this.fire(o, i, this.conversionApi);
            } this._clearConversionApi(); }
            convertMarkerRemove(t, e, n) { if (e.root.rootName == "$graveyard") {
                return;
            } this.conversionApi.writer = n; this.fire("removeMarker:" + t, { markerName: t, markerRange: e }, this.conversionApi); this._clearConversionApi(); }
            _mapReconversionTriggerEvent(t, e) { this._reconversionEventsMapping.set(e, t); }
            _createInsertConsumable(t) { const e = new Gf; for (const n of t) {
                const t = n.item;
                e.add(t, "insert");
                for (const n of t.getAttributeKeys()) {
                    e.add(t, "attribute:" + n);
                }
            } return e; }
            _createConsumableForRange(t, e) { const n = new Gf; for (const o of t.getItems()) {
                n.add(o, e);
            } return n; }
            _createSelectionConsumable(t, e) { const n = new Gf; n.add(t, "selection"); for (const o of e) {
                n.add(t, "addMarker:" + o.name);
            } for (const e of t.getAttributeKeys()) {
                n.add(t, "attribute:" + e);
            } return n; }
            _testAndFire(t, e) { if (!this.conversionApi.consumable.test(e.item, t)) {
                return;
            } this.fire(Qf(t, e), e, this.conversionApi); }
            _clearConversionApi() { delete this.conversionApi.writer; delete this.conversionApi.consumable; }
            _convertInsertWithAttributes(t) { this._testAndFire("insert", t); for (const e of t.item.getAttributeKeys()) {
                t.attributeKey = e;
                t.attributeOldValue = null;
                t.attributeNewValue = t.item.getAttribute(e);
                this._testAndFire(`attribute:${e}`, t);
            } }
            _mapChangesWithAutomaticReconversion(t) { const e = new Set; const n = []; for (const o of t.getChanges()) {
                const t = o.position || o.range.start;
                const i = t.parent;
                const r = Kf(t, i);
                if (r) {
                    n.push(o);
                    continue;
                }
                const s = o.type === "attribute" ? jf(t, i, null) : i;
                if (s.is("$text")) {
                    n.push(o);
                    continue;
                }
                let a;
                if (o.type === "attribute") {
                    a = `attribute:${o.attributeKey}:${s.name}`;
                }
                else {
                    a = `${o.type}:${o.name}`;
                }
                if (this._isReconvertTriggerEvent(a, s.name)) {
                    if (e.has(s)) {
                        continue;
                    }
                    e.add(s);
                    n.push({ type: "reconvert", element: s });
                }
                else {
                    n.push(o);
                }
            } return n; }
            _isReconvertTriggerEvent(t, e) { return this._reconversionEventsMapping.get(t) === e; }
        }
        qn(Jf, g);
        function Yf(t, e, n) { const o = e.getRange(); const i = Array.from(t.getAncestors()); i.shift(); i.reverse(); const r = i.some((t => { if (o.containsItem(t)) {
            const e = n.toViewElement(t);
            return !!e.getCustomProperty("addHighlight");
        } })); return !r; }
        function Qf(t, e) { const n = e.item.name || "$text"; return `${t}:${n}`; }
        function Xf(t) { const e = t.item; const n = Wf._createFromPositionAndShift(t.previousPosition, t.length); return { item: e, range: n }; }
        function Zf(t, e) { if (t.is("textProxy")) {
            const n = e.toViewPosition(qf._createBefore(t));
            const o = n.parent;
            return o.is("$text") ? o : null;
        } return e.toViewElement(t); }
        class tp {
            constructor(t, e, n) { this._lastRangeBackward = false; this._ranges = []; this._attrs = new Map; if (t) {
                this.setTo(t, e, n);
            } }
            get anchor() { if (this._ranges.length > 0) {
                const t = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? t.end : t.start;
            } return null; }
            get focus() { if (this._ranges.length > 0) {
                const t = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? t.start : t.end;
            } return null; }
            get isCollapsed() { const t = this._ranges.length; if (t === 1) {
                return this._ranges[0].isCollapsed;
            }
            else {
                return false;
            } }
            get rangeCount() { return this._ranges.length; }
            get isBackward() { return !this.isCollapsed && this._lastRangeBackward; }
            isEqual(t) { if (this.rangeCount != t.rangeCount) {
                return false;
            }
            else if (this.rangeCount === 0) {
                return true;
            } if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) {
                return false;
            } for (const e of this._ranges) {
                let n = false;
                for (const o of t._ranges) {
                    if (e.isEqual(o)) {
                        n = true;
                        break;
                    }
                }
                if (!n) {
                    return false;
                }
            } return true; }
            *getRanges() { for (const t of this._ranges) {
                yield new Wf(t.start, t.end);
            } }
            getFirstRange() { let t = null; for (const e of this._ranges) {
                if (!t || e.start.isBefore(t.start)) {
                    t = e;
                }
            } return t ? new Wf(t.start, t.end) : null; }
            getLastRange() { let t = null; for (const e of this._ranges) {
                if (!t || e.end.isAfter(t.end)) {
                    t = e;
                }
            } return t ? new Wf(t.start, t.end) : null; }
            getFirstPosition() { const t = this.getFirstRange(); return t ? t.start.clone() : null; }
            getLastPosition() { const t = this.getLastRange(); return t ? t.end.clone() : null; }
            setTo(t, e, n) { if (t === null) {
                this._setRanges([]);
            }
            else if (t instanceof tp) {
                this._setRanges(t.getRanges(), t.isBackward);
            }
            else if (t && typeof t.getRanges == "function") {
                this._setRanges(t.getRanges(), t.isBackward);
            }
            else if (t instanceof Wf) {
                this._setRanges([t], !!e && !!e.backward);
            }
            else if (t instanceof qf) {
                this._setRanges([new Wf(t)]);
            }
            else if (t instanceof Rf) {
                const o = !!n && !!n.backward;
                let i;
                if (e == "in") {
                    i = Wf._createIn(t);
                }
                else if (e == "on") {
                    i = Wf._createOn(t);
                }
                else if (e !== undefined) {
                    i = new Wf(qf._createAt(t, e));
                }
                else {
                    throw new u["a"]("model-selection-setto-required-second-parameter", [this, t]);
                }
                this._setRanges([i], o);
            }
            else if (ka(t)) {
                this._setRanges(t, e && !!e.backward);
            }
            else {
                throw new u["a"]("model-selection-setto-not-selectable", [this, t]);
            } }
            _setRanges(t, e = false) { t = Array.from(t); const n = t.some((e => { if (!(e instanceof Wf)) {
                throw new u["a"]("model-selection-set-ranges-not-range", [this, t]);
            } return this._ranges.every((t => !t.isEqual(e))); })); if (t.length === this._ranges.length && !n) {
                return;
            } this._removeAllRanges(); for (const e of t) {
                this._pushRange(e);
            } this._lastRangeBackward = !!e; this.fire("change:range", { directChange: true }); }
            setFocus(t, e) { if (this.anchor === null) {
                throw new u["a"]("model-selection-setfocus-no-ranges", [this, t]);
            } const n = qf._createAt(t, e); if (n.compareWith(this.focus) == "same") {
                return;
            } const o = this.anchor; if (this._ranges.length) {
                this._popRange();
            } if (n.compareWith(o) == "before") {
                this._pushRange(new Wf(n, o));
                this._lastRangeBackward = true;
            }
            else {
                this._pushRange(new Wf(o, n));
                this._lastRangeBackward = false;
            } this.fire("change:range", { directChange: true }); }
            getAttribute(t) { return this._attrs.get(t); }
            getAttributes() { return this._attrs.entries(); }
            getAttributeKeys() { return this._attrs.keys(); }
            hasAttribute(t) { return this._attrs.has(t); }
            removeAttribute(t) { if (this.hasAttribute(t)) {
                this._attrs.delete(t);
                this.fire("change:attribute", { attributeKeys: [t], directChange: true });
            } }
            setAttribute(t, e) { if (this.getAttribute(t) !== e) {
                this._attrs.set(t, e);
                this.fire("change:attribute", { attributeKeys: [t], directChange: true });
            } }
            getSelectedElement() { if (this.rangeCount !== 1) {
                return null;
            } return this.getFirstRange().getContainedElement(); }
            is(t) { return t === "selection" || t === "model:selection"; }
            *getSelectedBlocks() { const t = new WeakSet; for (const e of this.getRanges()) {
                const n = op(e.start, t);
                if (n && ip(n, e)) {
                    yield n;
                }
                for (const n of e.getWalker()) {
                    const o = n.item;
                    if (n.type == "elementEnd" && np(o, t, e)) {
                        yield o;
                    }
                }
                const o = op(e.end, t);
                if (o && !e.end.isTouching(qf._createAt(o, 0)) && ip(o, e)) {
                    yield o;
                }
            } }
            containsEntireContent(t = this.anchor.root) { const e = qf._createAt(t, 0); const n = qf._createAt(t, "end"); return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition()); }
            _pushRange(t) { this._checkRange(t); this._ranges.push(new Wf(t.start, t.end)); }
            _checkRange(t) { for (let e = 0; e < this._ranges.length; e++) {
                if (t.isIntersecting(this._ranges[e])) {
                    throw new u["a"]("model-selection-range-intersects", [this, t], { addedRange: t, intersectingRange: this._ranges[e] });
                }
            } }
            _removeAllRanges() { while (this._ranges.length > 0) {
                this._popRange();
            } }
            _popRange() { this._ranges.pop(); }
        }
        qn(tp, g);
        function ep(t, e) { if (e.has(t)) {
            return false;
        } e.add(t); return t.root.document.model.schema.isBlock(t) && t.parent; }
        function np(t, e, n) { return ep(t, e) && ip(t, n); }
        function op(t, e) { const n = t.parent; const o = n.root.document.model.schema; const i = t.parent.getAncestors({ parentFirst: true, includeSelf: true }); let r = false; const s = i.find((t => { if (r) {
            return false;
        } r = o.isLimit(t); return !r && ep(t, e); })); i.forEach((t => e.add(t))); return s; }
        function ip(t, e) { const n = rp(t); if (!n) {
            return true;
        } const o = e.containsRange(Wf._createOn(n), true); return !o; }
        function rp(t) { const e = t.root.document.model.schema; let n = t.parent; while (n) {
            if (e.isBlock(n)) {
                return n;
            }
            n = n.parent;
        } }
        class sp extends Wf {
            constructor(t, e) { super(t, e); ap.call(this); }
            detach() { this.stopListening(); }
            is(t) { return t === "liveRange" || t === "model:liveRange" || t == "range" || t === "model:range"; }
            toRange() { return new Wf(this.start, this.end); }
            static fromRange(t) { return new sp(t.start, t.end); }
        }
        function ap() { this.listenTo(this.root.document.model, "applyOperation", ((t, e) => { const n = e[0]; if (!n.isDocumentOperation) {
            return;
        } cp.call(this, n); }), { priority: "low" }); }
        function cp(t) { const e = this.getTransformedByOperation(t); const n = Wf._createFromRanges(e); const o = !n.isEqual(this); const i = lp(this, t); let r = null; if (o) {
            if (n.root.rootName == "$graveyard") {
                if (t.type == "remove") {
                    r = t.sourcePosition;
                }
                else {
                    r = t.deletionPosition;
                }
            }
            const e = this.toRange();
            this.start = n.start;
            this.end = n.end;
            this.fire("change:range", e, { deletionPosition: r });
        }
        else if (i) {
            this.fire("change:content", this.toRange(), { deletionPosition: r });
        } }
        function lp(t, e) { switch (e.type) {
            case "insert": return t.containsPosition(e.position);
            case "move":
            case "remove":
            case "reinsert":
            case "merge": return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);
            case "split": return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
        } return false; }
        qn(sp, g);
        const dp = "selection:";
        class up {
            constructor(t) { this._selection = new hp(t); this._selection.delegate("change:range").to(this); this._selection.delegate("change:attribute").to(this); this._selection.delegate("change:marker").to(this); }
            get isCollapsed() { return this._selection.isCollapsed; }
            get anchor() { return this._selection.anchor; }
            get focus() { return this._selection.focus; }
            get rangeCount() { return this._selection.rangeCount; }
            get hasOwnRange() { return this._selection.hasOwnRange; }
            get isBackward() { return this._selection.isBackward; }
            get isGravityOverridden() { return this._selection.isGravityOverridden; }
            get markers() { return this._selection.markers; }
            get _ranges() { return this._selection._ranges; }
            getRanges() { return this._selection.getRanges(); }
            getFirstPosition() { return this._selection.getFirstPosition(); }
            getLastPosition() { return this._selection.getLastPosition(); }
            getFirstRange() { return this._selection.getFirstRange(); }
            getLastRange() { return this._selection.getLastRange(); }
            getSelectedBlocks() { return this._selection.getSelectedBlocks(); }
            getSelectedElement() { return this._selection.getSelectedElement(); }
            containsEntireContent(t) { return this._selection.containsEntireContent(t); }
            destroy() { this._selection.destroy(); }
            getAttributeKeys() { return this._selection.getAttributeKeys(); }
            getAttributes() { return this._selection.getAttributes(); }
            getAttribute(t) { return this._selection.getAttribute(t); }
            hasAttribute(t) { return this._selection.hasAttribute(t); }
            refresh() { this._selection._updateMarkers(); this._selection._updateAttributes(false); }
            observeMarkers(t) { this._selection.observeMarkers(t); }
            is(t) { return t === "selection" || t == "model:selection" || t == "documentSelection" || t == "model:documentSelection"; }
            _setFocus(t, e) { this._selection.setFocus(t, e); }
            _setTo(t, e, n) { this._selection.setTo(t, e, n); }
            _setAttribute(t, e) { this._selection.setAttribute(t, e); }
            _removeAttribute(t) { this._selection.removeAttribute(t); }
            _getStoredAttributes() { return this._selection._getStoredAttributes(); }
            _overrideGravity() { return this._selection.overrideGravity(); }
            _restoreGravity(t) { this._selection.restoreGravity(t); }
            static _getStoreAttributeKey(t) { return dp + t; }
            static _isStoreAttributeKey(t) { return t.startsWith(dp); }
        }
        qn(up, g);
        class hp extends tp {
            constructor(t) { super(); this.markers = new ba({ idProperty: "name" }); this._model = t.model; this._document = t; this._attributePriority = new Map; this._selectionRestorePosition = null; this._hasChangedRange = false; this._overriddenGravityRegister = new Set; this._observedMarkers = new Set; this.listenTo(this._model, "applyOperation", ((t, e) => { const n = e[0]; if (!n.isDocumentOperation || n.type == "marker" || n.type == "rename" || n.type == "noop") {
                return;
            } if (this._ranges.length == 0 && this._selectionRestorePosition) {
                this._fixGraveyardSelection(this._selectionRestorePosition);
            } this._selectionRestorePosition = null; if (this._hasChangedRange) {
                this._hasChangedRange = false;
                this.fire("change:range", { directChange: false });
            } }), { priority: "lowest" }); this.on("change:range", (() => { for (const t of this.getRanges()) {
                if (!this._document._validateSelectionRange(t)) {
                    throw new u["a"]("document-selection-wrong-position", this, { range: t });
                }
            } })); this.listenTo(this._model.markers, "update", ((t, e, n, o) => { this._updateMarker(e, o); })); this.listenTo(this._document, "change", ((t, e) => { pp(this._model, e); })); }
            get isCollapsed() { const t = this._ranges.length; return t === 0 ? this._document._getDefaultRange().isCollapsed : super.isCollapsed; }
            get anchor() { return super.anchor || this._document._getDefaultRange().start; }
            get focus() { return super.focus || this._document._getDefaultRange().end; }
            get rangeCount() { return this._ranges.length ? this._ranges.length : 1; }
            get hasOwnRange() { return this._ranges.length > 0; }
            get isGravityOverridden() { return !!this._overriddenGravityRegister.size; }
            destroy() { for (let t = 0; t < this._ranges.length; t++) {
                this._ranges[t].detach();
            } this.stopListening(); }
            *getRanges() { if (this._ranges.length) {
                yield* super.getRanges();
            }
            else {
                yield this._document._getDefaultRange();
            } }
            getFirstRange() { return super.getFirstRange() || this._document._getDefaultRange(); }
            getLastRange() { return super.getLastRange() || this._document._getDefaultRange(); }
            setTo(t, e, n) { super.setTo(t, e, n); this._updateAttributes(true); this._updateMarkers(); }
            setFocus(t, e) { super.setFocus(t, e); this._updateAttributes(true); this._updateMarkers(); }
            setAttribute(t, e) { if (this._setAttribute(t, e)) {
                const e = [t];
                this.fire("change:attribute", { attributeKeys: e, directChange: true });
            } }
            removeAttribute(t) { if (this._removeAttribute(t)) {
                const e = [t];
                this.fire("change:attribute", { attributeKeys: e, directChange: true });
            } }
            overrideGravity() { const t = a(); this._overriddenGravityRegister.add(t); if (this._overriddenGravityRegister.size === 1) {
                this._updateAttributes(true);
            } return t; }
            restoreGravity(t) { if (!this._overriddenGravityRegister.has(t)) {
                throw new u["a"]("document-selection-gravity-wrong-restore", this, { uid: t });
            } this._overriddenGravityRegister.delete(t); if (!this.isGravityOverridden) {
                this._updateAttributes(true);
            } }
            observeMarkers(t) { this._observedMarkers.add(t); this._updateMarkers(); }
            _popRange() { this._ranges.pop().detach(); }
            _pushRange(t) { const e = this._prepareRange(t); if (e) {
                this._ranges.push(e);
            } }
            _prepareRange(t) { this._checkRange(t); if (t.root == this._document.graveyard) {
                return;
            } const e = sp.fromRange(t); e.on("change:range", ((t, n, o) => { this._hasChangedRange = true; if (e.root == this._document.graveyard) {
                this._selectionRestorePosition = o.deletionPosition;
                const t = this._ranges.indexOf(e);
                this._ranges.splice(t, 1);
                e.detach();
            } })); return e; }
            _updateMarkers() { if (!this._observedMarkers.size) {
                return;
            } const t = []; let e = false; for (const e of this._model.markers) {
                const n = e.name.split(":", 1)[0];
                if (!this._observedMarkers.has(n)) {
                    continue;
                }
                const o = e.getRange();
                for (const n of this.getRanges()) {
                    if (o.containsRange(n, !n.isCollapsed)) {
                        t.push(e);
                    }
                }
            } const n = Array.from(this.markers); for (const n of t) {
                if (!this.markers.has(n)) {
                    this.markers.add(n);
                    e = true;
                }
            } for (const n of Array.from(this.markers)) {
                if (!t.includes(n)) {
                    this.markers.remove(n);
                    e = true;
                }
            } if (e) {
                this.fire("change:marker", { oldMarkers: n, directChange: false });
            } }
            _updateMarker(t, e) { const n = t.name.split(":", 1)[0]; if (!this._observedMarkers.has(n)) {
                return;
            } let o = false; const i = Array.from(this.markers); const r = this.markers.has(t); if (!e) {
                if (r) {
                    this.markers.remove(t);
                    o = true;
                }
            }
            else {
                let n = false;
                for (const t of this.getRanges()) {
                    if (e.containsRange(t, !t.isCollapsed)) {
                        n = true;
                        break;
                    }
                }
                if (n && !r) {
                    this.markers.add(t);
                    o = true;
                }
                else if (!n && r) {
                    this.markers.remove(t);
                    o = true;
                }
            } if (o) {
                this.fire("change:marker", { oldMarkers: i, directChange: false });
            } }
            _updateAttributes(t) { const e = La(this._getSurroundingAttributes()); const n = La(this.getAttributes()); if (t) {
                this._attributePriority = new Map;
                this._attrs = new Map;
            }
            else {
                for (const [t, e] of this._attributePriority) {
                    if (e == "low") {
                        this._attrs.delete(t);
                        this._attributePriority.delete(t);
                    }
                }
            } this._setAttributesTo(e); const o = []; for (const [t, e] of this.getAttributes()) {
                if (!n.has(t) || n.get(t) !== e) {
                    o.push(t);
                }
            } for (const [t] of n) {
                if (!this.hasAttribute(t)) {
                    o.push(t);
                }
            } if (o.length > 0) {
                this.fire("change:attribute", { attributeKeys: o, directChange: false });
            } }
            _setAttribute(t, e, n = true) { const o = n ? "normal" : "low"; if (o == "low" && this._attributePriority.get(t) == "normal") {
                return false;
            } const i = super.getAttribute(t); if (i === e) {
                return false;
            } this._attrs.set(t, e); this._attributePriority.set(t, o); return true; }
            _removeAttribute(t, e = true) { const n = e ? "normal" : "low"; if (n == "low" && this._attributePriority.get(t) == "normal") {
                return false;
            } this._attributePriority.set(t, n); if (!super.hasAttribute(t)) {
                return false;
            } this._attrs.delete(t); return true; }
            _setAttributesTo(t) { const e = new Set; for (const [e, n] of this.getAttributes()) {
                if (t.get(e) === n) {
                    continue;
                }
                this._removeAttribute(e, false);
            } for (const [n, o] of t) {
                const t = this._setAttribute(n, o, false);
                if (t) {
                    e.add(n);
                }
            } return e; }
            *_getStoredAttributes() { const t = this.getFirstPosition().parent; if (this.isCollapsed && t.isEmpty) {
                for (const e of t.getAttributeKeys()) {
                    if (e.startsWith(dp)) {
                        const n = e.substr(dp.length);
                        yield [n, t.getAttribute(e)];
                    }
                }
            } }
            _getSurroundingAttributes() { const t = this.getFirstPosition(); const e = this._model.schema; let n = null; if (!this.isCollapsed) {
                const t = this.getFirstRange();
                for (const o of t) {
                    if (o.item.is("element") && e.isObject(o.item)) {
                        break;
                    }
                    if (o.type == "text") {
                        n = o.item.getAttributes();
                        break;
                    }
                }
            }
            else {
                const o = t.textNode ? t.textNode : t.nodeBefore;
                const i = t.textNode ? t.textNode : t.nodeAfter;
                if (!this.isGravityOverridden) {
                    n = fp(o);
                }
                if (!n) {
                    n = fp(i);
                }
                if (!this.isGravityOverridden && !n) {
                    let t = o;
                    while (t && !e.isInline(t) && !n) {
                        t = t.previousSibling;
                        n = fp(t);
                    }
                }
                if (!n) {
                    let t = i;
                    while (t && !e.isInline(t) && !n) {
                        t = t.nextSibling;
                        n = fp(t);
                    }
                }
                if (!n) {
                    n = this._getStoredAttributes();
                }
            } return n; }
            _fixGraveyardSelection(t) { const e = this._model.schema.getNearestSelectionRange(t); if (e) {
                this._pushRange(e);
            } }
        }
        function fp(t) { if (t instanceof Of || t instanceof Ff) {
            return t.getAttributes();
        } return null; }
        function pp(t, e) { const n = t.document.differ; for (const o of n.getChanges()) {
            if (o.type != "insert") {
                continue;
            }
            const n = o.position.parent;
            const i = o.length === n.maxOffset;
            if (i) {
                t.enqueueChange(e, (t => { const e = Array.from(n.getAttributeKeys()).filter((t => t.startsWith(dp))); for (const o of e) {
                    t.removeAttribute(o, n);
                } }));
            }
        } }
        class gp {
            constructor(t) { this._dispatchers = t; }
            add(t) { for (const e of this._dispatchers) {
                t(e);
            } return this; }
        }
        var mp = 1, kp = 4;
        function bp(t) { return aa(t, mp | kp); }
        var wp = bp;
        class _p extends gp {
            elementToElement(t) { return this.add(Lp(t)); }
            attributeToElement(t) { return this.add(qp(t)); }
            attributeToAttribute(t) { return this.add(Kp(t)); }
            markerToElement(t) { return this.add(jp(t)); }
            markerToHighlight(t) { return this.add(Wp(t)); }
            markerToData(t) { return this.add(Hp(t)); }
        }
        function vp() { return (t, e, n) => { if (!n.consumable.consume(e.item, "insert")) {
            return;
        } const o = n.writer; const i = n.mapper.toViewPosition(e.range.start); const r = o.createText(e.item.data); o.insert(i, r); }; }
        function Ap() { return (t, e, n) => { const o = n.mapper.toViewPosition(e.position); const i = e.position.getShiftedBy(e.length); const r = n.mapper.toViewPosition(i, { isPhantom: true }); const s = n.writer.createRange(o, r); const a = n.writer.remove(s.getTrimmed()); for (const t of n.writer.createRangeIn(a).getItems()) {
            n.mapper.unbindViewElement(t);
        } }; }
        function Cp(t, e) { const n = t.createAttributeElement("span", e.attributes); if (e.classes) {
            n._addClass(e.classes);
        } if (e.priority) {
            n._priority = e.priority;
        } n._id = e.id; return n; }
        function yp() { return (t, e, n) => { const o = e.selection; if (o.isCollapsed) {
            return;
        } if (!n.consumable.consume(o, "selection")) {
            return;
        } const i = []; for (const t of o.getRanges()) {
            const e = n.mapper.toViewRange(t);
            i.push(e);
        } n.writer.setSelection(i, { backward: o.isBackward }); }; }
        function xp() { return (t, e, n) => { const o = e.selection; if (!o.isCollapsed) {
            return;
        } if (!n.consumable.consume(o, "selection")) {
            return;
        } const i = n.writer; const r = o.getFirstPosition(); const s = n.mapper.toViewPosition(r); const a = i.breakAttributes(s); i.setSelection(a); }; }
        function Ep() { return (t, e, n) => { const o = n.writer; const i = o.document.selection; for (const t of i.getRanges()) {
            if (t.isCollapsed) {
                if (t.end.parent.isAttached()) {
                    n.writer.mergeAttributes(t.start);
                }
            }
        } o.setSelection(null); }; }
        function Dp(t) { return (e, n, o) => { const i = t(n.attributeOldValue, o); const r = t(n.attributeNewValue, o); if (!i && !r) {
            return;
        } if (!o.consumable.consume(n.item, e.name)) {
            return;
        } const s = o.writer; const a = s.document.selection; if (n.item instanceof tp || n.item instanceof up) {
            s.wrap(a.getFirstRange(), r);
        }
        else {
            let t = o.mapper.toViewRange(n.range);
            if (n.attributeOldValue !== null && i) {
                t = s.unwrap(t, i);
            }
            if (n.attributeNewValue !== null && r) {
                s.wrap(t, r);
            }
        } }; }
        function Sp(t) { return (e, n, o) => { const i = t(n.item, o); if (!i) {
            return;
        } if (!o.consumable.consume(n.item, "insert")) {
            return;
        } const r = o.mapper.toViewPosition(n.range.start); o.mapper.bindElements(n.item, i); o.writer.insert(r, i); }; }
        function Tp(t) { return (e, n, o) => { n.isOpening = true; const i = t(n, o); n.isOpening = false; const r = t(n, o); if (!i || !r) {
            return;
        } const s = n.markerRange; if (s.isCollapsed && !o.consumable.consume(s, e.name)) {
            return;
        } for (const t of s) {
            if (!o.consumable.consume(t.item, e.name)) {
                return;
            }
        } const a = o.mapper; const c = o.writer; c.insert(a.toViewPosition(s.start), i); o.mapper.bindElementToMarker(i, n.markerName); if (!s.isCollapsed) {
            c.insert(a.toViewPosition(s.end), r);
            o.mapper.bindElementToMarker(r, n.markerName);
        } e.stop(); }; }
        function Pp() { return (t, e, n) => { const o = n.mapper.markerNameToElements(e.markerName); if (!o) {
            return;
        } for (const t of o) {
            n.mapper.unbindElementFromMarkerName(t, e.markerName);
            n.writer.clear(n.writer.createRangeOn(t), t);
        } n.writer.clearClonedElementsGroup(e.markerName); t.stop(); }; }
        function Bp(t) { return (e, n, o) => { const i = t(n.markerName, o); if (!i) {
            return;
        } const r = n.markerRange; if (!o.consumable.consume(r, e.name)) {
            return;
        } Ip(r, false, o, n, i); Ip(r, true, o, n, i); e.stop(); }; }
        function Ip(t, e, n, o, i) { const r = e ? t.start : t.end; const s = n.schema.checkChild(r, "$text"); if (s) {
            const t = n.mapper.toViewPosition(r);
            Fp(t, e, n, o, i);
        }
        else {
            let t;
            let s;
            if (e && r.nodeAfter || !e && !r.nodeBefore) {
                t = r.nodeAfter;
                s = true;
            }
            else {
                t = r.nodeBefore;
                s = false;
            }
            const a = n.mapper.toViewElement(t);
            Rp(a, e, s, n, o, i);
        } }
        function Rp(t, e, n, o, i, r) { const s = `data-${r.group}-${e ? "start" : "end"}-${n ? "before" : "after"}`; const a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : []; a.unshift(r.name); o.writer.setAttribute(s, a.join(","), t); o.mapper.bindElementToMarker(t, i.markerName); }
        function Fp(t, e, n, o, i) { const r = `${i.group}-${e ? "start" : "end"}`; const s = i.name ? { name: i.name } : null; const a = n.writer.createUIElement(r, s); n.writer.insert(t, a); n.mapper.bindElementToMarker(a, o.markerName); }
        function Op(t) { return (e, n, o) => { const i = t(n.markerName, o); if (!i) {
            return;
        } const r = o.mapper.markerNameToElements(n.markerName); if (!r) {
            return;
        } for (const t of r) {
            o.mapper.unbindElementFromMarkerName(t, n.markerName);
            if (t.is("containerElement")) {
                s(`data-${i.group}-start-before`, t);
                s(`data-${i.group}-start-after`, t);
                s(`data-${i.group}-end-before`, t);
                s(`data-${i.group}-end-after`, t);
            }
            else {
                o.writer.clear(o.writer.createRangeOn(t), t);
            }
        } o.writer.clearClonedElementsGroup(n.markerName); e.stop(); function s(t, e) { if (e.hasAttribute(t)) {
            const n = new Set(e.getAttribute(t).split(","));
            n.delete(i.name);
            if (n.size == 0) {
                o.writer.removeAttribute(t, e);
            }
            else {
                o.writer.setAttribute(t, Array.from(n).join(","), e);
            }
        } } }; }
        function zp(t) { return (e, n, o) => { const i = t(n.attributeOldValue, o); const r = t(n.attributeNewValue, o); if (!i && !r) {
            return;
        } if (!o.consumable.consume(n.item, e.name)) {
            return;
        } const s = o.mapper.toViewElement(n.item); const a = o.writer; if (!s) {
            throw new u["a"]("conversion-attribute-to-attribute-on-text", [n, o]);
        } if (n.attributeOldValue !== null && i) {
            if (i.key == "class") {
                const t = _a(i.value);
                for (const e of t) {
                    a.removeClass(e, s);
                }
            }
            else if (i.key == "style") {
                const t = Object.keys(i.value);
                for (const e of t) {
                    a.removeStyle(e, s);
                }
            }
            else {
                a.removeAttribute(i.key, s);
            }
        } if (n.attributeNewValue !== null && r) {
            if (r.key == "class") {
                const t = _a(r.value);
                for (const e of t) {
                    a.addClass(e, s);
                }
            }
            else if (r.key == "style") {
                const t = Object.keys(r.value);
                for (const e of t) {
                    a.setStyle(e, r.value[e], s);
                }
            }
            else {
                a.setAttribute(r.key, r.value, s);
            }
        } }; }
        function Np(t) { return (e, n, o) => { if (!n.item) {
            return;
        } if (!(n.item instanceof tp || n.item instanceof up) && !n.item.is("$textProxy")) {
            return;
        } const i = Yp(t, n, o); if (!i) {
            return;
        } if (!o.consumable.consume(n.item, e.name)) {
            return;
        } const r = o.writer; const s = Cp(r, i); const a = r.document.selection; if (n.item instanceof tp || n.item instanceof up) {
            r.wrap(a.getFirstRange(), s, a);
        }
        else {
            const t = o.mapper.toViewRange(n.range);
            const e = r.wrap(t, s);
            for (const t of e.getItems()) {
                if (t.is("attributeElement") && t.isSimilar(s)) {
                    o.mapper.bindElementToMarker(t, n.markerName);
                    break;
                }
            }
        } }; }
        function Mp(t) { return (e, n, o) => { if (!n.item) {
            return;
        } if (!(n.item instanceof Nf)) {
            return;
        } const i = Yp(t, n, o); if (!i) {
            return;
        } if (!o.consumable.test(n.item, e.name)) {
            return;
        } const r = o.mapper.toViewElement(n.item); if (r && r.getCustomProperty("addHighlight")) {
            o.consumable.consume(n.item, e.name);
            for (const t of Wf._createIn(n.item)) {
                o.consumable.consume(t.item, e.name);
            }
            r.getCustomProperty("addHighlight")(r, i, o.writer);
            o.mapper.bindElementToMarker(r, n.markerName);
        } }; }
        function Vp(t) { return (e, n, o) => { if (n.markerRange.isCollapsed) {
            return;
        } const i = Yp(t, n, o); if (!i) {
            return;
        } const r = Cp(o.writer, i); const s = o.mapper.markerNameToElements(n.markerName); if (!s) {
            return;
        } for (const t of s) {
            o.mapper.unbindElementFromMarkerName(t, n.markerName);
            if (t.is("attributeElement")) {
                o.writer.unwrap(o.writer.createRangeOn(t), r);
            }
            else {
                t.getCustomProperty("removeHighlight")(t, i.id, o.writer);
            }
        } o.writer.clearClonedElementsGroup(n.markerName); e.stop(); }; }
        function Lp(t) { t = wp(t); t.view = $p(t.view, "container"); return e => { e.on("insert:" + t.model, Sp(t.view), { priority: t.converterPriority || "normal" }); if (t.triggerBy) {
            if (t.triggerBy.attributes) {
                for (const n of t.triggerBy.attributes) {
                    e._mapReconversionTriggerEvent(t.model, `attribute:${n}:${t.model}`);
                }
            }
            if (t.triggerBy.children) {
                for (const n of t.triggerBy.children) {
                    e._mapReconversionTriggerEvent(t.model, `insert:${n}`);
                    e._mapReconversionTriggerEvent(t.model, `remove:${n}`);
                }
            }
        } }; }
        function qp(t) { t = wp(t); const e = t.model.key ? t.model.key : t.model; let n = "attribute:" + e; if (t.model.name) {
            n += ":" + t.model.name;
        } if (t.model.values) {
            for (const e of t.model.values) {
                t.view[e] = $p(t.view[e], "attribute");
            }
        }
        else {
            t.view = $p(t.view, "attribute");
        } const o = Up(t); return e => { e.on(n, Dp(o), { priority: t.converterPriority || "normal" }); }; }
        function Kp(t) { t = wp(t); const e = t.model.key ? t.model.key : t.model; let n = "attribute:" + e; if (t.model.name) {
            n += ":" + t.model.name;
        } if (t.model.values) {
            for (const e of t.model.values) {
                t.view[e] = Jp(t.view[e]);
            }
        }
        else {
            t.view = Jp(t.view);
        } const o = Up(t); return e => { e.on(n, zp(o), { priority: t.converterPriority || "normal" }); }; }
        function jp(t) { t = wp(t); t.view = $p(t.view, "ui"); return e => { e.on("addMarker:" + t.model, Tp(t.view), { priority: t.converterPriority || "normal" }); e.on("removeMarker:" + t.model, Pp(t.view), { priority: t.converterPriority || "normal" }); }; }
        function Hp(t) { t = wp(t); const e = t.model; if (!t.view) {
            t.view = n => ({ group: e, name: n.substr(t.model.length + 1) });
        } return n => { n.on("addMarker:" + e, Bp(t.view), { priority: t.converterPriority || "normal" }); n.on("removeMarker:" + e, Op(t.view), { priority: t.converterPriority || "normal" }); }; }
        function Wp(t) { return e => { e.on("addMarker:" + t.model, Np(t.view), { priority: t.converterPriority || "normal" }); e.on("addMarker:" + t.model, Mp(t.view), { priority: t.converterPriority || "normal" }); e.on("removeMarker:" + t.model, Vp(t.view), { priority: t.converterPriority || "normal" }); }; }
        function $p(t, e) { if (typeof t == "function") {
            return t;
        } return (n, o) => Gp(t, o, e); }
        function Gp(t, e, n) { if (typeof t == "string") {
            t = { name: t };
        } let o; const i = e.writer; const r = Object.assign({}, t.attributes); if (n == "container") {
            o = i.createContainerElement(t.name, r);
        }
        else if (n == "attribute") {
            const e = { priority: t.priority || Ml.DEFAULT_PRIORITY };
            o = i.createAttributeElement(t.name, r, e);
        }
        else {
            o = i.createUIElement(t.name, r);
        } if (t.styles) {
            const e = Object.keys(t.styles);
            for (const n of e) {
                i.setStyle(n, t.styles[n], o);
            }
        } if (t.classes) {
            const e = t.classes;
            if (typeof e == "string") {
                i.addClass(e, o);
            }
            else {
                for (const t of e) {
                    i.addClass(t, o);
                }
            }
        } return o; }
        function Up(t) { if (t.model.values) {
            return (e, n) => { const o = t.view[e]; if (o) {
                return o(e, n);
            } return null; };
        }
        else {
            return t.view;
        } }
        function Jp(t) { if (typeof t == "string") {
            return e => ({ key: t, value: e });
        }
        else if (typeof t == "object") {
            if (t.value) {
                return () => t;
            }
            else {
                return e => ({ key: t.key, value: e });
            }
        }
        else {
            return t;
        } }
        function Yp(t, e, n) { const o = typeof t == "function" ? t(e, n) : t; if (!o) {
            return null;
        } if (!o.priority) {
            o.priority = 10;
        } if (!o.id) {
            o.id = e.markerName;
        } return o; }
        function Qp(t) { const { schema: e, document: n } = t.model; for (const o of n.getRootNames()) {
            const i = n.getRoot(o);
            if (i.isEmpty && !e.checkChild(i, "$text")) {
                if (e.checkChild(i, "paragraph")) {
                    t.insertElement("paragraph", i);
                    return true;
                }
            }
        } return false; }
        function Xp(t, e, n) { const o = n.createContext(t); if (!n.checkChild(o, "paragraph")) {
            return false;
        } if (!n.checkChild(o.push("paragraph"), e)) {
            return false;
        } return true; }
        function Zp(t, e) { const n = e.createElement("paragraph"); e.insert(n, t); return e.createPositionAt(n, 0); }
        class tg extends gp {
            elementToElement(t) { return this.add(ig(t)); }
            elementToAttribute(t) { return this.add(rg(t)); }
            attributeToAttribute(t) { return this.add(sg(t)); }
            elementToMarker(t) { Object(u["b"])("upcast-helpers-element-to-marker-deprecated"); return this.add(ag(t)); }
            dataToMarker(t) { return this.add(cg(t)); }
        }
        function eg() { return (t, e, n) => { if (!e.modelRange && n.consumable.consume(e.viewItem, { name: true })) {
            const { modelRange: t, modelCursor: o } = n.convertChildren(e.viewItem, e.modelCursor);
            e.modelRange = t;
            e.modelCursor = o;
        } }; }
        function ng() { return (t, e, { schema: n, consumable: o, writer: i }) => { let r = e.modelCursor; if (!o.test(e.viewItem)) {
            return;
        } if (!n.checkChild(r, "$text")) {
            if (!Xp(r, "$text", n)) {
                return;
            }
            r = Zp(r, i);
        } o.consume(e.viewItem); const s = i.createText(e.viewItem.data); i.insert(s, r); e.modelRange = i.createRange(r, r.getShiftedBy(s.offsetSize)); e.modelCursor = e.modelRange.end; }; }
        function og(t, e) { return (n, o) => { const i = o.newSelection; const r = []; for (const t of i.getRanges()) {
            r.push(e.toModelRange(t));
        } const s = t.createSelection(r, { backward: i.isBackward }); if (!s.isEqual(t.document.selection)) {
            t.change((t => { t.setSelection(s); }));
        } }; }
        function ig(t) { t = wp(t); const e = ug(t); const n = dg(t.view); const o = n ? "element:" + n : "element"; return n => { n.on(o, e, { priority: t.converterPriority || "normal" }); }; }
        function rg(t) { t = wp(t); pg(t); const e = gg(t, false); const n = dg(t.view); const o = n ? "element:" + n : "element"; return n => { n.on(o, e, { priority: t.converterPriority || "low" }); }; }
        function sg(t) { t = wp(t); let e = null; if (typeof t.view == "string" || t.view.key) {
            e = fg(t);
        } pg(t, e); const n = gg(t, true); return e => { e.on("element", n, { priority: t.converterPriority || "low" }); }; }
        function ag(t) { t = wp(t); bg(t); return ig(t); }
        function cg(t) { t = wp(t); if (!t.model) {
            t.model = e => e ? t.view + ":" + e : t.view;
        } const e = ug(wg(t, "start")); const n = ug(wg(t, "end")); return o => { o.on("element:" + t.view + "-start", e, { priority: t.converterPriority || "normal" }); o.on("element:" + t.view + "-end", n, { priority: t.converterPriority || "normal" }); const i = l.get("low"); const r = l.get("highest"); const s = l.get(t.converterPriority) / r; o.on("element", lg(t), { priority: i + s }); }; }
        function lg(t) { return (e, n, o) => { const i = `data-${t.view}`; if (!n.modelRange) {
            n = Object.assign(n, o.convertChildren(n.viewItem, n.modelCursor));
        } if (o.consumable.consume(n.viewItem, { attributes: i + "-end-after" })) {
            r(n.modelRange.end, n.viewItem.getAttribute(i + "-end-after").split(","));
        } if (o.consumable.consume(n.viewItem, { attributes: i + "-start-after" })) {
            r(n.modelRange.end, n.viewItem.getAttribute(i + "-start-after").split(","));
        } if (o.consumable.consume(n.viewItem, { attributes: i + "-end-before" })) {
            r(n.modelRange.start, n.viewItem.getAttribute(i + "-end-before").split(","));
        } if (o.consumable.consume(n.viewItem, { attributes: i + "-start-before" })) {
            r(n.modelRange.start, n.viewItem.getAttribute(i + "-start-before").split(","));
        } function r(e, i) { for (const r of i) {
            const i = t.model(r, o);
            const s = o.writer.createElement("$marker", { "data-name": i });
            o.writer.insert(s, e);
            if (n.modelCursor.isEqual(e)) {
                n.modelCursor = n.modelCursor.getShiftedBy(1);
            }
            else {
                n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1);
            }
            n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0];
        } } }; }
        function dg(t) { if (typeof t == "string") {
            return t;
        } if (typeof t == "object" && typeof t.name == "string") {
            return t.name;
        } return null; }
        function ug(t) { const e = new qa(t.view); return (n, o, i) => { const r = e.match(o.viewItem); if (!r) {
            return;
        } const s = r.match; s.name = true; if (!i.consumable.test(o.viewItem, s)) {
            return;
        } const a = hg(t.model, o.viewItem, i); if (!a) {
            return;
        } if (!i.safeInsert(a, o.modelCursor)) {
            return;
        } i.consumable.consume(o.viewItem, s); i.convertChildren(o.viewItem, a); i.updateConversionResult(a, o); }; }
        function hg(t, e, n) { if (t instanceof Function) {
            return t(e, n);
        }
        else {
            return n.writer.createElement(t);
        } }
        function fg(t) { if (typeof t.view == "string") {
            t.view = { key: t.view };
        } const e = t.view.key; let n; if (e == "class" || e == "style") {
            const o = e == "class" ? "classes" : "styles";
            n = { [o]: t.view.value };
        }
        else {
            const o = typeof t.view.value == "undefined" ? /[\s\S]*/ : t.view.value;
            n = { attributes: { [e]: o } };
        } if (t.view.name) {
            n.name = t.view.name;
        } t.view = n; return e; }
        function pg(t, e = null) { const n = e === null ? true : t => t.getAttribute(e); const o = typeof t.model != "object" ? t.model : t.model.key; const i = typeof t.model != "object" || typeof t.model.value == "undefined" ? n : t.model.value; t.model = { key: o, value: i }; }
        function gg(t, e) { const n = new qa(t.view); return (o, i, r) => { const s = n.match(i.viewItem); if (!s) {
            return;
        } const a = t.model.key; const c = typeof t.model.value == "function" ? t.model.value(i.viewItem, r) : t.model.value; if (c === null) {
            return;
        } if (mg(t.view, i.viewItem)) {
            s.match.name = true;
        }
        else {
            delete s.match.name;
        } if (!r.consumable.test(i.viewItem, s.match)) {
            return;
        } if (!i.modelRange) {
            i = Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
        } const l = kg(i.modelRange, { key: a, value: c }, e, r); if (l) {
            r.consumable.consume(i.viewItem, s.match);
        } }; }
        function mg(t, e) { const n = typeof t == "function" ? t(e) : t; if (typeof n == "object" && !dg(n)) {
            return false;
        } return !n.classes && !n.attributes && !n.styles; }
        function kg(t, e, n, o) { let i = false; for (const r of Array.from(t.getItems({ shallow: n }))) {
            if (!o.schema.checkAttribute(r, e.key)) {
                continue;
            }
            i = true;
            if (r.hasAttribute(e.key)) {
                continue;
            }
            o.writer.setAttribute(e.key, e.value, r);
        } return i; }
        function bg(t) { const e = t.model; t.model = (t, n) => { const o = typeof e == "string" ? e : e(t, n); return n.writer.createElement("$marker", { "data-name": o }); }; }
        function wg(t, e) { const n = {}; n.view = t.view + "-" + e; n.model = (e, n) => { const o = e.getAttribute("name"); const i = t.model(o, n); return n.writer.createElement("$marker", { "data-name": i }); }; return n; }
        class _g {
            constructor(t, e) { this.model = t; this.view = new If(e); this.mapper = new $f; this.downcastDispatcher = new Jf({ mapper: this.mapper, schema: t.schema }); const n = this.model.document; const o = n.selection; const i = this.model.markers; this.listenTo(this.model, "_beforeChanges", (() => { this.view._disableRendering(true); }), { priority: "highest" }); this.listenTo(this.model, "_afterChanges", (() => { this.view._disableRendering(false); }), { priority: "lowest" }); this.listenTo(n, "change", (() => { this.view.change((t => { this.downcastDispatcher.convertChanges(n.differ, i, t); this.downcastDispatcher.convertSelection(o, i, t); })); }), { priority: "low" }); this.listenTo(this.view.document, "selectionChange", og(this.model, this.mapper)); this.downcastDispatcher.on("insert:$text", vp(), { priority: "lowest" }); this.downcastDispatcher.on("remove", Ap(), { priority: "low" }); this.downcastDispatcher.on("selection", Ep(), { priority: "low" }); this.downcastDispatcher.on("selection", yp(), { priority: "low" }); this.downcastDispatcher.on("selection", xp(), { priority: "low" }); this.view.document.roots.bindTo(this.model.document.roots).using((t => { if (t.rootName == "$graveyard") {
                return null;
            } const e = new wl(this.view.document, t.name); e.rootName = t.rootName; this.mapper.bindElements(t, e); return e; })); }
            destroy() { this.view.destroy(); this.stopListening(); }
        }
        qn(_g, Pn);
        class vg {
            constructor() { this._commands = new Map; }
            add(t, e) { this._commands.set(t, e); }
            get(t) { return this._commands.get(t); }
            execute(t, ...e) { const n = this.get(t); if (!n) {
                throw new u["a"]("commandcollection-command-not-found", this, { commandName: t });
            } return n.execute(...e); }
            *names() { yield* this._commands.keys(); }
            *commands() { yield* this._commands.values(); }
            [Symbol.iterator]() { return this._commands[Symbol.iterator](); }
            destroy() { for (const t of this.commands()) {
                t.destroy();
            } }
        }
        class Ag {
            constructor() { this._consumables = new Map; }
            add(t, e) { let n; if (t.is("$text") || t.is("documentFragment")) {
                this._consumables.set(t, true);
                return;
            } if (!this._consumables.has(t)) {
                n = new Cg(t);
                this._consumables.set(t, n);
            }
            else {
                n = this._consumables.get(t);
            } n.add(e); }
            test(t, e) { const n = this._consumables.get(t); if (n === undefined) {
                return null;
            } if (t.is("$text") || t.is("documentFragment")) {
                return n;
            } return n.test(e); }
            consume(t, e) { if (this.test(t, e)) {
                if (t.is("$text") || t.is("documentFragment")) {
                    this._consumables.set(t, false);
                }
                else {
                    this._consumables.get(t).consume(e);
                }
                return true;
            } return false; }
            revert(t, e) { const n = this._consumables.get(t); if (n !== undefined) {
                if (t.is("$text") || t.is("documentFragment")) {
                    this._consumables.set(t, true);
                }
                else {
                    n.revert(e);
                }
            } }
            static consumablesFromElement(t) { const e = { element: t, name: true, attributes: [], classes: [], styles: [] }; const n = t.getAttributeKeys(); for (const t of n) {
                if (t == "style" || t == "class") {
                    continue;
                }
                e.attributes.push(t);
            } const o = t.getClassNames(); for (const t of o) {
                e.classes.push(t);
            } const i = t.getStyleNames(); for (const t of i) {
                e.styles.push(t);
            } return e; }
            static createFrom(t, e) { if (!e) {
                e = new Ag(t);
            } if (t.is("$text")) {
                e.add(t);
                return e;
            } if (t.is("element")) {
                e.add(t, Ag.consumablesFromElement(t));
            } if (t.is("documentFragment")) {
                e.add(t);
            } for (const n of t.getChildren()) {
                e = Ag.createFrom(n, e);
            } return e; }
        }
        class Cg {
            constructor(t) { this.element = t; this._canConsumeName = null; this._consumables = { attributes: new Map, styles: new Map, classes: new Map }; }
            add(t) { if (t.name) {
                this._canConsumeName = true;
            } for (const e in this._consumables) {
                if (e in t) {
                    this._add(e, t[e]);
                }
            } }
            test(t) { if (t.name && !this._canConsumeName) {
                return this._canConsumeName;
            } for (const e in this._consumables) {
                if (e in t) {
                    const n = this._test(e, t[e]);
                    if (n !== true) {
                        return n;
                    }
                }
            } return true; }
            consume(t) { if (t.name) {
                this._canConsumeName = false;
            } for (const e in this._consumables) {
                if (e in t) {
                    this._consume(e, t[e]);
                }
            } }
            revert(t) { if (t.name) {
                this._canConsumeName = true;
            } for (const e in this._consumables) {
                if (e in t) {
                    this._revert(e, t[e]);
                }
            } }
            _add(t, e) { const n = xe(e) ? e : [e]; const o = this._consumables[t]; for (const e of n) {
                if (t === "attributes" && (e === "class" || e === "style")) {
                    throw new u["a"]("viewconsumable-invalid-attribute", this);
                }
                o.set(e, true);
                if (t === "styles") {
                    for (const t of this.element.document.stylesProcessor.getRelatedStyles(e)) {
                        o.set(t, true);
                    }
                }
            } }
            _test(t, e) { const n = xe(e) ? e : [e]; const o = this._consumables[t]; for (const e of n) {
                if (t === "attributes" && (e === "class" || e === "style")) {
                    const t = e == "class" ? "classes" : "styles";
                    const n = this._test(t, [...this._consumables[t].keys()]);
                    if (n !== true) {
                        return n;
                    }
                }
                else {
                    const t = o.get(e);
                    if (t === undefined) {
                        return null;
                    }
                    if (!t) {
                        return false;
                    }
                }
            } return true; }
            _consume(t, e) { const n = xe(e) ? e : [e]; const o = this._consumables[t]; for (const e of n) {
                if (t === "attributes" && (e === "class" || e === "style")) {
                    const t = e == "class" ? "classes" : "styles";
                    this._consume(t, [...this._consumables[t].keys()]);
                }
                else {
                    o.set(e, false);
                    if (t == "styles") {
                        for (const t of this.element.document.stylesProcessor.getRelatedStyles(e)) {
                            o.set(t, false);
                        }
                    }
                }
            } }
            _revert(t, e) { const n = xe(e) ? e : [e]; const o = this._consumables[t]; for (const e of n) {
                if (t === "attributes" && (e === "class" || e === "style")) {
                    const t = e == "class" ? "classes" : "styles";
                    this._revert(t, [...this._consumables[t].keys()]);
                }
                else {
                    const t = o.get(e);
                    if (t === false) {
                        o.set(e, true);
                    }
                }
            } }
        }
        class yg {
            constructor() { this._sourceDefinitions = {}; this._attributeProperties = {}; this.decorate("checkChild"); this.decorate("checkAttribute"); this.on("checkAttribute", ((t, e) => { e[0] = new xg(e[0]); }), { priority: "highest" }); this.on("checkChild", ((t, e) => { e[0] = new xg(e[0]); e[1] = this.getDefinition(e[1]); }), { priority: "highest" }); }
            register(t, e) { if (this._sourceDefinitions[t]) {
                throw new u["a"]("schema-cannot-register-item-twice", this, { itemName: t });
            } this._sourceDefinitions[t] = [Object.assign({}, e)]; this._clearCache(); }
            extend(t, e) { if (!this._sourceDefinitions[t]) {
                throw new u["a"]("schema-cannot-extend-missing-item", this, { itemName: t });
            } this._sourceDefinitions[t].push(Object.assign({}, e)); this._clearCache(); }
            getDefinitions() { if (!this._compiledDefinitions) {
                this._compile();
            } return this._compiledDefinitions; }
            getDefinition(t) { let e; if (typeof t == "string") {
                e = t;
            }
            else if (t.is && (t.is("$text") || t.is("$textProxy"))) {
                e = "$text";
            }
            else {
                e = t.name;
            } return this.getDefinitions()[e]; }
            isRegistered(t) { return !!this.getDefinition(t); }
            isBlock(t) { const e = this.getDefinition(t); return !!(e && e.isBlock); }
            isLimit(t) { const e = this.getDefinition(t); if (!e) {
                return false;
            } return !!(e.isLimit || e.isObject); }
            isObject(t) { const e = this.getDefinition(t); if (!e) {
                return false;
            } return !!(e.isObject || e.isLimit && e.isSelectable && e.isContent); }
            isInline(t) { const e = this.getDefinition(t); return !!(e && e.isInline); }
            isSelectable(t) { const e = this.getDefinition(t); if (!e) {
                return false;
            } return !!(e.isSelectable || e.isObject); }
            isContent(t) { const e = this.getDefinition(t); if (!e) {
                return false;
            } return !!(e.isContent || e.isObject); }
            checkChild(t, e) { if (!e) {
                return false;
            } return this._checkContextMatch(e, t); }
            checkAttribute(t, e) { const n = this.getDefinition(t.last); if (!n) {
                return false;
            } return n.allowAttributes.includes(e); }
            checkMerge(t, e = null) { if (t instanceof qf) {
                const e = t.nodeBefore;
                const n = t.nodeAfter;
                if (!(e instanceof Nf)) {
                    throw new u["a"]("schema-check-merge-no-element-before", this);
                }
                if (!(n instanceof Nf)) {
                    throw new u["a"]("schema-check-merge-no-element-after", this);
                }
                return this.checkMerge(e, n);
            } for (const n of e.getChildren()) {
                if (!this.checkChild(t, n)) {
                    return false;
                }
            } return true; }
            addChildCheck(t) { this.on("checkChild", ((e, [n, o]) => { if (!o) {
                return;
            } const i = t(n, o); if (typeof i == "boolean") {
                e.stop();
                e.return = i;
            } }), { priority: "high" }); }
            addAttributeCheck(t) { this.on("checkAttribute", ((e, [n, o]) => { const i = t(n, o); if (typeof i == "boolean") {
                e.stop();
                e.return = i;
            } }), { priority: "high" }); }
            setAttributeProperties(t, e) { this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e); }
            getAttributeProperties(t) { return this._attributeProperties[t] || {}; }
            getLimitElement(t) { let e; if (t instanceof qf) {
                e = t.parent;
            }
            else {
                const n = t instanceof Wf ? [t] : Array.from(t.getRanges());
                e = n.reduce(((t, e) => { const n = e.getCommonAncestor(); if (!t) {
                    return n;
                } return t.getCommonAncestor(n, { includeSelf: true }); }), null);
            } while (!this.isLimit(e)) {
                if (e.parent) {
                    e = e.parent;
                }
                else {
                    break;
                }
            } return e; }
            checkAttributeInSelection(t, e) { if (t.isCollapsed) {
                const n = t.getFirstPosition();
                const o = [...n.getAncestors(), new Ff("", t.getAttributes())];
                return this.checkAttribute(o, e);
            }
            else {
                const n = t.getRanges();
                for (const t of n) {
                    for (const n of t) {
                        if (this.checkAttribute(n.item, e)) {
                            return true;
                        }
                    }
                }
            } return false; }
            *getValidRanges(t, e) { t = Lg(t); for (const n of t) {
                yield* this._getValidRangesForRange(n, e);
            } }
            getNearestSelectionRange(t, e = "both") { if (this.checkChild(t, "$text")) {
                return new Wf(t);
            } let n, o; const i = t.getAncestors().reverse().find((t => this.isLimit(t))) || t.root; if (e == "both" || e == "backward") {
                n = new Vf({ boundaries: Wf._createIn(i), startPosition: t, direction: "backward" });
            } if (e == "both" || e == "forward") {
                o = new Vf({ boundaries: Wf._createIn(i), startPosition: t });
            } for (const t of Vg(n, o)) {
                const e = t.walker == n ? "elementEnd" : "elementStart";
                const o = t.value;
                if (o.type == e && this.isObject(o.item)) {
                    return Wf._createOn(o.item);
                }
                if (this.checkChild(o.nextPosition, "$text")) {
                    return new Wf(o.nextPosition);
                }
            } return null; }
            findAllowedParent(t, e) { let n = t.parent; while (n) {
                if (this.checkChild(n, e)) {
                    return n;
                }
                if (this.isLimit(n)) {
                    return null;
                }
                n = n.parent;
            } return null; }
            removeDisallowedAttributes(t, e) { for (const n of t) {
                if (n.is("$text")) {
                    qg(this, n, e);
                }
                else {
                    const t = Wf._createIn(n);
                    const o = t.getPositions();
                    for (const t of o) {
                        const n = t.nodeBefore || t.parent;
                        qg(this, n, e);
                    }
                }
            } }
            createContext(t) { return new xg(t); }
            _clearCache() { this._compiledDefinitions = null; }
            _compile() { const t = {}; const e = this._sourceDefinitions; const n = Object.keys(e); for (const o of n) {
                t[o] = Eg(e[o], o);
            } for (const e of n) {
                Dg(t, e);
            } for (const e of n) {
                Sg(t, e);
            } for (const e of n) {
                Tg(t, e);
                Pg(t, e);
            } for (const e of n) {
                Bg(t, e);
                Ig(t, e);
            } this._compiledDefinitions = t; }
            _checkContextMatch(t, e, n = e.length - 1) { const o = e.getItem(n); if (t.allowIn.includes(o.name)) {
                if (n == 0) {
                    return true;
                }
                else {
                    const t = this.getDefinition(o);
                    return this._checkContextMatch(t, e, n - 1);
                }
            }
            else {
                return false;
            } }
            *_getValidRangesForRange(t, e) { let n = t.start; let o = t.start; for (const i of t.getItems({ shallow: true })) {
                if (i.is("element")) {
                    yield* this._getValidRangesForRange(Wf._createIn(i), e);
                }
                if (!this.checkAttribute(i, e)) {
                    if (!n.isEqual(o)) {
                        yield new Wf(n, o);
                    }
                    n = qf._createAfter(i);
                }
                o = qf._createAfter(i);
            } if (!n.isEqual(o)) {
                yield new Wf(n, o);
            } }
        }
        qn(yg, Pn);
        class xg {
            constructor(t) { if (t instanceof xg) {
                return t;
            } if (typeof t == "string") {
                t = [t];
            }
            else if (!Array.isArray(t)) {
                t = t.getAncestors({ includeSelf: true });
            } this._items = t.map(Mg); }
            get length() { return this._items.length; }
            get last() { return this._items[this._items.length - 1]; }
            [Symbol.iterator]() { return this._items[Symbol.iterator](); }
            push(t) { const e = new xg([t]); e._items = [...this._items, ...e._items]; return e; }
            getItem(t) { return this._items[t]; }
            *getNames() { yield* this._items.map((t => t.name)); }
            endsWith(t) { return Array.from(this.getNames()).join(" ").endsWith(t); }
            startsWith(t) { return Array.from(this.getNames()).join(" ").startsWith(t); }
        }
        function Eg(t, e) { const n = { name: e, allowIn: [], allowContentOf: [], allowWhere: [], allowAttributes: [], allowAttributesOf: [], inheritTypesFrom: [] }; Rg(t, n); Fg(t, n, "allowIn"); Fg(t, n, "allowContentOf"); Fg(t, n, "allowWhere"); Fg(t, n, "allowAttributes"); Fg(t, n, "allowAttributesOf"); Fg(t, n, "inheritTypesFrom"); Og(t, n); return n; }
        function Dg(t, e) { for (const n of t[e].allowContentOf) {
            if (t[n]) {
                const o = zg(t, n);
                o.forEach((t => { t.allowIn.push(e); }));
            }
        } delete t[e].allowContentOf; }
        function Sg(t, e) { for (const n of t[e].allowWhere) {
            const o = t[n];
            if (o) {
                const n = o.allowIn;
                t[e].allowIn.push(...n);
            }
        } delete t[e].allowWhere; }
        function Tg(t, e) { for (const n of t[e].allowAttributesOf) {
            const o = t[n];
            if (o) {
                const n = o.allowAttributes;
                t[e].allowAttributes.push(...n);
            }
        } delete t[e].allowAttributesOf; }
        function Pg(t, e) { const n = t[e]; for (const e of n.inheritTypesFrom) {
            const o = t[e];
            if (o) {
                const t = Object.keys(o).filter((t => t.startsWith("is")));
                for (const e of t) {
                    if (!(e in n)) {
                        n[e] = o[e];
                    }
                }
            }
        } delete n.inheritTypesFrom; }
        function Bg(t, e) { const n = t[e]; const o = n.allowIn.filter((e => t[e])); n.allowIn = Array.from(new Set(o)); }
        function Ig(t, e) { const n = t[e]; n.allowAttributes = Array.from(new Set(n.allowAttributes)); }
        function Rg(t, e) { for (const n of t) {
            const t = Object.keys(n).filter((t => t.startsWith("is")));
            for (const o of t) {
                e[o] = n[o];
            }
        } }
        function Fg(t, e, n) { for (const o of t) {
            if (typeof o[n] == "string") {
                e[n].push(o[n]);
            }
            else if (Array.isArray(o[n])) {
                e[n].push(...o[n]);
            }
        } }
        function Og(t, e) { for (const n of t) {
            const t = n.inheritAllFrom;
            if (t) {
                e.allowContentOf.push(t);
                e.allowWhere.push(t);
                e.allowAttributesOf.push(t);
                e.inheritTypesFrom.push(t);
            }
        } }
        function zg(t, e) { const n = t[e]; return Ng(t).filter((t => t.allowIn.includes(n.name))); }
        function Ng(t) { return Object.keys(t).map((e => t[e])); }
        function Mg(t) { if (typeof t == "string" || t.is("documentFragment")) {
            return { name: typeof t == "string" ? t : "$documentFragment", *getAttributeKeys() { }, getAttribute() { } };
        }
        else {
            return { name: t.is("element") ? t.name : "$text", *getAttributeKeys() { yield* t.getAttributeKeys(); }, getAttribute(e) { return t.getAttribute(e); } };
        } }
        function* Vg(t, e) { let n = false; while (!n) {
            n = true;
            if (t) {
                const e = t.next();
                if (!e.done) {
                    n = false;
                    yield { walker: t, value: e.value };
                }
            }
            if (e) {
                const t = e.next();
                if (!t.done) {
                    n = false;
                    yield { walker: e, value: t.value };
                }
            }
        } }
        function* Lg(t) { for (const e of t) {
            yield* e.getMinimalFlatRanges();
        } }
        function qg(t, e, n) { for (const o of e.getAttributeKeys()) {
            if (!t.checkAttribute(e, o)) {
                n.removeAttribute(o, e);
            }
        } }
        class Kg {
            constructor(t = {}) { this._splitParts = new Map; this._cursorParents = new Map; this._modelCursor = null; this.conversionApi = Object.assign({}, t); this.conversionApi.convertItem = this._convertItem.bind(this); this.conversionApi.convertChildren = this._convertChildren.bind(this); this.conversionApi.safeInsert = this._safeInsert.bind(this); this.conversionApi.updateConversionResult = this._updateConversionResult.bind(this); this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this); this.conversionApi.getSplitParts = this._getSplitParts.bind(this); }
            convert(t, e, n = ["$root"]) { this.fire("viewCleanup", t); this._modelCursor = Hg(n, e); this.conversionApi.writer = e; this.conversionApi.consumable = Ag.createFrom(t); this.conversionApi.store = {}; const { modelRange: o } = this._convertItem(t, this._modelCursor); const i = e.createDocumentFragment(); if (o) {
                this._removeEmptyElements();
                for (const t of Array.from(this._modelCursor.parent.getChildren())) {
                    e.append(t, i);
                }
                i.markers = jg(i, e);
            } this._modelCursor = null; this._splitParts.clear(); this._cursorParents.clear(); this.conversionApi.writer = null; this.conversionApi.store = null; return i; }
            _convertItem(t, e) { const n = Object.assign({ viewItem: t, modelCursor: e, modelRange: null }); if (t.is("element")) {
                this.fire("element:" + t.name, n, this.conversionApi);
            }
            else if (t.is("$text")) {
                this.fire("text", n, this.conversionApi);
            }
            else {
                this.fire("documentFragment", n, this.conversionApi);
            } if (n.modelRange && !(n.modelRange instanceof Wf)) {
                throw new u["a"]("view-conversion-dispatcher-incorrect-result", this);
            } return { modelRange: n.modelRange, modelCursor: n.modelCursor }; }
            _convertChildren(t, e) { let n = e.is("position") ? e : qf._createAt(e, 0); const o = new Wf(n); for (const e of Array.from(t.getChildren())) {
                const t = this._convertItem(e, n);
                if (t.modelRange instanceof Wf) {
                    o.end = t.modelRange.end;
                    n = t.modelCursor;
                }
            } return { modelRange: o, modelCursor: n }; }
            _safeInsert(t, e) { const n = this._splitToAllowedParent(t, e); if (!n) {
                return false;
            } this.conversionApi.writer.insert(t, n.position); return true; }
            _updateConversionResult(t, e) { const n = this._getSplitParts(t); const o = this.conversionApi.writer; if (!e.modelRange) {
                e.modelRange = o.createRange(o.createPositionBefore(t), o.createPositionAfter(n[n.length - 1]));
            } const i = this._cursorParents.get(t); if (i) {
                e.modelCursor = o.createPositionAt(i, 0);
            }
            else {
                e.modelCursor = e.modelRange.end;
            } }
            _splitToAllowedParent(t, e) { const { schema: n, writer: o } = this.conversionApi; let i = n.findAllowedParent(e, t); if (i) {
                if (i === e.parent) {
                    return { position: e };
                }
                if (this._modelCursor.parent.getAncestors().includes(i)) {
                    i = null;
                }
            } if (!i) {
                if (!Xp(e, t, n)) {
                    return null;
                }
                return { position: Zp(e, o) };
            } const r = this.conversionApi.writer.split(e, i); const s = []; for (const t of r.range.getWalker()) {
                if (t.type == "elementEnd") {
                    s.push(t.item);
                }
                else {
                    const e = s.pop();
                    const n = t.item;
                    this._registerSplitPair(e, n);
                }
            } const a = r.range.end.parent; this._cursorParents.set(t, a); return { position: r.position, cursorParent: a }; }
            _registerSplitPair(t, e) { if (!this._splitParts.has(t)) {
                this._splitParts.set(t, [t]);
            } const n = this._splitParts.get(t); this._splitParts.set(e, n); n.push(e); }
            _getSplitParts(t) { let e; if (!this._splitParts.has(t)) {
                e = [t];
            }
            else {
                e = this._splitParts.get(t);
            } return e; }
            _removeEmptyElements() { let t = false; for (const e of this._splitParts.keys()) {
                if (e.isEmpty) {
                    this.conversionApi.writer.remove(e);
                    this._splitParts.delete(e);
                    t = true;
                }
            } if (t) {
                this._removeEmptyElements();
            } }
        }
        qn(Kg, g);
        function jg(t, e) { const n = new Set; const o = new Map; const i = Wf._createIn(t).getItems(); for (const t of i) {
            if (t.name == "$marker") {
                n.add(t);
            }
        } for (const t of n) {
            const n = t.getAttribute("data-name");
            const i = e.createPositionBefore(t);
            if (!o.has(n)) {
                o.set(n, new Wf(i.clone()));
            }
            else {
                o.get(n).end = i.clone();
            }
            e.remove(t);
        } return o; }
        function Hg(t, e) { let n; for (const o of new xg(t)) {
            const t = {};
            for (const e of o.getAttributeKeys()) {
                t[e] = o.getAttribute(e);
            }
            const i = e.createElement(o.name, t);
            if (n) {
                e.append(i, n);
            }
            n = qf._createAt(i, 0);
        } return n; }
        class Wg {
            getHtml(t) { const e = document.implementation.createHTMLDocument(""); const n = e.createElement("div"); n.appendChild(t); return n.innerHTML; }
        }
        class $g {
            constructor(t) { this._domParser = new DOMParser; this._domConverter = new fu(t, { blockFillerMode: "nbsp" }); this._htmlWriter = new Wg; }
            toData(t) { const e = this._domConverter.viewToDom(t, document); return this._htmlWriter.getHtml(e); }
            toView(t) { const e = this._toDom(t); return this._domConverter.domToView(e); }
            registerRawContentMatcher(t) { this._domConverter.registerRawContentMatcher(t); }
            useFillerType(t) { this._domConverter.blockFillerMode = t == "marked" ? "markedNbsp" : "nbsp"; }
            _toDom(t) { const e = this._domParser.parseFromString(t, "text/html"); const n = e.createDocumentFragment(); const o = e.body.childNodes; while (o.length > 0) {
                n.appendChild(o[0]);
            } return n; }
        }
        class Gg {
            constructor(t, e) { this.model = t; this.mapper = new $f; this.downcastDispatcher = new Jf({ mapper: this.mapper, schema: t.schema }); this.downcastDispatcher.on("insert:$text", vp(), { priority: "lowest" }); this.upcastDispatcher = new Kg({ schema: t.schema }); this.viewDocument = new zl(e); this.stylesProcessor = e; this.htmlProcessor = new $g(this.viewDocument); this.processor = this.htmlProcessor; this._viewWriter = new wd(this.viewDocument); this.upcastDispatcher.on("text", ng(), { priority: "lowest" }); this.upcastDispatcher.on("element", eg(), { priority: "lowest" }); this.upcastDispatcher.on("documentFragment", eg(), { priority: "lowest" }); this.decorate("init"); this.decorate("set"); this.on("init", (() => { this.fire("ready"); }), { priority: "lowest" }); this.on("ready", (() => { this.model.enqueueChange("transparent", Qp); }), { priority: "lowest" }); }
            get(t = {}) { const { rootName: e = "main", trim: n = "empty" } = t; if (!this._checkIfRootsExists([e])) {
                throw new u["a"]("datacontroller-get-non-existent-root", this);
            } const o = this.model.document.getRoot(e); if (n === "empty" && !this.model.hasContent(o, { ignoreWhitespaces: true })) {
                return "";
            } return this.stringify(o, t); }
            stringify(t, e = {}) { const n = this.toView(t, e); return this.processor.toData(n); }
            toView(t, e = {}) { const n = this.viewDocument; const o = this._viewWriter; this.mapper.clearBindings(); const i = Wf._createIn(t); const r = new kd(n); this.mapper.bindElements(t, r); this.downcastDispatcher.conversionApi.options = e; this.downcastDispatcher.convertInsert(i, o); const s = t.is("documentFragment") ? Array.from(t.markers) : Ug(t); for (const [t, e] of s) {
                this.downcastDispatcher.convertMarkerAdd(t, e, o);
            } delete this.downcastDispatcher.conversionApi.options; return r; }
            init(t) { if (this.model.document.version) {
                throw new u["a"]("datacontroller-init-document-not-empty", this);
            } let e = {}; if (typeof t === "string") {
                e.main = t;
            }
            else {
                e = t;
            } if (!this._checkIfRootsExists(Object.keys(e))) {
                throw new u["a"]("datacontroller-init-non-existent-root", this);
            } this.model.enqueueChange("transparent", (t => { for (const n of Object.keys(e)) {
                const o = this.model.document.getRoot(n);
                t.insert(this.parse(e[n], o), o, 0);
            } })); return Promise.resolve(); }
            set(t) { let e = {}; if (typeof t === "string") {
                e.main = t;
            }
            else {
                e = t;
            } if (!this._checkIfRootsExists(Object.keys(e))) {
                throw new u["a"]("datacontroller-set-non-existent-root", this);
            } this.model.enqueueChange("transparent", (t => { t.setSelection(null); t.removeSelectionAttribute(this.model.document.selection.getAttributeKeys()); for (const n of Object.keys(e)) {
                const o = this.model.document.getRoot(n);
                t.remove(t.createRangeIn(o));
                t.insert(this.parse(e[n], o), o, 0);
            } })); }
            parse(t, e = "$root") { const n = this.processor.toView(t); return this.toModel(n, e); }
            toModel(t, e = "$root") { return this.model.change((n => this.upcastDispatcher.convert(t, n, e))); }
            addStyleProcessorRules(t) { t(this.stylesProcessor); }
            registerRawContentMatcher(t) { if (this.processor && this.processor !== this.htmlProcessor) {
                this.processor.registerRawContentMatcher(t);
            } this.htmlProcessor.registerRawContentMatcher(t); }
            destroy() { this.stopListening(); }
            _checkIfRootsExists(t) { for (const e of t) {
                if (!this.model.document.getRootNames().includes(e)) {
                    return false;
                }
            } return true; }
        }
        qn(Gg, Pn);
        function Ug(t) { const e = []; const n = t.root.document; if (!n) {
            return [];
        } const o = Wf._createIn(t); for (const t of n.model.markers) {
            const n = o.getIntersection(t.getRange());
            if (n) {
                e.push([t.name, n]);
            }
        } return e; }
        class Jg {
            constructor(t, e) { this._helpers = new Map; this._downcast = _a(t); this._createConversionHelpers({ name: "downcast", dispatchers: this._downcast, isDowncast: true }); this._upcast = _a(e); this._createConversionHelpers({ name: "upcast", dispatchers: this._upcast, isDowncast: false }); }
            addAlias(t, e) { const n = this._downcast.includes(e); const o = this._upcast.includes(e); if (!o && !n) {
                throw new u["a"]("conversion-add-alias-dispatcher-not-registered", this);
            } this._createConversionHelpers({ name: t, dispatchers: [e], isDowncast: n }); }
            for(t) { if (!this._helpers.has(t)) {
                throw new u["a"]("conversion-for-unknown-group", this);
            } return this._helpers.get(t); }
            elementToElement(t) { this.for("downcast").elementToElement(t); for (const { model: e, view: n } of Yg(t)) {
                this.for("upcast").elementToElement({ model: e, view: n, converterPriority: t.converterPriority });
            } }
            attributeToElement(t) { this.for("downcast").attributeToElement(t); for (const { model: e, view: n } of Yg(t)) {
                this.for("upcast").elementToAttribute({ view: n, model: e, converterPriority: t.converterPriority });
            } }
            attributeToAttribute(t) { this.for("downcast").attributeToAttribute(t); for (const { model: e, view: n } of Yg(t)) {
                this.for("upcast").attributeToAttribute({ view: n, model: e });
            } }
            _createConversionHelpers({ name: t, dispatchers: e, isDowncast: n }) { if (this._helpers.has(t)) {
                throw new u["a"]("conversion-group-exists", this);
            } const o = n ? new _p(e) : new tg(e); this._helpers.set(t, o); }
        }
        function* Yg(t) { if (t.model.values) {
            for (const e of t.model.values) {
                const n = { key: t.model.key, value: e };
                const o = t.view[e];
                const i = t.upcastAlso ? t.upcastAlso[e] : undefined;
                yield* Qg(n, o, i);
            }
        }
        else {
            yield* Qg(t.model, t.view, t.upcastAlso);
        } }
        function* Qg(t, e, n) { yield { model: t, view: e }; if (n) {
            for (const e of _a(n)) {
                yield { model: t, view: e };
            }
        } }
        class Xg {
            constructor(t = "default") { this.operations = []; this.type = t; }
            get baseVersion() { for (const t of this.operations) {
                if (t.baseVersion !== null) {
                    return t.baseVersion;
                }
            } return null; }
            addOperation(t) { t.batch = this; this.operations.push(t); return t; }
        }
        class Zg {
            constructor(t) { this.baseVersion = t; this.isDocumentOperation = this.baseVersion !== null; this.batch = null; }
            _validate() { }
            toJSON() { const t = Object.assign({}, this); t.__className = this.constructor.className; delete t.batch; delete t.isDocumentOperation; return t; }
            static get className() { return "Operation"; }
            static fromJSON(t) { return new this(t.baseVersion); }
        }
        class tm {
            constructor(t) { this.markers = new Map; this._children = new zf; if (t) {
                this._insertChild(0, t);
            } }
            [Symbol.iterator]() { return this.getChildren(); }
            get childCount() { return this._children.length; }
            get maxOffset() { return this._children.maxOffset; }
            get isEmpty() { return this.childCount === 0; }
            get root() { return this; }
            get parent() { return null; }
            is(t) { return t === "documentFragment" || t === "model:documentFragment"; }
            getChild(t) { return this._children.getNode(t); }
            getChildren() { return this._children[Symbol.iterator](); }
            getChildIndex(t) { return this._children.getNodeIndex(t); }
            getChildStartOffset(t) { return this._children.getNodeStartOffset(t); }
            getPath() { return []; }
            getNodeByPath(t) { let e = this; for (const n of t) {
                e = e.getChild(e.offsetToIndex(n));
            } return e; }
            offsetToIndex(t) { return this._children.offsetToIndex(t); }
            toJSON() { const t = []; for (const e of this._children) {
                t.push(e.toJSON());
            } return t; }
            static fromJSON(t) { const e = []; for (const n of t) {
                if (n.name) {
                    e.push(Nf.fromJSON(n));
                }
                else {
                    e.push(Ff.fromJSON(n));
                }
            } return new tm(e); }
            _appendChild(t) { this._insertChild(this.childCount, t); }
            _insertChild(t, e) { const n = em(e); for (const t of n) {
                if (t.parent !== null) {
                    t._remove();
                }
                t.parent = this;
            } this._children._insertNodes(t, n); }
            _removeChildren(t, e = 1) { const n = this._children._removeNodes(t, e); for (const t of n) {
                t.parent = null;
            } return n; }
        }
        function em(t) { if (typeof t == "string") {
            return [new Ff(t)];
        } if (!ka(t)) {
            t = [t];
        } return Array.from(t).map((t => { if (typeof t == "string") {
            return new Ff(t);
        } if (t instanceof Of) {
            return new Ff(t.data, t.getAttributes());
        } return t; })); }
        function nm(t, e) { e = sm(e); const n = e.reduce(((t, e) => t + e.offsetSize), 0); const o = t.parent; cm(t); const i = t.index; o._insertChild(i, e); am(o, i + e.length); am(o, i); return new Wf(t, t.getShiftedBy(n)); }
        function om(t) { if (!t.isFlat) {
            throw new u["a"]("operation-utils-remove-range-not-flat", this);
        } const e = t.start.parent; cm(t.start); cm(t.end); const n = e._removeChildren(t.start.index, t.end.index - t.start.index); am(e, t.start.index); return n; }
        function im(t, e) { if (!t.isFlat) {
            throw new u["a"]("operation-utils-move-range-not-flat", this);
        } const n = om(t); e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset); return nm(e, n); }
        function rm(t, e, n) { cm(t.start); cm(t.end); for (const o of t.getItems({ shallow: true })) {
            const t = o.is("$textProxy") ? o.textNode : o;
            if (n !== null) {
                t._setAttribute(e, n);
            }
            else {
                t._removeAttribute(e);
            }
            am(t.parent, t.index);
        } am(t.end.parent, t.end.index); }
        function sm(t) { const e = []; if (!(t instanceof Array)) {
            t = [t];
        } for (let n = 0; n < t.length; n++) {
            if (typeof t[n] == "string") {
                e.push(new Ff(t[n]));
            }
            else if (t[n] instanceof Of) {
                e.push(new Ff(t[n].data, t[n].getAttributes()));
            }
            else if (t[n] instanceof tm || t[n] instanceof zf) {
                for (const o of t[n]) {
                    e.push(o);
                }
            }
            else if (t[n] instanceof Rf) {
                e.push(t[n]);
            }
        } for (let t = 1; t < e.length; t++) {
            const n = e[t];
            const o = e[t - 1];
            if (n instanceof Ff && o instanceof Ff && lm(n, o)) {
                e.splice(t - 1, 2, new Ff(o.data + n.data, o.getAttributes()));
                t--;
            }
        } return e; }
        function am(t, e) { const n = t.getChild(e - 1); const o = t.getChild(e); if (n && o && n.is("$text") && o.is("$text") && lm(n, o)) {
            const i = new Ff(n.data + o.data, n.getAttributes());
            t._removeChildren(e - 1, 2);
            t._insertChild(e - 1, i);
        } }
        function cm(t) { const e = t.textNode; const n = t.parent; if (e) {
            const o = t.offset - e.startOffset;
            const i = e.index;
            n._removeChildren(i, 1);
            const r = new Ff(e.data.substr(0, o), e.getAttributes());
            const s = new Ff(e.data.substr(o), e.getAttributes());
            n._insertChild(i, [r, s]);
        } }
        function lm(t, e) { const n = t.getAttributes(); const o = e.getAttributes(); for (const t of n) {
            if (t[1] !== e.getAttribute(t[0])) {
                return false;
            }
            o.next();
        } return o.next().done; }
        function dm(t, e) { return _h(t, e); }
        var um = dm;
        class hm extends Zg {
            constructor(t, e, n, o, i) { super(i); this.range = t.clone(); this.key = e; this.oldValue = n === undefined ? null : n; this.newValue = o === undefined ? null : o; }
            get type() { if (this.oldValue === null) {
                return "addAttribute";
            }
            else if (this.newValue === null) {
                return "removeAttribute";
            }
            else {
                return "changeAttribute";
            } }
            clone() { return new hm(this.range, this.key, this.oldValue, this.newValue, this.baseVersion); }
            getReversed() { return new hm(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1); }
            toJSON() { const t = super.toJSON(); t.range = this.range.toJSON(); return t; }
            _validate() { if (!this.range.isFlat) {
                throw new u["a"]("attribute-operation-range-not-flat", this);
            } for (const t of this.range.getItems({ shallow: true })) {
                if (this.oldValue !== null && !um(t.getAttribute(this.key), this.oldValue)) {
                    throw new u["a"]("attribute-operation-wrong-old-value", this, { item: t, key: this.key, value: this.oldValue });
                }
                if (this.oldValue === null && this.newValue !== null && t.hasAttribute(this.key)) {
                    throw new u["a"]("attribute-operation-attribute-exists", this, { node: t, key: this.key });
                }
            } }
            _execute() { if (!um(this.oldValue, this.newValue)) {
                rm(this.range, this.key, this.newValue);
            } }
            static get className() { return "AttributeOperation"; }
            static fromJSON(t, e) { return new hm(Wf.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion); }
        }
        class fm extends Zg {
            constructor(t, e) { super(null); this.sourcePosition = t.clone(); this.howMany = e; }
            get type() { return "detach"; }
            toJSON() { const t = super.toJSON(); t.sourcePosition = this.sourcePosition.toJSON(); return t; }
            _validate() { if (this.sourcePosition.root.document) {
                throw new u["a"]("detach-operation-on-document-node", this);
            } }
            _execute() { om(Wf._createFromPositionAndShift(this.sourcePosition, this.howMany)); }
            static get className() { return "DetachOperation"; }
        }
        class pm extends Zg {
            constructor(t, e, n, o) { super(o); this.sourcePosition = t.clone(); this.sourcePosition.stickiness = "toNext"; this.howMany = e; this.targetPosition = n.clone(); this.targetPosition.stickiness = "toNone"; }
            get type() { if (this.targetPosition.root.rootName == "$graveyard") {
                return "remove";
            }
            else if (this.sourcePosition.root.rootName == "$graveyard") {
                return "reinsert";
            } return "move"; }
            clone() { return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion); }
            getMovedRangeStart() { return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany); }
            getReversed() { const t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany); return new this.constructor(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1); }
            _validate() { const t = this.sourcePosition.parent; const e = this.targetPosition.parent; const n = this.sourcePosition.offset; const o = this.targetPosition.offset; if (n + this.howMany > t.maxOffset) {
                throw new u["a"]("move-operation-nodes-do-not-exist", this);
            }
            else if (t === e && n < o && o < n + this.howMany) {
                throw new u["a"]("move-operation-range-into-itself", this);
            }
            else if (this.sourcePosition.root == this.targetPosition.root) {
                if (Ia(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
                    const t = this.sourcePosition.path.length - 1;
                    if (this.targetPosition.path[t] >= n && this.targetPosition.path[t] < n + this.howMany) {
                        throw new u["a"]("move-operation-node-into-itself", this);
                    }
                }
            } }
            _execute() { im(Wf._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition); }
            toJSON() { const t = super.toJSON(); t.sourcePosition = this.sourcePosition.toJSON(); t.targetPosition = this.targetPosition.toJSON(); return t; }
            static get className() { return "MoveOperation"; }
            static fromJSON(t, e) { const n = qf.fromJSON(t.sourcePosition, e); const o = qf.fromJSON(t.targetPosition, e); return new this(n, t.howMany, o, t.baseVersion); }
        }
        class gm extends Zg {
            constructor(t, e, n) { super(n); this.position = t.clone(); this.position.stickiness = "toNone"; this.nodes = new zf(sm(e)); this.shouldReceiveAttributes = false; }
            get type() { return "insert"; }
            get howMany() { return this.nodes.maxOffset; }
            clone() { const t = new zf([...this.nodes].map((t => t._clone(true)))); const e = new gm(this.position, t, this.baseVersion); e.shouldReceiveAttributes = this.shouldReceiveAttributes; return e; }
            getReversed() { const t = this.position.root.document.graveyard; const e = new qf(t, [0]); return new pm(this.position, this.nodes.maxOffset, e, this.baseVersion + 1); }
            _validate() { const t = this.position.parent; if (!t || t.maxOffset < this.position.offset) {
                throw new u["a"]("insert-operation-position-invalid", this);
            } }
            _execute() { const t = this.nodes; this.nodes = new zf([...t].map((t => t._clone(true)))); nm(this.position, t); }
            toJSON() { const t = super.toJSON(); t.position = this.position.toJSON(); t.nodes = this.nodes.toJSON(); return t; }
            static get className() { return "InsertOperation"; }
            static fromJSON(t, e) { const n = []; for (const e of t.nodes) {
                if (e.name) {
                    n.push(Nf.fromJSON(e));
                }
                else {
                    n.push(Ff.fromJSON(e));
                }
            } const o = new gm(qf.fromJSON(t.position, e), n, t.baseVersion); o.shouldReceiveAttributes = t.shouldReceiveAttributes; return o; }
        }
        class mm extends Zg {
            constructor(t, e, n, o, i, r) { super(r); this.name = t; this.oldRange = e ? e.clone() : null; this.newRange = n ? n.clone() : null; this.affectsData = i; this._markers = o; }
            get type() { return "marker"; }
            clone() { return new mm(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion); }
            getReversed() { return new mm(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1); }
            _execute() { const t = this.newRange ? "_set" : "_remove"; this._markers[t](this.name, this.newRange, true, this.affectsData); }
            toJSON() { const t = super.toJSON(); if (this.oldRange) {
                t.oldRange = this.oldRange.toJSON();
            } if (this.newRange) {
                t.newRange = this.newRange.toJSON();
            } delete t._markers; return t; }
            static get className() { return "MarkerOperation"; }
            static fromJSON(t, e) { return new mm(t.name, t.oldRange ? Wf.fromJSON(t.oldRange, e) : null, t.newRange ? Wf.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion); }
        }
        class km extends Zg {
            constructor(t, e, n, o) { super(o); this.position = t; this.position.stickiness = "toNext"; this.oldName = e; this.newName = n; }
            get type() { return "rename"; }
            clone() { return new km(this.position.clone(), this.oldName, this.newName, this.baseVersion); }
            getReversed() { return new km(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1); }
            _validate() { const t = this.position.nodeAfter; if (!(t instanceof Nf)) {
                throw new u["a"]("rename-operation-wrong-position", this);
            }
            else if (t.name !== this.oldName) {
                throw new u["a"]("rename-operation-wrong-name", this);
            } }
            _execute() { const t = this.position.nodeAfter; t.name = this.newName; }
            toJSON() { const t = super.toJSON(); t.position = this.position.toJSON(); return t; }
            static get className() { return "RenameOperation"; }
            static fromJSON(t, e) { return new km(qf.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion); }
        }
        class bm extends Zg {
            constructor(t, e, n, o, i) { super(i); this.root = t; this.key = e; this.oldValue = n; this.newValue = o; }
            get type() { if (this.oldValue === null) {
                return "addRootAttribute";
            }
            else if (this.newValue === null) {
                return "removeRootAttribute";
            }
            else {
                return "changeRootAttribute";
            } }
            clone() { return new bm(this.root, this.key, this.oldValue, this.newValue, this.baseVersion); }
            getReversed() { return new bm(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1); }
            _validate() { if (this.root != this.root.root || this.root.is("documentFragment")) {
                throw new u["a"]("rootattribute-operation-not-a-root", this, { root: this.root, key: this.key });
            } if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue) {
                throw new u["a"]("rootattribute-operation-wrong-old-value", this, { root: this.root, key: this.key });
            } if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key)) {
                throw new u["a"]("rootattribute-operation-attribute-exists", this, { root: this.root, key: this.key });
            } }
            _execute() { if (this.newValue !== null) {
                this.root._setAttribute(this.key, this.newValue);
            }
            else {
                this.root._removeAttribute(this.key);
            } }
            toJSON() { const t = super.toJSON(); t.root = this.root.toJSON(); return t; }
            static get className() { return "RootAttributeOperation"; }
            static fromJSON(t, e) { if (!e.getRoot(t.root)) {
                throw new u["a"]("rootattribute-operation-fromjson-no-root", this, { rootName: t.root });
            } return new bm(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion); }
        }
        class wm extends Zg {
            constructor(t, e, n, o, i) { super(i); this.sourcePosition = t.clone(); this.sourcePosition.stickiness = "toPrevious"; this.howMany = e; this.targetPosition = n.clone(); this.targetPosition.stickiness = "toNext"; this.graveyardPosition = o.clone(); }
            get type() { return "merge"; }
            get deletionPosition() { return new qf(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1)); }
            get movedRange() { const t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY); return new Wf(this.sourcePosition, t); }
            clone() { return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion); }
            getReversed() { const t = this.targetPosition._getTransformedByMergeOperation(this); const e = this.sourcePosition.path.slice(0, -1); const n = new qf(this.sourcePosition.root, e)._getTransformedByMergeOperation(this); return new _m(t, this.howMany, n, this.graveyardPosition, this.baseVersion + 1); }
            _validate() { const t = this.sourcePosition.parent; const e = this.targetPosition.parent; if (!t.parent) {
                throw new u["a"]("merge-operation-source-position-invalid", this);
            }
            else if (!e.parent) {
                throw new u["a"]("merge-operation-target-position-invalid", this);
            }
            else if (this.howMany != t.maxOffset) {
                throw new u["a"]("merge-operation-how-many-invalid", this);
            } }
            _execute() { const t = this.sourcePosition.parent; const e = Wf._createIn(t); im(e, this.targetPosition); im(Wf._createOn(t), this.graveyardPosition); }
            toJSON() { const t = super.toJSON(); t.sourcePosition = t.sourcePosition.toJSON(); t.targetPosition = t.targetPosition.toJSON(); t.graveyardPosition = t.graveyardPosition.toJSON(); return t; }
            static get className() { return "MergeOperation"; }
            static fromJSON(t, e) { const n = qf.fromJSON(t.sourcePosition, e); const o = qf.fromJSON(t.targetPosition, e); const i = qf.fromJSON(t.graveyardPosition, e); return new this(n, t.howMany, o, i, t.baseVersion); }
        }
        class _m extends Zg {
            constructor(t, e, n, o, i) { super(i); this.splitPosition = t.clone(); this.splitPosition.stickiness = "toNext"; this.howMany = e; this.insertionPosition = n; this.graveyardPosition = o ? o.clone() : null; if (this.graveyardPosition) {
                this.graveyardPosition.stickiness = "toNext";
            } }
            get type() { return "split"; }
            get moveTargetPosition() { const t = this.insertionPosition.path.slice(); t.push(0); return new qf(this.insertionPosition.root, t); }
            get movedRange() { const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY); return new Wf(this.splitPosition, t); }
            clone() { return new this.constructor(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion); }
            getReversed() { const t = this.splitPosition.root.document.graveyard; const e = new qf(t, [0]); return new wm(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1); }
            _validate() { const t = this.splitPosition.parent; const e = this.splitPosition.offset; if (!t || t.maxOffset < e) {
                throw new u["a"]("split-operation-position-invalid", this);
            }
            else if (!t.parent) {
                throw new u["a"]("split-operation-split-in-root", this);
            }
            else if (this.howMany != t.maxOffset - this.splitPosition.offset) {
                throw new u["a"]("split-operation-how-many-invalid", this);
            }
            else if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) {
                throw new u["a"]("split-operation-graveyard-position-invalid", this);
            } }
            _execute() { const t = this.splitPosition.parent; if (this.graveyardPosition) {
                im(Wf._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
            }
            else {
                const e = t._clone();
                nm(this.insertionPosition, e);
            } const e = new Wf(qf._createAt(t, this.splitPosition.offset), qf._createAt(t, t.maxOffset)); im(e, this.moveTargetPosition); }
            toJSON() { const t = super.toJSON(); t.splitPosition = this.splitPosition.toJSON(); t.insertionPosition = this.insertionPosition.toJSON(); if (this.graveyardPosition) {
                t.graveyardPosition = this.graveyardPosition.toJSON();
            } return t; }
            static get className() { return "SplitOperation"; }
            static getInsertionPosition(t) { const e = t.path.slice(0, -1); e[e.length - 1]++; return new qf(t.root, e, "toPrevious"); }
            static fromJSON(t, e) { const n = qf.fromJSON(t.splitPosition, e); const o = qf.fromJSON(t.insertionPosition, e); const i = t.graveyardPosition ? qf.fromJSON(t.graveyardPosition, e) : null; return new this(n, t.howMany, o, i, t.baseVersion); }
        }
        class vm extends Nf {
            constructor(t, e, n = "main") { super(e); this._document = t; this.rootName = n; }
            get document() { return this._document; }
            is(t, e) { if (!e) {
                return t === "rootElement" || t === "model:rootElement" || t === "element" || t === "model:element" || t === "node" || t === "model:node";
            } return e === this.name && (t === "rootElement" || t === "model:rootElement" || t === "element" || t === "model:element"); }
            toJSON() { return this.rootName; }
        }
        class Am {
            constructor(t, e) { this.model = t; this.batch = e; }
            createText(t, e) { return new Ff(t, e); }
            createElement(t, e) { return new Nf(t, e); }
            createDocumentFragment() { return new tm; }
            cloneElement(t, e = true) { return t._clone(e); }
            insert(t, e, n = 0) { this._assertWriterUsedCorrectly(); if (t instanceof Ff && t.data == "") {
                return;
            } const o = qf._createAt(e, n); if (t.parent) {
                if (Dm(t.root, o.root)) {
                    this.move(Wf._createOn(t), o);
                    return;
                }
                else {
                    if (t.root.document) {
                        throw new u["a"]("model-writer-insert-forbidden-move", this);
                    }
                    else {
                        this.remove(t);
                    }
                }
            } const i = o.root.document ? o.root.document.version : null; const r = new gm(o, t, i); if (t instanceof Ff) {
                r.shouldReceiveAttributes = true;
            } this.batch.addOperation(r); this.model.applyOperation(r); if (t instanceof tm) {
                for (const [e, n] of t.markers) {
                    const t = qf._createAt(n.root, 0);
                    const i = new Wf(n.start._getCombined(t, o), n.end._getCombined(t, o));
                    const r = { range: i, usingOperation: true, affectsData: true };
                    if (this.model.markers.has(e)) {
                        this.updateMarker(e, r);
                    }
                    else {
                        this.addMarker(e, r);
                    }
                }
            } }
            insertText(t, e, n, o) { if (e instanceof tm || e instanceof Nf || e instanceof qf) {
                this.insert(this.createText(t), e, n);
            }
            else {
                this.insert(this.createText(t, e), n, o);
            } }
            insertElement(t, e, n, o) { if (e instanceof tm || e instanceof Nf || e instanceof qf) {
                this.insert(this.createElement(t), e, n);
            }
            else {
                this.insert(this.createElement(t, e), n, o);
            } }
            append(t, e) { this.insert(t, e, "end"); }
            appendText(t, e, n) { if (e instanceof tm || e instanceof Nf) {
                this.insert(this.createText(t), e, "end");
            }
            else {
                this.insert(this.createText(t, e), n, "end");
            } }
            appendElement(t, e, n) { if (e instanceof tm || e instanceof Nf) {
                this.insert(this.createElement(t), e, "end");
            }
            else {
                this.insert(this.createElement(t, e), n, "end");
            } }
            setAttribute(t, e, n) { this._assertWriterUsedCorrectly(); if (n instanceof Wf) {
                const o = n.getMinimalFlatRanges();
                for (const n of o) {
                    Cm(this, t, e, n);
                }
            }
            else {
                ym(this, t, e, n);
            } }
            setAttributes(t, e) { for (const [n, o] of La(t)) {
                this.setAttribute(n, o, e);
            } }
            removeAttribute(t, e) { this._assertWriterUsedCorrectly(); if (e instanceof Wf) {
                const n = e.getMinimalFlatRanges();
                for (const e of n) {
                    Cm(this, t, null, e);
                }
            }
            else {
                ym(this, t, null, e);
            } }
            clearAttributes(t) { this._assertWriterUsedCorrectly(); const e = t => { for (const e of t.getAttributeKeys()) {
                this.removeAttribute(e, t);
            } }; if (!(t instanceof Wf)) {
                e(t);
            }
            else {
                for (const n of t.getItems()) {
                    e(n);
                }
            } }
            move(t, e, n) { this._assertWriterUsedCorrectly(); if (!(t instanceof Wf)) {
                throw new u["a"]("writer-move-invalid-range", this);
            } if (!t.isFlat) {
                throw new u["a"]("writer-move-range-not-flat", this);
            } const o = qf._createAt(e, n); if (o.isEqual(t.start)) {
                return;
            } this._addOperationForAffectedMarkers("move", t); if (!Dm(t.root, o.root)) {
                throw new u["a"]("writer-move-different-document", this);
            } const i = t.root.document ? t.root.document.version : null; const r = new pm(t.start, t.end.offset - t.start.offset, o, i); this.batch.addOperation(r); this.model.applyOperation(r); }
            remove(t) { this._assertWriterUsedCorrectly(); const e = t instanceof Wf ? t : Wf._createOn(t); const n = e.getMinimalFlatRanges().reverse(); for (const t of n) {
                this._addOperationForAffectedMarkers("move", t);
                Em(t.start, t.end.offset - t.start.offset, this.batch, this.model);
            } }
            merge(t) { this._assertWriterUsedCorrectly(); const e = t.nodeBefore; const n = t.nodeAfter; this._addOperationForAffectedMarkers("merge", t); if (!(e instanceof Nf)) {
                throw new u["a"]("writer-merge-no-element-before", this);
            } if (!(n instanceof Nf)) {
                throw new u["a"]("writer-merge-no-element-after", this);
            } if (!t.root.document) {
                this._mergeDetached(t);
            }
            else {
                this._merge(t);
            } }
            createPositionFromPath(t, e, n) { return this.model.createPositionFromPath(t, e, n); }
            createPositionAt(t, e) { return this.model.createPositionAt(t, e); }
            createPositionAfter(t) { return this.model.createPositionAfter(t); }
            createPositionBefore(t) { return this.model.createPositionBefore(t); }
            createRange(t, e) { return this.model.createRange(t, e); }
            createRangeIn(t) { return this.model.createRangeIn(t); }
            createRangeOn(t) { return this.model.createRangeOn(t); }
            createSelection(t, e, n) { return this.model.createSelection(t, e, n); }
            _mergeDetached(t) { const e = t.nodeBefore; const n = t.nodeAfter; this.move(Wf._createIn(n), qf._createAt(e, "end")); this.remove(n); }
            _merge(t) { const e = qf._createAt(t.nodeBefore, "end"); const n = qf._createAt(t.nodeAfter, 0); const o = t.root.document.graveyard; const i = new qf(o, [0]); const r = t.root.document.version; const s = new wm(n, t.nodeAfter.maxOffset, e, i, r); this.batch.addOperation(s); this.model.applyOperation(s); }
            rename(t, e) { this._assertWriterUsedCorrectly(); if (!(t instanceof Nf)) {
                throw new u["a"]("writer-rename-not-element-instance", this);
            } const n = t.root.document ? t.root.document.version : null; const o = new km(qf._createBefore(t), t.name, e, n); this.batch.addOperation(o); this.model.applyOperation(o); }
            split(t, e) { this._assertWriterUsedCorrectly(); let n = t.parent; if (!n.parent) {
                throw new u["a"]("writer-split-element-no-parent", this);
            } if (!e) {
                e = n.parent;
            } if (!t.parent.getAncestors({ includeSelf: true }).includes(e)) {
                throw new u["a"]("writer-split-invalid-limit-element", this);
            } let o, i; do {
                const e = n.root.document ? n.root.document.version : null;
                const r = n.maxOffset - t.offset;
                const s = _m.getInsertionPosition(t);
                const a = new _m(t, r, s, null, e);
                this.batch.addOperation(a);
                this.model.applyOperation(a);
                if (!o && !i) {
                    o = n;
                    i = t.parent.nextSibling;
                }
                t = this.createPositionAfter(t.parent);
                n = t.parent;
            } while (n !== e); return { position: t, range: new Wf(qf._createAt(o, "end"), qf._createAt(i, 0)) }; }
            wrap(t, e) { this._assertWriterUsedCorrectly(); if (!t.isFlat) {
                throw new u["a"]("writer-wrap-range-not-flat", this);
            } const n = e instanceof Nf ? e : new Nf(e); if (n.childCount > 0) {
                throw new u["a"]("writer-wrap-element-not-empty", this);
            } if (n.parent !== null) {
                throw new u["a"]("writer-wrap-element-attached", this);
            } this.insert(n, t.start); const o = new Wf(t.start.getShiftedBy(1), t.end.getShiftedBy(1)); this.move(o, qf._createAt(n, 0)); }
            unwrap(t) { this._assertWriterUsedCorrectly(); if (t.parent === null) {
                throw new u["a"]("writer-unwrap-element-no-parent", this);
            } this.move(Wf._createIn(t), this.createPositionAfter(t)); this.remove(t); }
            addMarker(t, e) { this._assertWriterUsedCorrectly(); if (!e || typeof e.usingOperation != "boolean") {
                throw new u["a"]("writer-addmarker-no-usingoperation", this);
            } const n = e.usingOperation; const o = e.range; const i = e.affectsData === undefined ? false : e.affectsData; if (this.model.markers.has(t)) {
                throw new u["a"]("writer-addmarker-marker-exists", this);
            } if (!o) {
                throw new u["a"]("writer-addmarker-no-range", this);
            } if (!n) {
                return this.model.markers._set(t, o, n, i);
            } xm(this, t, null, o, i); return this.model.markers.get(t); }
            updateMarker(t, e) { this._assertWriterUsedCorrectly(); const n = typeof t == "string" ? t : t.name; const o = this.model.markers.get(n); if (!o) {
                throw new u["a"]("writer-updatemarker-marker-not-exists", this);
            } if (!e) {
                this.model.markers._refresh(o);
                return;
            } const i = typeof e.usingOperation == "boolean"; const r = typeof e.affectsData == "boolean"; const s = r ? e.affectsData : o.affectsData; if (!i && !e.range && !r) {
                throw new u["a"]("writer-updatemarker-wrong-options", this);
            } const a = o.getRange(); const c = e.range ? e.range : a; if (i && e.usingOperation !== o.managedUsingOperations) {
                if (e.usingOperation) {
                    xm(this, n, null, c, s);
                }
                else {
                    xm(this, n, a, null, s);
                    this.model.markers._set(n, c, undefined, s);
                }
                return;
            } if (o.managedUsingOperations) {
                xm(this, n, a, c, s);
            }
            else {
                this.model.markers._set(n, c, undefined, s);
            } }
            removeMarker(t) { this._assertWriterUsedCorrectly(); const e = typeof t == "string" ? t : t.name; if (!this.model.markers.has(e)) {
                throw new u["a"]("writer-removemarker-no-marker", this);
            } const n = this.model.markers.get(e); if (!n.managedUsingOperations) {
                this.model.markers._remove(e);
                return;
            } const o = n.getRange(); xm(this, e, o, null, n.affectsData); }
            setSelection(t, e, n) { this._assertWriterUsedCorrectly(); this.model.document.selection._setTo(t, e, n); }
            setSelectionFocus(t, e) { this._assertWriterUsedCorrectly(); this.model.document.selection._setFocus(t, e); }
            setSelectionAttribute(t, e) { this._assertWriterUsedCorrectly(); if (typeof t === "string") {
                this._setSelectionAttribute(t, e);
            }
            else {
                for (const [e, n] of La(t)) {
                    this._setSelectionAttribute(e, n);
                }
            } }
            removeSelectionAttribute(t) { this._assertWriterUsedCorrectly(); if (typeof t === "string") {
                this._removeSelectionAttribute(t);
            }
            else {
                for (const e of t) {
                    this._removeSelectionAttribute(e);
                }
            } }
            overrideSelectionGravity() { return this.model.document.selection._overrideGravity(); }
            restoreSelectionGravity(t) { this.model.document.selection._restoreGravity(t); }
            _setSelectionAttribute(t, e) { const n = this.model.document.selection; if (n.isCollapsed && n.anchor.parent.isEmpty) {
                const o = up._getStoreAttributeKey(t);
                this.setAttribute(o, e, n.anchor.parent);
            } n._setAttribute(t, e); }
            _removeSelectionAttribute(t) { const e = this.model.document.selection; if (e.isCollapsed && e.anchor.parent.isEmpty) {
                const n = up._getStoreAttributeKey(t);
                this.removeAttribute(n, e.anchor.parent);
            } e._removeAttribute(t); }
            _assertWriterUsedCorrectly() { if (this.model._currentWriter !== this) {
                throw new u["a"]("writer-incorrect-use", this);
            } }
            _addOperationForAffectedMarkers(t, e) { for (const n of this.model.markers) {
                if (!n.managedUsingOperations) {
                    continue;
                }
                const o = n.getRange();
                let i = false;
                if (t === "move") {
                    i = e.containsPosition(o.start) || e.start.isEqual(o.start) || e.containsPosition(o.end) || e.end.isEqual(o.end);
                }
                else {
                    const t = e.nodeBefore;
                    const n = e.nodeAfter;
                    const r = o.start.parent == t && o.start.isAtEnd;
                    const s = o.end.parent == n && o.end.offset == 0;
                    const a = o.end.nodeAfter == n;
                    const c = o.start.nodeAfter == n;
                    i = r || s || a || c;
                }
                if (i) {
                    this.updateMarker(n.name, { range: o });
                }
            } }
        }
        function Cm(t, e, n, o) { const i = t.model; const r = i.document; let s = o.start; let a; let c; let l; for (const t of o.getWalker({ shallow: true })) {
            l = t.item.getAttribute(e);
            if (a && c != l) {
                if (c != n) {
                    d();
                }
                s = a;
            }
            a = t.nextPosition;
            c = l;
        } if (a instanceof qf && a != s && c != n) {
            d();
        } function d() { const o = new Wf(s, a); const l = o.root.document ? r.version : null; const d = new hm(o, e, c, n, l); t.batch.addOperation(d); i.applyOperation(d); } }
        function ym(t, e, n, o) { const i = t.model; const r = i.document; const s = o.getAttribute(e); let a, c; if (s != n) {
            const l = o.root === o;
            if (l) {
                const t = o.document ? r.version : null;
                c = new bm(o, e, s, n, t);
            }
            else {
                a = new Wf(qf._createBefore(o), t.createPositionAfter(o));
                const i = a.root.document ? r.version : null;
                c = new hm(a, e, s, n, i);
            }
            t.batch.addOperation(c);
            i.applyOperation(c);
        } }
        function xm(t, e, n, o, i) { const r = t.model; const s = r.document; const a = new mm(e, n, o, r.markers, i, s.version); t.batch.addOperation(a); r.applyOperation(a); }
        function Em(t, e, n, o) { let i; if (t.root.document) {
            const n = o.document;
            const r = new qf(n.graveyard, [0]);
            i = new pm(t, e, r, n.version);
        }
        else {
            i = new fm(t, e);
        } n.addOperation(i); o.applyOperation(i); }
        function Dm(t, e) { if (t === e) {
            return true;
        } if (t instanceof vm && e instanceof vm) {
            return true;
        } return false; }
        class Sm {
            constructor(t) { this._markerCollection = t; this._changesInElement = new Map; this._elementSnapshots = new Map; this._changedMarkers = new Map; this._changeCount = 0; this._cachedChanges = null; this._cachedChangesWithGraveyard = null; }
            get isEmpty() { return this._changesInElement.size == 0 && this._changedMarkers.size == 0; }
            refreshItem(t) { if (this._isInInsertedElement(t.parent)) {
                return;
            } this._markRemove(t.parent, t.startOffset, t.offsetSize); this._markInsert(t.parent, t.startOffset, t.offsetSize); const e = Wf._createOn(t); for (const t of this._markerCollection.getMarkersIntersectingRange(e)) {
                const e = t.getRange();
                this.bufferMarkerChange(t.name, e, e, t.affectsData);
            } this._cachedChanges = null; }
            bufferOperation(t) { switch (t.type) {
                case "insert": {
                    if (this._isInInsertedElement(t.position.parent)) {
                        return;
                    }
                    this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);
                    break;
                }
                case "addAttribute":
                case "removeAttribute":
                case "changeAttribute": {
                    for (const e of t.range.getItems({ shallow: true })) {
                        if (this._isInInsertedElement(e.parent)) {
                            continue;
                        }
                        this._markAttribute(e);
                    }
                    break;
                }
                case "remove":
                case "move":
                case "reinsert": {
                    if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) {
                        return;
                    }
                    const e = this._isInInsertedElement(t.sourcePosition.parent);
                    const n = this._isInInsertedElement(t.targetPosition.parent);
                    if (!e) {
                        this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany);
                    }
                    if (!n) {
                        this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                    }
                    break;
                }
                case "rename": {
                    if (this._isInInsertedElement(t.position.parent)) {
                        return;
                    }
                    this._markRemove(t.position.parent, t.position.offset, 1);
                    this._markInsert(t.position.parent, t.position.offset, 1);
                    const e = Wf._createFromPositionAndShift(t.position, 1);
                    for (const t of this._markerCollection.getMarkersIntersectingRange(e)) {
                        const e = t.getRange();
                        this.bufferMarkerChange(t.name, e, e, t.affectsData);
                    }
                    break;
                }
                case "split": {
                    const e = t.splitPosition.parent;
                    if (!this._isInInsertedElement(e)) {
                        this._markRemove(e, t.splitPosition.offset, t.howMany);
                    }
                    if (!this._isInInsertedElement(t.insertionPosition.parent)) {
                        this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1);
                    }
                    if (t.graveyardPosition) {
                        this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                    }
                    break;
                }
                case "merge": {
                    const e = t.sourcePosition.parent;
                    if (!this._isInInsertedElement(e.parent)) {
                        this._markRemove(e.parent, e.startOffset, 1);
                    }
                    const n = t.graveyardPosition.parent;
                    this._markInsert(n, t.graveyardPosition.offset, 1);
                    const o = t.targetPosition.parent;
                    if (!this._isInInsertedElement(o)) {
                        this._markInsert(o, t.targetPosition.offset, e.maxOffset);
                    }
                    break;
                }
            } this._cachedChanges = null; }
            bufferMarkerChange(t, e, n, o) { const i = this._changedMarkers.get(t); if (!i) {
                this._changedMarkers.set(t, { oldRange: e, newRange: n, affectsData: o });
            }
            else {
                i.newRange = n;
                i.affectsData = o;
                if (i.oldRange == null && i.newRange == null) {
                    this._changedMarkers.delete(t);
                }
            } }
            getMarkersToRemove() { const t = []; for (const [e, n] of this._changedMarkers) {
                if (n.oldRange != null) {
                    t.push({ name: e, range: n.oldRange });
                }
            } return t; }
            getMarkersToAdd() { const t = []; for (const [e, n] of this._changedMarkers) {
                if (n.newRange != null) {
                    t.push({ name: e, range: n.newRange });
                }
            } return t; }
            getChangedMarkers() { return Array.from(this._changedMarkers).map((t => ({ name: t[0], data: { oldRange: t[1].oldRange, newRange: t[1].newRange } }))); }
            hasDataChanges() { for (const [, t] of this._changedMarkers) {
                if (t.affectsData) {
                    return true;
                }
            } return this._changesInElement.size > 0; }
            getChanges(t = { includeChangesInGraveyard: false }) { if (this._cachedChanges) {
                if (t.includeChangesInGraveyard) {
                    return this._cachedChangesWithGraveyard.slice();
                }
                else {
                    return this._cachedChanges.slice();
                }
            } let e = []; for (const t of this._changesInElement.keys()) {
                const n = this._changesInElement.get(t).sort(((t, e) => { if (t.offset === e.offset) {
                    if (t.type != e.type) {
                        return t.type == "remove" ? -1 : 1;
                    }
                    return 0;
                } return t.offset < e.offset ? -1 : 1; }));
                const o = this._elementSnapshots.get(t);
                const i = Tm(t.getChildren());
                const r = Pm(o.length, n);
                let s = 0;
                let a = 0;
                for (const n of r) {
                    if (n === "i") {
                        e.push(this._getInsertDiff(t, s, i[s].name));
                        s++;
                    }
                    else if (n === "r") {
                        e.push(this._getRemoveDiff(t, s, o[a].name));
                        a++;
                    }
                    else if (n === "a") {
                        const n = i[s].attributes;
                        const r = o[a].attributes;
                        let c;
                        if (i[s].name == "$text") {
                            c = new Wf(qf._createAt(t, s), qf._createAt(t, s + 1));
                        }
                        else {
                            const e = t.offsetToIndex(s);
                            c = new Wf(qf._createAt(t, s), qf._createAt(t.getChild(e), 0));
                        }
                        e.push(...this._getAttributesDiff(c, r, n));
                        s++;
                        a++;
                    }
                    else {
                        s++;
                        a++;
                    }
                }
            } e.sort(((t, e) => { if (t.position.root != e.position.root) {
                return t.position.root.rootName < e.position.root.rootName ? -1 : 1;
            } if (t.position.isEqual(e.position)) {
                return t.changeCount - e.changeCount;
            } return t.position.isBefore(e.position) ? -1 : 1; })); for (let t = 1, n = 0; t < e.length; t++) {
                const o = e[n];
                const i = e[t];
                const r = o.type == "remove" && i.type == "remove" && o.name == "$text" && i.name == "$text" && o.position.isEqual(i.position);
                const s = o.type == "insert" && i.type == "insert" && o.name == "$text" && i.name == "$text" && o.position.parent == i.position.parent && o.position.offset + o.length == i.position.offset;
                const a = o.type == "attribute" && i.type == "attribute" && o.position.parent == i.position.parent && o.range.isFlat && i.range.isFlat && o.position.offset + o.length == i.position.offset && o.attributeKey == i.attributeKey && o.attributeOldValue == i.attributeOldValue && o.attributeNewValue == i.attributeNewValue;
                if (r || s || a) {
                    o.length++;
                    if (a) {
                        o.range.end = o.range.end.getShiftedBy(1);
                    }
                    e[t] = null;
                }
                else {
                    n = t;
                }
            } e = e.filter((t => t)); for (const t of e) {
                delete t.changeCount;
                if (t.type == "attribute") {
                    delete t.position;
                    delete t.length;
                }
            } this._changeCount = 0; this._cachedChangesWithGraveyard = e.slice(); this._cachedChanges = e.filter(Bm); if (t.includeChangesInGraveyard) {
                return this._cachedChangesWithGraveyard;
            }
            else {
                return this._cachedChanges;
            } }
            reset() { this._changesInElement.clear(); this._elementSnapshots.clear(); this._changedMarkers.clear(); this._cachedChanges = null; }
            _markInsert(t, e, n) { const o = { type: "insert", offset: e, howMany: n, count: this._changeCount++ }; this._markChange(t, o); }
            _markRemove(t, e, n) { const o = { type: "remove", offset: e, howMany: n, count: this._changeCount++ }; this._markChange(t, o); this._removeAllNestedChanges(t, e, n); }
            _markAttribute(t) { const e = { type: "attribute", offset: t.startOffset, howMany: t.offsetSize, count: this._changeCount++ }; this._markChange(t.parent, e); }
            _markChange(t, e) { this._makeSnapshot(t); const n = this._getChangesForElement(t); this._handleChange(e, n); n.push(e); for (let t = 0; t < n.length; t++) {
                if (n[t].howMany < 1) {
                    n.splice(t, 1);
                    t--;
                }
            } }
            _getChangesForElement(t) { let e; if (this._changesInElement.has(t)) {
                e = this._changesInElement.get(t);
            }
            else {
                e = [];
                this._changesInElement.set(t, e);
            } return e; }
            _makeSnapshot(t) { if (!this._elementSnapshots.has(t)) {
                this._elementSnapshots.set(t, Tm(t.getChildren()));
            } }
            _handleChange(t, e) { t.nodesToHandle = t.howMany; for (const n of e) {
                const o = t.offset + t.howMany;
                const i = n.offset + n.howMany;
                if (t.type == "insert") {
                    if (n.type == "insert") {
                        if (t.offset <= n.offset) {
                            n.offset += t.howMany;
                        }
                        else if (t.offset < i) {
                            n.howMany += t.nodesToHandle;
                            t.nodesToHandle = 0;
                        }
                    }
                    if (n.type == "remove") {
                        if (t.offset < n.offset) {
                            n.offset += t.howMany;
                        }
                    }
                    if (n.type == "attribute") {
                        if (t.offset <= n.offset) {
                            n.offset += t.howMany;
                        }
                        else if (t.offset < i) {
                            const i = n.howMany;
                            n.howMany = t.offset - n.offset;
                            e.unshift({ type: "attribute", offset: o, howMany: i - n.howMany, count: this._changeCount++ });
                        }
                    }
                }
                if (t.type == "remove") {
                    if (n.type == "insert") {
                        if (o <= n.offset) {
                            n.offset -= t.howMany;
                        }
                        else if (o <= i) {
                            if (t.offset < n.offset) {
                                const e = o - n.offset;
                                n.offset = t.offset;
                                n.howMany -= e;
                                t.nodesToHandle -= e;
                            }
                            else {
                                n.howMany -= t.nodesToHandle;
                                t.nodesToHandle = 0;
                            }
                        }
                        else {
                            if (t.offset <= n.offset) {
                                t.nodesToHandle -= n.howMany;
                                n.howMany = 0;
                            }
                            else if (t.offset < i) {
                                const e = i - t.offset;
                                n.howMany -= e;
                                t.nodesToHandle -= e;
                            }
                        }
                    }
                    if (n.type == "remove") {
                        if (o <= n.offset) {
                            n.offset -= t.howMany;
                        }
                        else if (t.offset < n.offset) {
                            t.nodesToHandle += n.howMany;
                            n.howMany = 0;
                        }
                    }
                    if (n.type == "attribute") {
                        if (o <= n.offset) {
                            n.offset -= t.howMany;
                        }
                        else if (t.offset < n.offset) {
                            const e = o - n.offset;
                            n.offset = t.offset;
                            n.howMany -= e;
                        }
                        else if (t.offset < i) {
                            if (o <= i) {
                                const o = n.howMany;
                                n.howMany = t.offset - n.offset;
                                const i = o - n.howMany - t.nodesToHandle;
                                e.unshift({ type: "attribute", offset: t.offset, howMany: i, count: this._changeCount++ });
                            }
                            else {
                                n.howMany -= i - t.offset;
                            }
                        }
                    }
                }
                if (t.type == "attribute") {
                    if (n.type == "insert") {
                        if (t.offset < n.offset && o > n.offset) {
                            if (o > i) {
                                const t = { type: "attribute", offset: i, howMany: o - i, count: this._changeCount++ };
                                this._handleChange(t, e);
                                e.push(t);
                            }
                            t.nodesToHandle = n.offset - t.offset;
                            t.howMany = t.nodesToHandle;
                        }
                        else if (t.offset >= n.offset && t.offset < i) {
                            if (o > i) {
                                t.nodesToHandle = o - i;
                                t.offset = i;
                            }
                            else {
                                t.nodesToHandle = 0;
                            }
                        }
                    }
                    if (n.type == "remove") {
                        if (t.offset < n.offset && o > n.offset) {
                            const i = { type: "attribute", offset: n.offset, howMany: o - n.offset, count: this._changeCount++ };
                            this._handleChange(i, e);
                            e.push(i);
                            t.nodesToHandle = n.offset - t.offset;
                            t.howMany = t.nodesToHandle;
                        }
                    }
                    if (n.type == "attribute") {
                        if (t.offset >= n.offset && o <= i) {
                            t.nodesToHandle = 0;
                            t.howMany = 0;
                            t.offset = 0;
                        }
                        else if (t.offset <= n.offset && o >= i) {
                            n.howMany = 0;
                        }
                    }
                }
            } t.howMany = t.nodesToHandle; delete t.nodesToHandle; }
            _getInsertDiff(t, e, n) { return { type: "insert", position: qf._createAt(t, e), name: n, length: 1, changeCount: this._changeCount++ }; }
            _getRemoveDiff(t, e, n) { return { type: "remove", position: qf._createAt(t, e), name: n, length: 1, changeCount: this._changeCount++ }; }
            _getAttributesDiff(t, e, n) { const o = []; n = new Map(n); for (const [i, r] of e) {
                const e = n.has(i) ? n.get(i) : null;
                if (e !== r) {
                    o.push({ type: "attribute", position: t.start, range: t.clone(), length: 1, attributeKey: i, attributeOldValue: r, attributeNewValue: e, changeCount: this._changeCount++ });
                }
                n.delete(i);
            } for (const [e, i] of n) {
                o.push({ type: "attribute", position: t.start, range: t.clone(), length: 1, attributeKey: e, attributeOldValue: null, attributeNewValue: i, changeCount: this._changeCount++ });
            } return o; }
            _isInInsertedElement(t) { const e = t.parent; if (!e) {
                return false;
            } const n = this._changesInElement.get(e); const o = t.startOffset; if (n) {
                for (const t of n) {
                    if (t.type == "insert" && o >= t.offset && o < t.offset + t.howMany) {
                        return true;
                    }
                }
            } return this._isInInsertedElement(e); }
            _removeAllNestedChanges(t, e, n) { const o = new Wf(qf._createAt(t, e), qf._createAt(t, e + n)); for (const t of o.getItems({ shallow: true })) {
                if (t.is("element")) {
                    this._elementSnapshots.delete(t);
                    this._changesInElement.delete(t);
                    this._removeAllNestedChanges(t, 0, t.maxOffset);
                }
            } }
        }
        function Tm(t) { const e = []; for (const n of t) {
            if (n.is("$text")) {
                for (let t = 0; t < n.data.length; t++) {
                    e.push({ name: "$text", attributes: new Map(n.getAttributes()) });
                }
            }
            else {
                e.push({ name: n.name, attributes: new Map(n.getAttributes()) });
            }
        } return e; }
        function Pm(t, e) { const n = []; let o = 0; let i = 0; for (const t of e) {
            if (t.offset > o) {
                for (let e = 0; e < t.offset - o; e++) {
                    n.push("e");
                }
                i += t.offset - o;
            }
            if (t.type == "insert") {
                for (let e = 0; e < t.howMany; e++) {
                    n.push("i");
                }
                o = t.offset + t.howMany;
            }
            else if (t.type == "remove") {
                for (let e = 0; e < t.howMany; e++) {
                    n.push("r");
                }
                o = t.offset;
                i += t.howMany;
            }
            else {
                n.push(..."a".repeat(t.howMany).split(""));
                o = t.offset + t.howMany;
                i += t.howMany;
            }
        } if (i < t) {
            for (let e = 0; e < t - i - o; e++) {
                n.push("e");
            }
        } return n; }
        function Bm(t) { const e = t.position && t.position.root.rootName == "$graveyard"; const n = t.range && t.range.root.rootName == "$graveyard"; return !e && !n; }
        class Im {
            constructor() { this._operations = []; this._undoPairs = new Map; this._undoneOperations = new Set; }
            addOperation(t) { if (this._operations.includes(t)) {
                return;
            } this._operations.push(t); }
            getOperations(t = Number.NEGATIVE_INFINITY, e = Number.POSITIVE_INFINITY) { const n = []; for (const o of this._operations) {
                if (o.baseVersion >= t && o.baseVersion < e) {
                    n.push(o);
                }
            } return n; }
            getOperation(t) { for (const e of this._operations) {
                if (e.baseVersion == t) {
                    return e;
                }
            } }
            setOperationAsUndone(t, e) { this._undoPairs.set(e, t); this._undoneOperations.add(t); }
            isUndoingOperation(t) { return this._undoPairs.has(t); }
            isUndoneOperation(t) { return this._undoneOperations.has(t); }
            getUndoneOperation(t) { return this._undoPairs.get(t); }
        }
        function Rm(t) { return !!t && t.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(t); }
        function Fm(t) { return !!t && t.length == 1 && /[\ud800-\udbff]/.test(t); }
        function Om(t) { return !!t && t.length == 1 && /[\udc00-\udfff]/.test(t); }
        function zm(t, e) { return Fm(t.charAt(e - 1)) && Om(t.charAt(e)); }
        function Nm(t, e) { return Rm(t.charAt(e)); }
        const Mm = "$graveyard";
        class Vm {
            constructor(t) { this.model = t; this.version = 0; this.history = new Im(this); this.selection = new up(this); this.roots = new ba({ idProperty: "rootName" }); this.differ = new Sm(t.markers); this._postFixers = new Set; this._hasSelectionChangedFromTheLastChangeBlock = false; this.createRoot("$root", Mm); this.listenTo(t, "applyOperation", ((t, e) => { const n = e[0]; if (n.isDocumentOperation && n.baseVersion !== this.version) {
                throw new u["a"]("model-document-applyoperation-wrong-version", this, { operation: n });
            } }), { priority: "highest" }); this.listenTo(t, "applyOperation", ((t, e) => { const n = e[0]; if (n.isDocumentOperation) {
                this.differ.bufferOperation(n);
            } }), { priority: "high" }); this.listenTo(t, "applyOperation", ((t, e) => { const n = e[0]; if (n.isDocumentOperation) {
                this.version++;
                this.history.addOperation(n);
            } }), { priority: "low" }); this.listenTo(this.selection, "change", (() => { this._hasSelectionChangedFromTheLastChangeBlock = true; })); this.listenTo(t.markers, "update", ((t, e, n, o) => { this.differ.bufferMarkerChange(e.name, n, o, e.affectsData); if (n === null) {
                e.on("change", ((t, n) => { this.differ.bufferMarkerChange(e.name, n, e.getRange(), e.affectsData); }));
            } })); }
            get graveyard() { return this.getRoot(Mm); }
            createRoot(t = "$root", e = "main") { if (this.roots.get(e)) {
                throw new u["a"]("model-document-createroot-name-exists", this, { name: e });
            } const n = new vm(this, t, e); this.roots.add(n); return n; }
            destroy() { this.selection.destroy(); this.stopListening(); }
            getRoot(t = "main") { return this.roots.get(t); }
            getRootNames() { return Array.from(this.roots, (t => t.rootName)).filter((t => t != Mm)); }
            registerPostFixer(t) { this._postFixers.add(t); }
            toJSON() { const t = Oa(this); t.selection = "[engine.model.DocumentSelection]"; t.model = "[engine.model.Model]"; return t; }
            _handleChangeBlock(t) { if (this._hasDocumentChangedFromTheLastChangeBlock()) {
                this._callPostFixers(t);
                this.selection.refresh();
                if (this.differ.hasDataChanges()) {
                    this.fire("change:data", t.batch);
                }
                else {
                    this.fire("change", t.batch);
                }
                this.selection.refresh();
                this.differ.reset();
            } this._hasSelectionChangedFromTheLastChangeBlock = false; }
            _hasDocumentChangedFromTheLastChangeBlock() { return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock; }
            _getDefaultRoot() { for (const t of this.roots) {
                if (t !== this.graveyard) {
                    return t;
                }
            } return this.graveyard; }
            _getDefaultRange() { const t = this._getDefaultRoot(); const e = this.model; const n = e.schema; const o = e.createPositionFromPath(t, [0]); const i = n.getNearestSelectionRange(o); return i || e.createRange(o); }
            _validateSelectionRange(t) { return Lm(t.start) && Lm(t.end); }
            _callPostFixers(t) { let e = false; do {
                for (const n of this._postFixers) {
                    this.selection.refresh();
                    e = n(t);
                    if (e) {
                        break;
                    }
                }
            } while (e); }
        }
        qn(Vm, g);
        function Lm(t) { const e = t.textNode; if (e) {
            const n = e.data;
            const o = t.offset - e.startOffset;
            return !zm(n, o) && !Nm(n, o);
        } return true; }
        class qm {
            constructor() { this._markers = new Map; }
            [Symbol.iterator]() { return this._markers.values(); }
            has(t) { return this._markers.has(t); }
            get(t) { return this._markers.get(t) || null; }
            _set(t, e, n = false, o = false) { const i = t instanceof Km ? t.name : t; if (i.includes(",")) {
                throw new u["a"]("markercollection-incorrect-marker-name", this);
            } const r = this._markers.get(i); if (r) {
                const t = r.getRange();
                let s = false;
                if (!t.isEqual(e)) {
                    r._attachLiveRange(sp.fromRange(e));
                    s = true;
                }
                if (n != r.managedUsingOperations) {
                    r._managedUsingOperations = n;
                    s = true;
                }
                if (typeof o === "boolean" && o != r.affectsData) {
                    r._affectsData = o;
                    s = true;
                }
                if (s) {
                    this.fire("update:" + i, r, t, e);
                }
                return r;
            } const s = sp.fromRange(e); const a = new Km(i, s, n, o); this._markers.set(i, a); this.fire("update:" + i, a, null, e); return a; }
            _remove(t) { const e = t instanceof Km ? t.name : t; const n = this._markers.get(e); if (n) {
                this._markers.delete(e);
                this.fire("update:" + e, n, n.getRange(), null);
                this._destroyMarker(n);
                return true;
            } return false; }
            _refresh(t) { const e = t instanceof Km ? t.name : t; const n = this._markers.get(e); if (!n) {
                throw new u["a"]("markercollection-refresh-marker-not-exists", this);
            } const o = n.getRange(); this.fire("update:" + e, n, o, o, n.managedUsingOperations, n.affectsData); }
            *getMarkersAtPosition(t) { for (const e of this) {
                if (e.getRange().containsPosition(t)) {
                    yield e;
                }
            } }
            *getMarkersIntersectingRange(t) { for (const e of this) {
                if (e.getRange().getIntersection(t) !== null) {
                    yield e;
                }
            } }
            destroy() { for (const t of this._markers.values()) {
                this._destroyMarker(t);
            } this._markers = null; this.stopListening(); }
            *getMarkersGroup(t) { for (const e of this._markers.values()) {
                if (e.name.startsWith(t + ":")) {
                    yield e;
                }
            } }
            _destroyMarker(t) { t.stopListening(); t._detachLiveRange(); }
        }
        qn(qm, g);
        class Km {
            constructor(t, e, n, o) { this.name = t; this._liveRange = this._attachLiveRange(e); this._managedUsingOperations = n; this._affectsData = o; }
            get managedUsingOperations() { if (!this._liveRange) {
                throw new u["a"]("marker-destroyed", this);
            } return this._managedUsingOperations; }
            get affectsData() { if (!this._liveRange) {
                throw new u["a"]("marker-destroyed", this);
            } return this._affectsData; }
            getStart() { if (!this._liveRange) {
                throw new u["a"]("marker-destroyed", this);
            } return this._liveRange.start.clone(); }
            getEnd() { if (!this._liveRange) {
                throw new u["a"]("marker-destroyed", this);
            } return this._liveRange.end.clone(); }
            getRange() { if (!this._liveRange) {
                throw new u["a"]("marker-destroyed", this);
            } return this._liveRange.toRange(); }
            is(t) { return t === "marker" || t === "model:marker"; }
            _attachLiveRange(t) { if (this._liveRange) {
                this._detachLiveRange();
            } t.delegate("change:range").to(this); t.delegate("change:content").to(this); this._liveRange = t; return t; }
            _detachLiveRange() { this._liveRange.stopDelegating("change:range", this); this._liveRange.stopDelegating("change:content", this); this._liveRange.detach(); this._liveRange = null; }
        }
        qn(Km, g);
        class jm extends Zg {
            get type() { return "noop"; }
            clone() { return new jm(this.baseVersion); }
            getReversed() { return new jm(this.baseVersion + 1); }
            _execute() { }
            static get className() { return "NoOperation"; }
        }
        const Hm = {};
        Hm[hm.className] = hm;
        Hm[gm.className] = gm;
        Hm[mm.className] = mm;
        Hm[pm.className] = pm;
        Hm[jm.className] = jm;
        Hm[Zg.className] = Zg;
        Hm[km.className] = km;
        Hm[bm.className] = bm;
        Hm[_m.className] = _m;
        Hm[wm.className] = wm;
        class Wm {
            static fromJSON(t, e) { return Hm[t.__className].fromJSON(t, e); }
        }
        class $m extends qf {
            constructor(t, e, n = "toNone") { super(t, e, n); if (!this.root.is("rootElement")) {
                throw new u["a"]("model-liveposition-root-not-rootelement", t);
            } Gm.call(this); }
            detach() { this.stopListening(); }
            is(t) { return t === "livePosition" || t === "model:livePosition" || t == "position" || t === "model:position"; }
            toPosition() { return new qf(this.root, this.path.slice(), this.stickiness); }
            static fromPosition(t, e) { return new this(t.root, t.path.slice(), e ? e : t.stickiness); }
        }
        function Gm() { this.listenTo(this.root.document.model, "applyOperation", ((t, e) => { const n = e[0]; if (!n.isDocumentOperation) {
            return;
        } Um.call(this, n); }), { priority: "low" }); }
        function Um(t) { const e = this.getTransformedByOperation(t); if (!this.isEqual(e)) {
            const t = this.toPosition();
            this.path = e.path;
            this.root = e.root;
            this.fire("change", t);
        } }
        qn($m, g);
        function Jm(t, e, n, o) { return t.change((i => { let r; if (!n) {
            r = t.document.selection;
        }
        else if (n instanceof tp || n instanceof up) {
            r = n;
        }
        else {
            r = i.createSelection(n, o);
        } if (!r.isCollapsed) {
            t.deleteContent(r, { doNotAutoparagraph: true });
        } const s = new Ym(t, i, r.anchor); let a; if (e.is("documentFragment")) {
            a = e.getChildren();
        }
        else {
            a = [e];
        } s.handleNodes(a); const c = s.getSelectionRange(); if (c) {
            if (r instanceof up) {
                i.setSelection(c);
            }
            else {
                r.setTo(c);
            }
        }
        else { } const l = s.getAffectedRange() || t.createRange(r.anchor); s.destroy(); return l; })); }
        class Ym {
            constructor(t, e, n) { this.model = t; this.writer = e; this.position = n; this.canMergeWith = new Set([this.position.parent]); this.schema = t.schema; this._documentFragment = e.createDocumentFragment(); this._documentFragmentPosition = e.createPositionAt(this._documentFragment, 0); this._firstNode = null; this._lastNode = null; this._lastAutoParagraph = null; this._filterAttributesOf = []; this._affectedStart = null; this._affectedEnd = null; }
            handleNodes(t) { for (const e of Array.from(t)) {
                this._handleNode(e);
            } this._insertPartialFragment(); if (this._lastAutoParagraph) {
                this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph);
            } this._mergeOnRight(); this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer); this._filterAttributesOf = []; }
            _updateLastNodeFromAutoParagraph(t) { const e = this.writer.createPositionAfter(this._lastNode); const n = this.writer.createPositionAfter(t); if (n.isAfter(e)) {
                this._lastNode = t;
                if (this.position.parent != t || !this.position.isAtEnd) {
                    throw new u["a"]("insertcontent-invalid-insertion-position", this);
                }
                this.position = n;
                this._setAffectedBoundaries(this.position);
            } }
            getSelectionRange() { if (this.nodeToSelect) {
                return Wf._createOn(this.nodeToSelect);
            } return this.model.schema.getNearestSelectionRange(this.position); }
            getAffectedRange() { if (!this._affectedStart) {
                return null;
            } return new Wf(this._affectedStart, this._affectedEnd); }
            destroy() { if (this._affectedStart) {
                this._affectedStart.detach();
            } if (this._affectedEnd) {
                this._affectedEnd.detach();
            } }
            _handleNode(t) { if (this.schema.isObject(t)) {
                this._handleObject(t);
                return;
            } let e = this._checkAndAutoParagraphToAllowedPosition(t); if (!e) {
                e = this._checkAndSplitToAllowedPosition(t);
                if (!e) {
                    this._handleDisallowedNode(t);
                    return;
                }
            } this._appendToFragment(t); if (!this._firstNode) {
                this._firstNode = t;
            } this._lastNode = t; }
            _insertPartialFragment() { if (this._documentFragment.isEmpty) {
                return;
            } const t = $m.fromPosition(this.position, "toNext"); this._setAffectedBoundaries(this.position); if (this._documentFragment.getChild(0) == this._firstNode) {
                this.writer.insert(this._firstNode, this.position);
                this._mergeOnLeft();
                this.position = t.toPosition();
            } if (!this._documentFragment.isEmpty) {
                this.writer.insert(this._documentFragment, this.position);
            } this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0); this.position = t.toPosition(); t.detach(); }
            _handleObject(t) { if (this._checkAndSplitToAllowedPosition(t)) {
                this._appendToFragment(t);
            }
            else {
                this._tryAutoparagraphing(t);
            } }
            _handleDisallowedNode(t) { if (t.is("element")) {
                this.handleNodes(t.getChildren());
            }
            else {
                this._tryAutoparagraphing(t);
            } }
            _appendToFragment(t) { if (!this.schema.checkChild(this.position, t)) {
                throw new u["a"]("insertcontent-wrong-position", this, { node: t, position: this.position });
            } this.writer.insert(t, this._documentFragmentPosition); this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t.offsetSize); if (this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text")) {
                this.nodeToSelect = t;
            }
            else {
                this.nodeToSelect = null;
            } this._filterAttributesOf.push(t); }
            _setAffectedBoundaries(t) { if (!this._affectedStart) {
                this._affectedStart = $m.fromPosition(t, "toPrevious");
            } if (!this._affectedEnd || this._affectedEnd.isBefore(t)) {
                if (this._affectedEnd) {
                    this._affectedEnd.detach();
                }
                this._affectedEnd = $m.fromPosition(t, "toNext");
            } }
            _mergeOnLeft() { const t = this._firstNode; if (!(t instanceof Nf)) {
                return;
            } if (!this._canMergeLeft(t)) {
                return;
            } const e = $m._createBefore(t); e.stickiness = "toNext"; const n = $m.fromPosition(this.position, "toNext"); if (this._affectedStart.isEqual(e)) {
                this._affectedStart.detach();
                this._affectedStart = $m._createAt(e.nodeBefore, "end", "toPrevious");
            } if (this._firstNode === this._lastNode) {
                this._firstNode = e.nodeBefore;
                this._lastNode = e.nodeBefore;
            } this.writer.merge(e); if (e.isEqual(this._affectedEnd) && this._firstNode === this._lastNode) {
                this._affectedEnd.detach();
                this._affectedEnd = $m._createAt(e.nodeBefore, "end", "toNext");
            } this.position = n.toPosition(); n.detach(); this._filterAttributesOf.push(this.position.parent); e.detach(); }
            _mergeOnRight() { const t = this._lastNode; if (!(t instanceof Nf)) {
                return;
            } if (!this._canMergeRight(t)) {
                return;
            } const e = $m._createAfter(t); e.stickiness = "toNext"; if (!this.position.isEqual(e)) {
                throw new u["a"]("insertcontent-invalid-insertion-position", this);
            } this.position = qf._createAt(e.nodeBefore, "end"); const n = $m.fromPosition(this.position, "toPrevious"); if (this._affectedEnd.isEqual(e)) {
                this._affectedEnd.detach();
                this._affectedEnd = $m._createAt(e.nodeBefore, "end", "toNext");
            } if (this._firstNode === this._lastNode) {
                this._firstNode = e.nodeBefore;
                this._lastNode = e.nodeBefore;
            } this.writer.merge(e); if (e.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode) {
                this._affectedStart.detach();
                this._affectedStart = $m._createAt(e.nodeBefore, 0, "toPrevious");
            } this.position = n.toPosition(); n.detach(); this._filterAttributesOf.push(this.position.parent); e.detach(); }
            _canMergeLeft(t) { const e = t.previousSibling; return e instanceof Nf && this.canMergeWith.has(e) && this.model.schema.checkMerge(e, t); }
            _canMergeRight(t) { const e = t.nextSibling; return e instanceof Nf && this.canMergeWith.has(e) && this.model.schema.checkMerge(t, e); }
            _tryAutoparagraphing(t) { const e = this.writer.createElement("paragraph"); if (this._getAllowedIn(e, this.position.parent) && this.schema.checkChild(e, t)) {
                e._appendChild(t);
                this._handleNode(e);
            } }
            _checkAndAutoParagraphToAllowedPosition(t) { if (this.schema.checkChild(this.position.parent, t)) {
                return true;
            } if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t)) {
                return false;
            } this._insertPartialFragment(); const e = this.writer.createElement("paragraph"); this.writer.insert(e, this.position); this._setAffectedBoundaries(this.position); this._lastAutoParagraph = e; this.position = this.writer.createPositionAt(e, 0); return true; }
            _checkAndSplitToAllowedPosition(t) { const e = this._getAllowedIn(t, this.position.parent); if (!e) {
                return false;
            } if (e != this.position.parent) {
                this._insertPartialFragment();
            } while (e != this.position.parent) {
                if (this.schema.isLimit(this.position.parent)) {
                    return false;
                }
                if (this.position.isAtStart) {
                    const t = this.position.parent;
                    this.position = this.writer.createPositionBefore(t);
                    if (t.isEmpty && t.parent === e) {
                        this.writer.remove(t);
                    }
                }
                else if (this.position.isAtEnd) {
                    this.position = this.writer.createPositionAfter(this.position.parent);
                }
                else {
                    const t = this.writer.createPositionAfter(this.position.parent);
                    this._setAffectedBoundaries(this.position);
                    this.writer.split(this.position);
                    this.position = t;
                    this.canMergeWith.add(this.position.nodeAfter);
                }
            } return true; }
            _getAllowedIn(t, e) { if (this.schema.checkChild(e, t)) {
                return e;
            } if (e.parent) {
                return this._getAllowedIn(t, e.parent);
            } return null; }
        }
        function Qm(t, e, n = {}) { if (e.isCollapsed) {
            return;
        } const o = e.getFirstRange(); if (o.root.rootName == "$graveyard") {
            return;
        } const i = t.schema; t.change((t => { if (!n.doNotResetEntireContent && dk(i, e)) {
            lk(t, e, i);
            return;
        } const [r, s] = Xm(o); if (!r.isTouching(s)) {
            t.remove(t.createRange(r, s));
        } if (!n.leaveUnmerged) {
            tk(t, r, s);
            i.removeDisallowedAttributes(r.parent.getChildren(), t);
        } uk(t, e, r); if (!n.doNotAutoparagraph && sk(i, r)) {
            ck(t, r, e);
        } r.detach(); s.detach(); })); }
        function Xm(t) { const e = t.root.document.model; const n = t.start; let o = t.end; if (e.hasContent(t, { ignoreMarkers: true })) {
            const n = Zm(o);
            if (n && o.isTouching(e.createPositionAt(n, 0))) {
                const n = e.createSelection(t);
                e.modifySelection(n, { direction: "backward" });
                o = n.getLastPosition();
            }
        } return [$m.fromPosition(n, "toPrevious"), $m.fromPosition(o, "toNext")]; }
        function Zm(t) { const e = t.parent; const n = e.root.document.model.schema; const o = e.getAncestors({ parentFirst: true, includeSelf: true }); for (const t of o) {
            if (n.isLimit(t)) {
                return null;
            }
            if (n.isBlock(t)) {
                return t;
            }
        } }
        function tk(t, e, n) { const o = t.model; if (!ik(t.model.schema, e, n)) {
            return;
        } const [i, r] = rk(e, n); if (!i || !r) {
            return;
        } if (!o.hasContent(i, { ignoreMarkers: true }) && o.hasContent(r, { ignoreMarkers: true })) {
            nk(t, e, n, i.parent);
        }
        else {
            ek(t, e, n, i.parent);
        } }
        function ek(t, e, n, o) { const i = e.parent; const r = n.parent; if (i == o || r == o) {
            return;
        } e = t.createPositionAfter(i); n = t.createPositionBefore(r); if (!n.isEqual(e)) {
            t.insert(r, e);
        } t.merge(e); while (n.parent.isEmpty) {
            const e = n.parent;
            n = t.createPositionBefore(e);
            t.remove(e);
        } if (!ik(t.model.schema, e, n)) {
            return;
        } ek(t, e, n, o); }
        function nk(t, e, n, o) { const i = e.parent; const r = n.parent; if (i == o || r == o) {
            return;
        } e = t.createPositionAfter(i); n = t.createPositionBefore(r); if (!n.isEqual(e)) {
            t.insert(i, n);
        } while (e.parent.isEmpty) {
            const n = e.parent;
            e = t.createPositionBefore(n);
            t.remove(n);
        } n = t.createPositionBefore(r); ok(t, n); if (!ik(t.model.schema, e, n)) {
            return;
        } nk(t, e, n, o); }
        function ok(t, e) { const n = e.nodeBefore; const o = e.nodeAfter; if (n.name != o.name) {
            t.rename(n, o.name);
        } t.clearAttributes(n); t.setAttributes(Object.fromEntries(o.getAttributes()), n); t.merge(e); }
        function ik(t, e, n) { const o = e.parent; const i = n.parent; if (o == i) {
            return false;
        } if (t.isLimit(o) || t.isLimit(i)) {
            return false;
        } return ak(e, n, t); }
        function rk(t, e) { const n = t.getAncestors(); const o = e.getAncestors(); let i = 0; while (n[i] && n[i] == o[i]) {
            i++;
        } return [n[i], o[i]]; }
        function sk(t, e) { const n = t.checkChild(e, "$text"); const o = t.checkChild(e, "paragraph"); return !n && o; }
        function ak(t, e, n) { const o = new Wf(t, e); for (const t of o.getWalker()) {
            if (n.isLimit(t.item)) {
                return false;
            }
        } return true; }
        function ck(t, e, n) { const o = t.createElement("paragraph"); t.insert(o, e); uk(t, n, t.createPositionAt(o, 0)); }
        function lk(t, e) { const n = t.model.schema.getLimitElement(e); t.remove(t.createRangeIn(n)); ck(t, t.createPositionAt(n, 0), e); }
        function dk(t, e) { const n = t.getLimitElement(e); if (!e.containsEntireContent(n)) {
            return false;
        } const o = e.getFirstRange(); if (o.start.parent == o.end.parent) {
            return false;
        } return t.checkChild(n, "paragraph"); }
        function uk(t, e, n) { if (e instanceof up) {
            t.setSelection(n);
        }
        else {
            e.setTo(n);
        } }
        const hk = ' ,.?!:;"-()';
        function fk(t, e, n = {}) { const o = t.schema; const i = n.direction != "backward"; const r = n.unit ? n.unit : "character"; const s = e.focus; const a = new Vf({ boundaries: kk(s, i), singleCharacters: true, direction: i ? "forward" : "backward" }); const c = { walker: a, schema: o, isForward: i, unit: r }; let l; while (l = a.next()) {
            if (l.done) {
                return;
            }
            const n = pk(c, l.value);
            if (n) {
                if (e instanceof up) {
                    t.change((t => { t.setSelectionFocus(n); }));
                }
                else {
                    e.setFocus(n);
                }
                return;
            }
        } }
        function pk(t, e) { const { isForward: n, walker: o, unit: i, schema: r } = t; const { type: s, item: a, nextPosition: c } = e; if (s == "text") {
            if (t.unit === "word") {
                return mk(o, n);
            }
            return gk(o, i, n);
        } if (s == (n ? "elementStart" : "elementEnd")) {
            if (r.isSelectable(a)) {
                return qf._createAt(a, n ? "after" : "before");
            }
            if (r.checkChild(c, "$text")) {
                return c;
            }
        }
        else {
            if (r.isLimit(a)) {
                o.skip((() => true));
                return;
            }
            if (r.checkChild(c, "$text")) {
                return c;
            }
        } }
        function gk(t, e) { const n = t.position.textNode; if (n) {
            const o = n.data;
            let i = t.position.offset - n.startOffset;
            while (zm(o, i) || e == "character" && Nm(o, i)) {
                t.next();
                i = t.position.offset - n.startOffset;
            }
        } return t.position; }
        function mk(t, e) { let n = t.position.textNode; if (n) {
            let o = t.position.offset - n.startOffset;
            while (!bk(n.data, o, e) && !wk(n, o, e)) {
                t.next();
                const i = e ? t.position.nodeAfter : t.position.nodeBefore;
                if (i && i.is("$text")) {
                    const o = i.data.charAt(e ? 0 : i.data.length - 1);
                    if (!hk.includes(o)) {
                        t.next();
                        n = t.position.textNode;
                    }
                }
                o = t.position.offset - n.startOffset;
            }
        } return t.position; }
        function kk(t, e) { const n = t.root; const o = qf._createAt(n, e ? "end" : 0); if (e) {
            return new Wf(t, o);
        }
        else {
            return new Wf(o, t);
        } }
        function bk(t, e, n) { const o = e + (n ? 0 : -1); return hk.includes(t.charAt(o)); }
        function wk(t, e, n) { return e === (n ? t.endOffset : 0); }
        function _k(t, e) { return t.change((t => { const n = t.createDocumentFragment(); const o = e.getFirstRange(); if (!o || o.isCollapsed) {
            return n;
        } const i = o.start.root; const r = o.start.getCommonPath(o.end); const s = i.getNodeByPath(r); let a; if (o.start.parent == o.end.parent) {
            a = o;
        }
        else {
            a = t.createRange(t.createPositionAt(s, o.start.path[r.length]), t.createPositionAt(s, o.end.path[r.length] + 1));
        } const c = a.end.offset - a.start.offset; for (const e of a.getItems({ shallow: true })) {
            if (e.is("$textProxy")) {
                t.appendText(e.data, e.getAttributes(), n);
            }
            else {
                t.append(t.cloneElement(e, true), n);
            }
        } if (a != o) {
            const e = o._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0];
            const i = t.createRange(t.createPositionAt(n, 0), e.start);
            const r = t.createRange(e.end, t.createPositionAt(n, "end"));
            vk(r, t);
            vk(i, t);
        } return n; })); }
        function vk(t, e) { const n = []; Array.from(t.getItems({ direction: "backward" })).map((t => e.createRangeOn(t))).filter((e => { const n = (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end)); return n; })).forEach((t => { n.push(t.start.parent); e.remove(t); })); n.forEach((t => { let n = t; while (n.parent && n.isEmpty) {
            const t = e.createRangeOn(n);
            n = n.parent;
            e.remove(t);
        } })); }
        function Ak(t) { t.document.registerPostFixer((e => Ck(e, t))); }
        function Ck(t, e) { const n = e.document.selection; const o = e.schema; const i = []; let r = false; for (const t of n.getRanges()) {
            const e = yk(t, o);
            if (e && !e.isEqual(t)) {
                i.push(e);
                r = true;
            }
            else {
                i.push(t);
            }
        } if (r) {
            t.setSelection(Tk(i), { backward: n.isBackward });
        } }
        function yk(t, e) { if (t.isCollapsed) {
            return xk(t, e);
        } return Ek(t, e); }
        function xk(t, e) { const n = t.start; const o = e.getNearestSelectionRange(n); if (!o) {
            return null;
        } if (!o.isCollapsed) {
            return o;
        } const i = o.start; if (n.isEqual(i)) {
            return null;
        } return new Wf(i); }
        function Ek(t, e) { const { start: n, end: o } = t; const i = e.checkChild(n, "$text"); const r = e.checkChild(o, "$text"); const s = e.getLimitElement(n); const a = e.getLimitElement(o); if (s === a) {
            if (i && r) {
                return null;
            }
            if (Sk(n, o, e)) {
                const t = n.nodeAfter && e.isSelectable(n.nodeAfter);
                const i = t ? null : e.getNearestSelectionRange(n, "forward");
                const r = o.nodeBefore && e.isSelectable(o.nodeBefore);
                const s = r ? null : e.getNearestSelectionRange(o, "backward");
                const a = i ? i.start : n;
                const c = s ? s.end : o;
                return new Wf(a, c);
            }
        } const c = s && !s.is("rootElement"); const l = a && !a.is("rootElement"); if (c || l) {
            const t = n.nodeAfter && o.nodeBefore && n.nodeAfter.parent === o.nodeBefore.parent;
            const i = c && (!t || !Pk(n.nodeAfter, e));
            const r = l && (!t || !Pk(o.nodeBefore, e));
            let d = n;
            let u = o;
            if (i) {
                d = qf._createBefore(Dk(s, e));
            }
            if (r) {
                u = qf._createAfter(Dk(a, e));
            }
            return new Wf(d, u);
        } return null; }
        function Dk(t, e) { let n = t; let o = n; while (e.isLimit(o) && o.parent) {
            n = o;
            o = o.parent;
        } return n; }
        function Sk(t, e, n) { const o = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"); const i = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text"); return o || i; }
        function Tk(t) { const e = []; e.push(t.shift()); for (const n of t) {
            const t = e.pop();
            if (n.isEqual(t)) {
                e.push(t);
            }
            else if (n.isIntersecting(t)) {
                const o = t.start.isAfter(n.start) ? n.start : t.start;
                const i = t.end.isAfter(n.end) ? t.end : n.end;
                const r = new Wf(o, i);
                e.push(r);
            }
            else {
                e.push(t);
                e.push(n);
            }
        } return e; }
        function Pk(t, e) { return t && e.isSelectable(t); }
        class Bk {
            constructor() { this.markers = new qm; this.document = new Vm(this); this.schema = new yg; this._pendingChanges = []; this._currentWriter = null; ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach((t => this.decorate(t))); this.on("applyOperation", ((t, e) => { const n = e[0]; n._validate(); }), { priority: "highest" }); this.schema.register("$root", { isLimit: true }); this.schema.register("$block", { allowIn: "$root", isBlock: true }); this.schema.register("$text", { allowIn: "$block", isInline: true, isContent: true }); this.schema.register("$clipboardHolder", { allowContentOf: "$root", isLimit: true }); this.schema.extend("$text", { allowIn: "$clipboardHolder" }); this.schema.register("$documentFragment", { allowContentOf: "$root", isLimit: true }); this.schema.extend("$text", { allowIn: "$documentFragment" }); this.schema.register("$marker"); this.schema.addChildCheck(((t, e) => { if (e.name === "$marker") {
                return true;
            } })); Ak(this); this.document.registerPostFixer(Qp); }
            change(t) { try {
                if (this._pendingChanges.length === 0) {
                    this._pendingChanges.push({ batch: new Xg, callback: t });
                    return this._runPendingChanges()[0];
                }
                else {
                    return t(this._currentWriter);
                }
            }
            catch (t) {
                u["a"].rethrowUnexpectedError(t, this);
            } }
            enqueueChange(t, e) { try {
                if (typeof t === "string") {
                    t = new Xg(t);
                }
                else if (typeof t == "function") {
                    e = t;
                    t = new Xg;
                }
                this._pendingChanges.push({ batch: t, callback: e });
                if (this._pendingChanges.length == 1) {
                    this._runPendingChanges();
                }
            }
            catch (t) {
                u["a"].rethrowUnexpectedError(t, this);
            } }
            applyOperation(t) { t._execute(); }
            insertContent(t, e, n) { return Jm(this, t, e, n); }
            deleteContent(t, e) { Qm(this, t, e); }
            modifySelection(t, e) { fk(this, t, e); }
            getSelectedContent(t) { return _k(this, t); }
            hasContent(t, e = {}) { const n = t instanceof Nf ? Wf._createIn(t) : t; if (n.isCollapsed) {
                return false;
            } const { ignoreWhitespaces: o = false, ignoreMarkers: i = false } = e; if (!i) {
                for (const t of this.markers.getMarkersIntersectingRange(n)) {
                    if (t.affectsData) {
                        return true;
                    }
                }
            } for (const t of n.getItems()) {
                if (this.schema.isContent(t)) {
                    if (t.is("$textProxy")) {
                        if (!o) {
                            return true;
                        }
                        else if (t.data.search(/\S/) !== -1) {
                            return true;
                        }
                    }
                    else {
                        return true;
                    }
                }
            } return false; }
            createPositionFromPath(t, e, n) { return new qf(t, e, n); }
            createPositionAt(t, e) { return qf._createAt(t, e); }
            createPositionAfter(t) { return qf._createAfter(t); }
            createPositionBefore(t) { return qf._createBefore(t); }
            createRange(t, e) { return new Wf(t, e); }
            createRangeIn(t) { return Wf._createIn(t); }
            createRangeOn(t) { return Wf._createOn(t); }
            createSelection(t, e, n) { return new tp(t, e, n); }
            createBatch(t) { return new Xg(t); }
            createOperationFromJSON(t) { return Wm.fromJSON(t, this.document); }
            destroy() { this.document.destroy(); this.stopListening(); }
            _runPendingChanges() { const t = []; this.fire("_beforeChanges"); while (this._pendingChanges.length) {
                const e = this._pendingChanges[0].batch;
                this._currentWriter = new Am(this, e);
                const n = this._pendingChanges[0].callback(this._currentWriter);
                t.push(n);
                this.document._handleChangeBlock(this._currentWriter);
                this._pendingChanges.shift();
                this._currentWriter = null;
            } this.fire("_afterChanges"); return t; }
        }
        qn(Bk, Pn);
        class Ik extends bf {
            constructor(t) { super(); this.editor = t; }
            set(t, e, n = {}) { if (typeof e == "string") {
                const t = e;
                e = (e, n) => { this.editor.execute(t); n(); };
            } super.set(t, e, n); }
        }
        class Rk {
            constructor(t = {}) { this._context = t.context || new Pa({ language: t.language }); this._context._addEditor(this, !t.context); const e = Array.from(this.constructor.builtinPlugins || []); this.config = new pa(t, this.constructor.defaultConfig); this.config.define("plugins", e); this.config.define(this._context._getEditorConfig()); this.plugins = new wa(this, e, this._context.plugins); this.locale = this._context.locale; this.t = this.locale.t; this.commands = new vg; this.set("state", "initializing"); this.once("ready", (() => this.state = "ready"), { priority: "high" }); this.once("destroy", (() => this.state = "destroyed"), { priority: "high" }); this.set("isReadOnly", false); this.model = new Bk; const n = new al; this.data = new Gg(this.model, n); this.editing = new _g(this.model, n); this.editing.view.document.bind("isReadOnly").to(this); this.conversion = new Jg([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher); this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher); this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher); this.keystrokes = new Ik(this); this.keystrokes.listenTo(this.editing.view.document); }
            initPlugins() { const t = this.config; const e = t.get("plugins"); const n = t.get("removePlugins") || []; const o = t.get("extraPlugins") || []; const i = t.get("substitutePlugins") || []; return this.plugins.init(e.concat(o), n, i); }
            destroy() { let t = Promise.resolve(); if (this.state == "initializing") {
                t = new Promise((t => this.once("ready", t)));
            } return t.then((() => { this.fire("destroy"); this.stopListening(); this.commands.destroy(); })).then((() => this.plugins.destroy())).then((() => { this.model.destroy(); this.data.destroy(); this.editing.destroy(); this.keystrokes.destroy(); })).then((() => this._context._removeEditor(this))); }
            execute(...t) { try {
                return this.commands.execute(...t);
            }
            catch (t) {
                u["a"].rethrowUnexpectedError(t, this);
            } }
            focus() { this.editing.view.focus(); }
        }
        qn(Rk, Pn);
        class Fk {
            constructor(t) { this.editor = t; this._components = new Map; }
            *names() { for (const t of this._components.values()) {
                yield t.originalName;
            } }
            add(t, e) { this._components.set(Ok(t), { callback: e, originalName: t }); }
            create(t) { if (!this.has(t)) {
                throw new u["a"]("componentfactory-item-missing", this, { name: t });
            } return this._components.get(Ok(t)).callback(this.editor.locale); }
            has(t) { return this._components.has(Ok(t)); }
        }
        function Ok(t) { return String(t).toLowerCase(); }
        class zk {
            constructor(t) { this.editor = t; this.componentFactory = new Fk(t); this.focusTracker = new kf; this._editableElementsMap = new Map; this.listenTo(t.editing.view.document, "layoutChanged", (() => this.update())); }
            get element() { return null; }
            update() { this.fire("update"); }
            destroy() { this.stopListening(); this.focusTracker.destroy(); for (const t of this._editableElementsMap.values()) {
                t.ckeditorInstance = null;
            } this._editableElementsMap = new Map; }
            setEditableElement(t, e) { this._editableElementsMap.set(t, e); if (!e.ckeditorInstance) {
                e.ckeditorInstance = this.editor;
            } }
            getEditableElement(t = "main") { return this._editableElementsMap.get(t); }
            getEditableElementsNames() { return this._editableElementsMap.keys(); }
            get _editableElements() { console.warn("editor-ui-deprecated-editable-elements: " + "The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", { editorUI: this }); return this._editableElementsMap; }
        }
        qn(zk, g);
        function Nk(t) { if (!X(t.updateSourceElement)) {
            throw new u["a"]("attachtoform-missing-elementapi-interface", t);
        } const e = t.sourceElement; if (e && e.tagName.toLowerCase() === "textarea" && e.form) {
            let n;
            const o = e.form;
            const i = () => t.updateSourceElement();
            if (X(o.submit)) {
                n = o.submit;
                o.submit = () => { i(); n.apply(o); };
            }
            o.addEventListener("submit", i);
            t.on("destroy", (() => { o.removeEventListener("submit", i); if (n) {
                o.submit = n;
            } }));
        } }
        const Mk = { setData(t) { this.data.set(t); }, getData(t) { return this.data.get(t); } };
        var Vk = Mk;
        const Lk = { updateSourceElement() { if (!this.sourceElement) {
                throw new u["a"]("editor-missing-sourceelement", this);
            } pf(this.sourceElement, this.data.get()); } };
        var qk = Lk;
        function Kk(t) { const e = t.sourceElement; if (!e) {
            return;
        } if (e.ckeditorInstance) {
            throw new u["a"]("editor-source-element-already-used", t);
        } e.ckeditorInstance = t; t.once("destroy", (() => { delete e.ckeditorInstance; })); }
        class jk extends Ba {
            static get pluginName() { return "PendingActions"; }
            init() { this.set("hasAny", false); this._actions = new ba({ idProperty: "_id" }); this._actions.delegate("add", "remove").to(this); }
            add(t) { if (typeof t !== "string") {
                throw new u["a"]("pendingactions-add-invalid-message", this);
            } const e = Object.create(Pn); e.set("message", t); this._actions.add(e); this.hasAny = true; return e; }
            remove(t) { this._actions.remove(t); this.hasAny = !!this._actions.length; }
            get first() { return this._actions.get(0); }
            [Symbol.iterator]() { return this._actions[Symbol.iterator](); }
        }
        var Hk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
        var Wk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>';
        var $k = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>';
        var Gk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>';
        var Uk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';
        var Jk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';
        var Yk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>';
        var Qk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>';
        var Xk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>';
        var Zk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
        var tb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>';
        var eb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>';
        var nb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
        var ob = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>';
        var ib = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>';
        var rb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
        var sb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>';
        var ab = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>';
        var cb = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>';
        var lb = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>';
        var db = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>';
        var ub = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>';
        var hb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>';
        var fb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
        var pb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>';
        const gb = { cancel: Hk, caption: Wk, check: $k, eraser: Gk, lowVision: Uk, image: Jk, alignBottom: Yk, alignMiddle: Qk, alignTop: Xk, alignLeft: Zk, alignCenter: tb, alignRight: eb, alignJustify: nb, objectLeft: ob, objectCenter: ib, objectRight: rb, objectFullWidth: sb, objectSizeFull: ab, objectSizeLarge: cb, objectSizeSmall: lb, objectSizeMedium: db, pencil: ub, pilcrow: hb, quote: fb, threeVerticalDots: pb };
        function mb({ emitter: t, activator: e, callback: n, contextElements: o }) { t.listenTo(document, "mousedown", ((t, i) => { if (!e()) {
            return;
        } const r = typeof i.composedPath == "function" ? i.composedPath() : []; for (const t of o) {
            if (t.contains(i.target) || r.includes(t)) {
                return;
            }
        } n(); })); }
        function kb(t) { t.set("_isCssTransitionsDisabled", false); t.disableCssTransitions = () => { t._isCssTransitionsDisabled = true; }; t.enableCssTransitions = () => { t._isCssTransitionsDisabled = false; }; t.extendTemplate({ attributes: { class: [t.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")] } }); }
        function bb({ view: t }) { t.listenTo(t.element, "submit", ((e, n) => { n.preventDefault(); t.fire("submit"); }), { useCapture: true }); }
        class wb extends ba {
            constructor(t = []) { super(t, { idProperty: "viewUid" }); this.on("add", ((t, e, n) => { this._renderViewIntoCollectionParent(e, n); })); this.on("remove", ((t, e) => { if (e.element && this._parentElement) {
                e.element.remove();
            } })); this._parentElement = null; }
            destroy() { this.map((t => t.destroy())); }
            setParent(t) { this._parentElement = t; for (const t of this) {
                this._renderViewIntoCollectionParent(t);
            } }
            delegate(...t) { if (!t.length || !_b(t)) {
                throw new u["a"]("ui-viewcollection-delegate-wrong-events", this);
            } return { to: e => { for (const n of this) {
                    for (const o of t) {
                        n.delegate(o).to(e);
                    }
                } this.on("add", ((n, o) => { for (const n of t) {
                    o.delegate(n).to(e);
                } })); this.on("remove", ((n, o) => { for (const n of t) {
                    o.stopDelegating(n, e);
                } })); } }; }
            _renderViewIntoCollectionParent(t, e) { if (!t.isRendered) {
                t.render();
            } if (t.element && this._parentElement) {
                this._parentElement.insertBefore(t.element, this._parentElement.children[e]);
            } }
        }
        function _b(t) { return t.every((t => typeof t == "string")); }
        var vb = n(1);
        var Ab = n.n(vb);
        var Cb = n(12);
        var yb = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        yb.insert = "head";
        yb.singleton = true;
        var xb = Ab()(Cb["a"], yb);
        var Eb = Cb["a"].locals || {};
        class Db {
            constructor(t) { this.element = null; this.isRendered = false; this.locale = t; this.t = t && t.t; this._viewCollections = new ba; this._unboundChildren = this.createCollection(); this._viewCollections.on("add", ((e, n) => { n.locale = t; })); this.decorate("render"); }
            get bindTemplate() { if (this._bindTemplate) {
                return this._bindTemplate;
            } return this._bindTemplate = Tb.bind(this, this); }
            createCollection(t) { const e = new wb(t); this._viewCollections.add(e); return e; }
            registerChild(t) { if (!ka(t)) {
                t = [t];
            } for (const e of t) {
                this._unboundChildren.add(e);
            } }
            deregisterChild(t) { if (!ka(t)) {
                t = [t];
            } for (const e of t) {
                this._unboundChildren.remove(e);
            } }
            setTemplate(t) { this.template = new Tb(t); }
            extendTemplate(t) { Tb.extend(this.template, t); }
            render() { if (this.isRendered) {
                throw new u["a"]("ui-view-render-already-rendered", this);
            } if (this.template) {
                this.element = this.template.render();
                this.registerChild(this.template.getViews());
            } this.isRendered = true; }
            destroy() { this.stopListening(); this._viewCollections.map((t => t.destroy())); if (this.template && this.template._revertData) {
                this.template.revert(this.element);
            } }
        }
        qn(Db, _u);
        qn(Db, Pn);
        const Sb = "http://www.w3.org/1999/xhtml";
        class Tb {
            constructor(t) { Object.assign(this, Lb(Vb(t))); this._isRendered = false; this._revertData = null; }
            render() { const t = this._renderNode({ intoFragment: true }); this._isRendered = true; return t; }
            apply(t) { this._revertData = Zb(); this._renderNode({ node: t, isApplying: true, revertData: this._revertData }); return t; }
            revert(t) { if (!this._revertData) {
                throw new u["a"]("ui-template-revert-not-applied", [this, t]);
            } this._revertTemplateFromNode(t, this._revertData); }
            *getViews() { function* t(e) { if (e.children) {
                for (const n of e.children) {
                    if (Yb(n)) {
                        yield n;
                    }
                    else if (Qb(n)) {
                        yield* t(n);
                    }
                }
            } } yield* t(this); }
            static bind(t, e) { return { to(n, o) { return new Bb({ eventNameOrFunction: n, attribute: n, observable: t, emitter: e, callback: o }); }, if(n, o, i) { return new Ib({ observable: t, emitter: e, attribute: n, valueIfTrue: o, callback: i }); } }; }
            static extend(t, e) { if (t._isRendered) {
                throw new u["a"]("template-extend-render", [this, t]);
            } Ub(t, Lb(Vb(e))); }
            _renderNode(t) { let e; if (t.node) {
                e = this.tag && this.text;
            }
            else {
                e = this.tag ? this.text : !this.text;
            } if (e) {
                throw new u["a"]("ui-template-wrong-syntax", this);
            } if (this.text) {
                return this._renderText(t);
            }
            else {
                return this._renderElement(t);
            } }
            _renderElement(t) { let e = t.node; if (!e) {
                e = t.node = document.createElementNS(this.ns || Sb, this.tag);
            } this._renderAttributes(t); this._renderElementChildren(t); this._setUpListeners(t); return e; }
            _renderText(t) { let e = t.node; if (e) {
                t.revertData.text = e.textContent;
            }
            else {
                e = t.node = document.createTextNode("");
            } if (Rb(this.text)) {
                this._bindToObservable({ schema: this.text, updater: zb(e), data: t });
            }
            else {
                e.textContent = this.text.join("");
            } return e; }
            _renderAttributes(t) { let e, n, o, i; if (!this.attributes) {
                return;
            } const r = t.node; const s = t.revertData; for (e in this.attributes) {
                o = r.getAttribute(e);
                n = this.attributes[e];
                if (s) {
                    s.attributes[e] = o;
                }
                i = S(n[0]) && n[0].ns ? n[0].ns : null;
                if (Rb(n)) {
                    const a = i ? n[0].value : n;
                    if (s && tw(e)) {
                        a.unshift(o);
                    }
                    this._bindToObservable({ schema: a, updater: Nb(r, e, i), data: t });
                }
                else if (e == "style" && typeof n[0] !== "string") {
                    this._renderStyleAttribute(n[0], t);
                }
                else {
                    if (s && o && tw(e)) {
                        n.unshift(o);
                    }
                    n = n.map((t => t ? t.value || t : t)).reduce(((t, e) => t.concat(e)), []).reduce($b, "");
                    if (!Jb(n)) {
                        r.setAttributeNS(i, e, n);
                    }
                }
            } }
            _renderStyleAttribute(t, e) { const n = e.node; for (const o in t) {
                const i = t[o];
                if (Rb(i)) {
                    this._bindToObservable({ schema: [i], updater: Mb(n, o), data: e });
                }
                else {
                    n.style[o] = i;
                }
            } }
            _renderElementChildren(t) { const e = t.node; const n = t.intoFragment ? document.createDocumentFragment() : e; const o = t.isApplying; let i = 0; for (const r of this.children) {
                if (Xb(r)) {
                    if (!o) {
                        r.setParent(e);
                        for (const t of r) {
                            n.appendChild(t.element);
                        }
                    }
                }
                else if (Yb(r)) {
                    if (!o) {
                        if (!r.isRendered) {
                            r.render();
                        }
                        n.appendChild(r.element);
                    }
                }
                else if (Qd(r)) {
                    n.appendChild(r);
                }
                else {
                    if (o) {
                        const e = t.revertData;
                        const o = Zb();
                        e.children.push(o);
                        r._renderNode({ node: n.childNodes[i++], isApplying: true, revertData: o });
                    }
                    else {
                        n.appendChild(r.render());
                    }
                }
            } if (t.intoFragment) {
                e.appendChild(n);
            } }
            _setUpListeners(t) { if (!this.eventListeners) {
                return;
            } for (const e in this.eventListeners) {
                const n = this.eventListeners[e].map((n => { const [o, i] = e.split("@"); return n.activateDomEventListener(o, i, t); }));
                if (t.revertData) {
                    t.revertData.bindings.push(n);
                }
            } }
            _bindToObservable({ schema: t, updater: e, data: n }) { const o = n.revertData; Ob(t, e, n); const i = t.filter((t => !Jb(t))).filter((t => t.observable)).map((o => o.activateAttributeListener(t, e, n))); if (o) {
                o.bindings.push(i);
            } }
            _revertTemplateFromNode(t, e) { for (const t of e.bindings) {
                for (const e of t) {
                    e();
                }
            } if (e.text) {
                t.textContent = e.text;
                return;
            } for (const n in e.attributes) {
                const o = e.attributes[n];
                if (o === null) {
                    t.removeAttribute(n);
                }
                else {
                    t.setAttribute(n, o);
                }
            } for (let n = 0; n < e.children.length; ++n) {
                this._revertTemplateFromNode(t.childNodes[n], e.children[n]);
            } }
        }
        qn(Tb, g);
        class Pb {
            constructor(t) { Object.assign(this, t); }
            getValue(t) { const e = this.observable[this.attribute]; return this.callback ? this.callback(e, t) : e; }
            activateAttributeListener(t, e, n) { const o = () => Ob(t, e, n); this.emitter.listenTo(this.observable, "change:" + this.attribute, o); return () => { this.emitter.stopListening(this.observable, "change:" + this.attribute, o); }; }
        }
        class Bb extends Pb {
            activateDomEventListener(t, e, n) { const o = (t, n) => { if (!e || n.target.matches(e)) {
                if (typeof this.eventNameOrFunction == "function") {
                    this.eventNameOrFunction(n);
                }
                else {
                    this.observable.fire(this.eventNameOrFunction, n);
                }
            } }; this.emitter.listenTo(n.node, t, o); return () => { this.emitter.stopListening(n.node, t, o); }; }
        }
        class Ib extends Pb {
            getValue(t) { const e = super.getValue(t); return Jb(e) ? false : this.valueIfTrue || true; }
        }
        function Rb(t) { if (!t) {
            return false;
        } if (t.value) {
            t = t.value;
        } if (Array.isArray(t)) {
            return t.some(Rb);
        }
        else if (t instanceof Pb) {
            return true;
        } return false; }
        function Fb(t, e) { return t.map((t => { if (t instanceof Pb) {
            return t.getValue(e);
        } return t; })); }
        function Ob(t, e, { node: n }) { let o = Fb(t, n); if (t.length == 1 && t[0] instanceof Ib) {
            o = o[0];
        }
        else {
            o = o.reduce($b, "");
        } if (Jb(o)) {
            e.remove();
        }
        else {
            e.set(o);
        } }
        function zb(t) { return { set(e) { t.textContent = e; }, remove() { t.textContent = ""; } }; }
        function Nb(t, e, n) { return { set(o) { t.setAttributeNS(n, e, o); }, remove() { t.removeAttributeNS(n, e); } }; }
        function Mb(t, e) { return { set(n) { t.style[e] = n; }, remove() { t.style[e] = null; } }; }
        function Vb(t) { const e = ua(t, (t => { if (t && (t instanceof Pb || Qb(t) || Yb(t) || Xb(t))) {
            return t;
        } })); return e; }
        function Lb(t) { if (typeof t == "string") {
            t = jb(t);
        }
        else if (t.text) {
            Hb(t);
        } if (t.on) {
            t.eventListeners = Kb(t.on);
            delete t.on;
        } if (!t.text) {
            if (t.attributes) {
                qb(t.attributes);
            }
            const e = [];
            if (t.children) {
                if (Xb(t.children)) {
                    e.push(t.children);
                }
                else {
                    for (const n of t.children) {
                        if (Qb(n) || Yb(n) || Qd(n)) {
                            e.push(n);
                        }
                        else {
                            e.push(new Tb(n));
                        }
                    }
                }
            }
            t.children = e;
        } return t; }
        function qb(t) { for (const e in t) {
            if (t[e].value) {
                t[e].value = _a(t[e].value);
            }
            Wb(t, e);
        } }
        function Kb(t) { for (const e in t) {
            Wb(t, e);
        } return t; }
        function jb(t) { return { text: [t] }; }
        function Hb(t) { t.text = _a(t.text); }
        function Wb(t, e) { t[e] = _a(t[e]); }
        function $b(t, e) { if (Jb(e)) {
            return t;
        }
        else if (Jb(t)) {
            return e;
        }
        else {
            return `${t} ${e}`;
        } }
        function Gb(t, e) { for (const n in e) {
            if (t[n]) {
                t[n].push(...e[n]);
            }
            else {
                t[n] = e[n];
            }
        } }
        function Ub(t, e) { if (e.attributes) {
            if (!t.attributes) {
                t.attributes = {};
            }
            Gb(t.attributes, e.attributes);
        } if (e.eventListeners) {
            if (!t.eventListeners) {
                t.eventListeners = {};
            }
            Gb(t.eventListeners, e.eventListeners);
        } if (e.text) {
            t.text.push(...e.text);
        } if (e.children && e.children.length) {
            if (t.children.length != e.children.length) {
                throw new u["a"]("ui-template-extend-children-mismatch", t);
            }
            let n = 0;
            for (const o of e.children) {
                Ub(t.children[n++], o);
            }
        } }
        function Jb(t) { return !t && t !== 0; }
        function Yb(t) { return t instanceof Db; }
        function Qb(t) { return t instanceof Tb; }
        function Xb(t) { return t instanceof wb; }
        function Zb() { return { children: [], bindings: [], attributes: {} }; }
        function tw(t) { return t == "class" || t == "style"; }
        class ew extends wb {
            constructor(t, e = []) { super(e); this.locale = t; }
            attachToDom() { this._bodyCollectionContainer = new Tb({ tag: "div", attributes: { class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"], dir: this.locale.uiLanguageDirection }, children: this }).render(); let t = document.querySelector(".ck-body-wrapper"); if (!t) {
                t = nf(document, "div", { class: "ck-body-wrapper" });
                document.body.appendChild(t);
            } t.appendChild(this._bodyCollectionContainer); }
            detachFromDom() { super.destroy(); if (this._bodyCollectionContainer) {
                this._bodyCollectionContainer.remove();
            } const t = document.querySelector(".ck-body-wrapper"); if (t && t.childElementCount == 0) {
                t.remove();
            } }
        }
        var nw = n(13);
        var ow = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        ow.insert = "head";
        ow.singleton = true;
        var iw = Ab()(nw["a"], ow);
        var rw = nw["a"].locals || {};
        class sw extends Db {
            constructor() { super(); const t = this.bindTemplate; this.set("content", ""); this.set("viewBox", "0 0 20 20"); this.set("fillColor", ""); this.setTemplate({ tag: "svg", ns: "http://www.w3.org/2000/svg", attributes: { class: ["ck", "ck-icon"], viewBox: t.to("viewBox") } }); }
            render() { super.render(); this._updateXMLContent(); this._colorFillPaths(); this.on("change:content", (() => { this._updateXMLContent(); this._colorFillPaths(); })); this.on("change:fillColor", (() => { this._colorFillPaths(); })); }
            _updateXMLContent() { if (this.content) {
                const t = (new DOMParser).parseFromString(this.content.trim(), "image/svg+xml");
                const e = t.querySelector("svg");
                const n = e.getAttribute("viewBox");
                if (n) {
                    this.viewBox = n;
                }
                this.element.innerHTML = "";
                while (e.childNodes.length > 0) {
                    this.element.appendChild(e.childNodes[0]);
                }
            } }
            _colorFillPaths() { if (this.fillColor) {
                this.element.querySelectorAll(".ck-icon__fill").forEach((t => { t.style.fill = this.fillColor; }));
            } }
        }
        var aw = n(14);
        var cw = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        cw.insert = "head";
        cw.singleton = true;
        var lw = Ab()(aw["a"], cw);
        var dw = aw["a"].locals || {};
        class uw extends Db {
            constructor(t) { super(t); this.set("text", ""); this.set("position", "s"); const e = this.bindTemplate; this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-tooltip", e.to("position", (t => "ck-tooltip_" + t)), e.if("text", "ck-hidden", (t => !t.trim()))] }, children: [{ tag: "span", attributes: { class: ["ck", "ck-tooltip__text"] }, children: [{ text: e.to("text") }] }] }); }
        }
        var hw = n(15);
        var fw = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        fw.insert = "head";
        fw.singleton = true;
        var pw = Ab()(hw["a"], fw);
        var gw = hw["a"].locals || {};
        class mw extends Db {
            constructor(t) { super(t); const e = this.bindTemplate; const n = a(); this.set("class"); this.set("labelStyle"); this.set("icon"); this.set("isEnabled", true); this.set("isOn", false); this.set("isVisible", true); this.set("isToggleable", false); this.set("keystroke"); this.set("label"); this.set("tabindex", -1); this.set("tooltip"); this.set("tooltipPosition", "s"); this.set("type", "button"); this.set("withText", false); this.set("withKeystroke", false); this.children = this.createCollection(); this.tooltipView = this._createTooltipView(); this.labelView = this._createLabelView(n); this.iconView = new sw; this.iconView.extendTemplate({ attributes: { class: "ck-button__icon" } }); this.keystrokeView = this._createKeystrokeView(); this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this)); this.setTemplate({ tag: "button", attributes: { class: ["ck", "ck-button", e.to("class"), e.if("isEnabled", "ck-disabled", (t => !t)), e.if("isVisible", "ck-hidden", (t => !t)), e.to("isOn", (t => t ? "ck-on" : "ck-off")), e.if("withText", "ck-button_with-text"), e.if("withKeystroke", "ck-button_with-keystroke")], type: e.to("type", (t => t ? t : "button")), tabindex: e.to("tabindex"), "aria-labelledby": `ck-editor__aria-label_${n}`, "aria-disabled": e.if("isEnabled", true, (t => !t)), "aria-pressed": e.to("isOn", (t => this.isToggleable ? String(t) : false)) }, children: this.children, on: { mousedown: e.to((t => { t.preventDefault(); })), click: e.to((t => { if (this.isEnabled) {
                        this.fire("execute");
                    }
                    else {
                        t.preventDefault();
                    } })) } }); }
            render() { super.render(); if (this.icon) {
                this.iconView.bind("content").to(this, "icon");
                this.children.add(this.iconView);
            } this.children.add(this.tooltipView); this.children.add(this.labelView); if (this.withKeystroke) {
                this.children.add(this.keystrokeView);
            } }
            focus() { this.element.focus(); }
            _createTooltipView() { const t = new uw; t.bind("text").to(this, "_tooltipString"); t.bind("position").to(this, "tooltipPosition"); return t; }
            _createLabelView(t) { const e = new Db; const n = this.bindTemplate; e.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__label"], style: n.to("labelStyle"), id: `ck-editor__aria-label_${t}` }, children: [{ text: this.bindTemplate.to("label") }] }); return e; }
            _createKeystrokeView() { const t = new Db; t.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__keystroke"] }, children: [{ text: this.bindTemplate.to("keystroke", (t => id(t))) }] }); return t; }
            _getTooltipString(t, e, n) { if (t) {
                if (typeof t == "string") {
                    return t;
                }
                else {
                    if (n) {
                        n = id(n);
                    }
                    if (t instanceof Function) {
                        return t(e, n);
                    }
                    else {
                        return `${e}${n ? ` (${n})` : ""}`;
                    }
                }
            } return ""; }
        }
        var kw = n(16);
        var bw = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        bw.insert = "head";
        bw.singleton = true;
        var ww = Ab()(kw["a"], bw);
        var _w = kw["a"].locals || {};
        class vw extends mw {
            constructor(t) { super(t); this.isToggleable = true; this.toggleSwitchView = this._createToggleView(); this.extendTemplate({ attributes: { class: "ck-switchbutton" } }); }
            render() { super.render(); this.children.add(this.toggleSwitchView); }
            _createToggleView() { const t = new Db; t.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__toggle"] }, children: [{ tag: "span", attributes: { class: ["ck", "ck-button__toggle__inner"] } }] }); return t; }
        }
        function Aw(t, e) { const n = t.t; const o = { Black: n("Black"), "Dim grey": n("Dim grey"), Grey: n("Grey"), "Light grey": n("Light grey"), White: n("White"), Red: n("Red"), Orange: n("Orange"), Yellow: n("Yellow"), "Light green": n("Light green"), Green: n("Green"), Aquamarine: n("Aquamarine"), Turquoise: n("Turquoise"), "Light blue": n("Light blue"), Blue: n("Blue"), Purple: n("Purple") }; return e.map((t => { const e = o[t.label]; if (e && e != t.label) {
            t.label = e;
        } return t; })); }
        function Cw(t) { return t.map(yw).filter((t => !!t)); }
        function yw(t) { if (typeof t === "string") {
            return { model: t, label: t, hasBorder: false, view: { name: "span", styles: { color: t } } };
        }
        else {
            return { model: t.color, label: t.label || t.color, hasBorder: t.hasBorder === undefined ? false : t.hasBorder, view: { name: "span", styles: { color: `${t.color}` } } };
        } }
        var xw = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>';
        class Ew extends mw {
            constructor(t) { super(t); const e = this.bindTemplate; this.set("color"); this.set("hasBorder"); this.icon = xw; this.extendTemplate({ attributes: { style: { backgroundColor: e.to("color") }, class: ["ck", "ck-color-grid__tile", e.if("hasBorder", "ck-color-table__color-tile_bordered")] } }); }
            render() { super.render(); this.iconView.fillColor = "hsl(0, 0%, 100%)"; }
        }
        class Dw {
            constructor(t) { Object.assign(this, t); if (t.actions && t.keystrokeHandler) {
                for (const e in t.actions) {
                    let n = t.actions[e];
                    if (typeof n == "string") {
                        n = [n];
                    }
                    for (const o of n) {
                        t.keystrokeHandler.set(o, ((t, n) => { this[e](); n(); }));
                    }
                }
            } }
            get first() { return this.focusables.find(Sw) || null; }
            get last() { return this.focusables.filter(Sw).slice(-1)[0] || null; }
            get next() { return this._getFocusableItem(1); }
            get previous() { return this._getFocusableItem(-1); }
            get current() { let t = null; if (this.focusTracker.focusedElement === null) {
                return null;
            } this.focusables.find(((e, n) => { const o = e.element === this.focusTracker.focusedElement; if (o) {
                t = n;
            } return o; })); return t; }
            focusFirst() { this._focus(this.first); }
            focusLast() { this._focus(this.last); }
            focusNext() { this._focus(this.next); }
            focusPrevious() { this._focus(this.previous); }
            _focus(t) { if (t) {
                t.focus();
            } }
            _getFocusableItem(t) { const e = this.current; const n = this.focusables.length; if (!n) {
                return null;
            } if (e === null) {
                return this[t === 1 ? "first" : "last"];
            } let o = (e + n + t) % n; do {
                const e = this.focusables.get(o);
                if (Sw(e)) {
                    return e;
                }
                o = (o + n + t) % n;
            } while (o !== e); return null; }
        }
        function Sw(t) { return !!(t.focus && su.window.getComputedStyle(t.element).display != "none"); }
        var Tw = n(17);
        var Pw = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        Pw.insert = "head";
        Pw.singleton = true;
        var Bw = Ab()(Tw["a"], Pw);
        var Iw = Tw["a"].locals || {};
        class Rw extends Db {
            constructor(t, e) { super(t); const n = e && e.colorDefinitions || []; const o = {}; if (e && e.columns) {
                o.gridTemplateColumns = `repeat( ${e.columns}, 1fr)`;
            } this.set("selectedColor"); this.items = this.createCollection(); this.focusTracker = new kf; this.keystrokes = new bf; this._focusCycler = new Dw({ focusables: this.items, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "arrowleft", focusNext: "arrowright" } }); this.items.on("add", ((t, e) => { e.isOn = e.color === this.selectedColor; })); n.forEach((t => { const e = new Ew; e.set({ color: t.color, label: t.label, tooltip: true, hasBorder: t.options.hasBorder }); e.on("execute", (() => { this.fire("execute", { value: t.color, hasBorder: t.options.hasBorder, label: t.label }); })); this.items.add(e); })); this.setTemplate({ tag: "div", children: this.items, attributes: { class: ["ck", "ck-color-grid"], style: o } }); this.on("change:selectedColor", ((t, e, n) => { for (const t of this.items) {
                t.isOn = t.color === n;
            } })); }
            focus() { if (this.items.length) {
                this.items.first.focus();
            } }
            focusLast() { if (this.items.length) {
                this.items.last.focus();
            } }
            render() { super.render(); for (const t of this.items) {
                this.focusTracker.add(t.element);
            } this.items.on("add", ((t, e) => { this.focusTracker.add(e.element); })); this.items.on("remove", ((t, e) => { this.focusTracker.remove(e.element); })); this.keystrokes.listenTo(this.element); }
        }
        var Fw = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
        class Ow extends mw {
            constructor(t) { super(t); this.arrowView = this._createArrowView(); this.extendTemplate({ attributes: { "aria-haspopup": true } }); this.delegate("execute").to(this, "open"); }
            render() { super.render(); this.children.add(this.arrowView); }
            _createArrowView() { const t = new sw; t.content = Fw; t.extendTemplate({ attributes: { class: "ck-dropdown__arrow" } }); return t; }
        }
        var zw = n(18);
        var Nw = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        Nw.insert = "head";
        Nw.singleton = true;
        var Mw = Ab()(zw["a"], Nw);
        var Vw = zw["a"].locals || {};
        class Lw extends Db {
            constructor(t) { super(t); const e = this.bindTemplate; this.set("icon"); this.set("isEnabled", true); this.set("isOn", false); this.set("isToggleable", false); this.set("isVisible", true); this.set("keystroke"); this.set("label"); this.set("tabindex", -1); this.set("tooltip"); this.set("tooltipPosition", "s"); this.set("type", "button"); this.set("withText", false); this.children = this.createCollection(); this.actionView = this._createActionView(); this.arrowView = this._createArrowView(); this.keystrokes = new bf; this.focusTracker = new kf; this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-splitbutton", e.if("isVisible", "ck-hidden", (t => !t)), this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")] }, children: this.children }); }
            render() { super.render(); this.children.add(this.actionView); this.children.add(this.arrowView); this.focusTracker.add(this.actionView.element); this.focusTracker.add(this.arrowView.element); this.keystrokes.listenTo(this.element); this.keystrokes.set("arrowright", ((t, e) => { if (this.focusTracker.focusedElement === this.actionView.element) {
                this.arrowView.focus();
                e();
            } })); this.keystrokes.set("arrowleft", ((t, e) => { if (this.focusTracker.focusedElement === this.arrowView.element) {
                this.actionView.focus();
                e();
            } })); }
            focus() { this.actionView.focus(); }
            _createActionView() { const t = new mw; t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this); t.extendTemplate({ attributes: { class: "ck-splitbutton__action" } }); t.delegate("execute").to(this); return t; }
            _createArrowView() { const t = new mw; const e = t.bindTemplate; t.icon = Fw; t.extendTemplate({ attributes: { class: "ck-splitbutton__arrow", "aria-haspopup": true, "aria-expanded": e.to("isOn", (t => String(t))) } }); t.bind("isEnabled").to(this); t.delegate("execute").to(this, "open"); return t; }
        }
        class qw extends Db {
            constructor(t) { super(t); const e = this.bindTemplate; this.set("isVisible", false); this.set("position", "se"); this.children = this.createCollection(); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", (t => `ck-dropdown__panel_${t}`)), e.if("isVisible", "ck-dropdown__panel-visible")] }, children: this.children, on: { selectstart: e.to((t => t.preventDefault())) } }); }
            focus() { if (this.children.length) {
                this.children.first.focus();
            } }
            focusLast() { if (this.children.length) {
                const t = this.children.last;
                if (typeof t.focusLast === "function") {
                    t.focusLast();
                }
                else {
                    t.focus();
                }
            } }
        }
        var Kw = n(19);
        var jw = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        jw.insert = "head";
        jw.singleton = true;
        var Hw = Ab()(Kw["a"], jw);
        var Ww = Kw["a"].locals || {};
        function $w(t) { if (!t || !t.parentNode) {
            return null;
        } if (t.offsetParent === su.document.body) {
            return null;
        } return t.offsetParent; }
        function Gw({ element: t, target: e, positions: n, limiter: o, fitInViewport: i }) { if (X(e)) {
            e = e();
        } if (X(o)) {
            o = o();
        } const r = $w(t); const s = new cf(t); const a = new cf(e); let c; let l; if (!o && !i) {
            [l, c] = Uw(n[0], a, s);
        }
        else {
            const t = o && new cf(o).getVisible();
            const e = i && new cf(su.window);
            const r = Jw(n, { targetRect: a, elementRect: s, limiterRect: t, viewportRect: e });
            [l, c] = r || Uw(n[0], a, s);
        } let d = Zw(c); if (r) {
            d = Xw(d, r);
        } return { left: d.left, top: d.top, name: l }; }
        function Uw(t, e, n) { const o = t(e, n); if (!o) {
            return null;
        } const { left: i, top: r, name: s } = o; return [s, n.clone().moveTo(i, r)]; }
        function Jw(t, e) { const { elementRect: n, viewportRect: o } = e; const i = n.getArea(); const r = Yw(t, e); if (o) {
            const t = r.filter((({ viewportIntersectArea: t }) => t === i));
            const e = Qw(t, i);
            if (e) {
                return e;
            }
        } return Qw(r, i); }
        function Yw(t, { targetRect: e, elementRect: n, limiterRect: o, viewportRect: i }) { const r = []; const s = n.getArea(); for (const a of t) {
            const t = Uw(a, e, n);
            if (!t) {
                continue;
            }
            const [c, l] = t;
            let d = 0;
            let u = 0;
            if (o) {
                if (i) {
                    const t = o.getIntersection(i);
                    if (t) {
                        d = t.getIntersectionArea(l);
                    }
                }
                else {
                    d = o.getIntersectionArea(l);
                }
            }
            if (i) {
                u = i.getIntersectionArea(l);
            }
            const h = { positionName: c, positionRect: l, limiterIntersectArea: d, viewportIntersectArea: u };
            if (d === s) {
                return [h];
            }
            r.push(h);
        } return r; }
        function Qw(t, e) { let n = 0; let o; let i; for (const { positionName: r, positionRect: s, limiterIntersectArea: a, viewportIntersectArea: c } of t) {
            if (a === e) {
                return [r, s];
            }
            const t = Math.pow(c, 2) + Math.pow(a, 2);
            if (t > n) {
                n = t;
                o = s;
                i = r;
            }
        } return o ? [i, o] : null; }
        function Xw({ left: t, top: e }, n) { const o = Zw(new cf(n)); const i = sf(n); t -= o.left; e -= o.top; t += n.scrollLeft; e += n.scrollTop; t -= i.left; e -= i.top; return { left: t, top: e }; }
        function Zw({ left: t, top: e }) { const { scrollX: n, scrollY: o } = su.window; return { left: t + n, top: e + o }; }
        class t_ extends Db {
            constructor(t, e, n) { super(t); const o = this.bindTemplate; this.buttonView = e; this.panelView = n; this.set("isOpen", false); this.set("isEnabled", true); this.set("class"); this.set("id"); this.set("panelPosition", "auto"); this.keystrokes = new bf; this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-dropdown", o.to("class"), o.if("isEnabled", "ck-disabled", (t => !t))], id: o.to("id"), "aria-describedby": o.to("ariaDescribedById") }, children: [e, n] }); e.extendTemplate({ attributes: { class: ["ck-dropdown__button"] } }); }
            render() { super.render(); this.listenTo(this.buttonView, "open", (() => { this.isOpen = !this.isOpen; })); this.panelView.bind("isVisible").to(this, "isOpen"); this.on("change:isOpen", (() => { if (!this.isOpen) {
                return;
            } if (this.panelPosition === "auto") {
                this.panelView.position = t_._getOptimalPosition({ element: this.panelView.element, target: this.buttonView.element, fitInViewport: true, positions: this._panelPositions }).name;
            }
            else {
                this.panelView.position = this.panelPosition;
            } })); this.keystrokes.listenTo(this.element); const t = (t, e) => { if (this.isOpen) {
                this.buttonView.focus();
                this.isOpen = false;
                e();
            } }; this.keystrokes.set("arrowdown", ((t, e) => { if (this.buttonView.isEnabled && !this.isOpen) {
                this.isOpen = true;
                e();
            } })); this.keystrokes.set("arrowright", ((t, e) => { if (this.isOpen) {
                e();
            } })); this.keystrokes.set("arrowleft", t); this.keystrokes.set("esc", t); }
            focus() { this.buttonView.focus(); }
            get _panelPositions() { const { south: t, north: e, southEast: n, southWest: o, northEast: i, northWest: r, southMiddleEast: s, southMiddleWest: a, northMiddleEast: c, northMiddleWest: l } = t_.defaultPanelPositions; if (this.locale.uiLanguageDirection !== "rtl") {
                return [n, o, s, a, t, i, r, c, l, e];
            }
            else {
                return [o, n, a, s, t, r, i, l, c, e];
            } }
        }
        t_.defaultPanelPositions = { south: (t, e) => ({ top: t.bottom, left: t.left - (e.width - t.width) / 2, name: "s" }), southEast: t => ({ top: t.bottom, left: t.left, name: "se" }), southWest: (t, e) => ({ top: t.bottom, left: t.left - e.width + t.width, name: "sw" }), southMiddleEast: (t, e) => ({ top: t.bottom, left: t.left - (e.width - t.width) / 4, name: "sme" }), southMiddleWest: (t, e) => ({ top: t.bottom, left: t.left - (e.width - t.width) * 3 / 4, name: "smw" }), north: (t, e) => ({ top: t.top - e.height, left: t.left - (e.width - t.width) / 2, name: "n" }), northEast: (t, e) => ({ top: t.top - e.height, left: t.left, name: "ne" }), northWest: (t, e) => ({ top: t.top - e.height, left: t.left - e.width + t.width, name: "nw" }), northMiddleEast: (t, e) => ({ top: t.top - e.height, left: t.left - (e.width - t.width) / 4, name: "nme" }), northMiddleWest: (t, e) => ({ top: t.top - e.height, left: t.left - (e.width - t.width) * 3 / 4, name: "nmw" }) };
        t_._getOptimalPosition = Gw;
        class e_ extends Db {
            constructor(t) { super(t); this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-toolbar__separator"] } }); }
        }
        class n_ extends Db {
            constructor(t) { super(t); this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-toolbar__line-break"] } }); }
        }
        function o_(t) { return t.bindTemplate.to((e => { if (e.target === t.element) {
            e.preventDefault();
        } })); }
        function i_(t) { if (Array.isArray(t)) {
            return { items: t, removeItems: [] };
        } if (!t) {
            return { items: [], removeItems: [] };
        } return Object.assign({ items: [], removeItems: [] }, t); }
        var r_ = n(20);
        var s_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        s_.insert = "head";
        s_.singleton = true;
        var a_ = Ab()(r_["a"], s_);
        var c_ = r_["a"].locals || {};
        class l_ extends Db {
            constructor(t, e) { super(t); const n = this.bindTemplate; const o = this.t; this.options = e || {}; this.set("ariaLabel", o("Editor toolbar")); this.set("maxWidth", "auto"); this.items = this.createCollection(); this.focusTracker = new kf; this.keystrokes = new bf; this.set("class"); this.set("isCompact", false); this.itemsView = new d_(t); this.children = this.createCollection(); this.children.add(this.itemsView); this.focusables = this.createCollection(); this._focusCycler = new Dw({ focusables: this.focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: ["arrowleft", "arrowup"], focusNext: ["arrowright", "arrowdown"] } }); const i = ["ck", "ck-toolbar", n.to("class"), n.if("isCompact", "ck-toolbar_compact")]; if (this.options.shouldGroupWhenFull && this.options.isFloating) {
                i.push("ck-toolbar_floating");
            } this.setTemplate({ tag: "div", attributes: { class: i, role: "toolbar", "aria-label": n.to("ariaLabel"), style: { maxWidth: n.to("maxWidth") } }, children: this.children, on: { mousedown: o_(this) } }); this._behavior = this.options.shouldGroupWhenFull ? new h_(this) : new u_(this); }
            render() { super.render(); for (const t of this.items) {
                this.focusTracker.add(t.element);
            } this.items.on("add", ((t, e) => { this.focusTracker.add(e.element); })); this.items.on("remove", ((t, e) => { this.focusTracker.remove(e.element); })); this.keystrokes.listenTo(this.element); this._behavior.render(this); }
            destroy() { this._behavior.destroy(); return super.destroy(); }
            focus() { this._focusCycler.focusFirst(); }
            focusLast() { this._focusCycler.focusLast(); }
            fillFromConfig(t, e) { const n = i_(t); const o = n.items.filter(((t, o, i) => { if (t === "|") {
                return true;
            } if (n.removeItems.indexOf(t) !== -1) {
                return false;
            } if (t === "-") {
                if (this.options.shouldGroupWhenFull) {
                    Object(u["b"])("toolbarview-line-break-ignored-when-grouping-items", i);
                    return false;
                }
                return true;
            } if (!e.has(t)) {
                Object(u["b"])("toolbarview-item-unavailable", { name: t });
                return false;
            } return true; })); const i = this._cleanSeparators(o).map((t => { if (t === "|") {
                return new e_;
            }
            else if (t === "-") {
                return new n_;
            } return e.create(t); })); this.items.addMany(i); }
            _cleanSeparators(t) { const e = t => t !== "-" && t !== "|"; const n = t.length; const o = t.findIndex(e); const i = n - t.slice().reverse().findIndex(e); return t.slice(o, i).filter(((t, n, o) => { if (e(t)) {
                return true;
            } const i = n > 0 && o[n - 1] === t; return !i; })); }
        }
        class d_ extends Db {
            constructor(t) { super(t); this.children = this.createCollection(); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-toolbar__items"] }, children: this.children }); }
        }
        class u_ {
            constructor(t) { const e = t.bindTemplate; t.set("isVertical", false); t.itemsView.children.bindTo(t.items).using((t => t)); t.focusables.bindTo(t.items).using((t => t)); t.extendTemplate({ attributes: { class: [e.if("isVertical", "ck-toolbar_vertical")] } }); }
            render() { }
            destroy() { }
        }
        class h_ {
            constructor(t) { this.view = t; this.viewChildren = t.children; this.viewFocusables = t.focusables; this.viewItemsView = t.itemsView; this.viewFocusTracker = t.focusTracker; this.viewLocale = t.locale; this.ungroupedItems = t.createCollection(); this.groupedItems = t.createCollection(); this.groupedItemsDropdown = this._createGroupedItemsDropdown(); this.resizeObserver = null; this.cachedPadding = null; this.shouldUpdateGroupingOnNextResize = false; t.itemsView.children.bindTo(this.ungroupedItems).using((t => t)); this.ungroupedItems.on("add", this._updateFocusCycleableItems.bind(this)); this.ungroupedItems.on("remove", this._updateFocusCycleableItems.bind(this)); t.children.on("add", this._updateFocusCycleableItems.bind(this)); t.children.on("remove", this._updateFocusCycleableItems.bind(this)); t.items.on("change", ((t, e) => { const n = e.index; for (const t of e.removed) {
                if (n >= this.ungroupedItems.length) {
                    this.groupedItems.remove(t);
                }
                else {
                    this.ungroupedItems.remove(t);
                }
            } for (let t = n; t < n + e.added.length; t++) {
                const o = e.added[t - n];
                if (t > this.ungroupedItems.length) {
                    this.groupedItems.add(o, t - this.ungroupedItems.length);
                }
                else {
                    this.ungroupedItems.add(o, t);
                }
            } this._updateGrouping(); })); t.extendTemplate({ attributes: { class: ["ck-toolbar_grouping"] } }); }
            render(t) { this.viewElement = t.element; this._enableGroupingOnResize(); this._enableGroupingOnMaxWidthChange(t); }
            destroy() { this.groupedItemsDropdown.destroy(); this.resizeObserver.destroy(); }
            _updateGrouping() { if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) {
                return;
            } if (!this.viewElement.offsetParent) {
                this.shouldUpdateGroupingOnNextResize = true;
                return;
            } const t = this.groupedItems.length; let e; while (this._areItemsOverflowing) {
                this._groupLastItem();
                e = true;
            } if (!e && this.groupedItems.length) {
                while (this.groupedItems.length && !this._areItemsOverflowing) {
                    this._ungroupFirstItem();
                }
                if (this._areItemsOverflowing) {
                    this._groupLastItem();
                }
            } if (this.groupedItems.length !== t) {
                this.view.fire("groupedItemsUpdate");
            } }
            get _areItemsOverflowing() { if (!this.ungroupedItems.length) {
                return false;
            } const t = this.viewElement; const e = this.viewLocale.uiLanguageDirection; const n = new cf(t.lastChild); const o = new cf(t); if (!this.cachedPadding) {
                const n = su.window.getComputedStyle(t);
                const o = e === "ltr" ? "paddingRight" : "paddingLeft";
                this.cachedPadding = Number.parseInt(n[o]);
            } if (e === "ltr") {
                return n.right > o.right - this.cachedPadding;
            }
            else {
                return n.left < o.left + this.cachedPadding;
            } }
            _enableGroupingOnResize() { let t; this.resizeObserver = new hf(this.viewElement, (e => { if (!t || t !== e.contentRect.width || this.shouldUpdateGroupingOnNextResize) {
                this.shouldUpdateGroupingOnNextResize = false;
                this._updateGrouping();
                t = e.contentRect.width;
            } })); this._updateGrouping(); }
            _enableGroupingOnMaxWidthChange(t) { t.on("change:maxWidth", (() => { this._updateGrouping(); })); }
            _groupLastItem() { if (!this.groupedItems.length) {
                this.viewChildren.add(new e_);
                this.viewChildren.add(this.groupedItemsDropdown);
                this.viewFocusTracker.add(this.groupedItemsDropdown.element);
            } this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0); }
            _ungroupFirstItem() { this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)); if (!this.groupedItems.length) {
                this.viewChildren.remove(this.groupedItemsDropdown);
                this.viewChildren.remove(this.viewChildren.last);
                this.viewFocusTracker.remove(this.groupedItemsDropdown.element);
            } }
            _createGroupedItemsDropdown() { const t = this.viewLocale; const e = t.t; const n = S_(t); n.class = "ck-toolbar__grouped-dropdown"; n.panelPosition = t.uiLanguageDirection === "ltr" ? "sw" : "se"; T_(n, []); n.buttonView.set({ label: e("Show more items"), tooltip: true, tooltipPosition: t.uiLanguageDirection === "rtl" ? "se" : "sw", icon: gb.threeVerticalDots }); n.toolbarView.items.bindTo(this.groupedItems).using((t => t)); return n; }
            _updateFocusCycleableItems() { this.viewFocusables.clear(); this.ungroupedItems.map((t => { this.viewFocusables.add(t); })); if (this.groupedItems.length) {
                this.viewFocusables.add(this.groupedItemsDropdown);
            } }
        }
        var f_ = n(21);
        var p_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        p_.insert = "head";
        p_.singleton = true;
        var g_ = Ab()(f_["a"], p_);
        var m_ = f_["a"].locals || {};
        class k_ extends Db {
            constructor() { super(); this.items = this.createCollection(); this.focusTracker = new kf; this.keystrokes = new bf; this._focusCycler = new Dw({ focusables: this.items, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "arrowup", focusNext: "arrowdown" } }); this.setTemplate({ tag: "ul", attributes: { class: ["ck", "ck-reset", "ck-list"] }, children: this.items }); }
            render() { super.render(); for (const t of this.items) {
                this.focusTracker.add(t.element);
            } this.items.on("add", ((t, e) => { this.focusTracker.add(e.element); })); this.items.on("remove", ((t, e) => { this.focusTracker.remove(e.element); })); this.keystrokes.listenTo(this.element); }
            focus() { this._focusCycler.focusFirst(); }
            focusLast() { this._focusCycler.focusLast(); }
        }
        class b_ extends Db {
            constructor(t) { super(t); this.children = this.createCollection(); this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__item"] }, children: this.children }); }
            focus() { this.children.first.focus(); }
        }
        class w_ extends Db {
            constructor(t) { super(t); this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__separator"] } }); }
        }
        var __ = n(22);
        var v_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        v_.insert = "head";
        v_.singleton = true;
        var A_ = Ab()(__["a"], v_);
        var C_ = __["a"].locals || {};
        var y_ = n(23);
        var x_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        x_.insert = "head";
        x_.singleton = true;
        var E_ = Ab()(y_["a"], x_);
        var D_ = y_["a"].locals || {};
        function S_(t, e = Ow) { const n = new e(t); const o = new qw(t); const i = new t_(t, n, o); n.bind("isEnabled").to(i); if (n instanceof Ow) {
            n.bind("isOn").to(i, "isOpen");
        }
        else {
            n.arrowView.bind("isOn").to(i, "isOpen");
        } B_(i); return i; }
        function T_(t, e) { const n = t.locale; const o = n.t; const i = t.toolbarView = new l_(n); i.set("ariaLabel", o("Dropdown toolbar")); t.extendTemplate({ attributes: { class: ["ck-toolbar-dropdown"] } }); e.map((t => i.items.add(t))); t.panelView.children.add(i); i.items.delegate("execute").to(t); }
        function P_(t, e) { const n = t.locale; const o = t.listView = new k_(n); o.items.bindTo(e).using((({ type: t, model: e }) => { if (t === "separator") {
            return new w_(n);
        }
        else if (t === "button" || t === "switchbutton") {
            const o = new b_(n);
            let i;
            if (t === "button") {
                i = new mw(n);
            }
            else {
                i = new vw(n);
            }
            i.bind(...Object.keys(e)).to(e);
            i.delegate("execute").to(o);
            o.children.add(i);
            return o;
        } })); t.panelView.children.add(o); o.items.delegate("execute").to(t); }
        function B_(t) { I_(t); R_(t); F_(t); }
        function I_(t) { t.on("render", (() => { mb({ emitter: t, activator: () => t.isOpen, callback: () => { t.isOpen = false; }, contextElements: [t.element] }); })); }
        function R_(t) { t.on("execute", (e => { if (e.source instanceof vw) {
            return;
        } t.isOpen = false; })); }
        function F_(t) { t.keystrokes.set("arrowdown", ((e, n) => { if (t.isOpen) {
            t.panelView.focus();
            n();
        } })); t.keystrokes.set("arrowup", ((e, n) => { if (t.isOpen) {
            t.panelView.focusLast();
            n();
        } })); }
        var O_ = n(24);
        var z_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        z_.insert = "head";
        z_.singleton = true;
        var N_ = Ab()(O_["a"], z_);
        var M_ = O_["a"].locals || {};
        class V_ extends Db {
            constructor(t) { super(t); this.body = new ew(t); }
            render() { super.render(); this.body.attachToDom(); }
            destroy() { this.body.detachFromDom(); return super.destroy(); }
        }
        var L_ = n(25);
        var q_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        q_.insert = "head";
        q_.singleton = true;
        var K_ = Ab()(L_["a"], q_);
        var j_ = L_["a"].locals || {};
        class H_ extends Db {
            constructor(t) { super(t); this.set("text"); this.set("for"); this.id = `ck-editor__label_${a()}`; const e = this.bindTemplate; this.setTemplate({ tag: "label", attributes: { class: ["ck", "ck-label"], id: this.id, for: e.to("for") }, children: [{ text: e.to("text") }] }); }
        }
        class W_ extends V_ {
            constructor(t) { super(t); this.top = this.createCollection(); this.main = this.createCollection(); this._voiceLabelView = this._createVoiceLabel(); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"], role: "application", dir: t.uiLanguageDirection, lang: t.uiLanguage, "aria-labelledby": this._voiceLabelView.id }, children: [this._voiceLabelView, { tag: "div", attributes: { class: ["ck", "ck-editor__top", "ck-reset_all"], role: "presentation" }, children: this.top }, { tag: "div", attributes: { class: ["ck", "ck-editor__main"], role: "presentation" }, children: this.main }] }); }
            _createVoiceLabel() { const t = this.t; const e = new H_; e.text = t("Rich Text Editor"); e.extendTemplate({ attributes: { class: "ck-voice-label" } }); return e; }
        }
        class $_ extends Db {
            constructor(t, e, n) { super(t); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"], lang: t.contentLanguage, dir: t.contentLanguageDirection } }); this.name = null; this.set("isFocused", false); this._editableElement = n; this._hasExternalElement = !!this._editableElement; this._editingView = e; }
            render() { super.render(); if (this._hasExternalElement) {
                this.template.apply(this.element = this._editableElement);
            }
            else {
                this._editableElement = this.element;
            } this.on("change:isFocused", (() => this._updateIsFocusedClasses())); this._updateIsFocusedClasses(); }
            destroy() { if (this._hasExternalElement) {
                this.template.revert(this._editableElement);
            } super.destroy(); }
            _updateIsFocusedClasses() { const t = this._editingView; if (t.isRenderingInProgress) {
                n(this);
            }
            else {
                e(this);
            } function e(e) { t.change((n => { const o = t.document.getRoot(e.name); n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", o); n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", o); })); } function n(o) { t.once("change:isRenderingInProgress", ((t, i, r) => { if (!r) {
                e(o);
            }
            else {
                n(o);
            } })); } }
        }
        class G_ extends $_ {
            constructor(t, e, n) { super(t, e, n); this.extendTemplate({ attributes: { role: "textbox", class: "ck-editor__editable_inline" } }); }
            render() { super.render(); const t = this._editingView; const e = this.t; t.change((n => { const o = t.document.getRoot(this.name); n.setAttribute("aria-label", e("Rich Text Editor, %0", this.name), o); })); }
        }
        var U_ = n(26);
        var J_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        J_.insert = "head";
        J_.singleton = true;
        var Y_ = Ab()(U_["a"], J_);
        var Q_ = U_["a"].locals || {};
        class X_ extends Db {
            constructor(t, e = {}) { super(t); const n = this.bindTemplate; this.set("label", e.label || ""); this.set("class", e.class || null); this.children = this.createCollection(); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-form__header", n.to("class")] }, children: this.children }); const o = new Db(t); o.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-form__header__label"] }, children: [{ text: n.to("label") }] }); this.children.add(o); }
        }
        var Z_ = n(27);
        var tv = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        tv.insert = "head";
        tv.singleton = true;
        var ev = Ab()(Z_["a"], tv);
        var nv = Z_["a"].locals || {};
        class ov extends Db {
            constructor(t) { super(t); this.set("value"); this.set("id"); this.set("placeholder"); this.set("isReadOnly", false); this.set("hasError", false); this.set("ariaDescribedById"); this.focusTracker = new kf; this.bind("isFocused").to(this.focusTracker); this.set("isEmpty", true); const e = this.bindTemplate; this.setTemplate({ tag: "input", attributes: { type: "text", class: ["ck", "ck-input", "ck-input-text", e.if("isFocused", "ck-input_focused"), e.if("isEmpty", "ck-input-text_empty"), e.if("hasError", "ck-error")], id: e.to("id"), placeholder: e.to("placeholder"), readonly: e.to("isReadOnly"), "aria-invalid": e.if("hasError", true), "aria-describedby": e.to("ariaDescribedById") }, on: { input: e.to("input"), change: e.to(this._updateIsEmpty.bind(this)) } }); }
            render() { super.render(); this.focusTracker.add(this.element); this._setDomElementValue(this.value); this._updateIsEmpty(); this.on("change:value", ((t, e, n) => { this._setDomElementValue(n); this._updateIsEmpty(); })); }
            select() { this.element.select(); }
            focus() { this.element.focus(); }
            _updateIsEmpty() { this.isEmpty = iv(this.element); }
            _setDomElementValue(t) { this.element.value = !t && t !== 0 ? "" : t; }
        }
        function iv(t) { return !t.value; }
        var rv = n(28);
        var sv = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        sv.insert = "head";
        sv.singleton = true;
        var av = Ab()(rv["a"], sv);
        var cv = rv["a"].locals || {};
        class lv extends Db {
            constructor(t, e) { super(t); const n = `ck-labeled-field-view-${a()}`; const o = `ck-labeled-field-view-status-${a()}`; this.fieldView = e(this, n, o); this.set("label"); this.set("isEnabled", true); this.set("isEmpty", true); this.set("isFocused", false); this.set("errorText", null); this.set("infoText", null); this.set("class"); this.set("placeholder"); this.labelView = this._createLabelView(n); this.statusView = this._createStatusView(o); this.bind("_statusText").to(this, "errorText", this, "infoText", ((t, e) => t || e)); const i = this.bindTemplate; this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view", i.to("class"), i.if("isEnabled", "ck-disabled", (t => !t)), i.if("isEmpty", "ck-labeled-field-view_empty"), i.if("isFocused", "ck-labeled-field-view_focused"), i.if("placeholder", "ck-labeled-field-view_placeholder"), i.if("errorText", "ck-error")] }, children: [{ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view__input-wrapper"] }, children: [this.fieldView, this.labelView] }, this.statusView] }); }
            _createLabelView(t) { const e = new H_(this.locale); e.for = t; e.bind("text").to(this, "label"); return e; }
            _createStatusView(t) { const e = new Db(this.locale); const n = this.bindTemplate; e.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view__status", n.if("errorText", "ck-labeled-field-view__status_error"), n.if("_statusText", "ck-hidden", (t => !t))], id: t, role: n.if("errorText", "alert") }, children: [{ text: n.to("_statusText") }] }); return e; }
            focus() { this.fieldView.focus(); }
        }
        function dv(t, e, n) { const o = new ov(t.locale); o.set({ id: e, ariaDescribedById: n }); o.bind("isReadOnly").to(t, "isEnabled", (t => !t)); o.bind("hasError").to(t, "errorText", (t => !!t)); o.on("input", (() => { t.errorText = null; })); t.bind("isEmpty", "isFocused", "placeholder").to(o); return o; }
        function uv(t, e, n) { const o = S_(t.locale); o.set({ id: e, ariaDescribedById: n }); o.bind("isEnabled").to(t); return o; }
        class hv extends Ba {
            static get pluginName() { return "Notification"; }
            init() { this.on("show:warning", ((t, e) => { window.alert(e.message); }), { priority: "lowest" }); }
            showSuccess(t, e = {}) { this._showNotification({ message: t, type: "success", namespace: e.namespace, title: e.title }); }
            showInfo(t, e = {}) { this._showNotification({ message: t, type: "info", namespace: e.namespace, title: e.title }); }
            showWarning(t, e = {}) { this._showNotification({ message: t, type: "warning", namespace: e.namespace, title: e.title }); }
            _showNotification(t) { const e = `show:${t.type}` + (t.namespace ? `:${t.namespace}` : ""); this.fire(e, { message: t.message, type: t.type, title: t.title || "" }); }
        }
        class fv {
            constructor(t, e) { if (e) {
                Cn(this, e);
            } if (t) {
                this.set(t);
            } }
        }
        qn(fv, Pn);
        var pv = n(29);
        var gv = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        gv.insert = "head";
        gv.singleton = true;
        var mv = Ab()(pv["a"], gv);
        var kv = pv["a"].locals || {};
        const bv = gf("px");
        const wv = su.document.body;
        class _v extends Db {
            constructor(t) { super(t); const e = this.bindTemplate; this.set("top", 0); this.set("left", 0); this.set("position", "arrow_nw"); this.set("isVisible", false); this.set("withArrow", true); this.set("class"); this.content = this.createCollection(); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-panel", e.to("position", (t => `ck-balloon-panel_${t}`)), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")], style: { top: e.to("top", bv), left: e.to("left", bv) } }, children: this.content }); }
            show() { this.isVisible = true; }
            hide() { this.isVisible = false; }
            attachTo(t) { this.show(); const e = _v.defaultPositions; const n = Object.assign({}, { element: this.element, positions: [e.southArrowNorth, e.southArrowNorthMiddleWest, e.southArrowNorthMiddleEast, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthMiddleWest, e.northArrowSouthMiddleEast, e.northArrowSouthWest, e.northArrowSouthEast], limiter: wv, fitInViewport: true }, t); const o = _v._getOptimalPosition(n); const i = parseInt(o.left); const r = parseInt(o.top); const s = o.name; Object.assign(this, { top: r, left: i, position: s }); }
            pin(t) { this.unpin(); this._pinWhenIsVisibleCallback = () => { if (this.isVisible) {
                this._startPinning(t);
            }
            else {
                this._stopPinning();
            } }; this._startPinning(t); this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback); }
            unpin() { if (this._pinWhenIsVisibleCallback) {
                this._stopPinning();
                this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback);
                this._pinWhenIsVisibleCallback = null;
                this.hide();
            } }
            _startPinning(t) { this.attachTo(t); const e = vv(t.target); const n = t.limiter ? vv(t.limiter) : wv; this.listenTo(su.document, "scroll", ((o, i) => { const r = i.target; const s = e && r.contains(e); const a = n && r.contains(n); if (s || a || !e || !n) {
                this.attachTo(t);
            } }), { useCapture: true }); this.listenTo(su.window, "resize", (() => { this.attachTo(t); })); }
            _stopPinning() { this.stopListening(su.document, "scroll"); this.stopListening(su.window, "resize"); }
        }
        function vv(t) { if (fa(t)) {
            return t;
        } if (rf(t)) {
            return t.commonAncestorContainer;
        } if (typeof t == "function") {
            return vv(t());
        } return null; }
        _v.arrowHorizontalOffset = 25;
        _v.arrowVerticalOffset = 10;
        _v._getOptimalPosition = Gw;
        _v.defaultPositions = { northWestArrowSouthWest: (t, e) => ({ top: Av(t, e), left: t.left - _v.arrowHorizontalOffset, name: "arrow_sw" }), northWestArrowSouthMiddleWest: (t, e) => ({ top: Av(t, e), left: t.left - e.width * .25 - _v.arrowHorizontalOffset, name: "arrow_smw" }), northWestArrowSouth: (t, e) => ({ top: Av(t, e), left: t.left - e.width / 2, name: "arrow_s" }), northWestArrowSouthMiddleEast: (t, e) => ({ top: Av(t, e), left: t.left - e.width * .75 + _v.arrowHorizontalOffset, name: "arrow_sme" }), northWestArrowSouthEast: (t, e) => ({ top: Av(t, e), left: t.left - e.width + _v.arrowHorizontalOffset, name: "arrow_se" }), northArrowSouthWest: (t, e) => ({ top: Av(t, e), left: t.left + t.width / 2 - _v.arrowHorizontalOffset, name: "arrow_sw" }), northArrowSouthMiddleWest: (t, e) => ({ top: Av(t, e), left: t.left + t.width / 2 - e.width * .25 - _v.arrowHorizontalOffset, name: "arrow_smw" }), northArrowSouth: (t, e) => ({ top: Av(t, e), left: t.left + t.width / 2 - e.width / 2, name: "arrow_s" }), northArrowSouthMiddleEast: (t, e) => ({ top: Av(t, e), left: t.left + t.width / 2 - e.width * .75 + _v.arrowHorizontalOffset, name: "arrow_sme" }), northArrowSouthEast: (t, e) => ({ top: Av(t, e), left: t.left + t.width / 2 - e.width + _v.arrowHorizontalOffset, name: "arrow_se" }), northEastArrowSouthWest: (t, e) => ({ top: Av(t, e), left: t.right - _v.arrowHorizontalOffset, name: "arrow_sw" }), northEastArrowSouthMiddleWest: (t, e) => ({ top: Av(t, e), left: t.right - e.width * .25 - _v.arrowHorizontalOffset, name: "arrow_smw" }), northEastArrowSouth: (t, e) => ({ top: Av(t, e), left: t.right - e.width / 2, name: "arrow_s" }), northEastArrowSouthMiddleEast: (t, e) => ({ top: Av(t, e), left: t.right - e.width * .75 + _v.arrowHorizontalOffset, name: "arrow_sme" }), northEastArrowSouthEast: (t, e) => ({ top: Av(t, e), left: t.right - e.width + _v.arrowHorizontalOffset, name: "arrow_se" }), southWestArrowNorthWest: (t, e) => ({ top: Cv(t, e), left: t.left - _v.arrowHorizontalOffset, name: "arrow_nw" }), southWestArrowNorthMiddleWest: (t, e) => ({ top: Cv(t, e), left: t.left - e.width * .25 - _v.arrowHorizontalOffset, name: "arrow_nmw" }), southWestArrowNorth: (t, e) => ({ top: Cv(t, e), left: t.left - e.width / 2, name: "arrow_n" }), southWestArrowNorthMiddleEast: (t, e) => ({ top: Cv(t, e), left: t.left - e.width * .75 + _v.arrowHorizontalOffset, name: "arrow_nme" }), southWestArrowNorthEast: (t, e) => ({ top: Cv(t, e), left: t.left - e.width + _v.arrowHorizontalOffset, name: "arrow_ne" }), southArrowNorthWest: (t, e) => ({ top: Cv(t, e), left: t.left + t.width / 2 - _v.arrowHorizontalOffset, name: "arrow_nw" }), southArrowNorthMiddleWest: (t, e) => ({ top: Cv(t, e), left: t.left + t.width / 2 - e.width * .25 - _v.arrowHorizontalOffset, name: "arrow_nmw" }), southArrowNorth: (t, e) => ({ top: Cv(t, e), left: t.left + t.width / 2 - e.width / 2, name: "arrow_n" }), southArrowNorthMiddleEast: (t, e) => ({ top: Cv(t, e), left: t.left + t.width / 2 - e.width * .75 + _v.arrowHorizontalOffset, name: "arrow_nme" }), southArrowNorthEast: (t, e) => ({ top: Cv(t, e), left: t.left + t.width / 2 - e.width + _v.arrowHorizontalOffset, name: "arrow_ne" }), southEastArrowNorthWest: (t, e) => ({ top: Cv(t, e), left: t.right - _v.arrowHorizontalOffset, name: "arrow_nw" }), southEastArrowNorthMiddleWest: (t, e) => ({ top: Cv(t, e), left: t.right - e.width * .25 - _v.arrowHorizontalOffset, name: "arrow_nmw" }), southEastArrowNorth: (t, e) => ({ top: Cv(t, e), left: t.right - e.width / 2, name: "arrow_n" }), southEastArrowNorthMiddleEast: (t, e) => ({ top: Cv(t, e), left: t.right - e.width * .75 + _v.arrowHorizontalOffset, name: "arrow_nme" }), southEastArrowNorthEast: (t, e) => ({ top: Cv(t, e), left: t.right - e.width + _v.arrowHorizontalOffset, name: "arrow_ne" }) };
        function Av(t, e) { return t.top - e.height - _v.arrowVerticalOffset; }
        function Cv(t) { return t.bottom + _v.arrowVerticalOffset; }
        var yv = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>';
        var xv = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>';
        var Ev = n(30);
        var Dv = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        Dv.insert = "head";
        Dv.singleton = true;
        var Sv = Ab()(Ev["a"], Dv);
        var Tv = Ev["a"].locals || {};
        var Pv = n(31);
        var Bv = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        Bv.insert = "head";
        Bv.singleton = true;
        var Iv = Ab()(Pv["a"], Bv);
        var Rv = Pv["a"].locals || {};
        const Fv = gf("px");
        class Ov extends Kn {
            static get pluginName() { return "ContextualBalloon"; }
            constructor(t) { super(t); this.positionLimiter = () => { const t = this.editor.editing.view; const e = t.document; const n = e.selection.editableElement; if (n) {
                return t.domConverter.mapViewToDom(n.root);
            } return null; }; this.set("visibleView", null); this.view = new _v(t.locale); t.ui.view.body.add(this.view); t.ui.focusTracker.add(this.view.element); this._viewToStack = new Map; this._idToStack = new Map; this.set("_numberOfStacks", 0); this.set("_singleViewMode", false); this._rotatorView = this._createRotatorView(); this._fakePanelsView = this._createFakePanelsView(); }
            hasView(t) { return Array.from(this._viewToStack.keys()).includes(t); }
            add(t) { if (this.hasView(t.view)) {
                throw new u["a"]("contextualballoon-add-view-exist", [this, t]);
            } const e = t.stackId || "main"; if (!this._idToStack.has(e)) {
                this._idToStack.set(e, new Map([[t.view, t]]));
                this._viewToStack.set(t.view, this._idToStack.get(e));
                this._numberOfStacks = this._idToStack.size;
                if (!this._visibleStack || t.singleViewMode) {
                    this.showStack(e);
                }
                return;
            } const n = this._idToStack.get(e); if (t.singleViewMode) {
                this.showStack(e);
            } n.set(t.view, t); this._viewToStack.set(t.view, n); if (n === this._visibleStack) {
                this._showView(t);
            } }
            remove(t) { if (!this.hasView(t)) {
                throw new u["a"]("contextualballoon-remove-view-not-exist", [this, t]);
            } const e = this._viewToStack.get(t); if (this._singleViewMode && this.visibleView === t) {
                this._singleViewMode = false;
            } if (this.visibleView === t) {
                if (e.size === 1) {
                    if (this._idToStack.size > 1) {
                        this._showNextStack();
                    }
                    else {
                        this.view.hide();
                        this.visibleView = null;
                        this._rotatorView.hideView();
                    }
                }
                else {
                    this._showView(Array.from(e.values())[e.size - 2]);
                }
            } if (e.size === 1) {
                this._idToStack.delete(this._getStackId(e));
                this._numberOfStacks = this._idToStack.size;
            }
            else {
                e.delete(t);
            } this._viewToStack.delete(t); }
            updatePosition(t) { if (t) {
                this._visibleStack.get(this.visibleView).position = t;
            } this.view.pin(this._getBalloonPosition()); this._fakePanelsView.updatePosition(); }
            showStack(t) { this.visibleStack = t; const e = this._idToStack.get(t); if (!e) {
                throw new u["a"]("contextualballoon-showstack-stack-not-exist", this);
            } if (this._visibleStack === e) {
                return;
            } this._showView(Array.from(e.values()).pop()); }
            get _visibleStack() { return this._viewToStack.get(this.visibleView); }
            _getStackId(t) { const e = Array.from(this._idToStack.entries()).find((e => e[1] === t)); return e[0]; }
            _showNextStack() { const t = Array.from(this._idToStack.values()); let e = t.indexOf(this._visibleStack) + 1; if (!t[e]) {
                e = 0;
            } this.showStack(this._getStackId(t[e])); }
            _showPrevStack() { const t = Array.from(this._idToStack.values()); let e = t.indexOf(this._visibleStack) - 1; if (!t[e]) {
                e = t.length - 1;
            } this.showStack(this._getStackId(t[e])); }
            _createRotatorView() { const t = new zv(this.editor.locale); const e = this.editor.locale.t; this.view.content.add(t); t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", ((t, e) => !e && t > 1)); t.on("change:isNavigationVisible", (() => this.updatePosition()), { priority: "low" }); t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", ((t, n) => { if (n < 2) {
                return "";
            } const o = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1; return e("%0 of %1", [o, n]); })); t.buttonNextView.on("execute", (() => { if (t.focusTracker.isFocused) {
                this.editor.editing.view.focus();
            } this._showNextStack(); })); t.buttonPrevView.on("execute", (() => { if (t.focusTracker.isFocused) {
                this.editor.editing.view.focus();
            } this._showPrevStack(); })); return t; }
            _createFakePanelsView() { const t = new Nv(this.editor.locale, this.view); t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", ((t, e) => { const n = !e && t >= 2; return n ? Math.min(t - 1, 2) : 0; })); t.listenTo(this.view, "change:top", (() => t.updatePosition())); t.listenTo(this.view, "change:left", (() => t.updatePosition())); this.editor.ui.view.body.add(t); return t; }
            _showView({ view: t, balloonClassName: e = "", withArrow: n = true, singleViewMode: o = false }) { this.view.class = e; this.view.withArrow = n; this._rotatorView.showView(t); this.visibleView = t; this.view.pin(this._getBalloonPosition()); this._fakePanelsView.updatePosition(); if (o) {
                this._singleViewMode = true;
            } }
            _getBalloonPosition() { let t = Array.from(this._visibleStack.values()).pop().position; if (t && !t.limiter) {
                t = Object.assign({}, t, { limiter: this.positionLimiter });
            } return t; }
        }
        class zv extends Db {
            constructor(t) { super(t); const e = t.t; const n = this.bindTemplate; this.set("isNavigationVisible", true); this.focusTracker = new kf; this.buttonPrevView = this._createButtonView(e("Previous"), yv); this.buttonNextView = this._createButtonView(e("Next"), xv); this.content = this.createCollection(); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-rotator"], "z-index": "-1" }, children: [{ tag: "div", attributes: { class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", (t => t ? "" : "ck-hidden"))] }, children: [this.buttonPrevView, { tag: "span", attributes: { class: ["ck-balloon-rotator__counter"] }, children: [{ text: n.to("counter") }] }, this.buttonNextView] }, { tag: "div", attributes: { class: "ck-balloon-rotator__content" }, children: this.content }] }); }
            render() { super.render(); this.focusTracker.add(this.element); }
            showView(t) { this.hideView(); this.content.add(t); }
            hideView() { this.content.clear(); }
            _createButtonView(t, e) { const n = new mw(this.locale); n.set({ label: t, icon: e, tooltip: true }); return n; }
        }
        class Nv extends Db {
            constructor(t, e) { super(t); const n = this.bindTemplate; this.set("top", 0); this.set("left", 0); this.set("height", 0); this.set("width", 0); this.set("numberOfPanels", 0); this.content = this.createCollection(); this._balloonPanelView = e; this.setTemplate({ tag: "div", attributes: { class: ["ck-fake-panel", n.to("numberOfPanels", (t => t ? "" : "ck-hidden"))], style: { top: n.to("top", Fv), left: n.to("left", Fv), width: n.to("width", Fv), height: n.to("height", Fv) } }, children: this.content }); this.on("change:numberOfPanels", ((t, e, n, o) => { if (n > o) {
                this._addPanels(n - o);
            }
            else {
                this._removePanels(o - n);
            } this.updatePosition(); })); }
            _addPanels(t) { while (t--) {
                const t = new Db;
                t.setTemplate({ tag: "div" });
                this.content.add(t);
                this.registerChild(t);
            } }
            _removePanels(t) { while (t--) {
                const t = this.content.last;
                this.content.remove(t);
                this.deregisterChild(t);
                t.destroy();
            } }
            updatePosition() { if (this.numberOfPanels) {
                const { top: t, left: e } = this._balloonPanelView;
                const { width: n, height: o } = new cf(this._balloonPanelView.element);
                Object.assign(this, { top: t, left: e, width: n, height: o });
            } }
        }
        var Mv = n(32);
        var Vv = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        Vv.insert = "head";
        Vv.singleton = true;
        var Lv = Ab()(Mv["a"], Vv);
        var qv = Mv["a"].locals || {};
        const Kv = gf("px");
        class jv extends Db {
            constructor(t) { super(t); const e = this.bindTemplate; this.set("isActive", false); this.set("isSticky", false); this.set("limiterElement", null); this.set("limiterBottomOffset", 50); this.set("viewportTopOffset", 0); this.set("_marginLeft", null); this.set("_isStickyToTheLimiter", false); this.set("_hasViewportTopOffset", false); this.content = this.createCollection(); this._contentPanelPlaceholder = new Tb({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__placeholder"], style: { display: e.to("isSticky", (t => t ? "block" : "none")), height: e.to("isSticky", (t => t ? Kv(this._panelRect.height) : null)) } } }).render(); this._contentPanel = new Tb({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")], style: { width: e.to("isSticky", (t => t ? Kv(this._contentPanelPlaceholder.getBoundingClientRect().width) : null)), top: e.to("_hasViewportTopOffset", (t => t ? Kv(this.viewportTopOffset) : null)), bottom: e.to("_isStickyToTheLimiter", (t => t ? Kv(this.limiterBottomOffset) : null)), marginLeft: e.to("_marginLeft") } }, children: this.content }).render(); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel"] }, children: [this._contentPanelPlaceholder, this._contentPanel] }); }
            render() { super.render(); this._checkIfShouldBeSticky(); this.listenTo(su.window, "scroll", (() => { this._checkIfShouldBeSticky(); })); this.listenTo(this, "change:isActive", (() => { this._checkIfShouldBeSticky(); })); }
            _checkIfShouldBeSticky() { const t = this._panelRect = this._contentPanel.getBoundingClientRect(); let e; if (!this.limiterElement) {
                this.isSticky = false;
            }
            else {
                e = this._limiterRect = this.limiterElement.getBoundingClientRect();
                this.isSticky = this.isActive && e.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < e.height;
            } if (this.isSticky) {
                this._isStickyToTheLimiter = e.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset;
                this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset;
                this._marginLeft = this._isStickyToTheLimiter ? null : Kv(-su.window.scrollX);
            }
            else {
                this._isStickyToTheLimiter = false;
                this._hasViewportTopOffset = false;
                this._marginLeft = null;
            } }
        }
        function Hv({ origin: t, originKeystrokeHandler: e, originFocusTracker: n, toolbar: o, beforeFocus: i, afterBlur: r }) { n.add(o.element); e.set("Alt+F10", ((t, e) => { if (n.isFocused && !o.focusTracker.isFocused) {
            if (i) {
                i();
            }
            o.focus();
            e();
        } })); o.keystrokes.set("Esc", ((e, n) => { if (o.focusTracker.isFocused) {
            t.focus();
            if (r) {
                r();
            }
            n();
        } })); }
        const Wv = gf("px");
        class $v extends Kn {
            static get pluginName() { return "BalloonToolbar"; }
            static get requires() { return [Ov]; }
            constructor(t) { super(t); this._balloonConfig = i_(t.config.get("balloonToolbar")); this.toolbarView = this._createToolbarView(); this.focusTracker = new kf; t.ui.once("ready", (() => { this.focusTracker.add(t.ui.getEditableElement()); this.focusTracker.add(this.toolbarView.element); })); this._resizeObserver = null; this._balloon = t.plugins.get(Ov); this._fireSelectionChangeDebounced = $h((() => this.fire("_selectionChangeDebounced")), 200); this.decorate("show"); }
            init() { const t = this.editor; const e = t.model.document.selection; this.listenTo(this.focusTracker, "change:isFocused", ((t, e, n) => { const o = this._balloon.visibleView === this.toolbarView; if (!n && o) {
                this.hide();
            }
            else if (n) {
                this.show();
            } })); this.listenTo(e, "change:range", ((t, n) => { if (n.directChange || e.isCollapsed) {
                this.hide();
            } this._fireSelectionChangeDebounced(); })); this.listenTo(this, "_selectionChangeDebounced", (() => { if (this.editor.editing.view.document.isFocused) {
                this.show();
            } })); if (!this._balloonConfig.shouldNotGroupWhenFull) {
                this.listenTo(t, "ready", (() => { const e = t.ui.view.editable.element; this._resizeObserver = new hf(e, (() => { this.toolbarView.maxWidth = Wv(new cf(e).width * .9); })); }));
            } this.listenTo(this.toolbarView, "groupedItemsUpdate", (() => { this._updatePosition(); })); }
            afterInit() { const t = this.editor.ui.componentFactory; this.toolbarView.fillFromConfig(this._balloonConfig, t); }
            _createToolbarView() { const t = !this._balloonConfig.shouldNotGroupWhenFull; const e = new l_(this.editor.locale, { shouldGroupWhenFull: t, isFloating: true }); e.render(); return e; }
            show() { const t = this.editor; const e = t.model.document.selection; const n = t.model.schema; if (this._balloon.hasView(this.toolbarView)) {
                return;
            } if (e.isCollapsed) {
                return;
            } if (Uv(e, n)) {
                return;
            } if (Array.from(this.toolbarView.items).every((t => t.isEnabled !== undefined && !t.isEnabled))) {
                return;
            } this.listenTo(this.editor.ui, "update", (() => { this._updatePosition(); })); this._balloon.add({ view: this.toolbarView, position: this._getBalloonPositionData(), balloonClassName: "ck-toolbar-container" }); }
            hide() { if (this._balloon.hasView(this.toolbarView)) {
                this.stopListening(this.editor.ui, "update");
                this._balloon.remove(this.toolbarView);
            } }
            _getBalloonPositionData() { const t = this.editor; const e = t.editing.view; const n = e.document; const o = n.selection; const i = n.selection.isBackward; return { target: () => { const t = i ? o.getFirstRange() : o.getLastRange(); const n = cf.getDomRangeRects(e.domConverter.viewRangeToDom(t)); if (i) {
                    return n[0];
                }
                else {
                    if (n.length > 1 && n[n.length - 1].width === 0) {
                        n.pop();
                    }
                    return n[n.length - 1];
                } }, positions: Gv(i) }; }
            _updatePosition() { this._balloon.updatePosition(this._getBalloonPositionData()); }
            destroy() { super.destroy(); this.stopListening(); this._fireSelectionChangeDebounced.cancel(); this.toolbarView.destroy(); this.focusTracker.destroy(); if (this._resizeObserver) {
                this._resizeObserver.destroy();
            } }
        }
        function Gv(t) { const e = _v.defaultPositions; return t ? [e.northWestArrowSouth, e.northWestArrowSouthWest, e.northWestArrowSouthEast, e.northWestArrowSouthMiddleEast, e.northWestArrowSouthMiddleWest, e.southWestArrowNorth, e.southWestArrowNorthWest, e.southWestArrowNorthEast, e.southWestArrowNorthMiddleWest, e.southWestArrowNorthMiddleEast] : [e.southEastArrowNorth, e.southEastArrowNorthEast, e.southEastArrowNorthWest, e.southEastArrowNorthMiddleEast, e.southEastArrowNorthMiddleWest, e.northEastArrowSouth, e.northEastArrowSouthEast, e.northEastArrowSouthWest, e.northEastArrowSouthMiddleEast, e.northEastArrowSouthMiddleWest]; }
        function Uv(t, e) { if (t.rangeCount === 1) {
            return false;
        } return [...t.getRanges()].every((t => { const n = t.getContainedElement(); return n && e.isSelectable(n); })); }
        var Jv = n(33);
        var Yv = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        Yv.insert = "head";
        Yv.singleton = true;
        var Qv = Ab()(Jv["a"], Yv);
        var Xv = Jv["a"].locals || {};
        const Zv = gf("px");
        class tA extends mw {
            constructor(t) { super(t); const e = this.bindTemplate; this.isVisible = false; this.isToggleable = true; this.set("top", 0); this.set("left", 0); this.extendTemplate({ attributes: { class: "ck-block-toolbar-button", style: { top: e.to("top", (t => Zv(t))), left: e.to("left", (t => Zv(t))) } } }); }
        }
        const eA = gf("px");
        class nA extends Kn {
            static get pluginName() { return "BlockToolbar"; }
            constructor(t) { super(t); this._blockToolbarConfig = i_(this.editor.config.get("blockToolbar")); this.toolbarView = this._createToolbarView(); this.panelView = this._createPanelView(); this.buttonView = this._createButtonView(); this._resizeObserver = null; mb({ emitter: this.panelView, contextElements: [this.panelView.element, this.buttonView.element], activator: () => this.panelView.isVisible, callback: () => this._hidePanel() }); }
            init() { const t = this.editor; this.listenTo(t.model.document.selection, "change:range", ((t, e) => { if (e.directChange) {
                this._hidePanel();
            } })); this.listenTo(t.ui, "update", (() => this._updateButton())); this.listenTo(t, "change:isReadOnly", (() => this._updateButton()), { priority: "low" }); this.listenTo(t.ui.focusTracker, "change:isFocused", (() => this._updateButton())); this.listenTo(this.buttonView, "change:isVisible", ((t, e, n) => { if (n) {
                this.buttonView.listenTo(window, "resize", (() => this._updateButton()));
            }
            else {
                this.buttonView.stopListening(window, "resize");
                this._hidePanel();
            } })); }
            afterInit() { const t = this.editor.ui.componentFactory; const e = this._blockToolbarConfig; this.toolbarView.fillFromConfig(e, t); for (const t of this.toolbarView.items) {
                t.on("execute", (() => this._hidePanel(true)), { priority: "high" });
            } if (!e.shouldNotGroupWhenFull) {
                this.listenTo(this.editor, "ready", (() => { const t = this.editor.ui.view.editable.element; this._resizeObserver = new hf(t, (() => { this.toolbarView.maxWidth = this._getToolbarMaxWidth(); })); }));
            } }
            destroy() { super.destroy(); this.panelView.destroy(); this.buttonView.destroy(); this.toolbarView.destroy(); if (this._resizeObserver) {
                this._resizeObserver.destroy();
            } }
            _createToolbarView() { const t = !this._blockToolbarConfig.shouldNotGroupWhenFull; const e = new l_(this.editor.locale, { shouldGroupWhenFull: t, isFloating: true }); e.focusTracker.on("change:isFocused", ((t, e, n) => { if (!n) {
                this._hidePanel();
            } })); return e; }
            _createPanelView() { const t = this.editor; const e = new _v(t.locale); e.content.add(this.toolbarView); e.class = "ck-toolbar-container"; t.ui.view.body.add(e); t.ui.focusTracker.add(e.element); this.toolbarView.keystrokes.set("Esc", ((t, e) => { this._hidePanel(true); e(); })); return e; }
            _createButtonView() { const t = this.editor; const e = t.t; const n = new tA(t.locale); n.set({ label: e("Edit block"), icon: gb.pilcrow, withText: false }); n.bind("isOn").to(this.panelView, "isVisible"); n.bind("tooltip").to(this.panelView, "isVisible", (t => !t)); this.listenTo(n, "execute", (() => { if (!this.panelView.isVisible) {
                this._showPanel();
            }
            else {
                this._hidePanel(true);
            } })); t.ui.view.body.add(n); t.ui.focusTracker.add(n.element); return n; }
            _updateButton() { const t = this.editor; const e = t.model; const n = t.editing.view; if (!t.ui.focusTracker.isFocused) {
                this._hideButton();
                return;
            } if (t.isReadOnly) {
                this._hideButton();
                return;
            } const o = Array.from(e.document.selection.getSelectedBlocks())[0]; if (!o || Array.from(this.toolbarView.items).every((t => !t.isEnabled))) {
                this._hideButton();
                return;
            } const i = n.domConverter.mapViewToDom(t.editing.mapper.toViewElement(o)); this.buttonView.isVisible = true; this._attachButtonToElement(i); if (this.panelView.isVisible) {
                this._showPanel();
            } }
            _hideButton() { this.buttonView.isVisible = false; }
            _showPanel() { const t = this.panelView.isVisible; this.panelView.show(); this.toolbarView.maxWidth = this._getToolbarMaxWidth(); this.panelView.pin({ target: this.buttonView.element, limiter: this.editor.ui.getEditableElement() }); if (!t) {
                this.toolbarView.items.get(0).focus();
            } }
            _hidePanel(t) { this.panelView.isVisible = false; if (t) {
                this.editor.editing.view.focus();
            } }
            _attachButtonToElement(t) { const e = window.getComputedStyle(t); const n = new cf(this.editor.ui.getEditableElement()); const o = parseInt(e.paddingTop, 10); const i = parseInt(e.lineHeight, 10) || parseInt(e.fontSize, 10) * 1.2; const r = Gw({ element: this.buttonView.element, target: t, positions: [(t, e) => { let r; if (this.editor.locale.uiLanguageDirection === "ltr") {
                        r = n.left - e.width;
                    }
                    else {
                        r = n.right;
                    } return { top: t.top + o + (i - e.height) / 2, left: r }; }] }); this.buttonView.top = r.top; this.buttonView.left = r.left; }
            _getToolbarMaxWidth() { const t = this.editor.ui.view.editable.element; const e = new cf(t); const n = new cf(this.buttonView.element); const o = this.editor.locale.uiLanguageDirection === "rtl"; const i = o ? n.left - e.right + n.width : e.left - n.left; return eA(e.width + i); }
        }
        var oA = n(34);
        var iA = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        iA.insert = "head";
        iA.singleton = true;
        var rA = Ab()(oA["a"], iA);
        var sA = oA["a"].locals || {};
        const aA = new WeakMap;
        function cA(t) { const { view: e, element: n, text: o, isDirectHost: i = true, keepOnFocus: r = false } = t; const s = e.document; if (!aA.has(s)) {
            aA.set(s, new Map);
            s.registerPostFixer((t => fA(s, t)));
        } aA.get(s).set(n, { text: o, isDirectHost: i, keepOnFocus: r, hostElement: i ? n : null }); e.change((t => fA(s, t))); }
        function lA(t, e) { const n = e.document; t.change((t => { if (!aA.has(n)) {
            return;
        } const o = aA.get(n); const i = o.get(e); t.removeAttribute("data-placeholder", i.hostElement); uA(t, i.hostElement); o.delete(e); })); }
        function dA(t, e) { if (!e.hasClass("ck-placeholder")) {
            t.addClass("ck-placeholder", e);
            return true;
        } return false; }
        function uA(t, e) { if (e.hasClass("ck-placeholder")) {
            t.removeClass("ck-placeholder", e);
            return true;
        } return false; }
        function hA(t, e) { if (!t.isAttached()) {
            return false;
        } const n = Array.from(t.getChildren()).some((t => !t.is("uiElement"))); if (n) {
            return false;
        } if (e) {
            return true;
        } const o = t.document; if (!o.isFocused) {
            return true;
        } const i = o.selection; const r = i.anchor; return r && r.parent !== t; }
        function fA(t, e) { const n = aA.get(t); const o = []; let i = false; for (const [t, r] of n) {
            if (r.isDirectHost) {
                o.push(t);
                if (pA(e, t, r)) {
                    i = true;
                }
            }
        } for (const [t, r] of n) {
            if (r.isDirectHost) {
                continue;
            }
            const n = gA(t);
            if (!n) {
                continue;
            }
            if (o.includes(n)) {
                continue;
            }
            r.hostElement = n;
            if (pA(e, t, r)) {
                i = true;
            }
        } return i; }
        function pA(t, e, n) { const { text: o, isDirectHost: i, hostElement: r } = n; let s = false; if (r.getAttribute("data-placeholder") !== o) {
            t.setAttribute("data-placeholder", o, r);
            s = true;
        } const a = i || e.childCount == 1; if (a && hA(r, n.keepOnFocus)) {
            if (dA(t, r)) {
                s = true;
            }
        }
        else if (uA(t, r)) {
            s = true;
        } return s; }
        function gA(t) { if (t.childCount) {
            const e = t.getChild(0);
            if (e.is("element") && !e.is("uiElement")) {
                return e;
            }
        } return null; }
        const mA = new Map;
        function kA(t, e, n) { let o = mA.get(t); if (!o) {
            o = new Map;
            mA.set(t, o);
        } o.set(e, n); }
        function bA(t, e) { const n = mA.get(t); if (n && n.has(e)) {
            return n.get(e);
        } return wA; }
        function wA(t) { return [t]; }
        function _A(t, e, n = {}) { const o = bA(t.constructor, e.constructor); try {
            t = t.clone();
            return o(t, e, n);
        }
        catch (t) {
            throw t;
        } }
        function vA(t, e, n) { t = t.slice(); e = e.slice(); const o = new AA(n.document, n.useRelations, n.forceWeakRemove); o.setOriginalOperations(t); o.setOriginalOperations(e); const i = o.originalOperations; if (t.length == 0 || e.length == 0) {
            return { operationsA: t, operationsB: e, originalOperations: i };
        } const r = new WeakMap; for (const e of t) {
            r.set(e, 0);
        } const s = { nextBaseVersionA: t[t.length - 1].baseVersion + 1, nextBaseVersionB: e[e.length - 1].baseVersion + 1, originalOperationsACount: t.length, originalOperationsBCount: e.length }; let a = 0; while (a < t.length) {
            const n = t[a];
            const i = r.get(n);
            if (i == e.length) {
                a++;
                continue;
            }
            const s = e[i];
            const c = _A(n, s, o.getContext(n, s, true));
            const l = _A(s, n, o.getContext(s, n, false));
            o.updateRelation(n, s);
            o.setOriginalOperations(c, n);
            o.setOriginalOperations(l, s);
            for (const t of c) {
                r.set(t, i + l.length);
            }
            t.splice(a, 1, ...c);
            e.splice(i, 1, ...l);
        } if (n.padWithNoOps) {
            const n = t.length - s.originalOperationsACount;
            const o = e.length - s.originalOperationsBCount;
            yA(t, o - n);
            yA(e, n - o);
        } CA(t, s.nextBaseVersionB); CA(e, s.nextBaseVersionA); return { operationsA: t, operationsB: e, originalOperations: i }; }
        class AA {
            constructor(t, e, n = false) { this.originalOperations = new Map; this._history = t.history; this._useRelations = e; this._forceWeakRemove = !!n; this._relations = new Map; }
            setOriginalOperations(t, e = null) { const n = e ? this.originalOperations.get(e) : null; for (const e of t) {
                this.originalOperations.set(e, n || e);
            } }
            updateRelation(t, e) { switch (t.constructor) {
                case pm: {
                    switch (e.constructor) {
                        case wm: {
                            if (t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition)) {
                                this._setRelation(t, e, "insertAtSource");
                            }
                            else if (t.targetPosition.isEqual(e.deletionPosition)) {
                                this._setRelation(t, e, "insertBetween");
                            }
                            else if (t.targetPosition.isAfter(e.sourcePosition)) {
                                this._setRelation(t, e, "moveTargetAfter");
                            }
                            break;
                        }
                        case pm: {
                            if (t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition)) {
                                this._setRelation(t, e, "insertBefore");
                            }
                            else {
                                this._setRelation(t, e, "insertAfter");
                            }
                            break;
                        }
                    }
                    break;
                }
                case _m: {
                    switch (e.constructor) {
                        case wm: {
                            if (t.splitPosition.isBefore(e.sourcePosition)) {
                                this._setRelation(t, e, "splitBefore");
                            }
                            break;
                        }
                        case pm: {
                            if (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) {
                                this._setRelation(t, e, "splitBefore");
                            }
                            else {
                                const n = Wf._createFromPositionAndShift(e.sourcePosition, e.howMany);
                                if (t.splitPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(t.splitPosition)) {
                                    const o = n.end.offset - t.splitPosition.offset;
                                    const i = t.splitPosition.offset - n.start.offset;
                                    this._setRelation(t, e, { howMany: o, offset: i });
                                }
                            }
                        }
                    }
                    break;
                }
                case wm: {
                    switch (e.constructor) {
                        case wm: {
                            if (!t.targetPosition.isEqual(e.sourcePosition)) {
                                this._setRelation(t, e, "mergeTargetNotMoved");
                            }
                            if (t.sourcePosition.isEqual(e.targetPosition)) {
                                this._setRelation(t, e, "mergeSourceNotMoved");
                            }
                            if (t.sourcePosition.isEqual(e.sourcePosition)) {
                                this._setRelation(t, e, "mergeSameElement");
                            }
                            break;
                        }
                        case _m: {
                            if (t.sourcePosition.isEqual(e.splitPosition)) {
                                this._setRelation(t, e, "splitAtSource");
                            }
                        }
                    }
                    break;
                }
                case mm: {
                    const n = t.newRange;
                    if (!n) {
                        return;
                    }
                    switch (e.constructor) {
                        case pm: {
                            const o = Wf._createFromPositionAndShift(e.sourcePosition, e.howMany);
                            const i = o.containsPosition(n.start) || o.start.isEqual(n.start);
                            const r = o.containsPosition(n.end) || o.end.isEqual(n.end);
                            if ((i || r) && !o.containsRange(n)) {
                                this._setRelation(t, e, { side: i ? "left" : "right", path: i ? n.start.path.slice() : n.end.path.slice() });
                            }
                            break;
                        }
                        case wm: {
                            const o = n.start.isEqual(e.targetPosition);
                            const i = n.start.isEqual(e.deletionPosition);
                            const r = n.end.isEqual(e.deletionPosition);
                            const s = n.end.isEqual(e.sourcePosition);
                            if (o || i || r || s) {
                                this._setRelation(t, e, { wasInLeftElement: o, wasStartBeforeMergedElement: i, wasEndBeforeMergedElement: r, wasInRightElement: s });
                            }
                            break;
                        }
                    }
                    break;
                }
            } }
            getContext(t, e, n) { return { aIsStrong: n, aWasUndone: this._wasUndone(t), bWasUndone: this._wasUndone(e), abRelation: this._useRelations ? this._getRelation(t, e) : null, baRelation: this._useRelations ? this._getRelation(e, t) : null, forceWeakRemove: this._forceWeakRemove }; }
            _wasUndone(t) { const e = this.originalOperations.get(t); return e.wasUndone || this._history.isUndoneOperation(e); }
            _getRelation(t, e) { const n = this.originalOperations.get(e); const o = this._history.getUndoneOperation(n); if (!o) {
                return null;
            } const i = this.originalOperations.get(t); const r = this._relations.get(i); if (r) {
                return r.get(o) || null;
            } return null; }
            _setRelation(t, e, n) { const o = this.originalOperations.get(t); const i = this.originalOperations.get(e); let r = this._relations.get(o); if (!r) {
                r = new Map;
                this._relations.set(o, r);
            } r.set(i, n); }
        }
        function CA(t, e) { for (const n of t) {
            n.baseVersion = e++;
        } }
        function yA(t, e) { for (let n = 0; n < e; n++) {
            t.push(new jm(0));
        } }
        kA(hm, hm, ((t, e, n) => { if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
            const o = t.range.getDifference(e.range).map((e => new hm(e, t.key, t.oldValue, t.newValue, 0)));
            const i = t.range.getIntersection(e.range);
            if (i) {
                if (n.aIsStrong) {
                    o.push(new hm(i, e.key, e.newValue, t.newValue, 0));
                }
            }
            if (o.length == 0) {
                return [new jm(0)];
            }
            return o;
        }
        else {
            return [t];
        } }));
        kA(hm, gm, ((t, e) => { if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
            const n = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes);
            const o = n.map((e => new hm(e, t.key, t.oldValue, t.newValue, t.baseVersion)));
            if (e.shouldReceiveAttributes) {
                const n = xA(e, t.key, t.oldValue);
                if (n) {
                    o.unshift(n);
                }
            }
            return o;
        } t.range = t.range._getTransformedByInsertion(e.position, e.howMany, false)[0]; return [t]; }));
        function xA(t, e, n) { const o = t.nodes; const i = o.getNode(0).getAttribute(e); if (i == n) {
            return null;
        } const r = new Wf(t.position, t.position.getShiftedBy(t.howMany)); return new hm(r, e, i, n, 0); }
        kA(hm, wm, ((t, e) => { const n = []; if (t.range.start.hasSameParentAs(e.deletionPosition)) {
            if (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) {
                n.push(Wf._createFromPositionAndShift(e.graveyardPosition, 1));
            }
        } const o = t.range._getTransformedByMergeOperation(e); if (!o.isCollapsed) {
            n.push(o);
        } return n.map((e => new hm(e, t.key, t.oldValue, t.newValue, t.baseVersion))); }));
        kA(hm, pm, ((t, e) => { const n = EA(t.range, e); return n.map((e => new hm(e, t.key, t.oldValue, t.newValue, t.baseVersion))); }));
        function EA(t, e) { const n = Wf._createFromPositionAndShift(e.sourcePosition, e.howMany); let o = null; let i = []; if (n.containsRange(t, true)) {
            o = t;
        }
        else if (t.start.hasSameParentAs(n.start)) {
            i = t.getDifference(n);
            o = t.getIntersection(n);
        }
        else {
            i = [t];
        } const r = []; for (let t of i) {
            t = t._getTransformedByDeletion(e.sourcePosition, e.howMany);
            const n = e.getMovedRangeStart();
            const o = t.start.hasSameParentAs(n);
            t = t._getTransformedByInsertion(n, e.howMany, o);
            r.push(...t);
        } if (o) {
            r.push(o._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, false)[0]);
        } return r; }
        kA(hm, _m, ((t, e) => { if (t.range.end.isEqual(e.insertionPosition)) {
            if (!e.graveyardPosition) {
                t.range.end.offset++;
            }
            return [t];
        } if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
            const n = t.clone();
            n.range = new Wf(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition));
            t.range.end = e.splitPosition.clone();
            t.range.end.stickiness = "toPrevious";
            return [t, n];
        } t.range = t.range._getTransformedBySplitOperation(e); return [t]; }));
        kA(gm, hm, ((t, e) => { const n = [t]; if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
            const o = xA(t, e.key, e.newValue);
            if (o) {
                n.push(o);
            }
        } return n; }));
        kA(gm, gm, ((t, e, n) => { if (t.position.isEqual(e.position) && n.aIsStrong) {
            return [t];
        } t.position = t.position._getTransformedByInsertOperation(e); return [t]; }));
        kA(gm, pm, ((t, e) => { t.position = t.position._getTransformedByMoveOperation(e); return [t]; }));
        kA(gm, _m, ((t, e) => { t.position = t.position._getTransformedBySplitOperation(e); return [t]; }));
        kA(gm, wm, ((t, e) => { t.position = t.position._getTransformedByMergeOperation(e); return [t]; }));
        kA(mm, gm, ((t, e) => { if (t.oldRange) {
            t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0];
        } if (t.newRange) {
            t.newRange = t.newRange._getTransformedByInsertOperation(e)[0];
        } return [t]; }));
        kA(mm, mm, ((t, e, n) => { if (t.name == e.name) {
            if (n.aIsStrong) {
                t.oldRange = e.newRange ? e.newRange.clone() : null;
            }
            else {
                return [new jm(0)];
            }
        } return [t]; }));
        kA(mm, wm, ((t, e) => { if (t.oldRange) {
            t.oldRange = t.oldRange._getTransformedByMergeOperation(e);
        } if (t.newRange) {
            t.newRange = t.newRange._getTransformedByMergeOperation(e);
        } return [t]; }));
        kA(mm, pm, ((t, e, n) => { if (t.oldRange) {
            t.oldRange = Wf._createFromRanges(t.oldRange._getTransformedByMoveOperation(e));
        } if (t.newRange) {
            if (n.abRelation) {
                const o = Wf._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
                if (n.abRelation.side == "left" && e.targetPosition.isEqual(t.newRange.start)) {
                    t.newRange.start.path = n.abRelation.path;
                    t.newRange.end = o.end;
                    return [t];
                }
                else if (n.abRelation.side == "right" && e.targetPosition.isEqual(t.newRange.end)) {
                    t.newRange.start = o.start;
                    t.newRange.end.path = n.abRelation.path;
                    return [t];
                }
            }
            t.newRange = Wf._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
        } return [t]; }));
        kA(mm, _m, ((t, e, n) => { if (t.oldRange) {
            t.oldRange = t.oldRange._getTransformedBySplitOperation(e);
        } if (t.newRange) {
            if (n.abRelation) {
                const o = t.newRange._getTransformedBySplitOperation(e);
                if (t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement) {
                    t.newRange.start = qf._createAt(e.insertionPosition);
                }
                else if (t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement) {
                    t.newRange.start = qf._createAt(e.moveTargetPosition);
                }
                if (t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement) {
                    t.newRange.end = qf._createAt(e.moveTargetPosition);
                }
                else if (t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement) {
                    t.newRange.end = qf._createAt(e.insertionPosition);
                }
                else {
                    t.newRange.end = o.end;
                }
                return [t];
            }
            t.newRange = t.newRange._getTransformedBySplitOperation(e);
        } return [t]; }));
        kA(wm, gm, ((t, e) => { if (t.sourcePosition.hasSameParentAs(e.position)) {
            t.howMany += e.howMany;
        } t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e); t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e); return [t]; }));
        kA(wm, wm, ((t, e, n) => { if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
            if (!n.bWasUndone) {
                return [new jm(0)];
            }
            else {
                const n = e.graveyardPosition.path.slice();
                n.push(0);
                t.sourcePosition = new qf(e.graveyardPosition.root, n);
                t.howMany = 0;
                return [t];
            }
        } if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && n.abRelation != "splitAtSource") {
            const o = t.targetPosition.root.rootName == "$graveyard";
            const i = e.targetPosition.root.rootName == "$graveyard";
            const r = o && !i;
            const s = i && !o;
            const a = s || !r && n.aIsStrong;
            if (a) {
                const n = e.targetPosition._getTransformedByMergeOperation(e);
                const o = t.targetPosition._getTransformedByMergeOperation(e);
                return [new pm(n, t.howMany, o, 0)];
            }
            else {
                return [new jm(0)];
            }
        } if (t.sourcePosition.hasSameParentAs(e.targetPosition)) {
            t.howMany += e.howMany;
        } t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e); t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e); if (!t.graveyardPosition.isEqual(e.graveyardPosition) || !n.aIsStrong) {
            t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e);
        } return [t]; }));
        kA(wm, pm, ((t, e, n) => { const o = Wf._createFromPositionAndShift(e.sourcePosition, e.howMany); if (e.type == "remove" && !n.bWasUndone && !n.forceWeakRemove) {
            if (t.deletionPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.sourcePosition)) {
                return [new jm(0)];
            }
        } if (t.sourcePosition.hasSameParentAs(e.targetPosition)) {
            t.howMany += e.howMany;
        } if (t.sourcePosition.hasSameParentAs(e.sourcePosition)) {
            t.howMany -= e.howMany;
        } t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e); t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e); if (!t.graveyardPosition.isEqual(e.targetPosition)) {
            t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
        } return [t]; }));
        kA(wm, _m, ((t, e, n) => { if (e.graveyardPosition) {
            t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1);
            if (t.deletionPosition.isEqual(e.graveyardPosition)) {
                t.howMany = e.howMany;
            }
        } if (t.targetPosition.isEqual(e.splitPosition)) {
            const o = e.howMany != 0;
            const i = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);
            if (o || i || n.abRelation == "mergeTargetNotMoved") {
                t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e);
                return [t];
            }
        } if (t.sourcePosition.isEqual(e.splitPosition)) {
            if (n.abRelation == "mergeSourceNotMoved") {
                t.howMany = 0;
                t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
                return [t];
            }
            if (n.abRelation == "mergeSameElement" || t.sourcePosition.offset > 0) {
                t.sourcePosition = e.moveTargetPosition.clone();
                t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
                return [t];
            }
        } if (t.sourcePosition.hasSameParentAs(e.splitPosition)) {
            t.howMany = e.splitPosition.offset;
        } t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e); t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e); return [t]; }));
        kA(pm, gm, ((t, e) => { const n = Wf._createFromPositionAndShift(t.sourcePosition, t.howMany); const o = n._getTransformedByInsertOperation(e, false)[0]; t.sourcePosition = o.start; t.howMany = o.end.offset - o.start.offset; if (!t.targetPosition.isEqual(e.position)) {
            t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e);
        } return [t]; }));
        kA(pm, pm, ((t, e, n) => { const o = Wf._createFromPositionAndShift(t.sourcePosition, t.howMany); const i = Wf._createFromPositionAndShift(e.sourcePosition, e.howMany); let r = n.aIsStrong; let s = !n.aIsStrong; if (n.abRelation == "insertBefore" || n.baRelation == "insertAfter") {
            s = true;
        }
        else if (n.abRelation == "insertAfter" || n.baRelation == "insertBefore") {
            s = false;
        } let a; if (t.targetPosition.isEqual(e.targetPosition) && s) {
            a = t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
        }
        else {
            a = t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
        } if (DA(t, e) && DA(e, t)) {
            return [e.getReversed()];
        } const c = o.containsPosition(e.targetPosition); if (c && o.containsRange(i, true)) {
            o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
            o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
            return SA([o], a);
        } const l = i.containsPosition(t.targetPosition); if (l && i.containsRange(o, true)) {
            o.start = o.start._getCombined(e.sourcePosition, e.getMovedRangeStart());
            o.end = o.end._getCombined(e.sourcePosition, e.getMovedRangeStart());
            return SA([o], a);
        } const d = Ia(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath()); if (d == "prefix" || d == "extension") {
            o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
            o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
            return SA([o], a);
        } if (t.type == "remove" && e.type != "remove" && !n.aWasUndone && !n.forceWeakRemove) {
            r = true;
        }
        else if (t.type != "remove" && e.type == "remove" && !n.bWasUndone && !n.forceWeakRemove) {
            r = false;
        } const u = []; const h = o.getDifference(i); for (const t of h) {
            t.start = t.start._getTransformedByDeletion(e.sourcePosition, e.howMany);
            t.end = t.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
            const n = Ia(t.start.getParentPath(), e.getMovedRangeStart().getParentPath()) == "same";
            const o = t._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, n);
            u.push(...o);
        } const f = o.getIntersection(i); if (f !== null && r) {
            f.start = f.start._getCombined(e.sourcePosition, e.getMovedRangeStart());
            f.end = f.end._getCombined(e.sourcePosition, e.getMovedRangeStart());
            if (u.length === 0) {
                u.push(f);
            }
            else if (u.length == 1) {
                if (i.start.isBefore(o.start) || i.start.isEqual(o.start)) {
                    u.unshift(f);
                }
                else {
                    u.push(f);
                }
            }
            else {
                u.splice(1, 0, f);
            }
        } if (u.length === 0) {
            return [new jm(t.baseVersion)];
        } return SA(u, a); }));
        kA(pm, _m, ((t, e, n) => { let o = t.targetPosition.clone(); if (!t.targetPosition.isEqual(e.insertionPosition) || !e.graveyardPosition || n.abRelation == "moveTargetAfter") {
            o = t.targetPosition._getTransformedBySplitOperation(e);
        } const i = Wf._createFromPositionAndShift(t.sourcePosition, t.howMany); if (i.end.isEqual(e.insertionPosition)) {
            if (!e.graveyardPosition) {
                t.howMany++;
            }
            t.targetPosition = o;
            return [t];
        } if (i.start.hasSameParentAs(e.splitPosition) && i.containsPosition(e.splitPosition)) {
            let t = new Wf(e.splitPosition, i.end);
            t = t._getTransformedBySplitOperation(e);
            const n = [new Wf(i.start, e.splitPosition), t];
            return SA(n, o);
        } if (t.targetPosition.isEqual(e.splitPosition) && n.abRelation == "insertAtSource") {
            o = e.moveTargetPosition;
        } if (t.targetPosition.isEqual(e.insertionPosition) && n.abRelation == "insertBetween") {
            o = t.targetPosition;
        } const r = i._getTransformedBySplitOperation(e); const s = [r]; if (e.graveyardPosition) {
            const o = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
            if (t.howMany > 1 && o && !n.aWasUndone) {
                s.push(Wf._createFromPositionAndShift(e.insertionPosition, 1));
            }
        } return SA(s, o); }));
        kA(pm, wm, ((t, e, n) => { const o = Wf._createFromPositionAndShift(t.sourcePosition, t.howMany); if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.sourcePosition)) {
            if (t.type == "remove" && !n.forceWeakRemove) {
                if (!n.aWasUndone) {
                    const n = [];
                    let o = e.graveyardPosition.clone();
                    let i = e.targetPosition._getTransformedByMergeOperation(e);
                    if (t.howMany > 1) {
                        n.push(new pm(t.sourcePosition, t.howMany - 1, t.targetPosition, 0));
                        o = o._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1);
                        i = i._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1);
                    }
                    const r = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition);
                    const s = new pm(o, 1, r, 0);
                    const a = s.getMovedRangeStart().path.slice();
                    a.push(0);
                    const c = new qf(s.targetPosition.root, a);
                    i = i._getTransformedByMove(o, r, 1);
                    const l = new pm(i, e.howMany, c, 0);
                    n.push(s);
                    n.push(l);
                    return n;
                }
            }
            else {
                if (t.howMany == 1) {
                    if (!n.bWasUndone) {
                        return [new jm(0)];
                    }
                    else {
                        t.sourcePosition = e.graveyardPosition.clone();
                        t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e);
                        return [t];
                    }
                }
            }
        } const i = Wf._createFromPositionAndShift(t.sourcePosition, t.howMany); const r = i._getTransformedByMergeOperation(e); t.sourcePosition = r.start; t.howMany = r.end.offset - r.start.offset; t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e); return [t]; }));
        kA(km, gm, ((t, e) => { t.position = t.position._getTransformedByInsertOperation(e); return [t]; }));
        kA(km, wm, ((t, e) => { if (t.position.isEqual(e.deletionPosition)) {
            t.position = e.graveyardPosition.clone();
            t.position.stickiness = "toNext";
            return [t];
        } t.position = t.position._getTransformedByMergeOperation(e); return [t]; }));
        kA(km, pm, ((t, e) => { t.position = t.position._getTransformedByMoveOperation(e); return [t]; }));
        kA(km, km, ((t, e, n) => { if (t.position.isEqual(e.position)) {
            if (n.aIsStrong) {
                t.oldName = e.newName;
            }
            else {
                return [new jm(0)];
            }
        } return [t]; }));
        kA(km, _m, ((t, e) => { const n = t.position.path; const o = e.splitPosition.getParentPath(); if (Ia(n, o) == "same" && !e.graveyardPosition) {
            const e = new km(t.position.getShiftedBy(1), t.oldName, t.newName, 0);
            return [t, e];
        } t.position = t.position._getTransformedBySplitOperation(e); return [t]; }));
        kA(bm, bm, ((t, e, n) => { if (t.root === e.root && t.key === e.key) {
            if (!n.aIsStrong || t.newValue === e.newValue) {
                return [new jm(0)];
            }
            else {
                t.oldValue = e.newValue;
            }
        } return [t]; }));
        kA(_m, gm, ((t, e) => { if (t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset) {
            t.howMany += e.howMany;
        } t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e); t.insertionPosition = t.insertionPosition._getTransformedByInsertOperation(e); return [t]; }));
        kA(_m, wm, ((t, e, n) => { if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
            const n = e.graveyardPosition.path.slice();
            n.push(0);
            const o = new qf(e.graveyardPosition.root, n);
            const i = _m.getInsertionPosition(new qf(e.graveyardPosition.root, n));
            const r = new _m(o, 0, i, null, 0);
            t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e);
            t.insertionPosition = _m.getInsertionPosition(t.splitPosition);
            t.graveyardPosition = r.insertionPosition.clone();
            t.graveyardPosition.stickiness = "toNext";
            return [r, t];
        } if (t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition)) {
            t.howMany--;
        } if (t.splitPosition.hasSameParentAs(e.targetPosition)) {
            t.howMany += e.howMany;
        } t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e); t.insertionPosition = _m.getInsertionPosition(t.splitPosition); if (t.graveyardPosition) {
            t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e);
        } return [t]; }));
        kA(_m, pm, ((t, e, n) => { const o = Wf._createFromPositionAndShift(e.sourcePosition, e.howMany); if (t.graveyardPosition) {
            const i = o.start.isEqual(t.graveyardPosition) || o.containsPosition(t.graveyardPosition);
            if (!n.bWasUndone && i) {
                const n = t.splitPosition._getTransformedByMoveOperation(e);
                const o = t.graveyardPosition._getTransformedByMoveOperation(e);
                const i = o.path.slice();
                i.push(0);
                const r = new qf(o.root, i);
                const s = new pm(n, t.howMany, r, 0);
                return [s];
            }
            t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
        } const i = t.splitPosition.isEqual(e.targetPosition); if (i && (n.baRelation == "insertAtSource" || n.abRelation == "splitBefore")) {
            t.howMany += e.howMany;
            t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
            t.insertionPosition = _m.getInsertionPosition(t.splitPosition);
            return [t];
        } if (i && n.abRelation && n.abRelation.howMany) {
            const { howMany: e, offset: o } = n.abRelation;
            t.howMany += e;
            t.splitPosition = t.splitPosition.getShiftedBy(o);
            return [t];
        } if (t.splitPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.splitPosition)) {
            const n = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);
            t.howMany -= n;
            if (t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset) {
                t.howMany += e.howMany;
            }
            t.splitPosition = e.sourcePosition.clone();
            t.insertionPosition = _m.getInsertionPosition(t.splitPosition);
            return [t];
        } if (!e.sourcePosition.isEqual(e.targetPosition)) {
            if (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset) {
                t.howMany -= e.howMany;
            }
            if (t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset) {
                t.howMany += e.howMany;
            }
        } t.splitPosition.stickiness = "toNone"; t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e); t.splitPosition.stickiness = "toNext"; if (t.graveyardPosition) {
            t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e);
        }
        else {
            t.insertionPosition = _m.getInsertionPosition(t.splitPosition);
        } return [t]; }));
        kA(_m, _m, ((t, e, n) => { if (t.splitPosition.isEqual(e.splitPosition)) {
            if (!t.graveyardPosition && !e.graveyardPosition) {
                return [new jm(0)];
            }
            if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
                return [new jm(0)];
            }
            if (n.abRelation == "splitBefore") {
                t.howMany = 0;
                t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e);
                return [t];
            }
        } if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
            const o = t.splitPosition.root.rootName == "$graveyard";
            const i = e.splitPosition.root.rootName == "$graveyard";
            const r = o && !i;
            const s = i && !o;
            const a = s || !r && n.aIsStrong;
            if (a) {
                const n = [];
                if (e.howMany) {
                    n.push(new pm(e.moveTargetPosition, e.howMany, e.splitPosition, 0));
                }
                if (t.howMany) {
                    n.push(new pm(t.splitPosition, t.howMany, t.moveTargetPosition, 0));
                }
                return n;
            }
            else {
                return [new jm(0)];
            }
        } if (t.graveyardPosition) {
            t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e);
        } if (t.splitPosition.isEqual(e.insertionPosition) && n.abRelation == "splitBefore") {
            t.howMany++;
            return [t];
        } if (e.splitPosition.isEqual(t.insertionPosition) && n.baRelation == "splitBefore") {
            const n = e.insertionPosition.path.slice();
            n.push(0);
            const o = new qf(e.insertionPosition.root, n);
            const i = new pm(t.insertionPosition, 1, o, 0);
            return [t, i];
        } if (t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset) {
            t.howMany -= e.howMany;
        } t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e); t.insertionPosition = _m.getInsertionPosition(t.splitPosition); return [t]; }));
        function DA(t, e) { return t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) === null; }
        function SA(t, e) { const n = []; for (let o = 0; o < t.length; o++) {
            const i = t[o];
            const r = new pm(i.start, i.end.offset - i.start.offset, e, 0);
            n.push(r);
            for (let e = o + 1; e < t.length; e++) {
                t[e] = t[e]._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany)[0];
            }
            e = e._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany);
        } return n; }
        class TA extends xh {
            constructor(t) { super(t); this.domEventType = "click"; }
            onDomEvent(t) { this.fire(t.type, t); }
        }
        class PA extends xh {
            constructor(t) { super(t); this.domEventType = ["mousedown", "mouseup"]; }
            onDomEvent(t) { this.fire(t.type, t); }
        }
        class BA {
            constructor(t) { this.document = t; }
            createDocumentFragment(t) { return new kd(this.document, t); }
            createElement(t, e, n) { return new ul(this.document, t, e, n); }
            createText(t) { return new Na(this.document, t); }
            clone(t, e = false) { return t._clone(e); }
            appendChild(t, e) { return e._appendChild(t); }
            insertChild(t, e, n) { return n._insertChild(t, e); }
            removeChildren(t, e, n) { return n._removeChildren(t, e); }
            remove(t) { const e = t.parent; if (e) {
                return this.removeChildren(e.getChildIndex(t), 1, e);
            } return []; }
            replace(t, e) { const n = t.parent; if (n) {
                const o = n.getChildIndex(t);
                this.removeChildren(o, 1, n);
                this.insertChild(o, e, n);
                return true;
            } return false; }
            unwrapElement(t) { const e = t.parent; if (e) {
                const n = e.getChildIndex(t);
                this.remove(t);
                this.insertChild(n, t.getChildren(), e);
            } }
            rename(t, e) { const n = new ul(this.document, t, e.getAttributes(), e.getChildren()); return this.replace(e, n) ? n : null; }
            setAttribute(t, e, n) { n._setAttribute(t, e); }
            removeAttribute(t, e) { e._removeAttribute(t); }
            addClass(t, e) { e._addClass(t); }
            removeClass(t, e) { e._removeClass(t); }
            setStyle(t, e, n) { if (io(t) && n === undefined) {
                n = e;
            } n._setStyle(t, e); }
            removeStyle(t, e) { e._removeStyle(t); }
            setCustomProperty(t, e, n) { n._setCustomProperty(t, e); }
            removeCustomProperty(t, e) { return e._removeCustomProperty(t); }
            createPositionAt(t, e) { return vl._createAt(t, e); }
            createPositionAfter(t) { return vl._createAfter(t); }
            createPositionBefore(t) { return vl._createBefore(t); }
            createRange(t, e) { return new Al(t, e); }
            createRangeOn(t) { return Al._createOn(t); }
            createRangeIn(t) { return Al._createIn(t); }
            createSelection(t, e, n) { return new xl(t, e, n); }
        }
        const IA = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
        const RA = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i;
        const FA = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
        const OA = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i;
        const zA = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
        const NA = new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "rebeccapurple", "currentcolor", "transparent"]);
        function MA(t) { if (t.startsWith("#")) {
            return IA.test(t);
        } if (t.startsWith("rgb")) {
            return RA.test(t) || FA.test(t);
        } if (t.startsWith("hsl")) {
            return OA.test(t) || zA.test(t);
        } return NA.has(t.toLowerCase()); }
        const VA = ["none", "hidden", "dotted", "dashed", "solid", "double", "groove", "ridge", "inset", "outset"];
        function LA(t) { return VA.includes(t); }
        const qA = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
        function KA(t) { return qA.test(t); }
        const jA = /^[+-]?[0-9]*([.][0-9]+)?%$/;
        function HA(t) { return jA.test(t); }
        const WA = ["repeat-x", "repeat-y", "repeat", "space", "round", "no-repeat"];
        function $A(t) { return WA.includes(t); }
        const GA = ["center", "top", "bottom", "left", "right"];
        function UA(t) { return GA.includes(t); }
        const JA = ["fixed", "scroll", "local"];
        function YA(t) { return JA.includes(t); }
        const QA = /^url\(/;
        function XA(t) { return QA.test(t); }
        function ZA(t = "") { if (t === "") {
            return { top: undefined, right: undefined, bottom: undefined, left: undefined };
        } const e = oC(t); const n = e[0]; const o = e[2] || n; const i = e[1] || n; const r = e[3] || i; return { top: n, bottom: o, right: i, left: r }; }
        function tC(t) { return e => { const { top: n, right: o, bottom: i, left: r } = e; const s = []; if (![n, o, r, i].every((t => !!t))) {
            if (n) {
                s.push([t + "-top", n]);
            }
            if (o) {
                s.push([t + "-right", o]);
            }
            if (i) {
                s.push([t + "-bottom", i]);
            }
            if (r) {
                s.push([t + "-left", r]);
            }
        }
        else {
            s.push([t, eC(e)]);
        } return s; }; }
        function eC({ top: t, right: e, bottom: n, left: o }) { const i = []; if (o !== e) {
            i.push(t, e, n, o);
        }
        else if (n !== t) {
            i.push(t, e, n);
        }
        else if (e !== t) {
            i.push(t, e);
        }
        else {
            i.push(t);
        } return i.join(" "); }
        function nC(t) { return e => ({ path: t, value: ZA(e) }); }
        function oC(t) { return t.replace(/, /g, ",").split(" ").map((t => t.replace(/,/g, ", "))); }
        function iC(t) { t.setNormalizer("background", rC); t.setNormalizer("background-color", (t => ({ path: "background.color", value: t }))); t.setReducer("background", (t => { const e = []; e.push(["background-color", t.color]); return e; })); }
        function rC(t) { const e = {}; const n = oC(t); for (const t of n) {
            if ($A(t)) {
                e.repeat = e.repeat || [];
                e.repeat.push(t);
            }
            else if (UA(t)) {
                e.position = e.position || [];
                e.position.push(t);
            }
            else if (YA(t)) {
                e.attachment = t;
            }
            else if (MA(t)) {
                e.color = t;
            }
            else if (XA(t)) {
                e.image = t;
            }
        } return { path: "background", value: e }; }
        function sC(t) { t.setNormalizer("border", aC); t.setNormalizer("border-top", cC("top")); t.setNormalizer("border-right", cC("right")); t.setNormalizer("border-bottom", cC("bottom")); t.setNormalizer("border-left", cC("left")); t.setNormalizer("border-color", lC("color")); t.setNormalizer("border-width", lC("width")); t.setNormalizer("border-style", lC("style")); t.setNormalizer("border-top-color", uC("color", "top")); t.setNormalizer("border-top-style", uC("style", "top")); t.setNormalizer("border-top-width", uC("width", "top")); t.setNormalizer("border-right-color", uC("color", "right")); t.setNormalizer("border-right-style", uC("style", "right")); t.setNormalizer("border-right-width", uC("width", "right")); t.setNormalizer("border-bottom-color", uC("color", "bottom")); t.setNormalizer("border-bottom-style", uC("style", "bottom")); t.setNormalizer("border-bottom-width", uC("width", "bottom")); t.setNormalizer("border-left-color", uC("color", "left")); t.setNormalizer("border-left-style", uC("style", "left")); t.setNormalizer("border-left-width", uC("width", "left")); t.setExtractor("border-top", hC("top")); t.setExtractor("border-right", hC("right")); t.setExtractor("border-bottom", hC("bottom")); t.setExtractor("border-left", hC("left")); t.setExtractor("border-top-color", "border.color.top"); t.setExtractor("border-right-color", "border.color.right"); t.setExtractor("border-bottom-color", "border.color.bottom"); t.setExtractor("border-left-color", "border.color.left"); t.setExtractor("border-top-width", "border.width.top"); t.setExtractor("border-right-width", "border.width.right"); t.setExtractor("border-bottom-width", "border.width.bottom"); t.setExtractor("border-left-width", "border.width.left"); t.setExtractor("border-top-style", "border.style.top"); t.setExtractor("border-right-style", "border.style.right"); t.setExtractor("border-bottom-style", "border.style.bottom"); t.setExtractor("border-left-style", "border.style.left"); t.setReducer("border-color", tC("border-color")); t.setReducer("border-style", tC("border-style")); t.setReducer("border-width", tC("border-width")); t.setReducer("border-top", mC("top")); t.setReducer("border-right", mC("right")); t.setReducer("border-bottom", mC("bottom")); t.setReducer("border-left", mC("left")); t.setReducer("border", gC); t.setStyleRelation("border", ["border-color", "border-style", "border-width", "border-top", "border-right", "border-bottom", "border-left", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]); t.setStyleRelation("border-color", ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"]); t.setStyleRelation("border-style", ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"]); t.setStyleRelation("border-width", ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"]); t.setStyleRelation("border-top", ["border-top-color", "border-top-style", "border-top-width"]); t.setStyleRelation("border-right", ["border-right-color", "border-right-style", "border-right-width"]); t.setStyleRelation("border-bottom", ["border-bottom-color", "border-bottom-style", "border-bottom-width"]); t.setStyleRelation("border-left", ["border-left-color", "border-left-style", "border-left-width"]); }
        function aC(t) { const { color: e, style: n, width: o } = pC(t); return { path: "border", value: { color: ZA(e), style: ZA(n), width: ZA(o) } }; }
        function cC(t) { return e => { const { color: n, style: o, width: i } = pC(e); const r = {}; if (n !== undefined) {
            r.color = { [t]: n };
        } if (o !== undefined) {
            r.style = { [t]: o };
        } if (i !== undefined) {
            r.width = { [t]: i };
        } return { path: "border", value: r }; }; }
        function lC(t) { return e => ({ path: "border", value: dC(e, t) }); }
        function dC(t, e) { return { [e]: ZA(t) }; }
        function uC(t, e) { return n => ({ path: "border", value: { [t]: { [e]: n } } }); }
        function hC(t) { return (e, n) => { if (n.border) {
            return fC(n.border, t);
        } }; }
        function fC(t, e) { const n = {}; if (t.width && t.width[e]) {
            n.width = t.width[e];
        } if (t.style && t.style[e]) {
            n.style = t.style[e];
        } if (t.color && t.color[e]) {
            n.color = t.color[e];
        } return n; }
        function pC(t) { const e = {}; const n = oC(t); for (const t of n) {
            if (KA(t) || /thin|medium|thick/.test(t)) {
                e.width = t;
            }
            else if (LA(t)) {
                e.style = t;
            }
            else {
                e.color = t;
            }
        } return e; }
        function gC(t) { const e = []; e.push(...kC(fC(t, "top"), "top")); e.push(...kC(fC(t, "right"), "right")); e.push(...kC(fC(t, "bottom"), "bottom")); e.push(...kC(fC(t, "left"), "left")); return e; }
        function mC(t) { return e => kC(e, t); }
        function kC(t, e) { const n = []; if (t && t.width !== undefined) {
            n.push(t.width);
        } if (t && t.style !== undefined) {
            n.push(t.style);
        } if (t && t.color !== undefined) {
            n.push(t.color);
        } if (n.length) {
            return [[`border-${e}`, n.join(" ")]];
        } return []; }
        function bC(t) { t.setNormalizer("margin", nC("margin")); t.setNormalizer("margin-top", (t => ({ path: "margin.top", value: t }))); t.setNormalizer("margin-right", (t => ({ path: "margin.right", value: t }))); t.setNormalizer("margin-bottom", (t => ({ path: "margin.bottom", value: t }))); t.setNormalizer("margin-left", (t => ({ path: "margin.left", value: t }))); t.setReducer("margin", tC("margin")); t.setStyleRelation("margin", ["margin-top", "margin-right", "margin-bottom", "margin-left"]); }
        function wC(t) { t.setNormalizer("padding", nC("padding")); t.setNormalizer("padding-top", (t => ({ path: "padding.top", value: t }))); t.setNormalizer("padding-right", (t => ({ path: "padding.right", value: t }))); t.setNormalizer("padding-bottom", (t => ({ path: "padding.bottom", value: t }))); t.setNormalizer("padding-left", (t => ({ path: "padding.left", value: t }))); t.setReducer("padding", tC("padding")); t.setStyleRelation("padding", ["padding-top", "padding-right", "padding-bottom", "padding-left"]); }
        class _C extends zk {
            constructor(t, e) { super(t); this.view = e; this._toolbarConfig = i_(t.config.get("toolbar")); this._elementReplacer = new Xh; }
            get element() { return this.view.element; }
            init(t) { const e = this.editor; const n = this.view; const o = e.editing.view; const i = n.editable; const r = o.document.getRoot(); i.name = r.rootName; n.render(); const s = i.element; this.setEditableElement(i.name, s); this.focusTracker.add(s); n.editable.bind("isFocused").to(this.focusTracker); o.attachDomRoot(s); if (t) {
                this._elementReplacer.replace(t, this.element);
            } this._initPlaceholder(); this._initToolbar(); this.fire("ready"); }
            destroy() { const t = this.view; const e = this.editor.editing.view; this._elementReplacer.restore(); e.detachDomRoot(t.editable.name); t.destroy(); super.destroy(); }
            _initToolbar() { const t = this.editor; const e = this.view; const n = t.editing.view; e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"); e.stickyPanel.limiterElement = e.element; if (this._toolbarConfig.viewportTopOffset) {
                e.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset;
            } e.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory); Hv({ origin: n, originFocusTracker: this.focusTracker, originKeystrokeHandler: t.keystrokes, toolbar: e.toolbar }); }
            _initPlaceholder() { const t = this.editor; const e = t.editing.view; const n = e.document.getRoot(); const o = t.sourceElement; const i = t.config.get("placeholder") || o && o.tagName.toLowerCase() === "textarea" && o.getAttribute("placeholder"); if (i) {
                cA({ view: e, element: n, text: i, isDirectHost: false, keepOnFocus: true });
            } }
        }
        var vC = n(35);
        var AC = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        AC.insert = "head";
        AC.singleton = true;
        var CC = Ab()(vC["a"], AC);
        var yC = vC["a"].locals || {};
        class xC extends W_ {
            constructor(t, e, n = {}) { super(t); this.stickyPanel = new jv(t); this.toolbar = new l_(t, { shouldGroupWhenFull: n.shouldToolbarGroupWhenFull }); this.editable = new G_(t, e); }
            render() { super.render(); this.stickyPanel.content.add(this.toolbar); this.top.add(this.stickyPanel); this.main.add(this.editable); }
        }
        class EC extends Rk {
            constructor(t, e) { super(e); if (fa(t)) {
                this.sourceElement = t;
            } this.model.document.createRoot(); const n = !this.config.get("toolbar.shouldNotGroupWhenFull"); const o = new xC(this.locale, this.editing.view, { shouldToolbarGroupWhenFull: n }); this.ui = new _C(this, o); Nk(this); }
            destroy() { if (this.sourceElement) {
                this.updateSourceElement();
            } this.ui.destroy(); return super.destroy(); }
            static create(t, e = {}) { return new Promise((n => { const o = new this(t, e); n(o.initPlugins().then((() => o.ui.init(fa(t) ? t : null))).then((() => { if (!fa(t) && e.initialData) {
                throw new u["a"]("editor-create-initial-data", null);
            } const n = e.initialData !== undefined ? e.initialData : DC(t); return o.data.init(n); })).then((() => o.fire("ready"))).then((() => o))); })); }
        }
        qn(EC, Vk);
        qn(EC, qk);
        function DC(t) { return fa(t) ? of(t) : t; }
        const SC = ["left", "right", "center", "justify"];
        function TC(t) { return SC.includes(t); }
        function PC(t, e) { if (e.contentLanguageDirection == "rtl") {
            return t === "right";
        }
        else {
            return t === "left";
        } }
        function BC(t) { const e = t.map((t => { let e; if (typeof t == "string") {
            e = { name: t };
        }
        else {
            e = t;
        } return e; })).filter((t => { const e = !!SC.includes(t.name); if (!e) {
            Object(u["b"])("alignment-config-name-not-recognized", { option: t });
        } return e; })); const n = e.filter((t => !!t.className)).length; if (n && n < e.length) {
            throw new u["a"]("alignment-config-classnames-are-missing", { configuredOptions: t });
        } e.forEach(((e, n, o) => { const i = o.slice(n + 1); const r = i.some((t => t.name == e.name)); if (r) {
            throw new u["a"]("alignment-config-name-already-defined", { option: e, configuredOptions: t });
        } if (e.className) {
            const n = i.some((t => t.className == e.className));
            if (n) {
                throw new u["a"]("alignment-config-classname-already-defined", { option: e, configuredOptions: t });
            }
        } })); return e; }
        const IC = "alignment";
        class RC extends Hn {
            refresh() { const t = this.editor; const e = t.locale; const n = mf(this.editor.model.document.selection.getSelectedBlocks()); this.isEnabled = !!n && this._canBeAligned(n); if (this.isEnabled && n.hasAttribute("alignment")) {
                this.value = n.getAttribute("alignment");
            }
            else {
                this.value = e.contentLanguageDirection === "rtl" ? "right" : "left";
            } }
            execute(t = {}) { const e = this.editor; const n = e.locale; const o = e.model; const i = o.document; const r = t.value; o.change((t => { const e = Array.from(i.selection.getSelectedBlocks()).filter((t => this._canBeAligned(t))); const o = e[0].getAttribute("alignment"); const s = PC(r, n) || o === r || !r; if (s) {
                FC(e, t);
            }
            else {
                OC(e, t, r);
            } })); }
            _canBeAligned(t) { return this.editor.model.schema.checkAttribute(t, IC); }
        }
        function FC(t, e) { for (const n of t) {
            e.removeAttribute(IC, n);
        } }
        function OC(t, e, n) { for (const o of t) {
            e.setAttribute(IC, n, o);
        } }
        class zC extends Kn {
            static get pluginName() { return "AlignmentEditing"; }
            constructor(t) { super(t); t.config.define("alignment", { options: [...SC.map((t => ({ name: t })))] }); }
            init() { const t = this.editor; const e = t.locale; const n = t.model.schema; const o = BC(t.config.get("alignment.options")); const i = o.filter((t => TC(t.name) && !PC(t.name, e))); const r = i.some((t => !!t.className)); n.extend("$block", { allowAttributes: "alignment" }); t.model.schema.setAttributeProperties("alignment", { isFormatting: true }); if (r) {
                t.conversion.attributeToAttribute(LC(i));
            }
            else {
                t.conversion.for("downcast").attributeToAttribute(NC(i));
            } const s = MC(i); for (const e of s) {
                t.conversion.for("upcast").attributeToAttribute(e);
            } const a = VC(i); for (const e of a) {
                t.conversion.for("upcast").attributeToAttribute(e);
            } t.commands.add("alignment", new RC(t)); }
        }
        function NC(t) { const e = { model: { key: "alignment", values: t.map((t => t.name)) }, view: {} }; for (const { name: n } of t) {
            e.view[n] = { key: "style", value: { "text-align": n } };
        } return e; }
        function MC(t) { const e = []; for (const { name: n } of t) {
            e.push({ view: { key: "style", value: { "text-align": n } }, model: { key: "alignment", value: n } });
        } return e; }
        function VC(t) { const e = []; for (const { name: n } of t) {
            e.push({ view: { key: "align", value: n }, model: { key: "alignment", value: n } });
        } return e; }
        function LC(t) { const e = { model: { key: "alignment", values: t.map((t => t.name)) }, view: {} }; for (const n of t) {
            e.view[n.name] = { key: "class", value: n.className };
        } return e; }
        const qC = new Map([["left", gb.alignLeft], ["right", gb.alignRight], ["center", gb.alignCenter], ["justify", gb.alignJustify]]);
        class KC extends Kn {
            get localizedOptionTitles() { const t = this.editor.t; return { left: t("Align left"), right: t("Align right"), center: t("Align center"), justify: t("Justify") }; }
            static get pluginName() { return "AlignmentUI"; }
            init() { const t = this.editor; const e = t.ui.componentFactory; const n = t.t; const o = BC(t.config.get("alignment.options")); o.map((t => t.name)).filter(TC).forEach((t => this._addButton(t))); e.add("alignment", (t => { const i = S_(t); const r = o.map((t => e.create(`alignment:${t.name}`))); T_(i, r); i.buttonView.set({ label: n("Text alignment"), tooltip: true }); i.toolbarView.isVertical = true; i.toolbarView.ariaLabel = n("Text alignment toolbar"); i.extendTemplate({ attributes: { class: "ck-alignment-dropdown" } }); const s = t.contentLanguageDirection === "rtl" ? qC.get("right") : qC.get("left"); i.buttonView.bind("icon").toMany(r, "isOn", ((...t) => { const e = t.findIndex((t => t)); if (e < 0) {
                return s;
            } return r[e].icon; })); i.bind("isEnabled").toMany(r, "isEnabled", ((...t) => t.some((t => t)))); return i; })); }
            _addButton(t) { const e = this.editor; e.ui.componentFactory.add(`alignment:${t}`, (n => { const o = e.commands.get("alignment"); const i = new mw(n); i.set({ label: this.localizedOptionTitles[t], icon: qC.get(t), tooltip: true, isToggleable: true }); i.bind("isEnabled").to(o); i.bind("isOn").to(o, "value", (e => e === t)); this.listenTo(i, "execute", (() => { e.execute("alignment", { value: t }); e.editing.view.focus(); })); return i; })); }
        }
        class jC extends Kn {
            static get requires() { return [zC, KC]; }
            static get pluginName() { return "Alignment"; }
        }
        function HC(t, e, n, o) { let i; let r = null; if (typeof o == "function") {
            i = o;
        }
        else {
            r = t.commands.get(o);
            i = () => { t.execute(o); };
        } t.model.document.on("change:data", ((s, a) => { if (r && !r.isEnabled || !e.isEnabled) {
            return;
        } const c = mf(t.model.document.selection.getRanges()); if (!c.isCollapsed) {
            return;
        } if (a.type == "transparent") {
            return;
        } const l = Array.from(t.model.document.differ.getChanges()); const d = l[0]; if (l.length != 1 || d.type !== "insert" || d.name != "$text" || d.length != 1) {
            return;
        } const u = d.position.parent; if (u.is("element", "codeBlock")) {
            return;
        } if (u.is("element", "listItem") && typeof o !== "function" && !["numberedList", "bulletedList", "todoList"].includes(o)) {
            return;
        } if (r && r.value === true) {
            return;
        } const h = u.getChild(0); const f = t.model.createRangeOn(h); if (!f.containsRange(c) && !c.end.isEqual(f.end)) {
            return;
        } const p = n.exec(h.data.substr(0, c.end.offset)); if (!p) {
            return;
        } t.model.enqueueChange((e => { const n = e.createPositionAt(u, 0); const o = e.createPositionAt(u, p[0].length); const r = new sp(n, o); const s = i({ match: p }); if (s !== false) {
            e.remove(r);
            const n = t.model.document.selection.getFirstRange();
            const o = e.createRangeIn(u);
            if (u.isEmpty && !o.isEqual(n) && !o.containsRange(n, true)) {
                e.remove(u);
            }
        } r.detach(); })); })); }
        function WC(t, e, n, o) { let i; let r; if (n instanceof RegExp) {
            i = n;
        }
        else {
            r = n;
        } r = r || (t => { let e; const n = []; const o = []; while ((e = i.exec(t)) !== null) {
            if (e && e.length < 4) {
                break;
            }
            let { index: t, 1: i, 2: r, 3: s } = e;
            const a = i + r + s;
            t += e[0].length - a.length;
            const c = [t, t + i.length];
            const l = [t + i.length + r.length, t + i.length + r.length + s.length];
            n.push(c);
            n.push(l);
            o.push([t + i.length, t + i.length + r.length]);
        } return { remove: n, format: o }; }); t.model.document.on("change:data", ((n, i) => { if (i.type == "transparent" || !e.isEnabled) {
            return;
        } const s = t.model; const a = s.document.selection; if (!a.isCollapsed) {
            return;
        } const c = Array.from(s.document.differ.getChanges()); const l = c[0]; if (c.length != 1 || l.type !== "insert" || l.name != "$text" || l.length != 1) {
            return;
        } const d = a.focus; const u = d.parent; const { text: h, range: f } = GC(s.createRange(s.createPositionAt(u, 0), d), s); const p = r(h); const g = $C(f.start, p.format, s); const m = $C(f.start, p.remove, s); if (!(g.length && m.length)) {
            return;
        } s.enqueueChange((t => { const e = o(t, g); if (e === false) {
            return;
        } for (const e of m.reverse()) {
            t.remove(e);
        } })); })); }
        function $C(t, e, n) { return e.filter((t => t[0] !== undefined && t[1] !== undefined)).map((e => n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1])))); }
        function GC(t, e) { let n = t.start; const o = Array.from(t.getItems()).reduce(((t, o) => { if (!(o.is("$text") || o.is("$textProxy")) || o.getAttribute("code")) {
            n = e.createPositionAfter(o);
            return "";
        } return t + o.data; }), ""); return { text: o, range: e.createRange(n, t.end) }; }
        class UC extends Kn {
            static get pluginName() { return "Autoformat"; }
            afterInit() { this._addListAutoformats(); this._addBasicStylesAutoformats(); this._addHeadingAutoformats(); this._addBlockQuoteAutoformats(); this._addCodeBlockAutoformats(); this._addHorizontalLineAutoformats(); }
            _addListAutoformats() { const t = this.editor.commands; if (t.get("bulletedList")) {
                HC(this.editor, this, /^[*-]\s$/, "bulletedList");
            } if (t.get("numberedList")) {
                HC(this.editor, this, /^1[.|)]\s$/, "numberedList");
            } if (t.get("todoList")) {
                HC(this.editor, this, /^\[\s?\]\s$/, "todoList");
            } if (t.get("checkTodoList")) {
                HC(this.editor, this, /^\[\s?x\s?\]\s$/, (() => { this.editor.execute("todoList"); this.editor.execute("checkTodoList"); }));
            } }
            _addBasicStylesAutoformats() { const t = this.editor.commands; if (t.get("bold")) {
                const t = JC(this.editor, "bold");
                WC(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t);
                WC(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t);
            } if (t.get("italic")) {
                const t = JC(this.editor, "italic");
                WC(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t);
                WC(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t);
            } if (t.get("code")) {
                const t = JC(this.editor, "code");
                WC(this.editor, this, /(`)([^`]+)(`)$/g, t);
            } if (t.get("strikethrough")) {
                const t = JC(this.editor, "strikethrough");
                WC(this.editor, this, /(~~)([^~]+)(~~)$/g, t);
            } }
            _addHeadingAutoformats() { const t = this.editor.commands.get("heading"); if (t) {
                t.modelElements.filter((t => t.match(/^heading[1-6]$/))).forEach((e => { const n = e[7]; const o = new RegExp(`^(#{${n}})\\s$`); HC(this.editor, this, o, (() => { if (!t.isEnabled || t.value === e) {
                    return false;
                } this.editor.execute("heading", { value: e }); })); }));
            } }
            _addBlockQuoteAutoformats() { if (this.editor.commands.get("blockQuote")) {
                HC(this.editor, this, /^>\s$/, "blockQuote");
            } }
            _addCodeBlockAutoformats() { if (this.editor.commands.get("codeBlock")) {
                HC(this.editor, this, /^```$/, "codeBlock");
            } }
            _addHorizontalLineAutoformats() { if (this.editor.commands.get("horizontalLine")) {
                HC(this.editor, this, /^---$/, "horizontalLine");
            } }
        }
        function JC(t, e) { return (n, o) => { const i = t.commands.get(e); if (!i.isEnabled) {
            return false;
        } const r = t.model.schema.getValidRanges(o, e); for (const t of r) {
            n.setAttribute(e, true, t);
        } n.removeSelectionAttribute(e); }; }
        class YC {
            constructor() { const t = new window.FileReader; this._reader = t; this._data = undefined; this.set("loaded", 0); t.onprogress = t => { this.loaded = t.loaded; }; }
            get error() { return this._reader.error; }
            get data() { return this._data; }
            read(t) { const e = this._reader; this.total = t.size; return new Promise(((n, o) => { e.onload = () => { const t = e.result; this._data = t; n(t); }; e.onerror = () => { o("error"); }; e.onabort = () => { o("aborted"); }; this._reader.readAsDataURL(t); })); }
            abort() { this._reader.abort(); }
        }
        qn(YC, Pn);
        class QC extends Kn {
            static get pluginName() { return "FileRepository"; }
            static get requires() { return [jk]; }
            init() { this.loaders = new ba; this.loaders.on("add", (() => this._updatePendingAction())); this.loaders.on("remove", (() => this._updatePendingAction())); this._loadersMap = new Map; this._pendingAction = null; this.set("uploaded", 0); this.set("uploadTotal", null); this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", ((t, e) => e ? t / e * 100 : 0)); }
            getLoader(t) { return this._loadersMap.get(t) || null; }
            createLoader(t) { if (!this.createUploadAdapter) {
                Object(u["b"])("filerepository-no-upload-adapter");
                return null;
            } const e = new XC(Promise.resolve(t), this.createUploadAdapter); this.loaders.add(e); this._loadersMap.set(t, e); if (t instanceof Promise) {
                e.file.then((t => { this._loadersMap.set(t, e); })).catch((() => { }));
            } e.on("change:uploaded", (() => { let t = 0; for (const e of this.loaders) {
                t += e.uploaded;
            } this.uploaded = t; })); e.on("change:uploadTotal", (() => { let t = 0; for (const e of this.loaders) {
                if (e.uploadTotal) {
                    t += e.uploadTotal;
                }
            } this.uploadTotal = t; })); return e; }
            destroyLoader(t) { const e = t instanceof XC ? t : this.getLoader(t); e._destroy(); this.loaders.remove(e); this._loadersMap.forEach(((t, n) => { if (t === e) {
                this._loadersMap.delete(n);
            } })); }
            _updatePendingAction() { const t = this.editor.plugins.get(jk); if (this.loaders.length) {
                if (!this._pendingAction) {
                    const e = this.editor.t;
                    const n = t => `${e("Upload in progress")} ${parseInt(t)}%.`;
                    this._pendingAction = t.add(n(this.uploadedPercent));
                    this._pendingAction.bind("message").to(this, "uploadedPercent", n);
                }
            }
            else {
                t.remove(this._pendingAction);
                this._pendingAction = null;
            } }
        }
        qn(QC, Pn);
        class XC {
            constructor(t, e) { this.id = a(); this._filePromiseWrapper = this._createFilePromiseWrapper(t); this._adapter = e(this); this._reader = new YC; this.set("status", "idle"); this.set("uploaded", 0); this.set("uploadTotal", null); this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", ((t, e) => e ? t / e * 100 : 0)); this.set("uploadResponse", null); }
            get file() { if (!this._filePromiseWrapper) {
                return Promise.resolve(null);
            }
            else {
                return this._filePromiseWrapper.promise.then((t => this._filePromiseWrapper ? t : null));
            } }
            get data() { return this._reader.data; }
            read() { if (this.status != "idle") {
                throw new u["a"]("filerepository-read-wrong-status", this);
            } this.status = "reading"; return this.file.then((t => this._reader.read(t))).then((t => { if (this.status !== "reading") {
                throw this.status;
            } this.status = "idle"; return t; })).catch((t => { if (t === "aborted") {
                this.status = "aborted";
                throw "aborted";
            } this.status = "error"; throw this._reader.error ? this._reader.error : t; })); }
            upload() { if (this.status != "idle") {
                throw new u["a"]("filerepository-upload-wrong-status", this);
            } this.status = "uploading"; return this.file.then((() => this._adapter.upload())).then((t => { this.uploadResponse = t; this.status = "idle"; return t; })).catch((t => { if (this.status === "aborted") {
                throw "aborted";
            } this.status = "error"; throw t; })); }
            abort() { const t = this.status; this.status = "aborted"; if (!this._filePromiseWrapper.isFulfilled) {
                this._filePromiseWrapper.promise.catch((() => { }));
                this._filePromiseWrapper.rejecter("aborted");
            }
            else if (t == "reading") {
                this._reader.abort();
            }
            else if (t == "uploading" && this._adapter.abort) {
                this._adapter.abort();
            } this._destroy(); }
            _destroy() { this._filePromiseWrapper = undefined; this._reader = undefined; this._adapter = undefined; this.uploadResponse = undefined; }
            _createFilePromiseWrapper(t) { const e = {}; e.promise = new Promise(((n, o) => { e.rejecter = o; e.isFulfilled = false; t.then((t => { e.isFulfilled = true; n(t); })).catch((t => { e.isFulfilled = true; o(t); })); })); return e; }
        }
        qn(XC, Pn);
        class ZC extends Kn {
            static get requires() { return [QC]; }
            static get pluginName() { return "Base64UploadAdapter"; }
            init() { this.editor.plugins.get(QC).createUploadAdapter = t => new ty(t); }
        }
        class ty {
            constructor(t) { this.loader = t; }
            upload() { return new Promise(((t, e) => { const n = this.reader = new window.FileReader; n.addEventListener("load", (() => { t({ default: n.result }); })); n.addEventListener("error", (t => { e(t); })); n.addEventListener("abort", (() => { e(); })); this.loader.file.then((t => { n.readAsDataURL(t); })); })); }
            abort() { this.reader.abort(); }
        }
        function* ey(t, e) { for (const n of e) {
            if (n && t.getAttributeProperties(n[0]).copyOnEnter) {
                yield n;
            }
        } }
        class ny extends Hn {
            execute() { const t = this.editor.model; const e = t.document; t.change((n => { oy(this.editor.model, n, e.selection, t.schema); this.fire("afterExecute", { writer: n }); })); }
        }
        function oy(t, e, n, o) { const i = n.isCollapsed; const r = n.getFirstRange(); const s = r.start.parent; const a = r.end.parent; if (o.isLimit(s) || o.isLimit(a)) {
            if (!i && s == a) {
                t.deleteContent(n);
            }
            return;
        } if (i) {
            const t = ey(e.model.schema, n.getAttributes());
            iy(e, r.start);
            e.setSelectionAttribute(t);
        }
        else {
            const o = !(r.start.isAtStart && r.end.isAtEnd);
            const i = s == a;
            t.deleteContent(n, { leaveUnmerged: o });
            if (o) {
                if (i) {
                    iy(e, n.focus);
                }
                else {
                    e.setSelection(a, 0);
                }
            }
        } }
        function iy(t, e) { t.split(e); t.setSelection(e.parent.nextSibling, 0); }
        class ry extends Cu {
            constructor(t) { super(t); const e = this.document; e.on("keydown", ((t, n) => { if (this.isEnabled && n.keyCode == td.enter) {
                const o = new Dl(e, "enter", e.selection.getFirstRange());
                e.fire(o, new yh(e, n.domEvent, { isSoft: n.shiftKey }));
                if (o.stop.called) {
                    t.stop();
                }
            } })); }
            observe() { }
        }
        class sy extends Kn {
            static get pluginName() { return "Enter"; }
            init() { const t = this.editor; const e = t.editing.view; const n = e.document; e.addObserver(ry); t.commands.add("enter", new ny(t)); this.listenTo(n, "enter", ((n, o) => { o.preventDefault(); if (o.isSoft) {
                return;
            } t.execute("enter"); e.scrollToTheSelection(); }), { priority: "low" }); }
        }
        class ay extends Hn {
            execute() { const t = this.editor.model; const e = t.document; t.change((n => { ly(t, n, e.selection); this.fire("afterExecute", { writer: n }); })); }
            refresh() { const t = this.editor.model; const e = t.document; this.isEnabled = cy(t.schema, e.selection); }
        }
        function cy(t, e) { if (e.rangeCount > 1) {
            return false;
        } const n = e.anchor; if (!n || !t.checkChild(n, "softBreak")) {
            return false;
        } const o = e.getFirstRange(); const i = o.start.parent; const r = o.end.parent; if ((uy(i, t) || uy(r, t)) && i !== r) {
            return false;
        } return true; }
        function ly(t, e, n) { const o = n.isCollapsed; const i = n.getFirstRange(); const r = i.start.parent; const s = i.end.parent; const a = r == s; if (o) {
            const o = ey(t.schema, n.getAttributes());
            dy(t, e, i.end);
            e.removeSelectionAttribute(n.getAttributeKeys());
            e.setSelectionAttribute(o);
        }
        else {
            const o = !(i.start.isAtStart && i.end.isAtEnd);
            t.deleteContent(n, { leaveUnmerged: o });
            if (a) {
                dy(t, e, n.focus);
            }
            else {
                if (o) {
                    e.setSelection(s, 0);
                }
            }
        } }
        function dy(t, e, n) { const o = e.createElement("softBreak"); t.insertContent(o, n); e.setSelection(o, "after"); }
        function uy(t, e) { if (t.is("rootElement")) {
            return false;
        } return e.isLimit(t) || uy(t.parent, e); }
        class hy extends Kn {
            static get pluginName() { return "ShiftEnter"; }
            init() { const t = this.editor; const e = t.model.schema; const n = t.conversion; const o = t.editing.view; const i = o.document; e.register("softBreak", { allowWhere: "$text", isInline: true }); n.for("upcast").elementToElement({ model: "softBreak", view: "br" }); n.for("downcast").elementToElement({ model: "softBreak", view: (t, { writer: e }) => e.createEmptyElement("br") }); o.addObserver(ry); t.commands.add("shiftEnter", new ay(t)); this.listenTo(i, "enter", ((e, n) => { n.preventDefault(); if (!n.isSoft) {
                return;
            } t.execute("shiftEnter"); o.scrollToTheSelection(); }), { priority: "low" }); }
        }
        class fy {
            constructor(t, e = 20) { this.model = t; this.size = 0; this.limit = e; this.isLocked = false; this._changeCallback = (t, e) => { if (e.type != "transparent" && e !== this._batch) {
                this._reset(true);
            } }; this._selectionChangeCallback = () => { this._reset(); }; this.model.document.on("change", this._changeCallback); this.model.document.selection.on("change:range", this._selectionChangeCallback); this.model.document.selection.on("change:attribute", this._selectionChangeCallback); }
            get batch() { if (!this._batch) {
                this._batch = this.model.createBatch();
            } return this._batch; }
            input(t) { this.size += t; if (this.size >= this.limit) {
                this._reset(true);
            } }
            lock() { this.isLocked = true; }
            unlock() { this.isLocked = false; }
            destroy() { this.model.document.off("change", this._changeCallback); this.model.document.selection.off("change:range", this._selectionChangeCallback); this.model.document.selection.off("change:attribute", this._selectionChangeCallback); }
            _reset(t) { if (!this.isLocked || t) {
                this._batch = null;
                this.size = 0;
            } }
        }
        class py extends Hn {
            constructor(t, e) { super(t); this._buffer = new fy(t.model, e); this._batches = new WeakSet; }
            get buffer() { return this._buffer; }
            destroy() { super.destroy(); this._buffer.destroy(); }
            execute(t = {}) { const e = this.editor.model; const n = e.document; const o = t.text || ""; const i = o.length; const r = t.range ? e.createSelection(t.range) : n.selection; const s = t.resultRange; e.enqueueChange(this._buffer.batch, (t => { this._buffer.lock(); this._batches.add(this._buffer.batch); e.deleteContent(r); if (o) {
                e.insertContent(t.createText(o, n.selection.getAttributes()), r);
            } if (s) {
                t.setSelection(s);
            }
            else if (!r.is("documentSelection")) {
                t.setSelection(r);
            } this._buffer.unlock(); this._buffer.input(i); })); }
        }
        function gy(t) { let e = null; const n = t.model; const o = t.editing.view; const i = t.commands.get("input"); if (Wl.isAndroid) {
            o.document.on("beforeinput", ((t, e) => r(e)), { priority: "lowest" });
        }
        else {
            o.document.on("keydown", ((t, e) => r(e)), { priority: "lowest" });
        } o.document.on("compositionstart", s, { priority: "lowest" }); o.document.on("compositionend", (() => { e = n.createSelection(n.document.selection); }), { priority: "lowest" }); function r(t) { const r = n.document; const s = o.document.isComposing; const c = e && e.isEqual(r.selection); e = null; if (!i.isEnabled) {
            return;
        } if (ky(t) || r.selection.isCollapsed) {
            return;
        } if (s && t.keyCode === 229) {
            return;
        } if (!s && t.keyCode === 229 && c) {
            return;
        } a(); } function s() { const t = n.document; const e = t.selection.rangeCount === 1 ? t.selection.getFirstRange().isFlat : true; if (t.selection.isCollapsed || e) {
            return;
        } a(); } function a() { const t = i.buffer; t.lock(); const e = t.batch; i._batches.add(e); n.enqueueChange(e, (() => { n.deleteContent(n.document.selection); })); t.unlock(); } }
        const my = [nd("arrowUp"), nd("arrowRight"), nd("arrowDown"), nd("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];
        for (let t = 112; t <= 135; t++) {
            my.push(t);
        }
        function ky(t) { if (t.ctrlKey || t.metaKey) {
            return true;
        } return my.includes(t.keyCode); }
        function by(t, e) { const n = []; let o = 0; let i; t.forEach((t => { if (t == "equal") {
            r();
            o++;
        }
        else if (t == "insert") {
            if (s("insert")) {
                i.values.push(e[o]);
            }
            else {
                r();
                i = { type: "insert", index: o, values: [e[o]] };
            }
            o++;
        }
        else {
            if (s("delete")) {
                i.howMany++;
            }
            else {
                r();
                i = { type: "delete", index: o, howMany: 1 };
            }
        } })); r(); return n; function r() { if (i) {
            n.push(i);
            i = null;
        } } function s(t) { return i && i.type == t; } }
        function wy(t) { if (t.length == 0) {
            return false;
        } for (const e of t) {
            if (e.type === "children" && !_y(e)) {
                return true;
            }
        } return false; }
        function _y(t) { if (t.newChildren.length - t.oldChildren.length != 1) {
            return;
        } const e = Ud(t.oldChildren, t.newChildren, vy); const n = by(e, t.newChildren); if (n.length > 1) {
            return;
        } const o = n[0]; if (!(!!o.values[0] && o.values[0].is("$text"))) {
            return;
        } return o; }
        function vy(t, e) { if (!!t && t.is("$text") && !!e && e.is("$text")) {
            return t.data === e.data;
        }
        else {
            return t === e;
        } }
        function Ay(t) { t.editing.view.document.on("mutations", ((e, n, o) => { new Cy(t).handle(n, o); })); }
        class Cy {
            constructor(t) { this.editor = t; this.editing = this.editor.editing; }
            handle(t, e) { if (wy(t)) {
                this._handleContainerChildrenMutations(t, e);
            }
            else {
                for (const n of t) {
                    this._handleTextMutation(n, e);
                    this._handleTextNodeInsertion(n);
                }
            } }
            _handleContainerChildrenMutations(t, e) { const n = yy(t); if (!n) {
                return;
            } const o = this.editor.editing.view.domConverter; const i = o.mapViewToDom(n); const r = new fu(this.editor.editing.view.document); const s = this.editor.data.toModel(r.domToView(i)).getChild(0); const a = this.editor.editing.mapper.toModelElement(n); if (!a) {
                return;
            } const c = Array.from(s.getChildren()); const l = Array.from(a.getChildren()); const d = c[c.length - 1]; const u = l[l.length - 1]; const h = d && d.is("element", "softBreak"); const f = u && !u.is("element", "softBreak"); if (h && f) {
                c.pop();
            } const p = this.editor.model.schema; if (!xy(c, p) || !xy(l, p)) {
                return;
            } const g = c.map((t => t.is("$text") ? t.data : "@")).join("").replace(/\u00A0/g, " "); const m = l.map((t => t.is("$text") ? t.data : "@")).join("").replace(/\u00A0/g, " "); if (m === g) {
                return;
            } const k = Ud(m, g); const { firstChangeAt: b, insertions: w, deletions: _ } = Ey(k); let v = null; if (e) {
                v = this.editing.mapper.toModelRange(e.getFirstRange());
            } const A = g.substr(b, w); const C = this.editor.model.createRange(this.editor.model.createPositionAt(a, b), this.editor.model.createPositionAt(a, b + _)); this.editor.execute("input", { text: A, range: C, resultRange: v }); }
            _handleTextMutation(t, e) { if (t.type != "text") {
                return;
            } const n = t.newText.replace(/\u00A0/g, " "); const o = t.oldText.replace(/\u00A0/g, " "); if (o === n) {
                return;
            } const i = Ud(o, n); const { firstChangeAt: r, insertions: s, deletions: a } = Ey(i); let c = null; if (e) {
                c = this.editing.mapper.toModelRange(e.getFirstRange());
            } const l = this.editing.view.createPositionAt(t.node, r); const d = this.editing.mapper.toModelPosition(l); const u = this.editor.model.createRange(d, d.getShiftedBy(a)); const h = n.substr(r, s); this.editor.execute("input", { text: h, range: u, resultRange: c }); }
            _handleTextNodeInsertion(t) { if (t.type != "children") {
                return;
            } const e = _y(t); const n = this.editing.view.createPositionAt(t.node, e.index); const o = this.editing.mapper.toModelPosition(n); const i = e.values[0].data; this.editor.execute("input", { text: i.replace(/\u00A0/g, " "), range: this.editor.model.createRange(o) }); }
        }
        function yy(t) { const e = t.map((t => t.node)).reduce(((t, e) => t.getCommonAncestor(e, { includeSelf: true }))); if (!e) {
            return;
        } return e.getAncestors({ includeSelf: true, parentFirst: true }).find((t => t.is("containerElement") || t.is("rootElement"))); }
        function xy(t, e) { return t.every((t => e.isInline(t))); }
        function Ey(t) { let e = null; let n = null; for (let o = 0; o < t.length; o++) {
            const i = t[o];
            if (i != "equal") {
                e = e === null ? o : e;
                n = o;
            }
        } let o = 0; let i = 0; for (let r = e; r <= n; r++) {
            if (t[r] != "insert") {
                o++;
            }
            if (t[r] != "delete") {
                i++;
            }
        } return { insertions: i, deletions: o, firstChangeAt: e }; }
        class Dy extends Kn {
            static get pluginName() { return "Input"; }
            init() { const t = this.editor; const e = new py(t, t.config.get("typing.undoStep") || 20); t.commands.add("input", e); gy(t); Ay(t); }
            isInput(t) { const e = this.editor.commands.get("input"); return e._batches.has(t); }
        }
        class Sy extends Hn {
            constructor(t, e) { super(t); this.direction = e; this._buffer = new fy(t.model, t.config.get("typing.undoStep")); }
            get buffer() { return this._buffer; }
            execute(t = {}) { const e = this.editor.model; const n = e.document; e.enqueueChange(this._buffer.batch, (o => { this._buffer.lock(); const i = o.createSelection(t.selection || n.selection); const r = t.sequence || 1; const s = i.isCollapsed; if (i.isCollapsed) {
                e.modifySelection(i, { direction: this.direction, unit: t.unit });
            } if (this._shouldEntireContentBeReplacedWithParagraph(r)) {
                this._replaceEntireContentWithParagraph(o);
                return;
            } if (this._shouldReplaceFirstBlockWithParagraph(i, r)) {
                this.editor.execute("paragraph", { selection: i });
                return;
            } if (i.isCollapsed) {
                return;
            } let a = 0; i.getFirstRange().getMinimalFlatRanges().forEach((t => { a += yl(t.getWalker({ singleCharacters: true, ignoreElementEnd: true, shallow: true })); })); e.deleteContent(i, { doNotResetEntireContent: s, direction: this.direction }); this._buffer.input(a); o.setSelection(i); this._buffer.unlock(); })); }
            _shouldEntireContentBeReplacedWithParagraph(t) { if (t > 1) {
                return false;
            } const e = this.editor.model; const n = e.document; const o = n.selection; const i = e.schema.getLimitElement(o); const r = o.isCollapsed && o.containsEntireContent(i); if (!r) {
                return false;
            } if (!e.schema.checkChild(i, "paragraph")) {
                return false;
            } const s = i.getChild(0); if (s && s.name === "paragraph") {
                return false;
            } return true; }
            _replaceEntireContentWithParagraph(t) { const e = this.editor.model; const n = e.document; const o = n.selection; const i = e.schema.getLimitElement(o); const r = t.createElement("paragraph"); t.remove(t.createRangeIn(i)); t.insert(r, i); t.setSelection(r, 0); }
            _shouldReplaceFirstBlockWithParagraph(t, e) { const n = this.editor.model; if (e > 1 || this.direction != "backward") {
                return false;
            } if (!t.isCollapsed) {
                return false;
            } const o = t.getFirstPosition(); const i = n.schema.getLimitElement(o); const r = i.getChild(0); if (o.parent != r) {
                return false;
            } if (!t.containsEntireContent(r)) {
                return false;
            } if (!n.schema.checkChild(i, "paragraph")) {
                return false;
            } if (r.name == "paragraph") {
                return false;
            } return true; }
        }
        class Ty extends Cu {
            constructor(t) { super(t); const e = t.document; let n = 0; e.on("keyup", ((t, e) => { if (e.keyCode == td.delete || e.keyCode == td.backspace) {
                n = 0;
            } })); e.on("keydown", ((t, e) => { const i = {}; if (e.keyCode == td.delete) {
                i.direction = "forward";
                i.unit = "character";
            }
            else if (e.keyCode == td.backspace) {
                i.direction = "backward";
                i.unit = "codePoint";
            }
            else {
                return;
            } const r = Wl.isMac ? e.altKey : e.ctrlKey; i.unit = r ? "word" : i.unit; i.sequence = ++n; o(t, e.domEvent, i); })); if (Wl.isAndroid) {
                e.on("beforeinput", ((e, n) => { if (n.domEvent.inputType != "deleteContentBackward") {
                    return;
                } const i = { unit: "codepoint", direction: "backward", sequence: 1 }; const r = n.domTarget.ownerDocument.defaultView.getSelection(); if (r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset) {
                    i.selectionToRemove = t.domConverter.domSelectionToView(r);
                } o(e, n.domEvent, i); }));
            } function o(t, n, o) { const i = new Dl(e, "delete", e.selection.getFirstRange()); e.fire(i, new yh(e, n, o)); if (i.stop.called) {
                t.stop();
            } } }
            observe() { }
        }
        class Py extends Kn {
            static get pluginName() { return "Delete"; }
            init() { const t = this.editor; const e = t.editing.view; const n = e.document; e.addObserver(Ty); const o = new Sy(t, "forward"); t.commands.add("deleteForward", o); t.commands.add("forwardDelete", o); t.commands.add("delete", new Sy(t, "backward")); this.listenTo(n, "delete", ((n, o) => { const i = { unit: o.unit, sequence: o.sequence }; if (o.selectionToRemove) {
                const e = t.model.createSelection();
                const n = [];
                for (const e of o.selectionToRemove.getRanges()) {
                    n.push(t.editing.mapper.toModelRange(e));
                }
                e.setTo(n);
                i.selection = e;
            } t.execute(o.direction == "forward" ? "deleteForward" : "delete", i); o.preventDefault(); e.scrollToTheSelection(); }), { priority: "low" }); if (Wl.isAndroid) {
                let t = null;
                this.listenTo(n, "delete", ((e, n) => { const o = n.domTarget.ownerDocument.defaultView.getSelection(); t = { anchorNode: o.anchorNode, anchorOffset: o.anchorOffset, focusNode: o.focusNode, focusOffset: o.focusOffset }; }), { priority: "lowest" });
                this.listenTo(n, "keyup", ((e, n) => { if (t) {
                    const e = n.domTarget.ownerDocument.defaultView.getSelection();
                    e.collapse(t.anchorNode, t.anchorOffset);
                    e.extend(t.focusNode, t.focusOffset);
                    t = null;
                } }));
            } }
        }
        class By extends Kn {
            static get requires() { return [Dy, Py]; }
            static get pluginName() { return "Typing"; }
        }
        function Iy(t, e) { let n = t.start; const o = Array.from(t.getItems()).reduce(((t, o) => { if (!(o.is("$text") || o.is("$textProxy"))) {
            n = e.createPositionAfter(o);
            return "";
        } return t + o.data; }), ""); return { text: o, range: e.createRange(n, t.end) }; }
        class Ry {
            constructor(t, e) { this.model = t; this.testCallback = e; this.hasMatch = false; this.set("isEnabled", true); this.on("change:isEnabled", (() => { if (this.isEnabled) {
                this._startListening();
            }
            else {
                this.stopListening(t.document.selection);
                this.stopListening(t.document);
            } })); this._startListening(); }
            _startListening() { const t = this.model; const e = t.document; this.listenTo(e.selection, "change:range", ((t, { directChange: n }) => { if (!n) {
                return;
            } if (!e.selection.isCollapsed) {
                if (this.hasMatch) {
                    this.fire("unmatched");
                    this.hasMatch = false;
                }
                return;
            } this._evaluateTextBeforeSelection("selection"); })); this.listenTo(e, "change:data", ((t, e) => { if (e.type == "transparent") {
                return;
            } this._evaluateTextBeforeSelection("data", { batch: e }); })); }
            _evaluateTextBeforeSelection(t, e = {}) { const n = this.model; const o = n.document; const i = o.selection; const r = n.createRange(n.createPositionAt(i.focus.parent, 0), i.focus); const { text: s, range: a } = Iy(r, n); const c = this.testCallback(s); if (!c && this.hasMatch) {
                this.fire("unmatched");
            } this.hasMatch = !!c; if (c) {
                const n = Object.assign(e, { text: s, range: a });
                if (typeof c == "object") {
                    Object.assign(n, c);
                }
                this.fire(`matched:${t}`, n);
            } }
        }
        qn(Ry, Pn);
        class Fy extends Kn {
            static get pluginName() { return "TwoStepCaretMovement"; }
            constructor(t) { super(t); this.attributes = new Set; this._overrideUid = null; }
            init() { const t = this.editor; const e = t.model; const n = t.editing.view; const o = t.locale; const i = e.document.selection; this.listenTo(n.document, "arrowKey", ((t, e) => { if (!i.isCollapsed) {
                return;
            } if (e.shiftKey || e.altKey || e.ctrlKey) {
                return;
            } const n = e.keyCode == td.arrowright; const r = e.keyCode == td.arrowleft; if (!n && !r) {
                return;
            } const s = o.contentLanguageDirection; let a = false; if (s === "ltr" && n || s === "rtl" && r) {
                a = this._handleForwardMovement(e);
            }
            else {
                a = this._handleBackwardMovement(e);
            } if (a === true) {
                t.stop();
            } }), { context: "$text", priority: "highest" }); this._isNextGravityRestorationSkipped = false; this.listenTo(i, "change:range", ((t, e) => { if (this._isNextGravityRestorationSkipped) {
                this._isNextGravityRestorationSkipped = false;
                return;
            } if (!this._isGravityOverridden) {
                return;
            } if (!e.directChange && Vy(i.getFirstPosition(), this.attributes)) {
                return;
            } this._restoreGravity(); })); }
            registerAttribute(t) { this.attributes.add(t); }
            _handleForwardMovement(t) { const e = this.attributes; const n = this.editor.model; const o = n.document.selection; const i = o.getFirstPosition(); if (this._isGravityOverridden) {
                return false;
            } if (i.isAtStart && Oy(o, e)) {
                return false;
            } if (Vy(i, e)) {
                Ny(t);
                this._overrideGravity();
                return true;
            } }
            _handleBackwardMovement(t) { const e = this.attributes; const n = this.editor.model; const o = n.document.selection; const i = o.getFirstPosition(); if (this._isGravityOverridden) {
                Ny(t);
                this._restoreGravity();
                zy(n, e, i);
                return true;
            }
            else {
                if (i.isAtStart) {
                    if (Oy(o, e)) {
                        Ny(t);
                        zy(n, e, i);
                        return true;
                    }
                    return false;
                }
                if (My(i, e)) {
                    if (i.isAtEnd && !Oy(o, e) && Vy(i, e)) {
                        Ny(t);
                        zy(n, e, i);
                        return true;
                    }
                    this._isNextGravityRestorationSkipped = true;
                    this._overrideGravity();
                    return false;
                }
            } }
            get _isGravityOverridden() { return !!this._overrideUid; }
            _overrideGravity() { this._overrideUid = this.editor.model.change((t => t.overrideSelectionGravity())); }
            _restoreGravity() { this.editor.model.change((t => { t.restoreSelectionGravity(this._overrideUid); this._overrideUid = null; })); }
        }
        function Oy(t, e) { for (const n of e) {
            if (t.hasAttribute(n)) {
                return true;
            }
        } return false; }
        function zy(t, e, n) { const o = n.nodeBefore; t.change((t => { if (o) {
            t.setSelectionAttribute(o.getAttributes());
        }
        else {
            t.removeSelectionAttribute(e);
        } })); }
        function Ny(t) { t.preventDefault(); }
        function My(t, e) { const n = t.getShiftedBy(-1); return Vy(n, e); }
        function Vy(t, e) { const { nodeBefore: n, nodeAfter: o } = t; for (const t of e) {
            const e = n ? n.getAttribute(t) : undefined;
            const i = o ? o.getAttribute(t) : undefined;
            if (i !== e) {
                return true;
            }
        } return false; }
        var Ly = /[\\^$.*+?()[\]{}|]/g, qy = RegExp(Ly.source);
        function Ky(t) { t = bc(t); return t && qy.test(t) ? t.replace(Ly, "\\$&") : t; }
        var jy = Ky;
        const Hy = { copyright: { from: "(c)", to: "©" }, registeredTrademark: { from: "(r)", to: "®" }, trademark: { from: "(tm)", to: "™" }, oneHalf: { from: "1/2", to: "½" }, oneThird: { from: "1/3", to: "⅓" }, twoThirds: { from: "2/3", to: "⅔" }, oneForth: { from: "1/4", to: "¼" }, threeQuarters: { from: "3/4", to: "¾" }, lessThanOrEqual: { from: "<=", to: "≤" }, greaterThanOrEqual: { from: ">=", to: "≥" }, notEqual: { from: "!=", to: "≠" }, arrowLeft: { from: "<-", to: "←" }, arrowRight: { from: "->", to: "→" }, horizontalEllipsis: { from: "...", to: "…" }, enDash: { from: /(^| )(--)( )$/, to: [null, "–", null] }, emDash: { from: /(^| )(---)( )$/, to: [null, "—", null] }, quotesPrimary: { from: Qy('"'), to: [null, "“", null, "”"] }, quotesSecondary: { from: Qy("'"), to: [null, "‘", null, "’"] }, quotesPrimaryEnGb: { from: Qy("'"), to: [null, "‘", null, "’"] }, quotesSecondaryEnGb: { from: Qy('"'), to: [null, "“", null, "”"] }, quotesPrimaryPl: { from: Qy('"'), to: [null, "„", null, "”"] }, quotesSecondaryPl: { from: Qy("'"), to: [null, "‚", null, "’"] } };
        const Wy = { symbols: ["copyright", "registeredTrademark", "trademark"], mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"], typography: ["horizontalEllipsis", "enDash", "emDash"], quotes: ["quotesPrimary", "quotesSecondary"] };
        const $y = ["symbols", "mathematical", "typography", "quotes"];
        class Gy extends Kn {
            static get pluginName() { return "TextTransformation"; }
            constructor(t) { super(t); t.config.define("typing", { transformations: { include: $y } }); }
            init() { const t = this.editor.model; const e = t.document.selection; e.on("change:range", (() => { this.isEnabled = !e.anchor.parent.is("element", "codeBlock"); })); this._enableTransformationWatchers(); }
            _enableTransformationWatchers() { const t = this.editor; const e = t.model; const n = t.plugins.get("Input"); const o = Xy(t.config.get("typing.transformations")); const i = t => { for (const e of o) {
                const n = e.from;
                const o = n.test(t);
                if (o) {
                    return { normalizedTransformation: e };
                }
            } }; const r = (t, o) => { if (!n.isInput(o.batch)) {
                return;
            } const { from: i, to: r } = o.normalizedTransformation; const s = i.exec(o.text); const a = r(s.slice(1)); const c = o.range; let l = s.index; e.enqueueChange((t => { for (let n = 1; n < s.length; n++) {
                const o = s[n];
                const i = a[n - 1];
                if (i == null) {
                    l += o.length;
                    continue;
                }
                const r = c.start.getShiftedBy(l);
                const d = e.createRange(r, r.getShiftedBy(o.length));
                const u = Yy(r);
                e.insertContent(t.createText(i, u), d);
                l += i.length;
            } })); }; const s = new Ry(t.model, i); s.on("matched:data", r); s.bind("isEnabled").to(this); }
        }
        function Uy(t) { if (typeof t == "string") {
            return new RegExp(`(${jy(t)})$`);
        } return t; }
        function Jy(t) { if (typeof t == "string") {
            return () => [t];
        }
        else if (t instanceof Array) {
            return () => t;
        } return t; }
        function Yy(t) { const e = t.textNode ? t.textNode : t.nodeAfter; return e.getAttributes(); }
        function Qy(t) { return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`); }
        function Xy(t) { const e = t.extra || []; const n = t.remove || []; const o = t => !n.includes(t); const i = t.include.concat(e).filter(o); return Zy(i).filter(o).map((t => Hy[t] || t)).map((t => ({ from: Uy(t.from), to: Jy(t.to) }))); }
        function Zy(t) { const e = new Set; for (const n of t) {
            if (Wy[n]) {
                for (const t of Wy[n]) {
                    e.add(t);
                }
            }
            else {
                e.add(n);
            }
        } return Array.from(e); }
        function tx(t, e, n, o) { return o.createRange(ex(t, e, n, true, o), ex(t, e, n, false, o)); }
        function ex(t, e, n, o, i) { let r = t.textNode || (o ? t.nodeBefore : t.nodeAfter); let s = null; while (r && r.getAttribute(e) == n) {
            s = r;
            r = o ? r.previousSibling : r.nextSibling;
        } return s ? i.createPositionAt(s, o ? "before" : "after") : t; }
        function nx(t, e, n, o) { const i = t.editing.view; const r = new Set; i.document.registerPostFixer((i => { const s = t.model.document.selection; let a = false; if (s.hasAttribute(e)) {
            const c = tx(s.getFirstPosition(), e, s.getAttribute(e), t.model);
            const l = t.editing.mapper.toViewRange(c);
            for (const t of l.getItems()) {
                if (t.is("element", n) && !t.hasClass(o)) {
                    i.addClass(o, t);
                    r.add(t);
                    a = true;
                }
            }
        } return a; })); t.conversion.for("editingDowncast").add((t => { t.on("insert", e, { priority: "highest" }); t.on("remove", e, { priority: "highest" }); t.on("attribute", e, { priority: "highest" }); t.on("selection", e, { priority: "highest" }); function e() { i.change((t => { for (const e of r.values()) {
            t.removeClass(o, e);
            r.delete(e);
        } })); } })); }
        class ox extends Hn {
            refresh() { this.value = this._getValue(); this.isEnabled = this._checkEnabled(); }
            execute(t = {}) { const e = this.editor.model; const n = e.schema; const o = e.document.selection; const i = Array.from(o.getSelectedBlocks()); const r = t.forceValue === undefined ? !this.value : t.forceValue; e.change((t => { if (!r) {
                this._removeQuote(t, i.filter(ix));
            }
            else {
                const e = i.filter((t => ix(t) || sx(n, t)));
                this._applyQuote(t, e);
            } })); }
            _getValue() { const t = this.editor.model.document.selection; const e = mf(t.getSelectedBlocks()); return !!(e && ix(e)); }
            _checkEnabled() { if (this.value) {
                return true;
            } const t = this.editor.model.document.selection; const e = this.editor.model.schema; const n = mf(t.getSelectedBlocks()); if (!n) {
                return false;
            } return sx(e, n); }
            _removeQuote(t, e) { rx(t, e).reverse().forEach((e => { if (e.start.isAtStart && e.end.isAtEnd) {
                t.unwrap(e.start.parent);
                return;
            } if (e.start.isAtStart) {
                const n = t.createPositionBefore(e.start.parent);
                t.move(e, n);
                return;
            } if (!e.end.isAtEnd) {
                t.split(e.end);
            } const n = t.createPositionAfter(e.end.parent); t.move(e, n); })); }
            _applyQuote(t, e) { const n = []; rx(t, e).reverse().forEach((e => { let o = ix(e.start); if (!o) {
                o = t.createElement("blockQuote");
                t.wrap(e, o);
            } n.push(o); })); n.reverse().reduce(((e, n) => { if (e.nextSibling == n) {
                t.merge(t.createPositionAfter(e));
                return e;
            } return n; })); }
        }
        function ix(t) { return t.parent.name == "blockQuote" ? t.parent : null; }
        function rx(t, e) { let n; let o = 0; const i = []; while (o < e.length) {
            const r = e[o];
            const s = e[o + 1];
            if (!n) {
                n = t.createPositionBefore(r);
            }
            if (!s || r.nextSibling != s) {
                i.push(t.createRange(n, t.createPositionAfter(r)));
                n = null;
            }
            o++;
        } return i; }
        function sx(t, e) { const n = t.checkChild(e.parent, "blockQuote"); const o = t.checkChild(["$root", "blockQuote"], e); return n && o; }
        class ax extends Kn {
            static get pluginName() { return "BlockQuoteEditing"; }
            static get requires() { return [sy, Py]; }
            init() { const t = this.editor; const e = t.model.schema; t.commands.add("blockQuote", new ox(t)); e.register("blockQuote", { allowWhere: "$block", allowContentOf: "$root" }); t.conversion.elementToElement({ model: "blockQuote", view: "blockquote" }); t.model.document.registerPostFixer((n => { const o = t.model.document.differ.getChanges(); for (const t of o) {
                if (t.type == "insert") {
                    const o = t.position.nodeAfter;
                    if (!o) {
                        continue;
                    }
                    if (o.is("element", "blockQuote") && o.isEmpty) {
                        n.remove(o);
                        return true;
                    }
                    else if (o.is("element", "blockQuote") && !e.checkChild(t.position, o)) {
                        n.unwrap(o);
                        return true;
                    }
                    else if (o.is("element")) {
                        const t = n.createRangeIn(o);
                        for (const o of t.getItems()) {
                            if (o.is("element", "blockQuote") && !e.checkChild(n.createPositionBefore(o), o)) {
                                n.unwrap(o);
                                return true;
                            }
                        }
                    }
                }
                else if (t.type == "remove") {
                    const e = t.position.parent;
                    if (e.is("element", "blockQuote") && e.isEmpty) {
                        n.remove(e);
                        return true;
                    }
                }
            } return false; })); const n = this.editor.editing.view.document; const o = t.model.document.selection; const i = t.commands.get("blockQuote"); this.listenTo(n, "enter", ((e, n) => { if (!o.isCollapsed || !i.value) {
                return;
            } const r = o.getLastPosition().parent; if (r.isEmpty) {
                t.execute("blockQuote");
                t.editing.view.scrollToTheSelection();
                n.preventDefault();
                e.stop();
            } }), { context: "blockquote" }); this.listenTo(n, "delete", ((e, n) => { if (n.direction != "backward" || !o.isCollapsed || !i.value) {
                return;
            } const r = o.getLastPosition().parent; if (r.isEmpty && !r.previousSibling) {
                t.execute("blockQuote");
                t.editing.view.scrollToTheSelection();
                n.preventDefault();
                e.stop();
            } }), { context: "blockquote" }); }
        }
        var cx = n(36);
        var lx = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        lx.insert = "head";
        lx.singleton = true;
        var dx = Ab()(cx["a"], lx);
        var ux = cx["a"].locals || {};
        class hx extends Kn {
            static get pluginName() { return "BlockQuoteUI"; }
            init() { const t = this.editor; const e = t.t; t.ui.componentFactory.add("blockQuote", (n => { const o = t.commands.get("blockQuote"); const i = new mw(n); i.set({ label: e("Block quote"), icon: gb.quote, tooltip: true, isToggleable: true }); i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"); this.listenTo(i, "execute", (() => { t.execute("blockQuote"); t.editing.view.focus(); })); return i; })); }
        }
        class fx extends Kn {
            static get requires() { return [ax, hx]; }
            static get pluginName() { return "BlockQuote"; }
        }
        class px extends Hn {
            constructor(t, e) { super(t); this.attributeKey = e; }
            refresh() { const t = this.editor.model; const e = t.document; this.value = this._getValueFromFirstAllowedNode(); this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey); }
            execute(t = {}) { const e = this.editor.model; const n = e.document; const o = n.selection; const i = t.forceValue === undefined ? !this.value : t.forceValue; e.change((t => { if (o.isCollapsed) {
                if (i) {
                    t.setSelectionAttribute(this.attributeKey, true);
                }
                else {
                    t.removeSelectionAttribute(this.attributeKey);
                }
            }
            else {
                const n = e.schema.getValidRanges(o.getRanges(), this.attributeKey);
                for (const e of n) {
                    if (i) {
                        t.setAttribute(this.attributeKey, i, e);
                    }
                    else {
                        t.removeAttribute(this.attributeKey, e);
                    }
                }
            } })); }
            _getValueFromFirstAllowedNode() { const t = this.editor.model; const e = t.schema; const n = t.document.selection; if (n.isCollapsed) {
                return n.hasAttribute(this.attributeKey);
            } for (const t of n.getRanges()) {
                for (const n of t.getItems()) {
                    if (e.checkAttribute(n, this.attributeKey)) {
                        return n.hasAttribute(this.attributeKey);
                    }
                }
            } return false; }
        }
        const gx = "bold";
        class mx extends Kn {
            static get pluginName() { return "BoldEditing"; }
            init() { const t = this.editor; t.model.schema.extend("$text", { allowAttributes: gx }); t.model.schema.setAttributeProperties(gx, { isFormatting: true, copyOnEnter: true }); t.conversion.attributeToElement({ model: gx, view: "strong", upcastAlso: ["b", t => { const e = t.getStyle("font-weight"); if (!e) {
                        return null;
                    } if (e == "bold" || Number(e) >= 600) {
                        return { name: true, styles: ["font-weight"] };
                    } }] }); t.commands.add(gx, new px(t, gx)); t.keystrokes.set("CTRL+B", gx); }
        }
        var kx = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
        const bx = "bold";
        class wx extends Kn {
            static get pluginName() { return "BoldUI"; }
            init() { const t = this.editor; const e = t.t; t.ui.componentFactory.add(bx, (n => { const o = t.commands.get(bx); const i = new mw(n); i.set({ label: e("Bold"), icon: kx, keystroke: "CTRL+B", tooltip: true, isToggleable: true }); i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"); this.listenTo(i, "execute", (() => { t.execute(bx); t.editing.view.focus(); })); return i; })); }
        }
        class _x extends Kn {
            static get requires() { return [mx, wx]; }
            static get pluginName() { return "Bold"; }
        }
        const vx = { autoRefresh: true };
        const Ax = 36e5;
        class Cx {
            constructor(t, e = vx) { if (!t) {
                throw new u["a"]("token-missing-token-url", this);
            } if (e.initValue) {
                this._validateTokenValue(e.initValue);
            } this.set("value", e.initValue); if (typeof t === "function") {
                this._refresh = t;
            }
            else {
                this._refresh = () => yx(t);
            } this._options = Object.assign({}, vx, e); }
            init() { return new Promise(((t, e) => { if (!this.value) {
                this.refreshToken().then(t).catch(e);
                return;
            } if (this._options.autoRefresh) {
                this._registerRefreshTokenTimeout();
            } t(this); })); }
            refreshToken() { return this._refresh().then((t => { this._validateTokenValue(t); this.set("value", t); if (this._options.autoRefresh) {
                this._registerRefreshTokenTimeout();
            } })).then((() => this)); }
            destroy() { clearTimeout(this._tokenRefreshTimeout); }
            _validateTokenValue(t) { const e = typeof t === "string"; const n = !/^".*"$/.test(t); const o = e && t.split(".").length === 3; if (!(n && o)) {
                throw new u["a"]("token-not-in-jwt-format", this);
            } }
            _registerRefreshTokenTimeout() { const t = this._getTokenRefreshTimeoutTime(); clearTimeout(this._tokenRefreshTimeout); this._tokenRefreshTimeout = setTimeout((() => { this.refreshToken(); }), t); }
            _getTokenRefreshTimeoutTime() { try {
                const [, t] = this.value.split(".");
                const { exp: e } = JSON.parse(atob(t));
                if (!e) {
                    return Ax;
                }
                const n = Math.floor((e * 1e3 - Date.now()) / 2);
                return n;
            }
            catch (t) {
                return Ax;
            } }
            static create(t, e = vx) { const n = new Cx(t, e); return n.init(); }
        }
        qn(Cx, Pn);
        function yx(t) { return new Promise(((e, n) => { const o = new XMLHttpRequest; o.open("GET", t); o.addEventListener("load", (() => { const t = o.status; const i = o.response; if (t < 200 || t > 299) {
            return n(new u["a"]("token-cannot-download-new-token", null));
        } return e(i); })); o.addEventListener("error", (() => n(new Error("Network Error")))); o.addEventListener("abort", (() => n(new Error("Abort")))); o.send(); })); }
        var xx = Cx;
        const Ex = /^data:(\S*?);base64,/;
        class Dx {
            constructor(t, e, n) { if (!t) {
                throw new u["a"]("fileuploader-missing-file", null);
            } if (!e) {
                throw new u["a"]("fileuploader-missing-token", null);
            } if (!n) {
                throw new u["a"]("fileuploader-missing-api-address", null);
            } this.file = Tx(t) ? Sx(t) : t; this._token = e; this._apiAddress = n; }
            onProgress(t) { this.on("progress", ((e, n) => t(n))); return this; }
            onError(t) { this.once("error", ((e, n) => t(n))); return this; }
            abort() { this.xhr.abort(); }
            send() { this._prepareRequest(); this._attachXHRListeners(); return this._sendRequest(); }
            _prepareRequest() { const t = new XMLHttpRequest; t.open("POST", this._apiAddress); t.setRequestHeader("Authorization", this._token.value); t.responseType = "json"; this.xhr = t; }
            _attachXHRListeners() { const t = this; const e = this.xhr; e.addEventListener("error", n("Network Error")); e.addEventListener("abort", n("Abort")); if (e.upload) {
                e.upload.addEventListener("progress", (t => { if (t.lengthComputable) {
                    this.fire("progress", { total: t.total, uploaded: t.loaded });
                } }));
            } e.addEventListener("load", (() => { const t = e.status; const n = e.response; if (t < 200 || t > 299) {
                return this.fire("error", n.message || n.error);
            } })); function n(e) { return () => t.fire("error", e); } }
            _sendRequest() { const t = new FormData; const e = this.xhr; t.append("file", this.file); return new Promise(((n, o) => { e.addEventListener("load", (() => { const t = e.status; const i = e.response; if (t < 200 || t > 299) {
                if (i.message) {
                    return o(new u["a"]("fileuploader-uploading-data-failed", this, { message: i.message }));
                }
                return o(i.error);
            } return n(i); })); e.addEventListener("error", (() => o(new Error("Network Error")))); e.addEventListener("abort", (() => o(new Error("Abort")))); e.send(t); })); }
        }
        qn(Dx, g);
        function Sx(t, e = 512) { try {
            const n = t.match(Ex)[1];
            const o = atob(t.replace(Ex, ""));
            const i = [];
            for (let t = 0; t < o.length; t += e) {
                const n = o.slice(t, t + e);
                const r = new Array(n.length);
                for (let t = 0; t < n.length; t++) {
                    r[t] = n.charCodeAt(t);
                }
                i.push(new Uint8Array(r));
            }
            return new Blob(i, { type: n });
        }
        catch (t) {
            throw new u["a"]("fileuploader-decoding-image-data-error", null);
        } }
        function Tx(t) { if (typeof t !== "string") {
            return false;
        } const e = t.match(Ex); return !!(e && e.length); }
        class Px {
            constructor(t, e) { if (!t) {
                throw new u["a"]("uploadgateway-missing-token", null);
            } if (!e) {
                throw new u["a"]("uploadgateway-missing-api-address", null);
            } this._token = t; this._apiAddress = e; }
            upload(t) { return new Dx(t, this._token, this._apiAddress); }
        }
        class Bx extends Ba {
            static get pluginName() { return "CloudServicesCore"; }
            createToken(t, e) { return new xx(t, e); }
            createUploadGateway(t, e) { return new Px(t, e); }
        }
        class Ix extends Ba {
            static get pluginName() { return "CloudServices"; }
            static get requires() { return [Bx]; }
            init() { const t = this.context.config; const e = t.get("cloudServices") || {}; for (const t in e) {
                this[t] = e[t];
            } this._tokens = new Map; if (!this.tokenUrl) {
                this.token = null;
                return;
            } this.token = this.context.plugins.get("CloudServicesCore").createToken(this.tokenUrl); this._tokens.set(this.tokenUrl, this.token); return this.token.init(); }
            registerTokenUrl(t) { if (this._tokens.has(t)) {
                return Promise.resolve(this.getTokenFor(t));
            } const e = this.context.plugins.get("CloudServicesCore").createToken(t); this._tokens.set(t, e); return e.init(); }
            getTokenFor(t) { const e = this._tokens.get(t); if (!e) {
                throw new u["a"]("cloudservices-token-not-registered", this);
            } return e; }
            destroy() { super.destroy(); for (const t of this._tokens.values()) {
                t.destroy();
            } }
        }
        class Rx {
            constructor(t) { this.files = Fx(t); this._native = t; }
            get types() { return this._native.types; }
            getData(t) { return this._native.getData(t); }
            setData(t, e) { this._native.setData(t, e); }
            set effectAllowed(t) { this._native.effectAllowed = t; }
            get effectAllowed() { return this._native.effectAllowed; }
            set dropEffect(t) { this._native.dropEffect = t; }
            get dropEffect() { return this._native.dropEffect; }
            get isCanceled() { return this._native.dropEffect == "none" || !!this._native.mozUserCancelled; }
        }
        function Fx(t) { const e = t.files ? Array.from(t.files) : []; const n = t.items ? Array.from(t.items) : []; if (e.length) {
            return e;
        } return n.filter((t => t.kind === "file")).map((t => t.getAsFile())); }
        class Ox extends xh {
            constructor(t) { super(t); const e = this.document; this.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"]; this.listenTo(e, "paste", n("clipboardInput"), { priority: "low" }); this.listenTo(e, "drop", n("clipboardInput"), { priority: "low" }); this.listenTo(e, "dragover", n("dragging"), { priority: "low" }); function n(t) { return (n, o) => { o.preventDefault(); const i = o.dropRange ? [o.dropRange] : null; const s = new r(e, t); e.fire(s, { dataTransfer: o.dataTransfer, method: n.name, targetRanges: i, target: o.target }); if (s.stop.called) {
                o.stopPropagation();
            } }; } }
            onDomEvent(t) { const e = { dataTransfer: new Rx(t.clipboardData ? t.clipboardData : t.dataTransfer) }; if (t.type == "drop" || t.type == "dragover") {
                e.dropRange = zx(this.view, t);
            } this.fire(t.type, t, e); }
        }
        function zx(t, e) { const n = e.target.ownerDocument; const o = e.clientX; const i = e.clientY; let r; if (n.caretRangeFromPoint && n.caretRangeFromPoint(o, i)) {
            r = n.caretRangeFromPoint(o, i);
        }
        else if (e.rangeParent) {
            r = n.createRange();
            r.setStart(e.rangeParent, e.rangeOffset);
            r.collapse(true);
        } if (r) {
            return t.domConverter.domRangeToView(r);
        } return null; }
        function Nx(t) { t = t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;"); if (t.includes("</p><p>") || t.includes("<br>")) {
            t = `<p>${t}</p>`;
        } return t; }
        function Mx(t) { return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, ((t, e) => { if (e.length == 1) {
            return " ";
        } return e; })); }
        const Vx = ["figcaption", "li"];
        function Lx(t) { let e = ""; if (t.is("$text") || t.is("$textProxy")) {
            e = t.data;
        }
        else if (t.is("element", "img") && t.hasAttribute("alt")) {
            e = t.getAttribute("alt");
        }
        else if (t.is("element", "br")) {
            e = "\n";
        }
        else {
            let n = null;
            for (const o of t.getChildren()) {
                const t = Lx(o);
                if (n && (n.is("containerElement") || o.is("containerElement"))) {
                    if (Vx.includes(n.name) || Vx.includes(o.name)) {
                        e += "\n";
                    }
                    else {
                        e += "\n\n";
                    }
                }
                e += t;
                n = o;
            }
        } return e; }
        class qx extends Kn {
            static get pluginName() { return "ClipboardPipeline"; }
            init() { const t = this.editor; const e = t.editing.view; e.addObserver(Ox); this._setupPasteDrop(); this._setupCopyCut(); }
            _setupPasteDrop() { const t = this.editor; const e = t.model; const n = t.editing.view; const o = n.document; this.listenTo(o, "clipboardInput", (e => { if (t.isReadOnly) {
                e.stop();
            } }), { priority: "highest" }); this.listenTo(o, "clipboardInput", ((t, e) => { const o = e.dataTransfer; let i = e.content || ""; if (!i) {
                if (o.getData("text/html")) {
                    i = Mx(o.getData("text/html"));
                }
                else if (o.getData("text/plain")) {
                    i = Nx(o.getData("text/plain"));
                }
                i = this.editor.data.htmlProcessor.toView(i);
            } const s = new r(this, "inputTransformation"); this.fire(s, { content: i, dataTransfer: o, targetRanges: e.targetRanges, method: e.method }); if (s.stop.called) {
                t.stop();
            } n.scrollToTheSelection(); }), { priority: "low" }); this.listenTo(this, "inputTransformation", ((t, n) => { if (n.content.isEmpty) {
                return;
            } const o = this.editor.data; const i = o.toModel(n.content, "$clipboardHolder"); if (i.childCount == 0) {
                return;
            } t.stop(); e.change((() => { this.fire("contentInsertion", { content: i, method: n.method, dataTransfer: n.dataTransfer, targetRanges: n.targetRanges }); })); }), { priority: "low" }); this.listenTo(this, "contentInsertion", ((t, n) => { n.resultRange = e.insertContent(n.content); }), { priority: "low" }); }
            _setupCopyCut() { const t = this.editor; const e = t.model.document; const n = t.editing.view; const o = n.document; function i(n, i) { const r = i.dataTransfer; i.preventDefault(); const s = t.data.toView(t.model.getSelectedContent(e.selection)); o.fire("clipboardOutput", { dataTransfer: r, content: s, method: n.name }); } this.listenTo(o, "copy", i, { priority: "low" }); this.listenTo(o, "cut", ((e, n) => { if (t.isReadOnly) {
                n.preventDefault();
            }
            else {
                i(e, n);
            } }), { priority: "low" }); this.listenTo(o, "clipboardOutput", ((n, o) => { if (!o.content.isEmpty) {
                o.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(o.content));
                o.dataTransfer.setData("text/plain", Lx(o.content));
            } if (o.method == "cut") {
                t.model.deleteContent(e.selection);
            } }), { priority: "low" }); }
        }
        class Kx {
            constructor() { this._stack = []; }
            add(t, e) { const n = this._stack; const o = n[0]; this._insertDescriptor(t); const i = n[0]; if (o !== i && !jx(o, i)) {
                this.fire("change:top", { oldDescriptor: o, newDescriptor: i, writer: e });
            } }
            remove(t, e) { const n = this._stack; const o = n[0]; this._removeDescriptor(t); const i = n[0]; if (o !== i && !jx(o, i)) {
                this.fire("change:top", { oldDescriptor: o, newDescriptor: i, writer: e });
            } }
            _insertDescriptor(t) { const e = this._stack; const n = e.findIndex((e => e.id === t.id)); if (jx(t, e[n])) {
                return;
            } if (n > -1) {
                e.splice(n, 1);
            } let o = 0; while (e[o] && Hx(e[o], t)) {
                o++;
            } e.splice(o, 0, t); }
            _removeDescriptor(t) { const e = this._stack; const n = e.findIndex((e => e.id === t)); if (n > -1) {
                e.splice(n, 1);
            } }
        }
        qn(Kx, g);
        function jx(t, e) { return t && e && t.priority == e.priority && Wx(t.classes) == Wx(e.classes); }
        function Hx(t, e) { if (t.priority > e.priority) {
            return true;
        }
        else if (t.priority < e.priority) {
            return false;
        } return Wx(t.classes) > Wx(e.classes); }
        function Wx(t) { return Array.isArray(t) ? t.sort().join(",") : t; }
        var $x = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
        const Gx = "ck-widget";
        const Ux = "ck-widget_selected";
        function Jx(t) { if (!t.is("element")) {
            return false;
        } return !!t.getCustomProperty("widget"); }
        function Yx(t, e, n = {}) { if (!t.is("containerElement")) {
            throw new u["a"]("widget-to-widget-wrong-element-type", null, { element: t });
        } e.setAttribute("contenteditable", "false", t); e.addClass(Gx, t); e.setCustomProperty("widget", true, t); t.getFillerOffset = aE; if (n.label) {
            tE(t, n.label, e);
        } if (n.hasSelectionHandle) {
            cE(t, e);
        } Zx(t, e, Qx, Xx); return t; }
        function Qx(t, e, n) { if (e.classes) {
            n.addClass(_a(e.classes), t);
        } if (e.attributes) {
            for (const o in e.attributes) {
                n.setAttribute(o, e.attributes[o], t);
            }
        } }
        function Xx(t, e, n) { if (e.classes) {
            n.removeClass(_a(e.classes), t);
        } if (e.attributes) {
            for (const o in e.attributes) {
                n.removeAttribute(o, t);
            }
        } }
        function Zx(t, e, n, o) { const i = new Kx; i.on("change:top", ((e, i) => { if (i.oldDescriptor) {
            o(t, i.oldDescriptor, i.writer);
        } if (i.newDescriptor) {
            n(t, i.newDescriptor, i.writer);
        } })); e.setCustomProperty("addHighlight", ((t, e, n) => i.add(e, n)), t); e.setCustomProperty("removeHighlight", ((t, e, n) => i.remove(e, n)), t); }
        function tE(t, e, n) { n.setCustomProperty("widgetLabel", e, t); }
        function eE(t) { const e = t.getCustomProperty("widgetLabel"); if (!e) {
            return "";
        } return typeof e == "function" ? e() : e; }
        function nE(t, e) { e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t); e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t); t.on("change:isReadOnly", ((n, o, i) => { e.setAttribute("contenteditable", i ? "false" : "true", t); })); t.on("change:isFocused", ((n, o, i) => { if (i) {
            e.addClass("ck-editor__nested-editable_focused", t);
        }
        else {
            e.removeClass("ck-editor__nested-editable_focused", t);
        } })); return t; }
        function oE(t, e) { const n = t.getSelectedElement(); if (n) {
            const o = pE(t);
            if (o) {
                return e.createPositionAt(n, o);
            }
            if (e.schema.isBlock(n)) {
                return e.createPositionAfter(n);
            }
        } const o = t.getSelectedBlocks().next().value; if (o) {
            if (o.isEmpty) {
                return e.createPositionAt(o, 0);
            }
            const n = e.createPositionAfter(o);
            if (t.focus.isTouching(n)) {
                return n;
            }
            return e.createPositionBefore(o);
        } return t.focus; }
        function iE(t, e) { const n = t.getSelectedElement(); return !!n && e.isObject(n); }
        function rE(t, e) { return (n, o) => { const { mapper: i, viewPosition: r } = o; const s = i.findMappedViewAncestor(r); if (!e(s)) {
            return;
        } const a = i.toModelElement(s); o.modelPosition = t.createPositionAt(a, r.isAtStart ? "before" : "after"); }; }
        function sE(t, e) { const n = new cf(su.window); const o = n.getIntersection(t); const i = e.height + _v.arrowVerticalOffset; if (t.top - i > n.top || t.bottom + i < n.bottom) {
            return null;
        } const r = o || t; const s = r.left + r.width / 2 - e.width / 2; return { top: Math.max(t.top, 0) + _v.arrowVerticalOffset, left: s, name: "arrow_n" }; }
        function aE() { return null; }
        function cE(t, e) { const n = e.createUIElement("div", { class: "ck ck-widget__selection-handle" }, (function (t) { const e = this.toDomElement(t); const n = new sw; n.set("content", $x); n.render(); e.appendChild(n.element); return e; })); e.insert(e.createPositionAt(t, 0), n); e.addClass(["ck-widget_with-selection-handle"], t); }
        const lE = "widget-type-around";
        function dE(t, e, n) { return t && Jx(t) && !n.isInline(e); }
        function uE(t) { return t.closest(".ck-widget__type-around__button"); }
        function hE(t) { return t.classList.contains("ck-widget__type-around__button_before") ? "before" : "after"; }
        function fE(t, e) { const n = t.closest(".ck-widget"); return e.mapDomToView(n); }
        function pE(t) { return t.getAttribute(lE); }
        var gE = '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>';
        var mE = n(37);
        var kE = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        kE.insert = "head";
        kE.singleton = true;
        var bE = Ab()(mE["a"], kE);
        var wE = mE["a"].locals || {};
        const _E = ["before", "after"];
        const vE = (new DOMParser).parseFromString(gE, "image/svg+xml").firstChild;
        const AE = "ck-widget__type-around_disabled";
        class CE extends Kn {
            static get pluginName() { return "WidgetTypeAround"; }
            static get requires() { return [sy, Py]; }
            constructor(t) { super(t); this._currentFakeCaretModelElement = null; }
            init() { const t = this.editor; const e = t.editing.view; this.on("change:isEnabled", ((n, o, i) => { e.change((t => { for (const n of e.document.roots) {
                if (i) {
                    t.removeClass(AE, n);
                }
                else {
                    t.addClass(AE, n);
                }
            } })); if (!i) {
                t.model.change((t => { t.removeSelectionAttribute(lE); }));
            } })); this._enableTypeAroundUIInjection(); this._enableInsertingParagraphsOnButtonClick(); this._enableInsertingParagraphsOnEnterKeypress(); this._enableInsertingParagraphsOnTypingKeystroke(); this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(); this._enableDeleteIntegration(); this._enableInsertContentIntegration(); }
            destroy() { this._currentFakeCaretModelElement = null; }
            _insertParagraph(t, e) { const n = this.editor; const o = n.editing.view; n.execute("insertParagraph", { position: n.model.createPositionAt(t, e) }); o.focus(); o.scrollToTheSelection(); }
            _listenToIfEnabled(t, e, n, o) { this.listenTo(t, e, ((...t) => { if (this.isEnabled) {
                n(...t);
            } }), o); }
            _insertParagraphAccordingToFakeCaretPosition() { const t = this.editor; const e = t.model; const n = e.document.selection; const o = pE(n); if (!o) {
                return false;
            } const i = n.getSelectedElement(); this._insertParagraph(i, o); return true; }
            _enableTypeAroundUIInjection() { const t = this.editor; const e = t.model.schema; const n = t.locale.t; const o = { before: n("Insert paragraph before block"), after: n("Insert paragraph after block") }; t.editing.downcastDispatcher.on("insert", ((t, n, i) => { const r = i.mapper.toViewElement(n.item); if (dE(r, n.item, e)) {
                yE(i.writer, o, r);
            } }), { priority: "low" }); }
            _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() { const t = this.editor; const e = t.model; const n = e.document.selection; const o = e.schema; const i = t.editing.view; this._listenToIfEnabled(i.document, "arrowKey", ((t, e) => { this._handleArrowKeyPress(t, e); }), { context: [Jx, "$text"], priority: "high" }); this._listenToIfEnabled(n, "change:range", ((e, n) => { if (!n.directChange) {
                return;
            } t.model.change((t => { t.removeSelectionAttribute(lE); })); })); this._listenToIfEnabled(e.document, "change:data", (() => { const e = n.getSelectedElement(); if (e) {
                const n = t.editing.mapper.toViewElement(e);
                if (dE(n, e, o)) {
                    return;
                }
            } t.model.change((t => { t.removeSelectionAttribute(lE); })); })); this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", ((t, e, n) => { const i = n.writer; if (this._currentFakeCaretModelElement) {
                const t = n.mapper.toViewElement(this._currentFakeCaretModelElement);
                if (t) {
                    i.removeClass(_E.map(r), t);
                    this._currentFakeCaretModelElement = null;
                }
            } const s = e.selection.getSelectedElement(); if (!s) {
                return;
            } const a = n.mapper.toViewElement(s); if (!dE(a, s, o)) {
                return;
            } const c = pE(e.selection); if (!c) {
                return;
            } i.addClass(r(c), a); this._currentFakeCaretModelElement = s; })); this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", ((e, n, o) => { if (!o) {
                t.model.change((t => { t.removeSelectionAttribute(lE); }));
            } })); function r(t) { return `ck-widget_type-around_show-fake-caret_${t}`; } }
            _handleArrowKeyPress(t, e) { const n = this.editor; const o = n.model; const i = o.document.selection; const r = o.schema; const s = n.editing.view; const a = e.keyCode; const c = cd(a, n.locale.contentLanguageDirection); const l = s.document.selection.getSelectedElement(); const d = n.editing.mapper.toModelElement(l); let u; if (dE(l, d, r)) {
                u = this._handleArrowKeyPressOnSelectedWidget(c);
            }
            else if (i.isCollapsed) {
                u = this._handleArrowKeyPressWhenSelectionNextToAWidget(c);
            } if (u) {
                e.preventDefault();
                t.stop();
            } }
            _handleArrowKeyPressOnSelectedWidget(t) { const e = this.editor; const n = e.model; const o = n.document.selection; const i = pE(o); return n.change((e => { if (i) {
                const n = i === (t ? "after" : "before");
                if (!n) {
                    e.removeSelectionAttribute(lE);
                    return true;
                }
            }
            else {
                e.setSelectionAttribute(lE, t ? "after" : "before");
                return true;
            } return false; })); }
            _handleArrowKeyPressWhenSelectionNextToAWidget(t) { const e = this.editor; const n = e.model; const o = n.schema; const i = e.plugins.get("Widget"); const r = i._getObjectElementNextToSelection(t); const s = e.editing.mapper.toViewElement(r); if (dE(s, r, o)) {
                n.change((e => { i._setSelectionOverElement(r); e.setSelectionAttribute(lE, t ? "before" : "after"); }));
                return true;
            } return false; }
            _enableInsertingParagraphsOnButtonClick() { const t = this.editor; const e = t.editing.view; this._listenToIfEnabled(e.document, "mousedown", ((n, o) => { const i = uE(o.domTarget); if (!i) {
                return;
            } const r = hE(i); const s = fE(i, e.domConverter); const a = t.editing.mapper.toModelElement(s); this._insertParagraph(a, r); o.preventDefault(); n.stop(); })); }
            _enableInsertingParagraphsOnEnterKeypress() { const t = this.editor; const e = t.model.document.selection; const n = t.editing.view; this._listenToIfEnabled(n.document, "enter", ((n, o) => { if (n.eventPhase != "atTarget") {
                return;
            } const i = e.getSelectedElement(); const r = t.editing.mapper.toViewElement(i); const s = t.model.schema; let a; if (this._insertParagraphAccordingToFakeCaretPosition()) {
                a = true;
            }
            else if (dE(r, i, s)) {
                this._insertParagraph(i, o.isSoft ? "before" : "after");
                a = true;
            } if (a) {
                o.preventDefault();
                n.stop();
            } }), { context: Jx }); }
            _enableInsertingParagraphsOnTypingKeystroke() { const t = this.editor; const e = t.editing.view; const n = [td.enter, td.delete, td.backspace]; this._listenToIfEnabled(e.document, "keydown", ((t, e) => { if (!n.includes(e.keyCode) && !ky(e)) {
                this._insertParagraphAccordingToFakeCaretPosition();
            } }), { priority: "high" }); }
            _enableDeleteIntegration() { const t = this.editor; const e = t.editing.view; const n = t.model; const o = n.schema; this._listenToIfEnabled(e.document, "delete", ((e, i) => { if (e.eventPhase != "atTarget") {
                return;
            } const r = pE(n.document.selection); if (!r) {
                return;
            } const s = i.direction; const a = n.document.selection.getSelectedElement(); const c = r === "before"; const l = s == "forward"; const d = c === l; if (d) {
                t.execute("delete", { selection: n.createSelection(a, "on") });
            }
            else {
                const e = o.getNearestSelectionRange(n.createPositionAt(a, r), s);
                if (e) {
                    if (!e.isCollapsed) {
                        n.change((n => { n.setSelection(e); t.execute(l ? "deleteForward" : "delete"); }));
                    }
                    else {
                        const i = n.createSelection(e.start);
                        n.modifySelection(i, { direction: s });
                        if (!i.focus.isEqual(e.start)) {
                            n.change((n => { n.setSelection(e); t.execute(l ? "deleteForward" : "delete"); }));
                        }
                        else {
                            const t = DE(o, e.start.parent);
                            n.deleteContent(n.createSelection(t, "on"), { doNotAutoparagraph: true });
                        }
                    }
                }
            } i.preventDefault(); e.stop(); }), { context: Jx }); }
            _enableInsertContentIntegration() { const t = this.editor; const e = this.editor.model; const n = e.document.selection; this._listenToIfEnabled(t.model, "insertContent", ((t, [o, i]) => { if (i && !i.is("documentSelection")) {
                return;
            } const r = pE(n); if (!r) {
                return;
            } t.stop(); return e.change((t => { const i = n.getSelectedElement(); const s = e.createPositionAt(i, r); const a = t.createSelection(s); const c = e.insertContent(o, a); t.setSelection(a); return c; })); }), { priority: "high" }); }
        }
        function yE(t, e, n) { const o = t.createUIElement("div", { class: "ck ck-reset_all ck-widget__type-around" }, (function (t) { const n = this.toDomElement(t); xE(n, e); EE(n); return n; })); t.insert(t.createPositionAt(n, "end"), o); }
        function xE(t, e) { for (const n of _E) {
            const o = new Tb({ tag: "div", attributes: { class: ["ck", "ck-widget__type-around__button", `ck-widget__type-around__button_${n}`], title: e[n] }, children: [t.ownerDocument.importNode(vE, true)] });
            t.appendChild(o.render());
        } }
        function EE(t) { const e = new Tb({ tag: "div", attributes: { class: ["ck", "ck-widget__type-around__fake-caret"] } }); t.appendChild(e.render()); }
        function DE(t, e) { let n = e; for (const o of e.getAncestors({ parentFirst: true })) {
            if (o.childCount > 1 || t.isLimit(o)) {
                break;
            }
            n = o;
        } return n; }
        var SE = n(38);
        var TE = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        TE.insert = "head";
        TE.singleton = true;
        var PE = Ab()(SE["a"], TE);
        var BE = SE["a"].locals || {};
        function IE(t) { const e = t.model; return (n, o) => { const i = o.keyCode == td.arrowup; const r = o.keyCode == td.arrowdown; const s = o.shiftKey; const a = e.document.selection; if (!i && !r) {
            return;
        } const c = r; if (s && NE(a, c)) {
            return;
        } const l = RE(t, a, c); if (!l || l.isCollapsed) {
            return;
        } if (zE(t, l, c)) {
            e.change((t => { const n = c ? l.end : l.start; if (s) {
                const o = e.createSelection(a.anchor);
                o.setFocus(n);
                t.setSelection(o);
            }
            else {
                t.setSelection(n);
            } }));
            n.stop();
            o.preventDefault();
            o.stopPropagation();
        } }; }
        function RE(t, e, n) { const o = t.model; if (n) {
            const t = e.isCollapsed ? e.focus : e.getLastPosition();
            const n = FE(o, t, "forward");
            if (!n) {
                return null;
            }
            const i = o.createRange(t, n);
            const r = OE(o.schema, i, "backward");
            if (r && t.isBefore(r)) {
                return o.createRange(t, r);
            }
            return null;
        }
        else {
            const t = e.isCollapsed ? e.focus : e.getFirstPosition();
            const n = FE(o, t, "backward");
            if (!n) {
                return null;
            }
            const i = o.createRange(n, t);
            const r = OE(o.schema, i, "forward");
            if (r && t.isAfter(r)) {
                return o.createRange(r, t);
            }
            return null;
        } }
        function FE(t, e, n) { const o = t.schema; const i = t.createRangeIn(e.root); const r = n == "forward" ? "elementStart" : "elementEnd"; for (const { previousPosition: t, item: s, type: a } of i.getWalker({ startPosition: e, direction: n })) {
            if (o.isLimit(s) && !o.isInline(s)) {
                return t;
            }
            if (a == r && o.isBlock(s)) {
                return null;
            }
        } return null; }
        function OE(t, e, n) { const o = n == "backward" ? e.end : e.start; if (t.checkChild(o, "$text")) {
            return o;
        } for (const { nextPosition: o } of e.getWalker({ direction: n })) {
            if (t.checkChild(o, "$text")) {
                return o;
            }
        } }
        function zE(t, e, n) { const o = t.model; const i = t.view.domConverter; if (n) {
            const t = o.createSelection(e.start);
            o.modifySelection(t);
            if (!t.focus.isAtEnd && !e.start.isEqual(t.focus)) {
                e = o.createRange(t.focus, e.end);
            }
        } const r = t.mapper.toViewRange(e); const s = i.viewRangeToDom(r); const a = cf.getDomRangeRects(s); let c; for (const t of a) {
            if (c === undefined) {
                c = Math.round(t.bottom);
                continue;
            }
            if (Math.round(t.top) >= c) {
                return false;
            }
            c = Math.max(c, Math.round(t.bottom));
        } return true; }
        function NE(t, e) { return !t.isCollapsed && t.isBackward == e; }
        class ME extends Kn {
            static get pluginName() { return "Widget"; }
            static get requires() { return [CE, Py]; }
            init() { const t = this.editor.editing.view; const e = t.document; this._previouslySelected = new Set; this.editor.editing.downcastDispatcher.on("selection", ((t, e, n) => { this._clearPreviouslySelectedWidgets(n.writer); const o = n.writer; const i = o.document.selection; const r = i.getSelectedElement(); let s = null; for (const t of i.getRanges()) {
                for (const e of t) {
                    const t = e.item;
                    if (Jx(t) && !LE(t, s)) {
                        o.addClass(Ux, t);
                        this._previouslySelected.add(t);
                        s = t;
                        if (t == r) {
                            o.setSelection(i.getRanges(), { fake: true, label: eE(r) });
                        }
                    }
                }
            } }), { priority: "low" }); t.addObserver(PA); this.listenTo(e, "mousedown", ((...t) => this._onMousedown(...t))); this.listenTo(e, "arrowKey", ((...t) => { this._handleSelectionChangeOnArrowKeyPress(...t); }), { context: [Jx, "$text"] }); this.listenTo(e, "arrowKey", ((...t) => { this._preventDefaultOnArrowKeyPress(...t); }), { context: "$root" }); this.listenTo(e, "arrowKey", IE(this.editor.editing), { context: "$text" }); this.listenTo(e, "delete", ((t, e) => { if (this._handleDelete(e.direction == "forward")) {
                e.preventDefault();
                t.stop();
            } }), { context: "$root" }); }
            _onMousedown(t, e) { const n = this.editor; const o = n.editing.view; const i = o.document; let r = e.target; if (VE(r)) {
                if ((Wl.isSafari || Wl.isGecko) && e.domEvent.detail >= 3) {
                    const t = n.editing.mapper;
                    const o = r.is("attributeElement") ? r.findAncestor((t => !t.is("attributeElement"))) : r;
                    const i = t.toModelElement(o);
                    e.preventDefault();
                    this.editor.model.change((t => { t.setSelection(i, "in"); }));
                }
                return;
            } if (!Jx(r)) {
                r = r.findAncestor(Jx);
                if (!r) {
                    return;
                }
            } if (Wl.isAndroid) {
                e.preventDefault();
            } if (!i.isFocused) {
                o.focus();
            } const s = n.editing.mapper.toModelElement(r); this._setSelectionOverElement(s); }
            _handleSelectionChangeOnArrowKeyPress(t, e) { const n = e.keyCode; const o = this.editor.model; const i = o.schema; const r = o.document.selection; const s = r.getSelectedElement(); const a = cd(n, this.editor.locale.contentLanguageDirection); if (s && i.isObject(s)) {
                const n = a ? r.getLastPosition() : r.getFirstPosition();
                const s = i.getNearestSelectionRange(n, a ? "forward" : "backward");
                if (s) {
                    o.change((t => { t.setSelection(s); }));
                    e.preventDefault();
                    t.stop();
                }
                return;
            } if (!r.isCollapsed) {
                return;
            } const c = this._getObjectElementNextToSelection(a); if (c && i.isObject(c)) {
                this._setSelectionOverElement(c);
                e.preventDefault();
                t.stop();
            } }
            _preventDefaultOnArrowKeyPress(t, e) { const n = this.editor.model; const o = n.schema; const i = n.document.selection.getSelectedElement(); if (i && o.isObject(i)) {
                e.preventDefault();
                t.stop();
            } }
            _handleDelete(t) { if (this.editor.isReadOnly) {
                return;
            } const e = this.editor.model.document; const n = e.selection; if (!n.isCollapsed) {
                return;
            } const o = this._getObjectElementNextToSelection(t); if (o) {
                this.editor.model.change((t => { let e = n.anchor.parent; while (e.isEmpty) {
                    const n = e;
                    e = n.parent;
                    t.remove(n);
                } this._setSelectionOverElement(o); }));
                return true;
            } }
            _setSelectionOverElement(t) { this.editor.model.change((e => { e.setSelection(e.createRangeOn(t)); })); }
            _getObjectElementNextToSelection(t) { const e = this.editor.model; const n = e.schema; const o = e.document.selection; const i = e.createSelection(o); e.modifySelection(i, { direction: t ? "forward" : "backward" }); const r = t ? i.focus.nodeBefore : i.focus.nodeAfter; if (!!r && n.isObject(r)) {
                return r;
            } return null; }
            _clearPreviouslySelectedWidgets(t) { for (const e of this._previouslySelected) {
                t.removeClass(Ux, e);
            } this._previouslySelected.clear(); }
        }
        function VE(t) { while (t) {
            if (t.is("editableElement") && !t.is("rootElement")) {
                return true;
            }
            if (Jx(t)) {
                return false;
            }
            t = t.parent;
        } return false; }
        function LE(t, e) { if (!e) {
            return false;
        } return Array.from(t.getAncestors()).includes(e); }
        var qE = "Expected a function";
        function KE(t, e, n) { var o = true, i = true; if (typeof t != "function") {
            throw new TypeError(qE);
        } if (S(n)) {
            o = "leading" in n ? !!n.leading : o;
            i = "trailing" in n ? !!n.trailing : i;
        } return $h(t, e, { leading: o, maxWait: e, trailing: i }); }
        var jE = KE;
        var HE = n(39);
        var WE = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        WE.insert = "head";
        WE.singleton = true;
        var $E = Ab()(HE["a"], WE);
        var GE = HE["a"].locals || {};
        class UE extends Kn {
            static get pluginName() { return "DragDrop"; }
            static get requires() { return [qx, ME]; }
            init() { const t = this.editor; const e = t.editing.view; this._draggedRange = null; this._draggingUid = ""; this._draggableElement = null; this._updateDropMarkerThrottled = jE((t => this._updateDropMarker(t)), 40); this._removeDropMarkerDelayed = nD((() => this._removeDropMarker()), 40); this._clearDraggableAttributesDelayed = nD((() => this._clearDraggableAttributes()), 40); e.addObserver(Ox); e.addObserver(PA); this._setupDragging(); this._setupContentInsertionIntegration(); this._setupClipboardInputIntegration(); this._setupDropMarker(); this._setupDraggableAttributeHandling(); this.listenTo(t, "change:isReadOnly", ((t, e, n) => { if (n) {
                this.forceDisabled("readOnlyMode");
            }
            else {
                this.clearForceDisabled("readOnlyMode");
            } })); this.on("change:isEnabled", ((t, e, n) => { if (!n) {
                this._finalizeDragging(false);
            } })); if (Wl.isAndroid) {
                this.forceDisabled("noAndroidSupport");
            } }
            destroy() { if (this._draggedRange) {
                this._draggedRange.detach();
                this._draggedRange = null;
            } this._updateDropMarkerThrottled.cancel(); this._removeDropMarkerDelayed.cancel(); this._clearDraggableAttributesDelayed.cancel(); return super.destroy(); }
            _setupDragging() { const t = this.editor; const e = t.model; const n = e.document; const o = t.editing.view; const i = o.document; this.listenTo(i, "dragstart", ((o, r) => { const s = n.selection; if (r.target && r.target.is("editableElement")) {
                r.preventDefault();
                return;
            } const c = r.target ? oD(r.target) : null; if (c) {
                const n = t.editing.mapper.toModelElement(c);
                this._draggedRange = sp.fromRange(e.createRangeOn(n));
            }
            else if (!i.selection.isCollapsed) {
                const t = i.selection.getSelectedElement();
                if (!t || !Jx(t)) {
                    this._draggedRange = sp.fromRange(s.getFirstRange());
                }
            } if (!this._draggedRange) {
                r.preventDefault();
                return;
            } this._draggingUid = a(); r.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy"; r.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid); const l = e.createSelection(this._draggedRange.toRange()); const d = t.data.toView(e.getSelectedContent(l)); i.fire("clipboardOutput", { dataTransfer: r.dataTransfer, content: d, method: o.name }); if (!this.isEnabled) {
                this._draggedRange.detach();
                this._draggedRange = null;
                this._draggingUid = "";
            } }), { priority: "low" }); this.listenTo(i, "dragend", ((t, e) => { this._finalizeDragging(!e.dataTransfer.isCanceled && e.dataTransfer.dropEffect == "move"); }), { priority: "low" }); this.listenTo(i, "dragenter", (() => { if (!this.isEnabled) {
                return;
            } o.focus(); })); this.listenTo(i, "dragleave", (() => { this._removeDropMarkerDelayed(); })); this.listenTo(i, "dragging", ((e, n) => { if (!this.isEnabled) {
                n.dataTransfer.dropEffect = "none";
                return;
            } this._removeDropMarkerDelayed.cancel(); const o = JE(t, n.targetRanges, n.target); if (!this._draggedRange) {
                n.dataTransfer.dropEffect = "copy";
            } if (!Wl.isGecko) {
                if (n.dataTransfer.effectAllowed == "copy") {
                    n.dataTransfer.dropEffect = "copy";
                }
                else if (["all", "copyMove"].includes(n.dataTransfer.effectAllowed)) {
                    n.dataTransfer.dropEffect = "move";
                }
            } if (o) {
                this._updateDropMarkerThrottled(o);
            } }), { priority: "low" }); }
            _setupClipboardInputIntegration() { const t = this.editor; const e = t.editing.view; const n = e.document; this.listenTo(n, "clipboardInput", ((e, n) => { if (n.method != "drop") {
                return;
            } const o = JE(t, n.targetRanges, n.target); this._removeDropMarker(); if (!o) {
                this._finalizeDragging(false);
                e.stop();
                return;
            } if (this._draggedRange && this._draggingUid != n.dataTransfer.getData("application/ckeditor5-dragging-uid")) {
                this._draggedRange.detach();
                this._draggedRange = null;
                this._draggingUid = "";
            } const i = eD(n.dataTransfer) == "move"; if (i && this._draggedRange && this._draggedRange.containsRange(o, true)) {
                this._finalizeDragging(false);
                e.stop();
                return;
            } n.targetRanges = [t.editing.mapper.toViewRange(o)]; }), { priority: "high" }); }
            _setupContentInsertionIntegration() { const t = this.editor.plugins.get(qx); t.on("contentInsertion", ((t, e) => { if (!this.isEnabled || e.method !== "drop") {
                return;
            } const n = e.targetRanges.map((t => this.editor.editing.mapper.toModelRange(t))); this.editor.model.change((t => t.setSelection(n))); }), { priority: "high" }); t.on("contentInsertion", ((t, e) => { if (!this.isEnabled || e.method !== "drop") {
                return;
            } const n = eD(e.dataTransfer) == "move"; const o = !e.resultRange || !e.resultRange.isCollapsed; this._finalizeDragging(o && n); }), { priority: "lowest" }); }
            _setupDraggableAttributeHandling() { const t = this.editor; const e = t.editing.view; const n = e.document; this.listenTo(n, "mousedown", ((o, i) => { if (Wl.isAndroid || !i) {
                return;
            } this._clearDraggableAttributesDelayed.cancel(); let r = oD(i.target); if (Wl.isBlink && !t.isReadOnly && !r && !n.selection.isCollapsed) {
                const t = n.selection.getSelectedElement();
                if (!t || !Jx(t)) {
                    r = n.selection.editableElement;
                }
            } if (r) {
                e.change((t => { t.setAttribute("draggable", "true", r); }));
                this._draggableElement = t.editing.mapper.toModelElement(r);
            } })); this.listenTo(n, "mouseup", (() => { if (!Wl.isAndroid) {
                this._clearDraggableAttributesDelayed();
            } })); }
            _clearDraggableAttributes() { const t = this.editor.editing; t.view.change((e => { if (this._draggableElement && this._draggableElement.root.rootName != "$graveyard") {
                e.removeAttribute("draggable", t.mapper.toViewElement(this._draggableElement));
            } this._draggableElement = null; })); }
            _setupDropMarker() { const t = this.editor; t.conversion.for("editingDowncast").markerToHighlight({ model: "drop-target", view: { classes: ["ck-clipboard-drop-target-range"] } }); t.conversion.for("editingDowncast").markerToElement({ model: "drop-target", view: (e, { writer: n }) => { const o = t.model.schema.checkChild(e.markerRange.start, "$text"); if (!o) {
                    return;
                } return n.createUIElement("span", { class: "ck ck-clipboard-drop-target-position" }, (function (t) { const e = this.toDomElement(t); e.innerHTML = "&NoBreak;<span></span>&NoBreak;"; return e; })); } }); }
            _updateDropMarker(t) { const e = this.editor; const n = e.model.markers; e.model.change((e => { if (n.has("drop-target")) {
                if (!n.get("drop-target").getRange().isEqual(t)) {
                    e.updateMarker("drop-target", { range: t });
                }
            }
            else {
                e.addMarker("drop-target", { range: t, usingOperation: false, affectsData: false });
            } })); }
            _removeDropMarker() { const t = this.editor.model; this._removeDropMarkerDelayed.cancel(); this._updateDropMarkerThrottled.cancel(); if (t.markers.has("drop-target")) {
                t.change((t => { t.removeMarker("drop-target"); }));
            } }
            _finalizeDragging(t) { const e = this.editor; const n = e.model; this._removeDropMarker(); this._clearDraggableAttributes(); this._draggingUid = ""; if (!this._draggedRange) {
                return;
            } if (t && this.isEnabled) {
                n.deleteContent(n.createSelection(this._draggedRange), { doNotAutoparagraph: true });
            } this._draggedRange.detach(); this._draggedRange = null; }
        }
        function JE(t, e, n) { const o = t.model; const i = t.editing.mapper; let r = null; const s = e ? e[0].start : null; if (n.is("uiElement")) {
            n = n.parent;
        } r = YE(t, n); if (r) {
            return r;
        } const a = tD(t, n); const c = s ? i.toModelPosition(s) : null; if (!c) {
            return QE(t, a);
        } r = XE(t, c, a); if (r) {
            return r;
        } r = o.schema.getNearestSelectionRange(c, Wl.isGecko ? "forward" : "backward"); if (r) {
            return r;
        } return ZE(t, c.parent); }
        function YE(t, e) { const n = t.model; const o = t.editing.mapper; if (Jx(e)) {
            return n.createRangeOn(o.toModelElement(e));
        } if (!e.is("editableElement")) {
            const t = e.findAncestor((t => Jx(t) || t.is("editableElement")));
            if (Jx(t)) {
                return n.createRangeOn(o.toModelElement(t));
            }
        } return null; }
        function QE(t, e) { const n = t.model; const o = n.schema; const i = n.createPositionAt(e, 0); return o.getNearestSelectionRange(i, "forward"); }
        function XE(t, e, n) { const o = t.model; if (!o.schema.checkChild(n, "$block")) {
            return null;
        } const i = o.createPositionAt(n, 0); const r = e.path.slice(0, i.path.length); const s = o.createPositionFromPath(e.root, r); const a = s.nodeAfter; if (a && o.schema.isObject(a)) {
            return o.createRangeOn(a);
        } return null; }
        function ZE(t, e) { const n = t.model; while (e) {
            if (n.schema.isObject(e)) {
                return n.createRangeOn(e);
            }
            e = e.parent;
        } }
        function tD(t, e) { const n = t.editing.mapper; const o = t.editing.view; const i = n.toModelElement(e); if (i) {
            return i;
        } const r = o.createPositionBefore(e); const s = n.findMappedViewAncestor(r); return n.toModelElement(s); }
        function eD(t) { if (Wl.isGecko) {
            return t.dropEffect;
        } return ["all", "copyMove"].includes(t.effectAllowed) ? "move" : "copy"; }
        function nD(t, e) { let n; function o(...i) { o.cancel(); n = setTimeout((() => t(...i)), e); } o.cancel = () => { clearTimeout(n); }; return o; }
        function oD(t) { if (t.is("editableElement")) {
            return null;
        } if (t.hasClass("ck-widget__selection-handle")) {
            return t.findAncestor(Jx);
        } if (Jx(t)) {
            return t;
        } const e = t.findAncestor((t => Jx(t) || t.is("editableElement"))); if (Jx(e)) {
            return e;
        } return null; }
        class iD extends Kn {
            static get pluginName() { return "PastePlainText"; }
            static get requires() { return [qx]; }
            init() { const t = this.editor; const e = t.model; const n = t.editing.view; const o = n.document; const i = e.document.selection; let r = false; n.addObserver(Ox); this.listenTo(o, "keydown", ((t, e) => { r = e.shiftKey; })); t.plugins.get(qx).on("contentInsertion", ((t, n) => { if (!r && !rD(n.content, e.schema)) {
                return;
            } e.change((t => { const o = Array.from(i.getAttributes()).filter((([t]) => e.schema.getAttributeProperties(t).isFormatting)); if (!i.isCollapsed) {
                e.deleteContent(i, { doNotAutoparagraph: true });
            } o.push(...i.getAttributes()); const r = t.createRangeIn(n.content); for (const e of r.getItems()) {
                if (e.is("$textProxy")) {
                    t.setAttributes(o, e);
                }
            } })); })); }
        }
        function rD(t, e) { if (t.childCount > 1) {
            return false;
        } const n = t.getChild(0); if (e.isObject(n)) {
            return false;
        } return [...n.getAttributeKeys()].length == 0; }
        class sD extends Kn {
            static get pluginName() { return "Clipboard"; }
            static get requires() { return [qx, UE, iD]; }
        }
        class aD extends Hn {
            execute() { const t = this.editor.model; const e = t.document.selection; let n = t.schema.getLimitElement(e); if (e.containsEntireContent(n) || !cD(t.schema, n)) {
                do {
                    n = n.parent;
                    if (!n) {
                        return;
                    }
                } while (!cD(t.schema, n));
            } t.change((t => { t.setSelection(n, "in"); })); }
        }
        function cD(t, e) { return t.isLimit(e) && (t.checkChild(e, "$text") || t.checkChild(e, "paragraph")); }
        const lD = od("Ctrl+A");
        class dD extends Kn {
            static get pluginName() { return "SelectAllEditing"; }
            init() { const t = this.editor; const e = t.editing.view; const n = e.document; t.commands.add("selectAll", new aD(t)); this.listenTo(n, "keydown", ((e, n) => { if (nd(n) === lD) {
                t.execute("selectAll");
                n.preventDefault();
            } })); }
        }
        var uD = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>';
        class hD extends Kn {
            static get pluginName() { return "SelectAllUI"; }
            init() { const t = this.editor; t.ui.componentFactory.add("selectAll", (e => { const n = t.commands.get("selectAll"); const o = new mw(e); const i = e.t; o.set({ label: i("Select all"), icon: uD, keystroke: "Ctrl+A", tooltip: true }); o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"); this.listenTo(o, "execute", (() => { t.execute("selectAll"); t.editing.view.focus(); })); return o; })); }
        }
        class fD extends Kn {
            static get requires() { return [dD, hD]; }
            static get pluginName() { return "SelectAll"; }
        }
        class pD extends Hn {
            constructor(t) { super(t); this._stack = []; this._createdBatches = new WeakSet; this.refresh(); this.listenTo(t.data, "set", (() => this.clearStack())); }
            refresh() { this.isEnabled = this._stack.length > 0; }
            addBatch(t) { const e = this.editor.model.document.selection; const n = { ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [], isBackward: e.isBackward }; this._stack.push({ batch: t, selection: n }); this.refresh(); }
            clearStack() { this._stack = []; this.refresh(); }
            _restoreSelection(t, e, n) { const o = this.editor.model; const i = o.document; const r = []; const s = t.map((t => t.getTransformedByOperations(n))); const a = s.flat(); for (const t of s) {
                const e = t.filter((t => t.root != i.graveyard)).filter((t => !mD(t, a)));
                if (!e.length) {
                    continue;
                }
                gD(e);
                r.push(e[0]);
            } if (r.length) {
                o.change((t => { t.setSelection(r, { backward: e }); }));
            } }
            _undo(t, e) { const n = this.editor.model; const o = n.document; this._createdBatches.add(e); const i = t.operations.slice().filter((t => t.isDocumentOperation)); i.reverse(); for (const t of i) {
                const i = t.baseVersion + 1;
                const r = Array.from(o.history.getOperations(i));
                const s = vA([t.getReversed()], r, { useRelations: true, document: this.editor.model.document, padWithNoOps: false, forceWeakRemove: true });
                const a = s.operationsA;
                for (const i of a) {
                    e.addOperation(i);
                    n.applyOperation(i);
                    o.history.setOperationAsUndone(t, i);
                }
            } }
        }
        function gD(t) { t.sort(((t, e) => t.start.isBefore(e.start) ? -1 : 1)); for (let e = 1; e < t.length; e++) {
            const n = t[e - 1];
            const o = n.getJoined(t[e], true);
            if (o) {
                e--;
                t.splice(e, 2, o);
            }
        } }
        function mD(t, e) { return e.some((e => e !== t && e.containsRange(t, true))); }
        class kD extends pD {
            execute(t = null) { const e = t ? this._stack.findIndex((e => e.batch == t)) : this._stack.length - 1; const n = this._stack.splice(e, 1)[0]; const o = this.editor.model.createBatch("transparent"); this.editor.model.enqueueChange(o, (() => { this._undo(n.batch, o); const t = this.editor.model.document.history.getOperations(n.batch.baseVersion); this._restoreSelection(n.selection.ranges, n.selection.isBackward, t); this.fire("revert", n.batch, o); })); this.refresh(); }
        }
        class bD extends pD {
            execute() { const t = this._stack.pop(); const e = this.editor.model.createBatch("transparent"); this.editor.model.enqueueChange(e, (() => { const n = t.batch.operations[t.batch.operations.length - 1]; const o = n.baseVersion + 1; const i = this.editor.model.document.history.getOperations(o); this._restoreSelection(t.selection.ranges, t.selection.isBackward, i); this._undo(t.batch, e); })); this.refresh(); }
        }
        class wD extends Kn {
            static get pluginName() { return "UndoEditing"; }
            constructor(t) { super(t); this._batchRegistry = new WeakSet; }
            init() { const t = this.editor; this._undoCommand = new kD(t); this._redoCommand = new bD(t); t.commands.add("undo", this._undoCommand); t.commands.add("redo", this._redoCommand); this.listenTo(t.model, "applyOperation", ((t, e) => { const n = e[0]; if (!n.isDocumentOperation) {
                return;
            } const o = n.batch; const i = this._redoCommand._createdBatches.has(o); const r = this._undoCommand._createdBatches.has(o); const s = this._batchRegistry.has(o); if (s || o.type == "transparent" && !i && !r) {
                return;
            }
            else {
                if (i) {
                    this._undoCommand.addBatch(o);
                }
                else if (!r) {
                    this._undoCommand.addBatch(o);
                    this._redoCommand.clearStack();
                }
            } this._batchRegistry.add(o); }), { priority: "highest" }); this.listenTo(this._undoCommand, "revert", ((t, e, n) => { this._redoCommand.addBatch(n); })); t.keystrokes.set("CTRL+Z", "undo"); t.keystrokes.set("CTRL+Y", "redo"); t.keystrokes.set("CTRL+SHIFT+Z", "redo"); }
        }
        var _D = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>';
        var vD = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
        class AD extends Kn {
            static get pluginName() { return "UndoUI"; }
            init() { const t = this.editor; const e = t.locale; const n = t.t; const o = e.uiLanguageDirection == "ltr" ? _D : vD; const i = e.uiLanguageDirection == "ltr" ? vD : _D; this._addButton("undo", n("Undo"), "CTRL+Z", o); this._addButton("redo", n("Redo"), "CTRL+Y", i); }
            _addButton(t, e, n, o) { const i = this.editor; i.ui.componentFactory.add(t, (r => { const s = i.commands.get(t); const a = new mw(r); a.set({ label: e, icon: o, keystroke: n, tooltip: true }); a.bind("isEnabled").to(s, "isEnabled"); this.listenTo(a, "execute", (() => { i.execute(t); i.editing.view.focus(); })); return a; })); }
        }
        class CD extends Kn {
            static get requires() { return [wD, AD]; }
            static get pluginName() { return "Undo"; }
        }
        class yD extends Kn {
            static get requires() { return [sD, sy, fD, hy, By, CD]; }
            static get pluginName() { return "Essentials"; }
        }
        class xD extends Hn {
            constructor(t, e) { super(t); this.attributeKey = e; }
            refresh() { const t = this.editor.model; const e = t.document; this.value = e.selection.getAttribute(this.attributeKey); this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey); }
            execute(t = {}) { const e = this.editor.model; const n = e.document; const o = n.selection; const i = t.value; e.change((t => { if (o.isCollapsed) {
                if (i) {
                    t.setSelectionAttribute(this.attributeKey, i);
                }
                else {
                    t.removeSelectionAttribute(this.attributeKey);
                }
            }
            else {
                const n = e.schema.getValidRanges(o.getRanges(), this.attributeKey);
                for (const e of n) {
                    if (i) {
                        t.setAttribute(this.attributeKey, i, e);
                    }
                    else {
                        t.removeAttribute(this.attributeKey, e);
                    }
                }
            } })); }
        }
        class ED extends ba {
            constructor(t) { super(t); this.set("isEmpty", true); this.on("change", (() => { this.set("isEmpty", this.length === 0); })); }
            add(t, e) { if (this.find((e => e.color === t.color))) {
                return;
            } super.add(t, e); }
            hasColor(t) { return !!this.find((e => e.color === t)); }
        }
        qn(ED, Pn);
        var DD = n(40);
        var SD = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        SD.insert = "head";
        SD.singleton = true;
        var TD = Ab()(DD["a"], SD);
        var PD = DD["a"].locals || {};
        class BD extends Db {
            constructor(t, { colors: e, columns: n, removeButtonLabel: o, documentColorsLabel: i, documentColorsCount: r }) { super(t); this.items = this.createCollection(); this.colorDefinitions = e; this.focusTracker = new kf; this.keystrokes = new bf; this.set("selectedColor"); this.removeButtonLabel = o; this.columns = n; this.documentColors = new ED; this.documentColorsCount = r; this._focusCycler = new Dw({ focusables: this.items, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "arrowup", focusNext: "arrowdown" } }); this._documentColorsLabel = i; this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-color-table"] }, children: this.items }); this.items.add(this._removeColorButton()); }
            updateDocumentColors(t, e) { const n = t.document; const o = this.documentColorsCount; this.documentColors.clear(); for (const i of n.getRootNames()) {
                const r = n.getRoot(i);
                const s = t.createRangeIn(r);
                for (const t of s.getItems()) {
                    if (t.is("$textProxy") && t.hasAttribute(e)) {
                        this._addColorToDocumentColors(t.getAttribute(e));
                        if (this.documentColors.length >= o) {
                            return;
                        }
                    }
                }
            } }
            updateSelectedColors() { const t = this.documentColorsGrid; const e = this.staticColorsGrid; const n = this.selectedColor; e.selectedColor = n; if (t) {
                t.selectedColor = n;
            } }
            render() { super.render(); for (const t of this.items) {
                this.focusTracker.add(t.element);
            } this.keystrokes.listenTo(this.element); }
            appendGrids() { if (this.staticColorsGrid) {
                return;
            } this.staticColorsGrid = this._createStaticColorsGrid(); this.items.add(this.staticColorsGrid); if (this.documentColorsCount) {
                const t = Tb.bind(this.documentColors, this.documentColors);
                const e = new H_(this.locale);
                e.text = this._documentColorsLabel;
                e.extendTemplate({ attributes: { class: ["ck", "ck-color-grid__label", t.if("isEmpty", "ck-hidden")] } });
                this.items.add(e);
                this.documentColorsGrid = this._createDocumentColorsGrid();
                this.items.add(this.documentColorsGrid);
            } }
            focus() { this._focusCycler.focusFirst(); }
            focusLast() { this._focusCycler.focusLast(); }
            _removeColorButton() { const t = new mw; t.set({ withText: true, icon: gb.eraser, tooltip: true, label: this.removeButtonLabel }); t.class = "ck-color-table__remove-color"; t.on("execute", (() => { this.fire("execute", { value: null }); })); return t; }
            _createStaticColorsGrid() { const t = new Rw(this.locale, { colorDefinitions: this.colorDefinitions, columns: this.columns }); t.delegate("execute").to(this); return t; }
            _createDocumentColorsGrid() { const t = Tb.bind(this.documentColors, this.documentColors); const e = new Rw(this.locale, { columns: this.columns }); e.delegate("execute").to(this); e.extendTemplate({ attributes: { class: t.if("isEmpty", "ck-hidden") } }); e.items.bindTo(this.documentColors).using((t => { const e = new Ew; e.set({ color: t.color, hasBorder: t.options && t.options.hasBorder }); if (t.label) {
                e.set({ label: t.label, tooltip: true });
            } e.on("execute", (() => { this.fire("execute", { value: t.color }); })); return e; })); this.documentColors.on("change:isEmpty", ((t, n, o) => { if (o) {
                e.selectedColor = null;
            } })); return e; }
            _addColorToDocumentColors(t) { const e = this.colorDefinitions.find((e => e.color === t)); if (!e) {
                this.documentColors.add({ color: t, label: t, options: { hasBorder: false } });
            }
            else {
                this.documentColors.add(Object.assign({}, e));
            } }
        }
        const ID = "fontSize";
        const RD = "fontFamily";
        const FD = "fontColor";
        const OD = "fontBackgroundColor";
        function zD(t, e) { const n = { model: { key: t, values: [] }, view: {}, upcastAlso: {} }; for (const t of e) {
            n.model.values.push(t.model);
            n.view[t.model] = t.view;
            if (t.upcastAlso) {
                n.upcastAlso[t.model] = t.upcastAlso;
            }
        } return n; }
        function ND(t) { return e => LD(e.getStyle(t)); }
        function MD(t) { return (e, { writer: n }) => n.createAttributeElement("span", { style: `${t}:${e}` }, { priority: 7 }); }
        function VD({ dropdownView: t, colors: e, columns: n, removeButtonLabel: o, documentColorsLabel: i, documentColorsCount: r }) { const s = t.locale; const a = new BD(s, { colors: e, columns: n, removeButtonLabel: o, documentColorsLabel: i, documentColorsCount: r }); t.colorTableView = a; t.panelView.children.add(a); a.delegate("execute").to(t, "execute"); return a; }
        function LD(t) { return t.replace(/\s/g, ""); }
        class qD extends xD {
            constructor(t) { super(t, FD); }
        }
        class KD extends Kn {
            static get pluginName() { return "FontColorEditing"; }
            constructor(t) { super(t); t.config.define(FD, { colors: [{ color: "hsl(0, 0%, 0%)", label: "Black" }, { color: "hsl(0, 0%, 30%)", label: "Dim grey" }, { color: "hsl(0, 0%, 60%)", label: "Grey" }, { color: "hsl(0, 0%, 90%)", label: "Light grey" }, { color: "hsl(0, 0%, 100%)", label: "White", hasBorder: true }, { color: "hsl(0, 75%, 60%)", label: "Red" }, { color: "hsl(30, 75%, 60%)", label: "Orange" }, { color: "hsl(60, 75%, 60%)", label: "Yellow" }, { color: "hsl(90, 75%, 60%)", label: "Light green" }, { color: "hsl(120, 75%, 60%)", label: "Green" }, { color: "hsl(150, 75%, 60%)", label: "Aquamarine" }, { color: "hsl(180, 75%, 60%)", label: "Turquoise" }, { color: "hsl(210, 75%, 60%)", label: "Light blue" }, { color: "hsl(240, 75%, 60%)", label: "Blue" }, { color: "hsl(270, 75%, 60%)", label: "Purple" }], columns: 5 }); t.conversion.for("upcast").elementToAttribute({ view: { name: "span", styles: { color: /[\s\S]+/ } }, model: { key: FD, value: ND("color") } }); t.conversion.for("upcast").elementToAttribute({ view: { name: "font", attributes: { color: /^#?\w+$/ } }, model: { key: FD, value: t => t.getAttribute("color") } }); t.conversion.for("downcast").attributeToElement({ model: FD, view: MD("color") }); t.commands.add(FD, new qD(t)); t.model.schema.extend("$text", { allowAttributes: FD }); t.model.schema.setAttributeProperties(FD, { isFormatting: true, copyOnEnter: true }); }
        }
        class jD extends Kn {
            constructor(t, { commandName: e, icon: n, componentName: o, dropdownLabel: i }) { super(t); this.commandName = e; this.componentName = o; this.icon = n; this.dropdownLabel = i; this.columns = t.config.get(`${this.componentName}.columns`); this.colorTableView = undefined; }
            init() { const t = this.editor; const e = t.locale; const n = e.t; const o = t.commands.get(this.commandName); const i = Cw(t.config.get(this.componentName).colors); const r = Aw(e, i); const s = t.config.get(`${this.componentName}.documentColors`); t.ui.componentFactory.add(this.componentName, (e => { const i = S_(e); this.colorTableView = VD({ dropdownView: i, colors: r.map((t => ({ label: t.label, color: t.model, options: { hasBorder: t.hasBorder } }))), columns: this.columns, removeButtonLabel: n("Remove color"), documentColorsLabel: s !== 0 ? n("Document colors") : undefined, documentColorsCount: s === undefined ? this.columns : s }); this.colorTableView.bind("selectedColor").to(o, "value"); i.buttonView.set({ label: this.dropdownLabel, icon: this.icon, tooltip: true }); i.extendTemplate({ attributes: { class: "ck-color-ui-dropdown" } }); i.bind("isEnabled").to(o); i.on("execute", ((e, n) => { t.execute(this.commandName, n); t.editing.view.focus(); })); i.on("change:isOpen", ((e, n, o) => { i.colorTableView.appendGrids(); if (o) {
                if (s !== 0) {
                    this.colorTableView.updateDocumentColors(t.model, this.componentName);
                }
                this.colorTableView.updateSelectedColors();
            } })); return i; })); }
        }
        var HD = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 10.3 10 4.5l-2.4 5.8h4.8zm.5 1.2H7.1L5.7 15H4.2l5-12h1.6l5 12h-1.5L13 11.5zm3.1 7H4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z"/></svg>';
        class WD extends jD {
            constructor(t) { const e = t.locale.t; super(t, { commandName: FD, componentName: FD, icon: HD, dropdownLabel: e("Font Color") }); }
            static get pluginName() { return "FontColorUI"; }
        }
        class $D extends Kn {
            static get requires() { return [KD, WD]; }
            static get pluginName() { return "FontColor"; }
        }
        class GD extends xD {
            constructor(t) { super(t, ID); }
        }
        function UD(t) { return t.map((t => YD(t))).filter((t => !!t)); }
        const JD = { get tiny() { return { title: "Tiny", model: "tiny", view: { name: "span", classes: "text-tiny", priority: 7 } }; }, get small() { return { title: "Small", model: "small", view: { name: "span", classes: "text-small", priority: 7 } }; }, get big() { return { title: "Big", model: "big", view: { name: "span", classes: "text-big", priority: 7 } }; }, get huge() { return { title: "Huge", model: "huge", view: { name: "span", classes: "text-huge", priority: 7 } }; } };
        function YD(t) { if (tS(t)) {
            return XD(t);
        } const e = ZD(t); if (e) {
            return XD(e);
        } if (t === "default") {
            return { model: undefined, title: "Default" };
        } if (eS(t)) {
            return;
        } return QD(t); }
        function QD(t) { if (typeof t === "number" || typeof t === "string") {
            t = { title: String(t), model: `${parseFloat(t)}px` };
        } t.view = { name: "span", styles: { "font-size": t.model } }; return XD(t); }
        function XD(t) { if (!t.view.priority) {
            t.view.priority = 7;
        } return t; }
        function ZD(t) { return JD[t] || JD[t.model]; }
        function tS(t) { return typeof t === "object" && t.title && t.model && t.view; }
        function eS(t) { let e; if (typeof t === "object") {
            if (!t.model) {
                throw new u["a"]("font-size-invalid-definition", null, t);
            }
            else {
                e = parseFloat(t.model);
            }
        }
        else {
            e = parseFloat(t);
        } return isNaN(e); }
        const nS = ["x-small", "x-small", "small", "medium", "large", "x-large", "xx-large", "xxx-large"];
        class oS extends Kn {
            static get pluginName() { return "FontSizeEditing"; }
            constructor(t) { super(t); t.config.define(ID, { options: ["tiny", "small", "default", "big", "huge"], supportAllValues: false }); }
            init() { const t = this.editor; t.model.schema.extend("$text", { allowAttributes: ID }); t.model.schema.setAttributeProperties(ID, { isFormatting: true, copyOnEnter: true }); const e = t.config.get("fontSize.supportAllValues"); const n = UD(this.editor.config.get("fontSize.options")).filter((t => t.model)); const o = zD(ID, n); if (e) {
                this._prepareAnyValueConverters(o);
                this._prepareCompatibilityConverter();
            }
            else {
                t.conversion.attributeToElement(o);
            } t.commands.add(ID, new GD(t)); }
            _prepareAnyValueConverters(t) { const e = this.editor; const n = t.model.values.filter((t => !KA(String(t)) && !HA(String(t)))); if (n.length) {
                throw new u["a"]("font-size-invalid-use-of-named-presets", null, { presets: n });
            } e.conversion.for("downcast").attributeToElement({ model: ID, view: (t, { writer: e }) => { if (!t) {
                    return;
                } return e.createAttributeElement("span", { style: "font-size:" + t }, { priority: 7 }); } }); e.conversion.for("upcast").elementToAttribute({ model: { key: ID, value: t => t.getStyle("font-size") }, view: { name: "span", styles: { "font-size": /.*/ } } }); }
            _prepareCompatibilityConverter() { const t = this.editor; t.conversion.for("upcast").elementToAttribute({ view: { name: "font", attributes: { size: /^[+-]?\d{1,3}$/ } }, model: { key: ID, value: t => { const e = t.getAttribute("size"); const n = e[0] === "-" || e[0] === "+"; let o = parseInt(e, 10); if (n) {
                        o = 3 + o;
                    } const i = nS.length - 1; const r = Math.min(Math.max(o, 0), i); return nS[r]; } } }); }
        }
        var iS = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13zm7.55 2.279.779-.779.707.707-2.265 2.265-2.193-2.265.707-.707.765.765V4.825c0-.042 0-.083.002-.123l-.77.77-.707-.707L17.207 2.5l2.265 2.265-.707.707-.782-.782c.002.043.003.089.003.135v10.454z"/></svg>';
        var rS = n(41);
        var sS = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        sS.insert = "head";
        sS.singleton = true;
        var aS = Ab()(rS["a"], sS);
        var cS = rS["a"].locals || {};
        class lS extends Kn {
            static get pluginName() { return "FontSizeUI"; }
            init() { const t = this.editor; const e = t.t; const n = this._getLocalizedOptions(); const o = t.commands.get(ID); t.ui.componentFactory.add(ID, (i => { const r = S_(i); P_(r, dS(n, o)); r.buttonView.set({ label: e("Font Size"), icon: iS, tooltip: true }); r.extendTemplate({ attributes: { class: ["ck-font-size-dropdown"] } }); r.bind("isEnabled").to(o); this.listenTo(r, "execute", (e => { t.execute(e.source.commandName, { value: e.source.commandParam }); t.editing.view.focus(); })); return r; })); }
            _getLocalizedOptions() { const t = this.editor; const e = t.t; const n = { Default: e("Default"), Tiny: e("Tiny"), Small: e("Small"), Big: e("Big"), Huge: e("Huge") }; const o = UD(t.config.get(ID).options); return o.map((t => { const e = n[t.title]; if (e && e != t.title) {
                t = Object.assign({}, t, { title: e });
            } return t; })); }
        }
        function dS(t, e) { const n = new ba; for (const o of t) {
            const t = { type: "button", model: new fv({ commandName: ID, commandParam: o.model, label: o.title, class: "ck-fontsize-option", withText: true }) };
            if (o.view && o.view.styles) {
                t.model.set("labelStyle", `font-size:${o.view.styles["font-size"]}`);
            }
            if (o.view && o.view.classes) {
                t.model.set("class", `${t.model.class} ${o.view.classes}`);
            }
            t.model.bind("isOn").to(e, "value", (t => t === o.model));
            n.add(t);
        } return n; }
        class uS extends Kn {
            static get requires() { return [oS, lS]; }
            static get pluginName() { return "FontSize"; }
        }
        class hS extends Hn {
            refresh() { const t = this.editor.model; const e = t.document; const n = mf(e.selection.getSelectedBlocks()); this.value = !!n && n.is("element", "paragraph"); this.isEnabled = !!n && fS(n, t.schema); }
            execute(t = {}) { const e = this.editor.model; const n = e.document; e.change((o => { const i = (t.selection || n.selection).getSelectedBlocks(); for (const t of i) {
                if (!t.is("element", "paragraph") && fS(t, e.schema)) {
                    o.rename(t, "paragraph");
                }
            } })); }
        }
        function fS(t, e) { return e.checkChild(t.parent, "paragraph") && !e.isObject(t); }
        class pS extends Hn {
            execute(t) { const e = this.editor.model; let n = t.position; e.change((t => { const o = t.createElement("paragraph"); if (!e.schema.checkChild(n.parent, o)) {
                const i = e.schema.findAllowedParent(n, o);
                if (!i) {
                    return;
                }
                n = t.split(n, i).position;
            } e.insertContent(o, n); t.setSelection(o, "in"); })); }
        }
        class gS extends Kn {
            static get pluginName() { return "Paragraph"; }
            init() { const t = this.editor; const e = t.model; t.commands.add("paragraph", new hS(t)); t.commands.add("insertParagraph", new pS(t)); e.schema.register("paragraph", { inheritAllFrom: "$block" }); t.conversion.elementToElement({ model: "paragraph", view: "p" }); t.conversion.for("upcast").elementToElement({ model: (t, { writer: e }) => { if (!gS.paragraphLikeElements.has(t.name)) {
                    return null;
                } if (t.isEmpty) {
                    return null;
                } return e.createElement("paragraph"); }, view: /.+/, converterPriority: "low" }); }
        }
        gS.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
        var mS = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>';
        class kS extends Kn {
            init() { const t = this.editor; const e = t.t; t.ui.componentFactory.add("paragraph", (n => { const o = new mw(n); const i = t.commands.get("paragraph"); o.label = e("Paragraph"); o.icon = mS; o.tooltip = true; o.isToggleable = true; o.bind("isEnabled").to(i); o.bind("isOn").to(i, "value"); o.on("execute", (() => { t.execute("paragraph"); })); return o; })); }
        }
        class bS extends Hn {
            constructor(t, e) { super(t); this.modelElements = e; }
            refresh() { const t = mf(this.editor.model.document.selection.getSelectedBlocks()); this.value = !!t && this.modelElements.includes(t.name) && t.name; this.isEnabled = !!t && this.modelElements.some((e => wS(t, e, this.editor.model.schema))); }
            execute(t) { const e = this.editor.model; const n = e.document; const o = t.value; e.change((t => { const i = Array.from(n.selection.getSelectedBlocks()).filter((t => wS(t, o, e.schema))); for (const e of i) {
                if (!e.is("element", o)) {
                    t.rename(e, o);
                }
            } })); }
        }
        function wS(t, e, n) { return n.checkChild(t.parent, e) && !n.isObject(t); }
        const _S = "paragraph";
        class vS extends Kn {
            static get pluginName() { return "HeadingEditing"; }
            constructor(t) { super(t); t.config.define("heading", { options: [{ model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" }, { model: "heading1", view: "h2", title: "Heading 1", class: "ck-heading_heading1" }, { model: "heading2", view: "h3", title: "Heading 2", class: "ck-heading_heading2" }, { model: "heading3", view: "h4", title: "Heading 3", class: "ck-heading_heading3" }] }); }
            static get requires() { return [gS]; }
            init() { const t = this.editor; const e = t.config.get("heading.options"); const n = []; for (const o of e) {
                if (o.model !== _S) {
                    t.model.schema.register(o.model, { inheritAllFrom: "$block" });
                    t.conversion.elementToElement(o);
                    n.push(o.model);
                }
            } this._addDefaultH1Conversion(t); t.commands.add("heading", new bS(t, n)); }
            afterInit() { const t = this.editor; const e = t.commands.get("enter"); const n = t.config.get("heading.options"); if (e) {
                this.listenTo(e, "afterExecute", ((e, o) => { const i = t.model.document.selection.getFirstPosition().parent; const r = n.some((t => i.is("element", t.model))); if (r && !i.is("element", _S) && i.childCount === 0) {
                    o.writer.rename(i, _S);
                } }));
            } }
            _addDefaultH1Conversion(t) { t.conversion.for("upcast").elementToElement({ model: "heading1", view: "h1", converterPriority: l.get("low") + 1 }); }
        }
        function AS(t) { const e = t.t; const n = { Paragraph: e("Paragraph"), "Heading 1": e("Heading 1"), "Heading 2": e("Heading 2"), "Heading 3": e("Heading 3"), "Heading 4": e("Heading 4"), "Heading 5": e("Heading 5"), "Heading 6": e("Heading 6") }; return t.config.get("heading.options").map((t => { const e = n[t.title]; if (e && e != t.title) {
            t.title = e;
        } return t; })); }
        var CS = n(42);
        var yS = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        yS.insert = "head";
        yS.singleton = true;
        var xS = Ab()(CS["a"], yS);
        var ES = CS["a"].locals || {};
        class DS extends Kn {
            static get pluginName() { return "HeadingUI"; }
            init() { const t = this.editor; const e = t.t; const n = AS(t); const o = e("Choose heading"); const i = e("Heading"); t.ui.componentFactory.add("heading", (e => { const r = {}; const s = new ba; const a = t.commands.get("heading"); const c = t.commands.get("paragraph"); const l = [a]; for (const t of n) {
                const e = { type: "button", model: new fv({ label: t.title, class: t.class, withText: true }) };
                if (t.model === "paragraph") {
                    e.model.bind("isOn").to(c, "value");
                    e.model.set("commandName", "paragraph");
                    l.push(c);
                }
                else {
                    e.model.bind("isOn").to(a, "value", (e => e === t.model));
                    e.model.set({ commandName: "heading", commandValue: t.model });
                }
                s.add(e);
                r[t.model] = t.title;
            } const d = S_(e); P_(d, s); d.buttonView.set({ isOn: false, withText: true, tooltip: i }); d.extendTemplate({ attributes: { class: ["ck-heading-dropdown"] } }); d.bind("isEnabled").toMany(l, "isEnabled", ((...t) => t.some((t => t)))); d.buttonView.bind("label").to(a, "value", c, "value", ((t, e) => { const n = t || e && "paragraph"; return r[n] ? r[n] : o; })); this.listenTo(d, "execute", (e => { t.execute(e.source.commandName, e.source.commandValue ? { value: e.source.commandValue } : undefined); t.editing.view.focus(); })); return d; })); }
        }
        class SS extends Kn {
            static get requires() { return [vS, DS]; }
            static get pluginName() { return "Heading"; }
        }
        class TS extends Kn {
            static get requires() { return [Ov]; }
            static get pluginName() { return "WidgetToolbarRepository"; }
            init() { const t = this.editor; if (t.plugins.has("BalloonToolbar")) {
                const e = t.plugins.get("BalloonToolbar");
                this.listenTo(e, "show", (e => { if (IS(t.editing.view.document.selection)) {
                    e.stop();
                } }), { priority: "high" });
            } this._toolbarDefinitions = new Map; this._balloon = this.editor.plugins.get("ContextualBalloon"); this.on("change:isEnabled", (() => { this._updateToolbarsVisibility(); })); this.listenTo(t.ui, "update", (() => { this._updateToolbarsVisibility(); })); this.listenTo(t.ui.focusTracker, "change:isFocused", (() => { this._updateToolbarsVisibility(); }), { priority: "low" }); }
            destroy() { super.destroy(); for (const t of this._toolbarDefinitions.values()) {
                t.view.destroy();
            } }
            register(t, { ariaLabel: e, items: n, getRelatedElement: o, balloonClassName: i = "ck-toolbar-container" }) { if (!n.length) {
                Object(u["b"])("widget-toolbar-no-items", { toolbarId: t });
                return;
            } const r = this.editor; const s = r.t; const a = new l_(r.locale); a.ariaLabel = e || s("Widget toolbar"); if (this._toolbarDefinitions.has(t)) {
                throw new u["a"]("widget-toolbar-duplicated", this, { toolbarId: t });
            } a.fillFromConfig(n, r.ui.componentFactory); this._toolbarDefinitions.set(t, { view: a, getRelatedElement: o, balloonClassName: i }); }
            _updateToolbarsVisibility() { let t = 0; let e = null; let n = null; for (const o of this._toolbarDefinitions.values()) {
                const i = o.getRelatedElement(this.editor.editing.view.document.selection);
                if (!this.isEnabled || !i) {
                    if (this._isToolbarInBalloon(o)) {
                        this._hideToolbar(o);
                    }
                }
                else if (!this.editor.ui.focusTracker.isFocused) {
                    if (this._isToolbarVisible(o)) {
                        this._hideToolbar(o);
                    }
                }
                else {
                    const r = i.getAncestors().length;
                    if (r > t) {
                        t = r;
                        e = i;
                        n = o;
                    }
                }
            } if (n) {
                this._showToolbar(n, e);
            } }
            _hideToolbar(t) { this._balloon.remove(t.view); this.stopListening(this._balloon, "change:visibleView"); }
            _showToolbar(t, e) { if (this._isToolbarVisible(t)) {
                PS(this.editor, e);
            }
            else if (!this._isToolbarInBalloon(t)) {
                this._balloon.add({ view: t.view, position: BS(this.editor, e), balloonClassName: t.balloonClassName });
                this.listenTo(this._balloon, "change:visibleView", (() => { for (const t of this._toolbarDefinitions.values()) {
                    if (this._isToolbarVisible(t)) {
                        const e = t.getRelatedElement(this.editor.editing.view.document.selection);
                        PS(this.editor, e);
                    }
                } }));
            } }
            _isToolbarVisible(t) { return this._balloon.visibleView === t.view; }
            _isToolbarInBalloon(t) { return this._balloon.hasView(t.view); }
        }
        function PS(t, e) { const n = t.plugins.get("ContextualBalloon"); const o = BS(t, e); n.updatePosition(o); }
        function BS(t, e) { const n = t.editing.view; const o = _v.defaultPositions; return { target: n.domConverter.mapViewToDom(e), positions: [o.northArrowSouth, o.northArrowSouthWest, o.northArrowSouthEast, o.southArrowNorth, o.southArrowNorthWest, o.southArrowNorthEast, sE] }; }
        function IS(t) { const e = t.getSelectedElement(); return !!(e && Jx(e)); }
        class RS {
            constructor(t) { this.set("activeHandlePosition", null); this.set("proposedWidthPercents", null); this.set("proposedWidth", null); this.set("proposedHeight", null); this.set("proposedHandleHostWidth", null); this.set("proposedHandleHostHeight", null); this._options = t; this._referenceCoordinates = null; }
            begin(t, e, n) { const o = new cf(e); this.activeHandlePosition = NS(t); this._referenceCoordinates = OS(e, MS(this.activeHandlePosition)); this.originalWidth = o.width; this.originalHeight = o.height; this.aspectRatio = o.width / o.height; const i = n.style.width; if (i && i.match(/^\d+(\.\d*)?%$/)) {
                this.originalWidthPercents = parseFloat(i);
            }
            else {
                this.originalWidthPercents = FS(n, o);
            } }
            update(t) { this.proposedWidth = t.width; this.proposedHeight = t.height; this.proposedWidthPercents = t.widthPercents; this.proposedHandleHostWidth = t.handleHostWidth; this.proposedHandleHostHeight = t.handleHostHeight; }
        }
        qn(RS, Pn);
        function FS(t, e) { const n = t.parentElement; const o = parseFloat(n.ownerDocument.defaultView.getComputedStyle(n).width); return e.width / o * 100; }
        function OS(t, e) { const n = new cf(t); const o = e.split("-"); const i = { x: o[1] == "right" ? n.right : n.left, y: o[0] == "bottom" ? n.bottom : n.top }; i.x += t.ownerDocument.defaultView.scrollX; i.y += t.ownerDocument.defaultView.scrollY; return i; }
        function zS(t) { return `ck-widget__resizer__handle-${t}`; }
        function NS(t) { const e = ["top-left", "top-right", "bottom-right", "bottom-left"]; for (const n of e) {
            if (t.classList.contains(zS(n))) {
                return n;
            }
        } }
        function MS(t) { const e = t.split("-"); const n = { top: "bottom", bottom: "top", left: "right", right: "left" }; return `${n[e[0]]}-${n[e[1]]}`; }
        class VS {
            constructor(t) { this._options = t; this._domResizerWrapper = null; this._viewResizerWrapper = null; this.set("isEnabled", true); this.decorate("begin"); this.decorate("cancel"); this.decorate("commit"); this.decorate("updateSize"); this.on("commit", (t => { if (!this.state.proposedWidth && !this.state.proposedWidthPercents) {
                this._cleanup();
                t.stop();
            } }), { priority: "high" }); this.on("change:isEnabled", (() => { if (this.isEnabled) {
                this.redraw();
            } })); }
            attach() { const t = this; const e = this._options.viewElement; const n = this._options.editor.editing.view; n.change((n => { const o = n.createUIElement("div", { class: "ck ck-reset_all ck-widget__resizer" }, (function (e) { const n = this.toDomElement(e); t._appendHandles(n); t._appendSizeUI(n); t._domResizerWrapper = n; t.on("change:isEnabled", ((t, e, o) => { n.style.display = o ? "" : "none"; })); n.style.display = t.isEnabled ? "" : "none"; return n; })); n.insert(n.createPositionAt(e, "end"), o); n.addClass("ck-widget_with-resizer", e); this._viewResizerWrapper = o; })); }
            begin(t) { this.state = new RS(this._options); this._sizeUI.bindToState(this._options, this.state); this._initialViewWidth = this._options.viewElement.getStyle("width"); this.state.begin(t, this._getHandleHost(), this._getResizeHost()); }
            updateSize(t) { const e = this._proposeNewSize(t); const n = this._options.editor.editing.view; n.change((t => { const n = this._options.unit || "%"; const o = (n === "%" ? e.widthPercents : e.width) + n; t.setStyle("width", o, this._options.viewElement); })); const o = this._getHandleHost(); const i = new cf(o); e.handleHostWidth = Math.round(i.width); e.handleHostHeight = Math.round(i.height); const r = new cf(o); e.width = Math.round(r.width); e.height = Math.round(r.height); this.redraw(i); this.state.update(e); }
            commit() { const t = this._options.unit || "%"; const e = (t === "%" ? this.state.proposedWidthPercents : this.state.proposedWidth) + t; this._options.editor.editing.view.change((() => { this._cleanup(); this._options.onCommit(e); })); }
            cancel() { this._cleanup(); }
            destroy() { this.cancel(); }
            redraw(t) { const e = this._domResizerWrapper; if (!jS(e)) {
                return;
            } const n = e.parentElement; const o = this._getHandleHost(); const i = this._viewResizerWrapper; const r = [i.getStyle("width"), i.getStyle("height"), i.getStyle("left"), i.getStyle("top")]; let s; if (n.isSameNode(o)) {
                const e = t || new cf(o);
                s = [e.width + "px", e.height + "px", undefined, undefined];
            }
            else {
                s = [o.offsetWidth + "px", o.offsetHeight + "px", o.offsetLeft + "px", o.offsetTop + "px"];
            } if (Ia(r, s) !== "same") {
                this._options.editor.editing.view.change((t => { t.setStyle({ width: s[0], height: s[1], left: s[2], top: s[3] }, i); }));
            } }
            containsHandle(t) { return this._domResizerWrapper.contains(t); }
            static isResizeHandle(t) { return t.classList.contains("ck-widget__resizer__handle"); }
            _cleanup() { this._sizeUI.dismiss(); this._sizeUI.isVisible = false; const t = this._options.editor.editing.view; t.change((t => { t.setStyle("width", this._initialViewWidth, this._options.viewElement); })); }
            _proposeNewSize(t) { const e = this.state; const n = KS(t); const o = this._options.isCentered ? this._options.isCentered(this) : true; const i = { x: e._referenceCoordinates.x - (n.x + e.originalWidth), y: n.y - e.originalHeight - e._referenceCoordinates.y }; if (o && e.activeHandlePosition.endsWith("-right")) {
                i.x = n.x - (e._referenceCoordinates.x + e.originalWidth);
            } if (o) {
                i.x *= 2;
            } const r = { width: Math.abs(e.originalWidth + i.x), height: Math.abs(e.originalHeight + i.y) }; r.dominant = r.width / e.aspectRatio > r.height ? "width" : "height"; r.max = r[r.dominant]; const s = { width: r.width, height: r.height }; if (r.dominant == "width") {
                s.height = s.width / e.aspectRatio;
            }
            else {
                s.width = s.height * e.aspectRatio;
            } return { width: Math.round(s.width), height: Math.round(s.height), widthPercents: Math.min(Math.round(e.originalWidthPercents / e.originalWidth * s.width * 100) / 100, 100) }; }
            _getResizeHost() { const t = this._domResizerWrapper.parentElement; return this._options.getResizeHost(t); }
            _getHandleHost() { const t = this._domResizerWrapper.parentElement; return this._options.getHandleHost(t); }
            _appendHandles(t) { const e = ["top-left", "top-right", "bottom-right", "bottom-left"]; for (const n of e) {
                t.appendChild(new Tb({ tag: "div", attributes: { class: `ck-widget__resizer__handle ${qS(n)}` } }).render());
            } }
            _appendSizeUI(t) { const e = new LS; e.render(); this._sizeUI = e; t.appendChild(e.element); }
        }
        qn(VS, Pn);
        class LS extends Db {
            constructor() { super(); const t = this.bindTemplate; this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-size-view", t.to("activeHandlePosition", (t => t ? `ck-orientation-${t}` : ""))], style: { display: t.if("isVisible", "none", (t => !t)) } }, children: [{ text: t.to("label") }] }); }
            bindToState(t, e) { this.bind("isVisible").to(e, "proposedWidth", e, "proposedHeight", ((t, e) => t !== null && e !== null)); this.bind("label").to(e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", e, "proposedWidthPercents", ((e, n, o) => { if (t.unit === "px") {
                return `${e}×${n}`;
            }
            else {
                return `${o}%`;
            } })); this.bind("activeHandlePosition").to(e); }
            dismiss() { this.unbind(); this.isVisible = false; }
        }
        function qS(t) { return `ck-widget__resizer__handle-${t}`; }
        function KS(t) { return { x: t.pageX, y: t.pageY }; }
        function jS(t) { return t && t.ownerDocument && t.ownerDocument.contains(t); }
        var HS = n(43);
        var WS = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        WS.insert = "head";
        WS.singleton = true;
        var $S = Ab()(HS["a"], WS);
        var GS = HS["a"].locals || {};
        class US extends Kn {
            static get pluginName() { return "WidgetResize"; }
            init() { this.set("visibleResizer", null); this.set("_activeResizer", null); this._resizers = new Map; const t = su.window.document; this.editor.model.schema.setAttributeProperties("width", { isFormatting: true }); this.editor.editing.view.addObserver(PA); this._observer = Object.create(_u); this.listenTo(this.editor.editing.view.document, "mousedown", this._mouseDownListener.bind(this), { priority: "high" }); this._observer.listenTo(t, "mousemove", this._mouseMoveListener.bind(this)); this._observer.listenTo(t, "mouseup", this._mouseUpListener.bind(this)); const e = () => { if (this.visibleResizer) {
                this.visibleResizer.redraw();
            } }; const n = jE(e, 200); this.on("change:visibleResizer", e); this.editor.ui.on("update", n); this._observer.listenTo(su.window, "resize", n); const o = this.editor.editing.view.document.selection; o.on("change", (() => { const t = o.getSelectedElement(); this.visibleResizer = this.getResizerByViewElement(t) || null; })); }
            destroy() { this._observer.stopListening(); for (const t of this._resizers.values()) {
                t.destroy();
            } }
            attachTo(t) { const e = new VS(t); const n = this.editor.plugins; e.attach(); if (n.has("WidgetToolbarRepository")) {
                const t = n.get("WidgetToolbarRepository");
                e.on("begin", (() => { t.forceDisabled("resize"); }), { priority: "lowest" });
                e.on("cancel", (() => { t.clearForceDisabled("resize"); }), { priority: "highest" });
                e.on("commit", (() => { t.clearForceDisabled("resize"); }), { priority: "highest" });
            } this._resizers.set(t.viewElement, e); const o = this.editor.editing.view.document.selection; const i = o.getSelectedElement(); if (this.getResizerByViewElement(i) == e) {
                this.visibleResizer = e;
            } return e; }
            getResizerByViewElement(t) { return this._resizers.get(t); }
            _getResizerByHandle(t) { for (const e of this._resizers.values()) {
                if (e.containsHandle(t)) {
                    return e;
                }
            } }
            _mouseDownListener(t, e) { const n = e.domTarget; if (!VS.isResizeHandle(n)) {
                return;
            } this._activeResizer = this._getResizerByHandle(n); if (this._activeResizer) {
                this._activeResizer.begin(n);
                t.stop();
                e.preventDefault();
            } }
            _mouseMoveListener(t, e) { if (this._activeResizer) {
                this._activeResizer.updateSize(e);
            } }
            _mouseUpListener() { if (this._activeResizer) {
                this._activeResizer.commit();
                this._activeResizer = null;
            } }
        }
        qn(US, Pn);
        class JS extends Cu {
            observe(t) { this.listenTo(t, "load", ((t, e) => { const n = e.target; if (this.checkShouldIgnoreEventFromTarget(n)) {
                return;
            } if (n.tagName == "IMG") {
                this._fireEvents(e);
            } }), { useCapture: true }); }
            _fireEvents(t) { if (this.isEnabled) {
                this.document.fire("layoutChanged");
                this.document.fire("imageLoaded", t);
            } }
        }
        function YS(t, e, n) { e.setCustomProperty("image", true, t); return Yx(t, e, { label: o }); function o() { const e = nT(t); const o = e.getAttribute("alt"); return o ? `${o} ${n}` : n; } }
        function QS(t) { return !!t.getCustomProperty("image") && Jx(t); }
        function XS(t) { const e = t.getSelectedElement(); if (e && QS(e)) {
            return e;
        } return null; }
        function ZS(t) { return !!t && t.is("element", "image"); }
        function tT(t, e = {}, n = null) { t.change((o => { const i = o.createElement("image", e); const r = n || oE(t.document.selection, t); t.insertContent(i, r); if (i.parent) {
            o.setSelection(i, "on");
        } })); }
        function eT(t) { const e = t.schema; const n = t.document.selection; return oT(n, e, t) && !iE(n, e) && iT(n); }
        function nT(t) { const e = []; for (const n of t.getChildren()) {
            e.push(n);
            if (n.is("element")) {
                e.push(...n.getChildren());
            }
        } return e.find((t => t.is("element", "img"))); }
        function oT(t, e, n) { const o = rT(t, n); return e.checkChild(o, "image"); }
        function iT(t) { return [...t.focus.getAncestors()].every((t => !t.is("element", "image"))); }
        function rT(t, e) { const n = oE(t, e); const o = n.parent; if (o.isEmpty && !o.is("element", "$root")) {
            return o.parent;
        } return o; }
        function sT() { return e => { e.on("element:figure", t); }; function t(t, e, n) { if (!n.consumable.test(e.viewItem, { name: true, classes: "image" })) {
            return;
        } const o = nT(e.viewItem); if (!o || !o.hasAttribute("src") || !n.consumable.test(o, { name: true })) {
            return;
        } const i = n.convertItem(o, e.modelCursor); const r = mf(i.modelRange.getItems()); if (!r) {
            return;
        } n.convertChildren(e.viewItem, r); n.updateConversionResult(r, e); } }
        function aT() { return e => { e.on("attribute:srcset:image", t); }; function t(t, e, n) { if (!n.consumable.consume(e.item, t.name)) {
            return;
        } const o = n.writer; const i = n.mapper.toViewElement(e.item); const r = nT(i); if (e.attributeNewValue === null) {
            const t = e.attributeOldValue;
            if (t.data) {
                o.removeAttribute("srcset", r);
                o.removeAttribute("sizes", r);
                if (t.width) {
                    o.removeAttribute("width", r);
                }
            }
        }
        else {
            const t = e.attributeNewValue;
            if (t.data) {
                o.setAttribute("srcset", t.data, r);
                o.setAttribute("sizes", "100vw", r);
                if (t.width) {
                    o.setAttribute("width", t.width, r);
                }
            }
        } } }
        function cT(t) { return n => { n.on(`attribute:${t}:image`, e); }; function e(t, e, n) { if (!n.consumable.consume(e.item, t.name)) {
            return;
        } const o = n.writer; const i = n.mapper.toViewElement(e.item); const r = nT(i); o.setAttribute(e.attributeKey, e.attributeNewValue || "", r); } }
        class lT extends Hn {
            refresh() { this.isEnabled = eT(this.editor.model); }
            execute(t) { const e = this.editor.model; for (const n of _a(t.source)) {
                tT(e, { src: n });
            } }
        }
        class dT extends Kn {
            static get pluginName() { return "ImageEditing"; }
            init() { const t = this.editor; const e = t.model.schema; const n = t.t; const o = t.conversion; t.editing.view.addObserver(JS); e.register("image", { isObject: true, isBlock: true, allowWhere: "$block", allowAttributes: ["alt", "src", "srcset"] }); o.for("dataDowncast").elementToElement({ model: "image", view: (t, { writer: e }) => uT(e) }); o.for("editingDowncast").elementToElement({ model: "image", view: (t, { writer: e }) => YS(uT(e), e, n("image widget")) }); o.for("downcast").add(cT("src")).add(cT("alt")).add(aT()); o.for("upcast").elementToElement({ view: { name: "img", attributes: { src: true } }, model: (t, { writer: e }) => e.createElement("image", { src: t.getAttribute("src") }) }).attributeToAttribute({ view: { name: "img", key: "alt" }, model: "alt" }).attributeToAttribute({ view: { name: "img", key: "srcset" }, model: { key: "srcset", value: t => { const e = { data: t.getAttribute("srcset") }; if (t.hasAttribute("width")) {
                        e.width = t.getAttribute("width");
                    } return e; } } }).add(sT()); const i = new lT(t); t.commands.add("insertImage", i); t.commands.add("imageInsert", i); }
        }
        function uT(t) { const e = t.createEmptyElement("img"); const n = t.createContainerElement("figure", { class: "image" }); t.insert(t.createPositionAt(n, 0), e); return n; }
        class hT extends Hn {
            refresh() { const t = this.editor.model.document.selection.getSelectedElement(); this.isEnabled = ZS(t); if (ZS(t) && t.hasAttribute("alt")) {
                this.value = t.getAttribute("alt");
            }
            else {
                this.value = false;
            } }
            execute(t) { const e = this.editor.model; const n = e.document.selection.getSelectedElement(); e.change((e => { e.setAttribute("alt", t.newValue, n); })); }
        }
        class fT extends Kn {
            static get pluginName() { return "ImageTextAlternativeEditing"; }
            init() { this.editor.commands.add("imageTextAlternative", new hT(this.editor)); }
        }
        var pT = n(44);
        var gT = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        gT.insert = "head";
        gT.singleton = true;
        var mT = Ab()(pT["a"], gT);
        var kT = pT["a"].locals || {};
        var bT = n(45);
        var wT = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        wT.insert = "head";
        wT.singleton = true;
        var _T = Ab()(bT["a"], wT);
        var vT = bT["a"].locals || {};
        class AT extends Db {
            constructor(t) { super(t); const e = this.locale.t; this.focusTracker = new kf; this.keystrokes = new bf; this.labeledInput = this._createLabeledInputView(); this.saveButtonView = this._createButton(e("Save"), gb.check, "ck-button-save"); this.saveButtonView.type = "submit"; this.cancelButtonView = this._createButton(e("Cancel"), gb.cancel, "ck-button-cancel", "cancel"); this._focusables = new wb; this._focusCycler = new Dw({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }); this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-text-alternative-form", "ck-responsive-form"], tabindex: "-1" }, children: [this.labeledInput, this.saveButtonView, this.cancelButtonView] }); kb(this); }
            render() { super.render(); this.keystrokes.listenTo(this.element); bb({ view: this }); [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach((t => { this._focusables.add(t); this.focusTracker.add(t.element); })); }
            _createButton(t, e, n, o) { const i = new mw(this.locale); i.set({ label: t, icon: e, tooltip: true }); i.extendTemplate({ attributes: { class: n } }); if (o) {
                i.delegate("execute").to(this, o);
            } return i; }
            _createLabeledInputView() { const t = this.locale.t; const e = new lv(this.locale, dv); e.label = t("Text alternative"); return e; }
        }
        function CT(t) { const e = t.plugins.get("ContextualBalloon"); if (XS(t.editing.view.document.selection)) {
            const n = yT(t);
            e.updatePosition(n);
        } }
        function yT(t) { const e = t.editing.view; const n = _v.defaultPositions; return { target: e.domConverter.viewToDom(e.document.selection.getSelectedElement()), positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast] }; }
        class xT extends Kn {
            static get requires() { return [Ov]; }
            static get pluginName() { return "ImageTextAlternativeUI"; }
            init() { this._createButton(); this._createForm(); }
            destroy() { super.destroy(); this._form.destroy(); }
            _createButton() { const t = this.editor; const e = t.t; t.ui.componentFactory.add("imageTextAlternative", (n => { const o = t.commands.get("imageTextAlternative"); const i = new mw(n); i.set({ label: e("Change image text alternative"), icon: gb.lowVision, tooltip: true }); i.bind("isEnabled").to(o, "isEnabled"); this.listenTo(i, "execute", (() => { this._showForm(); })); return i; })); }
            _createForm() { const t = this.editor; const e = t.editing.view; const n = e.document; this._balloon = this.editor.plugins.get("ContextualBalloon"); this._form = new AT(t.locale); this._form.render(); this.listenTo(this._form, "submit", (() => { t.execute("imageTextAlternative", { newValue: this._form.labeledInput.fieldView.element.value }); this._hideForm(true); })); this.listenTo(this._form, "cancel", (() => { this._hideForm(true); })); this._form.keystrokes.set("Esc", ((t, e) => { this._hideForm(true); e(); })); this.listenTo(t.ui, "update", (() => { if (!XS(n.selection)) {
                this._hideForm(true);
            }
            else if (this._isVisible) {
                CT(t);
            } })); mb({ emitter: this._form, activator: () => this._isVisible, contextElements: [this._balloon.view.element], callback: () => this._hideForm() }); }
            _showForm() { if (this._isVisible) {
                return;
            } const t = this.editor; const e = t.commands.get("imageTextAlternative"); const n = this._form.labeledInput; this._form.disableCssTransitions(); if (!this._isInBalloon) {
                this._balloon.add({ view: this._form, position: yT(t) });
            } n.fieldView.value = n.fieldView.element.value = e.value || ""; this._form.labeledInput.fieldView.select(); this._form.enableCssTransitions(); }
            _hideForm(t) { if (!this._isInBalloon) {
                return;
            } if (this._form.focusTracker.isFocused) {
                this._form.saveButtonView.focus();
            } this._balloon.remove(this._form); if (t) {
                this.editor.editing.view.focus();
            } }
            get _isVisible() { return this._balloon.visibleView === this._form; }
            get _isInBalloon() { return this._balloon.hasView(this._form); }
        }
        class ET extends Kn {
            static get requires() { return [fT, xT]; }
            static get pluginName() { return "ImageTextAlternative"; }
        }
        var DT = n(46);
        var ST = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        ST.insert = "head";
        ST.singleton = true;
        var TT = Ab()(DT["a"], ST);
        var PT = DT["a"].locals || {};
        class BT extends Kn {
            static get requires() { return [dT, ME, ET]; }
            static get pluginName() { return "Image"; }
            isImageWidget(t) { return QS(t); }
        }
        function IT(t, e) { return n => { const o = n.createEditableElement("figcaption"); n.setCustomProperty("imageCaption", true, o); cA({ view: t, element: o, text: e }); return nE(o, n); }; }
        function RT(t) { return !!t.getCustomProperty("imageCaption"); }
        function FT(t) { for (const e of t.getChildren()) {
            if (!!e && e.is("element", "caption")) {
                return e;
            }
        } return null; }
        function OT(t) { const e = t.parent; if (t.name == "figcaption" && e && e.name == "figure" && e.hasClass("image")) {
            return { name: true };
        } return null; }
        class zT extends Kn {
            static get pluginName() { return "ImageCaptionEditing"; }
            init() { const t = this.editor; const e = t.editing.view; const n = t.model.schema; const o = t.data; const i = t.editing; const r = t.t; n.register("caption", { allowIn: "image", allowContentOf: "$block", isLimit: true }); t.model.document.registerPostFixer((t => this._insertMissingModelCaptionElement(t))); t.conversion.for("upcast").elementToElement({ view: OT, model: "caption" }); const s = t => t.createContainerElement("figcaption"); o.downcastDispatcher.on("insert:caption", NT(s, false)); const a = IT(e, r("Enter image caption")); i.downcastDispatcher.on("insert:caption", NT(a)); i.downcastDispatcher.on("insert", this._fixCaptionVisibility((t => t.item)), { priority: "high" }); i.downcastDispatcher.on("remove", this._fixCaptionVisibility((t => t.position.parent)), { priority: "high" }); e.document.registerPostFixer((t => this._updateCaptionVisibility(t))); }
            _updateCaptionVisibility(t) { const e = this.editor.editing.mapper; const n = this._lastSelectedCaption; let o; const i = this.editor.model.document.selection; const r = i.getSelectedElement(); if (r && r.is("element", "image")) {
                const t = FT(r);
                o = e.toViewElement(t);
            } const s = i.getFirstPosition(); const a = VT(s.parent); if (a) {
                o = e.toViewElement(a);
            } if (o && !this.editor.isReadOnly) {
                if (n) {
                    if (n === o) {
                        return qT(o, t);
                    }
                    else {
                        LT(n, t);
                        this._lastSelectedCaption = o;
                        return qT(o, t);
                    }
                }
                else {
                    this._lastSelectedCaption = o;
                    return qT(o, t);
                }
            }
            else {
                if (n) {
                    const e = LT(n, t);
                    this._lastSelectedCaption = null;
                    return e;
                }
                else {
                    return false;
                }
            } }
            _fixCaptionVisibility(t) { return (e, n, o) => { const i = t(n); const r = VT(i); const s = this.editor.editing.mapper; const a = o.writer; if (r) {
                const t = s.toViewElement(r);
                if (t) {
                    if (r.childCount) {
                        a.removeClass("ck-hidden", t);
                    }
                    else {
                        a.addClass("ck-hidden", t);
                    }
                }
            } }; }
            _insertMissingModelCaptionElement(t) { const e = this.editor.model; const n = e.document.differ.getChanges(); const o = []; for (const t of n) {
                if (t.type == "insert" && t.name != "$text") {
                    const n = t.position.nodeAfter;
                    if (n.is("element", "image") && !FT(n)) {
                        o.push(n);
                    }
                    if (!n.is("element", "image") && n.childCount) {
                        for (const t of e.createRangeIn(n).getItems()) {
                            if (t.is("element", "image") && !FT(t)) {
                                o.push(t);
                            }
                        }
                    }
                }
            } for (const e of o) {
                t.appendElement("caption", e);
            } return !!o.length; }
        }
        function NT(t, e = true) { return (n, o, i) => { const r = o.item; if (!r.childCount && !e) {
            return;
        } if (ZS(r.parent)) {
            if (!i.consumable.consume(o.item, "insert")) {
                return;
            }
            const e = i.mapper.toViewElement(o.range.start.parent);
            const n = t(i.writer);
            const s = i.writer;
            if (!r.childCount) {
                s.addClass("ck-hidden", n);
            }
            MT(n, o.item, e, i);
        } }; }
        function MT(t, e, n, o) { const i = o.writer.createPositionAt(n, "end"); o.writer.insert(i, t); o.mapper.bindElements(e, t); }
        function VT(t) { const e = t.getAncestors({ includeSelf: true }); const n = e.find((t => t.name == "caption")); if (n && n.parent && n.parent.name == "image") {
            return n;
        } return null; }
        function LT(t, e) { if (!t.childCount && !t.hasClass("ck-hidden")) {
            e.addClass("ck-hidden", t);
            return true;
        } return false; }
        function qT(t, e) { if (t.hasClass("ck-hidden")) {
            e.removeClass("ck-hidden", t);
            return true;
        } return false; }
        var KT = n(47);
        var jT = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        jT.insert = "head";
        jT.singleton = true;
        var HT = Ab()(KT["a"], jT);
        var WT = KT["a"].locals || {};
        class $T extends Kn {
            static get requires() { return [zT]; }
            static get pluginName() { return "ImageCaption"; }
        }
        class GT extends Hn {
            refresh() { const t = this.editor.model.document.selection.getSelectedElement(); this.isEnabled = ZS(t); if (!t || !t.hasAttribute("width")) {
                this.value = null;
            }
            else {
                this.value = { width: t.getAttribute("width"), height: null };
            } }
            execute(t) { const e = this.editor.model; const n = e.document.selection.getSelectedElement(); this.value = { width: t.width, height: null }; if (n) {
                e.change((e => { e.setAttribute("width", t.width, n); }));
            } }
        }
        class UT extends Kn {
            static get pluginName() { return "ImageResizeEditing"; }
            constructor(t) { super(t); t.config.define("image", { resizeUnit: "%", resizeOptions: [{ name: "resizeImage:original", value: null, icon: "original" }, { name: "resizeImage:25", value: "25", icon: "small" }, { name: "resizeImage:50", value: "50", icon: "medium" }, { name: "resizeImage:75", value: "75", icon: "large" }] }); }
            init() { const t = this.editor; const e = new GT(t); this._registerSchema(); this._registerConverters(); t.commands.add("resizeImage", e); t.commands.add("imageResize", e); }
            _registerSchema() { this.editor.model.schema.extend("image", { allowAttributes: "width" }); this.editor.model.schema.setAttributeProperties("width", { isFormatting: true }); }
            _registerConverters() { const t = this.editor; t.conversion.for("downcast").add((t => t.on("attribute:width:image", ((t, e, n) => { if (!n.consumable.consume(e.item, t.name)) {
                return;
            } const o = n.writer; const i = n.mapper.toViewElement(e.item); if (e.attributeNewValue !== null) {
                o.setStyle("width", e.attributeNewValue, i);
                o.addClass("image_resized", i);
            }
            else {
                o.removeStyle("width", i);
                o.removeClass("image_resized", i);
            } })))); t.conversion.for("upcast").attributeToAttribute({ view: { name: "figure", styles: { width: /.+/ } }, model: { key: "width", value: t => t.getStyle("width") } }); }
        }
        const JT = { small: gb.objectSizeSmall, medium: gb.objectSizeMedium, large: gb.objectSizeLarge, original: gb.objectSizeFull };
        class YT extends Kn {
            static get requires() { return [UT]; }
            static get pluginName() { return "ImageResizeButtons"; }
            constructor(t) { super(t); this._resizeUnit = t.config.get("image.resizeUnit"); }
            init() { const t = this.editor; const e = t.config.get("image.resizeOptions"); const n = t.commands.get("resizeImage"); this.bind("isEnabled").to(n); for (const t of e) {
                this._registerImageResizeButton(t);
            } this._registerImageResizeDropdown(e); }
            _registerImageResizeButton(t) { const e = this.editor; const { name: n, value: o, icon: i } = t; const r = o ? o + this._resizeUnit : null; e.ui.componentFactory.add(n, (n => { const o = new mw(n); const s = e.commands.get("resizeImage"); const a = this._getOptionLabelValue(t, true); if (!JT[i]) {
                throw new u["a"]("imageresizebuttons-missing-icon", e, t);
            } o.set({ label: a, icon: JT[i], tooltip: a, isToggleable: true }); o.bind("isEnabled").to(this); o.bind("isOn").to(s, "value", QT(r)); this.listenTo(o, "execute", (() => { e.execute("resizeImage", { width: r }); })); return o; })); }
            _registerImageResizeDropdown(t) { const e = this.editor; const n = e.t; const o = t.find((t => !t.value)); const i = i => { const r = e.commands.get("resizeImage"); const s = S_(i, Ow); const a = s.buttonView; a.set({ tooltip: n("Resize image"), commandValue: o.value, icon: JT.medium, isToggleable: true, label: this._getOptionLabelValue(o), withText: true, class: "ck-resize-image-button" }); a.bind("label").to(r, "value", (t => { if (t && t.width) {
                return t.width;
            }
            else {
                return this._getOptionLabelValue(o);
            } })); s.bind("isOn").to(r); s.bind("isEnabled").to(this); P_(s, this._getResizeDropdownListItemDefinitions(t, r)); s.listView.ariaLabel = n("Image resize list"); this.listenTo(s, "execute", (t => { e.execute(t.source.commandName, { width: t.source.commandValue }); e.editing.view.focus(); })); return s; }; e.ui.componentFactory.add("resizeImage", i); e.ui.componentFactory.add("imageResize", i); }
            _getOptionLabelValue(t, e) { const n = this.editor.t; if (t.label) {
                return t.label;
            }
            else if (e) {
                if (t.value) {
                    return n("Resize image to %0", t.value + this._resizeUnit);
                }
                else {
                    return n("Resize image to the original size");
                }
            }
            else {
                if (t.value) {
                    return t.value + this._resizeUnit;
                }
                else {
                    return n("Original");
                }
            } }
            _getResizeDropdownListItemDefinitions(t, e) { const n = new ba; t.map((t => { const o = t.value ? t.value + this._resizeUnit : null; const i = { type: "button", model: new fv({ commandName: "resizeImage", commandValue: o, label: this._getOptionLabelValue(t), withText: true, icon: null }) }; i.model.bind("isOn").to(e, "value", QT(o)); n.add(i); })); return n; }
        }
        function QT(t) { return e => { if (t === null && e === t) {
            return true;
        } return e && e.width === t; }; }
        class XT extends Kn {
            static get requires() { return [US]; }
            static get pluginName() { return "ImageResizeHandles"; }
            init() { const t = this.editor.commands.get("resizeImage"); this.bind("isEnabled").to(t); this._setupResizerCreator(); }
            _setupResizerCreator() { const t = this.editor; const e = t.editing.view; e.addObserver(JS); this.listenTo(e.document, "imageLoaded", ((n, o) => { if (!o.target.matches("figure.image.ck-widget > img, figure.image.ck-widget > a > img")) {
                return;
            } const i = t.editing.view.domConverter.domToView(o.target); const r = i.findAncestor("figure"); let s = this.editor.plugins.get(US).getResizerByViewElement(r); if (s) {
                s.redraw();
                return;
            } const a = t.editing.mapper; const c = a.toModelElement(r); s = t.plugins.get(US).attachTo({ unit: t.config.get("image.resizeUnit"), modelElement: c, viewElement: r, editor: t, getHandleHost(t) { return t.querySelector("img"); }, getResizeHost(t) { return t; }, isCentered() { const t = c.getAttribute("imageStyle"); return !t || t == "full" || t == "alignCenter"; }, onCommit(e) { t.execute("resizeImage", { width: e }); } }); s.on("updateSize", (() => { if (!r.hasClass("image_resized")) {
                e.change((t => { t.addClass("image_resized", r); }));
            } })); s.bind("isEnabled").to(this); })); }
        }
        var ZT = n(48);
        var tP = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        tP.insert = "head";
        tP.singleton = true;
        var eP = Ab()(ZT["a"], tP);
        var nP = ZT["a"].locals || {};
        class oP extends Kn {
            static get requires() { return [UT, XT, YT]; }
            static get pluginName() { return "ImageResize"; }
        }
        class iP extends Hn {
            constructor(t, e) { super(t); this.defaultStyle = false; this.styles = e.reduce(((t, e) => { t[e.name] = e; if (e.isDefault) {
                this.defaultStyle = e.name;
            } return t; }), {}); }
            refresh() { const t = this.editor.model.document.selection.getSelectedElement(); this.isEnabled = ZS(t); if (!t) {
                this.value = false;
            }
            else if (t.hasAttribute("imageStyle")) {
                const e = t.getAttribute("imageStyle");
                this.value = this.styles[e] ? e : false;
            }
            else {
                this.value = this.defaultStyle;
            } }
            execute(t) { const e = t.value; const n = this.editor.model; const o = n.document.selection.getSelectedElement(); n.change((t => { if (this.styles[e].isDefault) {
                t.removeAttribute("imageStyle", o);
            }
            else {
                t.setAttribute("imageStyle", e, o);
            } })); }
        }
        function rP(t) { return (e, n, o) => { if (!o.consumable.consume(n.item, e.name)) {
            return;
        } const i = aP(n.attributeNewValue, t); const r = aP(n.attributeOldValue, t); const s = o.mapper.toViewElement(n.item); const a = o.writer; if (r) {
            a.removeClass(r.className, s);
        } if (i) {
            a.addClass(i.className, s);
        } }; }
        function sP(t) { const e = t.filter((t => !t.isDefault)); return (t, n, o) => { if (!n.modelRange) {
            return;
        } const i = n.viewItem; const r = mf(n.modelRange.getItems()); if (r && !o.schema.checkAttribute(r, "imageStyle")) {
            return;
        } for (const t of e) {
            if (o.consumable.consume(i, { classes: t.className })) {
                o.writer.setAttribute("imageStyle", t.name, r);
            }
        } }; }
        function aP(t, e) { for (const n of e) {
            if (n.name === t) {
                return n;
            }
        } }
        const cP = { full: { name: "full", title: "Full size image", icon: gb.objectFullWidth, isDefault: true }, side: { name: "side", title: "Side image", icon: gb.objectRight, className: "image-style-side" }, alignLeft: { name: "alignLeft", title: "Left aligned image", icon: gb.objectLeft, className: "image-style-align-left" }, alignCenter: { name: "alignCenter", title: "Centered image", icon: gb.objectCenter, className: "image-style-align-center" }, alignRight: { name: "alignRight", title: "Right aligned image", icon: gb.objectRight, className: "image-style-align-right" } };
        const lP = { full: gb.objectFullWidth, left: gb.objectLeft, right: gb.objectRight, center: gb.objectCenter };
        function dP(t = []) { return t.map(uP); }
        function uP(t) { if (typeof t == "string") {
            const e = t;
            if (cP[e]) {
                t = Object.assign({}, cP[e]);
            }
            else {
                Object(u["b"])("image-style-not-found", { name: e });
                t = { name: e };
            }
        }
        else if (cP[t.name]) {
            const e = cP[t.name];
            const n = Object.assign({}, t);
            for (const o in e) {
                if (!Object.prototype.hasOwnProperty.call(t, o)) {
                    n[o] = e[o];
                }
            }
            t = n;
        } if (typeof t.icon == "string" && lP[t.icon]) {
            t.icon = lP[t.icon];
        } return t; }
        class hP extends Kn {
            static get pluginName() { return "ImageStyleEditing"; }
            init() { const t = this.editor; const e = t.model.schema; const n = t.data; const o = t.editing; t.config.define("image.styles", ["full", "side"]); const i = dP(t.config.get("image.styles")); e.extend("image", { allowAttributes: "imageStyle" }); const r = rP(i); o.downcastDispatcher.on("attribute:imageStyle:image", r); n.downcastDispatcher.on("attribute:imageStyle:image", r); n.upcastDispatcher.on("element:figure", sP(i), { priority: "low" }); t.commands.add("imageStyle", new iP(t, i)); }
        }
        var fP = n(49);
        var pP = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        pP.insert = "head";
        pP.singleton = true;
        var gP = Ab()(fP["a"], pP);
        var mP = fP["a"].locals || {};
        class kP extends Kn {
            static get pluginName() { return "ImageStyleUI"; }
            get localizedDefaultStylesTitles() { const t = this.editor.t; return { "Full size image": t("Full size image"), "Side image": t("Side image"), "Left aligned image": t("Left aligned image"), "Centered image": t("Centered image"), "Right aligned image": t("Right aligned image") }; }
            init() { const t = this.editor; const e = t.config.get("image.styles"); const n = bP(dP(e), this.localizedDefaultStylesTitles); for (const t of n) {
                this._createButton(t);
            } }
            _createButton(t) { const e = this.editor; const n = `imageStyle:${t.name}`; e.ui.componentFactory.add(n, (n => { const o = e.commands.get("imageStyle"); const i = new mw(n); i.set({ label: t.title, icon: t.icon, tooltip: true, isToggleable: true }); i.bind("isEnabled").to(o, "isEnabled"); i.bind("isOn").to(o, "value", (e => e === t.name)); this.listenTo(i, "execute", (() => { e.execute("imageStyle", { value: t.name }); e.editing.view.focus(); })); return i; })); }
        }
        function bP(t, e) { for (const n of t) {
            if (e[n.title]) {
                n.title = e[n.title];
            }
        } return t; }
        class wP extends Kn {
            static get requires() { return [hP, kP]; }
            static get pluginName() { return "ImageStyle"; }
        }
        class _P extends Kn {
            static get requires() { return [TS]; }
            static get pluginName() { return "ImageToolbar"; }
            afterInit() { const t = this.editor; const e = t.t; const n = t.plugins.get(TS); n.register("image", { ariaLabel: e("Image toolbar"), items: t.config.get("image.toolbar") || [], getRelatedElement: XS }); }
        }
        class vP extends Db {
            constructor(t) { super(t); this.buttonView = new mw(t); this._fileInputView = new AP(t); this._fileInputView.bind("acceptedType").to(this); this._fileInputView.bind("allowMultipleFiles").to(this); this._fileInputView.delegate("done").to(this); this.setTemplate({ tag: "span", attributes: { class: "ck-file-dialog-button" }, children: [this.buttonView, this._fileInputView] }); this.buttonView.on("execute", (() => { this._fileInputView.open(); })); }
            focus() { this.buttonView.focus(); }
        }
        class AP extends Db {
            constructor(t) { super(t); this.set("acceptedType"); this.set("allowMultipleFiles", false); const e = this.bindTemplate; this.setTemplate({ tag: "input", attributes: { class: ["ck-hidden"], type: "file", tabindex: "-1", accept: e.to("acceptedType"), multiple: e.to("allowMultipleFiles") }, on: { change: e.to((() => { if (this.element && this.element.files && this.element.files.length) {
                        this.fire("done", this.element.files);
                    } this.element.value = ""; })) } }); }
            open() { this.element.click(); }
        }
        class CP extends Kn {
            static get requires() { return [QC]; }
            static get pluginName() { return "SimpleUploadAdapter"; }
            init() { const t = this.editor.config.get("simpleUpload"); if (!t) {
                return;
            } if (!t.uploadUrl) {
                Object(u["b"])("simple-upload-adapter-missing-uploadurl");
                return;
            } this.editor.plugins.get(QC).createUploadAdapter = e => new yP(e, t); }
        }
        class yP {
            constructor(t, e) { this.loader = t; this.options = e; }
            upload() { return this.loader.file.then((t => new Promise(((e, n) => { this._initRequest(); this._initListeners(e, n, t); this._sendRequest(t); })))); }
            abort() { if (this.xhr) {
                this.xhr.abort();
            } }
            _initRequest() { const t = this.xhr = new XMLHttpRequest; t.open("POST", this.options.uploadUrl, true); t.responseType = "json"; }
            _initListeners(t, e, n) { const o = this.xhr; const i = this.loader; const r = `Couldn't upload file: ${n.name}.`; o.addEventListener("error", (() => e(r))); o.addEventListener("abort", (() => e())); o.addEventListener("load", (() => { const n = o.response; if (!n || n.error) {
                return e(n && n.error && n.error.message ? n.error.message : r);
            } const i = n.url ? { default: n.url } : n.urls; t(Object.assign(Object.assign({}, n), { urls: i })); })); if (o.upload) {
                o.upload.addEventListener("progress", (t => { if (t.lengthComputable) {
                    i.uploadTotal = t.total;
                    i.uploaded = t.loaded;
                } }));
            } }
            _sendRequest(t) { const e = this.options.headers || {}; const n = this.options.withCredentials || false; for (const t of Object.keys(e)) {
                this.xhr.setRequestHeader(t, e[t]);
            } this.xhr.withCredentials = n; const o = new FormData; o.append("upload", t); this.xhr.send(o); }
        }
        function xP(t) { const e = t.map((t => t.replace("+", "\\+"))); return new RegExp(`^image\\/(${e.join("|")})$`); }
        function EP(t) { return new Promise(((e, n) => { const o = t.getAttribute("src"); fetch(o).then((t => t.blob())).then((t => { const n = SP(t, o); const i = n.replace("image/", ""); const r = `image.${i}`; const s = new File([t], r, { type: n }); e(s); })).catch((t => t && t.name === "TypeError" ? TP(o).then(e).catch(n) : n(t))); })); }
        function DP(t) { if (!t.is("element", "img") || !t.getAttribute("src")) {
            return false;
        } return t.getAttribute("src").match(/^data:image\/\w+;base64,/g) || t.getAttribute("src").match(/^blob:/g); }
        function SP(t, e) { if (t.type) {
            return t.type;
        }
        else if (e.match(/data:(image\/\w+);base64/)) {
            return e.match(/data:(image\/\w+);base64/)[1].toLowerCase();
        }
        else {
            return "image/jpeg";
        } }
        function TP(t) { return PP(t).then((e => { const n = SP(e, t); const o = n.replace("image/", ""); const i = `image.${o}`; return new File([e], i, { type: n }); })); }
        function PP(t) { return new Promise(((e, n) => { const o = su.document.createElement("img"); o.addEventListener("load", (() => { const t = su.document.createElement("canvas"); t.width = o.width; t.height = o.height; const i = t.getContext("2d"); i.drawImage(o, 0, 0); t.toBlob((t => t ? e(t) : n())); })); o.addEventListener("error", (() => n())); o.src = t; })); }
        class BP extends Kn {
            static get pluginName() { return "ImageUploadUI"; }
            init() { const t = this.editor; const e = t.t; const n = n => { const o = new vP(n); const i = t.commands.get("uploadImage"); const r = t.config.get("image.upload.types"); const s = xP(r); o.set({ acceptedType: r.map((t => `image/${t}`)).join(","), allowMultipleFiles: true }); o.buttonView.set({ label: e("Insert image"), icon: gb.image, tooltip: true }); o.buttonView.bind("isEnabled").to(i); o.on("done", ((e, n) => { const o = Array.from(n).filter((t => s.test(t.type))); if (o.length) {
                t.execute("uploadImage", { file: o });
            } })); return o; }; t.ui.componentFactory.add("uploadImage", n); t.ui.componentFactory.add("imageUpload", n); }
        }
        var IP = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>';
        var RP = n(50);
        var FP = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        FP.insert = "head";
        FP.singleton = true;
        var OP = Ab()(RP["a"], FP);
        var zP = RP["a"].locals || {};
        var NP = n(51);
        var MP = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        MP.insert = "head";
        MP.singleton = true;
        var VP = Ab()(NP["a"], MP);
        var LP = NP["a"].locals || {};
        var qP = n(52);
        var KP = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        KP.insert = "head";
        KP.singleton = true;
        var jP = Ab()(qP["a"], KP);
        var HP = qP["a"].locals || {};
        class WP extends Kn {
            static get pluginName() { return "ImageUploadProgress"; }
            constructor(t) { super(t); this.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent(IP); }
            init() { const t = this.editor; t.editing.downcastDispatcher.on("attribute:uploadStatus:image", ((...t) => this.uploadStatusChange(...t))); }
            uploadStatusChange(t, e, n) { const o = this.editor; const i = e.item; const r = i.getAttribute("uploadId"); if (!n.consumable.consume(e.item, t.name)) {
                return;
            } const s = o.plugins.get(QC); const a = r ? e.attributeNewValue : null; const c = this.placeholder; const l = o.editing.mapper.toViewElement(i); const d = n.writer; if (a == "reading") {
                $P(l, d);
                UP(c, l, d);
                return;
            } if (a == "uploading") {
                const t = s.loaders.get(r);
                $P(l, d);
                if (!t) {
                    UP(c, l, d);
                }
                else {
                    JP(l, d);
                    YP(l, d, t, o.editing.view);
                    oB(l, d, t);
                }
                return;
            } if (a == "complete" && s.loaders.get(r)) {
                XP(l, d, o.editing.view);
            } QP(l, d); JP(l, d); GP(l, d); }
        }
        function $P(t, e) { if (!t.hasClass("ck-appear")) {
            e.addClass("ck-appear", t);
        } }
        function GP(t, e) { e.removeClass("ck-appear", t); }
        function UP(t, e, n) { if (!e.hasClass("ck-image-upload-placeholder")) {
            n.addClass("ck-image-upload-placeholder", e);
        } const o = nT(e); if (o.getAttribute("src") !== t) {
            n.setAttribute("src", t, o);
        } if (!eB(e, "placeholder")) {
            n.insert(n.createPositionAfter(o), tB(n));
        } }
        function JP(t, e) { if (t.hasClass("ck-image-upload-placeholder")) {
            e.removeClass("ck-image-upload-placeholder", t);
        } nB(t, e, "placeholder"); }
        function YP(t, e, n, o) { const i = ZP(e); e.insert(e.createPositionAt(t, "end"), i); n.on("change:uploadedPercent", ((t, e, n) => { o.change((t => { t.setStyle("width", n + "%", i); })); })); }
        function QP(t, e) { nB(t, e, "progressBar"); }
        function XP(t, e, n) { const o = e.createUIElement("div", { class: "ck-image-upload-complete-icon" }); e.insert(e.createPositionAt(t, "end"), o); setTimeout((() => { n.change((t => t.remove(t.createRangeOn(o)))); }), 3e3); }
        function ZP(t) { const e = t.createUIElement("div", { class: "ck-progress-bar" }); t.setCustomProperty("progressBar", true, e); return e; }
        function tB(t) { const e = t.createUIElement("div", { class: "ck-upload-placeholder-loader" }); t.setCustomProperty("placeholder", true, e); return e; }
        function eB(t, e) { for (const n of t.getChildren()) {
            if (n.getCustomProperty(e)) {
                return n;
            }
        } }
        function nB(t, e, n) { const o = eB(t, n); if (o) {
            e.remove(e.createRangeOn(o));
        } }
        function oB(t, e, n) { if (n.data) {
            const o = nT(t);
            e.setAttribute("src", n.data, o);
        } }
        class iB extends Hn {
            refresh() { const t = this.editor.model.document.selection.getSelectedElement(); const e = t && t.name === "image" || false; this.isEnabled = eT(this.editor.model) || e; }
            execute(t) { const e = this.editor; const n = e.model; const o = e.plugins.get(QC); for (const e of _a(t.file)) {
                rB(n, o, e);
            } }
        }
        function rB(t, e, n) { const o = e.createLoader(n); if (!o) {
            return;
        } tT(t, { uploadId: o.id }); }
        class sB extends Kn {
            static get requires() { return [QC, hv, qx]; }
            static get pluginName() { return "ImageUploadEditing"; }
            constructor(t) { super(t); t.config.define("image", { upload: { types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"] } }); }
            init() { const t = this.editor; const e = t.model.document; const n = t.model.schema; const o = t.conversion; const i = t.plugins.get(QC); const r = xP(t.config.get("image.upload.types")); n.extend("image", { allowAttributes: ["uploadId", "uploadStatus"] }); const s = new iB(t); t.commands.add("uploadImage", s); t.commands.add("imageUpload", s); o.for("upcast").attributeToAttribute({ view: { name: "img", key: "uploadId" }, model: "uploadId" }); this.listenTo(t.editing.view.document, "clipboardInput", ((e, n) => { if (aB(n.dataTransfer)) {
                return;
            } const o = Array.from(n.dataTransfer.files).filter((t => { if (!t) {
                return false;
            } return r.test(t.type); })); if (!o.length) {
                return;
            } e.stop(); t.model.change((e => { if (n.targetRanges) {
                e.setSelection(n.targetRanges.map((e => t.editing.mapper.toModelRange(e))));
            } t.model.enqueueChange("default", (() => { t.execute("uploadImage", { file: o }); })); })); })); this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", ((e, n) => { const o = Array.from(t.editing.view.createRangeIn(n.content)).filter((t => DP(t.item) && !t.item.getAttribute("uploadProcessed"))).map((t => ({ promise: EP(t.item), imageElement: t.item }))); if (!o.length) {
                return;
            } const r = new BA(t.editing.view.document); for (const t of o) {
                r.setAttribute("uploadProcessed", true, t.imageElement);
                const e = i.createLoader(t.promise);
                if (e) {
                    r.setAttribute("src", "", t.imageElement);
                    r.setAttribute("uploadId", e.id, t.imageElement);
                }
            } })); t.editing.view.document.on("dragover", ((t, e) => { e.preventDefault(); })); e.on("change", (() => { const n = e.differ.getChanges({ includeChangesInGraveyard: true }); for (const e of n) {
                if (e.type == "insert" && e.name != "$text") {
                    const n = e.position.nodeAfter;
                    const o = e.position.root.rootName == "$graveyard";
                    for (const e of cB(t, n)) {
                        const t = e.getAttribute("uploadId");
                        if (!t) {
                            continue;
                        }
                        const n = i.loaders.get(t);
                        if (!n) {
                            continue;
                        }
                        if (o) {
                            n.abort();
                        }
                        else if (n.status == "idle") {
                            this._readAndUpload(n, e);
                        }
                    }
                }
            } })); this.on("uploadComplete", ((t, { imageElement: e, data: n }) => { const o = n.urls ? n.urls : n; this.editor.model.change((t => { t.setAttribute("src", o.default, e); this._parseAndSetSrcsetAttributeOnImage(o, e, t); })); }), { priority: "low" }); }
            _readAndUpload(t, e) { const n = this.editor; const o = n.model; const i = n.locale.t; const r = n.plugins.get(QC); const s = n.plugins.get(hv); o.enqueueChange("transparent", (t => { t.setAttribute("uploadStatus", "reading", e); })); return t.read().then((() => { const i = t.upload(); if (Wl.isSafari) {
                const t = n.editing.mapper.toViewElement(e);
                const o = nT(t);
                n.editing.view.once("render", (() => { if (!o.parent) {
                    return;
                } const t = n.editing.view.domConverter.mapViewToDom(o.parent); if (!t) {
                    return;
                } const e = t.style.display; t.style.display = "none"; t._ckHack = t.offsetHeight; t.style.display = e; }));
            } o.enqueueChange("transparent", (t => { t.setAttribute("uploadStatus", "uploading", e); })); return i; })).then((t => { o.enqueueChange("transparent", (n => { n.setAttribute("uploadStatus", "complete", e); this.fire("uploadComplete", { data: t, imageElement: e }); })); a(); })).catch((n => { if (t.status !== "error" && t.status !== "aborted") {
                throw n;
            } if (t.status == "error" && n) {
                s.showWarning(n, { title: i("Upload failed"), namespace: "upload" });
            } a(); o.enqueueChange("transparent", (t => { t.remove(e); })); })); function a() { o.enqueueChange("transparent", (t => { t.removeAttribute("uploadId", e); t.removeAttribute("uploadStatus", e); })); r.destroyLoader(t); } }
            _parseAndSetSrcsetAttributeOnImage(t, e, n) { let o = 0; const i = Object.keys(t).filter((t => { const e = parseInt(t, 10); if (!isNaN(e)) {
                o = Math.max(o, e);
                return true;
            } })).map((e => `${t[e]} ${e}w`)).join(", "); if (i != "") {
                n.setAttribute("srcset", { data: i, width: o }, e);
            } }
        }
        function aB(t) { return Array.from(t.types).includes("text/html") && t.getData("text/html") !== ""; }
        function cB(t, e) { return Array.from(t.model.createRangeOn(e)).filter((t => t.item.is("element", "image"))).map((t => t.item)); }
        class lB extends Kn {
            static get pluginName() { return "ImageUpload"; }
            static get requires() { return [sB, BP, WP]; }
        }
        class dB extends Kn {
            static get pluginName() { return "IndentEditing"; }
            init() { const t = this.editor; t.commands.add("indent", new $n(t)); t.commands.add("outdent", new $n(t)); }
        }
        var uB = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>';
        var hB = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
        class fB extends Kn {
            static get pluginName() { return "IndentUI"; }
            init() { const t = this.editor; const e = t.locale; const n = t.t; const o = e.uiLanguageDirection == "ltr" ? uB : hB; const i = e.uiLanguageDirection == "ltr" ? hB : uB; this._defineButton("indent", n("Increase indent"), o); this._defineButton("outdent", n("Decrease indent"), i); }
            _defineButton(t, e, n) { const o = this.editor; o.ui.componentFactory.add(t, (i => { const r = o.commands.get(t); const s = new mw(i); s.set({ label: e, icon: n, tooltip: true }); s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"); this.listenTo(s, "execute", (() => { o.execute(t); o.editing.view.focus(); })); return s; })); }
        }
        class pB extends Kn {
            static get pluginName() { return "Indent"; }
            static get requires() { return [dB, fB]; }
        }
        const gB = "italic";
        class mB extends Kn {
            static get pluginName() { return "ItalicEditing"; }
            init() { const t = this.editor; t.model.schema.extend("$text", { allowAttributes: gB }); t.model.schema.setAttributeProperties(gB, { isFormatting: true, copyOnEnter: true }); t.conversion.attributeToElement({ model: gB, view: "i", upcastAlso: ["em", { styles: { "font-style": "italic" } }] }); t.commands.add(gB, new px(t, gB)); t.keystrokes.set("CTRL+I", gB); }
        }
        var kB = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
        const bB = "italic";
        class wB extends Kn {
            static get pluginName() { return "ItalicUI"; }
            init() { const t = this.editor; const e = t.t; t.ui.componentFactory.add(bB, (n => { const o = t.commands.get(bB); const i = new mw(n); i.set({ label: e("Italic"), icon: kB, keystroke: "CTRL+I", tooltip: true, isToggleable: true }); i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"); this.listenTo(i, "execute", (() => { t.execute(bB); t.editing.view.focus(); })); return i; })); }
        }
        class _B extends Kn {
            static get requires() { return [mB, wB]; }
            static get pluginName() { return "Italic"; }
        }
        class vB {
            constructor() { this._definitions = new Set; }
            get length() { return this._definitions.size; }
            add(t) { if (Array.isArray(t)) {
                t.forEach((t => this._definitions.add(t)));
            }
            else {
                this._definitions.add(t);
            } }
            getDispatcher() { return t => { t.on("attribute:linkHref", ((t, e, n) => { if (!n.consumable.test(e.item, "attribute:linkHref")) {
                return;
            } const o = n.writer; const i = o.document.selection; for (const t of this._definitions) {
                const r = o.createAttributeElement("a", t.attributes, { priority: 5 });
                o.setCustomProperty("link", true, r);
                if (t.callback(e.attributeNewValue)) {
                    if (e.item.is("selection")) {
                        o.wrap(i.getFirstRange(), r);
                    }
                    else {
                        o.wrap(n.mapper.toViewRange(e.range), r);
                    }
                }
                else {
                    o.unwrap(n.mapper.toViewRange(e.range), r);
                }
            } }), { priority: "high" }); }; }
            getDispatcherForLinkedImage() { return t => { t.on("attribute:linkHref:image", ((t, e, n) => { const o = n.mapper.toViewElement(e.item); const i = Array.from(o.getChildren()).find((t => t.name === "a")); for (const t of this._definitions) {
                const o = La(t.attributes);
                if (t.callback(e.attributeNewValue)) {
                    for (const [t, e] of o) {
                        if (t === "class") {
                            n.writer.addClass(e, i);
                        }
                        else {
                            n.writer.setAttribute(t, e, i);
                        }
                    }
                }
                else {
                    for (const [t, e] of o) {
                        if (t === "class") {
                            n.writer.removeClass(e, i);
                        }
                        else {
                            n.writer.removeAttribute(t, i);
                        }
                    }
                }
            } })); }; }
        }
        function AB(t, e, n) { var o = t.length; n = n === undefined ? o : n; return !e && n >= o ? t : Tc(t, e, n); }
        var CB = AB;
        var yB = "\\ud800-\\udfff", xB = "\\u0300-\\u036f", EB = "\\ufe20-\\ufe2f", DB = "\\u20d0-\\u20ff", SB = xB + EB + DB, TB = "\\ufe0e\\ufe0f";
        var PB = "\\u200d";
        var BB = RegExp("[" + PB + yB + SB + TB + "]");
        function IB(t) { return BB.test(t); }
        var RB = IB;
        function FB(t) { return t.split(""); }
        var OB = FB;
        var zB = "\\ud800-\\udfff", NB = "\\u0300-\\u036f", MB = "\\ufe20-\\ufe2f", VB = "\\u20d0-\\u20ff", LB = NB + MB + VB, qB = "\\ufe0e\\ufe0f";
        var KB = "[" + zB + "]", jB = "[" + LB + "]", HB = "\\ud83c[\\udffb-\\udfff]", WB = "(?:" + jB + "|" + HB + ")", $B = "[^" + zB + "]", GB = "(?:\\ud83c[\\udde6-\\uddff]){2}", UB = "[\\ud800-\\udbff][\\udc00-\\udfff]", JB = "\\u200d";
        var YB = WB + "?", QB = "[" + qB + "]?", XB = "(?:" + JB + "(?:" + [$B, GB, UB].join("|") + ")" + QB + YB + ")*", ZB = QB + YB + XB, tI = "(?:" + [$B + jB + "?", jB, GB, UB, KB].join("|") + ")";
        var eI = RegExp(HB + "(?=" + HB + ")|" + tI + ZB, "g");
        function nI(t) { return t.match(eI) || []; }
        var oI = nI;
        function iI(t) { return RB(t) ? oI(t) : OB(t); }
        var rI = iI;
        function sI(t) { return function (e) { e = bc(e); var n = RB(e) ? rI(e) : undefined; var o = n ? n[0] : e.charAt(0); var i = n ? CB(n, 1).join("") : e.slice(1); return o[t]() + i; }; }
        var aI = sI;
        var cI = aI("toUpperCase");
        var lI = cI;
        const dI = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
        const uI = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;
        const hI = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i;
        const fI = /^((\w+:(\/{2,})?)|(\W))/i;
        const pI = "Ctrl+K";
        function gI(t) { return t.is("attributeElement") && !!t.getCustomProperty("link"); }
        function mI(t, { writer: e }) { const n = e.createAttributeElement("a", { href: t }, { priority: 5 }); e.setCustomProperty("link", true, n); return n; }
        function kI(t) { t = String(t); return bI(t) ? t : "#"; }
        function bI(t) { const e = t.replace(dI, ""); return e.match(uI); }
        function wI(t, e) { const n = { "Open in a new tab": t("Open in a new tab"), Downloadable: t("Downloadable") }; e.forEach((t => { if (t.label && n[t.label]) {
            t.label = n[t.label];
        } return t; })); return e; }
        function _I(t) { const e = []; if (t) {
            for (const [n, o] of Object.entries(t)) {
                const t = Object.assign({}, o, { id: `link${lI(n)}` });
                e.push(t);
            }
        } return e; }
        function vI(t, e) { if (!t) {
            return false;
        } return t.is("element", "image") && e.checkAttribute("image", "linkHref"); }
        function AI(t) { return hI.test(t); }
        function CI(t, e) { const n = AI(t) ? "mailto:" : e; const o = !!n && !fI.test(t); return t && o ? n + t : t; }
        class yI extends Hn {
            constructor(t) { super(t); this.manualDecorators = new ba; this.automaticDecorators = new vB; }
            restoreManualDecoratorStates() { for (const t of this.manualDecorators) {
                t.value = this._getDecoratorStateFromModel(t.id);
            } }
            refresh() { const t = this.editor.model; const e = t.document; const n = mf(e.selection.getSelectedBlocks()); if (vI(n, t.schema)) {
                this.value = n.getAttribute("linkHref");
                this.isEnabled = t.schema.checkAttribute(n, "linkHref");
            }
            else {
                this.value = e.selection.getAttribute("linkHref");
                this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "linkHref");
            } for (const t of this.manualDecorators) {
                t.value = this._getDecoratorStateFromModel(t.id);
            } }
            execute(t, e = {}) { const n = this.editor.model; const o = n.document.selection; const i = []; const r = []; for (const t in e) {
                if (e[t]) {
                    i.push(t);
                }
                else {
                    r.push(t);
                }
            } n.change((e => { if (o.isCollapsed) {
                const s = o.getFirstPosition();
                if (o.hasAttribute("linkHref")) {
                    const a = tx(s, "linkHref", o.getAttribute("linkHref"), n);
                    e.setAttribute("linkHref", t, a);
                    i.forEach((t => { e.setAttribute(t, true, a); }));
                    r.forEach((t => { e.removeAttribute(t, a); }));
                    e.setSelection(e.createPositionAfter(a.end.nodeBefore));
                }
                else if (t !== "") {
                    const r = La(o.getAttributes());
                    r.set("linkHref", t);
                    i.forEach((t => { r.set(t, true); }));
                    const { end: a } = n.insertContent(e.createText(t, r), s);
                    e.setSelection(a);
                }
                ["linkHref", ...i, ...r].forEach((t => { e.removeSelectionAttribute(t); }));
            }
            else {
                const s = n.schema.getValidRanges(o.getRanges(), "linkHref");
                const a = [];
                for (const t of o.getSelectedBlocks()) {
                    if (n.schema.checkAttribute(t, "linkHref")) {
                        a.push(e.createRangeOn(t));
                    }
                }
                const c = a.slice();
                for (const t of s) {
                    if (this._isRangeToUpdate(t, a)) {
                        c.push(t);
                    }
                }
                for (const n of c) {
                    e.setAttribute("linkHref", t, n);
                    i.forEach((t => { e.setAttribute(t, true, n); }));
                    r.forEach((t => { e.removeAttribute(t, n); }));
                }
            } })); }
            _getDecoratorStateFromModel(t) { const e = this.editor.model; const n = e.document; const o = mf(n.selection.getSelectedBlocks()); if (vI(o, e.schema)) {
                return o.getAttribute(t);
            } return n.selection.getAttribute(t); }
            _isRangeToUpdate(t, e) { for (const n of e) {
                if (n.containsRange(t)) {
                    return false;
                }
            } return true; }
        }
        class xI extends Hn {
            refresh() { const t = this.editor.model; const e = t.document; const n = mf(e.selection.getSelectedBlocks()); if (vI(n, t.schema)) {
                this.isEnabled = t.schema.checkAttribute(n, "linkHref");
            }
            else {
                this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "linkHref");
            } }
            execute() { const t = this.editor; const e = this.editor.model; const n = e.document.selection; const o = t.commands.get("link"); e.change((t => { const i = n.isCollapsed ? [tx(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), e)] : e.schema.getValidRanges(n.getRanges(), "linkHref"); for (const e of i) {
                t.removeAttribute("linkHref", e);
                if (o) {
                    for (const n of o.manualDecorators) {
                        t.removeAttribute(n.id, e);
                    }
                }
            } })); }
        }
        class EI {
            constructor({ id: t, label: e, attributes: n, defaultValue: o }) { this.id = t; this.set("value"); this.defaultValue = o; this.label = e; this.attributes = n; }
        }
        qn(EI, Pn);
        var DI = n(53);
        var SI = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        SI.insert = "head";
        SI.singleton = true;
        var TI = Ab()(DI["a"], SI);
        var PI = DI["a"].locals || {};
        const BI = "ck-link_selected";
        const II = "automatic";
        const RI = "manual";
        const FI = /^(https?:)?\/\//;
        class OI extends Kn {
            static get pluginName() { return "LinkEditing"; }
            static get requires() { return [Fy, Dy, qx]; }
            constructor(t) { super(t); t.config.define("link", { addTargetToExternalLinks: false }); }
            init() { const t = this.editor; t.model.schema.extend("$text", { allowAttributes: "linkHref" }); t.conversion.for("dataDowncast").attributeToElement({ model: "linkHref", view: mI }); t.conversion.for("editingDowncast").attributeToElement({ model: "linkHref", view: (t, e) => mI(kI(t), e) }); t.conversion.for("upcast").elementToAttribute({ view: { name: "a", attributes: { href: true } }, model: { key: "linkHref", value: t => t.getAttribute("href") } }); t.commands.add("link", new yI(t)); t.commands.add("unlink", new xI(t)); const e = wI(t.t, _I(t.config.get("link.decorators"))); this._enableAutomaticDecorators(e.filter((t => t.mode === II))); this._enableManualDecorators(e.filter((t => t.mode === RI))); const n = t.plugins.get(Fy); n.registerAttribute("linkHref"); nx(t, "linkHref", "a", BI); this._enableInsertContentSelectionAttributesFixer(); this._enableClickingAfterLink(); this._enableTypingOverLink(); this._handleDeleteContentAfterLink(); }
            _enableAutomaticDecorators(t) { const e = this.editor; const n = e.commands.get("link"); const o = n.automaticDecorators; if (e.config.get("link.addTargetToExternalLinks")) {
                o.add({ id: "linkIsExternal", mode: II, callback: t => FI.test(t), attributes: { target: "_blank", rel: "noopener noreferrer" } });
            } o.add(t); if (o.length) {
                e.conversion.for("downcast").add(o.getDispatcher());
            } }
            _enableManualDecorators(t) { if (!t.length) {
                return;
            } const e = this.editor; const n = e.commands.get("link"); const o = n.manualDecorators; t.forEach((t => { e.model.schema.extend("$text", { allowAttributes: t.id }); o.add(new EI(t)); e.conversion.for("downcast").attributeToElement({ model: t.id, view: (e, { writer: n }) => { if (e) {
                    const e = o.get(t.id).attributes;
                    const i = n.createAttributeElement("a", e, { priority: 5 });
                    n.setCustomProperty("link", true, i);
                    return i;
                } } }); e.conversion.for("upcast").elementToAttribute({ view: { name: "a", attributes: o.get(t.id).attributes }, model: { key: t.id } }); })); }
            _enableInsertContentSelectionAttributesFixer() { const t = this.editor; const e = t.model; const n = e.document.selection; const o = t.commands.get("link"); this.listenTo(e, "insertContent", (() => { const t = n.anchor.nodeBefore; const i = n.anchor.nodeAfter; if (!n.hasAttribute("linkHref")) {
                return;
            } if (!t) {
                return;
            } if (!t.hasAttribute("linkHref")) {
                return;
            } if (i && i.hasAttribute("linkHref")) {
                return;
            } e.change((t => { zI(t, o.manualDecorators); })); }), { priority: "low" }); }
            _enableClickingAfterLink() { const t = this.editor; const e = t.commands.get("link"); t.editing.view.addObserver(PA); let n = false; this.listenTo(t.editing.view.document, "mousedown", (() => { n = true; })); this.listenTo(t.editing.view.document, "selectionChange", (() => { if (!n) {
                return;
            } n = false; const o = t.model.document.selection; if (!o.isCollapsed) {
                return;
            } if (!o.hasAttribute("linkHref")) {
                return;
            } const i = o.getFirstPosition(); const r = tx(i, "linkHref", o.getAttribute("linkHref"), t.model); if (i.isTouching(r.start) || i.isTouching(r.end)) {
                t.model.change((t => { zI(t, e.manualDecorators); }));
            } })); }
            _enableTypingOverLink() { const t = this.editor; const e = t.editing.view; let n; let o; this.listenTo(e.document, "delete", (() => { o = true; }), { priority: "high" }); this.listenTo(t.model, "deleteContent", (() => { const e = t.model.document.selection; if (e.isCollapsed) {
                return;
            } if (o) {
                o = false;
                return;
            } if (!MI(t)) {
                return;
            } if (NI(t.model)) {
                n = e.getAttributes();
            } }), { priority: "high" }); this.listenTo(t.model, "insertContent", ((e, [i]) => { o = false; if (!MI(t)) {
                return;
            } if (!n) {
                return;
            } t.model.change((t => { for (const [e, o] of n) {
                t.setAttribute(e, o, i);
            } })); n = null; }), { priority: "high" }); }
            _handleDeleteContentAfterLink() { const t = this.editor; const e = t.model; const n = e.document.selection; const o = t.editing.view; const i = t.commands.get("link"); let r = false; let s = false; this.listenTo(o.document, "delete", ((t, e) => { s = e.domEvent.keyCode === td.backspace; }), { priority: "high" }); this.listenTo(e, "deleteContent", (() => { r = false; const t = n.getFirstPosition(); const o = n.getAttribute("linkHref"); if (!o) {
                return;
            } const i = tx(t, "linkHref", o, e); r = i.containsPosition(t) || i.end.isEqual(t); }), { priority: "high" }); this.listenTo(e, "deleteContent", (() => { if (!s) {
                return;
            } s = false; if (r) {
                return;
            } t.model.enqueueChange((t => { zI(t, i.manualDecorators); })); }), { priority: "low" }); }
        }
        function zI(t, e) { t.removeSelectionAttribute("linkHref"); for (const n of e) {
            t.removeSelectionAttribute(n.id);
        } }
        function NI(t) { const e = t.document.selection; const n = e.getFirstPosition(); const o = e.getLastPosition(); const i = n.nodeAfter; if (!i) {
            return false;
        } if (!i.is("$text")) {
            return false;
        } if (!i.hasAttribute("linkHref")) {
            return false;
        } const r = o.textNode || o.nodeBefore; if (i === r) {
            return true;
        } const s = tx(n, "linkHref", i.getAttribute("linkHref"), t); return s.containsRange(t.createRange(n, o), true); }
        function MI(t) { const e = t.plugins.get("Input"); return e.isInput(t.model.change((t => t.batch))); }
        var VI = n(54);
        var LI = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        LI.insert = "head";
        LI.singleton = true;
        var qI = Ab()(VI["a"], LI);
        var KI = VI["a"].locals || {};
        class jI extends Db {
            constructor(t, e) { super(t); const n = t.t; this.focusTracker = new kf; this.keystrokes = new bf; this.urlInputView = this._createUrlInput(); this.saveButtonView = this._createButton(n("Save"), gb.check, "ck-button-save"); this.saveButtonView.type = "submit"; this.cancelButtonView = this._createButton(n("Cancel"), gb.cancel, "ck-button-cancel", "cancel"); this._manualDecoratorSwitches = this._createManualDecoratorSwitches(e); this.children = this._createFormChildren(e.manualDecorators); this._focusables = new wb; this._focusCycler = new Dw({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }); const o = ["ck", "ck-link-form", "ck-responsive-form"]; if (e.manualDecorators.length) {
                o.push("ck-link-form_layout-vertical", "ck-vertical-form");
            } this.setTemplate({ tag: "form", attributes: { class: o, tabindex: "-1" }, children: this.children }); kb(this); }
            getDecoratorSwitchesState() { return Array.from(this._manualDecoratorSwitches).reduce(((t, e) => { t[e.name] = e.isOn; return t; }), {}); }
            render() { super.render(); bb({ view: this }); const t = [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView]; t.forEach((t => { this._focusables.add(t); this.focusTracker.add(t.element); })); this.keystrokes.listenTo(this.element); }
            focus() { this._focusCycler.focusFirst(); }
            _createUrlInput() { const t = this.locale.t; const e = new lv(this.locale, dv); e.label = t("Link URL"); return e; }
            _createButton(t, e, n, o) { const i = new mw(this.locale); i.set({ label: t, icon: e, tooltip: true }); i.extendTemplate({ attributes: { class: n } }); if (o) {
                i.delegate("execute").to(this, o);
            } return i; }
            _createManualDecoratorSwitches(t) { const e = this.createCollection(); for (const n of t.manualDecorators) {
                const o = new vw(this.locale);
                o.set({ name: n.id, label: n.label, withText: true });
                o.bind("isOn").toMany([n, t], "value", ((t, e) => e === undefined && t === undefined ? n.defaultValue : t));
                o.on("execute", (() => { n.set("value", !o.isOn); }));
                e.add(o);
            } return e; }
            _createFormChildren(t) { const e = this.createCollection(); e.add(this.urlInputView); if (t.length) {
                const t = new Db;
                t.setTemplate({ tag: "ul", children: this._manualDecoratorSwitches.map((t => ({ tag: "li", children: [t], attributes: { class: ["ck", "ck-list__item"] } }))), attributes: { class: ["ck", "ck-reset", "ck-list"] } });
                e.add(t);
            } e.add(this.saveButtonView); e.add(this.cancelButtonView); return e; }
        }
        var HI = n(55);
        var WI = { injectType: "singletonStyleTag", attributes: { "data-cke": true } };
        WI.insert = "head";
        WI.singleton = true;
        var $I = Ab()(HI["a"], WI);
        var GI = HI["a"].locals || {};
        var UI = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>';
        class JI extends Db {
            constructor(t) { super(t); const e = t.t; this.focusTracker = new kf; this.keystrokes = new bf; this.previewButtonView = this._createPreviewButton(); this.unlinkButtonView = this._createButton(e("Unlink"), UI, "unlink"); this.editButtonView = this._createButton(e("Edit link"), gb.pencil, "edit"); this.set("href"); this._focusables = new wb; this._focusCycler = new Dw({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }); this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-link-actions", "ck-responsive-form"], tabindex: "-1" }, children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView] }); }
            render() { super.render(); const t = [this.previewButtonView, this.editButtonView, this.unlinkButtonView]; t.forEach((t => { this._focusables.add(t); this.focusTracker.add(t.element); })); this.keystrokes.listenTo(this.element); }
            focus() { this._focusCycler.focusFirst(); }
            _createButton(t, e, n) { const o = new mw(this.locale); o.set({ label: t, icon: e, tooltip: true }); o.delegate("execute").to(this, n); return o; }
            _createPreviewButton() { const t = new mw(this.locale); const e = this.bindTemplate; const n = this.t; t.set({ withText: true, tooltip: n("Open link in new tab") }); t.extendTemplate({ attributes: { class: ["ck", "ck-link-actions__preview"], href: e.to("href", (t => t && kI(t))), target: "_blank", rel: "noopener noreferrer" } }); t.bind("label").to(this, "href", (t => t || n("This link has no URL"))); t.bind("isEnabled").to(this, "href", (t => !!t)); t.template.tag = "a"; t.template.eventListeners = {}; return t; }
        }
        var YI = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
        const QI = "link-ui";
        class XI extends Kn {
            static get requires() { return [Ov]; }
            static get pluginName() { return "LinkUI"; }
            init() { const t = this.editor; t.editing.view.addObserver(TA); this.actionsView = this._createActionsView(); this.formView = this._createFormView(); this._balloon = t.plugins.get(Ov); this._createToolbarLinkButton(); this._enableUserBalloonInteractions(); t.conversion.for("editingDowncast").markerToHighlight({ model: QI, view: { classes: ["ck-fake-link-selection"] } }); t.conversion.for("editingDowncast").markerToElement({ model: QI, view: { name: "span", classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"] } }); }
            destroy() { super.destroy(); this.formView.destroy(); }
            _createActionsView() { const t = this.editor; const e = new JI(t.locale); const n = t.commands.get("link"); const o = t.commands.get("unlink"); e.bind("href").to(n, "value"); e.editButtonView.bind("isEnabled").to(n); e.unlinkButtonView.bind("isEnabled").to(o); this.listenTo(e, "edit", (() => { this._addFormView(); })); this.listenTo(e, "unlink", (() => { t.execute("unlink"); this._hideUI(); })); e.keystrokes.set("Esc", ((t, e) => { this._hideUI(); e(); })); e.keystrokes.set(pI, ((t, e) => { this._addFormView(); e(); })); return e; }
            _createFormView() { const t = this.editor; const e = t.commands.get("link"); const n = t.config.get("link.defaultProtocol"); const o = new jI(t.locale, e); o.urlInputView.fieldView.bind("value").to(e, "value"); o.urlInputView.bind("isReadOnly").to(e, "isEnabled", (t => !t)); o.saveButtonView.bind("isEnabled").to(e); this.listenTo(o, "submit", (() => { const { value: e } = o.urlInputView.fieldView.element; const i = CI(e, n); t.execute("link", i, o.getDecoratorSwitchesState()); this._closeFormView(); })); this.listenTo(o, "cancel", (() => { this._closeFormView(); })); o.keystrokes.set("Esc", ((t, e) => { this._closeFormView(); e(); })); return o; }
            _createToolbarLinkButton() { const t = this.editor; const e = t.commands.get("link"); const n = t.t; t.keystrokes.set(pI, ((t, n) => { n(); if (e.isEnabled) {
                this._showUI(true);
            } })); t.ui.componentFactory.add("link", (t => { const o = new mw(t); o.isEnabled = true; o.label = n("Link"); o.icon = YI; o.keystroke = pI; o.tooltip = true; o.isToggleable = true; o.bind("isEnabled").to(e, "isEnabled"); o.bind("isOn").to(e, "value", (t => !!t)); this.listenTo(o, "execute", (() => this._showUI(true))); return o; })); }
            _enableUserBalloonInteractions() { const t = this.editor.editing.view.document; this.listenTo(t, "click", (() => { const t = this._getSelectedLinkElement(); if (t) {
                this._showUI();
            } })); this.editor.keystrokes.set("Tab", ((t, e) => { if (this._areActionsVisible && !this.actionsView.focusTracker.isFocused) {
                this.actionsView.focus();
                e();
            } }), { priority: "high" }); this.editor.keystrokes.set("Esc", ((t, e) => { if (this._isUIVisible) {
                this._hideUI();
                e();
            } })); mb({ emitter: this.formView, activator: () => this._isUIInPanel, contextElements: [this._balloon.view.element], callback: () => this._hideUI() }); }
            _addActionsView() { if (this._areActionsInPanel) {
                return;
            } this._balloon.add({ view: this.actionsView, position: this._getBalloonPositionData() }); }
            _addFormView() { if (this._isFormInPanel) {
                return;
            } const t = this.editor; const e = t.commands.get("link"); this.formView.disableCssTransitions(); this._balloon.add({ view: this.formView, position: this._getBalloonPositionData() }); if (this._balloon.visibleView === this.formView) {
                this.formView.urlInputView.fieldView.select();
            } this.formView.enableCssTransitions(); this.formView.urlInputView.fieldView.element.value = e.value || ""; }
            _closeFormView() { const t = this.editor.commands.get("link"); t.restoreManualDecoratorStates(); if (t.value !== undefined) {
                this._removeFormView();
            }
            else {
                this._hideUI();
            } }
            _removeFormView() { if (this._isFormInPanel) {
                this.formView.saveButtonView.focus();
                this._balloon.remove(this.formView);
                this.editor.editing.view.focus();
                this._hideFakeVisualSelection();
            } }
            _showUI(t = false) { if (!this._getSelectedLinkElement()) {
                this._showFakeVisualSelection();
                this._addActionsView();
                if (t) {
                    this._balloon.showStack("main");
                }
                this._addFormView();
            }
            else {
                if (this._areActionsVisible) {
                    this._addFormView();
                }
                else {
                    this._addActionsView();
                }
                if (t) {
                    this._balloon.showStack("main");
                }
            } this._startUpdatingUI(); }
            _hideUI() { if (!this._isUIInPanel) {
                return;
            } const t = this.editor; this.stopListening(t.ui, "update"); this.stopListening(this._balloon, "change:visibleView"); t.editing.view.focus(); this._removeFormView(); this._balloon.remove(this.actionsView); this._hideFakeVisualSelection(); }
            _startUpdatingUI() { const t = this.editor; const e = t.editing.view.document; let n = this._getSelectedLinkElement(); let o = r(); const i = () => { const t = this._getSelectedLinkElement(); const e = r(); if (n && !t || !n && e !== o) {
                this._hideUI();
            }
            else if (this._isUIVisible) {
                this._balloon.updatePosition(this._getBalloonPositionData());
            } n = t; o = e; }; function r() { return e.selection.focus.getAncestors().reverse().find((t => t.is("element"))); } this.listenTo(t.ui, "update", i); this.listenTo(this._balloon, "change:visibleView", i); }
            get _isFormInPanel() { return this._balloon.hasView(this.formView); }
            get _areActionsInPanel() { return this._balloon.hasView(this.actionsView); }
            get _areActionsVisible() { return this._balloon.visibleView === this.actionsView; }
            get _isUIInPanel() { return this._isFormInPanel || this._areActionsInPanel; }
            get _isUIVisible() { const t = this._balloon.visibleView; return t == this.formView || this._areActionsVisible; }
            _getBalloonPositionData() { const t = this.editor.editing.view; const e = this.editor.model; const n = t.document; let o = null; if (e.markers.has(QI)) {
                const e = Array.from(this.editor.editing.mapper.markerNameToElements(QI));
                const n = t.createRange(t.createPositionBefore(e[0]), t.createPositionAfter(e[e.length - 1]));
                o = t.domConverter.viewRangeToDom(n);
            }
            else {
                const e = this._getSelectedLinkElement();
                const i = n.selection.getFirstRange();
                o = e ? t.domConverter.mapViewToDom(e) : t.domConverter.viewRangeToDom(i);
            } return { target: o }; }
            _getSelectedLinkElement() { const t = this.editor.editing.view; const e = t.document.selection; if (e.isCollapsed) {
                return ZI(e.getFirstPosition());
            }
            else {
                const n = e.getFirstRange().getTrimmed();
                const o = ZI(n.start);
                const i = ZI(n.end);
                if (!o || o != i) {
                    return null;
                }
                if (t.createRangeIn(o).getTrimmed().isEqual(n)) {
                    return o;
                }
                else {
                    return null;
                }
            } }
            _showFakeVisualSelection() { const t = this.editor.model; t.change((e => { const n = t.document.selection.getFirstRange(); if (t.markers.has(QI)) {
                e.updateMarker(QI, { range: n });
            }
            else {
                if (n.start.isAtEnd) {
                    const o = n.start.getLastMatchingPosition((({ item: e }) => !t.schema.isContent(e)), { boundaries: n });
                    e.addMarker(QI, { usingOperation: false, affectsData: false, range: e.createRange(o, n.end) });
                }
                else {
                    e.addMarker(QI, { usingOperation: false, affectsData: false, range: n });
                }
            } })); }
            _hideFakeVisualSelection() { const t = this.editor.model; if (t.markers.has(QI)) {
                t.change((t => { t.removeMarker(QI); }));
            } }
        }
        function ZI(t) { return t.getAncestors().find((t => gI(t))); }
        const tR = 4;
        const eR = new RegExp("(^|\\s)" + "(" + "(" + "(?:(?:(?:https?|ftp):)?\\/\\/)" + "(?:\\S+(?::\\S*)?@)?" + "(?:" + "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" + "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" + "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" + "|" + "(" + "((?!www\\.)|(www\\.))" + "(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+" + "(?:[a-z\\u00a1-\\uffff]{2,63})" + ")" + ")" + "(?::\\d{2,5})?" + "(?:[/?#]\\S*)?" + ")" + "|" + "(" + "(www.|(\\S+@))" + "((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+" + "(?:[a-z\\u00a1-\\uffff]{2,63})" + ")" + ")$", "i");
        const nR = 2;
        class oR extends Kn {
            static get pluginName() { return "AutoLink"; }
            init() { const t = this.editor; const e = t.model.document.selection; e.on("change:range", (() => { this.isEnabled = !e.anchor.parent.is("element", "codeBlock"); })); this._enableTypingHandling(); }
            afterInit() { this._enableEnterHandling(); this._enableShiftEnterHandling(); }
            _enableTypingHandling() { const t = this.editor; const e = new Ry(t.model, (t => { if (!iR(t)) {
                return;
            } const e = rR(t.substr(0, t.length - 1)); if (e) {
                return { url: e };
            } })); const n = t.plugins.get("Input"); e.on("matched:data", ((e, o) => { const { batch: i, range: r, url: s } = o; if (!n.isInput(i)) {
                return;
            } const a = r.end.getShiftedBy(-1); const c = a.getShiftedBy(-s.length); const l = t.model.createRange(c, a); this._applyAutoLink(s, l); })); e.bind("isEnabled").to(this); }
            _enableEnterHandling() { const t = this.editor; const e = t.model; const n = t.commands.get("enter"); if (!n) {
                return;
            } n.on("execute", (() => { const t = e.document.selection.getFirstPosition(); if (!t.parent.previousSibling) {
                return;
            } const n = e.createRangeIn(t.parent.previousSibling); this._checkAndApplyAutoLinkOnRange(n); })); }
            _enableShiftEnterHandling() { const t = this.editor; const e = t.model; const n = t.commands.get("shiftEnter"); if (!n) {
                return;
            } n.on("execute", (() => { const t = e.document.selection.getFirstPosition(); const n = e.createRange(e.createPositionAt(t.parent, 0), t.getShiftedBy(-1)); this._checkAndApplyAutoLinkOnRange(n); })); }
            _checkAndApplyAutoLinkOnRange(t) { const e = this.editor.model; const { text: n, range: o } = Iy(t, e); const i = rR(n); if (i) {
                const t = e.createRange(o.end.getShiftedBy(-i.length), o.end);
                this._applyAutoLink(i, t);
            } }
            _applyAutoLink(t, e) { const n = this.editor.model; if (!this.isEnabled || !sR(e, n)) {
                return;
            } n.enqueueChange((n => { const o = this.editor.config.get("link.defaultProtocol"); const i = CI(t, o); n.setAttribute("linkHref", i, e); })); }
        }
        function iR(t) { return t.length > tR && t[t.length - 1] === " " && t[t.length - 2] !== " "; }
        function rR(t) { const e = eR.exec(t); return e ? e[nR] : null; }
        function sR(t, e) { return e.schema.checkAttributeInSelection(e.createSelection(t), "linkHref"); }
        class aR extends Kn {
            static get requires() { return [OI, XI, oR]; }
            static get pluginName() { return "Link"; }
        }
        class cR extends Hn {
            constructor(t, e) { super(t); this.type = e; }
            refresh() { this.value = this._getValue(); this.isEnabled = this._checkEnabled(); }
            execute(t = {}) { const e = this.editor.model; const n = e.document; const o = Array.from(n.selection.getSelectedBlocks()).filter((t => dR(t, e.schema))); const i = t.forceValue !== undefined ? !t.forceValue : this.value; e.change((t => { if (i) {
                let e = o[o.length - 1].nextSibling;
                let n = Number.POSITIVE_INFINITY;
                let i = [];
                while (e && e.name == "listItem" && e.getAttribute("listIndent") !== 0) {
                    const t = e.getAttribute("listIndent");
                    if (t < n) {
                        n = t;
                    }
                    const o = t - n;
                    i.push({ element: e, listIndent: o });
                    e = e.nextSibling;
                }
                i = i.reverse();
                for (const e of i) {
                    t.setAttribute("listIndent", e.listIndent, e.element);
                }
            } if (!i) {
                let t = Number.POSITIVE_INFINITY;
                for (const e of o) {
                    if (e.is("element", "listItem") && e.getAttribute("listIndent") < t) {
                        t = e.getAttribute("listIndent");
                    }
                }
                t = t === 0 ? 1 : t;
                lR(o, true, t);
                lR(o, false, t);
            } for (const e of o.reverse()) {
                if (i && e.name == "listItem") {
                    t.rename(e, "paragraph");
                }
                else if (!i && e.name != "listItem") {
                    t.setAttributes({ listType: this.type, listIndent: 0 }, e);
                    t.rename(e, "listItem");
                }
                else if (!i && e.name == "listItem" && e.getAttribute("listType") != this.type) {
                    t.setAttribute("listType", this.type, e);
                }
            } this.fire("_executeCleanup", o); })); }
            _getValue() { const t = mf(this.editor.model.document.selection.getSelectedBlocks()); return !!t && t.is("element", "listItem") && t.getAttribute("listType") == this.type; }
            _checkEnabled() { if (this.value) {
                return true;
            } const t = this.editor.model.document.selection; const e = this.editor.model.schema; const n = mf(t.getSelectedBlocks()); if (!n) {
                return false;
            } return dR(n, e); }
        }
        function lR(t, e, n) { const o = e ? t[0] : t[t.length - 1]; if (o.is("element", "listItem")) {
            let i = o[e ? "previousSibling" : "nextSibling"];
            let r = o.getAttribute("listIndent");
            while (i && i.is("element", "listItem") && i.getAttribute("listIndent") >= n) {
                if (r > i.getAttribute("listIndent")) {
                    r = i.getAttribute("listIndent");
                }
                if (i.getAttribute("listIndent") == r) {
                    t[e ? "unshift" : "push"](i);
                }
                i = i[e ? "previousSibling" : "nextSibling"];
            }
        } }
        function dR(t, e) { return e.checkChild(t.parent, "listItem") && !e.isObject(t); }
        class uR extends Hn {
            constructor(t, e) { super(t); this._indentBy = e == "forward" ? 1 : -1; }
            refresh() { this.isEnabled = this._checkEnabled(); }
            execute() { const t = this.editor.model; const e = t.document; let n = Array.from(e.selection.getSelectedBlocks()); t.change((t => { const e = n[n.length - 1]; let o = e.nextSibling; while (o && o.name == "listItem" && o.getAttribute("listIndent") > e.getAttribute("listIndent")) {
                n.push(o);
                o = o.nextSibling;
            } if (this._indentBy < 0) {
                n = n.reverse();
            } for (const e of n) {
                const n = e.getAttribute("listIndent") + this._indentBy;
                if (n < 0) {
                    t.rename(e, "paragraph");
                }
                else {
                    t.setAttribute("listIndent", n, e);
                }
            } this.fire("_executeCleanup", n); })); }
            _checkEnabled() { const t = mf(this.editor.model.document.selection.getSelectedBlocks()); if (!t || !t.is("element", "listItem")) {
                return false;
            } if (this._indentBy > 0) {
                const e = t.getAttribute("listIndent");
                const n = t.getAttribute("listType");
                let o = t.previousSibling;
                while (o && o.is("element", "listItem") && o.getAttribute("listIndent") >= e) {
                    if (o.getAttribute("listIndent") == e) {
                        return o.getAttribute("listType") == n;
                    }
                    o = o.previousSibling;
                }
                return false;
            } return true; }
        }
        function hR(t) { const e = t.createContainerElement("li"); e.getFillerOffset = vR; return e; }
        function fR(t, e) { const n = e.mapper; const o = e.writer; const i = t.getAttribute("listType") == "numbered" ? "ol" : "ul"; const r = hR(o); const s = o.createContainerElement(i, null); o.insert(o.createPositionAt(s, 0), r); n.bindElements(t, r); return r; }
        function pR(t, e, n, o) { const i = e.parent; const r = n.mapper; const s = n.writer; let a = r.toViewPosition(o.createPositionBefore(t)); const c = kR(t.previousSibling, { sameIndent: true, smallerIndent: true, listIndent: t.getAttribute("listIndent") }); const l = t.previousSibling; if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
            const t = r.toViewElement(c);
            a = s.breakContainer(s.createPositionAfter(t));
        }
        else {
            if (l && l.name == "listItem") {
                a = r.toViewPosition(o.createPositionAt(l, "end"));
                const t = r.findMappedViewAncestor(a);
                const e = wR(t);
                if (e) {
                    a = s.createPositionBefore(e);
                }
                else {
                    a = s.createPositionAt(t, "end");
                }
            }
            else {
                a = r.toViewPosition(o.createPositionBefore(t));
            }
        } a = mR(a); s.insert(a, i); if (l && l.name == "listItem") {
            const t = r.toViewElement(l);
            const n = s.createRange(s.createPositionAt(t, 0), a);
            const o = n.getWalker({ ignoreElementEnd: true });
            for (const t of o) {
                if (t.item.is("element", "li")) {
                    const n = s.breakContainer(s.createPositionBefore(t.item));
                    const i = t.item.parent;
                    const r = s.createPositionAt(e, "end");
                    gR(s, r.nodeBefore, r.nodeAfter);
                    s.move(s.createRangeOn(i), r);
                    o.position = n;
                }
            }
        }
        else {
            const n = i.nextSibling;
            if (n && (n.is("element", "ul") || n.is("element", "ol"))) {
                let o = null;
                for (const e of n.getChildren()) {
                    const n = r.toModelElement(e);
                    if (n && n.getAttribute("listIndent") > t.getAttribute("listIndent")) {
                        o = e;
                    }
                    else {
                        break;
                    }
                }
                if (o) {
                    s.breakContainer(s.createPositionAfter(o));
                    s.move(s.createRangeOn(o.parent), s.createPositionAt(e, "end"));
                }
            }
        } gR(s, i, i.nextSibling); gR(s, i.previousSibling, i); }
        function gR(t, e, n) { if (!e || !n || e.name != "ul" && e.name != "ol") {
            return null;
        } if (e.name != n.name || e.getAttribute("class") !== n.getAttribute("class")) {
            return null;
        } return t.mergeContainers(t.createPositionAfter(e)); }
        function mR(t) { return t.getLastMatchingPosition((t => t.item.is("uiElement"))); }
        function kR(t, e) { const n = !!e.sameIndent; const o = !!e.smallerIndent; const i = e.listIndent; let r = t; while (r && r.name == "listItem") {
            const t = r.getAttribute("listIndent");
            if (n && i == t || o && i > t) {
                return r;
            }
            if (e.direction === "forward") {
                r = r.nextSibling;
            }
            else {
                r = r.previousSibling;
            }
        } return null; }
        function bR(t, e, n, o) { t.ui.componentFactory.add(e, (i => { const r = t.commands.get(e); const s = new mw(i); s.set({ label: n, icon: o, tooltip: true, isToggleable: true }); s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"); s.on("execute", (() => { t.execute(e); t.editing.view.focus(); })); return s; })); }
        function wR(t) { for (const e of t.getChildren()) {
            if (e.name == "ul" || e.name == "ol") {
                return e;
            }
        } return null; }
        function _R(t, e) { const n = []; const o = t.parent; const i = { ignoreElementEnd: true, startPosition: t, shallow: true, direction: e }; const r = o.getAttribute("listIndent"); const s = [...new Vf(i)].filter((t => t.item.is("element"))).map((t => t.item)); for (const t of s) {
            if (!t.is("element", "listItem")) {
                break;
            }
            if (t.getAttribute("listIndent") < r) {
                break;
            }
            if (t.getAttribute("listIndent") > r) {
                continue;
            }
            if (t.getAttribute("listType") !== o.getAttribute("listType")) {
                break;
            }
            if (t.getAttribute("listStyle") !== o.getAttribute("listStyle")) {
                break;
            }
            if (e === "backward") {
                n.unshift(t);
            }
            else {
                n.push(t);
            }
        } return n; }
        function vR() { const t = !this.isEmpty && (this.getChild(0).name == "ul" || this.getChild(0).name == "ol"); if (this.isEmpty || t) {
            return 0;
        } return ml.call(this); }
        function AR(t) { return (e, n, o) => { const i = o.consumable; if (!i.test(n.item, "insert") || !i.test(n.item, "attribute:listType") || !i.test(n.item, "attribute:listIndent")) {
            return;
        } i.consume(n.item, "insert"); i.consume(n.item, "attribute:listType"); i.consume(n.item, "attribute:listIndent"); const r = n.item; const s = fR(r, o); pR(r, s, o, t); }; }
        function CR(t) { return (e, n, o) => { const i = o.mapper.toViewPosition(n.position); const r = i.getLastMatchingPosition((t => !t.item.is("element", "li"))); const s = r.nodeAfter; const a = o.writer; a.breakContainer(a.createPositionBefore(s)); a.breakContainer(a.createPositionAfter(s)); const c = s.parent; const l = c.previousSibling; const d = a.createRangeOn(c); const u = a.remove(d); if (l && l.nextSibling) {
            gR(a, l, l.nextSibling);
        } const h = o.mapper.toModelElement(s); MR(h.getAttribute("listIndent") + 1, n.position, d.start, s, o, t); for (const t of a.createRangeIn(u).getItems()) {
            o.mapper.unbindViewElement(t);
        } e.stop(); }; }
        function yR(t, e, n) { if (!n.consumable.consume(e.item, "attribute:listType")) {
            return;
        } const o = n.mapper.toViewElement(e.item); const i = n.writer; i.breakContainer(i.createPositionBefore(o)); i.breakContainer(i.createPositionAfter(o)); const r = o.parent; const s = e.attributeNewValue == "numbered" ? "ol" : "ul"; i.rename(s, r); }
        function xR(t, e, n) { const o = n.mapper.toViewElement(e.item); const i = o.parent; const r = n.writer; gR(r, i, i.nextSibling); gR(r, i.previousSibling, i); for (const t of e.item.getChildren()) {
            n.consumable.consume(t, "insert");
        } }
        function ER(t) { return (e, n, o) => { if (!o.consumable.consume(n.item, "attribute:listIndent")) {
            return;
        } const i = o.mapper.toViewElement(n.item); const r = o.writer; r.breakContainer(r.createPositionBefore(i)); r.breakContainer(r.createPositionAfter(i)); const s = i.parent; const a = s.previousSibling; const c = r.createRangeOn(s); r.remove(c); if (a && a.nextSibling) {
            gR(r, a, a.nextSibling);
        } MR(n.attributeOldValue + 1, n.range.start, c.start, i, o, t); pR(n.item, i, o, t); for (const t of n.item.getChildren()) {
            o.consumable.consume(t, "insert");
        } }; }
        function DR(t, e, n) { if (e.item.name != "listItem") {
            let t = n.mapper.toViewPosition(e.range.start);
            const o = n.writer;
            const i = [];
            while (t.parent.name == "ul" || t.parent.name == "ol") {
                t = o.breakContainer(t);
                if (t.parent.name != "li") {
                    break;
                }
                const e = t;
                const n = o.createPositionAt(t.parent, "end");
                if (!e.isEqual(n)) {
                    const t = o.remove(o.createRange(e, n));
                    i.push(t);
                }
                t = o.createPositionAfter(t.parent);
            }
            if (i.length > 0) {
                for (let e = 0; e < i.length; e++) {
                    const n = t.nodeBefore;
                    const r = o.insert(t, i[e]);
                    t = r.end;
                    if (e > 0) {
                        const e = gR(o, n, n.nextSibling);
                        if (e && e.parent == n) {
                            t.offset--;
                        }
                    }
                }
                gR(o, t.nodeBefore, t.nodeAfter);
            }
        } }
        function SR(t, e, n) { const o = n.mapper.toViewPosition(e.position); const i = o.nodeBefore; const r = o.nodeAfter; gR(n.writer, i, r); }
        function TR(t, e, n) { if (n.consumable.consume(e.viewItem, { name: true })) {
            const t = n.writer;
            const o = t.createElement("listItem");
            const i = LR(e.viewItem);
            t.setAttribute("listIndent", i, o);
            const r = e.viewItem.parent && e.viewItem.parent.name == "ol" ? "numbered" : "bulleted";
            t.setAttribute("listType", r, o);
            if (!n.safeInsert(o, e.modelCursor)) {
                return;
            }
            const s = zR(o, e.viewItem.getChildren(), n);
            e.modelRange = t.createRange(e.modelCursor, s);
            n.updateConversionResult(o, e);
        } }
        function PR(t, e, n) { if (n.consumable.test(e.viewItem, { name: true })) {
            const t = Array.from(e.viewItem.getChildren());
            for (const e of t) {
                const t = !(e.is("element", "li") || VR(e));
                if (t) {
                    e._remove();
                }
            }
        } }
        function BR(t, e, n) { if (n.consumable.test(e.viewItem, { name: true })) {
            if (e.viewItem.childCount === 0) {
                return;
            }
            const t = [...e.viewItem.getChildren()];
            let n = false;
            let o = true;
            for (const e of t) {
                if (n && !VR(e)) {
                    e._remove();
                }
                if (e.is("$text")) {
                    if (o) {
                        e._data = e.data.trimStart();
                    }
                    if (!e.nextSibling || VR(e.nextSibling)) {
                        e._data = e.data.trimEnd();
                    }
                }
                else if (VR(e)) {
                    n = true;
                }
                o = false;
            }
        } }
        function IR(t) { return (e, n) => { if (n.isPhantom) {
            return;
        } const o = n.modelPosition.nodeBefore; if (o && o.is("element", "listItem")) {
            const e = n.mapper.toViewElement(o);
            const i = e.getAncestors().find(VR);
            const r = t.createPositionAt(e, 0).getWalker();
            for (const t of r) {
                if (t.type == "elementStart" && t.item.is("element", "li")) {
                    n.viewPosition = t.previousPosition;
                    break;
                }
                else if (t.type == "elementEnd" && t.item == i) {
                    n.viewPosition = t.nextPosition;
                    break;
                }
            }
        } }; }
        function RR(t) { return (e, n) => { const o = n.viewPosition; const i = o.parent; const r = n.mapper; if (i.name == "ul" || i.name == "ol") {
            if (!o.isAtEnd) {
                const e = r.toModelElement(o.nodeAfter);
                n.modelPosition = t.createPositionBefore(e);
            }
            else {
                const e = r.toModelElement(o.nodeBefore);
                const i = r.getModelLength(o.nodeBefore);
                n.modelPosition = t.createPositionBefore(e).getShiftedBy(i);
            }
            e.stop();
        }
        else if (i.name == "li" && o.nodeBefore && (o.nodeBefore.name == "ul" || o.nodeBefore.name == "ol")) {
            const s = r.toModelElement(i);
            let a = 1;
            let c = o.nodeBefore;
            while (c && VR(c)) {
                a += r.getModelLength(c);
                c = c.previousSibling;
            }
            n.modelPosition = t.createPositionBefore(s).getShiftedBy(a);
            e.stop();
        } }; }
        function FR(t, e) { const n = t.document.differ.getChanges(); const o = new Map; let i = false; for (const o of n) {
            if (o.type == "insert" && o.name == "listItem") {
                r(o.position);
            }
            else if (o.type == "insert" && o.name != "listItem") {
                if (o.name != "$text") {
                    const n = o.position.nodeAfter;
                    if (n.hasAttribute("listIndent")) {
                        e.removeAttribute("listIndent", n);
                        i = true;
                    }
                    if (n.hasAttribute("listType")) {
                        e.removeAttribute("listType", n);
                        i = true;
                    }
                    if (n.hasAttribute("listStyle")) {
                        e.removeAttribute("listStyle", n);
                        i = true;
                    }
                    for (const e of Array.from(t.createRangeIn(n)).filter((t => t.item.is("element", "listItem")))) {
                        r(e.previousPosition);
                    }
                }
                const n = o.position.getShiftedBy(o.length);
                r(n);
            }
            else if (o.type == "remove" && o.name == "listItem") {
                r(o.position);
            }
            else if (o.type == "attribute" && o.attributeKey == "listIndent") {
                r(o.range.start);
            }
            else if (o.type == "attribute" && o.attributeKey == "listType") {
                r(o.range.start);
            }
        } for (const t of o.values()) {
            s(t);
            a(t);
        } return i; function r(t) { const e = t.nodeBefore; if (!e || !e.is("element", "listItem")) {
            const e = t.nodeAfter;
            if (e && e.is("element", "listItem")) {
                o.set(e, e);
            }
        }
        else {
            let t = e;
            if (o.has(t)) {
                return;
            }
            for (let e = t.previousSibling; e && e.is("element", "listItem"); e = t.previousSibling) {
                t = e;
                if (o.has(t)) {
                    return;
                }
            }
            o.set(e, t);
        } } function s(t) { let n = 0; let o = null; while (t && t.is("element", "listItem")) {
            const r = t.getAttribute("listIndent");
            if (r > n) {
                let s;
                if (o === null) {
                    o = r - n;
                    s = n;
                }
                else {
                    if (o > r) {
                        o = r;
                    }
                    s = r - o;
                }
                e.setAttribute("listIndent", s, t);
                i = true;
            }
            else {
                o = null;
                n = t.getAttribute("listIndent") + 1;
            }
            t = t.nextSibling;
        } } function a(t) { let n = []; let o = null; while (t && t.is("element", "listItem")) {
            const r = t.getAttribute("listIndent");
            if (o && o.getAttribute("listIndent") > r) {
                n = n.slice(0, r + 1);
            }
            if (r != 0) {
                if (n[r]) {
                    const o = n[r];
                    if (t.getAttribute("listType") != o) {
                        e.setAttribute("listType", o, t);
                        i = true;
                    }
                }
                else {
                    n[r] = t.getAttribute("listType");
                }
            }
            o = t;
            t = t.nextSibling;
        } } }
        function OR(t, [e, n]) { let o = e.is("documentFragment") ? e.getChild(0) : e; let i; if (!n) {
            i = this.document.selection;
        }
        else {
            i = this.createSelection(n);
        } if (o && o.is("element", "listItem")) {
            const t = i.getFirstPosition();
            let e = null;
            if (t.parent.is("element", "listItem")) {
                e = t.parent;
            }
            else if (t.nodeBefore && t.nodeBefore.is("element", "listItem")) {
                e = t.nodeBefore;
            }
            if (e) {
                const t = e.getAttribute("listIndent");
                if (t > 0) {
                    while (o && o.is("element", "listItem")) {
                        o._setAttribute("listIndent", o.getAttribute("listIndent") + t);
                        o = o.nextSibling;
                    }
                }
            }
        } }
        function zR(t, e, n) { const { writer: o, schema: i } = n; let r = o.createPositionAfter(t); for (const s of e) {
            if (s.name == "ul" || s.name == "ol") {
                r = n.convertItem(s, r).modelCursor;
            }
            else {
                const e = n.convertItem(s, o.createPositionAt(t, "end"));
                const a = e.modelRange.start.nodeAfter;
                const c = a && a.is("element") && !i.checkChild(t, a.name);
                if (c) {
                    if (e.modelCursor.parent.is("element", "listItem")) {
                        t = e.modelCursor.parent;
                    }
                    else {
                        t = NR(e.modelCursor);
                    }
                    r = o.createPositionAfter(t);
                }
            }
        } return r; }
        function NR(t) { const e = new Vf({ startPosition: t }); let n; do {
            n = e.next();
        } while (!n.value.item.is("element", "listItem")); return n.value.item; }
        function MR(t, e, n, o, i, r) { const s = kR(e.nodeBefore, { sameIndent: true, smallerIndent: true, listIndent: t, foo: "b" }); const a = i.mapper; const c = i.writer; const l = s ? s.getAttribute("listIndent") : null; let d; if (!s) {
            d = n;
        }
        else if (l == t) {
            const t = a.toViewElement(s).parent;
            d = c.createPositionAfter(t);
        }
        else {
            const t = r.createPositionAt(s, "end");
            d = a.toViewPosition(t);
        } d = mR(d); for (const t of [...o.getChildren()]) {
            if (VR(t)) {
                d = c.move(c.createRangeOn(t), d).end;
                gR(c, t, t.nextSibling);
                gR(c, t.previousSibling, t);
            }
        } }
        function VR(t) { return t.is("element", "ol") || t.is("element", "ul"); }
        function LR(t) { let e = 0; let n = t.parent; while (n) {
            if (n.is("element", "li")) {
                e++;
            }
            else {
                const t = n.previousSibling;
                if (t && t.is("element", "li")) {
                    e++;
                }
            }
            n = n.parent;
        } return e; }
        class qR extends Kn {
            static get pluginName() { return "ListEditing"; }
            static get requires() { return [sy, Py]; }
            init() { const t = this.editor; t.model.schema.register("listItem", { inheritAllFrom: "$block", allowAttributes: ["listType", "listIndent"] }); const e = t.data; const n = t.editing; t.model.document.registerPostFixer((e => FR(t.model, e))); n.mapper.registerViewToModelLength("li", KR); e.mapper.registerViewToModelLength("li", KR); n.mapper.on("modelToViewPosition", IR(n.view)); n.mapper.on("viewToModelPosition", RR(t.model)); e.mapper.on("modelToViewPosition", IR(n.view)); t.conversion.for("editingDowncast").add((e => { e.on("insert", DR, { priority: "high" }); e.on("insert:listItem", AR(t.model)); e.on("attribute:listType:listItem", yR, { priority: "high" }); e.on("attribute:listType:listItem", xR, { priority: "low" }); e.on("attribute:listIndent:listItem", ER(t.model)); e.on("remove:listItem", CR(t.model)); e.on("remove", SR, { priority: "low" }); })); t.conversion.for("dataDowncast").add((e => { e.on("insert", DR, { priority: "high" }); e.on("insert:listItem", AR(t.model)); })); t.conversion.for("upcast").add((t => { t.on("element:ul", PR, { priority: "high" }); t.on("element:ol", PR, { priority: "high" }); t.on("element:li", BR, { priority: "high" }); t.on("element:li", TR); })); t.model.on("insertContent", OR, { priority: "high" }); t.commands.add("numberedList", new cR(t, "numbered")); t.commands.add("bulletedList", new cR(t, "bulleted")); t.commands.add("indentList", new uR(t, "forward")); t.commands.add("outdentList", new uR(t, "backward")); const o = n.view.document; this.listenTo(o, "enter", ((t, e) => { const n = this.editor.model.document; const o = n.selection.getLastPosition().parent; if (n.selection.isCollapsed && o.name == "listItem" && o.isEmpty) {
                this.editor.execute("outdentList");
                e.preventDefault();
                t.stop();
            } }), { context: "li" }); this.listenTo(o, "delete", ((t, e) => { if (e.direction !== "backward") {
                return;
            } const n = this.editor.model.document.selection; if (!n.isCollapsed) {
                return;
            } const o = n.getFirstPosition(); if (!o.isAtStart) {
                return;
            } const i = o.parent; if (i.name !== "listItem") {
                return;
            } const r = i.previousSibling && i.previousSibling.name === "listItem"; if (r) {
                return;
            } this.editor.execute("outdentList"); e.preventDefault(); t.stop(); }), { context: "li" }); const i = t => (e, n) => { const o = this.editor.commands.get(t); if (o.isEnabled) {
                this.editor.execute(t);
                n();
            } }; t.keystrokes.set("Tab", i("indentList")); t.keystrokes.set("Shift+Tab", i("outdentList")); }
            afterInit() { const t = this.editor.commands; const e = t.get("indent"); const n = t.get("outdent"); if (e) {
                e.registerChildCommand(t.get("indentList"));
            } if (n) {
                n.registerChildCommand(t.get("outdentList"));
            } }
        }
        function KR(t) { let e = 1; for (const n of t.getChildren()) {
            if (n.name == "ul" || n.name == "ol") {
                for (const t of n.getChildren()) {
                    e += KR(t);
                }
            }
        } return e; }
        var jR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>';
        var HR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';
        class WR extends Kn {
            static get pluginName() { return "ListUI"; }
            init() { const t = this.editor.t; bR(this.editor, "numberedList", t("Numbered List"), jR); bR(this.editor, "bulletedList", t("Bulleted List"), HR); }
        }
        class $R extends Kn {
            static get requires() { return [qR, WR]; }
            static get pluginName() { return "List"; }
        }
        function GR(t, e) { for (const n of t.getChildren()) {
            if (n.is("element", "b") && n.getStyle("font-weight") === "normal") {
                const o = t.getChildIndex(n);
                e.remove(n);
                e.insertChild(o, n.getChildren(), t);
            }
        } }
        function UR(t, e) { if (!t.childCount) {
            return;
        } const n = new BA(t.document); const o = YR(t, n); if (!o.length) {
            return;
        } let i = null; let r = 1; o.forEach(((t, s) => { const a = rF(o[s - 1], t); const c = a ? null : o[s - 1]; const l = aF(c, t); if (a) {
            i = null;
            r = 1;
        } if (!i || l !== 0) {
            const o = QR(t, e);
            if (!i) {
                i = eF(o, t.element, n);
            }
            else if (t.indent > r) {
                const t = i.getChild(i.childCount - 1);
                const e = t.getChild(t.childCount - 1);
                i = eF(o, e, n);
                r += 1;
            }
            else if (t.indent < r) {
                const e = r - t.indent;
                i = cF(i, e);
                r = parseInt(t.indent);
            }
            if (t.indent <= r) {
                if (!i.is("element", o.type)) {
                    i = n.rename(o.type, i);
                }
            }
        } const d = nF(t.element, n); n.appendChild(d, i); })); }
        function JR(t, e) { for (const n of e.createRangeIn(t)) {
            const t = n.item;
            if (t.is("element", "li")) {
                const n = t.getChild(0);
                if (n && n.is("element", "p")) {
                    e.unwrapElement(n);
                }
            }
        } }
        function YR(t, e) { const n = e.createRangeIn(t); const o = new qa({ name: /^p|h\d+$/, styles: { "mso-list": /.*/ } }); const i = []; for (const t of n) {
            if (t.type === "elementStart" && o.match(t.item)) {
                const e = oF(t.item);
                i.push({ element: t.item, id: e.id, order: e.order, indent: e.indent });
            }
        } return i; }
        function QR(t, e) { const n = new RegExp(`@list l${t.id}:level${t.indent}\\s*({[^}]*)`, "gi"); const o = /mso-level-number-format:([^;]{0,100});/gi; const i = n.exec(e); let r = "decimal"; let s = "ol"; if (i && i[1]) {
            const e = o.exec(i[1]);
            if (e && e[1]) {
                r = e[1].trim();
                s = r !== "bullet" && r !== "image" ? "ol" : "ul";
            }
            if (r === "bullet") {
                const e = XR(t.element);
                if (e) {
                    r = e;
                }
            }
        } return { type: s, style: tF(r) }; }
        function XR(t) { const e = ZR(t); if (!e) {
            return null;
        } const n = e._data; if (n === "o") {
            return "circle";
        }
        else if (n === "·") {
            return "disc";
        }
        else if (n === "§") {
            return "square";
        } return null; }
        function ZR(t) { if (t.getChild(0).is("$text")) {
            return null;
        } const e = t.getChild(0).getChild(0); if (e.is("$text")) {
            return e;
        } return e.getChild(0); }
        function tF(t) { switch (t) {
            case "arabic-leading-zero": return "decimal-leading-zero";
            case "alpha-upper": return "upper-alpha";
            case "alpha-lower": return "lower-alpha";
            case "roman-upper": return "upper-roman";
            case "roman-lower": return "lower-roman";
            case "circle":
            case "disc":
            case "square": return t;
            default: return null;
        } }
        function eF(t, e, n) { const o = e.parent; const i = n.createElement(t.type); const r = o.getChildIndex(e) + 1; n.insertChild(r, i, o); if (t.style) {
            n.setStyle("list-style-type", t.style, i);
        } return i; }
        function nF(t, e) { iF(t, e); return e.rename("li", t); }
        function oF(t) { const e = {}; const n = t.getStyle("mso-list"); if (n) {
            const t = n.match(/(^|\s{1,100})l(\d+)/i);
            const o = n.match(/\s{0,100}lfo(\d+)/i);
            const i = n.match(/\s{0,100}level(\d+)/i);
            if (t && o && i) {
                e.id = t[2];
                e.order = o[1];
                e.indent = i[1];
            }
        } return e; }
        function iF(t, e) { const n = new qa({ name: "span", styles: { "mso-list": "Ignore" } }); const o = e.createRangeIn(t); for (const t of o) {
            if (t.type === "elementStart" && n.match(t.item)) {
                e.remove(t.item);
            }
        } }
        function rF(t, e) { if (!t) {
            return true;
        } if (t.id !== e.id) {
            if (e.indent - t.indent === 1) {
                return false;
            }
            return true;
        } const n = e.element.previousSibling; if (!n) {
            return true;
        } return !sF(n); }
        function sF(t) { return t.is("element", "ol") || t.is("element", "ul"); }
        function aF(t, e) { return t ? e.indent - t.indent : e.indent - 1; }
        function cF(t, e) { const n = t.getAncestors({ parentFirst: true }); let o = null; let i = 0; for (const t of n) {
            if (t.name === "ul" || t.name === "ol") {
                i++;
            }
            if (i === e) {
                o = t;
                break;
            }
        } return o; }
        const lF = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
        class dF {
            constructor(t) { this.document = t; }
            isActive(t) { return lF.test(t); }
            execute(t) { const e = new BA(this.document); GR(t.content, e); JR(t.content, e); }
        }
        function uF(t) { return fF(fF(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><"); }
        function hF(t) { t.querySelectorAll("span[style*=spacerun]").forEach((t => { const e = t.innerText.length || 0; t.innerHTML = Array(e + 1).join("  ").substr(0, e); })); }
        function fF(t) { return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, ((t, e) => e.length === 1 ? " " : Array(e.length + 1).join("  ").substr(0, e.length))); }
        function pF(t, e) { const n = new DOMParser; t = t.replace(/<!--\[if gte vml 1]>/g, ""); const o = uF(kF(t)); const i = n.parseFromString(o, "text/html"); hF(i); const r = i.body.innerHTML; const s = gF(i, e); const a = mF(i); return { body: s, bodyString: r, styles: a.styles, stylesString: a.stylesString }; }
        function gF(t, e) { const n = new zl(e); const o = new fu(n, { blockFillerMode: "nbsp" }); const i = t.createDocumentFragment(); const r = t.body.childNodes; while (r.length > 0) {
            i.appendChild(r[0]);
        } return o.domToView(i); }
        function mF(t) { const e = []; const n = []; const o = Array.from(t.getElementsByTagName("style")); for (const t of o) {
            if (t.sheet && t.sheet.cssRules && t.sheet.cssRules.length) {
                e.push(t.sheet);
                n.push(t.innerHTML);
            }
        } return { styles: e, stylesString: n.join(" ") }; }
        function kF(t) { const e = "</body>"; const n = "</html>"; const o = t.indexOf(e); if (o < 0) {
            return t;
        } const i = t.indexOf(n, o + e.length); return t.substring(0, o + e.length) + (i >= 0 ? t.substring(i) : ""); }
        function bF(t, e) { if (!t.childCount) {
            return;
        } const n = new BA; const o = _F(t, n); vF(o, t, n); AF(t, n); const i = CF(t, n); if (i.length) {
            xF(i, yF(e), n);
        } }
        function wF(t) { return btoa(t.match(/\w{2}/g).map((t => String.fromCharCode(parseInt(t, 16)))).join("")); }
        function _F(t, e) { const n = e.createRangeIn(t); const o = new qa({ name: /v:(.+)/ }); const i = []; for (const t of n) {
            const e = t.item;
            const n = e.previousSibling && e.previousSibling.name || null;
            if (o.match(e) && e.getAttribute("o:gfxdata") && n !== "v:shapetype") {
                i.push(t.item.getAttribute("id"));
            }
        } return i; }
        function vF(t, e, n) { const o = n.createRangeIn(e); const i = new qa({ name: "img" }); const r = []; for (const e of o) {
            if (i.match(e.item)) {
                const n = e.item;
                const o = n.getAttribute("v:shapes") ? n.getAttribute("v:shapes").split(" ") : [];
                if (o.length && o.every((e => t.indexOf(e) > -1))) {
                    r.push(n);
                }
                else if (!n.getAttribute("src")) {
                    r.push(n);
                }
            }
        } for (const t of r) {
            n.remove(t);
        } }
        function AF(t, e) { const n = e.createRangeIn(t); const o = new qa({ name: /v:(.+)/ }); const i = []; for (const t of n) {
            if (o.match(t.item)) {
                i.push(t.item);
            }
        } for (const t of i) {
            e.remove(t);
        } }
        function CF(t, e) { const n = e.createRangeIn(t); const o = new qa({ name: "img" }); const i = []; for (const t of n) {
            if (o.match(t.item)) {
                if (t.item.getAttribute("src").startsWith("file://")) {
                    i.push(t.item);
                }
            }
        } return i; }
        function yF(t) { if (!t) {
            return [];
        } const e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/; const n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"); const o = t.match(n); const i = []; if (o) {
            for (const t of o) {
                let n = false;
                if (t.includes("\\pngblip")) {
                    n = "image/png";
                }
                else if (t.includes("\\jpegblip")) {
                    n = "image/jpeg";
                }
                if (n) {
                    i.push({ hex: t.replace(e, "").replace(/[^\da-fA-F]/g, ""), type: n });
                }
            }
        } return i; }
        function xF(t, e, n) { if (t.length === e.length) {
            for (let o = 0; o < t.length; o++) {
                const i = `data:${e[o].type};base64,${wF(e[o].hex)}`;
                n.setAttribute("src", i, t[o]);
            }
        } }
        const EF = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i;
        const DF = /xmlns:o="urn:schemas-microsoft-com/i;
        class SF {
            constructor(t) { this.document = t; }
            isActive(t) { return EF.test(t) || DF.test(t); }
            execute(t) { const { body: e, stylesString: n } = pF(t.dataTransfer.getData("text/html"), this.document.stylesProcessor); UR(e, n); bF(e, t.dataTransfer.getData("text/rtf")); t.content = e; }
        }
        class TF extends Kn {
            static get pluginName() { return "PasteFromOffice"; }
            static get requires() { return [qx]; }
            init() { const t = this.editor; const e = t.editing.view.document; const n = []; n.push(new SF(e)); n.push(new dF(e)); t.plugins.get("ClipboardPipeline").on("inputTransformation", ((t, e) => { if (e.isTransformedWithPasteFromOffice) {
                return;
            } const o = e.dataTransfer.getData("text/html"); const i = n.find((t => t.isActive(o))); if (i) {
                i.execute(e);
                e.isTransformedWithPasteFromOffice = true;
            } }), { priority: "high" }); }
        }
        class PF extends EC {
        }
        PF.builtinPlugins = [jC, UC, ZC, fx, _x, Ix, yD, $D, uS, SS, BT, $T, oP, wP, _P, lB, pB, _B, aR, $R, gS, TF, Gy];
        var BF = e["default"] = PF;
    }])["default"]; }));
//# sourceMappingURL=ckeditor.js.map
//# sourceMappingURL=ckeditor.js.map